export var preset = {
  "theme": {
    "id": "classic",
    "selector": "body",
    "modes": {
      "color": {
        "id": "color",
        "states": {
          "light": {
            "default": true
          },
          "dark": {
            "selector": ".awsui-dark-mode",
            "media": "not print"
          }
        }
      },
      "density": {
        "id": "density",
        "states": {
          "comfortable": {
            "default": true
          },
          "compact": {
            "selector": ".awsui-compact-mode"
          }
        }
      },
      "motion": {
        "id": "motion",
        "states": {
          "default": {
            "default": true
          },
          "disabled": {
            "selector": ".awsui-motion-disabled"
          }
        }
      }
    },
    "tokens": {
      "colorPrimary50": {
        "light": "#f1faff",
        "dark": "#f1faff"
      },
      "colorPrimary100": {
        "light": "#d1f1ff",
        "dark": "#d1f1ff"
      },
      "colorPrimary200": {
        "light": "#99cbe4",
        "dark": "#99cbe4"
      },
      "colorPrimary300": {
        "light": "#44b9d6",
        "dark": "#44b9d6"
      },
      "colorPrimary400": {
        "light": "#00a1c9",
        "dark": "#00a1c9"
      },
      "colorPrimary500": {
        "light": "#0099ff",
        "dark": "#0099ff"
      },
      "colorPrimary600": {
        "light": "#0073bb",
        "dark": "#0073bb"
      },
      "colorPrimary700": {
        "light": "#0a4a74",
        "dark": "#0a4a74"
      },
      "colorPrimary800": {
        "light": "#003b8f",
        "dark": "#003b8f"
      },
      "colorPrimary900": {
        "light": "#002b66",
        "dark": "#002b66"
      },
      "colorPrimary950": {
        "light": "#00204d",
        "dark": "#00204d"
      },
      "colorPrimary1000": {
        "light": "#12293b",
        "dark": "#12293b"
      },
      "colorNeutral50": {
        "light": "#fcfcfd",
        "dark": "#fcfcfd"
      },
      "colorNeutral100": {
        "light": "#fafafa",
        "dark": "#fafafa"
      },
      "colorNeutral150": {
        "light": "#f6f6f9",
        "dark": "#f6f6f9"
      },
      "colorNeutral200": {
        "light": "#f2f3f3",
        "dark": "#f2f3f3"
      },
      "colorNeutral250": {
        "light": "#eaeded",
        "dark": "#eaeded"
      },
      "colorNeutral300": {
        "light": "#d5dbdb",
        "dark": "#d5dbdb"
      },
      "colorNeutral350": {
        "light": "#c6c6cd",
        "dark": "#c6c6cd"
      },
      "colorNeutral400": {
        "light": "#aab7b8",
        "dark": "#aab7b8"
      },
      "colorNeutral450": {
        "light": "#95a5a6",
        "dark": "#95a5a6"
      },
      "colorNeutral500": {
        "light": "#879596",
        "dark": "#879596"
      },
      "colorNeutral550": {
        "light": "#72747e",
        "dark": "#72747e"
      },
      "colorNeutral600": {
        "light": "#687078",
        "dark": "#687078"
      },
      "colorNeutral650": {
        "light": "#545b64",
        "dark": "#545b64"
      },
      "colorNeutral700": {
        "light": "#414750",
        "dark": "#414750"
      },
      "colorNeutral750": {
        "light": "#2a2e33",
        "dark": "#2a2e33"
      },
      "colorNeutral800": {
        "light": "#21252c",
        "dark": "#21252c"
      },
      "colorNeutral850": {
        "light": "#1a2029",
        "dark": "#1a2029"
      },
      "colorNeutral900": {
        "light": "#131920",
        "dark": "#131920"
      },
      "colorNeutral950": {
        "light": "#16191f",
        "dark": "#16191f"
      },
      "colorNeutral1000": {
        "light": "#06080a",
        "dark": "#06080a"
      },
      "colorError50": {
        "light": "#fdf3f1",
        "dark": "#fdf3f1"
      },
      "colorError100": {
        "light": "#ffe0e0",
        "dark": "#ffe0e0"
      },
      "colorError400": {
        "light": "#ff5d64",
        "dark": "#ff5d64"
      },
      "colorError600": {
        "light": "#d13212",
        "dark": "#d13212"
      },
      "colorError700": {
        "light": "#c20000",
        "dark": "#c20000"
      },
      "colorError800": {
        "light": "#990000",
        "dark": "#990000"
      },
      "colorError900": {
        "light": "#700000",
        "dark": "#700000"
      },
      "colorError950": {
        "light": "#520000",
        "dark": "#520000"
      },
      "colorError1000": {
        "light": "#270a11",
        "dark": "#270a11"
      },
      "colorSuccess50": {
        "light": "#f2f8f0",
        "dark": "#f2f8f0"
      },
      "colorSuccess100": {
        "light": "#d9ffd6",
        "dark": "#d9ffd6"
      },
      "colorSuccess200": {
        "light": "#aeffa8",
        "dark": "#aeffa8"
      },
      "colorSuccess400": {
        "light": "#00e500",
        "dark": "#00e500"
      },
      "colorSuccess500": {
        "light": "#6aaf35",
        "dark": "#6aaf35"
      },
      "colorSuccess600": {
        "light": "#1d8102",
        "dark": "#1d8102"
      },
      "colorSuccess800": {
        "light": "#005c26",
        "dark": "#005c26"
      },
      "colorSuccess950": {
        "light": "#003311",
        "dark": "#003311"
      },
      "colorSuccess1000": {
        "light": "#172211",
        "dark": "#172211"
      },
      "colorWarning50": {
        "light": "#fffef0",
        "dark": "#fffef0"
      },
      "colorWarning100": {
        "light": "#fffbbd",
        "dark": "#fffbbd"
      },
      "colorWarning200": {
        "light": "#fef571",
        "dark": "#fef571"
      },
      "colorWarning400": {
        "light": "#ffe347",
        "dark": "#ffe347"
      },
      "colorWarning500": {
        "light": "#fbd332",
        "dark": "#fbd332"
      },
      "colorWarning600": {
        "light": "#f2b100",
        "dark": "#f2b100"
      },
      "colorWarning800": {
        "light": "#9e6900",
        "dark": "#9e6900"
      },
      "colorWarning900": {
        "light": "#906806",
        "dark": "#906806"
      },
      "colorWarning950": {
        "light": "#573a00",
        "dark": "#573a00"
      },
      "colorWarning1000": {
        "light": "#191100",
        "dark": "#191100"
      },
      "colorInfo50": {
        "light": "#f1faff",
        "dark": "#f1faff"
      },
      "colorInfo100": {
        "light": "#d1f1ff",
        "dark": "#d1f1ff"
      },
      "colorInfo300": {
        "light": "#44b9d6",
        "dark": "#44b9d6"
      },
      "colorInfo400": {
        "light": "#00a1c9",
        "dark": "#00a1c9"
      },
      "colorInfo600": {
        "light": "#0073bb",
        "dark": "#0073bb"
      },
      "colorInfo700": {
        "light": "#004a9e",
        "dark": "#004a9e"
      },
      "colorInfo800": {
        "light": "#003b8f",
        "dark": "#003b8f"
      },
      "colorInfo950": {
        "light": "#00204d",
        "dark": "#00204d"
      },
      "colorInfo1000": {
        "light": "#12293b",
        "dark": "#12293b"
      },
      "colorGrey50": {
        "light": "#fcfcfd",
        "dark": "#fcfcfd"
      },
      "colorGrey100": "#fafafa",
      "colorGrey150": {
        "light": "#f6f6f9",
        "dark": "#f6f6f9"
      },
      "colorGrey200": "#f2f3f3",
      "colorGrey250": "#eaeded",
      "colorGrey300": "#d5dbdb",
      "colorGrey350": {
        "light": "#c6c6cd",
        "dark": "#c6c6cd"
      },
      "colorGrey400": "#aab7b8",
      "colorGrey450": "#95a5a6",
      "colorGrey500": "#879596",
      "colorGrey600": "#687078",
      "colorGrey650": "#545b64",
      "colorGrey700": "#414750",
      "colorGrey750": "#2a2e33",
      "colorGrey800": "#21252c",
      "colorGrey850": "#1a2029",
      "colorGrey900": {
        "light": "#131920",
        "dark": "#131920"
      },
      "colorGrey950": "#16191f",
      "colorGrey1000": {
        "light": "#06080a",
        "dark": "#06080a"
      },
      "colorBlue50": "#f1faff",
      "colorBlue100": {
        "light": "#d1f1ff",
        "dark": "#d1f1ff"
      },
      "colorBlue200": "#99cbe4",
      "colorBlue300": "#44b9d6",
      "colorBlue400": "#00a1c9",
      "colorBlue600": "#0073bb",
      "colorBlue700": "#0a4a74",
      "colorBlue900": {
        "light": "#002b66",
        "dark": "#002b66"
      },
      "colorBlue1000": "#12293b",
      "colorGreen50": "#f2f8f0",
      "colorGreen500": "#6aaf35",
      "colorGreen600": "#1d8102",
      "colorGreen900": {
        "light": "#00471e",
        "dark": "#00471e"
      },
      "colorGreen1000": "#172211",
      "colorRed50": "#fdf3f1",
      "colorRed400": "#ff5d64",
      "colorRed600": "#d13212",
      "colorRed900": {
        "light": "#700000",
        "dark": "#700000"
      },
      "colorRed1000": "#270a11",
      "colorYellow50": {
        "light": "#fffef0",
        "dark": "#fffef0"
      },
      "colorYellow400": {
        "light": "#ffe347",
        "dark": "#ffe347"
      },
      "colorYellow500": {
        "light": "#fbd332",
        "dark": "#fbd332"
      },
      "colorYellow900": "#906806",
      "colorYellow1000": {
        "light": "#191100",
        "dark": "#191100"
      },
      "colorPurple400": {
        "light": "#bf80ff",
        "dark": "#bf80ff"
      },
      "colorPurple700": {
        "light": "#7300e5",
        "dark": "#7300e5"
      },
      "colorAmber400": {
        "light": "#ff9900",
        "dark": "#ff9900"
      },
      "colorAmber500": {
        "light": "#fa6f00",
        "dark": "#fa6f00"
      },
      "colorRed950": {
        "light": "#520000",
        "dark": "#520000"
      },
      "colorOrange50": {
        "light": "#fff7f5",
        "dark": "#fff7f5"
      },
      "colorOrange100": {
        "light": "#ffe0d6",
        "dark": "#ffe0d6"
      },
      "colorOrange400": {
        "light": "#ff6a3d",
        "dark": "#ff6a3d"
      },
      "colorOrange700": {
        "light": "#a82700",
        "dark": "#a82700"
      },
      "colorOrange800": {
        "light": "#8a2000",
        "dark": "#8a2000"
      },
      "colorOrange950": {
        "light": "#471100",
        "dark": "#471100"
      },
      "colorYellow600": {
        "light": "#f2b100",
        "dark": "#f2b100"
      },
      "colorYellow950": {
        "light": "#573a00",
        "dark": "#573a00"
      },
      "colorLime50": {
        "light": "#f7ffeb",
        "dark": "#f7ffeb"
      },
      "colorLime100": {
        "light": "#ebffcc",
        "dark": "#ebffcc"
      },
      "colorLime400": {
        "light": "#7ae500",
        "dark": "#7ae500"
      },
      "colorLime700": {
        "light": "#007000",
        "dark": "#007000"
      },
      "colorLime800": {
        "light": "#005700",
        "dark": "#005700"
      },
      "colorLime950": {
        "light": "#002e00",
        "dark": "#002e00"
      },
      "colorGreen400": {
        "light": "#00e500",
        "dark": "#00e500"
      },
      "colorGreen950": {
        "light": "#003311",
        "dark": "#003311"
      },
      "colorMint50": {
        "light": "#ebfff6",
        "dark": "#ebfff6"
      },
      "colorMint100": {
        "light": "#ccffe9",
        "dark": "#ccffe9"
      },
      "colorMint400": {
        "light": "#00e582",
        "dark": "#00e582"
      },
      "colorMint700": {
        "light": "#006b48",
        "dark": "#006b48"
      },
      "colorMint800": {
        "light": "#005237",
        "dark": "#005237"
      },
      "colorMint950": {
        "light": "#003322",
        "dark": "#003322"
      },
      "colorIndigo50": {
        "light": "#f5f7ff",
        "dark": "#f5f7ff"
      },
      "colorIndigo400": {
        "light": "#7598ff",
        "dark": "#7598ff"
      },
      "colorIndigo600": {
        "light": "#295eff",
        "dark": "#295eff"
      },
      "colorIndigo950": {
        "light": "#001475",
        "dark": "#001475"
      },
      "colorPurple50": {
        "light": "#faf5ff",
        "dark": "#faf5ff"
      },
      "colorPurple100": {
        "light": "#f2e5ff",
        "dark": "#f2e5ff"
      },
      "colorPurple600": {
        "light": "#962eff",
        "dark": "#962eff"
      },
      "colorPurple800": {
        "light": "#5900b2",
        "dark": "#5900b2"
      },
      "colorPurple950": {
        "light": "#300061",
        "dark": "#300061"
      },
      "colorTeal50": {
        "light": "#ebfffe",
        "dark": "#ebfffe"
      },
      "colorTeal100": {
        "light": "#ccfffc",
        "dark": "#ccfffc"
      },
      "colorTeal400": {
        "light": "#00d6c8",
        "dark": "#00d6c8"
      },
      "colorTeal700": {
        "light": "#00665f",
        "dark": "#00665f"
      },
      "colorTeal800": {
        "light": "#00524c",
        "dark": "#00524c"
      },
      "colorTeal950": {
        "light": "#003330",
        "dark": "#003330"
      },
      "colorCyan50": {
        "light": "#f0feff",
        "dark": "#f0feff"
      },
      "colorCyan100": {
        "light": "#d1fbff",
        "dark": "#d1fbff"
      },
      "colorCyan400": {
        "light": "#00d2e5",
        "dark": "#00d2e5"
      },
      "colorCyan700": {
        "light": "#00627a",
        "dark": "#00627a"
      },
      "colorCyan800": {
        "light": "#004761",
        "dark": "#004761"
      },
      "colorCyan950": {
        "light": "#00293d",
        "dark": "#00293d"
      },
      "colorBlue950": {
        "light": "#00204d",
        "dark": "#00204d"
      },
      "colorViolet50": {
        "light": "#f6f5ff",
        "dark": "#f6f5ff"
      },
      "colorViolet100": {
        "light": "#e8e5ff",
        "dark": "#e8e5ff"
      },
      "colorViolet400": {
        "light": "#978aff",
        "dark": "#978aff"
      },
      "colorViolet700": {
        "light": "#5724ff",
        "dark": "#5724ff"
      },
      "colorViolet800": {
        "light": "#4200db",
        "dark": "#4200db"
      },
      "colorViolet950": {
        "light": "#250070",
        "dark": "#250070"
      },
      "colorFuchsia50": {
        "light": "#fff5fe",
        "dark": "#fff5fe"
      },
      "colorFuchsia100": {
        "light": "#fce5ff",
        "dark": "#fce5ff"
      },
      "colorFuchsia400": {
        "light": "#ec70ff",
        "dark": "#ec70ff"
      },
      "colorFuchsia700": {
        "light": "#a000b8",
        "dark": "#a000b8"
      },
      "colorFuchsia800": {
        "light": "#78008a",
        "dark": "#78008a"
      },
      "colorFuchsia950": {
        "light": "#43004d",
        "dark": "#43004d"
      },
      "colorMagenta50": {
        "light": "#fff5fe",
        "dark": "#fff5fe"
      },
      "colorMagenta100": {
        "light": "#ffe0fb",
        "dark": "#ffe0fb"
      },
      "colorMagenta400": {
        "light": "#ff57e9",
        "dark": "#ff57e9"
      },
      "colorMagenta700": {
        "light": "#b2008f",
        "dark": "#b2008f"
      },
      "colorMagenta800": {
        "light": "#8f0072",
        "dark": "#8f0072"
      },
      "colorMagenta950": {
        "light": "#470039",
        "dark": "#470039"
      },
      "colorPink50": {
        "light": "#fff5fa",
        "dark": "#fff5fa"
      },
      "colorPink100": {
        "light": "#ffe0f0",
        "dark": "#ffe0f0"
      },
      "colorPink400": {
        "light": "#ff66b2",
        "dark": "#ff66b2"
      },
      "colorPink700": {
        "light": "#bb005d",
        "dark": "#bb005d"
      },
      "colorPink800": {
        "light": "#8f0047",
        "dark": "#8f0047"
      },
      "colorPink950": {
        "light": "#4d0020",
        "dark": "#4d0020"
      },
      "colorRose50": {
        "light": "#fff5f8",
        "dark": "#fff5f8"
      },
      "colorRose100": {
        "light": "#ffe0e8",
        "dark": "#ffe0e8"
      },
      "colorRose400": {
        "light": "#ff5c85",
        "dark": "#ff5c85"
      },
      "colorRose700": {
        "light": "#c20030",
        "dark": "#c20030"
      },
      "colorRose800": {
        "light": "#940025",
        "dark": "#940025"
      },
      "colorRose950": {
        "light": "#4d0013",
        "dark": "#4d0013"
      },
      "colorAmber50": {
        "light": "#fff7e6",
        "dark": "#fff7e6"
      },
      "colorAmber100": {
        "light": "#ffe8bd",
        "dark": "#ffe8bd"
      },
      "colorAmber700": {
        "light": "#9e3700",
        "dark": "#9e3700"
      },
      "colorAmber800": {
        "light": "#7a2b00",
        "dark": "#7a2b00"
      },
      "colorAmber950": {
        "light": "#471500",
        "dark": "#471500"
      },
      "colorAwsSquidInk": {
        "light": "#232f3e",
        "dark": "#232f3e"
      },
      "colorTransparent": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBlack": {
        "light": "#000000",
        "dark": "#000000"
      },
      "colorWhite": {
        "light": "#ffffff",
        "dark": "#ffffff"
      },
      "colorChartsRed300": {
        "light": "#ea7158",
        "dark": "#d63f38"
      },
      "colorChartsRed400": {
        "light": "#dc5032",
        "dark": "#ed5958"
      },
      "colorChartsRed500": {
        "light": "#d13313",
        "dark": "#fe6e73"
      },
      "colorChartsRed600": {
        "light": "#ba2e0f",
        "dark": "#ff8a8a"
      },
      "colorChartsRed700": {
        "light": "#a82a0c",
        "dark": "#ffa09e"
      },
      "colorChartsRed800": {
        "light": "#972709",
        "dark": "#ffb3b0"
      },
      "colorChartsRed900": {
        "light": "#892407",
        "dark": "#ffc4c0"
      },
      "colorChartsRed1000": {
        "light": "#7d2105",
        "dark": "#ffd2cf"
      },
      "colorChartsRed1100": {
        "light": "#721e03",
        "dark": "#ffe0dd"
      },
      "colorChartsRed1200": {
        "light": "#671c00",
        "dark": "#ffecea"
      },
      "colorChartsOrange300": {
        "light": "#e07941",
        "dark": "#c55305"
      },
      "colorChartsOrange400": {
        "light": "#cc5f21",
        "dark": "#de6923"
      },
      "colorChartsOrange500": {
        "light": "#bc4d01",
        "dark": "#f27c36"
      },
      "colorChartsOrange600": {
        "light": "#a84401",
        "dark": "#f89256"
      },
      "colorChartsOrange700": {
        "light": "#983c02",
        "dark": "#fca572"
      },
      "colorChartsOrange800": {
        "light": "#8a3603",
        "dark": "#ffb68b"
      },
      "colorChartsOrange900": {
        "light": "#7e3103",
        "dark": "#ffc6a4"
      },
      "colorChartsOrange1000": {
        "light": "#732c02",
        "dark": "#ffd4bb"
      },
      "colorChartsOrange1100": {
        "light": "#692801",
        "dark": "#ffe1cf"
      },
      "colorChartsOrange1200": {
        "light": "#602400",
        "dark": "#ffede2"
      },
      "colorChartsYellow300": {
        "light": "#b2911c",
        "dark": "#977001"
      },
      "colorChartsYellow400": {
        "light": "#9c7b0b",
        "dark": "#b08400"
      },
      "colorChartsYellow500": {
        "light": "#8a6b05",
        "dark": "#c59600"
      },
      "colorChartsYellow600": {
        "light": "#7b5f04",
        "dark": "#d3a61c"
      },
      "colorChartsYellow700": {
        "light": "#6f5504",
        "dark": "#dfb52c"
      },
      "colorChartsYellow800": {
        "light": "#654d03",
        "dark": "#eac33a"
      },
      "colorChartsYellow900": {
        "light": "#5d4503",
        "dark": "#f1cf65"
      },
      "colorChartsYellow1000": {
        "light": "#553f03",
        "dark": "#f7db8a"
      },
      "colorChartsYellow1100": {
        "light": "#4d3901",
        "dark": "#fce5a8"
      },
      "colorChartsYellow1200": {
        "light": "#483300",
        "dark": "#ffefc9"
      },
      "colorChartsGreen300": {
        "light": "#67a353",
        "dark": "#48851a"
      },
      "colorChartsGreen400": {
        "light": "#41902c",
        "dark": "#5a9b29"
      },
      "colorChartsGreen500": {
        "light": "#1f8104",
        "dark": "#69ae34"
      },
      "colorChartsGreen600": {
        "light": "#1a7302",
        "dark": "#7dbd4c"
      },
      "colorChartsGreen700": {
        "light": "#176702",
        "dark": "#8fca61"
      },
      "colorChartsGreen800": {
        "light": "#145d02",
        "dark": "#9fd673"
      },
      "colorChartsGreen900": {
        "light": "#125502",
        "dark": "#b2df8d"
      },
      "colorChartsGreen1000": {
        "light": "#104d01",
        "dark": "#c5e7a8"
      },
      "colorChartsGreen1100": {
        "light": "#0f4601",
        "dark": "#d5efbe"
      },
      "colorChartsGreen1200": {
        "light": "#0d4000",
        "dark": "#e4f7d5"
      },
      "colorChartsTeal300": {
        "light": "#2ea597",
        "dark": "#018977"
      },
      "colorChartsTeal400": {
        "light": "#1c8e81",
        "dark": "#009d89"
      },
      "colorChartsTeal500": {
        "light": "#0d7d70",
        "dark": "#00b09b"
      },
      "colorChartsTeal600": {
        "light": "#096f64",
        "dark": "#40bfa9"
      },
      "colorChartsTeal700": {
        "light": "#06645a",
        "dark": "#5fccb7"
      },
      "colorChartsTeal800": {
        "light": "#045b52",
        "dark": "#77d7c3"
      },
      "colorChartsTeal900": {
        "light": "#03524a",
        "dark": "#94e0d0"
      },
      "colorChartsTeal1000": {
        "light": "#014b44",
        "dark": "#ace9db"
      },
      "colorChartsTeal1100": {
        "light": "#01443e",
        "dark": "#c2f0e6"
      },
      "colorChartsTeal1200": {
        "light": "#003e38",
        "dark": "#d7f7f0"
      },
      "colorChartsBlue1300": {
        "light": "#529ccb",
        "dark": "#00819c"
      },
      "colorChartsBlue1400": {
        "light": "#3184c2",
        "dark": "#0497ba"
      },
      "colorChartsBlue1500": {
        "light": "#0273bb",
        "dark": "#08aad2"
      },
      "colorChartsBlue1600": {
        "light": "#0166ab",
        "dark": "#44b9dd"
      },
      "colorChartsBlue1700": {
        "light": "#015b9d",
        "dark": "#63c6e7"
      },
      "colorChartsBlue1800": {
        "light": "#015292",
        "dark": "#79d2f0"
      },
      "colorChartsBlue1900": {
        "light": "#014a87",
        "dark": "#98dcf5"
      },
      "colorChartsBlue11000": {
        "light": "#01437d",
        "dark": "#b3e4f8"
      },
      "colorChartsBlue11100": {
        "light": "#003c75",
        "dark": "#caedfc"
      },
      "colorChartsBlue11200": {
        "light": "#00366d",
        "dark": "#ddf4ff"
      },
      "colorChartsBlue2300": {
        "light": "#688ae8",
        "dark": "#486de8"
      },
      "colorChartsBlue2400": {
        "light": "#5978e3",
        "dark": "#6384f5"
      },
      "colorChartsBlue2500": {
        "light": "#4066df",
        "dark": "#7698fe"
      },
      "colorChartsBlue2600": {
        "light": "#3759ce",
        "dark": "#8ea9ff"
      },
      "colorChartsBlue2700": {
        "light": "#314fbf",
        "dark": "#a2b8ff"
      },
      "colorChartsBlue2800": {
        "light": "#2c46b1",
        "dark": "#b1c5ff"
      },
      "colorChartsBlue2900": {
        "light": "#273ea5",
        "dark": "#c3d1ff"
      },
      "colorChartsBlue21000": {
        "light": "#23379b",
        "dark": "#d2dcff"
      },
      "colorChartsBlue21100": {
        "light": "#1f3191",
        "dark": "#dfe6ff"
      },
      "colorChartsBlue21200": {
        "light": "#1b2b88",
        "dark": "#ecf0ff"
      },
      "colorChartsPurple300": {
        "light": "#a783e1",
        "dark": "#8d59de"
      },
      "colorChartsPurple400": {
        "light": "#9469d6",
        "dark": "#a173ea"
      },
      "colorChartsPurple500": {
        "light": "#8456ce",
        "dark": "#b088f5"
      },
      "colorChartsPurple600": {
        "light": "#7749bf",
        "dark": "#bf9bf9"
      },
      "colorChartsPurple700": {
        "light": "#6b40b2",
        "dark": "#cbabfc"
      },
      "colorChartsPurple800": {
        "light": "#6237a7",
        "dark": "#d6baff"
      },
      "colorChartsPurple900": {
        "light": "#59309d",
        "dark": "#dfc8ff"
      },
      "colorChartsPurple1000": {
        "light": "#512994",
        "dark": "#e8d5ff"
      },
      "colorChartsPurple1100": {
        "light": "#4a238b",
        "dark": "#efe2ff"
      },
      "colorChartsPurple1200": {
        "light": "#431d84",
        "dark": "#f5edff"
      },
      "colorChartsPink300": {
        "light": "#da7596",
        "dark": "#c64a70"
      },
      "colorChartsPink400": {
        "light": "#ce567c",
        "dark": "#d56889"
      },
      "colorChartsPink500": {
        "light": "#c33d69",
        "dark": "#e07f9d"
      },
      "colorChartsPink600": {
        "light": "#b1325c",
        "dark": "#eb92ad"
      },
      "colorChartsPink700": {
        "light": "#a32952",
        "dark": "#f5a2bb"
      },
      "colorChartsPink800": {
        "light": "#962249",
        "dark": "#ffb0c8"
      },
      "colorChartsPink900": {
        "light": "#8b1b42",
        "dark": "#ffc1d4"
      },
      "colorChartsPink1000": {
        "light": "#81143b",
        "dark": "#ffd1de"
      },
      "colorChartsPink1100": {
        "light": "#780d35",
        "dark": "#ffdfe8"
      },
      "colorChartsPink1200": {
        "light": "#6f062f",
        "dark": "#ffecf1"
      },
      "colorChartsStatusCritical": {
        "light": "{colorChartsRed1000}",
        "dark": "{colorChartsRed300}"
      },
      "colorChartsStatusHigh": {
        "light": "{colorChartsRed600}",
        "dark": "{colorChartsRed500}"
      },
      "colorChartsStatusMedium": {
        "light": "{colorChartsOrange400}",
        "dark": "{colorChartsOrange600}"
      },
      "colorChartsStatusLow": {
        "light": "{colorChartsYellow300}",
        "dark": "{colorChartsYellow700}"
      },
      "colorChartsStatusPositive": {
        "light": "{colorChartsGreen300}",
        "dark": "{colorChartsGreen500}"
      },
      "colorChartsStatusInfo": {
        "light": "{colorChartsBlue1400}",
        "dark": "{colorChartsBlue1500}"
      },
      "colorChartsStatusNeutral": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorChartsThresholdNegative": {
        "light": "{colorError600}",
        "dark": "{colorError400}"
      },
      "colorChartsThresholdPositive": {
        "light": "{colorSuccess600}",
        "dark": "{colorSuccess500}"
      },
      "colorChartsThresholdInfo": {
        "light": "{colorInfo600}",
        "dark": "{colorInfo300}"
      },
      "colorChartsThresholdNeutral": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorChartsLineGrid": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorChartsLineTick": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorChartsLineAxis": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorChartsPaletteCategorical1": {
        "light": "{colorChartsBlue2300}",
        "dark": "{colorChartsBlue2300}"
      },
      "colorChartsPaletteCategorical2": {
        "light": "{colorChartsPink500}",
        "dark": "{colorChartsPink500}"
      },
      "colorChartsPaletteCategorical3": {
        "light": "{colorChartsTeal300}",
        "dark": "{colorChartsTeal300}"
      },
      "colorChartsPaletteCategorical4": {
        "light": "{colorChartsPurple500}",
        "dark": "{colorChartsPurple500}"
      },
      "colorChartsPaletteCategorical5": {
        "light": "{colorChartsOrange300}",
        "dark": "{colorChartsOrange300}"
      },
      "colorChartsPaletteCategorical6": {
        "light": "{colorChartsBlue2600}",
        "dark": "{colorChartsBlue2600}"
      },
      "colorChartsPaletteCategorical7": {
        "light": "{colorChartsPink800}",
        "dark": "{colorChartsPink800}"
      },
      "colorChartsPaletteCategorical8": {
        "light": "{colorChartsTeal600}",
        "dark": "{colorChartsTeal600}"
      },
      "colorChartsPaletteCategorical9": {
        "light": "{colorChartsPurple800}",
        "dark": "{colorChartsPurple800}"
      },
      "colorChartsPaletteCategorical10": {
        "light": "{colorChartsOrange600}",
        "dark": "{colorChartsOrange600}"
      },
      "colorChartsPaletteCategorical11": {
        "light": "{colorChartsBlue2900}",
        "dark": "{colorChartsBlue2900}"
      },
      "colorChartsPaletteCategorical12": {
        "light": "{colorChartsPink1100}",
        "dark": "{colorChartsPink1100}"
      },
      "colorChartsPaletteCategorical13": {
        "light": "{colorChartsTeal900}",
        "dark": "{colorChartsTeal900}"
      },
      "colorChartsPaletteCategorical14": {
        "light": "{colorChartsPurple1100}",
        "dark": "{colorChartsPurple1100}"
      },
      "colorChartsPaletteCategorical15": {
        "light": "{colorChartsOrange900}",
        "dark": "{colorChartsOrange900}"
      },
      "colorChartsPaletteCategorical16": {
        "light": "{colorChartsBlue21200}",
        "dark": "{colorChartsBlue21200}"
      },
      "colorChartsPaletteCategorical17": {
        "light": "{colorChartsPink400}",
        "dark": "{colorChartsPink400}"
      },
      "colorChartsPaletteCategorical18": {
        "light": "{colorChartsTeal1200}",
        "dark": "{colorChartsTeal1200}"
      },
      "colorChartsPaletteCategorical19": {
        "light": "{colorChartsPurple400}",
        "dark": "{colorChartsPurple400}"
      },
      "colorChartsPaletteCategorical20": {
        "light": "{colorChartsOrange1200}",
        "dark": "{colorChartsOrange1200}"
      },
      "colorChartsPaletteCategorical21": {
        "light": "{colorChartsBlue2500}",
        "dark": "{colorChartsBlue2500}"
      },
      "colorChartsPaletteCategorical22": {
        "light": "{colorChartsPink700}",
        "dark": "{colorChartsPink700}"
      },
      "colorChartsPaletteCategorical23": {
        "light": "{colorChartsTeal500}",
        "dark": "{colorChartsTeal500}"
      },
      "colorChartsPaletteCategorical24": {
        "light": "{colorChartsPurple700}",
        "dark": "{colorChartsPurple700}"
      },
      "colorChartsPaletteCategorical25": {
        "light": "{colorChartsOrange500}",
        "dark": "{colorChartsOrange500}"
      },
      "colorChartsPaletteCategorical26": {
        "light": "{colorChartsBlue2800}",
        "dark": "{colorChartsBlue2800}"
      },
      "colorChartsPaletteCategorical27": {
        "light": "{colorChartsPink1000}",
        "dark": "{colorChartsPink1000}"
      },
      "colorChartsPaletteCategorical28": {
        "light": "{colorChartsTeal800}",
        "dark": "{colorChartsTeal800}"
      },
      "colorChartsPaletteCategorical29": {
        "light": "{colorChartsPurple1000}",
        "dark": "{colorChartsPurple1000}"
      },
      "colorChartsPaletteCategorical30": {
        "light": "{colorChartsOrange800}",
        "dark": "{colorChartsOrange800}"
      },
      "colorChartsPaletteCategorical31": {
        "light": "{colorChartsBlue21100}",
        "dark": "{colorChartsBlue21100}"
      },
      "colorChartsPaletteCategorical32": {
        "light": "{colorChartsPink300}",
        "dark": "{colorChartsPink300}"
      },
      "colorChartsPaletteCategorical33": {
        "light": "{colorChartsTeal1100}",
        "dark": "{colorChartsTeal1100}"
      },
      "colorChartsPaletteCategorical34": {
        "light": "{colorChartsPurple300}",
        "dark": "{colorChartsPurple300}"
      },
      "colorChartsPaletteCategorical35": {
        "light": "{colorChartsOrange1100}",
        "dark": "{colorChartsOrange1100}"
      },
      "colorChartsPaletteCategorical36": {
        "light": "{colorChartsBlue2400}",
        "dark": "{colorChartsBlue2400}"
      },
      "colorChartsPaletteCategorical37": {
        "light": "{colorChartsPink600}",
        "dark": "{colorChartsPink600}"
      },
      "colorChartsPaletteCategorical38": {
        "light": "{colorChartsTeal400}",
        "dark": "{colorChartsTeal400}"
      },
      "colorChartsPaletteCategorical39": {
        "light": "{colorChartsPurple600}",
        "dark": "{colorChartsPurple600}"
      },
      "colorChartsPaletteCategorical40": {
        "light": "{colorChartsOrange400}",
        "dark": "{colorChartsOrange400}"
      },
      "colorChartsPaletteCategorical41": {
        "light": "{colorChartsBlue2700}",
        "dark": "{colorChartsBlue2700}"
      },
      "colorChartsPaletteCategorical42": {
        "light": "{colorChartsPink900}",
        "dark": "{colorChartsPink900}"
      },
      "colorChartsPaletteCategorical43": {
        "light": "{colorChartsTeal700}",
        "dark": "{colorChartsTeal700}"
      },
      "colorChartsPaletteCategorical44": {
        "light": "{colorChartsPurple900}",
        "dark": "{colorChartsPurple900}"
      },
      "colorChartsPaletteCategorical45": {
        "light": "{colorChartsOrange700}",
        "dark": "{colorChartsOrange700}"
      },
      "colorChartsPaletteCategorical46": {
        "light": "{colorChartsBlue21000}",
        "dark": "{colorChartsBlue21000}"
      },
      "colorChartsPaletteCategorical47": {
        "light": "{colorChartsPink1200}",
        "dark": "{colorChartsPink1200}"
      },
      "colorChartsPaletteCategorical48": {
        "light": "{colorChartsTeal1000}",
        "dark": "{colorChartsTeal1000}"
      },
      "colorChartsPaletteCategorical49": {
        "light": "{colorChartsPurple1200}",
        "dark": "{colorChartsPurple1200}"
      },
      "colorChartsPaletteCategorical50": {
        "light": "{colorChartsOrange1000}",
        "dark": "{colorChartsOrange1000}"
      },
      "colorChartsErrorBarMarker": {
        "light": "{colorNeutral900}",
        "dark": "{colorWhite}"
      },
      "colorSeverityDarkRed": {
        "light": "#870303",
        "dark": "#d63f38"
      },
      "colorSeverityRed": {
        "light": "#ce3311",
        "dark": "#fe6e73"
      },
      "colorSeverityOrange": {
        "light": "#f89256",
        "dark": "#f89256"
      },
      "colorSeverityYellow": {
        "light": "#f2cd54",
        "dark": "#f2cd54"
      },
      "colorSeverityGrey": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral600}"
      },
      "colorBackgroundNotificationSeverityCritical": {
        "light": "{colorSeverityDarkRed}",
        "dark": "{colorSeverityDarkRed}"
      },
      "colorBackgroundNotificationSeverityHigh": {
        "light": "{colorSeverityRed}",
        "dark": "{colorSeverityRed}"
      },
      "colorBackgroundNotificationSeverityMedium": {
        "light": "{colorSeverityOrange}",
        "dark": "{colorSeverityOrange}"
      },
      "colorBackgroundNotificationSeverityLow": {
        "light": "{colorSeverityYellow}",
        "dark": "{colorSeverityYellow}"
      },
      "colorBackgroundNotificationSeverityNeutral": {
        "light": "{colorSeverityGrey}",
        "dark": "{colorSeverityGrey}"
      },
      "colorTextNotificationSeverityCritical": {
        "light": "{colorNeutral100}",
        "dark": "{colorBlack}"
      },
      "colorTextNotificationSeverityHigh": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral950}"
      },
      "colorTextNotificationSeverityMedium": {
        "light": "{colorBlack}",
        "dark": "{colorNeutral950}"
      },
      "colorTextNotificationSeverityLow": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral950}"
      },
      "colorTextNotificationSeverityNeutral": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral100}"
      },
      "colorBorderBadgeSeverityCritical": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeSeverityHigh": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeSeverityMedium": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeSeverityLow": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeSeverityNeutral": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorTextBadgeSeverityCritical": {
        "light": "{colorTextNotificationSeverityCritical}",
        "dark": "{colorTextNotificationSeverityCritical}"
      },
      "colorTextBadgeSeverityHigh": {
        "light": "{colorTextNotificationSeverityHigh}",
        "dark": "{colorTextNotificationSeverityHigh}"
      },
      "colorTextBadgeSeverityMedium": {
        "light": "{colorTextNotificationSeverityMedium}",
        "dark": "{colorTextNotificationSeverityMedium}"
      },
      "colorTextBadgeSeverityLow": {
        "light": "{colorTextNotificationSeverityLow}",
        "dark": "{colorTextNotificationSeverityLow}"
      },
      "colorTextBadgeSeverityNeutral": {
        "light": "{colorTextNotificationSeverityNeutral}",
        "dark": "{colorTextNotificationSeverityNeutral}"
      },
      "colorGreyOpaque10": {
        "light": "rgba(0, 0, 0, 0.1)",
        "dark": "rgba(0, 0, 0, 0.1)"
      },
      "colorGreyOpaque25": {
        "light": "rgba(255, 255, 255, 0.25)",
        "dark": "rgba(255, 255, 255, 0.25)"
      },
      "colorGreyOpaque40": {
        "light": "rgba(0, 0, 0, 0.4)",
        "dark": "rgba(0, 0, 0, 0.4)"
      },
      "colorGreyOpaque50": {
        "light": "rgba(0, 0, 0, 0.5)",
        "dark": "rgba(0, 0, 0, 0.5)"
      },
      "colorGreyOpaque70": {
        "light": "rgba(255, 255, 255, 0.7)",
        "dark": "rgba(255, 255, 255, 0.7)"
      },
      "colorGreyOpaque80": {
        "light": "rgba(22, 25, 31, 0.8)",
        "dark": "rgba(22, 25, 31, 0.8)"
      },
      "colorGreyOpaque90": {
        "light": "rgba(242, 243, 243, 0.9)",
        "dark": "rgba(242, 243, 243, 0.9)"
      },
      "colorGreyTransparent": {
        "light": "rgba(0, 28, 36, 0.3)",
        "dark": "rgba(0, 0, 0, 0.3)"
      },
      "colorGreyTransparentHeavy": {
        "light": "rgba(0, 28, 36, 0.5)",
        "dark": "rgba(0, 0, 0, 0.5)"
      },
      "colorGreyTransparentLight": {
        "light": "rgba(0, 28, 36, 0.15)",
        "dark": "rgba(0, 0, 0, 0.3)"
      },
      "colorBackgroundBadgeIcon": {
        "light": "{colorError600}",
        "dark": "{colorError400}"
      },
      "colorBackgroundButtonLinkActive": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral950}"
      },
      "colorBackgroundButtonLinkDefault": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundButtonLinkDisabled": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundButtonLinkHover": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundButtonNormalActive": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral950}"
      },
      "colorBackgroundButtonNormalDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundButtonNormalDisabled": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundButtonNormalHover": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundToggleButtonNormalPressed": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral950}"
      },
      "colorBackgroundToggleButtonNormalDefault": {
        "light": "{colorBackgroundButtonNormalDefault}",
        "dark": "{colorBackgroundButtonNormalDefault}"
      },
      "colorBackgroundToggleButtonNormalHover": {
        "light": "{colorBackgroundButtonNormalHover}",
        "dark": "{colorBackgroundButtonNormalHover}"
      },
      "colorBackgroundButtonPrimaryActive": {
        "light": "{colorPrimary1000}",
        "dark": "{colorPrimary300}"
      },
      "colorBackgroundButtonPrimaryDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary300}"
      },
      "colorBackgroundButtonPrimaryDisabled": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundButtonPrimaryHover": {
        "light": "{colorPrimary700}",
        "dark": "{colorPrimary400}"
      },
      "colorBackgroundDirectionButtonActive": {
        "light": "{colorNeutral750}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundDirectionButtonDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral650}"
      },
      "colorBackgroundDirectionButtonDisabled": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundDirectionButtonHover": {
        "light": "{colorNeutral700}",
        "dark": "{colorNeutral700}"
      },
      "colorTextDirectionButtonDefault": {
        "light": "{colorWhite}",
        "dark": "{colorWhite}"
      },
      "colorTextDirectionButtonDisabled": {
        "light": "{colorTextInteractiveDisabled}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorBackgroundCalendarCurrentDate": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral950}"
      },
      "colorBackgroundCellShaded": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral950}"
      },
      "colorBackgroundCodeEditorGutterActiveLineDefault": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral500}"
      },
      "colorBackgroundCodeEditorGutterActiveLineError": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorBackgroundCodeEditorGutterDefault": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundCodeEditorLoading": {
        "light": "{colorBackgroundCodeEditorStatusBar}",
        "dark": "{colorBackgroundCodeEditorStatusBar}"
      },
      "colorBackgroundCodeEditorPaneItemHover": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundCodeEditorStatusBar": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundCard": {
        "light": "{colorBackgroundContainerContent}",
        "dark": "{colorBackgroundContainerContent}"
      },
      "colorBackgroundItemCard": {
        "light": "{colorBackgroundCard}",
        "dark": "{colorBackgroundCard}"
      },
      "colorBackgroundContainerContent": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundContainerHeader": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundControlChecked": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBackgroundControlDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorBackgroundControlDisabled": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundDropdownItemDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundDropdownItemDimmed": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundDropdownItemFilterMatch": {
        "light": "{colorPrimary50}",
        "dark": "{colorPrimary1000}"
      },
      "colorBackgroundDropdownItemHover": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundDropdownItemSelected": {
        "light": "{colorBackgroundItemSelected}",
        "dark": "{colorBackgroundItemSelected}"
      },
      "colorBackgroundHomeHeader": {
        "light": "{colorBlack}",
        "dark": "{colorBlack}"
      },
      "colorBackgroundInlineCode": {
        "light": "rgba(0, 0, 0, 0.1)",
        "dark": "rgba(255, 255, 255, 0.1)"
      },
      "colorBackgroundInputDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorBackgroundInputDisabled": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundItemSelected": {
        "light": "{colorPrimary50}",
        "dark": "{colorPrimary1000}"
      },
      "colorBackgroundSideNavigationItemActive": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundSideNavigationItemActiveCollapsed": {
        "light": "{colorBackgroundControlChecked}",
        "dark": "{colorBackgroundControlChecked}"
      },
      "colorBackgroundSideNavigationItemIconHover": {
        "light": "{colorBackgroundItemSelected}",
        "dark": "{colorBackgroundItemSelected}"
      },
      "colorBackgroundLayoutMain": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral950}"
      },
      "colorBackgroundLayoutAiDrawer": {
        "light": "{colorNeutral850}",
        "dark": "{colorNeutral850}"
      },
      "colorBackgroundDrawer": {
        "light": "{colorBackgroundLayoutPanelContent}",
        "dark": "{colorBackgroundLayoutPanelContent}"
      },
      "colorBackgroundBackdrop": {
        "light": "{colorGreyOpaque90}",
        "dark": "{colorGreyOpaque80}"
      },
      "colorBackgroundDrawerBackdrop": {
        "light": "{colorBackgroundBackdrop}",
        "dark": "{colorBackgroundBackdrop}"
      },
      "colorBackgroundLayoutMobilePanel": {
        "light": "{colorBackgroundLayoutPanelContent}",
        "dark": "{colorBackgroundLayoutPanelContent}"
      },
      "colorBackgroundLayoutPanel": {
        "light": "{colorBackgroundContainerContent}",
        "dark": "{colorBackgroundContainerContent}"
      },
      "colorBackgroundLayoutPanelContent": {
        "light": "{colorBackgroundContainerContent}",
        "dark": "{colorBackgroundContainerContent}"
      },
      "colorBackgroundLayoutPanelHover": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundLayoutToolbar": {
        "light": "{colorBackgroundLayoutPanelContent}",
        "dark": "{colorBackgroundLayoutPanelContent}"
      },
      "colorBackgroundLayoutToggleActive": {
        "light": "{colorNeutral750}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundLayoutToggleDefault": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundLayoutToggleHover": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral650}"
      },
      "colorBackgroundLayoutToggleSelectedActive": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBackgroundLayoutToggleSelectedDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary300}"
      },
      "colorBackgroundLayoutToggleSelectedHover": {
        "light": "{colorPrimary700}",
        "dark": "{colorPrimary300}"
      },
      "colorBackgroundModalOverlay": {
        "light": "{colorBackgroundBackdrop}",
        "dark": "{colorBackgroundBackdrop}"
      },
      "colorBackgroundNotificationBlue": {
        "light": "{colorInfo600}",
        "dark": "{colorInfo600}"
      },
      "colorBackgroundNotificationGreen": {
        "light": "{colorSuccess600}",
        "dark": "{colorSuccess600}"
      },
      "colorBackgroundNotificationGrey": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral600}"
      },
      "colorBackgroundNotificationRed": {
        "light": "{colorError600}",
        "dark": "{colorError600}"
      },
      "colorBackgroundNotificationYellow": {
        "light": "{colorWarning400}",
        "dark": "{colorWarning400}"
      },
      "colorBackgroundFlashbarSuccess": {
        "light": "{colorBackgroundNotificationGreen}",
        "dark": "{colorBackgroundNotificationGreen}"
      },
      "colorBackgroundFlashbarError": {
        "light": "{colorBackgroundNotificationRed}",
        "dark": "{colorBackgroundNotificationRed}"
      },
      "colorBackgroundFlashbarInfo": {
        "light": "{colorBackgroundNotificationBlue}",
        "dark": "{colorBackgroundNotificationBlue}"
      },
      "colorBackgroundFlashbarWarning": {
        "light": "{colorBackgroundNotificationYellow}",
        "dark": "{colorBackgroundNotificationYellow}"
      },
      "colorBackgroundNotificationStackBar": {
        "light": "{colorNeutral750}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundNotificationStackBarActive": {
        "light": "{colorNeutral750}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundNotificationStackBarHover": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral650}"
      },
      "colorBackgroundPopover": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundProgressBarValueDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBackgroundProgressBarValueFlash": {
        "light": "{colorBackgroundProgressBarValueDefault}",
        "dark": "{colorBackgroundProgressBarValueDefault}"
      },
      "colorBackgroundProgressBarFlash": {
        "light": "{colorBackgroundProgressBarDefault}",
        "dark": "{colorBackgroundProgressBarDefault}"
      },
      "colorBackgroundProgressBarDefault": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundSegmentActive": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBackgroundSegmentDefault": {
        "light": "{colorBackgroundButtonNormalDefault}",
        "dark": "{colorBackgroundButtonNormalDefault}"
      },
      "colorBackgroundSegmentDisabled": {
        "light": "{colorBackgroundButtonNormalDisabled}",
        "dark": "{colorBackgroundButtonNormalDisabled}"
      },
      "colorBackgroundSegmentHover": {
        "light": "{colorBackgroundButtonNormalHover}",
        "dark": "{colorBackgroundButtonNormalHover}"
      },
      "colorBackgroundSegmentWrapper": {
        "light": "{colorBackgroundContainerContent}",
        "dark": "{colorBackgroundContainerContent}"
      },
      "colorBackgroundSliderRangeDefault": {
        "light": "{colorBackgroundSliderHandleDefault}",
        "dark": "{colorBackgroundSliderHandleDefault}"
      },
      "colorBackgroundSliderRangeActive": {
        "light": "{colorBackgroundSliderHandleActive}",
        "dark": "{colorBackgroundSliderHandleActive}"
      },
      "colorBackgroundSliderHandleDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBackgroundSliderHandleActive": {
        "light": "{colorPrimary700}",
        "dark": "{colorPrimary300}"
      },
      "colorBackgroundSliderTrackDefault": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral600}"
      },
      "colorBackgroundSliderHandleRing": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorBackgroundSliderHandleErrorDefault": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorBackgroundSliderHandleErrorActive": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorBackgroundSliderHandleWarningDefault": {
        "light": "{colorTextStatusWarning}",
        "dark": "{colorTextStatusWarning}"
      },
      "colorBackgroundSliderHandleWarningActive": {
        "light": "{colorTextStatusWarning}",
        "dark": "{colorTextStatusWarning}"
      },
      "colorBackgroundSliderRangeErrorDefault": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorBackgroundSliderRangeErrorActive": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorBackgroundSliderRangeWarningDefault": {
        "light": "{colorTextStatusWarning}",
        "dark": "{colorTextStatusWarning}"
      },
      "colorBackgroundSliderRangeWarningActive": {
        "light": "{colorTextStatusWarning}",
        "dark": "{colorTextStatusWarning}"
      },
      "colorBackgroundStatusError": {
        "light": "{colorError50}",
        "dark": "{colorError1000}"
      },
      "colorBackgroundStatusInfo": {
        "light": "{colorInfo50}",
        "dark": "{colorInfo1000}"
      },
      "colorBackgroundAlertError": {
        "light": "{colorBackgroundStatusError}",
        "dark": "{colorBackgroundStatusError}"
      },
      "colorBackgroundAlertInfo": {
        "light": "{colorBackgroundStatusInfo}",
        "dark": "{colorBackgroundStatusInfo}"
      },
      "colorBackgroundAlertSuccess": {
        "light": "{colorBackgroundStatusSuccess}",
        "dark": "{colorBackgroundStatusSuccess}"
      },
      "colorBackgroundAlertWarning": {
        "light": "{colorBackgroundStatusWarning}",
        "dark": "{colorBackgroundStatusWarning}"
      },
      "colorBackgroundDialog": {
        "light": "{colorBackgroundStatusInfo}",
        "dark": "{colorBackgroundStatusInfo}"
      },
      "colorBackgroundDialogDefault": {
        "light": "{colorBackgroundCard}",
        "dark": "{colorBackgroundCard}"
      },
      "colorBackgroundStatusSuccess": {
        "light": "{colorSuccess50}",
        "dark": "{colorSuccess1000}"
      },
      "colorBackgroundStatusWarning": {
        "light": "{colorWarning50}",
        "dark": "{colorWarning1000}"
      },
      "colorBackgroundTableHeader": {
        "light": "{colorBackgroundContainerHeader}",
        "dark": "{colorBackgroundContainerHeader}"
      },
      "colorBackgroundTilesDisabled": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral750}"
      },
      "colorBackgroundToggleCheckedDisabled": {
        "light": "{colorPrimary200}",
        "dark": "{colorPrimary700}"
      },
      "colorBackgroundToggleDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral500}"
      },
      "colorBackgroundAvatarGenAi": {
        "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
        "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
      },
      "colorBackgroundAvatarDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral650}"
      },
      "colorTextAvatar": {
        "light": "{colorWhite}",
        "dark": "{colorWhite}"
      },
      "colorBackgroundLoadingBarGenAi": {
        "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
        "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
      },
      "colorBackgroundStatusIndicatorError": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundStatusIndicatorWarning": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundStatusIndicatorSuccess": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundStatusIndicatorInfo": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundStatusIndicatorNeutral": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundChatBubbleOutgoing": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBackgroundChatBubbleIncoming": {
        "light": "{colorNeutral200}",
        "dark": "{colorNeutral950}"
      },
      "colorTextChatBubbleOutgoing": {
        "light": "{colorTextBodyDefault}",
        "dark": "{colorTextBodyDefault}"
      },
      "colorTextChatBubbleIncoming": {
        "light": "{colorTextBodyDefault}",
        "dark": "{colorTextBodyDefault}"
      },
      "colorBorderButtonLinkDisabled": {
        "light": "{colorBackgroundButtonLinkDisabled}",
        "dark": "{colorBackgroundButtonLinkDisabled}"
      },
      "colorBorderButtonNormalActive": {
        "light": "{colorBorderButtonNormalDefault}",
        "dark": "{colorBorderButtonNormalDefault}"
      },
      "colorBorderButtonNormalDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderToggleButtonNormalPressed": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderToggleButtonNormalDefault": {
        "light": "{colorBorderButtonNormalDefault}",
        "dark": "{colorBorderButtonNormalDefault}"
      },
      "colorBorderToggleButtonNormalHover": {
        "light": "{colorBorderButtonNormalHover}",
        "dark": "{colorBorderButtonNormalHover}"
      },
      "colorBorderButtonNormalDisabled": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorTextButtonNormalDisabled": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderButtonNormalHover": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral400}"
      },
      "colorTextButtonIconDisabled": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderButtonPrimaryActive": {
        "light": "{colorBackgroundButtonPrimaryActive}",
        "dark": "{colorBackgroundButtonPrimaryActive}"
      },
      "colorBorderButtonPrimaryDefault": {
        "light": "{colorBackgroundButtonPrimaryDefault}",
        "dark": "{colorBackgroundButtonPrimaryDefault}"
      },
      "colorBorderButtonPrimaryDisabled": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderButtonPrimaryHover": {
        "light": "{colorBackgroundButtonPrimaryHover}",
        "dark": "{colorBackgroundButtonPrimaryHover}"
      },
      "colorTextButtonPrimaryDisabled": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorItemSelected": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary300}"
      },
      "colorTextSideNavigationItemActive": {
        "light": "{colorTextAccent}",
        "dark": "{colorTextAccent}"
      },
      "colorTextSideNavigationItemActiveCollapsed": {
        "light": "{colorTextInverted}",
        "dark": "{colorTextInverted}"
      },
      "colorTextSideNavigationItemDefault": {
        "light": "{colorTextBodySecondary}",
        "dark": "{colorTextBodySecondary}"
      },
      "colorBorderCalendarGrid": {
        "light": "{colorBorderDropdownItemDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorBorderCalendarGridSelectedFocusRing": {
        "light": "{colorBorderItemFocused}",
        "dark": "{colorBorderItemFocused}"
      },
      "colorBorderCellShaded": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderCodeEditorAceActiveLineLightTheme": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral300}"
      },
      "colorBorderCodeEditorAceActiveLineDarkTheme": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral600}"
      },
      "colorBorderCodeEditorDefault": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral600}"
      },
      "colorBorderCodeEditorPaneItemHover": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderCard": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorBorderCardHighlighted": {
        "light": "{colorBorderItemSelected}",
        "dark": "{colorBorderItemSelected}"
      },
      "colorBorderItemCard": {
        "light": "{colorBorderCard}",
        "dark": "{colorBorderCard}"
      },
      "colorBorderItemCardHighlighted": {
        "light": "{colorBorderCardHighlighted}",
        "dark": "{colorBorderCardHighlighted}"
      },
      "colorBorderContainerDivider": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorBorderContainerTop": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral750}"
      },
      "colorBorderControlChecked": {
        "light": "{colorBackgroundControlChecked}",
        "dark": "{colorBackgroundControlChecked}"
      },
      "colorBorderControlDefault": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderControlDisabled": {
        "light": "{colorBackgroundControlDisabled}",
        "dark": "{colorBackgroundControlDisabled}"
      },
      "colorBorderDividerActive": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral600}"
      },
      "colorBorderDividerDefault": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderDividerNotification": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorBorderDividerPanelBottom": {
        "light": "{colorShadowSide}",
        "dark": "{colorShadowSide}"
      },
      "colorBorderDividerPanelSide": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderDividerSecondary": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderDividerTableGroup": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral600}"
      },
      "colorBorderDropdownContainer": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderDropdownGroup": {
        "light": "{colorBorderDropdownItemDefault}",
        "dark": "{colorBorderDropdownItemDefault}"
      },
      "colorBorderDropdownItemDefault": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorBorderDropdownItemHover": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderDropdownItemDimmedHover": {
        "light": "{colorBorderDropdownItemHover}",
        "dark": "{colorBorderDropdownItemHover}"
      },
      "colorBorderDropdownItemSelected": {
        "light": "{colorBorderDropdownItemDefault}",
        "dark": "{colorBorderDropdownItemDefault}"
      },
      "colorBorderDropdownItemTop": {
        "light": "{colorBorderDropdownItemDefault}",
        "dark": "{colorBorderDropdownItemDefault}"
      },
      "colorBorderEditableCellHover": {
        "light": "{colorBorderDropdownItemHover}",
        "dark": "{colorBorderDropdownItemHover}"
      },
      "colorBorderInputDefault": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderInputDisabled": {
        "light": "{colorBackgroundInputDisabled}",
        "dark": "{colorBackgroundInputDisabled}"
      },
      "colorBorderInputFocused": {
        "light": "{colorBorderItemFocused}",
        "dark": "{colorBorderItemFocused}"
      },
      "colorBorderItemFocused": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBorderDropdownItemFocused": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBorderItemPlaceholder": {
        "light": "{colorTransparent}",
        "dark": "{colorTransparent}"
      },
      "colorBorderItemSelected": {
        "light": "{colorItemSelected}",
        "dark": "{colorPrimary400}"
      },
      "colorBorderLayout": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderLayoutSideNavigation": {
        "light": "{colorBorderLayout}",
        "dark": "{colorBorderLayout}"
      },
      "colorBorderNotificationStackBar": {
        "light": "{colorNeutral750}",
        "dark": "{colorNeutral750}"
      },
      "colorBorderNotificationStackBarHover": {
        "light": "{colorBackgroundNotificationStackBarHover}",
        "dark": "{colorBackgroundNotificationStackBarHover}"
      },
      "colorBorderNotificationStackBarActive": {
        "light": "{colorBackgroundNotificationStackBar}",
        "dark": "{colorBackgroundNotificationStackBar}"
      },
      "colorBorderNotificationStackBarFocused": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral100}"
      },
      "colorBorderPanelHeader": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorBorderPopover": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral650}"
      },
      "colorBorderSegmentActive": {
        "light": "{colorBorderSegmentHover}",
        "dark": "{colorBorderSegmentHover}"
      },
      "colorBorderSegmentDefault": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral500}"
      },
      "colorBorderSegmentDisabled": {
        "light": "{colorBorderButtonNormalDisabled}",
        "dark": "{colorBorderButtonNormalDisabled}"
      },
      "colorBorderSegmentDivider": {
        "light": "{colorBorderInputDefault}",
        "dark": "{colorBorderInputDefault}"
      },
      "colorBorderSegmentHover": {
        "light": "{colorNeutral950}",
        "dark": "{colorWhite}"
      },
      "colorBorderSegmentWrapper": {
        "light": "{colorBorderInputDefault}",
        "dark": "{colorBorderInputDefault}"
      },
      "colorBorderStatusError": {
        "light": "{colorError600}",
        "dark": "{colorError600}"
      },
      "colorBorderStatusInfo": {
        "light": "{colorInfo600}",
        "dark": "{colorInfo400}"
      },
      "colorBorderStatusSuccess": {
        "light": "{colorSuccess600}",
        "dark": "{colorSuccess600}"
      },
      "colorBorderStatusWarning": {
        "light": "{colorWarning900}",
        "dark": "{colorWarning500}"
      },
      "colorBorderDialog": {
        "light": "{colorBorderStatusInfo}",
        "dark": "{colorBorderStatusInfo}"
      },
      "colorBorderDialogDefault": {
        "light": "{colorBorderCard}",
        "dark": "{colorBorderCard}"
      },
      "colorBorderDividerInteractiveDefault": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral600}"
      },
      "colorBorderTabsDivider": {
        "light": "{colorNeutral400}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderTabsShadow": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorGreyTransparent}"
      },
      "colorBorderTabsUnderline": {
        "light": "{colorTextInteractiveHover}",
        "dark": "{colorTextInteractiveHover}"
      },
      "colorBorderTilesDisabled": {
        "light": "{colorTransparent}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderTutorial": {
        "light": "{colorNeutral400}",
        "dark": "{colorNeutral500}"
      },
      "colorForegroundControlDefault": {
        "light": "{colorWhite}",
        "dark": "{colorWhite}"
      },
      "colorForegroundControlDisabled": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral600}"
      },
      "colorForegroundControlReadOnly": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorShadowDefault": {
        "light": "{colorGreyTransparentHeavy}",
        "dark": "{colorGreyTransparentHeavy}"
      },
      "colorShadowMedium": {
        "light": "{colorGreyTransparent}",
        "dark": "{colorGreyTransparent}"
      },
      "colorShadowSide": {
        "light": "{colorGreyTransparentLight}",
        "dark": "{colorGreyTransparentLight}"
      },
      "colorShadowToggleHandle": {
        "light": "rgba(0, 0, 0, 0.25)",
        "dark": "rgba(0, 0, 0, 0.25)"
      },
      "colorStrokeChartLine": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorStrokeCodeEditorGutterActiveLineDefault": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral700}"
      },
      "colorStrokeCodeEditorGutterActiveLineHover": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral950}"
      },
      "colorTextAccent": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary300}"
      },
      "colorTextBodyDefault": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral300}"
      },
      "colorTextBodySecondary": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral300}"
      },
      "colorTextBreadcrumbCurrent": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral300}"
      },
      "colorTextBreadcrumbIcon": {
        "light": "{colorNeutral600}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorTextButtonInlineIconDefault": {
        "light": "{colorTextInteractiveDefault}",
        "dark": "{colorTextInteractiveDefault}"
      },
      "colorTextButtonInlineIconDisabled": {
        "light": "{colorTextInteractiveDisabled}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorTextButtonInlineIconHover": {
        "light": "{colorTextInteractiveHover}",
        "dark": "{colorTextInteractiveHover}"
      },
      "colorTextButtonInlineLinkHover": {
        "light": "{colorTextButtonNormalHover}",
        "dark": "{colorTextButtonNormalHover}"
      },
      "colorTextButtonIconHover": {
        "light": "{colorTextInteractiveHover}",
        "dark": "{colorTextInteractiveHover}"
      },
      "colorTextButtonNormalActive": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextToggleButtonNormalPressed": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextButtonNormalDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral300}"
      },
      "colorTextButtonNormalHover": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextLinkButtonNormalDefault": {
        "light": "{colorTextButtonNormalDefault}",
        "dark": "{colorTextButtonNormalDefault}"
      },
      "colorTextLinkButtonNormalHover": {
        "light": "{colorTextButtonNormalHover}",
        "dark": "{colorTextButtonNormalHover}"
      },
      "colorTextLinkButtonNormalActive": {
        "light": "{colorTextButtonNormalActive}",
        "dark": "{colorTextButtonNormalActive}"
      },
      "colorTextButtonLinkActive": {
        "light": "{colorTextButtonNormalActive}",
        "dark": "{colorTextButtonNormalActive}"
      },
      "colorTextButtonLinkDefault": {
        "light": "{colorTextButtonNormalDefault}",
        "dark": "{colorTextButtonNormalDefault}"
      },
      "colorTextButtonLinkDisabled": {
        "light": "{colorTextInteractiveDisabled}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorTextButtonLinkHover": {
        "light": "{colorTextButtonNormalHover}",
        "dark": "{colorTextButtonNormalHover}"
      },
      "colorTextButtonPrimaryActive": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextButtonPrimaryDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextButtonPrimaryHover": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextCalendarDateHover": {
        "light": "{colorTextDropdownItemHighlighted}",
        "dark": "{colorTextDropdownItemHighlighted}"
      },
      "colorTextCalendarDateSelected": {
        "light": "{colorBackgroundControlDefault}",
        "dark": "{colorBackgroundControlDefault}"
      },
      "colorTextCalendarMonth": {
        "light": "{colorTextBodySecondary}",
        "dark": "{colorTextBodySecondary}"
      },
      "colorTextCodeEditorGutterActiveLine": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextCodeEditorGutterDefault": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral300}"
      },
      "colorTextCodeEditorStatusBarDisabled": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral600}"
      },
      "colorTextCodeEditorTabButtonError": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextColumnHeader": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral450}"
      },
      "colorTextColumnSortingIcon": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorTextControlDisabled": {
        "light": "{colorTextInteractiveDisabled}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorTextCounter": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorTextDisabled": {
        "light": "{colorNeutral400}",
        "dark": "{colorNeutral600}"
      },
      "colorTextDisabledInlineEdit": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral450}"
      },
      "colorTextDropdownFooter": {
        "light": "{colorTextFormSecondary}",
        "dark": "{colorTextFormSecondary}"
      },
      "colorTextDropdownGroupLabel": {
        "light": "{colorTextGroupLabel}",
        "dark": "{colorTextGroupLabel}"
      },
      "colorTextDropdownItemDefault": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral300}"
      },
      "colorTextDropdownItemDimmed": {
        "light": "{colorTextInteractiveDisabled}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorTextDropdownItemDisabled": {
        "light": "{colorTextInteractiveDisabled}",
        "dark": "{colorTextInteractiveDisabled}"
      },
      "colorTextDropdownItemFilterMatch": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary300}"
      },
      "colorTextDropdownItemHighlighted": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral250}"
      },
      "colorTextDropdownItemSecondary": {
        "light": "{colorTextFormSecondary}",
        "dark": "{colorTextFormSecondary}"
      },
      "colorTextDropdownItemSecondaryHover": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral300}"
      },
      "colorTextEmpty": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral300}"
      },
      "colorTextExpandableSectionDefault": {
        "light": "{colorTextInteractiveDefault}",
        "dark": "{colorTextInteractiveDefault}"
      },
      "colorTextExpandableSectionHover": {
        "light": "{colorTextInteractiveHover}",
        "dark": "{colorTextInteractiveHover}"
      },
      "colorTextExpandableSectionNavigationIconDefault": {
        "light": "{colorTextIconCaret}",
        "dark": "{colorTextIconCaret}"
      },
      "colorBorderExpandableSectionDefault": {
        "light": "{colorBorderDividerDefault}",
        "dark": "{colorBorderDividerDefault}"
      },
      "colorTextFormDefault": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral300}"
      },
      "colorTextFormLabel": {
        "light": "{colorTextFormDefault}",
        "dark": "{colorTextFormDefault}"
      },
      "colorTextFormSecondary": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorTextGroupLabel": {
        "light": "{colorTextLabel}",
        "dark": "{colorTextLabel}"
      },
      "colorTextLabelGenAi": {
        "light": "{colorPurple700}",
        "dark": "{colorPurple400}"
      },
      "colorTextHeadingDefault": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral250}"
      },
      "colorTextHeadingSecondary": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral300}"
      },
      "colorTextHomeHeaderDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral250}"
      },
      "colorTextHomeHeaderSecondary": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral300}"
      },
      "colorTextIconCaret": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral450}"
      },
      "colorTextIconSubtle": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral400}"
      },
      "colorTextInputDisabled": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral600}"
      },
      "colorTextInputPlaceholder": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral500}"
      },
      "colorTextInputPlaceholderDisabled": {
        "light": "{colorTextInputPlaceholder}",
        "dark": "{colorTextInputPlaceholder}"
      },
      "colorTextInteractiveActive": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextInteractiveDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral300}"
      },
      "colorTextInteractiveDisabled": {
        "light": "{colorNeutral400}",
        "dark": "{colorNeutral600}"
      },
      "colorTextInteractiveHover": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextToggleButtonIconPressed": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextInteractiveInvertedDefault": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral300}"
      },
      "colorTextInteractiveInvertedHover": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral100}"
      },
      "colorTextInverted": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextLabel": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral450}"
      },
      "colorTextKeyValuePairsValue": {
        "light": "{colorTextBodyDefault}",
        "dark": "{colorTextBodyDefault}"
      },
      "colorTextLayoutToggle": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral300}"
      },
      "colorTextLayoutToggleActive": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorTextLayoutToggleHover": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorTextLayoutToggleSelected": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral950}"
      },
      "colorTextLinkDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary300}"
      },
      "colorTextLinkHover": {
        "light": "{colorPrimary700}",
        "dark": "{colorPrimary200}"
      },
      "colorTextLinkDecorationDefault": {
        "light": "currentColor",
        "dark": "currentColor"
      },
      "colorTextLinkDecorationHover": {
        "light": "currentColor",
        "dark": "currentColor"
      },
      "colorTextLinkSecondaryDefault": {
        "light": "{colorTextLinkDefault}",
        "dark": "{colorTextLinkDefault}"
      },
      "colorTextLinkSecondaryHover": {
        "light": "{colorTextLinkHover}",
        "dark": "{colorTextLinkHover}"
      },
      "colorTextLinkSecondaryDecorationDefault": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorTextLinkInfoDefault": {
        "light": "{colorTextLinkDefault}",
        "dark": "{colorTextLinkDefault}"
      },
      "colorTextLinkInfoHover": {
        "light": "{colorTextLinkHover}",
        "dark": "{colorTextLinkHover}"
      },
      "colorTextLinkInvertedDefault": {
        "light": "{colorTextNotificationDefault}",
        "dark": "{colorTextNotificationDefault}"
      },
      "colorTextLinkInvertedHover": {
        "light": "{colorTextNotificationDefault}",
        "dark": "{colorTextNotificationDefault}"
      },
      "colorTextLinkButtonUnderline": {
        "light": "currentColor",
        "dark": "currentColor"
      },
      "colorTextLinkButtonUnderlineHover": {
        "light": "currentColor",
        "dark": "currentColor"
      },
      "colorTextNotificationDefault": {
        "light": "{colorNeutral100}",
        "dark": "{colorNeutral100}"
      },
      "colorTextAlertDefault": {
        "light": "{colorTextBodyDefault}",
        "dark": "{colorTextBodyDefault}"
      },
      "colorTextNotificationLinkDefault": {
        "light": "{colorTextLinkDefault}",
        "dark": "{colorTextLinkDefault}"
      },
      "colorTextNotificationLinkHover": {
        "light": "{colorTextLinkHover}",
        "dark": "{colorTextLinkHover}"
      },
      "colorTextNotificationStackBar": {
        "light": "{colorWhite}",
        "dark": "{colorWhite}"
      },
      "colorTextNotificationYellow": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral950}"
      },
      "colorTextPaginationPageNumberActiveDisabled": {
        "light": "{colorTextBodySecondary}",
        "dark": "{colorTextBodySecondary}"
      },
      "colorTextPaginationPageNumberDefault": {
        "light": "{colorTextInteractiveDefault}",
        "dark": "{colorTextInteractiveDefault}"
      },
      "colorTextSegmentActive": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorTextSegmentDefault": {
        "light": "{colorTextButtonNormalDefault}",
        "dark": "{colorTextButtonNormalDefault}"
      },
      "colorTextSegmentHover": {
        "light": "{colorTextButtonNormalHover}",
        "dark": "{colorTextButtonNormalHover}"
      },
      "colorTextSmall": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorTextFlashbarIconError": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorTextFlashbarIconInfo": {
        "light": "{colorTextStatusInfo}",
        "dark": "{colorTextStatusInfo}"
      },
      "colorTextFlashbarIconSuccess": {
        "light": "{colorTextStatusSuccess}",
        "dark": "{colorTextStatusSuccess}"
      },
      "colorTextFlashbarIconWarning": {
        "light": "{colorTextStatusWarning}",
        "dark": "{colorTextStatusWarning}"
      },
      "colorTextAlertIconError": {
        "light": "{colorTextStatusError}",
        "dark": "{colorTextStatusError}"
      },
      "colorTextAlertIconInfo": {
        "light": "{colorTextStatusInfo}",
        "dark": "{colorTextStatusInfo}"
      },
      "colorTextAlertIconSuccess": {
        "light": "{colorTextStatusSuccess}",
        "dark": "{colorTextStatusSuccess}"
      },
      "colorTextAlertIconWarning": {
        "light": "{colorTextStatusWarning}",
        "dark": "{colorTextStatusWarning}"
      },
      "colorTextStatusError": {
        "light": "{colorError600}",
        "dark": "{colorError400}"
      },
      "colorTextStatusInactive": {
        "light": "{colorNeutral600}",
        "dark": "{colorNeutral450}"
      },
      "colorTextStatusInfo": {
        "light": "{colorInfo600}",
        "dark": "{colorPrimary300}"
      },
      "colorTextStatusSuccess": {
        "light": "{colorSuccess600}",
        "dark": "{colorSuccess500}"
      },
      "colorTextStatusWarning": {
        "light": "{colorWarning900}",
        "dark": "{colorWarning500}"
      },
      "colorTextTopNavigationTitle": {
        "light": "{colorNeutral950}",
        "dark": "{colorNeutral100}"
      },
      "colorTextTutorialHotspotDefault": {
        "light": "{colorTextLinkDefault}",
        "dark": "{colorTextLinkDefault}"
      },
      "colorTextTutorialHotspotHover": {
        "light": "{colorTextLinkHover}",
        "dark": "{colorTextLinkHover}"
      },
      "colorBoardPlaceholderActive": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral600}"
      },
      "colorBoardPlaceholderHover": {
        "light": "{colorPrimary200}",
        "dark": "{colorPrimary600}"
      },
      "colorDragPlaceholderActive": {
        "light": "{colorNeutral300}",
        "dark": "{colorNeutral600}"
      },
      "colorDragPlaceholderHover": {
        "light": "{colorPrimary200}",
        "dark": "{colorPrimary600}"
      },
      "colorDropzoneBackgroundDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorDropzoneBackgroundHover": {
        "light": "{colorPrimary50}",
        "dark": "{colorPrimary1000}"
      },
      "colorDropzoneTextDefault": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral350}"
      },
      "colorDropzoneTextHover": {
        "light": "{colorNeutral650}",
        "dark": "{colorNeutral350}"
      },
      "colorDropzoneBorderDefault": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral600}"
      },
      "colorDropzoneBorderHover": {
        "light": "{colorPrimary900}",
        "dark": "{colorPrimary300}"
      },
      "colorGapGlobalDrawer": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral950}"
      },
      "colorTreeViewConnectorLine": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral300}"
      },
      "colorBackgroundActionCardDefault": {
        "light": "{colorWhite}",
        "dark": "{colorNeutral850}"
      },
      "colorBackgroundActionCardHover": {
        "light": "{colorPrimary50}",
        "dark": "{colorNeutral800}"
      },
      "colorBackgroundActionCardActive": {
        "light": "{colorPrimary100}",
        "dark": "{colorNeutral700}"
      },
      "colorBorderActionCardDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorBorderActionCardHover": {
        "light": "{colorPrimary900}",
        "dark": "{colorPrimary300}"
      },
      "colorBorderActionCardActive": {
        "light": "{colorPrimary900}",
        "dark": "{colorPrimary300}"
      },
      "colorBorderActionCardDisabled": {
        "light": "{colorNeutral400}",
        "dark": "{colorNeutral600}"
      },
      "colorBackgroundActionCardDisabled": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral800}"
      },
      "colorTextActionCardDisabled": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral500}"
      },
      "colorTextActionCardIconDefault": {
        "light": "{colorPrimary600}",
        "dark": "{colorPrimary400}"
      },
      "colorTextActionCardIconHover": {
        "light": "{colorPrimary900}",
        "dark": "{colorPrimary300}"
      },
      "colorTextActionCardIconActive": {
        "light": "{colorPrimary900}",
        "dark": "{colorPrimary300}"
      },
      "colorTextActionCardIconDisabled": {
        "light": "{colorNeutral400}",
        "dark": "{colorNeutral600}"
      },
      "colorBackgroundSkeleton": {
        "light": "{colorNeutral500}",
        "dark": "{colorNeutral600}"
      },
      "colorBackgroundSkeletonWave": {
        "light": "{colorNeutral150}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundBadgeGreen": {
        "light": "{colorBackgroundNotificationGreen}",
        "dark": "{colorBackgroundNotificationGreen}"
      },
      "colorBackgroundBadgeBlue": {
        "light": "{colorBackgroundNotificationBlue}",
        "dark": "{colorBackgroundNotificationBlue}"
      },
      "colorBackgroundBadgeRed": {
        "light": "{colorBackgroundNotificationRed}",
        "dark": "{colorBackgroundNotificationRed}"
      },
      "colorBackgroundBadgeYellow": {
        "light": "{colorBackgroundNotificationYellow}",
        "dark": "{colorBackgroundNotificationYellow}"
      },
      "colorBackgroundBadgeGrey": {
        "light": "{colorBackgroundNotificationGrey}",
        "dark": "{colorBackgroundNotificationGrey}"
      },
      "colorBorderBadge": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeGrey": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeGreen": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeBlue": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorBorderBadgeRed": {
        "light": "transparent",
        "dark": "transparent"
      },
      "colorTextBadgeGrey": {
        "light": "{colorTextNotificationDefault}",
        "dark": "{colorTextNotificationDefault}"
      },
      "colorTextBadgeGreen": {
        "light": "{colorTextNotificationDefault}",
        "dark": "{colorTextNotificationDefault}"
      },
      "colorTextBadgeBlue": {
        "light": "{colorTextNotificationDefault}",
        "dark": "{colorTextNotificationDefault}"
      },
      "colorTextBadgeRed": {
        "light": "{colorTextNotificationDefault}",
        "dark": "{colorTextNotificationDefault}"
      },
      "colorBackgroundCodeView": {
        "light": "#f8f8f8",
        "dark": "#282c34"
      },
      "colorBackgroundVisualAccentRed": {
        "light": "#ffe0e0",
        "dark": "rgba(255, 61, 61, 0.2)"
      },
      "colorBackgroundVisualAccentYellow": {
        "light": "#fffbbd",
        "dark": "rgba(251, 211, 50, 0.2)"
      },
      "colorBackgroundVisualAccentIndigo": {
        "light": "#dbe4ff",
        "dark": "rgba(92, 127, 255, 0.2)"
      },
      "colorBackgroundVisualAccentGreen": {
        "light": "#d9ffd6",
        "dark": "rgba(43, 181, 52, 0.2)"
      },
      "colorBackgroundVisualAccentOrange": {
        "light": "rgba(255, 224, 214, 0.6)",
        "dark": "rgba(255, 75, 20, 0.2)"
      },
      "colorBackgroundVisualAccentPurple": {
        "light": "rgba(242, 229, 255, 0.6)",
        "dark": "rgba(173, 92, 255, 0.2)"
      },
      "colorBackgroundVisualAccentLime": {
        "light": "{colorLime100}",
        "dark": "rgba(49, 184, 0, 0.2)"
      },
      "colorBackgroundVisualAccentGrey": {
        "light": "{colorNeutral250}",
        "dark": "{colorNeutral700}"
      },
      "colorBackgroundVisualAccentTeal": {
        "light": "rgba(204, 255, 252, 0.7)",
        "dark": "rgba(0, 173, 162, 0.2)"
      },
      "colorBackgroundVisualAccentBlue": {
        "light": "rgba(209, 241, 255, 0.6)",
        "dark": "rgba(0, 153, 255, 0.2)"
      },
      "colorBackgroundVisualAccentViolet": {
        "light": "rgba(232, 229, 255, 0.6)",
        "dark": "rgba(133, 117, 255, 0.2)"
      },
      "colorBackgroundVisualAccentMagenta": {
        "light": "rgba(255, 224, 251, 0.6)",
        "dark": "rgba(255, 26, 224, 0.2)"
      },
      "colorBackgroundVisualAccentPink": {
        "light": "rgba(255, 224, 240, 0.7)",
        "dark": "rgba(255, 51, 153, 0.2)"
      },
      "colorBackgroundVisualAccentAmber": {
        "light": "rgba(255, 232, 189, 0.7)",
        "dark": "rgba(250, 111, 0, 0.2)"
      },
      "colorTextVisualAccentRed": {
        "light": "{colorError700}",
        "dark": "{colorError400}"
      },
      "colorTextVisualAccentYellow": {
        "light": "{colorWarning900}",
        "dark": "{colorWarning200}"
      },
      "colorTextVisualAccentIndigo": {
        "light": "{colorInfo800}",
        "dark": "{colorInfo300}"
      },
      "colorTextVisualAccentGreen": {
        "light": "{colorSuccess600}",
        "dark": "{colorSuccess200}"
      },
      "colorTextVisualAccentOrange": {
        "light": "#a82700",
        "dark": "#ff997a"
      },
      "colorTextVisualAccentPurple": {
        "light": "#962eff",
        "dark": "#d4a8ff"
      },
      "colorTextVisualAccentLime": {
        "light": "#007000",
        "dark": "#acff2e"
      },
      "colorTextVisualAccentGrey": {
        "light": "{colorNeutral850}",
        "dark": "{colorNeutral300}"
      },
      "colorTextVisualAccentTeal": {
        "light": "#008077",
        "dark": "#00f5e4"
      },
      "colorTextVisualAccentBlue": {
        "light": "#006ce0",
        "dark": "#75cfff"
      },
      "colorTextVisualAccentViolet": {
        "light": "#6842ff",
        "dark": "#b2a8ff"
      },
      "colorTextVisualAccentMagenta": {
        "light": "#b2008f",
        "dark": "#ff57e9"
      },
      "colorTextVisualAccentPink": {
        "light": "#bb005d",
        "dark": "#ff99cc"
      },
      "colorTextVisualAccentAmber": {
        "light": "#9e3700",
        "dark": "#ffbb45"
      },
      "fontBoxValueLargeWeight": "300",
      "fontButtonLetterSpacing": "0.25px",
      "fontChartDetailSize": "{fontSizeBodyM}",
      "fontDecorationStyleLink": "solid",
      "fontDecorationLineLinkSecondary": "none",
      "fontDecorationThicknessLink": "1px",
      "fontDecorationThicknessLinkDisplayL": "2px",
      "fontDisplayLabelWeight": "400",
      "fontSizeExpandableHeading": "{fontSizeBodyM}",
      "fontFamilyBase": "'Noto Sans', 'Helvetica Neue', Roboto, Arial, sans-serif",
      "fontFamilyDisplay": "{fontFamilyBase}",
      "fontFamilyHeading": "{fontFamilyBase}",
      "fontFamilyMonospace": "Monaco, Menlo, Consolas, 'Courier Prime', Courier, 'Courier New', monospace",
      "fontHeaderH2DescriptionLineHeight": "{lineHeightBodyS}",
      "fontHeaderH2DescriptionSize": "{fontSizeBodyS}",
      "fontLinkButtonLetterSpacing": "normal",
      "fontLinkButtonWeight": "400",
      "fontPanelHeaderLineHeight": "{lineHeightHeadingL}",
      "fontPanelHeaderSize": "{fontSizeHeadingL}",
      "fontSideNavigationSectionHeaderSize": "inherit",
      "fontSideNavigationSectionHeaderWeight": "inherit",
      "fontSizeBodyM": "14px",
      "fontSizeBodyS": "12px",
      "fontSizeDisplayL": "44px",
      "fontSizeDisplayXl": "64px",
      "fontSizeFormLabel": "{fontSizeBodyM}",
      "fontSizeHeadingL": "18px",
      "fontSizeHeadingM": "18px",
      "fontSizeHeadingS": "16px",
      "fontSizeHeadingXl": "28px",
      "fontSizeHeadingXs": "16px",
      "fontSizeKeyValuePairsLabel": "{fontSizeBodyM}",
      "fontSizeTabs": "{fontSizeBodyM}",
      "fontSmoothingMozOsx": "auto",
      "fontSmoothingWebkit": "auto",
      "fontWayfindingLinkActiveWeight": "700",
      "fontWeightAlertHeader": "700",
      "fontWeightBold": "700",
      "fontWeightBreadcrumbCurrent": "{fontWeightBold}",
      "fontWeightButton": "700",
      "fontWeightDisplayL": "700",
      "fontWeightDisplayXl": "400",
      "fontWeightFlashbarHeader": "700",
      "fontWeightFormLabel": "{fontDisplayLabelWeight}",
      "fontWeightHeadingL": "{fontWeightHeavy}",
      "fontWeightHeadingM": "400",
      "fontWeightHeadingS": "{fontWeightHeavy}",
      "fontWeightHeadingXl": "400",
      "fontWeightHeadingXs": "400",
      "fontWeightHeavy": "700",
      "fontWeightKeyValuePairsLabel": "{fontDisplayLabelWeight}",
      "fontWeightLighter": "300",
      "fontWeightLinkSecondary": "inherit",
      "fontWeightNormal": "400",
      "fontWeightTabs": "700",
      "fontWeightTabsDisabled": "400",
      "letterSpacingBodyS": "normal",
      "letterSpacingDisplayL": "normal",
      "letterSpacingDisplayXl": "normal",
      "letterSpacingHeadingL": "normal",
      "letterSpacingHeadingM": "normal",
      "letterSpacingHeadingS": "normal",
      "letterSpacingHeadingXl": "normal",
      "letterSpacingHeadingXs": "normal",
      "lineHeightBodyM": "22px",
      "lineHeightBodyS": "16px",
      "lineHeightDisplayL": "56px",
      "lineHeightDisplayXl": "72px",
      "lineHeightFormLabel": "{lineHeightBodyM}",
      "lineHeightHeadingL": "22px",
      "lineHeightHeadingM": "22px",
      "lineHeightHeadingS": "20px",
      "lineHeightHeadingXl": "36px",
      "lineHeightHeadingXs": "20px",
      "lineHeightKeyValuePairsLabel": "{lineHeightBodyM}",
      "lineHeightTabs": "{lineHeightBodyM}",
      "borderActiveWidth": "2px",
      "borderCodeEditorStatusDividerWidth": "0px",
      "borderContainerStickyWidth": "1px",
      "borderContainerTopWidth": "1px",
      "borderControlFocusRingShadowSpread": "1px",
      "borderControlInvalidFocusRingShadowSpread": "{borderControlFocusRingShadowSpread}",
      "borderDividerListWidth": "1px",
      "borderDividerSectionWidth": "1px",
      "borderDropdownVirtualOffsetWidth": "0px",
      "borderInvalidWidth": "4px",
      "borderItemWidth": "1px",
      "borderLineChartDashArray": "3 5",
      "borderLineChartLineJoin": "miter",
      "borderLineChartWidth": "2px",
      "borderLinkFocusRingOutline": "5px auto Highlight",
      "borderLinkFocusRingShadowSpread": "0px",
      "borderPanelHeaderWidth": "0px",
      "borderPanelTopWidth": "0px",
      "borderRadiusActionCardDefault": "{borderRadiusCardDefault}",
      "borderRadiusActionCardEmbedded": "{borderRadiusCardEmbedded}",
      "borderRadiusAlert": "{borderRadiusInput}",
      "borderRadiusBadge": "16px",
      "borderRadiusButton": "2px",
      "borderRadiusCalendarDayFocusRing": "2px",
      "borderRadiusCardDefault": "{borderRadiusContainer}",
      "borderRadiusCardEmbedded": "{borderRadiusChatBubble}",
      "borderRadiusChatBubble": "2px",
      "borderRadiusSupportPrompt": "8px",
      "borderRadiusCodeEditor": "{borderRadiusItem}",
      "borderRadiusContainer": "0px",
      "borderRadiusControlCircularFocusRing": "50%",
      "borderRadiusControlDefaultFocusRing": "{borderRadiusInput}",
      "borderRadiusDropdown": "{borderRadiusItem}",
      "borderRadiusDropzone": "0px",
      "borderRadiusFlashbar": "0px",
      "borderRadiusInput": "2px",
      "borderRadiusItem": "0px",
      "borderRadiusSideNavigationItem": "{borderRadiusItem}",
      "borderRadiusSideNavigationItemCollapsed": "50%",
      "borderRadiusItemCardDefault": "{borderRadiusCardDefault}",
      "borderRadiusItemCardEmbedded": "{borderRadiusCardEmbedded}",
      "borderRadiusDialog": "{borderRadiusCardEmbedded}",
      "borderRadiusPopover": "{borderRadiusInput}",
      "borderRadiusSkeleton": "8px",
      "borderRadiusStatusIndicator": "{borderRadiusBadge}",
      "borderRadiusTabsFocusRing": "0px",
      "borderRadiusTiles": "{borderRadiusInput}",
      "borderRadiusToken": "{borderRadiusInput}",
      "borderRadiusTokenInline": "{borderRadiusToken}",
      "borderRadiusTutorialPanelItem": "{borderRadiusInput}",
      "borderTableStickyWidth": "0px",
      "borderWidthActionCardActive": "1px",
      "borderWidthActionCardDefault": "1px",
      "borderWidthActionCardDisabled": "1px",
      "borderWidthActionCardHover": "1px",
      "borderWidthAlert": "1px",
      "borderWidthAlertBlockEnd": "{borderWidthAlert}",
      "borderWidthAlertBlockStart": "{borderWidthAlert}",
      "borderWidthAlertInlineEnd": "{borderWidthAlert}",
      "borderWidthAlertInlineStart": "{borderWidthAlert}",
      "borderWidthFlashbarInlineStart": "0px",
      "borderWidthButton": "1px",
      "borderWidthCard": "0px",
      "borderWidthCardSelected": "{borderItemWidth}",
      "borderWidthDropdown": "1px",
      "borderWidthField": "1px",
      "borderWidthIconBig": "3px",
      "borderWidthIconLarge": "4px",
      "borderWidthIconMedium": "2px",
      "borderWidthIconNormal": "2px",
      "borderWidthIconSmall": "2px",
      "borderWidthIconXSmall": "1.5px",
      "borderWidthItemCard": "{borderWidthCard}",
      "borderWidthItemCardHighlighted": "{borderWidthCardSelected}",
      "borderWidthDialog": "{borderWidthCard}",
      "borderWidthItemSelected": "{borderItemWidth}",
      "borderWidthLayoutSideNavigation": "{borderDividerSectionWidth}",
      "borderWidthNotificationStackBar": "1px",
      "borderWidthBadge": "0px",
      "borderWidthPopover": "1px",
      "borderWidthToken": "1px",
      "motionDurationExtraFast": {
        "default": "45ms",
        "disabled": "0ms"
      },
      "motionDurationExtraSlow": {
        "default": "270ms",
        "disabled": "0ms"
      },
      "motionDurationFast": {
        "default": "90ms",
        "disabled": "0ms"
      },
      "motionDurationModerate": {
        "default": "135ms",
        "disabled": "0ms"
      },
      "motionDurationRefreshOnlyAmbient": "0ms",
      "motionDurationRefreshOnlyFast": "0ms",
      "motionDurationRefreshOnlyMedium": "0ms",
      "motionDurationRefreshOnlySlow": "0ms",
      "motionDurationAvatarGenAiGradient": {
        "default": "3600ms",
        "disabled": "0ms"
      },
      "motionDurationAvatarLoadingDots": {
        "default": "1200ms",
        "disabled": "0ms"
      },
      "motionDurationRotate180": {
        "default": "{motionDurationModerate}",
        "disabled": "{motionDurationModerate}"
      },
      "motionDurationRotate90": {
        "default": "{motionDurationModerate}",
        "disabled": "{motionDurationModerate}"
      },
      "motionDurationShowPaced": {
        "default": "{motionDurationSlow}",
        "disabled": "{motionDurationSlow}"
      },
      "motionDurationShowQuick": {
        "default": "{motionDurationModerate}",
        "disabled": "{motionDurationModerate}"
      },
      "motionDurationSlow": {
        "default": "180ms",
        "disabled": "0ms"
      },
      "motionDurationTransitionQuick": {
        "default": "{motionDurationFast}",
        "disabled": "{motionDurationFast}"
      },
      "motionDurationTransitionShowPaced": {
        "default": "{motionDurationSlow}",
        "disabled": "{motionDurationSlow}"
      },
      "motionDurationTransitionShowQuick": {
        "default": "{motionDurationFast}",
        "disabled": "{motionDurationFast}"
      },
      "motionEasingEaseOutQuart": {
        "default": "cubic-bezier(0.165, 0.84, 0.44, 1)",
        "disabled": "cubic-bezier(0.165, 0.84, 0.44, 1)"
      },
      "motionEasingRefreshOnlyA": {
        "default": "cubic-bezier(0, 0, 0, 1)",
        "disabled": "cubic-bezier(0, 0, 0, 1)"
      },
      "motionEasingRefreshOnlyB": {
        "default": "cubic-bezier(1, 0, 0.83, 1)",
        "disabled": "cubic-bezier(1, 0, 0.83, 1)"
      },
      "motionEasingRefreshOnlyC": {
        "default": "cubic-bezier(0.84, 0, 0.16, 1)",
        "disabled": "cubic-bezier(0.84, 0, 0.16, 1)"
      },
      "motionEasingRefreshOnlyD": {
        "default": "cubic-bezier(0.33, 0, 0.67, 1)",
        "disabled": "cubic-bezier(0.33, 0, 0.67, 1)"
      },
      "motionEasingAvatarGenAiGradient": {
        "default": "cubic-bezier(0.7, 0, 0.3, 1)",
        "disabled": "cubic-bezier(0.7, 0, 0.3, 1)"
      },
      "motionEasingRotate180": {
        "default": "{motionEasingEaseOutQuart}",
        "disabled": "{motionEasingEaseOutQuart}"
      },
      "motionEasingRotate90": {
        "default": "{motionEasingEaseOutQuart}",
        "disabled": "{motionEasingEaseOutQuart}"
      },
      "motionEasingShowPaced": {
        "default": "ease-out",
        "disabled": "ease-out"
      },
      "motionEasingShowQuick": {
        "default": "ease-out",
        "disabled": "ease-out"
      },
      "motionEasingTransitionQuick": {
        "default": "linear",
        "disabled": "linear"
      },
      "motionEasingTransitionShowPaced": {
        "default": "ease-out",
        "disabled": "ease-out"
      },
      "motionEasingTransitionShowQuick": {
        "default": "linear",
        "disabled": "linear"
      },
      "motionEasingResponsive": "ease-out",
      "motionEasingSticky": "ease-out",
      "motionEasingExpressive": "ease-out",
      "motionDurationResponsive": "{motionDurationModerate}",
      "motionDurationExpressive": "{motionDurationSlow}",
      "motionDurationComplex": "{motionDurationExtraSlow}",
      "motionDurationTooltipEnter": {
        "default": "{motionDurationRefreshOnlyFast}",
        "disabled": "{motionDurationRefreshOnlyFast}"
      },
      "motionEasingTooltipEnter": {
        "default": "{motionEasingRefreshOnlyA}",
        "disabled": "{motionEasingRefreshOnlyA}"
      },
      "motionDurationExpandableContentEnter": {
        "default": "{motionDurationShowPaced}",
        "disabled": "{motionDurationShowPaced}"
      },
      "motionEasingExpandableContentEnter": {
        "default": "{motionEasingShowPaced}",
        "disabled": "{motionEasingShowPaced}"
      },
      "motionDurationSideNavigationContentEnterFade": {
        "default": "0ms",
        "disabled": "0ms"
      },
      "motionDurationSideNavigationContentExit": {
        "default": "0ms",
        "disabled": "0ms"
      },
      "motionDurationSideNavigationContentExitFade": {
        "default": "0ms",
        "disabled": "0ms"
      },
      "motionEasingSideNavigationContentExit": {
        "default": "{motionEasingShowQuick}",
        "disabled": "{motionEasingShowQuick}"
      },
      "motionKeyframesFadeIn": {
        "default": "awsui-fade-in-jiml2r",
        "disabled": "awsui-fade-in-jiml2r"
      },
      "motionKeyframesFadeOut": {
        "default": "awsui-fade-out-au27m5",
        "disabled": "awsui-fade-out-au27m5"
      },
      "motionKeyframesStatusIconError": "awsui-none-kjh8f3",
      "motionKeyframesScalePopup": "awsui-none-kjh8f3",
      "sizeCalendarGridWidth": {
        "comfortable": "234px",
        "compact": "234px"
      },
      "sizeControl": {
        "comfortable": "14px",
        "compact": "14px"
      },
      "sizeIconBig": {
        "comfortable": "32px",
        "compact": "32px"
      },
      "sizeIconLarge": {
        "comfortable": "48px",
        "compact": "48px"
      },
      "sizeIconMedium": {
        "comfortable": "16px",
        "compact": "16px"
      },
      "sizeIconNormal": {
        "comfortable": "16px",
        "compact": "16px"
      },
      "sizeTableSelectionHorizontal": {
        "comfortable": "54px",
        "compact": "54px"
      },
      "sizeVerticalInput": {
        "comfortable": "32px",
        "compact": "28px"
      },
      "sizeVerticalPanelIconOffset": {
        "comfortable": "15px",
        "compact": "13px"
      },
      "sizeSideNavigationItemHeight": {
        "comfortable": "28px",
        "compact": "24px"
      },
      "sizeSideNavigationItemCollapsed": {
        "comfortable": "30px",
        "compact": "28px"
      },
      "sizeSideNavigationCollapsedWidth": {
        "comfortable": "52px",
        "compact": "52px"
      },
      "spaceAlertActionLeft": {
        "comfortable": "{spaceL}",
        "compact": "{spaceL}"
      },
      "spaceAlertHorizontal": {
        "comfortable": "{spaceL}",
        "compact": "{spaceL}"
      },
      "spaceAlertMessageRight": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceAlertVertical": {
        "comfortable": "{spaceScaledS}",
        "compact": "{spaceScaledS}"
      },
      "spaceButtonFocusOutlineGutter": {
        "comfortable": "3px",
        "compact": "3px"
      },
      "spaceButtonHorizontal": {
        "comfortable": "{spaceL}",
        "compact": "{spaceL}"
      },
      "spaceButtonVertical": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceTokenVertical": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceFieldVertical": {
        "comfortable": "4px",
        "compact": "2px"
      },
      "spaceButtonIconFocusOutlineGutterVertical": {
        "comfortable": "{spaceButtonFocusOutlineGutter}",
        "compact": "{spaceButtonFocusOutlineGutter}"
      },
      "spaceButtonIconOnlyHorizontal": {
        "comfortable": "{spaceM}",
        "compact": "{spaceM}"
      },
      "spaceButtonInlineIconFocusOutlineGutter": {
        "comfortable": "{spaceButtonFocusOutlineGutter}",
        "compact": "{spaceButtonFocusOutlineGutter}"
      },
      "spaceButtonModalDismissVertical": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceCalendarGridFocusOutlineGutter": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceCalendarGridSelectedFocusOutlineGutter": {
        "comfortable": "2px",
        "compact": "2px"
      },
      "spaceCalendarGridGutter": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceCardHorizontalDefault": {
        "comfortable": "{spaceContainerHorizontal}",
        "compact": "{spaceContainerHorizontal}"
      },
      "spaceCardHorizontalEmbedded": {
        "comfortable": "{spaceS}",
        "compact": "10px"
      },
      "spaceCardVerticalDefault": {
        "comfortable": "{spaceScaledL}",
        "compact": "{spaceScaledL}"
      },
      "spaceCardVerticalEmbedded": {
        "comfortable": "10px",
        "compact": "{spaceXs}"
      },
      "spaceItemCardHorizontalDefault": {
        "comfortable": "{spaceCardHorizontalDefault}",
        "compact": "{spaceCardHorizontalDefault}"
      },
      "spaceItemCardHorizontalEmbedded": {
        "comfortable": "{spaceCardHorizontalEmbedded}",
        "compact": "{spaceCardHorizontalEmbedded}"
      },
      "spaceItemCardVerticalDefault": {
        "comfortable": "{spaceCardVerticalDefault}",
        "compact": "{spaceCardVerticalDefault}"
      },
      "spaceItemCardVerticalEmbedded": {
        "comfortable": "{spaceCardVerticalEmbedded}",
        "compact": "{spaceCardVerticalEmbedded}"
      },
      "spaceDialogHorizontal": {
        "comfortable": "{spaceCardHorizontalEmbedded}",
        "compact": "{spaceCardHorizontalEmbedded}"
      },
      "spaceDialogVertical": {
        "comfortable": "{spaceCardVerticalEmbedded}",
        "compact": "{spaceCardVerticalEmbedded}"
      },
      "spaceDialogActionBlock": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceDialogActionInline": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxs}"
      },
      "spaceDialogHeaderGap": {
        "comfortable": "{spaceXs}",
        "compact": "{spaceXs}"
      },
      "spaceDialogSectionGap": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxs}"
      },
      "spaceCodeEditorStatusFocusOutlineGutter": {
        "comfortable": "3px",
        "compact": "3px"
      },
      "spaceContainerContentTop": {
        "comfortable": "{spaceScaledM}",
        "compact": "{spaceScaledM}"
      },
      "spaceContainerHeaderTop": {
        "comfortable": "{spaceScaledS}",
        "compact": "{spaceScaledS}"
      },
      "spaceContainerHeaderBottom": {
        "comfortable": "{spaceScaledS}",
        "compact": "{spaceScaledS}"
      },
      "spaceContainerHorizontal": {
        "comfortable": "{spaceL}",
        "compact": "{spaceL}"
      },
      "spaceContentHeaderPaddingBottom": {
        "comfortable": "{spaceScaledM}",
        "compact": "{spaceScaledM}"
      },
      "spaceDarkHeaderOverlapDistance": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceExpandableSectionIconOffsetTop": {
        "comfortable": "{spaceScaledXs}",
        "compact": "{spaceScaledXs}"
      },
      "spaceFieldHorizontal": {
        "comfortable": "{spaceXs}",
        "compact": "{spaceXs}"
      },
      "spaceFieldIconOffset": {
        "comfortable": "32px",
        "compact": "32px"
      },
      "spaceFilteringTokenDismissButtonFocusOutlineGutter": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceFilteringTokenOperationSelectFocusOutlineGutter": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceFlashbarActionLeft": {
        "comfortable": "{spaceM}",
        "compact": "{spaceM}"
      },
      "spaceFlashbarDismissRight": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxs}"
      },
      "spaceFlashbarHorizontal": {
        "comfortable": "{spaceS}",
        "compact": "{spaceS}"
      },
      "spaceFlashbarVertical": {
        "comfortable": "{spaceScaledXs}",
        "compact": "{spaceScaledXs}"
      },
      "spaceGridGutter": {
        "comfortable": "{spaceL}",
        "compact": "{spaceM}"
      },
      "spaceKeyValueGap": {
        "comfortable": "{spaceScaledXxxs}",
        "compact": "{spaceScaledXxxs}"
      },
      "spaceLayoutContentBottom": {
        "comfortable": "{spaceScaledL}",
        "compact": "{spaceScaledL}"
      },
      "spaceLayoutContentHorizontal": {
        "comfortable": "{spaceScaled2xXxxl}",
        "compact": "{spaceScaled2xXxxl}"
      },
      "spaceLayoutToggleDiameter": {
        "comfortable": "36px",
        "compact": "36px"
      },
      "spaceLayoutTogglePadding": {
        "comfortable": "{spaceStaticS}",
        "compact": "{spaceStaticS}"
      },
      "spaceModalContentBottom": {
        "comfortable": "{spaceScaledL}",
        "compact": "{spaceScaledL}"
      },
      "spaceModalHorizontal": {
        "comfortable": "{spaceContainerHorizontal}",
        "compact": "{spaceContainerHorizontal}"
      },
      "spacePanelContentBottom": {
        "comfortable": "{spaceScaledXxxl}",
        "compact": "{spaceScaledXxxl}"
      },
      "spacePanelContentTop": {
        "comfortable": "{spaceScaledL}",
        "compact": "{spaceScaledL}"
      },
      "spacePanelDividerMarginHorizontal": {
        "comfortable": "{spaceS}",
        "compact": "{spaceS}"
      },
      "spacePanelHeaderVertical": {
        "comfortable": "{spaceScaledL}",
        "compact": "{spaceScaledL}"
      },
      "spacePanelNavLeft": {
        "comfortable": "{spaceXxl}",
        "compact": "{spaceXxl}"
      },
      "spacePanelSideLeft": {
        "comfortable": "{spaceScaledXxl}",
        "compact": "{spaceScaledXxl}"
      },
      "spacePanelSideRight": {
        "comfortable": "{spaceScaledXxl}",
        "compact": "{spaceScaledXxl}"
      },
      "spacePanelSplitTop": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spacePanelSplitBottom": {
        "comfortable": "{spaceScaledL}",
        "compact": "{spaceScaledL}"
      },
      "spaceSegmentedControlFocusOutlineGutter": {
        "comfortable": "3px",
        "compact": "3px"
      },
      "spaceTabsContentTop": {
        "comfortable": "{spaceScaledM}",
        "compact": "{spaceScaledM}"
      },
      "spaceTabsFocusOutlineGutter": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceTabsVertical": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceTableContentBottom": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceTableEmbeddedHeaderTop": {
        "comfortable": "{spaceContainerHeaderTop}",
        "compact": "{spaceContainerHeaderTop}"
      },
      "spaceTableFooterHorizontal": {
        "comfortable": "{spaceTableHeaderHorizontal}",
        "compact": "{spaceTableHeaderHorizontal}"
      },
      "spaceTableHeaderFocusOutlineGutter": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceTableHeaderHorizontal": {
        "comfortable": "{spaceContainerHorizontal}",
        "compact": "{spaceContainerHorizontal}"
      },
      "spaceTableHeaderToolsBottom": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceTableHeaderToolsFullPageBottom": {
        "comfortable": "4px",
        "compact": "4px"
      },
      "spaceTableHorizontal": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceTreeViewIndentation": {
        "comfortable": "{spaceXl}",
        "compact": "{spaceXl}"
      },
      "spaceSideNavigationItemDefaultGap": {
        "comfortable": "{spaceNone}",
        "compact": "{spaceNone}"
      },
      "spaceSideNavigationItemIconGap": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxs}"
      },
      "spaceTileGutter": {
        "comfortable": "{spaceXl}",
        "compact": "{spaceM}"
      },
      "spaceActionCardHorizontalDefault": {
        "comfortable": "{spaceCardHorizontalDefault}",
        "compact": "{spaceCardHorizontalDefault}"
      },
      "spaceActionCardHorizontalEmbedded": {
        "comfortable": "{spaceCardHorizontalEmbedded}",
        "compact": "{spaceCardHorizontalEmbedded}"
      },
      "spaceActionCardVerticalDefault": {
        "comfortable": "{spaceCardVerticalDefault}",
        "compact": "{spaceCardVerticalDefault}"
      },
      "spaceActionCardVerticalEmbedded": {
        "comfortable": "{spaceCardVerticalEmbedded}",
        "compact": "{spaceCardVerticalEmbedded}"
      },
      "spaceActionCardDescriptionPaddingTop": {
        "comfortable": "{spaceScaledXxs}",
        "compact": "{spaceScaledXxs}"
      },
      "spaceActionCardContentPaddingTop": {
        "comfortable": "{spaceScaledS}",
        "compact": "{spaceScaledS}"
      },
      "spaceOptionPaddingVertical": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxs}"
      },
      "spaceOptionPaddingHorizontal": {
        "comfortable": "{spaceL}",
        "compact": "{spaceL}"
      },
      "spaceStatusIndicatorPaddingHorizontal": {
        "comfortable": "{spaceNone}",
        "compact": "{spaceNone}"
      },
      "spaceScaled2xNone": {
        "comfortable": "{spaceNone}",
        "compact": "{spaceNone}"
      },
      "spaceScaled2xXxxs": {
        "comfortable": "{spaceXxxs}",
        "compact": "{spaceNone}"
      },
      "spaceScaled2xXxs": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceNone}"
      },
      "spaceScaled2xXs": {
        "comfortable": "{spaceXs}",
        "compact": "{spaceNone}"
      },
      "spaceScaled2xS": {
        "comfortable": "{spaceS}",
        "compact": "{spaceXxs}"
      },
      "spaceScaled2xM": {
        "comfortable": "{spaceM}",
        "compact": "{spaceXs}"
      },
      "spaceScaled2xL": {
        "comfortable": "{spaceL}",
        "compact": "{spaceS}"
      },
      "spaceScaled2xXl": {
        "comfortable": "{spaceXl}",
        "compact": "{spaceM}"
      },
      "spaceScaled2xXxl": {
        "comfortable": "{spaceXxl}",
        "compact": "{spaceL}"
      },
      "spaceScaled2xXxxl": {
        "comfortable": "{spaceXxxl}",
        "compact": "{spaceXl}"
      },
      "spaceScaledNone": {
        "comfortable": "{spaceNone}",
        "compact": "{spaceNone}"
      },
      "spaceScaledXxxs": {
        "comfortable": "{spaceXxxs}",
        "compact": "{spaceNone}"
      },
      "spaceScaledXxs": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxxs}"
      },
      "spaceScaledXs": {
        "comfortable": "{spaceXs}",
        "compact": "{spaceXxs}"
      },
      "spaceScaledS": {
        "comfortable": "{spaceS}",
        "compact": "{spaceXs}"
      },
      "spaceScaledM": {
        "comfortable": "{spaceM}",
        "compact": "{spaceS}"
      },
      "spaceScaledL": {
        "comfortable": "{spaceL}",
        "compact": "{spaceM}"
      },
      "spaceScaledXl": {
        "comfortable": "{spaceXl}",
        "compact": "{spaceL}"
      },
      "spaceScaledXxl": {
        "comfortable": "{spaceXxl}",
        "compact": "{spaceXl}"
      },
      "spaceScaledXxxl": {
        "comfortable": "{spaceXxxl}",
        "compact": "{spaceXxl}"
      },
      "spaceStaticXxxs": {
        "comfortable": "{spaceXxxs}",
        "compact": "{spaceXxxs}"
      },
      "spaceStaticXxs": {
        "comfortable": "{spaceXxs}",
        "compact": "{spaceXxs}"
      },
      "spaceStaticXs": {
        "comfortable": "{spaceXs}",
        "compact": "{spaceXs}"
      },
      "spaceStaticS": {
        "comfortable": "{spaceS}",
        "compact": "{spaceS}"
      },
      "spaceStaticM": {
        "comfortable": "{spaceM}",
        "compact": "{spaceM}"
      },
      "spaceStaticL": {
        "comfortable": "{spaceL}",
        "compact": "{spaceL}"
      },
      "spaceStaticXl": {
        "comfortable": "{spaceXl}",
        "compact": "{spaceXl}"
      },
      "spaceStaticXxl": {
        "comfortable": "{spaceXxl}",
        "compact": "{spaceXxl}"
      },
      "spaceStaticXxxl": {
        "comfortable": "{spaceXxxl}",
        "compact": "{spaceXxxl}"
      },
      "spaceNone": {
        "comfortable": "0px",
        "compact": "0px"
      },
      "spaceXxxs": {
        "comfortable": "2px",
        "compact": "2px"
      },
      "spaceXxs": {
        "comfortable": "4px",
        "compact": "4px"
      },
      "spaceXs": {
        "comfortable": "8px",
        "compact": "8px"
      },
      "spaceS": {
        "comfortable": "12px",
        "compact": "12px"
      },
      "spaceM": {
        "comfortable": "16px",
        "compact": "16px"
      },
      "spaceL": {
        "comfortable": "20px",
        "compact": "20px"
      },
      "spaceXl": {
        "comfortable": "24px",
        "compact": "24px"
      },
      "spaceXxl": {
        "comfortable": "32px",
        "compact": "32px"
      },
      "spaceXxxl": {
        "comfortable": "40px",
        "compact": "40px"
      },
      "shadowCard": {
        "light": "{shadowContainer}",
        "dark": "{shadowContainer}"
      },
      "shadowItemCard": {
        "light": "{shadowCard}",
        "dark": "{shadowCard}"
      },
      "shadowDialog": {
        "light": "{shadowCard}",
        "dark": "{shadowCard}"
      },
      "shadowContainer": {
        "light": "0 1px 1px 0 rgba(0, 28, 36, 0.3), 1px 1px 1px 0 rgba(0, 28, 36, 0.15), -1px 1px 1px 0 rgba(0, 28, 36, 0.15)",
        "dark": "0 1px 1px 0 rgba(0, 0, 0, 0.3), 1px 1px 1px 0 rgba(0, 0, 0, 0.3), -1px 1px 1px 0 rgba(0, 0, 0, 0.3)"
      },
      "shadowContainerActive": {
        "light": "0px 4px 8px rgba(0, 28, 36, 0.45)",
        "dark": "0px 4px 8px rgba(0, 28, 36, 0.45)"
      },
      "shadowDropdown": {
        "light": "{shadowContainer}",
        "dark": "{shadowContainer}"
      },
      "shadowDropup": {
        "light": "0 -1px 1px 0 rgba(0, 28, 36, 0.3), 1px -1px 1px 0 rgba(0, 28, 36, 0.15), -1px -1px 1px 0 rgba(0, 28, 36, 0.15)",
        "dark": "0 -1px 1px 0 rgba(0, 0, 0, 0.3), 1px -1px 1px 0 rgba(0, 0, 0, 0.3), -1px -1px 1px 0 rgba(0, 0, 0, 0.3)"
      },
      "shadowFlashCollapsed": {
        "light": "0px 2px 2px rgba(0, 0, 0, 0.15)",
        "dark": "0px 2px 2px rgba(0, 0, 0, 0.15)"
      },
      "shadowFlashSticky": {
        "light": "{shadowPanel}",
        "dark": "{shadowPanel}"
      },
      "shadowModal": {
        "light": "{shadowContainer}",
        "dark": "{shadowContainer}"
      },
      "shadowPanel": {
        "light": "{shadowContainer}",
        "dark": "{shadowContainer}"
      },
      "shadowPanelToggle": {
        "light": "{shadowPanel}",
        "dark": "{shadowPanel}"
      },
      "shadowPopover": {
        "light": "{shadowSticky}",
        "dark": "{shadowSticky}"
      },
      "shadowSplitBottom": {
        "light": "0 -2px 1px -1px rgba(0, 28, 36, 0.15), 0 -1px 1px -1px rgba(0, 28, 36, 0.3)",
        "dark": "0 -2px 1px -1px rgba(0, 0, 0, 0.3), 0 -1px 1px -1px rgba(0, 0, 0, 0.3)"
      },
      "shadowSplitSide": {
        "light": "{shadowContainer}",
        "dark": "{shadowContainer}"
      },
      "shadowSticky": {
        "light": "0px 1px 4px -2px rgba(0, 28, 36, 0.5)",
        "dark": "0px 1px 4px -2px rgba(0, 0, 0, 0.5)"
      },
      "shadowStickyEmbedded": {
        "light": "{shadowSticky}",
        "dark": "{shadowSticky}"
      },
      "shadowStickyColumnFirst": {
        "light": "4px 0 8px 0 rgba(0, 28, 36, 0.1)",
        "dark": "4px 0 8px 0 rgba(0, 0, 0, 0.5)"
      },
      "shadowStickyColumnLast": {
        "light": "-4px 0 8px 0 rgba(0, 28, 36, 0.1)",
        "dark": "-4px 0 8px 0 rgba(0, 0, 0, 0.5)"
      }
    },
    "contexts": {
      "compact-table": {
        "id": "compact-table",
        "selector": ".awsui-context-compact-table",
        "tokens": {
          "spaceAlertActionLeft": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceAlertHorizontal": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceAlertMessageRight": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceAlertVertical": {
            "comfortable": "{spaceScaledS}",
            "compact": "{spaceScaledS}"
          },
          "spaceButtonFocusOutlineGutter": {
            "comfortable": "3px",
            "compact": "3px"
          },
          "spaceButtonHorizontal": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceButtonVertical": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceTokenVertical": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceFieldVertical": {
            "comfortable": "4px",
            "compact": "2px"
          },
          "spaceButtonIconFocusOutlineGutterVertical": {
            "comfortable": "{spaceButtonFocusOutlineGutter}",
            "compact": "{spaceButtonFocusOutlineGutter}"
          },
          "spaceButtonIconOnlyHorizontal": {
            "comfortable": "{spaceM}",
            "compact": "{spaceM}"
          },
          "spaceButtonInlineIconFocusOutlineGutter": {
            "comfortable": "{spaceButtonFocusOutlineGutter}",
            "compact": "{spaceButtonFocusOutlineGutter}"
          },
          "spaceButtonModalDismissVertical": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceCalendarGridFocusOutlineGutter": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceCalendarGridSelectedFocusOutlineGutter": {
            "comfortable": "2px",
            "compact": "2px"
          },
          "spaceCalendarGridGutter": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceCardHorizontalDefault": {
            "comfortable": "{spaceContainerHorizontal}",
            "compact": "{spaceContainerHorizontal}"
          },
          "spaceCardHorizontalEmbedded": {
            "comfortable": "{spaceS}",
            "compact": "10px"
          },
          "spaceCardVerticalDefault": {
            "comfortable": "{spaceScaledL}",
            "compact": "{spaceScaledL}"
          },
          "spaceCardVerticalEmbedded": {
            "comfortable": "10px",
            "compact": "{spaceXs}"
          },
          "spaceItemCardHorizontalDefault": {
            "comfortable": "{spaceCardHorizontalDefault}",
            "compact": "{spaceCardHorizontalDefault}"
          },
          "spaceItemCardHorizontalEmbedded": {
            "comfortable": "{spaceCardHorizontalEmbedded}",
            "compact": "{spaceCardHorizontalEmbedded}"
          },
          "spaceItemCardVerticalDefault": {
            "comfortable": "{spaceCardVerticalDefault}",
            "compact": "{spaceCardVerticalDefault}"
          },
          "spaceItemCardVerticalEmbedded": {
            "comfortable": "{spaceCardVerticalEmbedded}",
            "compact": "{spaceCardVerticalEmbedded}"
          },
          "spaceDialogHorizontal": {
            "comfortable": "{spaceCardHorizontalEmbedded}",
            "compact": "{spaceCardHorizontalEmbedded}"
          },
          "spaceDialogVertical": {
            "comfortable": "{spaceCardVerticalEmbedded}",
            "compact": "{spaceCardVerticalEmbedded}"
          },
          "spaceDialogActionBlock": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceDialogActionInline": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceDialogHeaderGap": {
            "comfortable": "{spaceXs}",
            "compact": "{spaceXs}"
          },
          "spaceDialogSectionGap": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceCodeEditorStatusFocusOutlineGutter": {
            "comfortable": "3px",
            "compact": "3px"
          },
          "spaceContainerContentTop": {
            "comfortable": "{spaceScaledM}",
            "compact": "{spaceScaledM}"
          },
          "spaceContainerHeaderTop": {
            "comfortable": "{spaceScaledS}",
            "compact": "{spaceScaledS}"
          },
          "spaceContainerHeaderBottom": {
            "comfortable": "{spaceScaledS}",
            "compact": "{spaceScaledS}"
          },
          "spaceContainerHorizontal": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceContentHeaderPaddingBottom": {
            "comfortable": "{spaceScaledM}",
            "compact": "{spaceScaledM}"
          },
          "spaceDarkHeaderOverlapDistance": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceExpandableSectionIconOffsetTop": {
            "comfortable": "{spaceScaledXs}",
            "compact": "{spaceScaledXs}"
          },
          "spaceFieldHorizontal": {
            "comfortable": "{spaceXs}",
            "compact": "{spaceXs}"
          },
          "spaceFieldIconOffset": {
            "comfortable": "32px",
            "compact": "32px"
          },
          "spaceFilteringTokenDismissButtonFocusOutlineGutter": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceFilteringTokenOperationSelectFocusOutlineGutter": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceFlashbarActionLeft": {
            "comfortable": "{spaceM}",
            "compact": "{spaceM}"
          },
          "spaceFlashbarDismissRight": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceFlashbarHorizontal": {
            "comfortable": "{spaceS}",
            "compact": "{spaceS}"
          },
          "spaceFlashbarVertical": {
            "comfortable": "{spaceScaledXs}",
            "compact": "{spaceScaledXs}"
          },
          "spaceGridGutter": {
            "comfortable": "{spaceL}",
            "compact": "{spaceM}"
          },
          "spaceKeyValueGap": {
            "comfortable": "{spaceScaledXxxs}",
            "compact": "{spaceScaledXxxs}"
          },
          "spaceLayoutContentBottom": {
            "comfortable": "{spaceScaledL}",
            "compact": "{spaceScaledL}"
          },
          "spaceLayoutContentHorizontal": {
            "comfortable": "{spaceScaled2xXxxl}",
            "compact": "{spaceScaled2xXxxl}"
          },
          "spaceLayoutToggleDiameter": {
            "comfortable": "36px",
            "compact": "36px"
          },
          "spaceLayoutTogglePadding": {
            "comfortable": "{spaceStaticS}",
            "compact": "{spaceStaticS}"
          },
          "spaceModalContentBottom": {
            "comfortable": "{spaceScaledL}",
            "compact": "{spaceScaledL}"
          },
          "spaceModalHorizontal": {
            "comfortable": "{spaceContainerHorizontal}",
            "compact": "{spaceContainerHorizontal}"
          },
          "spacePanelContentBottom": {
            "comfortable": "{spaceScaledXxxl}",
            "compact": "{spaceScaledXxxl}"
          },
          "spacePanelContentTop": {
            "comfortable": "{spaceScaledL}",
            "compact": "{spaceScaledL}"
          },
          "spacePanelDividerMarginHorizontal": {
            "comfortable": "{spaceS}",
            "compact": "{spaceS}"
          },
          "spacePanelHeaderVertical": {
            "comfortable": "{spaceScaledL}",
            "compact": "{spaceScaledL}"
          },
          "spacePanelNavLeft": {
            "comfortable": "{spaceXxl}",
            "compact": "{spaceXxl}"
          },
          "spacePanelSideLeft": {
            "comfortable": "{spaceScaledXxl}",
            "compact": "{spaceScaledXxl}"
          },
          "spacePanelSideRight": {
            "comfortable": "{spaceScaledXxl}",
            "compact": "{spaceScaledXxl}"
          },
          "spacePanelSplitTop": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spacePanelSplitBottom": {
            "comfortable": "{spaceScaledL}",
            "compact": "{spaceScaledL}"
          },
          "spaceSegmentedControlFocusOutlineGutter": {
            "comfortable": "3px",
            "compact": "3px"
          },
          "spaceTabsContentTop": {
            "comfortable": "{spaceScaledM}",
            "compact": "{spaceScaledM}"
          },
          "spaceTabsFocusOutlineGutter": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceTabsVertical": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceTableContentBottom": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceTableEmbeddedHeaderTop": {
            "comfortable": "{spaceContainerHeaderTop}",
            "compact": "{spaceContainerHeaderTop}"
          },
          "spaceTableFooterHorizontal": {
            "comfortable": "{spaceTableHeaderHorizontal}",
            "compact": "{spaceTableHeaderHorizontal}"
          },
          "spaceTableHeaderFocusOutlineGutter": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceTableHeaderHorizontal": {
            "comfortable": "{spaceContainerHorizontal}",
            "compact": "{spaceContainerHorizontal}"
          },
          "spaceTableHeaderToolsBottom": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceTableHeaderToolsFullPageBottom": {
            "comfortable": "4px",
            "compact": "4px"
          },
          "spaceTableHorizontal": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceTreeViewIndentation": {
            "comfortable": "{spaceXl}",
            "compact": "{spaceXl}"
          },
          "spaceSideNavigationItemDefaultGap": {
            "comfortable": "{spaceNone}",
            "compact": "{spaceNone}"
          },
          "spaceSideNavigationItemIconGap": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceTileGutter": {
            "comfortable": "{spaceXl}",
            "compact": "{spaceM}"
          },
          "spaceActionCardHorizontalDefault": {
            "comfortable": "{spaceCardHorizontalDefault}",
            "compact": "{spaceCardHorizontalDefault}"
          },
          "spaceActionCardHorizontalEmbedded": {
            "comfortable": "{spaceCardHorizontalEmbedded}",
            "compact": "{spaceCardHorizontalEmbedded}"
          },
          "spaceActionCardVerticalDefault": {
            "comfortable": "{spaceCardVerticalDefault}",
            "compact": "{spaceCardVerticalDefault}"
          },
          "spaceActionCardVerticalEmbedded": {
            "comfortable": "{spaceCardVerticalEmbedded}",
            "compact": "{spaceCardVerticalEmbedded}"
          },
          "spaceActionCardDescriptionPaddingTop": {
            "comfortable": "{spaceScaledXxs}",
            "compact": "{spaceScaledXxs}"
          },
          "spaceActionCardContentPaddingTop": {
            "comfortable": "{spaceScaledS}",
            "compact": "{spaceScaledS}"
          },
          "spaceOptionPaddingVertical": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceOptionPaddingHorizontal": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceStatusIndicatorPaddingHorizontal": {
            "comfortable": "{spaceNone}",
            "compact": "{spaceNone}"
          },
          "spaceScaled2xNone": {
            "comfortable": "{spaceNone}",
            "compact": "{spaceNone}"
          },
          "spaceScaled2xXxxs": {
            "comfortable": "{spaceXxxs}",
            "compact": "{spaceNone}"
          },
          "spaceScaled2xXxs": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceNone}"
          },
          "spaceScaled2xXs": {
            "comfortable": "{spaceXs}",
            "compact": "{spaceNone}"
          },
          "spaceScaled2xS": {
            "comfortable": "{spaceS}",
            "compact": "{spaceXxs}"
          },
          "spaceScaled2xM": {
            "comfortable": "{spaceM}",
            "compact": "{spaceXs}"
          },
          "spaceScaled2xL": {
            "comfortable": "{spaceL}",
            "compact": "{spaceS}"
          },
          "spaceScaled2xXl": {
            "comfortable": "{spaceXl}",
            "compact": "{spaceM}"
          },
          "spaceScaled2xXxl": {
            "comfortable": "{spaceXxl}",
            "compact": "{spaceL}"
          },
          "spaceScaled2xXxxl": {
            "comfortable": "{spaceXxxl}",
            "compact": "{spaceXl}"
          },
          "spaceScaledNone": {
            "comfortable": "{spaceNone}",
            "compact": "{spaceNone}"
          },
          "spaceScaledXxxs": {
            "comfortable": "{spaceNone}",
            "compact": "{spaceNone}"
          },
          "spaceScaledXxs": {
            "comfortable": "{spaceXxxs}",
            "compact": "{spaceXxxs}"
          },
          "spaceScaledXs": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceScaledS": {
            "comfortable": "{spaceXs}",
            "compact": "{spaceXs}"
          },
          "spaceScaledM": {
            "comfortable": "{spaceS}",
            "compact": "{spaceS}"
          },
          "spaceScaledL": {
            "comfortable": "{spaceM}",
            "compact": "{spaceM}"
          },
          "spaceScaledXl": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceScaledXxl": {
            "comfortable": "{spaceXl}",
            "compact": "{spaceXl}"
          },
          "spaceScaledXxxl": {
            "comfortable": "{spaceXxl}",
            "compact": "{spaceXxl}"
          },
          "spaceStaticXxxs": {
            "comfortable": "{spaceXxxs}",
            "compact": "{spaceXxxs}"
          },
          "spaceStaticXxs": {
            "comfortable": "{spaceXxs}",
            "compact": "{spaceXxs}"
          },
          "spaceStaticXs": {
            "comfortable": "{spaceXs}",
            "compact": "{spaceXs}"
          },
          "spaceStaticS": {
            "comfortable": "{spaceS}",
            "compact": "{spaceS}"
          },
          "spaceStaticM": {
            "comfortable": "{spaceM}",
            "compact": "{spaceM}"
          },
          "spaceStaticL": {
            "comfortable": "{spaceL}",
            "compact": "{spaceL}"
          },
          "spaceStaticXl": {
            "comfortable": "{spaceXl}",
            "compact": "{spaceXl}"
          },
          "spaceStaticXxl": {
            "comfortable": "{spaceXxl}",
            "compact": "{spaceXxl}"
          },
          "spaceStaticXxxl": {
            "comfortable": "{spaceXxxl}",
            "compact": "{spaceXxxl}"
          },
          "spaceNone": {
            "comfortable": "0px",
            "compact": "0px"
          },
          "spaceXxxs": {
            "comfortable": "2px",
            "compact": "2px"
          },
          "spaceXxs": {
            "comfortable": "4px",
            "compact": "4px"
          },
          "spaceXs": {
            "comfortable": "8px",
            "compact": "8px"
          },
          "spaceS": {
            "comfortable": "12px",
            "compact": "12px"
          },
          "spaceM": {
            "comfortable": "16px",
            "compact": "16px"
          },
          "spaceL": {
            "comfortable": "20px",
            "compact": "20px"
          },
          "spaceXl": {
            "comfortable": "24px",
            "compact": "24px"
          },
          "spaceXxl": {
            "comfortable": "32px",
            "compact": "32px"
          },
          "spaceXxxl": {
            "comfortable": "40px",
            "compact": "40px"
          },
          "sizeVerticalInput": {
            "comfortable": "28px",
            "compact": "28px"
          }
        }
      },
      "top-navigation": {
        "id": "top-navigation",
        "selector": ".awsui-context-top-navigation",
        "tokens": {
          "colorGreyOpaque10": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(0, 0, 0, 0.1)"
          },
          "colorGreyOpaque25": {
            "light": "rgba(255, 255, 255, 0.25)",
            "dark": "rgba(255, 255, 255, 0.25)"
          },
          "colorGreyOpaque40": {
            "light": "rgba(0, 0, 0, 0.4)",
            "dark": "rgba(0, 0, 0, 0.4)"
          },
          "colorGreyOpaque50": {
            "light": "rgba(0, 0, 0, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyOpaque70": {
            "light": "rgba(255, 255, 255, 0.7)",
            "dark": "rgba(255, 255, 255, 0.7)"
          },
          "colorGreyOpaque80": {
            "light": "rgba(22, 25, 31, 0.8)",
            "dark": "rgba(22, 25, 31, 0.8)"
          },
          "colorGreyOpaque90": {
            "light": "rgba(242, 243, 243, 0.9)",
            "dark": "rgba(242, 243, 243, 0.9)"
          },
          "colorGreyTransparent": {
            "light": "rgba(0, 0, 0, 0.3)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorGreyTransparentHeavy": {
            "light": "rgba(0, 0, 0, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyTransparentLight": {
            "light": "rgba(0, 0, 0, 0.3)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorBackgroundBadgeIcon": {
            "light": "{colorError400}",
            "dark": "{colorError400}"
          },
          "colorBackgroundButtonLinkActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonLinkDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkDisabled": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkHover": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundButtonNormalActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonNormalDefault": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalDisabled": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalHover": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundToggleButtonNormalPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundToggleButtonNormalDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundToggleButtonNormalHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundButtonPrimaryActive": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDefault": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDisabled": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonPrimaryHover": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundDirectionButtonActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundDirectionButtonDisabled": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorTextDirectionButtonDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextDirectionButtonDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorBackgroundCalendarCurrentDate": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCellShaded": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundCodeEditorGutterActiveLineError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundCodeEditorGutterDefault": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCodeEditorLoading": {
            "light": "{colorBackgroundCodeEditorStatusBar}",
            "dark": "{colorBackgroundCodeEditorStatusBar}"
          },
          "colorBackgroundCodeEditorPaneItemHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundCodeEditorStatusBar": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCard": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundItemCard": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundContainerContent": {
            "light": "{colorAwsSquidInk}",
            "dark": "{colorAwsSquidInk}"
          },
          "colorBackgroundContainerHeader": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundControlChecked": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundControlDefault": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundControlDisabled": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemDefault": {
            "light": "{colorAwsSquidInk}",
            "dark": "{colorAwsSquidInk}"
          },
          "colorBackgroundDropdownItemDimmed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundDropdownItemFilterMatch": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundDropdownItemHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemSelected": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundHomeHeader": {
            "light": "{colorBlack}",
            "dark": "{colorBlack}"
          },
          "colorBackgroundInlineCode": {
            "light": "rgba(255, 255, 255, 0.1)",
            "dark": "rgba(255, 255, 255, 0.1)"
          },
          "colorBackgroundInputDefault": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundInputDisabled": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundItemSelected": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundSideNavigationItemActive": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundSideNavigationItemActiveCollapsed": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBackgroundSideNavigationItemIconHover": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundLayoutMain": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundLayoutAiDrawer": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundDrawer": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundBackdrop": {
            "light": "{colorGreyOpaque80}",
            "dark": "{colorGreyOpaque80}"
          },
          "colorBackgroundDrawerBackdrop": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundLayoutMobilePanel": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutPanel": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelContent": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundLayoutToolbar": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutToggleActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundLayoutToggleDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundLayoutToggleHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundLayoutToggleSelectedActive": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundLayoutToggleSelectedDefault": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundLayoutToggleSelectedHover": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundModalOverlay": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundNotificationBlue": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo600}"
          },
          "colorBackgroundNotificationGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBackgroundNotificationGrey": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundNotificationRed": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBackgroundNotificationYellow": {
            "light": "{colorWarning400}",
            "dark": "{colorWarning400}"
          },
          "colorBackgroundFlashbarSuccess": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundFlashbarError": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundFlashbarInfo": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundFlashbarWarning": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundPopover": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundProgressBarValueDefault": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundProgressBarValueFlash": {
            "light": "{colorBackgroundProgressBarValueDefault}",
            "dark": "{colorBackgroundProgressBarValueDefault}"
          },
          "colorBackgroundProgressBarFlash": {
            "light": "{colorBackgroundProgressBarDefault}",
            "dark": "{colorBackgroundProgressBarDefault}"
          },
          "colorBackgroundProgressBarDefault": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundSegmentActive": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSegmentDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundSegmentDisabled": {
            "light": "{colorBackgroundButtonNormalDisabled}",
            "dark": "{colorBackgroundButtonNormalDisabled}"
          },
          "colorBackgroundSegmentHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundSegmentWrapper": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundSliderRangeDefault": {
            "light": "{colorBackgroundSliderHandleDefault}",
            "dark": "{colorBackgroundSliderHandleDefault}"
          },
          "colorBackgroundSliderRangeActive": {
            "light": "{colorBackgroundSliderHandleActive}",
            "dark": "{colorBackgroundSliderHandleActive}"
          },
          "colorBackgroundSliderHandleDefault": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSliderHandleActive": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundSliderTrackDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSliderHandleRing": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundSliderHandleErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderHandleWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundStatusError": {
            "light": "{colorError1000}",
            "dark": "{colorError1000}"
          },
          "colorBackgroundStatusInfo": {
            "light": "{colorInfo1000}",
            "dark": "{colorInfo1000}"
          },
          "colorBackgroundAlertError": {
            "light": "{colorBackgroundStatusError}",
            "dark": "{colorBackgroundStatusError}"
          },
          "colorBackgroundAlertInfo": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundAlertSuccess": {
            "light": "{colorBackgroundStatusSuccess}",
            "dark": "{colorBackgroundStatusSuccess}"
          },
          "colorBackgroundAlertWarning": {
            "light": "{colorBackgroundStatusWarning}",
            "dark": "{colorBackgroundStatusWarning}"
          },
          "colorBackgroundDialog": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundDialogDefault": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundStatusSuccess": {
            "light": "{colorSuccess1000}",
            "dark": "{colorSuccess1000}"
          },
          "colorBackgroundStatusWarning": {
            "light": "{colorWarning1000}",
            "dark": "{colorWarning1000}"
          },
          "colorBackgroundTableHeader": {
            "light": "{colorBackgroundContainerHeader}",
            "dark": "{colorBackgroundContainerHeader}"
          },
          "colorBackgroundTilesDisabled": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundToggleCheckedDisabled": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary700}"
          },
          "colorBackgroundToggleDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundAvatarGenAi": {
            "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
            "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
          },
          "colorBackgroundAvatarDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextAvatar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBackgroundLoadingBarGenAi": {
            "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
            "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
          },
          "colorBackgroundStatusIndicatorError": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorWarning": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorSuccess": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorInfo": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorNeutral": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleOutgoing": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleIncoming": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextChatBubbleOutgoing": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextChatBubbleIncoming": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorBorderButtonLinkDisabled": {
            "light": "{colorBackgroundButtonLinkDisabled}",
            "dark": "{colorBackgroundButtonLinkDisabled}"
          },
          "colorBorderButtonNormalActive": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderButtonNormalDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalPressed": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalDefault": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderToggleButtonNormalHover": {
            "light": "{colorBorderButtonNormalHover}",
            "dark": "{colorBorderButtonNormalHover}"
          },
          "colorBorderButtonNormalDisabled": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorTextButtonNormalDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonNormalHover": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral400}"
          },
          "colorTextButtonIconDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonPrimaryActive": {
            "light": "{colorBackgroundButtonPrimaryActive}",
            "dark": "{colorBackgroundButtonPrimaryActive}"
          },
          "colorBorderButtonPrimaryDefault": {
            "light": "{colorBackgroundButtonPrimaryDefault}",
            "dark": "{colorBackgroundButtonPrimaryDefault}"
          },
          "colorBorderButtonPrimaryDisabled": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderButtonPrimaryHover": {
            "light": "{colorBackgroundButtonPrimaryHover}",
            "dark": "{colorBackgroundButtonPrimaryHover}"
          },
          "colorTextButtonPrimaryDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorItemSelected": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextSideNavigationItemActive": {
            "light": "{colorTextAccent}",
            "dark": "{colorTextAccent}"
          },
          "colorTextSideNavigationItemActiveCollapsed": {
            "light": "{colorTextInverted}",
            "dark": "{colorTextInverted}"
          },
          "colorTextSideNavigationItemDefault": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorBorderCalendarGrid": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCalendarGridSelectedFocusRing": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderCellShaded": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderCodeEditorAceActiveLineLightTheme": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorBorderCodeEditorAceActiveLineDarkTheme": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorPaneItemHover": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderCard": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCardHighlighted": {
            "light": "{colorBorderItemSelected}",
            "dark": "{colorBorderItemSelected}"
          },
          "colorBorderItemCard": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderItemCardHighlighted": {
            "light": "{colorBorderCardHighlighted}",
            "dark": "{colorBorderCardHighlighted}"
          },
          "colorBorderContainerDivider": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderContainerTop": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderControlChecked": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBorderControlDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderControlDisabled": {
            "light": "{colorBackgroundControlDisabled}",
            "dark": "{colorBackgroundControlDisabled}"
          },
          "colorBorderDividerActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDividerDefault": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerNotification": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDividerPanelBottom": {
            "light": "{colorShadowSide}",
            "dark": "{colorShadowSide}"
          },
          "colorBorderDividerPanelSide": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDividerSecondary": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerTableGroup": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDropdownContainer": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDropdownGroup": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDropdownItemHover": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderDropdownItemDimmedHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderDropdownItemSelected": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemTop": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderEditableCellHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderInputDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderInputDisabled": {
            "light": "{colorBackgroundInputDisabled}",
            "dark": "{colorBackgroundInputDisabled}"
          },
          "colorBorderInputFocused": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderItemFocused": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderDropdownItemFocused": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderItemPlaceholder": {
            "light": "{colorTransparent}",
            "dark": "{colorTransparent}"
          },
          "colorBorderItemSelected": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderLayout": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderLayoutSideNavigation": {
            "light": "{colorBorderLayout}",
            "dark": "{colorBorderLayout}"
          },
          "colorBorderNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderNotificationStackBarHover": {
            "light": "{colorBackgroundNotificationStackBarHover}",
            "dark": "{colorBackgroundNotificationStackBarHover}"
          },
          "colorBorderNotificationStackBarActive": {
            "light": "{colorBackgroundNotificationStackBar}",
            "dark": "{colorBackgroundNotificationStackBar}"
          },
          "colorBorderNotificationStackBarFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderPanelHeader": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderPopover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBorderSegmentActive": {
            "light": "{colorBorderSegmentHover}",
            "dark": "{colorBorderSegmentHover}"
          },
          "colorBorderSegmentDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderSegmentDisabled": {
            "light": "{colorBorderButtonNormalDisabled}",
            "dark": "{colorBorderButtonNormalDisabled}"
          },
          "colorBorderSegmentDivider": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderSegmentHover": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBorderSegmentWrapper": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBorderStatusInfo": {
            "light": "{colorInfo400}",
            "dark": "{colorInfo400}"
          },
          "colorBorderStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBorderStatusWarning": {
            "light": "{colorWarning500}",
            "dark": "{colorWarning500}"
          },
          "colorBorderDialog": {
            "light": "{colorBorderStatusInfo}",
            "dark": "{colorBorderStatusInfo}"
          },
          "colorBorderDialogDefault": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderDividerInteractiveDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderTabsDivider": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTabsShadow": {
            "light": "{colorGreyTransparent}",
            "dark": "{colorGreyTransparent}"
          },
          "colorBorderTabsUnderline": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorBorderTilesDisabled": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTutorial": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorForegroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorForegroundControlDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorForegroundControlReadOnly": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorShadowDefault": {
            "light": "{colorGreyTransparentHeavy}",
            "dark": "{colorGreyTransparentHeavy}"
          },
          "colorShadowMedium": {
            "light": "{colorGreyTransparent}",
            "dark": "{colorGreyTransparent}"
          },
          "colorShadowSide": {
            "light": "{colorGreyTransparentLight}",
            "dark": "{colorGreyTransparentLight}"
          },
          "colorShadowToggleHandle": {
            "light": "rgba(0, 0, 0, 0.25)",
            "dark": "rgba(0, 0, 0, 0.25)"
          },
          "colorStrokeChartLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorStrokeCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorStrokeCodeEditorGutterActiveLineHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextAccent": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextBodyDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBodySecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbCurrent": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbIcon": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextButtonInlineIconDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonInlineLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonNormalActive": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonNormalPressed": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextButtonNormalDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextButtonNormalHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextLinkButtonNormalDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextLinkButtonNormalHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextLinkButtonNormalActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextButtonLinkDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonPrimaryActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCalendarDateHover": {
            "light": "{colorTextDropdownItemHighlighted}",
            "dark": "{colorTextDropdownItemHighlighted}"
          },
          "colorTextCalendarDateSelected": {
            "light": "{colorBackgroundControlDefault}",
            "dark": "{colorBackgroundControlDefault}"
          },
          "colorTextCalendarMonth": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextCodeEditorGutterActiveLine": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCodeEditorGutterDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextCodeEditorStatusBarDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorTextCodeEditorTabButtonError": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextColumnHeader": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextColumnSortingIcon": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextControlDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextCounter": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorTextDisabledInlineEdit": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDropdownFooter": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownGroupLabel": {
            "light": "{colorTextGroupLabel}",
            "dark": "{colorTextGroupLabel}"
          },
          "colorTextDropdownItemDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextDropdownItemDimmed": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemFilterMatch": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextDropdownItemHighlighted": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral250}"
          },
          "colorTextDropdownItemSecondary": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownItemSecondaryHover": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextEmpty": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextExpandableSectionDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextExpandableSectionHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextExpandableSectionNavigationIconDefault": {
            "light": "{colorTextIconCaret}",
            "dark": "{colorTextIconCaret}"
          },
          "colorBorderExpandableSectionDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorTextFormDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextFormLabel": {
            "light": "{colorTextFormDefault}",
            "dark": "{colorTextFormDefault}"
          },
          "colorTextFormSecondary": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextGroupLabel": {
            "light": "{colorTextLabel}",
            "dark": "{colorTextLabel}"
          },
          "colorTextLabelGenAi": {
            "light": "{colorPurple400}",
            "dark": "{colorPurple400}"
          },
          "colorTextHeadingDefault": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHeadingSecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextHomeHeaderDefault": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHomeHeaderSecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextIconCaret": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextIconSubtle": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral400}"
          },
          "colorTextInputDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInputPlaceholder": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorTextInputPlaceholderDisabled": {
            "light": "{colorTextInputPlaceholder}",
            "dark": "{colorTextInputPlaceholder}"
          },
          "colorTextInteractiveActive": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInteractiveHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonIconPressed": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveInvertedDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveInvertedHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInverted": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLabel": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextKeyValuePairsValue": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextLayoutToggle": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextLayoutToggleActive": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorTextLayoutToggleHover": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorTextLayoutToggleSelected": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLinkDefault": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextLinkHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary200}"
          },
          "colorTextLinkDecorationDefault": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkDecorationHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkSecondaryDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkSecondaryHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkSecondaryDecorationDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextLinkInfoDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkInfoHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkInvertedDefault": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkInvertedHover": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkButtonUnderline": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkButtonUnderlineHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextNotificationDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextAlertDefault": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextNotificationLinkDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextNotificationLinkHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextNotificationStackBar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextNotificationYellow": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextPaginationPageNumberActiveDisabled": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextPaginationPageNumberDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextSegmentActive": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorTextSegmentDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextSegmentHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextSmall": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextFlashbarIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextFlashbarIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextFlashbarIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextFlashbarIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextAlertIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextAlertIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextAlertIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextAlertIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextStatusError": {
            "light": "{colorError400}",
            "dark": "{colorError400}"
          },
          "colorTextStatusInactive": {
            "light": "{colorNeutral450}",
            "dark": "{colorNeutral450}"
          },
          "colorTextStatusInfo": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextStatusSuccess": {
            "light": "{colorSuccess500}",
            "dark": "{colorSuccess500}"
          },
          "colorTextStatusWarning": {
            "light": "{colorWarning500}",
            "dark": "{colorWarning500}"
          },
          "colorTextTopNavigationTitle": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextTutorialHotspotDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextTutorialHotspotHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorBoardPlaceholderActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBoardPlaceholderHover": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary600}"
          },
          "colorDragPlaceholderActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorDragPlaceholderHover": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary600}"
          },
          "colorDropzoneBackgroundDefault": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorDropzoneBackgroundHover": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary1000}"
          },
          "colorDropzoneTextDefault": {
            "light": "{colorNeutral350}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneTextHover": {
            "light": "{colorNeutral350}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneBorderDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorDropzoneBorderHover": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorGapGlobalDrawer": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTreeViewConnectorLine": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorBackgroundActionCardDefault": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundActionCardHover": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundActionCardActive": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderActionCardDefault": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderActionCardHover": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardActive": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundActionCardDisabled": {
            "light": "{colorNeutral800}",
            "dark": "{colorNeutral800}"
          },
          "colorTextActionCardDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorTextActionCardIconDefault": {
            "light": "{colorPrimary400}",
            "dark": "{colorPrimary400}"
          },
          "colorTextActionCardIconHover": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconActive": {
            "light": "{colorPrimary300}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconDisabled": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeleton": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeletonWave": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundBadgeGreen": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundBadgeBlue": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundBadgeRed": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundBadgeYellow": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundBadgeGrey": {
            "light": "{colorBackgroundNotificationGrey}",
            "dark": "{colorBackgroundNotificationGrey}"
          },
          "colorBorderBadge": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGrey": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGreen": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeBlue": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeRed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextBadgeGrey": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeGreen": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeBlue": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeRed": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorBackgroundCodeView": {
            "light": "#282c34",
            "dark": "#282c34"
          },
          "colorBackgroundVisualAccentRed": {
            "light": "rgba(255, 61, 61, 0.2)",
            "dark": "rgba(255, 61, 61, 0.2)"
          },
          "colorBackgroundVisualAccentYellow": {
            "light": "rgba(251, 211, 50, 0.2)",
            "dark": "rgba(251, 211, 50, 0.2)"
          },
          "colorBackgroundVisualAccentIndigo": {
            "light": "rgba(92, 127, 255, 0.2)",
            "dark": "rgba(92, 127, 255, 0.2)"
          },
          "colorBackgroundVisualAccentGreen": {
            "light": "rgba(43, 181, 52, 0.2)",
            "dark": "rgba(43, 181, 52, 0.2)"
          },
          "colorBackgroundVisualAccentOrange": {
            "light": "rgba(255, 75, 20, 0.2)",
            "dark": "rgba(255, 75, 20, 0.2)"
          },
          "colorBackgroundVisualAccentPurple": {
            "light": "rgba(173, 92, 255, 0.2)",
            "dark": "rgba(173, 92, 255, 0.2)"
          },
          "colorBackgroundVisualAccentLime": {
            "light": "rgba(49, 184, 0, 0.2)",
            "dark": "rgba(49, 184, 0, 0.2)"
          },
          "colorBackgroundVisualAccentGrey": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundVisualAccentTeal": {
            "light": "rgba(0, 173, 162, 0.2)",
            "dark": "rgba(0, 173, 162, 0.2)"
          },
          "colorBackgroundVisualAccentBlue": {
            "light": "rgba(0, 153, 255, 0.2)",
            "dark": "rgba(0, 153, 255, 0.2)"
          },
          "colorBackgroundVisualAccentViolet": {
            "light": "rgba(133, 117, 255, 0.2)",
            "dark": "rgba(133, 117, 255, 0.2)"
          },
          "colorBackgroundVisualAccentMagenta": {
            "light": "rgba(255, 26, 224, 0.2)",
            "dark": "rgba(255, 26, 224, 0.2)"
          },
          "colorBackgroundVisualAccentPink": {
            "light": "rgba(255, 51, 153, 0.2)",
            "dark": "rgba(255, 51, 153, 0.2)"
          },
          "colorBackgroundVisualAccentAmber": {
            "light": "rgba(250, 111, 0, 0.2)",
            "dark": "rgba(250, 111, 0, 0.2)"
          },
          "colorTextVisualAccentRed": {
            "light": "{colorError400}",
            "dark": "{colorError400}"
          },
          "colorTextVisualAccentYellow": {
            "light": "{colorWarning200}",
            "dark": "{colorWarning200}"
          },
          "colorTextVisualAccentIndigo": {
            "light": "{colorInfo300}",
            "dark": "{colorInfo300}"
          },
          "colorTextVisualAccentGreen": {
            "light": "{colorSuccess200}",
            "dark": "{colorSuccess200}"
          },
          "colorTextVisualAccentOrange": {
            "light": "#ff997a",
            "dark": "#ff997a"
          },
          "colorTextVisualAccentPurple": {
            "light": "#d4a8ff",
            "dark": "#d4a8ff"
          },
          "colorTextVisualAccentLime": {
            "light": "#acff2e",
            "dark": "#acff2e"
          },
          "colorTextVisualAccentGrey": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextVisualAccentTeal": {
            "light": "#00f5e4",
            "dark": "#00f5e4"
          },
          "colorTextVisualAccentBlue": {
            "light": "#75cfff",
            "dark": "#75cfff"
          },
          "colorTextVisualAccentViolet": {
            "light": "#b2a8ff",
            "dark": "#b2a8ff"
          },
          "colorTextVisualAccentMagenta": {
            "light": "#ff57e9",
            "dark": "#ff57e9"
          },
          "colorTextVisualAccentPink": {
            "light": "#ff99cc",
            "dark": "#ff99cc"
          },
          "colorTextVisualAccentAmber": {
            "light": "#ffbb45",
            "dark": "#ffbb45"
          },
          "colorPrimary50": "#f1faff",
          "colorPrimary100": "#d1f1ff",
          "colorPrimary200": "#99cbe4",
          "colorPrimary300": "#44b9d6",
          "colorPrimary400": "#00a1c9",
          "colorPrimary500": "#0099ff",
          "colorPrimary600": "#0073bb",
          "colorPrimary700": "#0a4a74",
          "colorPrimary800": "#003b8f",
          "colorPrimary900": "#002b66",
          "colorPrimary950": "#00204d",
          "colorPrimary1000": "#12293b",
          "colorNeutral50": "#fcfcfd",
          "colorNeutral100": "#fafafa",
          "colorNeutral150": "#f6f6f9",
          "colorNeutral200": "#f2f3f3",
          "colorNeutral250": "#eaeded",
          "colorNeutral300": "#d5dbdb",
          "colorNeutral350": "#c6c6cd",
          "colorNeutral400": "#aab7b8",
          "colorNeutral450": "#95a5a6",
          "colorNeutral500": "#879596",
          "colorNeutral550": "#72747e",
          "colorNeutral600": "#687078",
          "colorNeutral650": "#545b64",
          "colorNeutral700": "#414750",
          "colorNeutral750": "#2a2e33",
          "colorNeutral800": "#21252c",
          "colorNeutral850": "#1a2029",
          "colorNeutral900": "#131920",
          "colorNeutral950": "#16191f",
          "colorNeutral1000": "#06080a",
          "colorError50": "#fdf3f1",
          "colorError100": "#ffe0e0",
          "colorError400": "#ff5d64",
          "colorError600": "#d13212",
          "colorError700": "#c20000",
          "colorError800": "#990000",
          "colorError900": "#700000",
          "colorError950": "#520000",
          "colorError1000": "#270a11",
          "colorSuccess50": "#f2f8f0",
          "colorSuccess100": "#d9ffd6",
          "colorSuccess200": "#aeffa8",
          "colorSuccess400": "#00e500",
          "colorSuccess500": "#6aaf35",
          "colorSuccess600": "#1d8102",
          "colorSuccess800": "#005c26",
          "colorSuccess950": "#003311",
          "colorSuccess1000": "#172211",
          "colorWarning50": "#fffef0",
          "colorWarning100": "#fffbbd",
          "colorWarning200": "#fef571",
          "colorWarning400": "#ffe347",
          "colorWarning500": "#fbd332",
          "colorWarning600": "#f2b100",
          "colorWarning800": "#9e6900",
          "colorWarning900": "#906806",
          "colorWarning950": "#573a00",
          "colorWarning1000": "#191100",
          "colorInfo50": "#f1faff",
          "colorInfo100": "#d1f1ff",
          "colorInfo300": "#44b9d6",
          "colorInfo400": "#00a1c9",
          "colorInfo600": "#0073bb",
          "colorInfo700": "#004a9e",
          "colorInfo800": "#003b8f",
          "colorInfo950": "#00204d",
          "colorInfo1000": "#12293b",
          "colorChartsStatusNeutral": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorChartsThresholdNegative": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorChartsThresholdPositive": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess500}"
          },
          "colorChartsThresholdInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo300}"
          },
          "colorChartsThresholdNeutral": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorChartsLineGrid": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorChartsLineTick": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorChartsLineAxis": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorChartsErrorBarMarker": {
            "light": "{colorNeutral900}",
            "dark": "{colorWhite}"
          },
          "colorSeverityGrey": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundNotificationSeverityNeutral": {
            "light": "{colorSeverityGrey}",
            "dark": "{colorSeverityGrey}"
          },
          "colorTextNotificationSeverityCritical": {
            "light": "{colorNeutral100}",
            "dark": "{colorBlack}"
          },
          "colorTextNotificationSeverityHigh": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral950}"
          },
          "colorTextNotificationSeverityMedium": {
            "light": "{colorBlack}",
            "dark": "{colorNeutral950}"
          },
          "colorTextNotificationSeverityLow": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextNotificationSeverityNeutral": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextBadgeSeverityCritical": {
            "light": "{colorTextNotificationSeverityCritical}",
            "dark": "{colorTextNotificationSeverityCritical}"
          },
          "colorTextBadgeSeverityHigh": {
            "light": "{colorTextNotificationSeverityHigh}",
            "dark": "{colorTextNotificationSeverityHigh}"
          },
          "colorTextBadgeSeverityMedium": {
            "light": "{colorTextNotificationSeverityMedium}",
            "dark": "{colorTextNotificationSeverityMedium}"
          },
          "colorTextBadgeSeverityLow": {
            "light": "{colorTextNotificationSeverityLow}",
            "dark": "{colorTextNotificationSeverityLow}"
          },
          "colorTextBadgeSeverityNeutral": {
            "light": "{colorTextNotificationSeverityNeutral}",
            "dark": "{colorTextNotificationSeverityNeutral}"
          }
        },
        "defaultMode": "dark"
      },
      "app-layout-tools-drawer-trigger": {
        "id": "app-layout-tools-drawer-trigger",
        "selector": ".awsui-context-app-layout-tools-drawer-trigger",
        "tokens": {
          "colorGreyOpaque10": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(0, 0, 0, 0.1)"
          },
          "colorGreyOpaque25": {
            "light": "rgba(255, 255, 255, 0.25)",
            "dark": "rgba(255, 255, 255, 0.25)"
          },
          "colorGreyOpaque40": {
            "light": "rgba(0, 0, 0, 0.4)",
            "dark": "rgba(0, 0, 0, 0.4)"
          },
          "colorGreyOpaque50": {
            "light": "rgba(0, 0, 0, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyOpaque70": {
            "light": "rgba(255, 255, 255, 0.7)",
            "dark": "rgba(255, 255, 255, 0.7)"
          },
          "colorGreyOpaque80": {
            "light": "rgba(22, 25, 31, 0.8)",
            "dark": "rgba(22, 25, 31, 0.8)"
          },
          "colorGreyOpaque90": {
            "light": "rgba(242, 243, 243, 0.9)",
            "dark": "rgba(242, 243, 243, 0.9)"
          },
          "colorGreyTransparent": {
            "light": "rgba(0, 28, 36, 0.3)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorGreyTransparentHeavy": {
            "light": "rgba(0, 28, 36, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyTransparentLight": {
            "light": "rgba(0, 28, 36, 0.15)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorBackgroundBadgeIcon": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorBackgroundButtonLinkActive": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonLinkDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkDisabled": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundButtonNormalActive": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonNormalDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundToggleButtonNormalPressed": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundToggleButtonNormalDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundToggleButtonNormalHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundButtonPrimaryActive": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonPrimaryHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundDirectionButtonActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundDirectionButtonDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorTextDirectionButtonDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextDirectionButtonDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorBackgroundCalendarCurrentDate": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCellShaded": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundCodeEditorGutterActiveLineError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundCodeEditorGutterDefault": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCodeEditorLoading": {
            "light": "{colorBackgroundCodeEditorStatusBar}",
            "dark": "{colorBackgroundCodeEditorStatusBar}"
          },
          "colorBackgroundCodeEditorPaneItemHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundCodeEditorStatusBar": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCard": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundItemCard": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundContainerContent": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundContainerHeader": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundControlChecked": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundControlDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDropdownItemDimmed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundDropdownItemFilterMatch": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundDropdownItemHover": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemSelected": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundHomeHeader": {
            "light": "{colorBlack}",
            "dark": "{colorBlack}"
          },
          "colorBackgroundInlineCode": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(255, 255, 255, 0.1)"
          },
          "colorBackgroundInputDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundInputDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundItemSelected": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundSideNavigationItemActive": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundSideNavigationItemActiveCollapsed": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBackgroundSideNavigationItemIconHover": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundLayoutMain": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundLayoutAiDrawer": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundDrawer": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundBackdrop": {
            "light": "{colorGreyOpaque90}",
            "dark": "{colorGreyOpaque80}"
          },
          "colorBackgroundDrawerBackdrop": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundLayoutMobilePanel": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutPanel": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelContent": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundLayoutToolbar": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutToggleActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundLayoutToggleDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundLayoutToggleHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundLayoutToggleSelectedActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundLayoutToggleSelectedDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundLayoutToggleSelectedHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundModalOverlay": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundNotificationBlue": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo600}"
          },
          "colorBackgroundNotificationGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBackgroundNotificationGrey": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundNotificationRed": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBackgroundNotificationYellow": {
            "light": "{colorWarning400}",
            "dark": "{colorWarning400}"
          },
          "colorBackgroundFlashbarSuccess": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundFlashbarError": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundFlashbarInfo": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundFlashbarWarning": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundPopover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundProgressBarValueDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundProgressBarValueFlash": {
            "light": "{colorBackgroundProgressBarValueDefault}",
            "dark": "{colorBackgroundProgressBarValueDefault}"
          },
          "colorBackgroundProgressBarFlash": {
            "light": "{colorBackgroundProgressBarDefault}",
            "dark": "{colorBackgroundProgressBarDefault}"
          },
          "colorBackgroundProgressBarDefault": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundSegmentActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSegmentDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundSegmentDisabled": {
            "light": "{colorBackgroundButtonNormalDisabled}",
            "dark": "{colorBackgroundButtonNormalDisabled}"
          },
          "colorBackgroundSegmentHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundSegmentWrapper": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundSliderRangeDefault": {
            "light": "{colorBackgroundSliderHandleDefault}",
            "dark": "{colorBackgroundSliderHandleDefault}"
          },
          "colorBackgroundSliderRangeActive": {
            "light": "{colorBackgroundSliderHandleActive}",
            "dark": "{colorBackgroundSliderHandleActive}"
          },
          "colorBackgroundSliderHandleDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSliderHandleActive": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundSliderTrackDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSliderHandleRing": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundSliderHandleErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderHandleWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundStatusError": {
            "light": "{colorError50}",
            "dark": "{colorError1000}"
          },
          "colorBackgroundStatusInfo": {
            "light": "{colorInfo50}",
            "dark": "{colorInfo1000}"
          },
          "colorBackgroundAlertError": {
            "light": "{colorBackgroundStatusError}",
            "dark": "{colorBackgroundStatusError}"
          },
          "colorBackgroundAlertInfo": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundAlertSuccess": {
            "light": "{colorBackgroundStatusSuccess}",
            "dark": "{colorBackgroundStatusSuccess}"
          },
          "colorBackgroundAlertWarning": {
            "light": "{colorBackgroundStatusWarning}",
            "dark": "{colorBackgroundStatusWarning}"
          },
          "colorBackgroundDialog": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundDialogDefault": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundStatusSuccess": {
            "light": "{colorSuccess50}",
            "dark": "{colorSuccess1000}"
          },
          "colorBackgroundStatusWarning": {
            "light": "{colorWarning50}",
            "dark": "{colorWarning1000}"
          },
          "colorBackgroundTableHeader": {
            "light": "{colorBackgroundContainerHeader}",
            "dark": "{colorBackgroundContainerHeader}"
          },
          "colorBackgroundTilesDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundToggleCheckedDisabled": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary700}"
          },
          "colorBackgroundToggleDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundAvatarGenAi": {
            "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
            "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
          },
          "colorBackgroundAvatarDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextAvatar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBackgroundLoadingBarGenAi": {
            "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
            "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
          },
          "colorBackgroundStatusIndicatorError": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorWarning": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorSuccess": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorInfo": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorNeutral": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleOutgoing": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleIncoming": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorTextChatBubbleOutgoing": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextChatBubbleIncoming": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorBorderButtonLinkDisabled": {
            "light": "{colorBackgroundButtonLinkDisabled}",
            "dark": "{colorBackgroundButtonLinkDisabled}"
          },
          "colorBorderButtonNormalActive": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderButtonNormalDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalPressed": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalDefault": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderToggleButtonNormalHover": {
            "light": "{colorBorderButtonNormalHover}",
            "dark": "{colorBorderButtonNormalHover}"
          },
          "colorBorderButtonNormalDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorTextButtonNormalDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonNormalHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral400}"
          },
          "colorTextButtonIconDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonPrimaryActive": {
            "light": "{colorBackgroundButtonPrimaryActive}",
            "dark": "{colorBackgroundButtonPrimaryActive}"
          },
          "colorBorderButtonPrimaryDefault": {
            "light": "{colorBackgroundButtonPrimaryDefault}",
            "dark": "{colorBackgroundButtonPrimaryDefault}"
          },
          "colorBorderButtonPrimaryDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderButtonPrimaryHover": {
            "light": "{colorBackgroundButtonPrimaryHover}",
            "dark": "{colorBackgroundButtonPrimaryHover}"
          },
          "colorTextButtonPrimaryDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorItemSelected": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextSideNavigationItemActive": {
            "light": "{colorTextAccent}",
            "dark": "{colorTextAccent}"
          },
          "colorTextSideNavigationItemActiveCollapsed": {
            "light": "{colorTextInverted}",
            "dark": "{colorTextInverted}"
          },
          "colorTextSideNavigationItemDefault": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorBorderCalendarGrid": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCalendarGridSelectedFocusRing": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderCellShaded": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderCodeEditorAceActiveLineLightTheme": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorBorderCodeEditorAceActiveLineDarkTheme": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorPaneItemHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderCard": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCardHighlighted": {
            "light": "{colorBorderItemSelected}",
            "dark": "{colorBorderItemSelected}"
          },
          "colorBorderItemCard": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderItemCardHighlighted": {
            "light": "{colorBorderCardHighlighted}",
            "dark": "{colorBorderCardHighlighted}"
          },
          "colorBorderContainerDivider": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderContainerTop": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderControlChecked": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBorderControlDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderControlDisabled": {
            "light": "{colorBackgroundControlDisabled}",
            "dark": "{colorBackgroundControlDisabled}"
          },
          "colorBorderDividerActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDividerDefault": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerNotification": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDividerPanelBottom": {
            "light": "{colorShadowSide}",
            "dark": "{colorShadowSide}"
          },
          "colorBorderDividerPanelSide": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDividerSecondary": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerTableGroup": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDropdownContainer": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDropdownGroup": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDropdownItemHover": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderDropdownItemDimmedHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderDropdownItemSelected": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemTop": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderEditableCellHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderInputDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderInputDisabled": {
            "light": "{colorBackgroundInputDisabled}",
            "dark": "{colorBackgroundInputDisabled}"
          },
          "colorBorderInputFocused": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderItemFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderDropdownItemFocused": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderItemPlaceholder": {
            "light": "{colorTransparent}",
            "dark": "{colorTransparent}"
          },
          "colorBorderItemSelected": {
            "light": "{colorItemSelected}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderLayout": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderLayoutSideNavigation": {
            "light": "{colorBorderLayout}",
            "dark": "{colorBorderLayout}"
          },
          "colorBorderNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderNotificationStackBarHover": {
            "light": "{colorBackgroundNotificationStackBarHover}",
            "dark": "{colorBackgroundNotificationStackBarHover}"
          },
          "colorBorderNotificationStackBarActive": {
            "light": "{colorBackgroundNotificationStackBar}",
            "dark": "{colorBackgroundNotificationStackBar}"
          },
          "colorBorderNotificationStackBarFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderPanelHeader": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderPopover": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral650}"
          },
          "colorBorderSegmentActive": {
            "light": "{colorBorderSegmentHover}",
            "dark": "{colorBorderSegmentHover}"
          },
          "colorBorderSegmentDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderSegmentDisabled": {
            "light": "{colorBorderButtonNormalDisabled}",
            "dark": "{colorBorderButtonNormalDisabled}"
          },
          "colorBorderSegmentDivider": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderSegmentHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorWhite}"
          },
          "colorBorderSegmentWrapper": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBorderStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo400}"
          },
          "colorBorderStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBorderStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorBorderDialog": {
            "light": "{colorBorderStatusInfo}",
            "dark": "{colorBorderStatusInfo}"
          },
          "colorBorderDialogDefault": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderDividerInteractiveDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderTabsDivider": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTabsShadow": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorGreyTransparent}"
          },
          "colorBorderTabsUnderline": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorBorderTilesDisabled": {
            "light": "{colorTransparent}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTutorial": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral500}"
          },
          "colorForegroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorForegroundControlDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral600}"
          },
          "colorForegroundControlReadOnly": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorShadowDefault": {
            "light": "{colorGreyTransparentHeavy}",
            "dark": "{colorGreyTransparentHeavy}"
          },
          "colorShadowMedium": {
            "light": "{colorGreyTransparent}",
            "dark": "{colorGreyTransparent}"
          },
          "colorShadowSide": {
            "light": "{colorGreyTransparentLight}",
            "dark": "{colorGreyTransparentLight}"
          },
          "colorShadowToggleHandle": {
            "light": "rgba(0, 0, 0, 0.25)",
            "dark": "rgba(0, 0, 0, 0.25)"
          },
          "colorStrokeChartLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorStrokeCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorStrokeCodeEditorGutterActiveLineHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral950}"
          },
          "colorTextAccent": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextBodyDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBodySecondary": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbCurrent": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextButtonInlineIconDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonInlineLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonNormalActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonNormalPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextButtonNormalDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextButtonNormalHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextLinkButtonNormalDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextLinkButtonNormalHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextLinkButtonNormalActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextButtonLinkDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonPrimaryActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryHover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCalendarDateHover": {
            "light": "{colorTextDropdownItemHighlighted}",
            "dark": "{colorTextDropdownItemHighlighted}"
          },
          "colorTextCalendarDateSelected": {
            "light": "{colorBackgroundControlDefault}",
            "dark": "{colorBackgroundControlDefault}"
          },
          "colorTextCalendarMonth": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextCodeEditorGutterActiveLine": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCodeEditorGutterDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextCodeEditorStatusBarDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextCodeEditorTabButtonError": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextColumnHeader": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextColumnSortingIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextControlDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextCounter": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextDisabledInlineEdit": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDropdownFooter": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownGroupLabel": {
            "light": "{colorTextGroupLabel}",
            "dark": "{colorTextGroupLabel}"
          },
          "colorTextDropdownItemDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextDropdownItemDimmed": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemFilterMatch": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextDropdownItemHighlighted": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextDropdownItemSecondary": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownItemSecondaryHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextEmpty": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextExpandableSectionDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextExpandableSectionHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextExpandableSectionNavigationIconDefault": {
            "light": "{colorTextIconCaret}",
            "dark": "{colorTextIconCaret}"
          },
          "colorBorderExpandableSectionDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorTextFormDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextFormLabel": {
            "light": "{colorTextFormDefault}",
            "dark": "{colorTextFormDefault}"
          },
          "colorTextFormSecondary": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextGroupLabel": {
            "light": "{colorTextLabel}",
            "dark": "{colorTextLabel}"
          },
          "colorTextLabelGenAi": {
            "light": "{colorPurple700}",
            "dark": "{colorPurple400}"
          },
          "colorTextHeadingDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHeadingSecondary": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextHomeHeaderDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHomeHeaderSecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextIconCaret": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral450}"
          },
          "colorTextIconSubtle": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral400}"
          },
          "colorTextInputDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInputPlaceholder": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorTextInputPlaceholderDisabled": {
            "light": "{colorTextInputPlaceholder}",
            "dark": "{colorTextInputPlaceholder}"
          },
          "colorTextInteractiveActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInteractiveHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonIconPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveInvertedDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveInvertedHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInverted": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLabel": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextKeyValuePairsValue": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextLayoutToggle": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextLayoutToggleActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextLayoutToggleHover": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextLayoutToggleSelected": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLinkDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextLinkHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary200}"
          },
          "colorTextLinkDecorationDefault": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkDecorationHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkSecondaryDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkSecondaryHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkSecondaryDecorationDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextLinkInfoDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkInfoHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkInvertedDefault": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkInvertedHover": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkButtonUnderline": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkButtonUnderlineHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextNotificationDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextAlertDefault": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextNotificationLinkDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextNotificationLinkHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextNotificationStackBar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextNotificationYellow": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextPaginationPageNumberActiveDisabled": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextPaginationPageNumberDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextSegmentActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextSegmentDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextSegmentHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextSmall": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextFlashbarIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextFlashbarIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextFlashbarIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextFlashbarIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextAlertIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextAlertIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextAlertIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextAlertIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorTextStatusInactive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess500}"
          },
          "colorTextStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorTextTopNavigationTitle": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextTutorialHotspotDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextTutorialHotspotHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorBoardPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBoardPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDragPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorDragPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDropzoneBackgroundDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorDropzoneBackgroundHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorDropzoneTextDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneTextHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneBorderDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorDropzoneBorderHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorGapGlobalDrawer": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorTreeViewConnectorLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral300}"
          },
          "colorBackgroundActionCardDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundActionCardHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundActionCardActive": {
            "light": "{colorPrimary100}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderActionCardDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderActionCardHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundActionCardDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral800}"
          },
          "colorTextActionCardDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorTextActionCardIconDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextActionCardIconHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeleton": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeletonWave": {
            "light": "{colorNeutral150}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundBadgeGreen": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundBadgeBlue": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundBadgeRed": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundBadgeYellow": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundBadgeGrey": {
            "light": "{colorBackgroundNotificationGrey}",
            "dark": "{colorBackgroundNotificationGrey}"
          },
          "colorBorderBadge": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGrey": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGreen": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeBlue": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeRed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextBadgeGrey": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeGreen": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeBlue": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeRed": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorBackgroundCodeView": {
            "light": "#f8f8f8",
            "dark": "#282c34"
          },
          "colorBackgroundVisualAccentRed": {
            "light": "#ffe0e0",
            "dark": "rgba(255, 61, 61, 0.2)"
          },
          "colorBackgroundVisualAccentYellow": {
            "light": "#fffbbd",
            "dark": "rgba(251, 211, 50, 0.2)"
          },
          "colorBackgroundVisualAccentIndigo": {
            "light": "#dbe4ff",
            "dark": "rgba(92, 127, 255, 0.2)"
          },
          "colorBackgroundVisualAccentGreen": {
            "light": "#d9ffd6",
            "dark": "rgba(43, 181, 52, 0.2)"
          },
          "colorBackgroundVisualAccentOrange": {
            "light": "rgba(255, 224, 214, 0.6)",
            "dark": "rgba(255, 75, 20, 0.2)"
          },
          "colorBackgroundVisualAccentPurple": {
            "light": "rgba(242, 229, 255, 0.6)",
            "dark": "rgba(173, 92, 255, 0.2)"
          },
          "colorBackgroundVisualAccentLime": {
            "light": "{colorLime100}",
            "dark": "rgba(49, 184, 0, 0.2)"
          },
          "colorBackgroundVisualAccentGrey": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundVisualAccentTeal": {
            "light": "rgba(204, 255, 252, 0.7)",
            "dark": "rgba(0, 173, 162, 0.2)"
          },
          "colorBackgroundVisualAccentBlue": {
            "light": "rgba(209, 241, 255, 0.6)",
            "dark": "rgba(0, 153, 255, 0.2)"
          },
          "colorBackgroundVisualAccentViolet": {
            "light": "rgba(232, 229, 255, 0.6)",
            "dark": "rgba(133, 117, 255, 0.2)"
          },
          "colorBackgroundVisualAccentMagenta": {
            "light": "rgba(255, 224, 251, 0.6)",
            "dark": "rgba(255, 26, 224, 0.2)"
          },
          "colorBackgroundVisualAccentPink": {
            "light": "rgba(255, 224, 240, 0.7)",
            "dark": "rgba(255, 51, 153, 0.2)"
          },
          "colorBackgroundVisualAccentAmber": {
            "light": "rgba(255, 232, 189, 0.7)",
            "dark": "rgba(250, 111, 0, 0.2)"
          },
          "colorTextVisualAccentRed": {
            "light": "{colorError700}",
            "dark": "{colorError400}"
          },
          "colorTextVisualAccentYellow": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning200}"
          },
          "colorTextVisualAccentIndigo": {
            "light": "{colorInfo800}",
            "dark": "{colorInfo300}"
          },
          "colorTextVisualAccentGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess200}"
          },
          "colorTextVisualAccentOrange": {
            "light": "#a82700",
            "dark": "#ff997a"
          },
          "colorTextVisualAccentPurple": {
            "light": "#962eff",
            "dark": "#d4a8ff"
          },
          "colorTextVisualAccentLime": {
            "light": "#007000",
            "dark": "#acff2e"
          },
          "colorTextVisualAccentGrey": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral300}"
          },
          "colorTextVisualAccentTeal": {
            "light": "#008077",
            "dark": "#00f5e4"
          },
          "colorTextVisualAccentBlue": {
            "light": "#006ce0",
            "dark": "#75cfff"
          },
          "colorTextVisualAccentViolet": {
            "light": "#6842ff",
            "dark": "#b2a8ff"
          },
          "colorTextVisualAccentMagenta": {
            "light": "#b2008f",
            "dark": "#ff57e9"
          },
          "colorTextVisualAccentPink": {
            "light": "#bb005d",
            "dark": "#ff99cc"
          },
          "colorTextVisualAccentAmber": {
            "light": "#9e3700",
            "dark": "#ffbb45"
          }
        }
      },
      "flashbar": {
        "id": "flashbar",
        "selector": ".awsui-context-flashbar:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
        "tokens": {
          "colorGreyOpaque10": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(0, 0, 0, 0.1)"
          },
          "colorGreyOpaque25": {
            "light": "rgba(255, 255, 255, 0.25)",
            "dark": "rgba(255, 255, 255, 0.25)"
          },
          "colorGreyOpaque40": {
            "light": "rgba(0, 0, 0, 0.4)",
            "dark": "rgba(0, 0, 0, 0.4)"
          },
          "colorGreyOpaque50": {
            "light": "rgba(0, 0, 0, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyOpaque70": {
            "light": "rgba(255, 255, 255, 0.7)",
            "dark": "rgba(255, 255, 255, 0.7)"
          },
          "colorGreyOpaque80": {
            "light": "rgba(22, 25, 31, 0.8)",
            "dark": "rgba(22, 25, 31, 0.8)"
          },
          "colorGreyOpaque90": {
            "light": "rgba(242, 243, 243, 0.9)",
            "dark": "rgba(242, 243, 243, 0.9)"
          },
          "colorGreyTransparent": {
            "light": "rgba(0, 28, 36, 0.3)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorGreyTransparentHeavy": {
            "light": "rgba(0, 28, 36, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyTransparentLight": {
            "light": "rgba(0, 28, 36, 0.15)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorBackgroundBadgeIcon": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorBackgroundButtonLinkActive": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonLinkDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkDisabled": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundButtonNormalActive": {
            "light": "rgba(0, 7, 22, 0.2)",
            "dark": "rgba(0, 7, 22, 0.2)"
          },
          "colorBackgroundButtonNormalDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonNormalDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalHover": {
            "light": "rgba(0, 7, 22, 0.15)",
            "dark": "rgba(0, 7, 22, 0.15)"
          },
          "colorBackgroundToggleButtonNormalPressed": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundToggleButtonNormalDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundToggleButtonNormalHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundButtonPrimaryActive": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonPrimaryHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundDirectionButtonActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundDirectionButtonDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorTextDirectionButtonDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextDirectionButtonDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorBackgroundCalendarCurrentDate": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCellShaded": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundCodeEditorGutterActiveLineError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundCodeEditorGutterDefault": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCodeEditorLoading": {
            "light": "{colorBackgroundCodeEditorStatusBar}",
            "dark": "{colorBackgroundCodeEditorStatusBar}"
          },
          "colorBackgroundCodeEditorPaneItemHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundCodeEditorStatusBar": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCard": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundItemCard": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundContainerContent": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundContainerHeader": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundControlChecked": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundControlDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDropdownItemDimmed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundDropdownItemFilterMatch": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundDropdownItemHover": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemSelected": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundHomeHeader": {
            "light": "{colorBlack}",
            "dark": "{colorBlack}"
          },
          "colorBackgroundInlineCode": {
            "light": "rgba(0, 0, 0, 0.2)",
            "dark": "rgba(0, 0, 0, 0.2)"
          },
          "colorBackgroundInputDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundInputDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundItemSelected": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundSideNavigationItemActive": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundSideNavigationItemActiveCollapsed": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBackgroundSideNavigationItemIconHover": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundLayoutMain": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundLayoutAiDrawer": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundDrawer": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundBackdrop": {
            "light": "{colorGreyOpaque90}",
            "dark": "{colorGreyOpaque80}"
          },
          "colorBackgroundDrawerBackdrop": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundLayoutMobilePanel": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutPanel": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelContent": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundLayoutToolbar": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutToggleActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundLayoutToggleDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundLayoutToggleHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundLayoutToggleSelectedActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundLayoutToggleSelectedDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundLayoutToggleSelectedHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundModalOverlay": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundNotificationBlue": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo600}"
          },
          "colorBackgroundNotificationGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBackgroundNotificationGrey": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundNotificationRed": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBackgroundNotificationYellow": {
            "light": "{colorWarning400}",
            "dark": "{colorWarning400}"
          },
          "colorBackgroundFlashbarSuccess": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundFlashbarError": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundFlashbarInfo": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundFlashbarWarning": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundPopover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundProgressBarValueDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBackgroundProgressBarValueFlash": {
            "light": "{colorBackgroundProgressBarValueDefault}",
            "dark": "{colorBackgroundProgressBarValueDefault}"
          },
          "colorBackgroundProgressBarFlash": {
            "light": "{colorBackgroundProgressBarDefault}",
            "dark": "{colorBackgroundProgressBarDefault}"
          },
          "colorBackgroundProgressBarDefault": {
            "light": "{colorGreyOpaque25}",
            "dark": "{colorGreyOpaque25}"
          },
          "colorBackgroundSegmentActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSegmentDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundSegmentDisabled": {
            "light": "{colorBackgroundButtonNormalDisabled}",
            "dark": "{colorBackgroundButtonNormalDisabled}"
          },
          "colorBackgroundSegmentHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundSegmentWrapper": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundSliderRangeDefault": {
            "light": "{colorBackgroundSliderHandleDefault}",
            "dark": "{colorBackgroundSliderHandleDefault}"
          },
          "colorBackgroundSliderRangeActive": {
            "light": "{colorBackgroundSliderHandleActive}",
            "dark": "{colorBackgroundSliderHandleActive}"
          },
          "colorBackgroundSliderHandleDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSliderHandleActive": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundSliderTrackDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSliderHandleRing": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundSliderHandleErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderHandleWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundStatusError": {
            "light": "{colorError50}",
            "dark": "{colorError1000}"
          },
          "colorBackgroundStatusInfo": {
            "light": "{colorInfo50}",
            "dark": "{colorInfo1000}"
          },
          "colorBackgroundAlertError": {
            "light": "{colorBackgroundStatusError}",
            "dark": "{colorBackgroundStatusError}"
          },
          "colorBackgroundAlertInfo": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundAlertSuccess": {
            "light": "{colorBackgroundStatusSuccess}",
            "dark": "{colorBackgroundStatusSuccess}"
          },
          "colorBackgroundAlertWarning": {
            "light": "{colorBackgroundStatusWarning}",
            "dark": "{colorBackgroundStatusWarning}"
          },
          "colorBackgroundDialog": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundDialogDefault": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundStatusSuccess": {
            "light": "{colorSuccess50}",
            "dark": "{colorSuccess1000}"
          },
          "colorBackgroundStatusWarning": {
            "light": "{colorWarning50}",
            "dark": "{colorWarning1000}"
          },
          "colorBackgroundTableHeader": {
            "light": "{colorBackgroundContainerHeader}",
            "dark": "{colorBackgroundContainerHeader}"
          },
          "colorBackgroundTilesDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundToggleCheckedDisabled": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary700}"
          },
          "colorBackgroundToggleDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundAvatarGenAi": {
            "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
            "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
          },
          "colorBackgroundAvatarDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextAvatar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBackgroundLoadingBarGenAi": {
            "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
            "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
          },
          "colorBackgroundStatusIndicatorError": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorWarning": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorSuccess": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorInfo": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorNeutral": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleOutgoing": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleIncoming": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorTextChatBubbleOutgoing": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextChatBubbleIncoming": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorBorderButtonLinkDisabled": {
            "light": "{colorBackgroundButtonLinkDisabled}",
            "dark": "{colorBackgroundButtonLinkDisabled}"
          },
          "colorBorderButtonNormalActive": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBorderButtonNormalDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderToggleButtonNormalPressed": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalDefault": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderToggleButtonNormalHover": {
            "light": "{colorBorderButtonNormalHover}",
            "dark": "{colorBorderButtonNormalHover}"
          },
          "colorBorderButtonNormalDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorTextButtonNormalDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonNormalHover": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextButtonIconDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonPrimaryActive": {
            "light": "{colorBackgroundButtonPrimaryActive}",
            "dark": "{colorBackgroundButtonPrimaryActive}"
          },
          "colorBorderButtonPrimaryDefault": {
            "light": "{colorBackgroundButtonPrimaryDefault}",
            "dark": "{colorBackgroundButtonPrimaryDefault}"
          },
          "colorBorderButtonPrimaryDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderButtonPrimaryHover": {
            "light": "{colorBackgroundButtonPrimaryHover}",
            "dark": "{colorBackgroundButtonPrimaryHover}"
          },
          "colorTextButtonPrimaryDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorItemSelected": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextSideNavigationItemActive": {
            "light": "{colorTextAccent}",
            "dark": "{colorTextAccent}"
          },
          "colorTextSideNavigationItemActiveCollapsed": {
            "light": "{colorTextInverted}",
            "dark": "{colorTextInverted}"
          },
          "colorTextSideNavigationItemDefault": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorBorderCalendarGrid": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCalendarGridSelectedFocusRing": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderCellShaded": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderCodeEditorAceActiveLineLightTheme": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorBorderCodeEditorAceActiveLineDarkTheme": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorPaneItemHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderCard": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCardHighlighted": {
            "light": "{colorBorderItemSelected}",
            "dark": "{colorBorderItemSelected}"
          },
          "colorBorderItemCard": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderItemCardHighlighted": {
            "light": "{colorBorderCardHighlighted}",
            "dark": "{colorBorderCardHighlighted}"
          },
          "colorBorderContainerDivider": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderContainerTop": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderControlChecked": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBorderControlDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderControlDisabled": {
            "light": "{colorBackgroundControlDisabled}",
            "dark": "{colorBackgroundControlDisabled}"
          },
          "colorBorderDividerActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDividerDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderDividerNotification": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDividerPanelBottom": {
            "light": "{colorShadowSide}",
            "dark": "{colorShadowSide}"
          },
          "colorBorderDividerPanelSide": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDividerSecondary": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerTableGroup": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDropdownContainer": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDropdownGroup": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDropdownItemHover": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderDropdownItemDimmedHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderDropdownItemSelected": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemTop": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderEditableCellHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderInputDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderInputDisabled": {
            "light": "{colorBackgroundInputDisabled}",
            "dark": "{colorBackgroundInputDisabled}"
          },
          "colorBorderInputFocused": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderItemFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderDropdownItemFocused": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderItemPlaceholder": {
            "light": "{colorTransparent}",
            "dark": "{colorTransparent}"
          },
          "colorBorderItemSelected": {
            "light": "{colorItemSelected}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderLayout": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderLayoutSideNavigation": {
            "light": "{colorBorderLayout}",
            "dark": "{colorBorderLayout}"
          },
          "colorBorderNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderNotificationStackBarHover": {
            "light": "{colorBackgroundNotificationStackBarHover}",
            "dark": "{colorBackgroundNotificationStackBarHover}"
          },
          "colorBorderNotificationStackBarActive": {
            "light": "{colorBackgroundNotificationStackBar}",
            "dark": "{colorBackgroundNotificationStackBar}"
          },
          "colorBorderNotificationStackBarFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderPanelHeader": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderPopover": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral650}"
          },
          "colorBorderSegmentActive": {
            "light": "{colorBorderSegmentHover}",
            "dark": "{colorBorderSegmentHover}"
          },
          "colorBorderSegmentDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderSegmentDisabled": {
            "light": "{colorBorderButtonNormalDisabled}",
            "dark": "{colorBorderButtonNormalDisabled}"
          },
          "colorBorderSegmentDivider": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderSegmentHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorWhite}"
          },
          "colorBorderSegmentWrapper": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBorderStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo400}"
          },
          "colorBorderStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBorderStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorBorderDialog": {
            "light": "{colorBorderStatusInfo}",
            "dark": "{colorBorderStatusInfo}"
          },
          "colorBorderDialogDefault": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderDividerInteractiveDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderTabsDivider": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTabsShadow": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorGreyTransparent}"
          },
          "colorBorderTabsUnderline": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorBorderTilesDisabled": {
            "light": "{colorTransparent}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTutorial": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral500}"
          },
          "colorForegroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorForegroundControlDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral600}"
          },
          "colorForegroundControlReadOnly": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorShadowDefault": {
            "light": "{colorGreyTransparentHeavy}",
            "dark": "{colorGreyTransparentHeavy}"
          },
          "colorShadowMedium": {
            "light": "{colorGreyTransparent}",
            "dark": "{colorGreyTransparent}"
          },
          "colorShadowSide": {
            "light": "{colorGreyTransparentLight}",
            "dark": "{colorGreyTransparentLight}"
          },
          "colorShadowToggleHandle": {
            "light": "rgba(0, 0, 0, 0.25)",
            "dark": "rgba(0, 0, 0, 0.25)"
          },
          "colorStrokeChartLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorStrokeCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorStrokeCodeEditorGutterActiveLineHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral950}"
          },
          "colorTextAccent": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextBodyDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextBodySecondary": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextBreadcrumbCurrent": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextButtonInlineIconDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonInlineLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonNormalActive": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextToggleButtonNormalPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextButtonNormalDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextButtonNormalHover": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextLinkButtonNormalDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextLinkButtonNormalHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextLinkButtonNormalActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextButtonLinkDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonPrimaryActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryHover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCalendarDateHover": {
            "light": "{colorTextDropdownItemHighlighted}",
            "dark": "{colorTextDropdownItemHighlighted}"
          },
          "colorTextCalendarDateSelected": {
            "light": "{colorBackgroundControlDefault}",
            "dark": "{colorBackgroundControlDefault}"
          },
          "colorTextCalendarMonth": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextCodeEditorGutterActiveLine": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCodeEditorGutterDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextCodeEditorStatusBarDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextCodeEditorTabButtonError": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextColumnHeader": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextColumnSortingIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextControlDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextCounter": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextDisabledInlineEdit": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDropdownFooter": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownGroupLabel": {
            "light": "{colorTextGroupLabel}",
            "dark": "{colorTextGroupLabel}"
          },
          "colorTextDropdownItemDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextDropdownItemDimmed": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemFilterMatch": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextDropdownItemHighlighted": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextDropdownItemSecondary": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownItemSecondaryHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextEmpty": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextExpandableSectionDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextExpandableSectionHover": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextExpandableSectionNavigationIconDefault": {
            "light": "{colorTextIconCaret}",
            "dark": "{colorTextIconCaret}"
          },
          "colorBorderExpandableSectionDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorTextFormDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextFormLabel": {
            "light": "{colorTextFormDefault}",
            "dark": "{colorTextFormDefault}"
          },
          "colorTextFormSecondary": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextGroupLabel": {
            "light": "{colorTextLabel}",
            "dark": "{colorTextLabel}"
          },
          "colorTextLabelGenAi": {
            "light": "{colorPurple700}",
            "dark": "{colorPurple400}"
          },
          "colorTextHeadingDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHeadingSecondary": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextHomeHeaderDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHomeHeaderSecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextIconCaret": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral450}"
          },
          "colorTextIconSubtle": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral400}"
          },
          "colorTextInputDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInputPlaceholder": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorTextInputPlaceholderDisabled": {
            "light": "{colorTextInputPlaceholder}",
            "dark": "{colorTextInputPlaceholder}"
          },
          "colorTextInteractiveActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInteractiveHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonIconPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveInvertedDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveInvertedHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInverted": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLabel": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextKeyValuePairsValue": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextLayoutToggle": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextLayoutToggleActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextLayoutToggleHover": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextLayoutToggleSelected": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLinkDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextLinkHover": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextLinkDecorationDefault": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkDecorationHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkSecondaryDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkSecondaryHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkSecondaryDecorationDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextLinkInfoDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkInfoHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkInvertedDefault": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkInvertedHover": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkButtonUnderline": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkButtonUnderlineHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextNotificationDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextAlertDefault": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextNotificationLinkDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextNotificationLinkHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextNotificationStackBar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextNotificationYellow": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextPaginationPageNumberActiveDisabled": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextPaginationPageNumberDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextSegmentActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextSegmentDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextSegmentHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextSmall": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextFlashbarIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextFlashbarIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextFlashbarIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextFlashbarIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextAlertIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextAlertIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextAlertIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextAlertIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextStatusError": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextStatusInactive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextStatusInfo": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextStatusSuccess": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorTextTopNavigationTitle": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextTutorialHotspotDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextTutorialHotspotHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBoardPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBoardPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDragPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorDragPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDropzoneBackgroundDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorDropzoneBackgroundHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorDropzoneTextDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneTextHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneBorderDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorDropzoneBorderHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorGapGlobalDrawer": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorTreeViewConnectorLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral300}"
          },
          "colorBackgroundActionCardDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundActionCardHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundActionCardActive": {
            "light": "{colorPrimary100}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderActionCardDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderActionCardHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundActionCardDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral800}"
          },
          "colorTextActionCardDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorTextActionCardIconDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextActionCardIconHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeleton": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeletonWave": {
            "light": "{colorNeutral150}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundBadgeGreen": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundBadgeBlue": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundBadgeRed": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundBadgeYellow": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundBadgeGrey": {
            "light": "{colorBackgroundNotificationGrey}",
            "dark": "{colorBackgroundNotificationGrey}"
          },
          "colorBorderBadge": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGrey": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGreen": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeBlue": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeRed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextBadgeGrey": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeGreen": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeBlue": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeRed": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorBackgroundCodeView": {
            "light": "#f8f8f8",
            "dark": "#282c34"
          },
          "colorBackgroundVisualAccentRed": {
            "light": "#ffe0e0",
            "dark": "rgba(255, 61, 61, 0.2)"
          },
          "colorBackgroundVisualAccentYellow": {
            "light": "#fffbbd",
            "dark": "rgba(251, 211, 50, 0.2)"
          },
          "colorBackgroundVisualAccentIndigo": {
            "light": "#dbe4ff",
            "dark": "rgba(92, 127, 255, 0.2)"
          },
          "colorBackgroundVisualAccentGreen": {
            "light": "#d9ffd6",
            "dark": "rgba(43, 181, 52, 0.2)"
          },
          "colorBackgroundVisualAccentOrange": {
            "light": "rgba(255, 224, 214, 0.6)",
            "dark": "rgba(255, 75, 20, 0.2)"
          },
          "colorBackgroundVisualAccentPurple": {
            "light": "rgba(242, 229, 255, 0.6)",
            "dark": "rgba(173, 92, 255, 0.2)"
          },
          "colorBackgroundVisualAccentLime": {
            "light": "{colorLime100}",
            "dark": "rgba(49, 184, 0, 0.2)"
          },
          "colorBackgroundVisualAccentGrey": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundVisualAccentTeal": {
            "light": "rgba(204, 255, 252, 0.7)",
            "dark": "rgba(0, 173, 162, 0.2)"
          },
          "colorBackgroundVisualAccentBlue": {
            "light": "rgba(209, 241, 255, 0.6)",
            "dark": "rgba(0, 153, 255, 0.2)"
          },
          "colorBackgroundVisualAccentViolet": {
            "light": "rgba(232, 229, 255, 0.6)",
            "dark": "rgba(133, 117, 255, 0.2)"
          },
          "colorBackgroundVisualAccentMagenta": {
            "light": "rgba(255, 224, 251, 0.6)",
            "dark": "rgba(255, 26, 224, 0.2)"
          },
          "colorBackgroundVisualAccentPink": {
            "light": "rgba(255, 224, 240, 0.7)",
            "dark": "rgba(255, 51, 153, 0.2)"
          },
          "colorBackgroundVisualAccentAmber": {
            "light": "rgba(255, 232, 189, 0.7)",
            "dark": "rgba(250, 111, 0, 0.2)"
          },
          "colorTextVisualAccentRed": {
            "light": "{colorError700}",
            "dark": "{colorError400}"
          },
          "colorTextVisualAccentYellow": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning200}"
          },
          "colorTextVisualAccentIndigo": {
            "light": "{colorInfo800}",
            "dark": "{colorInfo300}"
          },
          "colorTextVisualAccentGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess200}"
          },
          "colorTextVisualAccentOrange": {
            "light": "#a82700",
            "dark": "#ff997a"
          },
          "colorTextVisualAccentPurple": {
            "light": "#962eff",
            "dark": "#d4a8ff"
          },
          "colorTextVisualAccentLime": {
            "light": "#007000",
            "dark": "#acff2e"
          },
          "colorTextVisualAccentGrey": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral300}"
          },
          "colorTextVisualAccentTeal": {
            "light": "#008077",
            "dark": "#00f5e4"
          },
          "colorTextVisualAccentBlue": {
            "light": "#006ce0",
            "dark": "#75cfff"
          },
          "colorTextVisualAccentViolet": {
            "light": "#6842ff",
            "dark": "#b2a8ff"
          },
          "colorTextVisualAccentMagenta": {
            "light": "#b2008f",
            "dark": "#ff57e9"
          },
          "colorTextVisualAccentPink": {
            "light": "#bb005d",
            "dark": "#ff99cc"
          },
          "colorTextVisualAccentAmber": {
            "light": "#9e3700",
            "dark": "#ffbb45"
          }
        }
      },
      "flashbar-warning": {
        "id": "flashbar-warning",
        "selector": ".awsui-context-flashbar-warning:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
        "tokens": {
          "colorGreyOpaque10": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(0, 0, 0, 0.1)"
          },
          "colorGreyOpaque25": {
            "light": "rgba(255, 255, 255, 0.25)",
            "dark": "rgba(255, 255, 255, 0.25)"
          },
          "colorGreyOpaque40": {
            "light": "rgba(0, 0, 0, 0.4)",
            "dark": "rgba(0, 0, 0, 0.4)"
          },
          "colorGreyOpaque50": {
            "light": "rgba(0, 0, 0, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyOpaque70": {
            "light": "rgba(255, 255, 255, 0.7)",
            "dark": "rgba(255, 255, 255, 0.7)"
          },
          "colorGreyOpaque80": {
            "light": "rgba(22, 25, 31, 0.8)",
            "dark": "rgba(22, 25, 31, 0.8)"
          },
          "colorGreyOpaque90": {
            "light": "rgba(242, 243, 243, 0.9)",
            "dark": "rgba(242, 243, 243, 0.9)"
          },
          "colorGreyTransparent": {
            "light": "rgba(0, 28, 36, 0.3)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorGreyTransparentHeavy": {
            "light": "rgba(0, 28, 36, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyTransparentLight": {
            "light": "rgba(0, 28, 36, 0.15)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorBackgroundBadgeIcon": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorBackgroundButtonLinkActive": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonLinkDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkDisabled": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundButtonNormalActive": {
            "light": "rgba(0, 7, 22, 0.1)",
            "dark": "rgba(0, 7, 22, 0.1)"
          },
          "colorBackgroundButtonNormalDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonNormalDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalHover": {
            "light": "rgba(0, 7, 22, 0.05)",
            "dark": "rgba(0, 7, 22, 0.05)"
          },
          "colorBackgroundToggleButtonNormalPressed": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundToggleButtonNormalDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundToggleButtonNormalHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundButtonPrimaryActive": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonPrimaryHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundDirectionButtonActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundDirectionButtonDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorTextDirectionButtonDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextDirectionButtonDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorBackgroundCalendarCurrentDate": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCellShaded": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundCodeEditorGutterActiveLineError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundCodeEditorGutterDefault": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCodeEditorLoading": {
            "light": "{colorBackgroundCodeEditorStatusBar}",
            "dark": "{colorBackgroundCodeEditorStatusBar}"
          },
          "colorBackgroundCodeEditorPaneItemHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundCodeEditorStatusBar": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCard": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundItemCard": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundContainerContent": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundContainerHeader": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundControlChecked": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundControlDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDropdownItemDimmed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundDropdownItemFilterMatch": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundDropdownItemHover": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemSelected": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundHomeHeader": {
            "light": "{colorBlack}",
            "dark": "{colorBlack}"
          },
          "colorBackgroundInlineCode": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(0, 0, 0, 0.1)"
          },
          "colorBackgroundInputDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundInputDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundItemSelected": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundSideNavigationItemActive": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundSideNavigationItemActiveCollapsed": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBackgroundSideNavigationItemIconHover": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundLayoutMain": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundLayoutAiDrawer": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundDrawer": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundBackdrop": {
            "light": "{colorGreyOpaque90}",
            "dark": "{colorGreyOpaque80}"
          },
          "colorBackgroundDrawerBackdrop": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundLayoutMobilePanel": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutPanel": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelContent": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundLayoutToolbar": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutToggleActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundLayoutToggleDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundLayoutToggleHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundLayoutToggleSelectedActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundLayoutToggleSelectedDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundLayoutToggleSelectedHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundModalOverlay": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundNotificationBlue": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo600}"
          },
          "colorBackgroundNotificationGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBackgroundNotificationGrey": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundNotificationRed": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBackgroundNotificationYellow": {
            "light": "{colorWarning400}",
            "dark": "{colorWarning400}"
          },
          "colorBackgroundFlashbarSuccess": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundFlashbarError": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundFlashbarInfo": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundFlashbarWarning": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundPopover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundProgressBarValueDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundProgressBarValueFlash": {
            "light": "{colorBackgroundProgressBarValueDefault}",
            "dark": "{colorBackgroundProgressBarValueDefault}"
          },
          "colorBackgroundProgressBarFlash": {
            "light": "{colorBackgroundProgressBarDefault}",
            "dark": "{colorBackgroundProgressBarDefault}"
          },
          "colorBackgroundProgressBarDefault": {
            "light": "{colorGreyOpaque10}",
            "dark": "{colorGreyOpaque10}"
          },
          "colorBackgroundSegmentActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSegmentDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundSegmentDisabled": {
            "light": "{colorBackgroundButtonNormalDisabled}",
            "dark": "{colorBackgroundButtonNormalDisabled}"
          },
          "colorBackgroundSegmentHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundSegmentWrapper": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundSliderRangeDefault": {
            "light": "{colorBackgroundSliderHandleDefault}",
            "dark": "{colorBackgroundSliderHandleDefault}"
          },
          "colorBackgroundSliderRangeActive": {
            "light": "{colorBackgroundSliderHandleActive}",
            "dark": "{colorBackgroundSliderHandleActive}"
          },
          "colorBackgroundSliderHandleDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSliderHandleActive": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundSliderTrackDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSliderHandleRing": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundSliderHandleErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderHandleWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundStatusError": {
            "light": "{colorError50}",
            "dark": "{colorError1000}"
          },
          "colorBackgroundStatusInfo": {
            "light": "{colorInfo50}",
            "dark": "{colorInfo1000}"
          },
          "colorBackgroundAlertError": {
            "light": "{colorBackgroundStatusError}",
            "dark": "{colorBackgroundStatusError}"
          },
          "colorBackgroundAlertInfo": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundAlertSuccess": {
            "light": "{colorBackgroundStatusSuccess}",
            "dark": "{colorBackgroundStatusSuccess}"
          },
          "colorBackgroundAlertWarning": {
            "light": "{colorBackgroundStatusWarning}",
            "dark": "{colorBackgroundStatusWarning}"
          },
          "colorBackgroundDialog": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundDialogDefault": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundStatusSuccess": {
            "light": "{colorSuccess50}",
            "dark": "{colorSuccess1000}"
          },
          "colorBackgroundStatusWarning": {
            "light": "{colorWarning50}",
            "dark": "{colorWarning1000}"
          },
          "colorBackgroundTableHeader": {
            "light": "{colorBackgroundContainerHeader}",
            "dark": "{colorBackgroundContainerHeader}"
          },
          "colorBackgroundTilesDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundToggleCheckedDisabled": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary700}"
          },
          "colorBackgroundToggleDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundAvatarGenAi": {
            "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
            "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
          },
          "colorBackgroundAvatarDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextAvatar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBackgroundLoadingBarGenAi": {
            "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
            "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
          },
          "colorBackgroundStatusIndicatorError": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorWarning": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorSuccess": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorInfo": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorNeutral": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleOutgoing": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleIncoming": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorTextChatBubbleOutgoing": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextChatBubbleIncoming": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorBorderButtonLinkDisabled": {
            "light": "{colorBackgroundButtonLinkDisabled}",
            "dark": "{colorBackgroundButtonLinkDisabled}"
          },
          "colorBorderButtonNormalActive": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorBorderButtonNormalDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorBorderToggleButtonNormalPressed": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalDefault": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderToggleButtonNormalHover": {
            "light": "{colorBorderButtonNormalHover}",
            "dark": "{colorBorderButtonNormalHover}"
          },
          "colorBorderButtonNormalDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorTextButtonNormalDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonNormalHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonIconDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonPrimaryActive": {
            "light": "{colorBackgroundButtonPrimaryActive}",
            "dark": "{colorBackgroundButtonPrimaryActive}"
          },
          "colorBorderButtonPrimaryDefault": {
            "light": "{colorBackgroundButtonPrimaryDefault}",
            "dark": "{colorBackgroundButtonPrimaryDefault}"
          },
          "colorBorderButtonPrimaryDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderButtonPrimaryHover": {
            "light": "{colorBackgroundButtonPrimaryHover}",
            "dark": "{colorBackgroundButtonPrimaryHover}"
          },
          "colorTextButtonPrimaryDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorItemSelected": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextSideNavigationItemActive": {
            "light": "{colorTextAccent}",
            "dark": "{colorTextAccent}"
          },
          "colorTextSideNavigationItemActiveCollapsed": {
            "light": "{colorTextInverted}",
            "dark": "{colorTextInverted}"
          },
          "colorTextSideNavigationItemDefault": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorBorderCalendarGrid": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCalendarGridSelectedFocusRing": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderCellShaded": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderCodeEditorAceActiveLineLightTheme": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorBorderCodeEditorAceActiveLineDarkTheme": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorPaneItemHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderCard": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCardHighlighted": {
            "light": "{colorBorderItemSelected}",
            "dark": "{colorBorderItemSelected}"
          },
          "colorBorderItemCard": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderItemCardHighlighted": {
            "light": "{colorBorderCardHighlighted}",
            "dark": "{colorBorderCardHighlighted}"
          },
          "colorBorderContainerDivider": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderContainerTop": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderControlChecked": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBorderControlDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderControlDisabled": {
            "light": "{colorBackgroundControlDisabled}",
            "dark": "{colorBackgroundControlDisabled}"
          },
          "colorBorderDividerActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDividerDefault": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorBorderDividerNotification": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDividerPanelBottom": {
            "light": "{colorShadowSide}",
            "dark": "{colorShadowSide}"
          },
          "colorBorderDividerPanelSide": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDividerSecondary": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerTableGroup": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDropdownContainer": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDropdownGroup": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDropdownItemHover": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderDropdownItemDimmedHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderDropdownItemSelected": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemTop": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderEditableCellHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderInputDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderInputDisabled": {
            "light": "{colorBackgroundInputDisabled}",
            "dark": "{colorBackgroundInputDisabled}"
          },
          "colorBorderInputFocused": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderItemFocused": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorBorderDropdownItemFocused": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderItemPlaceholder": {
            "light": "{colorTransparent}",
            "dark": "{colorTransparent}"
          },
          "colorBorderItemSelected": {
            "light": "{colorItemSelected}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderLayout": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderLayoutSideNavigation": {
            "light": "{colorBorderLayout}",
            "dark": "{colorBorderLayout}"
          },
          "colorBorderNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderNotificationStackBarHover": {
            "light": "{colorBackgroundNotificationStackBarHover}",
            "dark": "{colorBackgroundNotificationStackBarHover}"
          },
          "colorBorderNotificationStackBarActive": {
            "light": "{colorBackgroundNotificationStackBar}",
            "dark": "{colorBackgroundNotificationStackBar}"
          },
          "colorBorderNotificationStackBarFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderPanelHeader": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderPopover": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral650}"
          },
          "colorBorderSegmentActive": {
            "light": "{colorBorderSegmentHover}",
            "dark": "{colorBorderSegmentHover}"
          },
          "colorBorderSegmentDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderSegmentDisabled": {
            "light": "{colorBorderButtonNormalDisabled}",
            "dark": "{colorBorderButtonNormalDisabled}"
          },
          "colorBorderSegmentDivider": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderSegmentHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorWhite}"
          },
          "colorBorderSegmentWrapper": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBorderStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo400}"
          },
          "colorBorderStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBorderStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorBorderDialog": {
            "light": "{colorBorderStatusInfo}",
            "dark": "{colorBorderStatusInfo}"
          },
          "colorBorderDialogDefault": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderDividerInteractiveDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderTabsDivider": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTabsShadow": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorGreyTransparent}"
          },
          "colorBorderTabsUnderline": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorBorderTilesDisabled": {
            "light": "{colorTransparent}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTutorial": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral500}"
          },
          "colorForegroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorForegroundControlDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral600}"
          },
          "colorForegroundControlReadOnly": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorShadowDefault": {
            "light": "{colorGreyTransparentHeavy}",
            "dark": "{colorGreyTransparentHeavy}"
          },
          "colorShadowMedium": {
            "light": "{colorGreyTransparent}",
            "dark": "{colorGreyTransparent}"
          },
          "colorShadowSide": {
            "light": "{colorGreyTransparentLight}",
            "dark": "{colorGreyTransparentLight}"
          },
          "colorShadowToggleHandle": {
            "light": "rgba(0, 0, 0, 0.25)",
            "dark": "rgba(0, 0, 0, 0.25)"
          },
          "colorStrokeChartLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorStrokeCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorStrokeCodeEditorGutterActiveLineHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral950}"
          },
          "colorTextAccent": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextBodyDefault": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextBodySecondary": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextBreadcrumbCurrent": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextButtonInlineIconDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonInlineLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonNormalActive": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextToggleButtonNormalPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextButtonNormalDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextButtonNormalHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLinkButtonNormalDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkButtonNormalHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkButtonNormalActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextButtonLinkDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonPrimaryActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryHover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCalendarDateHover": {
            "light": "{colorTextDropdownItemHighlighted}",
            "dark": "{colorTextDropdownItemHighlighted}"
          },
          "colorTextCalendarDateSelected": {
            "light": "{colorBackgroundControlDefault}",
            "dark": "{colorBackgroundControlDefault}"
          },
          "colorTextCalendarMonth": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextCodeEditorGutterActiveLine": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCodeEditorGutterDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextCodeEditorStatusBarDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextCodeEditorTabButtonError": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextColumnHeader": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextColumnSortingIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextControlDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextCounter": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextDisabledInlineEdit": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDropdownFooter": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownGroupLabel": {
            "light": "{colorTextGroupLabel}",
            "dark": "{colorTextGroupLabel}"
          },
          "colorTextDropdownItemDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextDropdownItemDimmed": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemFilterMatch": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextDropdownItemHighlighted": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextDropdownItemSecondary": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownItemSecondaryHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextEmpty": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextExpandableSectionDefault": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextExpandableSectionHover": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextExpandableSectionNavigationIconDefault": {
            "light": "{colorTextIconCaret}",
            "dark": "{colorTextIconCaret}"
          },
          "colorBorderExpandableSectionDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorTextFormDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextFormLabel": {
            "light": "{colorTextFormDefault}",
            "dark": "{colorTextFormDefault}"
          },
          "colorTextFormSecondary": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextGroupLabel": {
            "light": "{colorTextLabel}",
            "dark": "{colorTextLabel}"
          },
          "colorTextLabelGenAi": {
            "light": "{colorPurple700}",
            "dark": "{colorPurple400}"
          },
          "colorTextHeadingDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHeadingSecondary": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextHomeHeaderDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHomeHeaderSecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextIconCaret": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral450}"
          },
          "colorTextIconSubtle": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral400}"
          },
          "colorTextInputDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInputPlaceholder": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorTextInputPlaceholderDisabled": {
            "light": "{colorTextInputPlaceholder}",
            "dark": "{colorTextInputPlaceholder}"
          },
          "colorTextInteractiveActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInteractiveHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonIconPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveInvertedDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextInteractiveInvertedHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextInverted": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLabel": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextKeyValuePairsValue": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextLayoutToggle": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextLayoutToggleActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextLayoutToggleHover": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextLayoutToggleSelected": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLinkDefault": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextLinkHover": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextLinkDecorationDefault": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkDecorationHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkSecondaryDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkSecondaryHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkSecondaryDecorationDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextLinkInfoDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkInfoHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkInvertedDefault": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkInvertedHover": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextLinkButtonUnderline": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkButtonUnderlineHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextNotificationDefault": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextAlertDefault": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextNotificationLinkDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextNotificationLinkHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextNotificationStackBar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextNotificationYellow": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextPaginationPageNumberActiveDisabled": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextPaginationPageNumberDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextSegmentActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextSegmentDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextSegmentHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextSmall": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextFlashbarIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextFlashbarIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextFlashbarIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextFlashbarIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextAlertIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextAlertIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextAlertIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextAlertIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorTextStatusInactive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess500}"
          },
          "colorTextStatusWarning": {
            "light": "{colorTextNotificationYellow}",
            "dark": "{colorTextNotificationYellow}"
          },
          "colorTextTopNavigationTitle": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextTutorialHotspotDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorTextTutorialHotspotHover": {
            "light": "{colorNeutral900}",
            "dark": "{colorNeutral900}"
          },
          "colorBoardPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBoardPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDragPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorDragPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDropzoneBackgroundDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorDropzoneBackgroundHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorDropzoneTextDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneTextHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneBorderDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorDropzoneBorderHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorGapGlobalDrawer": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorTreeViewConnectorLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral300}"
          },
          "colorBackgroundActionCardDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundActionCardHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundActionCardActive": {
            "light": "{colorPrimary100}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderActionCardDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderActionCardHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundActionCardDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral800}"
          },
          "colorTextActionCardDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorTextActionCardIconDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextActionCardIconHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeleton": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeletonWave": {
            "light": "{colorNeutral150}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundBadgeGreen": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundBadgeBlue": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundBadgeRed": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundBadgeYellow": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundBadgeGrey": {
            "light": "{colorBackgroundNotificationGrey}",
            "dark": "{colorBackgroundNotificationGrey}"
          },
          "colorBorderBadge": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGrey": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGreen": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeBlue": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeRed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextBadgeGrey": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeGreen": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeBlue": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeRed": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorBackgroundCodeView": {
            "light": "#f8f8f8",
            "dark": "#282c34"
          },
          "colorBackgroundVisualAccentRed": {
            "light": "#ffe0e0",
            "dark": "rgba(255, 61, 61, 0.2)"
          },
          "colorBackgroundVisualAccentYellow": {
            "light": "#fffbbd",
            "dark": "rgba(251, 211, 50, 0.2)"
          },
          "colorBackgroundVisualAccentIndigo": {
            "light": "#dbe4ff",
            "dark": "rgba(92, 127, 255, 0.2)"
          },
          "colorBackgroundVisualAccentGreen": {
            "light": "#d9ffd6",
            "dark": "rgba(43, 181, 52, 0.2)"
          },
          "colorBackgroundVisualAccentOrange": {
            "light": "rgba(255, 224, 214, 0.6)",
            "dark": "rgba(255, 75, 20, 0.2)"
          },
          "colorBackgroundVisualAccentPurple": {
            "light": "rgba(242, 229, 255, 0.6)",
            "dark": "rgba(173, 92, 255, 0.2)"
          },
          "colorBackgroundVisualAccentLime": {
            "light": "{colorLime100}",
            "dark": "rgba(49, 184, 0, 0.2)"
          },
          "colorBackgroundVisualAccentGrey": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundVisualAccentTeal": {
            "light": "rgba(204, 255, 252, 0.7)",
            "dark": "rgba(0, 173, 162, 0.2)"
          },
          "colorBackgroundVisualAccentBlue": {
            "light": "rgba(209, 241, 255, 0.6)",
            "dark": "rgba(0, 153, 255, 0.2)"
          },
          "colorBackgroundVisualAccentViolet": {
            "light": "rgba(232, 229, 255, 0.6)",
            "dark": "rgba(133, 117, 255, 0.2)"
          },
          "colorBackgroundVisualAccentMagenta": {
            "light": "rgba(255, 224, 251, 0.6)",
            "dark": "rgba(255, 26, 224, 0.2)"
          },
          "colorBackgroundVisualAccentPink": {
            "light": "rgba(255, 224, 240, 0.7)",
            "dark": "rgba(255, 51, 153, 0.2)"
          },
          "colorBackgroundVisualAccentAmber": {
            "light": "rgba(255, 232, 189, 0.7)",
            "dark": "rgba(250, 111, 0, 0.2)"
          },
          "colorTextVisualAccentRed": {
            "light": "{colorError700}",
            "dark": "{colorError400}"
          },
          "colorTextVisualAccentYellow": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning200}"
          },
          "colorTextVisualAccentIndigo": {
            "light": "{colorInfo800}",
            "dark": "{colorInfo300}"
          },
          "colorTextVisualAccentGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess200}"
          },
          "colorTextVisualAccentOrange": {
            "light": "#a82700",
            "dark": "#ff997a"
          },
          "colorTextVisualAccentPurple": {
            "light": "#962eff",
            "dark": "#d4a8ff"
          },
          "colorTextVisualAccentLime": {
            "light": "#007000",
            "dark": "#acff2e"
          },
          "colorTextVisualAccentGrey": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral300}"
          },
          "colorTextVisualAccentTeal": {
            "light": "#008077",
            "dark": "#00f5e4"
          },
          "colorTextVisualAccentBlue": {
            "light": "#006ce0",
            "dark": "#75cfff"
          },
          "colorTextVisualAccentViolet": {
            "light": "#6842ff",
            "dark": "#b2a8ff"
          },
          "colorTextVisualAccentMagenta": {
            "light": "#b2008f",
            "dark": "#ff57e9"
          },
          "colorTextVisualAccentPink": {
            "light": "#bb005d",
            "dark": "#ff99cc"
          },
          "colorTextVisualAccentAmber": {
            "light": "#9e3700",
            "dark": "#ffbb45"
          }
        }
      },
      "alert": {
        "id": "alert",
        "selector": ".awsui-context-alert:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
        "tokens": {
          "colorGreyOpaque10": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(0, 0, 0, 0.1)"
          },
          "colorGreyOpaque25": {
            "light": "rgba(255, 255, 255, 0.25)",
            "dark": "rgba(255, 255, 255, 0.25)"
          },
          "colorGreyOpaque40": {
            "light": "rgba(0, 0, 0, 0.4)",
            "dark": "rgba(0, 0, 0, 0.4)"
          },
          "colorGreyOpaque50": {
            "light": "rgba(0, 0, 0, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyOpaque70": {
            "light": "rgba(255, 255, 255, 0.7)",
            "dark": "rgba(255, 255, 255, 0.7)"
          },
          "colorGreyOpaque80": {
            "light": "rgba(22, 25, 31, 0.8)",
            "dark": "rgba(22, 25, 31, 0.8)"
          },
          "colorGreyOpaque90": {
            "light": "rgba(242, 243, 243, 0.9)",
            "dark": "rgba(242, 243, 243, 0.9)"
          },
          "colorGreyTransparent": {
            "light": "rgba(0, 28, 36, 0.3)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorGreyTransparentHeavy": {
            "light": "rgba(0, 28, 36, 0.5)",
            "dark": "rgba(0, 0, 0, 0.5)"
          },
          "colorGreyTransparentLight": {
            "light": "rgba(0, 28, 36, 0.15)",
            "dark": "rgba(0, 0, 0, 0.3)"
          },
          "colorBackgroundBadgeIcon": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorBackgroundButtonLinkActive": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonLinkDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkDisabled": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundButtonLinkHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundButtonNormalActive": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundButtonNormalDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonNormalHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundToggleButtonNormalPressed": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundToggleButtonNormalDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundToggleButtonNormalHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundButtonPrimaryActive": {
            "light": "{colorPrimary1000}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundButtonPrimaryDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundButtonPrimaryHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundDirectionButtonActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundDirectionButtonDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDirectionButtonHover": {
            "light": "{colorNeutral700}",
            "dark": "{colorNeutral700}"
          },
          "colorTextDirectionButtonDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextDirectionButtonDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorBackgroundCalendarCurrentDate": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCellShaded": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundCodeEditorGutterActiveLineError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundCodeEditorGutterDefault": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCodeEditorLoading": {
            "light": "{colorBackgroundCodeEditorStatusBar}",
            "dark": "{colorBackgroundCodeEditorStatusBar}"
          },
          "colorBackgroundCodeEditorPaneItemHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundCodeEditorStatusBar": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundCard": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundItemCard": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundContainerContent": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundContainerHeader": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundControlChecked": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundControlDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundDropdownItemDimmed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundDropdownItemFilterMatch": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundDropdownItemHover": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundDropdownItemSelected": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundHomeHeader": {
            "light": "{colorBlack}",
            "dark": "{colorBlack}"
          },
          "colorBackgroundInlineCode": {
            "light": "rgba(0, 0, 0, 0.1)",
            "dark": "rgba(255, 255, 255, 0.1)"
          },
          "colorBackgroundInputDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundInputDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundItemSelected": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorBackgroundSideNavigationItemActive": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundSideNavigationItemActiveCollapsed": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBackgroundSideNavigationItemIconHover": {
            "light": "{colorBackgroundItemSelected}",
            "dark": "{colorBackgroundItemSelected}"
          },
          "colorBackgroundLayoutMain": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorBackgroundLayoutAiDrawer": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundDrawer": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundBackdrop": {
            "light": "{colorGreyOpaque90}",
            "dark": "{colorGreyOpaque80}"
          },
          "colorBackgroundDrawerBackdrop": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundLayoutMobilePanel": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutPanel": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelContent": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundLayoutPanelHover": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundLayoutToolbar": {
            "light": "{colorBackgroundLayoutPanelContent}",
            "dark": "{colorBackgroundLayoutPanelContent}"
          },
          "colorBackgroundLayoutToggleActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundLayoutToggleDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundLayoutToggleHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundLayoutToggleSelectedActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundLayoutToggleSelectedDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundLayoutToggleSelectedHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundModalOverlay": {
            "light": "{colorBackgroundBackdrop}",
            "dark": "{colorBackgroundBackdrop}"
          },
          "colorBackgroundNotificationBlue": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo600}"
          },
          "colorBackgroundNotificationGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBackgroundNotificationGrey": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundNotificationRed": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBackgroundNotificationYellow": {
            "light": "{colorWarning400}",
            "dark": "{colorWarning400}"
          },
          "colorBackgroundFlashbarSuccess": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundFlashbarError": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundFlashbarInfo": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundFlashbarWarning": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarActive": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundNotificationStackBarHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorBackgroundPopover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundProgressBarValueDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundProgressBarValueFlash": {
            "light": "{colorBackgroundProgressBarValueDefault}",
            "dark": "{colorBackgroundProgressBarValueDefault}"
          },
          "colorBackgroundProgressBarFlash": {
            "light": "{colorBackgroundProgressBarDefault}",
            "dark": "{colorBackgroundProgressBarDefault}"
          },
          "colorBackgroundProgressBarDefault": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundSegmentActive": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSegmentDefault": {
            "light": "{colorBackgroundButtonNormalDefault}",
            "dark": "{colorBackgroundButtonNormalDefault}"
          },
          "colorBackgroundSegmentDisabled": {
            "light": "{colorBackgroundButtonNormalDisabled}",
            "dark": "{colorBackgroundButtonNormalDisabled}"
          },
          "colorBackgroundSegmentHover": {
            "light": "{colorBackgroundButtonNormalHover}",
            "dark": "{colorBackgroundButtonNormalHover}"
          },
          "colorBackgroundSegmentWrapper": {
            "light": "{colorBackgroundContainerContent}",
            "dark": "{colorBackgroundContainerContent}"
          },
          "colorBackgroundSliderRangeDefault": {
            "light": "{colorBackgroundSliderHandleDefault}",
            "dark": "{colorBackgroundSliderHandleDefault}"
          },
          "colorBackgroundSliderRangeActive": {
            "light": "{colorBackgroundSliderHandleActive}",
            "dark": "{colorBackgroundSliderHandleActive}"
          },
          "colorBackgroundSliderHandleDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBackgroundSliderHandleActive": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary300}"
          },
          "colorBackgroundSliderTrackDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSliderHandleRing": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundSliderHandleErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderHandleWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderHandleWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeErrorDefault": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeErrorActive": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorBackgroundSliderRangeWarningDefault": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundSliderRangeWarningActive": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorBackgroundStatusError": {
            "light": "{colorError50}",
            "dark": "{colorError1000}"
          },
          "colorBackgroundStatusInfo": {
            "light": "{colorInfo50}",
            "dark": "{colorInfo1000}"
          },
          "colorBackgroundAlertError": {
            "light": "{colorBackgroundStatusError}",
            "dark": "{colorBackgroundStatusError}"
          },
          "colorBackgroundAlertInfo": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundAlertSuccess": {
            "light": "{colorBackgroundStatusSuccess}",
            "dark": "{colorBackgroundStatusSuccess}"
          },
          "colorBackgroundAlertWarning": {
            "light": "{colorBackgroundStatusWarning}",
            "dark": "{colorBackgroundStatusWarning}"
          },
          "colorBackgroundDialog": {
            "light": "{colorBackgroundStatusInfo}",
            "dark": "{colorBackgroundStatusInfo}"
          },
          "colorBackgroundDialogDefault": {
            "light": "{colorBackgroundCard}",
            "dark": "{colorBackgroundCard}"
          },
          "colorBackgroundStatusSuccess": {
            "light": "{colorSuccess50}",
            "dark": "{colorSuccess1000}"
          },
          "colorBackgroundStatusWarning": {
            "light": "{colorWarning50}",
            "dark": "{colorWarning1000}"
          },
          "colorBackgroundTableHeader": {
            "light": "{colorBackgroundContainerHeader}",
            "dark": "{colorBackgroundContainerHeader}"
          },
          "colorBackgroundTilesDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBackgroundToggleCheckedDisabled": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary700}"
          },
          "colorBackgroundToggleDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBackgroundAvatarGenAi": {
            "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
            "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
          },
          "colorBackgroundAvatarDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral650}"
          },
          "colorTextAvatar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorBackgroundLoadingBarGenAi": {
            "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
            "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
          },
          "colorBackgroundStatusIndicatorError": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorWarning": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorSuccess": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorInfo": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundStatusIndicatorNeutral": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleOutgoing": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBackgroundChatBubbleIncoming": {
            "light": "{colorNeutral200}",
            "dark": "{colorNeutral950}"
          },
          "colorTextChatBubbleOutgoing": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextChatBubbleIncoming": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorBorderButtonLinkDisabled": {
            "light": "{colorBackgroundButtonLinkDisabled}",
            "dark": "{colorBackgroundButtonLinkDisabled}"
          },
          "colorBorderButtonNormalActive": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderButtonNormalDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalPressed": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderToggleButtonNormalDefault": {
            "light": "{colorBorderButtonNormalDefault}",
            "dark": "{colorBorderButtonNormalDefault}"
          },
          "colorBorderToggleButtonNormalHover": {
            "light": "{colorBorderButtonNormalHover}",
            "dark": "{colorBorderButtonNormalHover}"
          },
          "colorBorderButtonNormalDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorTextButtonNormalDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonNormalHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral400}"
          },
          "colorTextButtonIconDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderButtonPrimaryActive": {
            "light": "{colorBackgroundButtonPrimaryActive}",
            "dark": "{colorBackgroundButtonPrimaryActive}"
          },
          "colorBorderButtonPrimaryDefault": {
            "light": "{colorBackgroundButtonPrimaryDefault}",
            "dark": "{colorBackgroundButtonPrimaryDefault}"
          },
          "colorBorderButtonPrimaryDisabled": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderButtonPrimaryHover": {
            "light": "{colorBackgroundButtonPrimaryHover}",
            "dark": "{colorBackgroundButtonPrimaryHover}"
          },
          "colorTextButtonPrimaryDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorItemSelected": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextSideNavigationItemActive": {
            "light": "{colorTextAccent}",
            "dark": "{colorTextAccent}"
          },
          "colorTextSideNavigationItemActiveCollapsed": {
            "light": "{colorTextInverted}",
            "dark": "{colorTextInverted}"
          },
          "colorTextSideNavigationItemDefault": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorBorderCalendarGrid": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCalendarGridSelectedFocusRing": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderCellShaded": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderCodeEditorAceActiveLineLightTheme": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorBorderCodeEditorAceActiveLineDarkTheme": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderCodeEditorPaneItemHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderCard": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderCardHighlighted": {
            "light": "{colorBorderItemSelected}",
            "dark": "{colorBorderItemSelected}"
          },
          "colorBorderItemCard": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderItemCardHighlighted": {
            "light": "{colorBorderCardHighlighted}",
            "dark": "{colorBorderCardHighlighted}"
          },
          "colorBorderContainerDivider": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderContainerTop": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderControlChecked": {
            "light": "{colorBackgroundControlChecked}",
            "dark": "{colorBackgroundControlChecked}"
          },
          "colorBorderControlDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderControlDisabled": {
            "light": "{colorBackgroundControlDisabled}",
            "dark": "{colorBackgroundControlDisabled}"
          },
          "colorBorderDividerActive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDividerDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorBorderDividerNotification": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDividerPanelBottom": {
            "light": "{colorShadowSide}",
            "dark": "{colorShadowSide}"
          },
          "colorBorderDividerPanelSide": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDividerSecondary": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderDividerTableGroup": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderDropdownContainer": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderDropdownGroup": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderDropdownItemHover": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderDropdownItemDimmedHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderDropdownItemSelected": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderDropdownItemTop": {
            "light": "{colorBorderDropdownItemDefault}",
            "dark": "{colorBorderDropdownItemDefault}"
          },
          "colorBorderEditableCellHover": {
            "light": "{colorBorderDropdownItemHover}",
            "dark": "{colorBorderDropdownItemHover}"
          },
          "colorBorderInputDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderInputDisabled": {
            "light": "{colorBackgroundInputDisabled}",
            "dark": "{colorBackgroundInputDisabled}"
          },
          "colorBorderInputFocused": {
            "light": "{colorBorderItemFocused}",
            "dark": "{colorBorderItemFocused}"
          },
          "colorBorderItemFocused": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderDropdownItemFocused": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderItemPlaceholder": {
            "light": "{colorTransparent}",
            "dark": "{colorTransparent}"
          },
          "colorBorderItemSelected": {
            "light": "{colorItemSelected}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderLayout": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderLayoutSideNavigation": {
            "light": "{colorBorderLayout}",
            "dark": "{colorBorderLayout}"
          },
          "colorBorderNotificationStackBar": {
            "light": "{colorNeutral750}",
            "dark": "{colorNeutral750}"
          },
          "colorBorderNotificationStackBarHover": {
            "light": "{colorBackgroundNotificationStackBarHover}",
            "dark": "{colorBackgroundNotificationStackBarHover}"
          },
          "colorBorderNotificationStackBarActive": {
            "light": "{colorBackgroundNotificationStackBar}",
            "dark": "{colorBackgroundNotificationStackBar}"
          },
          "colorBorderNotificationStackBarFocused": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorBorderPanelHeader": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorBorderPopover": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral650}"
          },
          "colorBorderSegmentActive": {
            "light": "{colorBorderSegmentHover}",
            "dark": "{colorBorderSegmentHover}"
          },
          "colorBorderSegmentDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorBorderSegmentDisabled": {
            "light": "{colorBorderButtonNormalDisabled}",
            "dark": "{colorBorderButtonNormalDisabled}"
          },
          "colorBorderSegmentDivider": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderSegmentHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorWhite}"
          },
          "colorBorderSegmentWrapper": {
            "light": "{colorBorderInputDefault}",
            "dark": "{colorBorderInputDefault}"
          },
          "colorBorderStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError600}"
          },
          "colorBorderStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorInfo400}"
          },
          "colorBorderStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess600}"
          },
          "colorBorderStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorBorderDialog": {
            "light": "{colorBorderStatusInfo}",
            "dark": "{colorBorderStatusInfo}"
          },
          "colorBorderDialogDefault": {
            "light": "{colorBorderCard}",
            "dark": "{colorBorderCard}"
          },
          "colorBorderDividerInteractiveDefault": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral600}"
          },
          "colorBorderTabsDivider": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTabsShadow": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorGreyTransparent}"
          },
          "colorBorderTabsUnderline": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorBorderTilesDisabled": {
            "light": "{colorTransparent}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderTutorial": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral500}"
          },
          "colorForegroundControlDefault": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorForegroundControlDisabled": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral600}"
          },
          "colorForegroundControlReadOnly": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorShadowDefault": {
            "light": "{colorGreyTransparentHeavy}",
            "dark": "{colorGreyTransparentHeavy}"
          },
          "colorShadowMedium": {
            "light": "{colorGreyTransparent}",
            "dark": "{colorGreyTransparent}"
          },
          "colorShadowSide": {
            "light": "{colorGreyTransparentLight}",
            "dark": "{colorGreyTransparentLight}"
          },
          "colorShadowToggleHandle": {
            "light": "rgba(0, 0, 0, 0.25)",
            "dark": "rgba(0, 0, 0, 0.25)"
          },
          "colorStrokeChartLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorStrokeCodeEditorGutterActiveLineDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral700}"
          },
          "colorStrokeCodeEditorGutterActiveLineHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral950}"
          },
          "colorTextAccent": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextBodyDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBodySecondary": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbCurrent": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextBreadcrumbIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextButtonInlineIconDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonInlineIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonInlineLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonIconHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextButtonNormalActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonNormalPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextButtonNormalDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextButtonNormalHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextLinkButtonNormalDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextLinkButtonNormalHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextLinkButtonNormalActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkActive": {
            "light": "{colorTextButtonNormalActive}",
            "dark": "{colorTextButtonNormalActive}"
          },
          "colorTextButtonLinkDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextButtonLinkDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextButtonLinkHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextButtonPrimaryActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextButtonPrimaryHover": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCalendarDateHover": {
            "light": "{colorTextDropdownItemHighlighted}",
            "dark": "{colorTextDropdownItemHighlighted}"
          },
          "colorTextCalendarDateSelected": {
            "light": "{colorBackgroundControlDefault}",
            "dark": "{colorBackgroundControlDefault}"
          },
          "colorTextCalendarMonth": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextCodeEditorGutterActiveLine": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextCodeEditorGutterDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextCodeEditorStatusBarDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextCodeEditorTabButtonError": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextColumnHeader": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextColumnSortingIcon": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextControlDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextCounter": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextDisabledInlineEdit": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextDropdownFooter": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownGroupLabel": {
            "light": "{colorTextGroupLabel}",
            "dark": "{colorTextGroupLabel}"
          },
          "colorTextDropdownItemDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextDropdownItemDimmed": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemDisabled": {
            "light": "{colorTextInteractiveDisabled}",
            "dark": "{colorTextInteractiveDisabled}"
          },
          "colorTextDropdownItemFilterMatch": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextDropdownItemHighlighted": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextDropdownItemSecondary": {
            "light": "{colorTextFormSecondary}",
            "dark": "{colorTextFormSecondary}"
          },
          "colorTextDropdownItemSecondaryHover": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextEmpty": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral300}"
          },
          "colorTextExpandableSectionDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextExpandableSectionHover": {
            "light": "{colorTextInteractiveHover}",
            "dark": "{colorTextInteractiveHover}"
          },
          "colorTextExpandableSectionNavigationIconDefault": {
            "light": "{colorTextIconCaret}",
            "dark": "{colorTextIconCaret}"
          },
          "colorBorderExpandableSectionDefault": {
            "light": "{colorBorderDividerDefault}",
            "dark": "{colorBorderDividerDefault}"
          },
          "colorTextFormDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral300}"
          },
          "colorTextFormLabel": {
            "light": "{colorTextFormDefault}",
            "dark": "{colorTextFormDefault}"
          },
          "colorTextFormSecondary": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextGroupLabel": {
            "light": "{colorTextLabel}",
            "dark": "{colorTextLabel}"
          },
          "colorTextLabelGenAi": {
            "light": "{colorPurple700}",
            "dark": "{colorPurple400}"
          },
          "colorTextHeadingDefault": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHeadingSecondary": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextHomeHeaderDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral250}"
          },
          "colorTextHomeHeaderSecondary": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextIconCaret": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral450}"
          },
          "colorTextIconSubtle": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral400}"
          },
          "colorTextInputDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInputPlaceholder": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral500}"
          },
          "colorTextInputPlaceholderDisabled": {
            "light": "{colorTextInputPlaceholder}",
            "dark": "{colorTextInputPlaceholder}"
          },
          "colorTextInteractiveActive": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorTextInteractiveHover": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextToggleButtonIconPressed": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInteractiveInvertedDefault": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral300}"
          },
          "colorTextInteractiveInvertedHover": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextInverted": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLabel": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral450}"
          },
          "colorTextKeyValuePairsValue": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextLayoutToggle": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral300}"
          },
          "colorTextLayoutToggleActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextLayoutToggleHover": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextLayoutToggleSelected": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral950}"
          },
          "colorTextLinkDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextLinkHover": {
            "light": "{colorPrimary700}",
            "dark": "{colorPrimary200}"
          },
          "colorTextLinkDecorationDefault": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkDecorationHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkSecondaryDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkSecondaryHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkSecondaryDecorationDefault": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextLinkInfoDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextLinkInfoHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextLinkInvertedDefault": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkInvertedHover": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextLinkButtonUnderline": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextLinkButtonUnderlineHover": {
            "light": "currentColor",
            "dark": "currentColor"
          },
          "colorTextNotificationDefault": {
            "light": "{colorNeutral100}",
            "dark": "{colorNeutral100}"
          },
          "colorTextAlertDefault": {
            "light": "{colorTextBodyDefault}",
            "dark": "{colorTextBodyDefault}"
          },
          "colorTextNotificationLinkDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextNotificationLinkHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorTextNotificationStackBar": {
            "light": "{colorWhite}",
            "dark": "{colorWhite}"
          },
          "colorTextNotificationYellow": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral950}"
          },
          "colorTextPaginationPageNumberActiveDisabled": {
            "light": "{colorTextBodySecondary}",
            "dark": "{colorTextBodySecondary}"
          },
          "colorTextPaginationPageNumberDefault": {
            "light": "{colorTextInteractiveDefault}",
            "dark": "{colorTextInteractiveDefault}"
          },
          "colorTextSegmentActive": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorTextSegmentDefault": {
            "light": "{colorTextButtonNormalDefault}",
            "dark": "{colorTextButtonNormalDefault}"
          },
          "colorTextSegmentHover": {
            "light": "{colorTextButtonNormalHover}",
            "dark": "{colorTextButtonNormalHover}"
          },
          "colorTextSmall": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextFlashbarIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextFlashbarIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextFlashbarIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextFlashbarIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextAlertIconError": {
            "light": "{colorTextStatusError}",
            "dark": "{colorTextStatusError}"
          },
          "colorTextAlertIconInfo": {
            "light": "{colorTextStatusInfo}",
            "dark": "{colorTextStatusInfo}"
          },
          "colorTextAlertIconSuccess": {
            "light": "{colorTextStatusSuccess}",
            "dark": "{colorTextStatusSuccess}"
          },
          "colorTextAlertIconWarning": {
            "light": "{colorTextStatusWarning}",
            "dark": "{colorTextStatusWarning}"
          },
          "colorTextStatusError": {
            "light": "{colorError600}",
            "dark": "{colorError400}"
          },
          "colorTextStatusInactive": {
            "light": "{colorNeutral600}",
            "dark": "{colorNeutral450}"
          },
          "colorTextStatusInfo": {
            "light": "{colorInfo600}",
            "dark": "{colorPrimary300}"
          },
          "colorTextStatusSuccess": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess500}"
          },
          "colorTextStatusWarning": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning500}"
          },
          "colorTextTopNavigationTitle": {
            "light": "{colorNeutral950}",
            "dark": "{colorNeutral100}"
          },
          "colorTextTutorialHotspotDefault": {
            "light": "{colorTextLinkDefault}",
            "dark": "{colorTextLinkDefault}"
          },
          "colorTextTutorialHotspotHover": {
            "light": "{colorTextLinkHover}",
            "dark": "{colorTextLinkHover}"
          },
          "colorBoardPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorBoardPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDragPlaceholderActive": {
            "light": "{colorNeutral300}",
            "dark": "{colorNeutral600}"
          },
          "colorDragPlaceholderHover": {
            "light": "{colorPrimary200}",
            "dark": "{colorPrimary600}"
          },
          "colorDropzoneBackgroundDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorDropzoneBackgroundHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorPrimary1000}"
          },
          "colorDropzoneTextDefault": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneTextHover": {
            "light": "{colorNeutral650}",
            "dark": "{colorNeutral350}"
          },
          "colorDropzoneBorderDefault": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorDropzoneBorderHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorGapGlobalDrawer": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral950}"
          },
          "colorTreeViewConnectorLine": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral300}"
          },
          "colorBackgroundActionCardDefault": {
            "light": "{colorWhite}",
            "dark": "{colorNeutral850}"
          },
          "colorBackgroundActionCardHover": {
            "light": "{colorPrimary50}",
            "dark": "{colorNeutral800}"
          },
          "colorBackgroundActionCardActive": {
            "light": "{colorPrimary100}",
            "dark": "{colorNeutral700}"
          },
          "colorBorderActionCardDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorBorderActionCardHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorBorderActionCardDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundActionCardDisabled": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral800}"
          },
          "colorTextActionCardDisabled": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral500}"
          },
          "colorTextActionCardIconDefault": {
            "light": "{colorPrimary600}",
            "dark": "{colorPrimary400}"
          },
          "colorTextActionCardIconHover": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconActive": {
            "light": "{colorPrimary900}",
            "dark": "{colorPrimary300}"
          },
          "colorTextActionCardIconDisabled": {
            "light": "{colorNeutral400}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeleton": {
            "light": "{colorNeutral500}",
            "dark": "{colorNeutral600}"
          },
          "colorBackgroundSkeletonWave": {
            "light": "{colorNeutral150}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundBadgeGreen": {
            "light": "{colorBackgroundNotificationGreen}",
            "dark": "{colorBackgroundNotificationGreen}"
          },
          "colorBackgroundBadgeBlue": {
            "light": "{colorBackgroundNotificationBlue}",
            "dark": "{colorBackgroundNotificationBlue}"
          },
          "colorBackgroundBadgeRed": {
            "light": "{colorBackgroundNotificationRed}",
            "dark": "{colorBackgroundNotificationRed}"
          },
          "colorBackgroundBadgeYellow": {
            "light": "{colorBackgroundNotificationYellow}",
            "dark": "{colorBackgroundNotificationYellow}"
          },
          "colorBackgroundBadgeGrey": {
            "light": "{colorBackgroundNotificationGrey}",
            "dark": "{colorBackgroundNotificationGrey}"
          },
          "colorBorderBadge": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGrey": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeGreen": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeBlue": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorBorderBadgeRed": {
            "light": "transparent",
            "dark": "transparent"
          },
          "colorTextBadgeGrey": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeGreen": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeBlue": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorTextBadgeRed": {
            "light": "{colorTextNotificationDefault}",
            "dark": "{colorTextNotificationDefault}"
          },
          "colorBackgroundCodeView": {
            "light": "#f8f8f8",
            "dark": "#282c34"
          },
          "colorBackgroundVisualAccentRed": {
            "light": "#ffe0e0",
            "dark": "rgba(255, 61, 61, 0.2)"
          },
          "colorBackgroundVisualAccentYellow": {
            "light": "#fffbbd",
            "dark": "rgba(251, 211, 50, 0.2)"
          },
          "colorBackgroundVisualAccentIndigo": {
            "light": "#dbe4ff",
            "dark": "rgba(92, 127, 255, 0.2)"
          },
          "colorBackgroundVisualAccentGreen": {
            "light": "#d9ffd6",
            "dark": "rgba(43, 181, 52, 0.2)"
          },
          "colorBackgroundVisualAccentOrange": {
            "light": "rgba(255, 224, 214, 0.6)",
            "dark": "rgba(255, 75, 20, 0.2)"
          },
          "colorBackgroundVisualAccentPurple": {
            "light": "rgba(242, 229, 255, 0.6)",
            "dark": "rgba(173, 92, 255, 0.2)"
          },
          "colorBackgroundVisualAccentLime": {
            "light": "{colorLime100}",
            "dark": "rgba(49, 184, 0, 0.2)"
          },
          "colorBackgroundVisualAccentGrey": {
            "light": "{colorNeutral250}",
            "dark": "{colorNeutral700}"
          },
          "colorBackgroundVisualAccentTeal": {
            "light": "rgba(204, 255, 252, 0.7)",
            "dark": "rgba(0, 173, 162, 0.2)"
          },
          "colorBackgroundVisualAccentBlue": {
            "light": "rgba(209, 241, 255, 0.6)",
            "dark": "rgba(0, 153, 255, 0.2)"
          },
          "colorBackgroundVisualAccentViolet": {
            "light": "rgba(232, 229, 255, 0.6)",
            "dark": "rgba(133, 117, 255, 0.2)"
          },
          "colorBackgroundVisualAccentMagenta": {
            "light": "rgba(255, 224, 251, 0.6)",
            "dark": "rgba(255, 26, 224, 0.2)"
          },
          "colorBackgroundVisualAccentPink": {
            "light": "rgba(255, 224, 240, 0.7)",
            "dark": "rgba(255, 51, 153, 0.2)"
          },
          "colorBackgroundVisualAccentAmber": {
            "light": "rgba(255, 232, 189, 0.7)",
            "dark": "rgba(250, 111, 0, 0.2)"
          },
          "colorTextVisualAccentRed": {
            "light": "{colorError700}",
            "dark": "{colorError400}"
          },
          "colorTextVisualAccentYellow": {
            "light": "{colorWarning900}",
            "dark": "{colorWarning200}"
          },
          "colorTextVisualAccentIndigo": {
            "light": "{colorInfo800}",
            "dark": "{colorInfo300}"
          },
          "colorTextVisualAccentGreen": {
            "light": "{colorSuccess600}",
            "dark": "{colorSuccess200}"
          },
          "colorTextVisualAccentOrange": {
            "light": "#a82700",
            "dark": "#ff997a"
          },
          "colorTextVisualAccentPurple": {
            "light": "#962eff",
            "dark": "#d4a8ff"
          },
          "colorTextVisualAccentLime": {
            "light": "#007000",
            "dark": "#acff2e"
          },
          "colorTextVisualAccentGrey": {
            "light": "{colorNeutral850}",
            "dark": "{colorNeutral300}"
          },
          "colorTextVisualAccentTeal": {
            "light": "#008077",
            "dark": "#00f5e4"
          },
          "colorTextVisualAccentBlue": {
            "light": "#006ce0",
            "dark": "#75cfff"
          },
          "colorTextVisualAccentViolet": {
            "light": "#6842ff",
            "dark": "#b2a8ff"
          },
          "colorTextVisualAccentMagenta": {
            "light": "#b2008f",
            "dark": "#ff57e9"
          },
          "colorTextVisualAccentPink": {
            "light": "#bb005d",
            "dark": "#ff99cc"
          },
          "colorTextVisualAccentAmber": {
            "light": "#9e3700",
            "dark": "#ffbb45"
          }
        }
      }
    },
    "tokenModeMap": {
      "colorPrimary50": "color",
      "colorPrimary100": "color",
      "colorPrimary200": "color",
      "colorPrimary300": "color",
      "colorPrimary400": "color",
      "colorPrimary500": "color",
      "colorPrimary600": "color",
      "colorPrimary700": "color",
      "colorPrimary800": "color",
      "colorPrimary900": "color",
      "colorPrimary950": "color",
      "colorPrimary1000": "color",
      "colorNeutral50": "color",
      "colorNeutral100": "color",
      "colorNeutral150": "color",
      "colorNeutral200": "color",
      "colorNeutral250": "color",
      "colorNeutral300": "color",
      "colorNeutral350": "color",
      "colorNeutral400": "color",
      "colorNeutral450": "color",
      "colorNeutral500": "color",
      "colorNeutral550": "color",
      "colorNeutral600": "color",
      "colorNeutral650": "color",
      "colorNeutral700": "color",
      "colorNeutral750": "color",
      "colorNeutral800": "color",
      "colorNeutral850": "color",
      "colorNeutral900": "color",
      "colorNeutral950": "color",
      "colorNeutral1000": "color",
      "colorError50": "color",
      "colorError100": "color",
      "colorError400": "color",
      "colorError600": "color",
      "colorError700": "color",
      "colorError800": "color",
      "colorError900": "color",
      "colorError950": "color",
      "colorError1000": "color",
      "colorSuccess50": "color",
      "colorSuccess100": "color",
      "colorSuccess200": "color",
      "colorSuccess400": "color",
      "colorSuccess500": "color",
      "colorSuccess600": "color",
      "colorSuccess800": "color",
      "colorSuccess950": "color",
      "colorSuccess1000": "color",
      "colorWarning50": "color",
      "colorWarning100": "color",
      "colorWarning200": "color",
      "colorWarning400": "color",
      "colorWarning500": "color",
      "colorWarning600": "color",
      "colorWarning800": "color",
      "colorWarning900": "color",
      "colorWarning950": "color",
      "colorWarning1000": "color",
      "colorInfo50": "color",
      "colorInfo100": "color",
      "colorInfo300": "color",
      "colorInfo400": "color",
      "colorInfo600": "color",
      "colorInfo700": "color",
      "colorInfo800": "color",
      "colorInfo950": "color",
      "colorInfo1000": "color",
      "colorGrey50": "color",
      "colorGrey100": "color",
      "colorGrey150": "color",
      "colorGrey200": "color",
      "colorGrey250": "color",
      "colorGrey300": "color",
      "colorGrey350": "color",
      "colorGrey400": "color",
      "colorGrey450": "color",
      "colorGrey500": "color",
      "colorGrey600": "color",
      "colorGrey650": "color",
      "colorGrey700": "color",
      "colorGrey750": "color",
      "colorGrey800": "color",
      "colorGrey850": "color",
      "colorGrey900": "color",
      "colorGrey950": "color",
      "colorGrey1000": "color",
      "colorBlue50": "color",
      "colorBlue100": "color",
      "colorBlue200": "color",
      "colorBlue300": "color",
      "colorBlue400": "color",
      "colorBlue600": "color",
      "colorBlue700": "color",
      "colorBlue900": "color",
      "colorBlue1000": "color",
      "colorGreen50": "color",
      "colorGreen500": "color",
      "colorGreen600": "color",
      "colorGreen900": "color",
      "colorGreen1000": "color",
      "colorRed50": "color",
      "colorRed400": "color",
      "colorRed600": "color",
      "colorRed900": "color",
      "colorRed1000": "color",
      "colorYellow50": "color",
      "colorYellow400": "color",
      "colorYellow500": "color",
      "colorYellow900": "color",
      "colorYellow1000": "color",
      "colorPurple400": "color",
      "colorPurple700": "color",
      "colorAmber400": "color",
      "colorAmber500": "color",
      "colorRed950": "color",
      "colorOrange50": "color",
      "colorOrange100": "color",
      "colorOrange400": "color",
      "colorOrange700": "color",
      "colorOrange800": "color",
      "colorOrange950": "color",
      "colorYellow600": "color",
      "colorYellow950": "color",
      "colorLime50": "color",
      "colorLime100": "color",
      "colorLime400": "color",
      "colorLime700": "color",
      "colorLime800": "color",
      "colorLime950": "color",
      "colorGreen400": "color",
      "colorGreen950": "color",
      "colorMint50": "color",
      "colorMint100": "color",
      "colorMint400": "color",
      "colorMint700": "color",
      "colorMint800": "color",
      "colorMint950": "color",
      "colorIndigo50": "color",
      "colorIndigo400": "color",
      "colorIndigo600": "color",
      "colorIndigo950": "color",
      "colorPurple50": "color",
      "colorPurple100": "color",
      "colorPurple600": "color",
      "colorPurple800": "color",
      "colorPurple950": "color",
      "colorTeal50": "color",
      "colorTeal100": "color",
      "colorTeal400": "color",
      "colorTeal700": "color",
      "colorTeal800": "color",
      "colorTeal950": "color",
      "colorCyan50": "color",
      "colorCyan100": "color",
      "colorCyan400": "color",
      "colorCyan700": "color",
      "colorCyan800": "color",
      "colorCyan950": "color",
      "colorBlue950": "color",
      "colorViolet50": "color",
      "colorViolet100": "color",
      "colorViolet400": "color",
      "colorViolet700": "color",
      "colorViolet800": "color",
      "colorViolet950": "color",
      "colorFuchsia50": "color",
      "colorFuchsia100": "color",
      "colorFuchsia400": "color",
      "colorFuchsia700": "color",
      "colorFuchsia800": "color",
      "colorFuchsia950": "color",
      "colorMagenta50": "color",
      "colorMagenta100": "color",
      "colorMagenta400": "color",
      "colorMagenta700": "color",
      "colorMagenta800": "color",
      "colorMagenta950": "color",
      "colorPink50": "color",
      "colorPink100": "color",
      "colorPink400": "color",
      "colorPink700": "color",
      "colorPink800": "color",
      "colorPink950": "color",
      "colorRose50": "color",
      "colorRose100": "color",
      "colorRose400": "color",
      "colorRose700": "color",
      "colorRose800": "color",
      "colorRose950": "color",
      "colorAmber50": "color",
      "colorAmber100": "color",
      "colorAmber700": "color",
      "colorAmber800": "color",
      "colorAmber950": "color",
      "colorAwsSquidInk": "color",
      "colorTransparent": "color",
      "colorBlack": "color",
      "colorWhite": "color",
      "colorChartsRed300": "color",
      "colorChartsRed400": "color",
      "colorChartsRed500": "color",
      "colorChartsRed600": "color",
      "colorChartsRed700": "color",
      "colorChartsRed800": "color",
      "colorChartsRed900": "color",
      "colorChartsRed1000": "color",
      "colorChartsRed1100": "color",
      "colorChartsRed1200": "color",
      "colorChartsOrange300": "color",
      "colorChartsOrange400": "color",
      "colorChartsOrange500": "color",
      "colorChartsOrange600": "color",
      "colorChartsOrange700": "color",
      "colorChartsOrange800": "color",
      "colorChartsOrange900": "color",
      "colorChartsOrange1000": "color",
      "colorChartsOrange1100": "color",
      "colorChartsOrange1200": "color",
      "colorChartsYellow300": "color",
      "colorChartsYellow400": "color",
      "colorChartsYellow500": "color",
      "colorChartsYellow600": "color",
      "colorChartsYellow700": "color",
      "colorChartsYellow800": "color",
      "colorChartsYellow900": "color",
      "colorChartsYellow1000": "color",
      "colorChartsYellow1100": "color",
      "colorChartsYellow1200": "color",
      "colorChartsGreen300": "color",
      "colorChartsGreen400": "color",
      "colorChartsGreen500": "color",
      "colorChartsGreen600": "color",
      "colorChartsGreen700": "color",
      "colorChartsGreen800": "color",
      "colorChartsGreen900": "color",
      "colorChartsGreen1000": "color",
      "colorChartsGreen1100": "color",
      "colorChartsGreen1200": "color",
      "colorChartsTeal300": "color",
      "colorChartsTeal400": "color",
      "colorChartsTeal500": "color",
      "colorChartsTeal600": "color",
      "colorChartsTeal700": "color",
      "colorChartsTeal800": "color",
      "colorChartsTeal900": "color",
      "colorChartsTeal1000": "color",
      "colorChartsTeal1100": "color",
      "colorChartsTeal1200": "color",
      "colorChartsBlue1300": "color",
      "colorChartsBlue1400": "color",
      "colorChartsBlue1500": "color",
      "colorChartsBlue1600": "color",
      "colorChartsBlue1700": "color",
      "colorChartsBlue1800": "color",
      "colorChartsBlue1900": "color",
      "colorChartsBlue11000": "color",
      "colorChartsBlue11100": "color",
      "colorChartsBlue11200": "color",
      "colorChartsBlue2300": "color",
      "colorChartsBlue2400": "color",
      "colorChartsBlue2500": "color",
      "colorChartsBlue2600": "color",
      "colorChartsBlue2700": "color",
      "colorChartsBlue2800": "color",
      "colorChartsBlue2900": "color",
      "colorChartsBlue21000": "color",
      "colorChartsBlue21100": "color",
      "colorChartsBlue21200": "color",
      "colorChartsPurple300": "color",
      "colorChartsPurple400": "color",
      "colorChartsPurple500": "color",
      "colorChartsPurple600": "color",
      "colorChartsPurple700": "color",
      "colorChartsPurple800": "color",
      "colorChartsPurple900": "color",
      "colorChartsPurple1000": "color",
      "colorChartsPurple1100": "color",
      "colorChartsPurple1200": "color",
      "colorChartsPink300": "color",
      "colorChartsPink400": "color",
      "colorChartsPink500": "color",
      "colorChartsPink600": "color",
      "colorChartsPink700": "color",
      "colorChartsPink800": "color",
      "colorChartsPink900": "color",
      "colorChartsPink1000": "color",
      "colorChartsPink1100": "color",
      "colorChartsPink1200": "color",
      "colorChartsStatusCritical": "color",
      "colorChartsStatusHigh": "color",
      "colorChartsStatusMedium": "color",
      "colorChartsStatusLow": "color",
      "colorChartsStatusPositive": "color",
      "colorChartsStatusInfo": "color",
      "colorChartsStatusNeutral": "color",
      "colorChartsThresholdNegative": "color",
      "colorChartsThresholdPositive": "color",
      "colorChartsThresholdInfo": "color",
      "colorChartsThresholdNeutral": "color",
      "colorChartsLineGrid": "color",
      "colorChartsLineTick": "color",
      "colorChartsLineAxis": "color",
      "colorChartsPaletteCategorical1": "color",
      "colorChartsPaletteCategorical2": "color",
      "colorChartsPaletteCategorical3": "color",
      "colorChartsPaletteCategorical4": "color",
      "colorChartsPaletteCategorical5": "color",
      "colorChartsPaletteCategorical6": "color",
      "colorChartsPaletteCategorical7": "color",
      "colorChartsPaletteCategorical8": "color",
      "colorChartsPaletteCategorical9": "color",
      "colorChartsPaletteCategorical10": "color",
      "colorChartsPaletteCategorical11": "color",
      "colorChartsPaletteCategorical12": "color",
      "colorChartsPaletteCategorical13": "color",
      "colorChartsPaletteCategorical14": "color",
      "colorChartsPaletteCategorical15": "color",
      "colorChartsPaletteCategorical16": "color",
      "colorChartsPaletteCategorical17": "color",
      "colorChartsPaletteCategorical18": "color",
      "colorChartsPaletteCategorical19": "color",
      "colorChartsPaletteCategorical20": "color",
      "colorChartsPaletteCategorical21": "color",
      "colorChartsPaletteCategorical22": "color",
      "colorChartsPaletteCategorical23": "color",
      "colorChartsPaletteCategorical24": "color",
      "colorChartsPaletteCategorical25": "color",
      "colorChartsPaletteCategorical26": "color",
      "colorChartsPaletteCategorical27": "color",
      "colorChartsPaletteCategorical28": "color",
      "colorChartsPaletteCategorical29": "color",
      "colorChartsPaletteCategorical30": "color",
      "colorChartsPaletteCategorical31": "color",
      "colorChartsPaletteCategorical32": "color",
      "colorChartsPaletteCategorical33": "color",
      "colorChartsPaletteCategorical34": "color",
      "colorChartsPaletteCategorical35": "color",
      "colorChartsPaletteCategorical36": "color",
      "colorChartsPaletteCategorical37": "color",
      "colorChartsPaletteCategorical38": "color",
      "colorChartsPaletteCategorical39": "color",
      "colorChartsPaletteCategorical40": "color",
      "colorChartsPaletteCategorical41": "color",
      "colorChartsPaletteCategorical42": "color",
      "colorChartsPaletteCategorical43": "color",
      "colorChartsPaletteCategorical44": "color",
      "colorChartsPaletteCategorical45": "color",
      "colorChartsPaletteCategorical46": "color",
      "colorChartsPaletteCategorical47": "color",
      "colorChartsPaletteCategorical48": "color",
      "colorChartsPaletteCategorical49": "color",
      "colorChartsPaletteCategorical50": "color",
      "colorChartsErrorBarMarker": "color",
      "colorSeverityDarkRed": "color",
      "colorSeverityRed": "color",
      "colorSeverityOrange": "color",
      "colorSeverityYellow": "color",
      "colorSeverityGrey": "color",
      "colorBackgroundNotificationSeverityCritical": "color",
      "colorBackgroundNotificationSeverityHigh": "color",
      "colorBackgroundNotificationSeverityMedium": "color",
      "colorBackgroundNotificationSeverityLow": "color",
      "colorBackgroundNotificationSeverityNeutral": "color",
      "colorTextNotificationSeverityCritical": "color",
      "colorTextNotificationSeverityHigh": "color",
      "colorTextNotificationSeverityMedium": "color",
      "colorTextNotificationSeverityLow": "color",
      "colorTextNotificationSeverityNeutral": "color",
      "colorBorderBadgeSeverityCritical": "color",
      "colorBorderBadgeSeverityHigh": "color",
      "colorBorderBadgeSeverityMedium": "color",
      "colorBorderBadgeSeverityLow": "color",
      "colorBorderBadgeSeverityNeutral": "color",
      "colorTextBadgeSeverityCritical": "color",
      "colorTextBadgeSeverityHigh": "color",
      "colorTextBadgeSeverityMedium": "color",
      "colorTextBadgeSeverityLow": "color",
      "colorTextBadgeSeverityNeutral": "color",
      "colorGreyOpaque10": "color",
      "colorGreyOpaque25": "color",
      "colorGreyOpaque40": "color",
      "colorGreyOpaque50": "color",
      "colorGreyOpaque70": "color",
      "colorGreyOpaque80": "color",
      "colorGreyOpaque90": "color",
      "colorGreyTransparent": "color",
      "colorGreyTransparentHeavy": "color",
      "colorGreyTransparentLight": "color",
      "colorBackgroundBadgeIcon": "color",
      "colorBackgroundButtonLinkActive": "color",
      "colorBackgroundButtonLinkDefault": "color",
      "colorBackgroundButtonLinkDisabled": "color",
      "colorBackgroundButtonLinkHover": "color",
      "colorBackgroundButtonNormalActive": "color",
      "colorBackgroundButtonNormalDefault": "color",
      "colorBackgroundButtonNormalDisabled": "color",
      "colorBackgroundButtonNormalHover": "color",
      "colorBackgroundToggleButtonNormalPressed": "color",
      "colorBackgroundToggleButtonNormalDefault": "color",
      "colorBackgroundToggleButtonNormalHover": "color",
      "colorBackgroundButtonPrimaryActive": "color",
      "colorBackgroundButtonPrimaryDefault": "color",
      "colorBackgroundButtonPrimaryDisabled": "color",
      "colorBackgroundButtonPrimaryHover": "color",
      "colorBackgroundDirectionButtonActive": "color",
      "colorBackgroundDirectionButtonDefault": "color",
      "colorBackgroundDirectionButtonDisabled": "color",
      "colorBackgroundDirectionButtonHover": "color",
      "colorTextDirectionButtonDefault": "color",
      "colorTextDirectionButtonDisabled": "color",
      "colorBackgroundCalendarCurrentDate": "color",
      "colorBackgroundCellShaded": "color",
      "colorBackgroundCodeEditorGutterActiveLineDefault": "color",
      "colorBackgroundCodeEditorGutterActiveLineError": "color",
      "colorBackgroundCodeEditorGutterDefault": "color",
      "colorBackgroundCodeEditorLoading": "color",
      "colorBackgroundCodeEditorPaneItemHover": "color",
      "colorBackgroundCodeEditorStatusBar": "color",
      "colorBackgroundCard": "color",
      "colorBackgroundItemCard": "color",
      "colorBackgroundContainerContent": "color",
      "colorBackgroundContainerHeader": "color",
      "colorBackgroundControlChecked": "color",
      "colorBackgroundControlDefault": "color",
      "colorBackgroundControlDisabled": "color",
      "colorBackgroundDropdownItemDefault": "color",
      "colorBackgroundDropdownItemDimmed": "color",
      "colorBackgroundDropdownItemFilterMatch": "color",
      "colorBackgroundDropdownItemHover": "color",
      "colorBackgroundDropdownItemSelected": "color",
      "colorBackgroundHomeHeader": "color",
      "colorBackgroundInlineCode": "color",
      "colorBackgroundInputDefault": "color",
      "colorBackgroundInputDisabled": "color",
      "colorBackgroundItemSelected": "color",
      "colorBackgroundSideNavigationItemActive": "color",
      "colorBackgroundSideNavigationItemActiveCollapsed": "color",
      "colorBackgroundSideNavigationItemIconHover": "color",
      "colorBackgroundLayoutMain": "color",
      "colorBackgroundLayoutAiDrawer": "color",
      "colorBackgroundDrawer": "color",
      "colorBackgroundBackdrop": "color",
      "colorBackgroundDrawerBackdrop": "color",
      "colorBackgroundLayoutMobilePanel": "color",
      "colorBackgroundLayoutPanel": "color",
      "colorBackgroundLayoutPanelContent": "color",
      "colorBackgroundLayoutPanelHover": "color",
      "colorBackgroundLayoutToolbar": "color",
      "colorBackgroundLayoutToggleActive": "color",
      "colorBackgroundLayoutToggleDefault": "color",
      "colorBackgroundLayoutToggleHover": "color",
      "colorBackgroundLayoutToggleSelectedActive": "color",
      "colorBackgroundLayoutToggleSelectedDefault": "color",
      "colorBackgroundLayoutToggleSelectedHover": "color",
      "colorBackgroundModalOverlay": "color",
      "colorBackgroundNotificationBlue": "color",
      "colorBackgroundNotificationGreen": "color",
      "colorBackgroundNotificationGrey": "color",
      "colorBackgroundNotificationRed": "color",
      "colorBackgroundNotificationYellow": "color",
      "colorBackgroundFlashbarSuccess": "color",
      "colorBackgroundFlashbarError": "color",
      "colorBackgroundFlashbarInfo": "color",
      "colorBackgroundFlashbarWarning": "color",
      "colorBackgroundNotificationStackBar": "color",
      "colorBackgroundNotificationStackBarActive": "color",
      "colorBackgroundNotificationStackBarHover": "color",
      "colorBackgroundPopover": "color",
      "colorBackgroundProgressBarValueDefault": "color",
      "colorBackgroundProgressBarValueFlash": "color",
      "colorBackgroundProgressBarFlash": "color",
      "colorBackgroundProgressBarDefault": "color",
      "colorBackgroundSegmentActive": "color",
      "colorBackgroundSegmentDefault": "color",
      "colorBackgroundSegmentDisabled": "color",
      "colorBackgroundSegmentHover": "color",
      "colorBackgroundSegmentWrapper": "color",
      "colorBackgroundSliderRangeDefault": "color",
      "colorBackgroundSliderRangeActive": "color",
      "colorBackgroundSliderHandleDefault": "color",
      "colorBackgroundSliderHandleActive": "color",
      "colorBackgroundSliderTrackDefault": "color",
      "colorBackgroundSliderHandleRing": "color",
      "colorBackgroundSliderHandleErrorDefault": "color",
      "colorBackgroundSliderHandleErrorActive": "color",
      "colorBackgroundSliderHandleWarningDefault": "color",
      "colorBackgroundSliderHandleWarningActive": "color",
      "colorBackgroundSliderRangeErrorDefault": "color",
      "colorBackgroundSliderRangeErrorActive": "color",
      "colorBackgroundSliderRangeWarningDefault": "color",
      "colorBackgroundSliderRangeWarningActive": "color",
      "colorBackgroundStatusError": "color",
      "colorBackgroundStatusInfo": "color",
      "colorBackgroundAlertError": "color",
      "colorBackgroundAlertInfo": "color",
      "colorBackgroundAlertSuccess": "color",
      "colorBackgroundAlertWarning": "color",
      "colorBackgroundDialog": "color",
      "colorBackgroundDialogDefault": "color",
      "colorBackgroundStatusSuccess": "color",
      "colorBackgroundStatusWarning": "color",
      "colorBackgroundTableHeader": "color",
      "colorBackgroundTilesDisabled": "color",
      "colorBackgroundToggleCheckedDisabled": "color",
      "colorBackgroundToggleDefault": "color",
      "colorBackgroundAvatarGenAi": "color",
      "colorBackgroundAvatarDefault": "color",
      "colorTextAvatar": "color",
      "colorBackgroundLoadingBarGenAi": "color",
      "colorBackgroundStatusIndicatorError": "color",
      "colorBackgroundStatusIndicatorWarning": "color",
      "colorBackgroundStatusIndicatorSuccess": "color",
      "colorBackgroundStatusIndicatorInfo": "color",
      "colorBackgroundStatusIndicatorNeutral": "color",
      "colorBackgroundChatBubbleOutgoing": "color",
      "colorBackgroundChatBubbleIncoming": "color",
      "colorTextChatBubbleOutgoing": "color",
      "colorTextChatBubbleIncoming": "color",
      "colorBorderButtonLinkDisabled": "color",
      "colorBorderButtonNormalActive": "color",
      "colorBorderButtonNormalDefault": "color",
      "colorBorderToggleButtonNormalPressed": "color",
      "colorBorderToggleButtonNormalDefault": "color",
      "colorBorderToggleButtonNormalHover": "color",
      "colorBorderButtonNormalDisabled": "color",
      "colorTextButtonNormalDisabled": "color",
      "colorBorderButtonNormalHover": "color",
      "colorTextButtonIconDisabled": "color",
      "colorBorderButtonPrimaryActive": "color",
      "colorBorderButtonPrimaryDefault": "color",
      "colorBorderButtonPrimaryDisabled": "color",
      "colorBorderButtonPrimaryHover": "color",
      "colorTextButtonPrimaryDisabled": "color",
      "colorItemSelected": "color",
      "colorTextSideNavigationItemActive": "color",
      "colorTextSideNavigationItemActiveCollapsed": "color",
      "colorTextSideNavigationItemDefault": "color",
      "colorBorderCalendarGrid": "color",
      "colorBorderCalendarGridSelectedFocusRing": "color",
      "colorBorderCellShaded": "color",
      "colorBorderCodeEditorAceActiveLineLightTheme": "color",
      "colorBorderCodeEditorAceActiveLineDarkTheme": "color",
      "colorBorderCodeEditorDefault": "color",
      "colorBorderCodeEditorPaneItemHover": "color",
      "colorBorderCard": "color",
      "colorBorderCardHighlighted": "color",
      "colorBorderItemCard": "color",
      "colorBorderItemCardHighlighted": "color",
      "colorBorderContainerDivider": "color",
      "colorBorderContainerTop": "color",
      "colorBorderControlChecked": "color",
      "colorBorderControlDefault": "color",
      "colorBorderControlDisabled": "color",
      "colorBorderDividerActive": "color",
      "colorBorderDividerDefault": "color",
      "colorBorderDividerNotification": "color",
      "colorBorderDividerPanelBottom": "color",
      "colorBorderDividerPanelSide": "color",
      "colorBorderDividerSecondary": "color",
      "colorBorderDividerTableGroup": "color",
      "colorBorderDropdownContainer": "color",
      "colorBorderDropdownGroup": "color",
      "colorBorderDropdownItemDefault": "color",
      "colorBorderDropdownItemHover": "color",
      "colorBorderDropdownItemDimmedHover": "color",
      "colorBorderDropdownItemSelected": "color",
      "colorBorderDropdownItemTop": "color",
      "colorBorderEditableCellHover": "color",
      "colorBorderInputDefault": "color",
      "colorBorderInputDisabled": "color",
      "colorBorderInputFocused": "color",
      "colorBorderItemFocused": "color",
      "colorBorderDropdownItemFocused": "color",
      "colorBorderItemPlaceholder": "color",
      "colorBorderItemSelected": "color",
      "colorBorderLayout": "color",
      "colorBorderLayoutSideNavigation": "color",
      "colorBorderNotificationStackBar": "color",
      "colorBorderNotificationStackBarHover": "color",
      "colorBorderNotificationStackBarActive": "color",
      "colorBorderNotificationStackBarFocused": "color",
      "colorBorderPanelHeader": "color",
      "colorBorderPopover": "color",
      "colorBorderSegmentActive": "color",
      "colorBorderSegmentDefault": "color",
      "colorBorderSegmentDisabled": "color",
      "colorBorderSegmentDivider": "color",
      "colorBorderSegmentHover": "color",
      "colorBorderSegmentWrapper": "color",
      "colorBorderStatusError": "color",
      "colorBorderStatusInfo": "color",
      "colorBorderStatusSuccess": "color",
      "colorBorderStatusWarning": "color",
      "colorBorderDialog": "color",
      "colorBorderDialogDefault": "color",
      "colorBorderDividerInteractiveDefault": "color",
      "colorBorderTabsDivider": "color",
      "colorBorderTabsShadow": "color",
      "colorBorderTabsUnderline": "color",
      "colorBorderTilesDisabled": "color",
      "colorBorderTutorial": "color",
      "colorForegroundControlDefault": "color",
      "colorForegroundControlDisabled": "color",
      "colorForegroundControlReadOnly": "color",
      "colorShadowDefault": "color",
      "colorShadowMedium": "color",
      "colorShadowSide": "color",
      "colorShadowToggleHandle": "color",
      "colorStrokeChartLine": "color",
      "colorStrokeCodeEditorGutterActiveLineDefault": "color",
      "colorStrokeCodeEditorGutterActiveLineHover": "color",
      "colorTextAccent": "color",
      "colorTextBodyDefault": "color",
      "colorTextBodySecondary": "color",
      "colorTextBreadcrumbCurrent": "color",
      "colorTextBreadcrumbIcon": "color",
      "colorTextButtonInlineIconDefault": "color",
      "colorTextButtonInlineIconDisabled": "color",
      "colorTextButtonInlineIconHover": "color",
      "colorTextButtonInlineLinkHover": "color",
      "colorTextButtonIconHover": "color",
      "colorTextButtonNormalActive": "color",
      "colorTextToggleButtonNormalPressed": "color",
      "colorTextButtonNormalDefault": "color",
      "colorTextButtonNormalHover": "color",
      "colorTextLinkButtonNormalDefault": "color",
      "colorTextLinkButtonNormalHover": "color",
      "colorTextLinkButtonNormalActive": "color",
      "colorTextButtonLinkActive": "color",
      "colorTextButtonLinkDefault": "color",
      "colorTextButtonLinkDisabled": "color",
      "colorTextButtonLinkHover": "color",
      "colorTextButtonPrimaryActive": "color",
      "colorTextButtonPrimaryDefault": "color",
      "colorTextButtonPrimaryHover": "color",
      "colorTextCalendarDateHover": "color",
      "colorTextCalendarDateSelected": "color",
      "colorTextCalendarMonth": "color",
      "colorTextCodeEditorGutterActiveLine": "color",
      "colorTextCodeEditorGutterDefault": "color",
      "colorTextCodeEditorStatusBarDisabled": "color",
      "colorTextCodeEditorTabButtonError": "color",
      "colorTextColumnHeader": "color",
      "colorTextColumnSortingIcon": "color",
      "colorTextControlDisabled": "color",
      "colorTextCounter": "color",
      "colorTextDisabled": "color",
      "colorTextDisabledInlineEdit": "color",
      "colorTextDropdownFooter": "color",
      "colorTextDropdownGroupLabel": "color",
      "colorTextDropdownItemDefault": "color",
      "colorTextDropdownItemDimmed": "color",
      "colorTextDropdownItemDisabled": "color",
      "colorTextDropdownItemFilterMatch": "color",
      "colorTextDropdownItemHighlighted": "color",
      "colorTextDropdownItemSecondary": "color",
      "colorTextDropdownItemSecondaryHover": "color",
      "colorTextEmpty": "color",
      "colorTextExpandableSectionDefault": "color",
      "colorTextExpandableSectionHover": "color",
      "colorTextExpandableSectionNavigationIconDefault": "color",
      "colorBorderExpandableSectionDefault": "color",
      "colorTextFormDefault": "color",
      "colorTextFormLabel": "color",
      "colorTextFormSecondary": "color",
      "colorTextGroupLabel": "color",
      "colorTextLabelGenAi": "color",
      "colorTextHeadingDefault": "color",
      "colorTextHeadingSecondary": "color",
      "colorTextHomeHeaderDefault": "color",
      "colorTextHomeHeaderSecondary": "color",
      "colorTextIconCaret": "color",
      "colorTextIconSubtle": "color",
      "colorTextInputDisabled": "color",
      "colorTextInputPlaceholder": "color",
      "colorTextInputPlaceholderDisabled": "color",
      "colorTextInteractiveActive": "color",
      "colorTextInteractiveDefault": "color",
      "colorTextInteractiveDisabled": "color",
      "colorTextInteractiveHover": "color",
      "colorTextToggleButtonIconPressed": "color",
      "colorTextInteractiveInvertedDefault": "color",
      "colorTextInteractiveInvertedHover": "color",
      "colorTextInverted": "color",
      "colorTextLabel": "color",
      "colorTextKeyValuePairsValue": "color",
      "colorTextLayoutToggle": "color",
      "colorTextLayoutToggleActive": "color",
      "colorTextLayoutToggleHover": "color",
      "colorTextLayoutToggleSelected": "color",
      "colorTextLinkDefault": "color",
      "colorTextLinkHover": "color",
      "colorTextLinkDecorationDefault": "color",
      "colorTextLinkDecorationHover": "color",
      "colorTextLinkSecondaryDefault": "color",
      "colorTextLinkSecondaryHover": "color",
      "colorTextLinkSecondaryDecorationDefault": "color",
      "colorTextLinkInfoDefault": "color",
      "colorTextLinkInfoHover": "color",
      "colorTextLinkInvertedDefault": "color",
      "colorTextLinkInvertedHover": "color",
      "colorTextLinkButtonUnderline": "color",
      "colorTextLinkButtonUnderlineHover": "color",
      "colorTextNotificationDefault": "color",
      "colorTextAlertDefault": "color",
      "colorTextNotificationLinkDefault": "color",
      "colorTextNotificationLinkHover": "color",
      "colorTextNotificationStackBar": "color",
      "colorTextNotificationYellow": "color",
      "colorTextPaginationPageNumberActiveDisabled": "color",
      "colorTextPaginationPageNumberDefault": "color",
      "colorTextSegmentActive": "color",
      "colorTextSegmentDefault": "color",
      "colorTextSegmentHover": "color",
      "colorTextSmall": "color",
      "colorTextFlashbarIconError": "color",
      "colorTextFlashbarIconInfo": "color",
      "colorTextFlashbarIconSuccess": "color",
      "colorTextFlashbarIconWarning": "color",
      "colorTextAlertIconError": "color",
      "colorTextAlertIconInfo": "color",
      "colorTextAlertIconSuccess": "color",
      "colorTextAlertIconWarning": "color",
      "colorTextStatusError": "color",
      "colorTextStatusInactive": "color",
      "colorTextStatusInfo": "color",
      "colorTextStatusSuccess": "color",
      "colorTextStatusWarning": "color",
      "colorTextTopNavigationTitle": "color",
      "colorTextTutorialHotspotDefault": "color",
      "colorTextTutorialHotspotHover": "color",
      "colorBoardPlaceholderActive": "color",
      "colorBoardPlaceholderHover": "color",
      "colorDragPlaceholderActive": "color",
      "colorDragPlaceholderHover": "color",
      "colorDropzoneBackgroundDefault": "color",
      "colorDropzoneBackgroundHover": "color",
      "colorDropzoneTextDefault": "color",
      "colorDropzoneTextHover": "color",
      "colorDropzoneBorderDefault": "color",
      "colorDropzoneBorderHover": "color",
      "colorGapGlobalDrawer": "color",
      "colorTreeViewConnectorLine": "color",
      "colorBackgroundActionCardDefault": "color",
      "colorBackgroundActionCardHover": "color",
      "colorBackgroundActionCardActive": "color",
      "colorBorderActionCardDefault": "color",
      "colorBorderActionCardHover": "color",
      "colorBorderActionCardActive": "color",
      "colorBorderActionCardDisabled": "color",
      "colorBackgroundActionCardDisabled": "color",
      "colorTextActionCardDisabled": "color",
      "colorTextActionCardIconDefault": "color",
      "colorTextActionCardIconHover": "color",
      "colorTextActionCardIconActive": "color",
      "colorTextActionCardIconDisabled": "color",
      "colorBackgroundSkeleton": "color",
      "colorBackgroundSkeletonWave": "color",
      "colorBackgroundBadgeGreen": "color",
      "colorBackgroundBadgeBlue": "color",
      "colorBackgroundBadgeRed": "color",
      "colorBackgroundBadgeYellow": "color",
      "colorBackgroundBadgeGrey": "color",
      "colorBorderBadge": "color",
      "colorBorderBadgeGrey": "color",
      "colorBorderBadgeGreen": "color",
      "colorBorderBadgeBlue": "color",
      "colorBorderBadgeRed": "color",
      "colorTextBadgeGrey": "color",
      "colorTextBadgeGreen": "color",
      "colorTextBadgeBlue": "color",
      "colorTextBadgeRed": "color",
      "colorBackgroundCodeView": "color",
      "colorBackgroundVisualAccentRed": "color",
      "colorBackgroundVisualAccentYellow": "color",
      "colorBackgroundVisualAccentIndigo": "color",
      "colorBackgroundVisualAccentGreen": "color",
      "colorBackgroundVisualAccentOrange": "color",
      "colorBackgroundVisualAccentPurple": "color",
      "colorBackgroundVisualAccentLime": "color",
      "colorBackgroundVisualAccentGrey": "color",
      "colorBackgroundVisualAccentTeal": "color",
      "colorBackgroundVisualAccentBlue": "color",
      "colorBackgroundVisualAccentViolet": "color",
      "colorBackgroundVisualAccentMagenta": "color",
      "colorBackgroundVisualAccentPink": "color",
      "colorBackgroundVisualAccentAmber": "color",
      "colorTextVisualAccentRed": "color",
      "colorTextVisualAccentYellow": "color",
      "colorTextVisualAccentIndigo": "color",
      "colorTextVisualAccentGreen": "color",
      "colorTextVisualAccentOrange": "color",
      "colorTextVisualAccentPurple": "color",
      "colorTextVisualAccentLime": "color",
      "colorTextVisualAccentGrey": "color",
      "colorTextVisualAccentTeal": "color",
      "colorTextVisualAccentBlue": "color",
      "colorTextVisualAccentViolet": "color",
      "colorTextVisualAccentMagenta": "color",
      "colorTextVisualAccentPink": "color",
      "colorTextVisualAccentAmber": "color",
      "motionDurationExtraFast": "motion",
      "motionDurationExtraSlow": "motion",
      "motionDurationFast": "motion",
      "motionDurationModerate": "motion",
      "motionDurationRefreshOnlyAmbient": "motion",
      "motionDurationRefreshOnlyFast": "motion",
      "motionDurationRefreshOnlyMedium": "motion",
      "motionDurationRefreshOnlySlow": "motion",
      "motionDurationAvatarGenAiGradient": "motion",
      "motionDurationAvatarLoadingDots": "motion",
      "motionDurationRotate180": "motion",
      "motionDurationRotate90": "motion",
      "motionDurationShowPaced": "motion",
      "motionDurationShowQuick": "motion",
      "motionDurationSlow": "motion",
      "motionDurationTransitionQuick": "motion",
      "motionDurationTransitionShowPaced": "motion",
      "motionDurationTransitionShowQuick": "motion",
      "motionEasingEaseOutQuart": "motion",
      "motionEasingRefreshOnlyA": "motion",
      "motionEasingRefreshOnlyB": "motion",
      "motionEasingRefreshOnlyC": "motion",
      "motionEasingRefreshOnlyD": "motion",
      "motionEasingAvatarGenAiGradient": "motion",
      "motionEasingRotate180": "motion",
      "motionEasingRotate90": "motion",
      "motionEasingShowPaced": "motion",
      "motionEasingShowQuick": "motion",
      "motionEasingTransitionQuick": "motion",
      "motionEasingTransitionShowPaced": "motion",
      "motionEasingTransitionShowQuick": "motion",
      "motionEasingResponsive": "motion",
      "motionEasingSticky": "motion",
      "motionEasingExpressive": "motion",
      "motionDurationResponsive": "motion",
      "motionDurationExpressive": "motion",
      "motionDurationComplex": "motion",
      "motionDurationTooltipEnter": "motion",
      "motionEasingTooltipEnter": "motion",
      "motionDurationExpandableContentEnter": "motion",
      "motionEasingExpandableContentEnter": "motion",
      "motionDurationSideNavigationContentEnterFade": "motion",
      "motionDurationSideNavigationContentExit": "motion",
      "motionDurationSideNavigationContentExitFade": "motion",
      "motionEasingSideNavigationContentExit": "motion",
      "motionKeyframesFadeIn": "motion",
      "motionKeyframesFadeOut": "motion",
      "motionKeyframesStatusIconError": "motion",
      "motionKeyframesScalePopup": "motion",
      "sizeCalendarGridWidth": "density",
      "sizeControl": "density",
      "sizeIconBig": "density",
      "sizeIconLarge": "density",
      "sizeIconMedium": "density",
      "sizeIconNormal": "density",
      "sizeTableSelectionHorizontal": "density",
      "sizeVerticalInput": "density",
      "sizeVerticalPanelIconOffset": "density",
      "sizeSideNavigationItemHeight": "density",
      "sizeSideNavigationItemCollapsed": "density",
      "sizeSideNavigationCollapsedWidth": "density",
      "spaceAlertActionLeft": "density",
      "spaceAlertHorizontal": "density",
      "spaceAlertMessageRight": "density",
      "spaceAlertVertical": "density",
      "spaceButtonFocusOutlineGutter": "density",
      "spaceButtonHorizontal": "density",
      "spaceButtonVertical": "density",
      "spaceTokenVertical": "density",
      "spaceFieldVertical": "density",
      "spaceButtonIconFocusOutlineGutterVertical": "density",
      "spaceButtonIconOnlyHorizontal": "density",
      "spaceButtonInlineIconFocusOutlineGutter": "density",
      "spaceButtonModalDismissVertical": "density",
      "spaceCalendarGridFocusOutlineGutter": "density",
      "spaceCalendarGridSelectedFocusOutlineGutter": "density",
      "spaceCalendarGridGutter": "density",
      "spaceCardHorizontalDefault": "density",
      "spaceCardHorizontalEmbedded": "density",
      "spaceCardVerticalDefault": "density",
      "spaceCardVerticalEmbedded": "density",
      "spaceItemCardHorizontalDefault": "density",
      "spaceItemCardHorizontalEmbedded": "density",
      "spaceItemCardVerticalDefault": "density",
      "spaceItemCardVerticalEmbedded": "density",
      "spaceDialogHorizontal": "density",
      "spaceDialogVertical": "density",
      "spaceDialogActionBlock": "density",
      "spaceDialogActionInline": "density",
      "spaceDialogHeaderGap": "density",
      "spaceDialogSectionGap": "density",
      "spaceCodeEditorStatusFocusOutlineGutter": "density",
      "spaceContainerContentTop": "density",
      "spaceContainerHeaderTop": "density",
      "spaceContainerHeaderBottom": "density",
      "spaceContainerHorizontal": "density",
      "spaceContentHeaderPaddingBottom": "density",
      "spaceDarkHeaderOverlapDistance": "density",
      "spaceExpandableSectionIconOffsetTop": "density",
      "spaceFieldHorizontal": "density",
      "spaceFieldIconOffset": "density",
      "spaceFilteringTokenDismissButtonFocusOutlineGutter": "density",
      "spaceFilteringTokenOperationSelectFocusOutlineGutter": "density",
      "spaceFlashbarActionLeft": "density",
      "spaceFlashbarDismissRight": "density",
      "spaceFlashbarHorizontal": "density",
      "spaceFlashbarVertical": "density",
      "spaceGridGutter": "density",
      "spaceKeyValueGap": "density",
      "spaceLayoutContentBottom": "density",
      "spaceLayoutContentHorizontal": "density",
      "spaceLayoutToggleDiameter": "density",
      "spaceLayoutTogglePadding": "density",
      "spaceModalContentBottom": "density",
      "spaceModalHorizontal": "density",
      "spacePanelContentBottom": "density",
      "spacePanelContentTop": "density",
      "spacePanelDividerMarginHorizontal": "density",
      "spacePanelHeaderVertical": "density",
      "spacePanelNavLeft": "density",
      "spacePanelSideLeft": "density",
      "spacePanelSideRight": "density",
      "spacePanelSplitTop": "density",
      "spacePanelSplitBottom": "density",
      "spaceSegmentedControlFocusOutlineGutter": "density",
      "spaceTabsContentTop": "density",
      "spaceTabsFocusOutlineGutter": "density",
      "spaceTabsVertical": "density",
      "spaceTableContentBottom": "density",
      "spaceTableEmbeddedHeaderTop": "density",
      "spaceTableFooterHorizontal": "density",
      "spaceTableHeaderFocusOutlineGutter": "density",
      "spaceTableHeaderHorizontal": "density",
      "spaceTableHeaderToolsBottom": "density",
      "spaceTableHeaderToolsFullPageBottom": "density",
      "spaceTableHorizontal": "density",
      "spaceTreeViewIndentation": "density",
      "spaceSideNavigationItemDefaultGap": "density",
      "spaceSideNavigationItemIconGap": "density",
      "spaceTileGutter": "density",
      "spaceActionCardHorizontalDefault": "density",
      "spaceActionCardHorizontalEmbedded": "density",
      "spaceActionCardVerticalDefault": "density",
      "spaceActionCardVerticalEmbedded": "density",
      "spaceActionCardDescriptionPaddingTop": "density",
      "spaceActionCardContentPaddingTop": "density",
      "spaceOptionPaddingVertical": "density",
      "spaceOptionPaddingHorizontal": "density",
      "spaceStatusIndicatorPaddingHorizontal": "density",
      "spaceScaled2xNone": "density",
      "spaceScaled2xXxxs": "density",
      "spaceScaled2xXxs": "density",
      "spaceScaled2xXs": "density",
      "spaceScaled2xS": "density",
      "spaceScaled2xM": "density",
      "spaceScaled2xL": "density",
      "spaceScaled2xXl": "density",
      "spaceScaled2xXxl": "density",
      "spaceScaled2xXxxl": "density",
      "spaceScaledNone": "density",
      "spaceScaledXxxs": "density",
      "spaceScaledXxs": "density",
      "spaceScaledXs": "density",
      "spaceScaledS": "density",
      "spaceScaledM": "density",
      "spaceScaledL": "density",
      "spaceScaledXl": "density",
      "spaceScaledXxl": "density",
      "spaceScaledXxxl": "density",
      "spaceStaticXxxs": "density",
      "spaceStaticXxs": "density",
      "spaceStaticXs": "density",
      "spaceStaticS": "density",
      "spaceStaticM": "density",
      "spaceStaticL": "density",
      "spaceStaticXl": "density",
      "spaceStaticXxl": "density",
      "spaceStaticXxxl": "density",
      "spaceNone": "density",
      "spaceXxxs": "density",
      "spaceXxs": "density",
      "spaceXs": "density",
      "spaceS": "density",
      "spaceM": "density",
      "spaceL": "density",
      "spaceXl": "density",
      "spaceXxl": "density",
      "spaceXxxl": "density",
      "shadowCard": "color",
      "shadowItemCard": "color",
      "shadowDialog": "color",
      "shadowContainer": "color",
      "shadowContainerActive": "color",
      "shadowDropdown": "color",
      "shadowDropup": "color",
      "shadowFlashCollapsed": "color",
      "shadowFlashSticky": "color",
      "shadowModal": "color",
      "shadowPanel": "color",
      "shadowPanelToggle": "color",
      "shadowPopover": "color",
      "shadowSplitBottom": "color",
      "shadowSplitSide": "color",
      "shadowSticky": "color",
      "shadowStickyEmbedded": "color",
      "shadowStickyColumnFirst": "color",
      "shadowStickyColumnLast": "color"
    },
    "referenceTokens": {
      "color": {
        "primary": {
          "50": {
            "light": "#f1faff",
            "dark": "#f1faff"
          },
          "100": {
            "light": "#d1f1ff",
            "dark": "#d1f1ff"
          },
          "200": {
            "light": "#99cbe4",
            "dark": "#99cbe4"
          },
          "300": {
            "light": "#44b9d6",
            "dark": "#44b9d6"
          },
          "400": {
            "light": "#00a1c9",
            "dark": "#00a1c9"
          },
          "500": {
            "light": "#0099ff",
            "dark": "#0099ff"
          },
          "600": {
            "light": "#0073bb",
            "dark": "#0073bb"
          },
          "700": {
            "light": "#0a4a74",
            "dark": "#0a4a74"
          },
          "800": {
            "light": "#003b8f",
            "dark": "#003b8f"
          },
          "900": {
            "light": "#002b66",
            "dark": "#002b66"
          },
          "950": {
            "light": "#00204d",
            "dark": "#00204d"
          },
          "1000": {
            "light": "#12293b",
            "dark": "#12293b"
          }
        },
        "neutral": {
          "50": {
            "light": "#fcfcfd",
            "dark": "#fcfcfd"
          },
          "100": {
            "light": "#fafafa",
            "dark": "#fafafa"
          },
          "150": {
            "light": "#f6f6f9",
            "dark": "#f6f6f9"
          },
          "200": {
            "light": "#f2f3f3",
            "dark": "#f2f3f3"
          },
          "250": {
            "light": "#eaeded",
            "dark": "#eaeded"
          },
          "300": {
            "light": "#d5dbdb",
            "dark": "#d5dbdb"
          },
          "350": {
            "light": "#c6c6cd",
            "dark": "#c6c6cd"
          },
          "400": {
            "light": "#aab7b8",
            "dark": "#aab7b8"
          },
          "450": {
            "light": "#95a5a6",
            "dark": "#95a5a6"
          },
          "500": {
            "light": "#879596",
            "dark": "#879596"
          },
          "550": {
            "light": "#72747e",
            "dark": "#72747e"
          },
          "600": {
            "light": "#687078",
            "dark": "#687078"
          },
          "650": {
            "light": "#545b64",
            "dark": "#545b64"
          },
          "700": {
            "light": "#414750",
            "dark": "#414750"
          },
          "750": {
            "light": "#2a2e33",
            "dark": "#2a2e33"
          },
          "800": {
            "light": "#21252c",
            "dark": "#21252c"
          },
          "850": {
            "light": "#1a2029",
            "dark": "#1a2029"
          },
          "900": {
            "light": "#131920",
            "dark": "#131920"
          },
          "950": {
            "light": "#16191f",
            "dark": "#16191f"
          },
          "1000": {
            "light": "#06080a",
            "dark": "#06080a"
          }
        },
        "error": {
          "50": {
            "light": "#fdf3f1",
            "dark": "#fdf3f1"
          },
          "100": {
            "light": "#ffe0e0",
            "dark": "#ffe0e0"
          },
          "400": {
            "light": "#ff5d64",
            "dark": "#ff5d64"
          },
          "600": {
            "light": "#d13212",
            "dark": "#d13212"
          },
          "700": {
            "light": "#c20000",
            "dark": "#c20000"
          },
          "800": {
            "light": "#990000",
            "dark": "#990000"
          },
          "900": {
            "light": "#700000",
            "dark": "#700000"
          },
          "950": {
            "light": "#520000",
            "dark": "#520000"
          },
          "1000": {
            "light": "#270a11",
            "dark": "#270a11"
          }
        },
        "success": {
          "50": {
            "light": "#f2f8f0",
            "dark": "#f2f8f0"
          },
          "100": {
            "light": "#d9ffd6",
            "dark": "#d9ffd6"
          },
          "200": {
            "light": "#aeffa8",
            "dark": "#aeffa8"
          },
          "400": {
            "light": "#00e500",
            "dark": "#00e500"
          },
          "500": {
            "light": "#6aaf35",
            "dark": "#6aaf35"
          },
          "600": {
            "light": "#1d8102",
            "dark": "#1d8102"
          },
          "800": {
            "light": "#005c26",
            "dark": "#005c26"
          },
          "950": {
            "light": "#003311",
            "dark": "#003311"
          },
          "1000": {
            "light": "#172211",
            "dark": "#172211"
          }
        },
        "warning": {
          "50": {
            "light": "#fffef0",
            "dark": "#fffef0"
          },
          "100": {
            "light": "#fffbbd",
            "dark": "#fffbbd"
          },
          "200": {
            "light": "#fef571",
            "dark": "#fef571"
          },
          "400": {
            "light": "#ffe347",
            "dark": "#ffe347"
          },
          "500": {
            "light": "#fbd332",
            "dark": "#fbd332"
          },
          "600": {
            "light": "#f2b100",
            "dark": "#f2b100"
          },
          "800": {
            "light": "#9e6900",
            "dark": "#9e6900"
          },
          "900": {
            "light": "#906806",
            "dark": "#906806"
          },
          "950": {
            "light": "#573a00",
            "dark": "#573a00"
          },
          "1000": {
            "light": "#191100",
            "dark": "#191100"
          }
        },
        "info": {
          "50": {
            "light": "#f1faff",
            "dark": "#f1faff"
          },
          "100": {
            "light": "#d1f1ff",
            "dark": "#d1f1ff"
          },
          "300": {
            "light": "#44b9d6",
            "dark": "#44b9d6"
          },
          "400": {
            "light": "#00a1c9",
            "dark": "#00a1c9"
          },
          "600": {
            "light": "#0073bb",
            "dark": "#0073bb"
          },
          "700": {
            "light": "#004a9e",
            "dark": "#004a9e"
          },
          "800": {
            "light": "#003b8f",
            "dark": "#003b8f"
          },
          "950": {
            "light": "#00204d",
            "dark": "#00204d"
          },
          "1000": {
            "light": "#12293b",
            "dark": "#12293b"
          }
        }
      }
    }
  },
  "secondary": [
    {
      "id": "visual-refresh",
      "selector": ".awsui-visual-refresh:not(.awsui-one-theme)",
      "modes": {
        "color": {
          "id": "color",
          "states": {
            "light": {
              "default": true
            },
            "dark": {
              "selector": ".awsui-dark-mode",
              "media": "not print"
            }
          }
        },
        "density": {
          "id": "density",
          "states": {
            "comfortable": {
              "default": true
            },
            "compact": {
              "selector": ".awsui-compact-mode"
            }
          }
        },
        "motion": {
          "id": "motion",
          "states": {
            "default": {
              "default": true
            },
            "disabled": {
              "selector": ".awsui-motion-disabled"
            }
          }
        }
      },
      "tokens": {
        "colorPrimary50": {
          "light": "#f0fbff",
          "dark": "#f0fbff"
        },
        "colorPrimary100": {
          "light": "#d1f1ff",
          "dark": "#d1f1ff"
        },
        "colorPrimary200": {
          "light": "#b8e7ff",
          "dark": "#b8e7ff"
        },
        "colorPrimary300": {
          "light": "#75cfff",
          "dark": "#75cfff"
        },
        "colorPrimary400": {
          "light": "#42b4ff",
          "dark": "#42b4ff"
        },
        "colorPrimary500": {
          "light": "#0099ff",
          "dark": "#0099ff"
        },
        "colorPrimary600": {
          "light": "#006ce0",
          "dark": "#006ce0"
        },
        "colorPrimary700": {
          "light": "#004a9e",
          "dark": "#004a9e"
        },
        "colorPrimary800": {
          "light": "#003b8f",
          "dark": "#003b8f"
        },
        "colorPrimary900": {
          "light": "#002b66",
          "dark": "#002b66"
        },
        "colorPrimary950": {
          "light": "#00204d",
          "dark": "#00204d"
        },
        "colorPrimary1000": {
          "light": "#001129",
          "dark": "#001129"
        },
        "colorNeutral50": {
          "light": "#fcfcfd",
          "dark": "#fcfcfd"
        },
        "colorNeutral100": {
          "light": "#f9f9fa",
          "dark": "#f9f9fa"
        },
        "colorNeutral150": {
          "light": "#f6f6f9",
          "dark": "#f6f6f9"
        },
        "colorNeutral200": {
          "light": "#f3f3f7",
          "dark": "#f3f3f7"
        },
        "colorNeutral250": {
          "light": "#ebebf0",
          "dark": "#ebebf0"
        },
        "colorNeutral300": {
          "light": "#dedee3",
          "dark": "#dedee3"
        },
        "colorNeutral350": {
          "light": "#c6c6cd",
          "dark": "#c6c6cd"
        },
        "colorNeutral400": {
          "light": "#b4b4bb",
          "dark": "#b4b4bb"
        },
        "colorNeutral450": {
          "light": "#a4a4ad",
          "dark": "#a4a4ad"
        },
        "colorNeutral500": {
          "light": "#8c8c94",
          "dark": "#8c8c94"
        },
        "colorNeutral550": {
          "light": "#72747e",
          "dark": "#72747e"
        },
        "colorNeutral600": {
          "light": "#656871",
          "dark": "#656871"
        },
        "colorNeutral650": {
          "light": "#424650",
          "dark": "#424650"
        },
        "colorNeutral700": {
          "light": "#333843",
          "dark": "#333843"
        },
        "colorNeutral750": {
          "light": "#232b37",
          "dark": "#232b37"
        },
        "colorNeutral800": {
          "light": "#1b232d",
          "dark": "#1b232d"
        },
        "colorNeutral850": {
          "light": "#161d26",
          "dark": "#161d26"
        },
        "colorNeutral900": {
          "light": "#131920",
          "dark": "#131920"
        },
        "colorNeutral950": {
          "light": "#0f141a",
          "dark": "#0f141a"
        },
        "colorNeutral1000": {
          "light": "#06080a",
          "dark": "#06080a"
        },
        "colorError50": {
          "light": "#fff5f5",
          "dark": "#fff5f5"
        },
        "colorError100": {
          "light": "#ffe0e0",
          "dark": "#ffe0e0"
        },
        "colorError400": {
          "light": "#ff7a7a",
          "dark": "#ff7a7a"
        },
        "colorError600": {
          "light": "#db0000",
          "dark": "#db0000"
        },
        "colorError700": {
          "light": "#c20000",
          "dark": "#c20000"
        },
        "colorError800": {
          "light": "#990000",
          "dark": "#990000"
        },
        "colorError900": {
          "light": "#700000",
          "dark": "#700000"
        },
        "colorError950": {
          "light": "#520000",
          "dark": "#520000"
        },
        "colorError1000": {
          "light": "#1f0000",
          "dark": "#1f0000"
        },
        "colorSuccess50": {
          "light": "#effff1",
          "dark": "#effff1"
        },
        "colorSuccess100": {
          "light": "#d9ffd6",
          "dark": "#d9ffd6"
        },
        "colorSuccess200": {
          "light": "#aeffa8",
          "dark": "#aeffa8"
        },
        "colorSuccess400": {
          "light": "#00e500",
          "dark": "#00e500"
        },
        "colorSuccess500": {
          "light": "#2bb534",
          "dark": "#2bb534"
        },
        "colorSuccess600": {
          "light": "#00802f",
          "dark": "#00802f"
        },
        "colorSuccess800": {
          "light": "#005c26",
          "dark": "#005c26"
        },
        "colorSuccess950": {
          "light": "#003311",
          "dark": "#003311"
        },
        "colorSuccess1000": {
          "light": "#001401",
          "dark": "#001401"
        },
        "colorWarning50": {
          "light": "#fffef0",
          "dark": "#fffef0"
        },
        "colorWarning100": {
          "light": "#fffbbd",
          "dark": "#fffbbd"
        },
        "colorWarning200": {
          "light": "#fef571",
          "dark": "#fef571"
        },
        "colorWarning400": {
          "light": "#ffe347",
          "dark": "#ffe347"
        },
        "colorWarning500": {
          "light": "#fbd332",
          "dark": "#fbd332"
        },
        "colorWarning600": {
          "light": "#f2b100",
          "dark": "#f2b100"
        },
        "colorWarning800": {
          "light": "#9e6900",
          "dark": "#9e6900"
        },
        "colorWarning900": {
          "light": "#855900",
          "dark": "#855900"
        },
        "colorWarning950": {
          "light": "#573a00",
          "dark": "#573a00"
        },
        "colorWarning1000": {
          "light": "#191100",
          "dark": "#191100"
        },
        "colorInfo50": {
          "light": "#f0fbff",
          "dark": "#f0fbff"
        },
        "colorInfo100": {
          "light": "#d1f1ff",
          "dark": "#d1f1ff"
        },
        "colorInfo300": {
          "light": "#75cfff",
          "dark": "#75cfff"
        },
        "colorInfo400": {
          "light": "#42b4ff",
          "dark": "#42b4ff"
        },
        "colorInfo600": {
          "light": "#006ce0",
          "dark": "#006ce0"
        },
        "colorInfo700": {
          "light": "#004a9e",
          "dark": "#004a9e"
        },
        "colorInfo800": {
          "light": "#003b8f",
          "dark": "#003b8f"
        },
        "colorInfo950": {
          "light": "#00204d",
          "dark": "#00204d"
        },
        "colorInfo1000": {
          "light": "#001129",
          "dark": "#001129"
        },
        "colorGrey50": {
          "light": "#fcfcfd",
          "dark": "#fcfcfd"
        },
        "colorGrey100": {
          "light": "#f9f9fa",
          "dark": "#f9f9fa"
        },
        "colorGrey150": {
          "light": "#f6f6f9",
          "dark": "#f6f6f9"
        },
        "colorGrey200": {
          "light": "#f3f3f7",
          "dark": "#f3f3f7"
        },
        "colorGrey250": {
          "light": "#ebebf0",
          "dark": "#ebebf0"
        },
        "colorGrey300": {
          "light": "#dedee3",
          "dark": "#dedee3"
        },
        "colorGrey350": {
          "light": "#c6c6cd",
          "dark": "#c6c6cd"
        },
        "colorGrey400": {
          "light": "#b4b4bb",
          "dark": "#b4b4bb"
        },
        "colorGrey450": {
          "light": "#a4a4ad",
          "dark": "#a4a4ad"
        },
        "colorGrey500": {
          "light": "#8c8c94",
          "dark": "#8c8c94"
        },
        "colorGrey600": {
          "light": "#656871",
          "dark": "#656871"
        },
        "colorGrey650": {
          "light": "#424650",
          "dark": "#424650"
        },
        "colorGrey700": {
          "light": "#333843",
          "dark": "#333843"
        },
        "colorGrey750": {
          "light": "#232b37",
          "dark": "#232b37"
        },
        "colorGrey800": {
          "light": "#1b232d",
          "dark": "#1b232d"
        },
        "colorGrey850": {
          "light": "#161d26",
          "dark": "#161d26"
        },
        "colorGrey900": {
          "light": "#131920",
          "dark": "#131920"
        },
        "colorGrey950": {
          "light": "#0f141a",
          "dark": "#0f141a"
        },
        "colorGrey1000": {
          "light": "#06080a",
          "dark": "#06080a"
        },
        "colorBlue50": {
          "light": "#f0fbff",
          "dark": "#f0fbff"
        },
        "colorBlue100": {
          "light": "#d1f1ff",
          "dark": "#d1f1ff"
        },
        "colorBlue200": {
          "light": "#b8e7ff",
          "dark": "#b8e7ff"
        },
        "colorBlue300": {
          "light": "#75cfff",
          "dark": "#75cfff"
        },
        "colorBlue400": {
          "light": "#42b4ff",
          "dark": "#42b4ff"
        },
        "colorBlue600": {
          "light": "#006ce0",
          "dark": "#006ce0"
        },
        "colorBlue700": {
          "light": "#004a9e",
          "dark": "#004a9e"
        },
        "colorBlue900": {
          "light": "#002b66",
          "dark": "#002b66"
        },
        "colorBlue1000": {
          "light": "#001129",
          "dark": "#001129"
        },
        "colorGreen50": {
          "light": "#effff1",
          "dark": "#effff1"
        },
        "colorGreen500": {
          "light": "#2bb534",
          "dark": "#2bb534"
        },
        "colorGreen600": {
          "light": "#00802f",
          "dark": "#00802f"
        },
        "colorGreen900": {
          "light": "#00471e",
          "dark": "#00471e"
        },
        "colorGreen1000": {
          "light": "#001401",
          "dark": "#001401"
        },
        "colorRed50": {
          "light": "#fff5f5",
          "dark": "#fff5f5"
        },
        "colorRed400": {
          "light": "#ff7a7a",
          "dark": "#ff7a7a"
        },
        "colorRed600": {
          "light": "#db0000",
          "dark": "#db0000"
        },
        "colorRed900": {
          "light": "#700000",
          "dark": "#700000"
        },
        "colorRed1000": {
          "light": "#1f0000",
          "dark": "#1f0000"
        },
        "colorYellow50": {
          "light": "#fffef0",
          "dark": "#fffef0"
        },
        "colorYellow400": {
          "light": "#ffe347",
          "dark": "#ffe347"
        },
        "colorYellow500": {
          "light": "#fbd332",
          "dark": "#fbd332"
        },
        "colorYellow900": {
          "light": "#855900",
          "dark": "#855900"
        },
        "colorYellow1000": {
          "light": "#191100",
          "dark": "#191100"
        },
        "colorPurple400": {
          "light": "#bf80ff",
          "dark": "#bf80ff"
        },
        "colorPurple700": {
          "light": "#7300e5",
          "dark": "#7300e5"
        },
        "colorAmber400": {
          "light": "#ff9900",
          "dark": "#ff9900"
        },
        "colorAmber500": {
          "light": "#fa6f00",
          "dark": "#fa6f00"
        },
        "colorRed950": {
          "light": "#520000",
          "dark": "#520000"
        },
        "colorOrange50": {
          "light": "#fff7f5",
          "dark": "#fff7f5"
        },
        "colorOrange100": {
          "light": "#ffe0d6",
          "dark": "#ffe0d6"
        },
        "colorOrange400": {
          "light": "#ff6a3d",
          "dark": "#ff6a3d"
        },
        "colorOrange700": {
          "light": "#a82700",
          "dark": "#a82700"
        },
        "colorOrange800": {
          "light": "#8a2000",
          "dark": "#8a2000"
        },
        "colorOrange950": {
          "light": "#471100",
          "dark": "#471100"
        },
        "colorYellow600": {
          "light": "#f2b100",
          "dark": "#f2b100"
        },
        "colorYellow950": {
          "light": "#573a00",
          "dark": "#573a00"
        },
        "colorLime50": {
          "light": "#f7ffeb",
          "dark": "#f7ffeb"
        },
        "colorLime100": {
          "light": "#ebffcc",
          "dark": "#ebffcc"
        },
        "colorLime400": {
          "light": "#7ae500",
          "dark": "#7ae500"
        },
        "colorLime700": {
          "light": "#007000",
          "dark": "#007000"
        },
        "colorLime800": {
          "light": "#005700",
          "dark": "#005700"
        },
        "colorLime950": {
          "light": "#002e00",
          "dark": "#002e00"
        },
        "colorGreen400": {
          "light": "#00e500",
          "dark": "#00e500"
        },
        "colorGreen950": {
          "light": "#003311",
          "dark": "#003311"
        },
        "colorMint50": {
          "light": "#ebfff6",
          "dark": "#ebfff6"
        },
        "colorMint100": {
          "light": "#ccffe9",
          "dark": "#ccffe9"
        },
        "colorMint400": {
          "light": "#00e582",
          "dark": "#00e582"
        },
        "colorMint700": {
          "light": "#006b48",
          "dark": "#006b48"
        },
        "colorMint800": {
          "light": "#005237",
          "dark": "#005237"
        },
        "colorMint950": {
          "light": "#003322",
          "dark": "#003322"
        },
        "colorIndigo50": {
          "light": "#f5f7ff",
          "dark": "#f5f7ff"
        },
        "colorIndigo400": {
          "light": "#7598ff",
          "dark": "#7598ff"
        },
        "colorIndigo600": {
          "light": "#295eff",
          "dark": "#295eff"
        },
        "colorIndigo950": {
          "light": "#001475",
          "dark": "#001475"
        },
        "colorPurple50": {
          "light": "#faf5ff",
          "dark": "#faf5ff"
        },
        "colorPurple100": {
          "light": "#f2e5ff",
          "dark": "#f2e5ff"
        },
        "colorPurple600": {
          "light": "#962eff",
          "dark": "#962eff"
        },
        "colorPurple800": {
          "light": "#5900b2",
          "dark": "#5900b2"
        },
        "colorPurple950": {
          "light": "#300061",
          "dark": "#300061"
        },
        "colorTeal50": {
          "light": "#ebfffe",
          "dark": "#ebfffe"
        },
        "colorTeal100": {
          "light": "#ccfffc",
          "dark": "#ccfffc"
        },
        "colorTeal400": {
          "light": "#00d6c8",
          "dark": "#00d6c8"
        },
        "colorTeal700": {
          "light": "#00665f",
          "dark": "#00665f"
        },
        "colorTeal800": {
          "light": "#00524c",
          "dark": "#00524c"
        },
        "colorTeal950": {
          "light": "#003330",
          "dark": "#003330"
        },
        "colorCyan50": {
          "light": "#f0feff",
          "dark": "#f0feff"
        },
        "colorCyan100": {
          "light": "#d1fbff",
          "dark": "#d1fbff"
        },
        "colorCyan400": {
          "light": "#00d2e5",
          "dark": "#00d2e5"
        },
        "colorCyan700": {
          "light": "#00627a",
          "dark": "#00627a"
        },
        "colorCyan800": {
          "light": "#004761",
          "dark": "#004761"
        },
        "colorCyan950": {
          "light": "#00293d",
          "dark": "#00293d"
        },
        "colorBlue950": {
          "light": "#00204d",
          "dark": "#00204d"
        },
        "colorViolet50": {
          "light": "#f6f5ff",
          "dark": "#f6f5ff"
        },
        "colorViolet100": {
          "light": "#e8e5ff",
          "dark": "#e8e5ff"
        },
        "colorViolet400": {
          "light": "#978aff",
          "dark": "#978aff"
        },
        "colorViolet700": {
          "light": "#5724ff",
          "dark": "#5724ff"
        },
        "colorViolet800": {
          "light": "#4200db",
          "dark": "#4200db"
        },
        "colorViolet950": {
          "light": "#250070",
          "dark": "#250070"
        },
        "colorFuchsia50": {
          "light": "#fff5fe",
          "dark": "#fff5fe"
        },
        "colorFuchsia100": {
          "light": "#fce5ff",
          "dark": "#fce5ff"
        },
        "colorFuchsia400": {
          "light": "#ec70ff",
          "dark": "#ec70ff"
        },
        "colorFuchsia700": {
          "light": "#a000b8",
          "dark": "#a000b8"
        },
        "colorFuchsia800": {
          "light": "#78008a",
          "dark": "#78008a"
        },
        "colorFuchsia950": {
          "light": "#43004d",
          "dark": "#43004d"
        },
        "colorMagenta50": {
          "light": "#fff5fe",
          "dark": "#fff5fe"
        },
        "colorMagenta100": {
          "light": "#ffe0fb",
          "dark": "#ffe0fb"
        },
        "colorMagenta400": {
          "light": "#ff57e9",
          "dark": "#ff57e9"
        },
        "colorMagenta700": {
          "light": "#b2008f",
          "dark": "#b2008f"
        },
        "colorMagenta800": {
          "light": "#8f0072",
          "dark": "#8f0072"
        },
        "colorMagenta950": {
          "light": "#470039",
          "dark": "#470039"
        },
        "colorPink50": {
          "light": "#fff5fa",
          "dark": "#fff5fa"
        },
        "colorPink100": {
          "light": "#ffe0f0",
          "dark": "#ffe0f0"
        },
        "colorPink400": {
          "light": "#ff66b2",
          "dark": "#ff66b2"
        },
        "colorPink700": {
          "light": "#bb005d",
          "dark": "#bb005d"
        },
        "colorPink800": {
          "light": "#8f0047",
          "dark": "#8f0047"
        },
        "colorPink950": {
          "light": "#4d0020",
          "dark": "#4d0020"
        },
        "colorRose50": {
          "light": "#fff5f8",
          "dark": "#fff5f8"
        },
        "colorRose100": {
          "light": "#ffe0e8",
          "dark": "#ffe0e8"
        },
        "colorRose400": {
          "light": "#ff5c85",
          "dark": "#ff5c85"
        },
        "colorRose700": {
          "light": "#c20030",
          "dark": "#c20030"
        },
        "colorRose800": {
          "light": "#940025",
          "dark": "#940025"
        },
        "colorRose950": {
          "light": "#4d0013",
          "dark": "#4d0013"
        },
        "colorAmber50": {
          "light": "#fff7e6",
          "dark": "#fff7e6"
        },
        "colorAmber100": {
          "light": "#ffe8bd",
          "dark": "#ffe8bd"
        },
        "colorAmber700": {
          "light": "#9e3700",
          "dark": "#9e3700"
        },
        "colorAmber800": {
          "light": "#7a2b00",
          "dark": "#7a2b00"
        },
        "colorAmber950": {
          "light": "#471500",
          "dark": "#471500"
        },
        "colorAwsSquidInk": {
          "light": "#232f3e",
          "dark": "#232f3e"
        },
        "colorTransparent": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBlack": {
          "light": "#000000",
          "dark": "#000000"
        },
        "colorWhite": {
          "light": "#ffffff",
          "dark": "#ffffff"
        },
        "colorChartsRed300": {
          "light": "#ea7158",
          "dark": "#d63f38"
        },
        "colorChartsRed400": {
          "light": "#dc5032",
          "dark": "#ed5958"
        },
        "colorChartsRed500": {
          "light": "#d13313",
          "dark": "#fe6e73"
        },
        "colorChartsRed600": {
          "light": "#ba2e0f",
          "dark": "#ff8a8a"
        },
        "colorChartsRed700": {
          "light": "#a82a0c",
          "dark": "#ffa09e"
        },
        "colorChartsRed800": {
          "light": "#972709",
          "dark": "#ffb3b0"
        },
        "colorChartsRed900": {
          "light": "#892407",
          "dark": "#ffc4c0"
        },
        "colorChartsRed1000": {
          "light": "#7d2105",
          "dark": "#ffd2cf"
        },
        "colorChartsRed1100": {
          "light": "#721e03",
          "dark": "#ffe0dd"
        },
        "colorChartsRed1200": {
          "light": "#671c00",
          "dark": "#ffecea"
        },
        "colorChartsOrange300": {
          "light": "#e07941",
          "dark": "#c55305"
        },
        "colorChartsOrange400": {
          "light": "#cc5f21",
          "dark": "#de6923"
        },
        "colorChartsOrange500": {
          "light": "#bc4d01",
          "dark": "#f27c36"
        },
        "colorChartsOrange600": {
          "light": "#a84401",
          "dark": "#f89256"
        },
        "colorChartsOrange700": {
          "light": "#983c02",
          "dark": "#fca572"
        },
        "colorChartsOrange800": {
          "light": "#8a3603",
          "dark": "#ffb68b"
        },
        "colorChartsOrange900": {
          "light": "#7e3103",
          "dark": "#ffc6a4"
        },
        "colorChartsOrange1000": {
          "light": "#732c02",
          "dark": "#ffd4bb"
        },
        "colorChartsOrange1100": {
          "light": "#692801",
          "dark": "#ffe1cf"
        },
        "colorChartsOrange1200": {
          "light": "#602400",
          "dark": "#ffede2"
        },
        "colorChartsYellow300": {
          "light": "#b2911c",
          "dark": "#977001"
        },
        "colorChartsYellow400": {
          "light": "#9c7b0b",
          "dark": "#b08400"
        },
        "colorChartsYellow500": {
          "light": "#8a6b05",
          "dark": "#c59600"
        },
        "colorChartsYellow600": {
          "light": "#7b5f04",
          "dark": "#d3a61c"
        },
        "colorChartsYellow700": {
          "light": "#6f5504",
          "dark": "#dfb52c"
        },
        "colorChartsYellow800": {
          "light": "#654d03",
          "dark": "#eac33a"
        },
        "colorChartsYellow900": {
          "light": "#5d4503",
          "dark": "#f1cf65"
        },
        "colorChartsYellow1000": {
          "light": "#553f03",
          "dark": "#f7db8a"
        },
        "colorChartsYellow1100": {
          "light": "#4d3901",
          "dark": "#fce5a8"
        },
        "colorChartsYellow1200": {
          "light": "#483300",
          "dark": "#ffefc9"
        },
        "colorChartsGreen300": {
          "light": "#67a353",
          "dark": "#48851a"
        },
        "colorChartsGreen400": {
          "light": "#41902c",
          "dark": "#5a9b29"
        },
        "colorChartsGreen500": {
          "light": "#1f8104",
          "dark": "#69ae34"
        },
        "colorChartsGreen600": {
          "light": "#1a7302",
          "dark": "#7dbd4c"
        },
        "colorChartsGreen700": {
          "light": "#176702",
          "dark": "#8fca61"
        },
        "colorChartsGreen800": {
          "light": "#145d02",
          "dark": "#9fd673"
        },
        "colorChartsGreen900": {
          "light": "#125502",
          "dark": "#b2df8d"
        },
        "colorChartsGreen1000": {
          "light": "#104d01",
          "dark": "#c5e7a8"
        },
        "colorChartsGreen1100": {
          "light": "#0f4601",
          "dark": "#d5efbe"
        },
        "colorChartsGreen1200": {
          "light": "#0d4000",
          "dark": "#e4f7d5"
        },
        "colorChartsTeal300": {
          "light": "#2ea597",
          "dark": "#018977"
        },
        "colorChartsTeal400": {
          "light": "#1c8e81",
          "dark": "#009d89"
        },
        "colorChartsTeal500": {
          "light": "#0d7d70",
          "dark": "#00b09b"
        },
        "colorChartsTeal600": {
          "light": "#096f64",
          "dark": "#40bfa9"
        },
        "colorChartsTeal700": {
          "light": "#06645a",
          "dark": "#5fccb7"
        },
        "colorChartsTeal800": {
          "light": "#045b52",
          "dark": "#77d7c3"
        },
        "colorChartsTeal900": {
          "light": "#03524a",
          "dark": "#94e0d0"
        },
        "colorChartsTeal1000": {
          "light": "#014b44",
          "dark": "#ace9db"
        },
        "colorChartsTeal1100": {
          "light": "#01443e",
          "dark": "#c2f0e6"
        },
        "colorChartsTeal1200": {
          "light": "#003e38",
          "dark": "#d7f7f0"
        },
        "colorChartsBlue1300": {
          "light": "#529ccb",
          "dark": "#00819c"
        },
        "colorChartsBlue1400": {
          "light": "#3184c2",
          "dark": "#0497ba"
        },
        "colorChartsBlue1500": {
          "light": "#0273bb",
          "dark": "#08aad2"
        },
        "colorChartsBlue1600": {
          "light": "#0166ab",
          "dark": "#44b9dd"
        },
        "colorChartsBlue1700": {
          "light": "#015b9d",
          "dark": "#63c6e7"
        },
        "colorChartsBlue1800": {
          "light": "#015292",
          "dark": "#79d2f0"
        },
        "colorChartsBlue1900": {
          "light": "#014a87",
          "dark": "#98dcf5"
        },
        "colorChartsBlue11000": {
          "light": "#01437d",
          "dark": "#b3e4f8"
        },
        "colorChartsBlue11100": {
          "light": "#003c75",
          "dark": "#caedfc"
        },
        "colorChartsBlue11200": {
          "light": "#00366d",
          "dark": "#ddf4ff"
        },
        "colorChartsBlue2300": {
          "light": "#688ae8",
          "dark": "#486de8"
        },
        "colorChartsBlue2400": {
          "light": "#5978e3",
          "dark": "#6384f5"
        },
        "colorChartsBlue2500": {
          "light": "#4066df",
          "dark": "#7698fe"
        },
        "colorChartsBlue2600": {
          "light": "#3759ce",
          "dark": "#8ea9ff"
        },
        "colorChartsBlue2700": {
          "light": "#314fbf",
          "dark": "#a2b8ff"
        },
        "colorChartsBlue2800": {
          "light": "#2c46b1",
          "dark": "#b1c5ff"
        },
        "colorChartsBlue2900": {
          "light": "#273ea5",
          "dark": "#c3d1ff"
        },
        "colorChartsBlue21000": {
          "light": "#23379b",
          "dark": "#d2dcff"
        },
        "colorChartsBlue21100": {
          "light": "#1f3191",
          "dark": "#dfe6ff"
        },
        "colorChartsBlue21200": {
          "light": "#1b2b88",
          "dark": "#ecf0ff"
        },
        "colorChartsPurple300": {
          "light": "#a783e1",
          "dark": "#8d59de"
        },
        "colorChartsPurple400": {
          "light": "#9469d6",
          "dark": "#a173ea"
        },
        "colorChartsPurple500": {
          "light": "#8456ce",
          "dark": "#b088f5"
        },
        "colorChartsPurple600": {
          "light": "#7749bf",
          "dark": "#bf9bf9"
        },
        "colorChartsPurple700": {
          "light": "#6b40b2",
          "dark": "#cbabfc"
        },
        "colorChartsPurple800": {
          "light": "#6237a7",
          "dark": "#d6baff"
        },
        "colorChartsPurple900": {
          "light": "#59309d",
          "dark": "#dfc8ff"
        },
        "colorChartsPurple1000": {
          "light": "#512994",
          "dark": "#e8d5ff"
        },
        "colorChartsPurple1100": {
          "light": "#4a238b",
          "dark": "#efe2ff"
        },
        "colorChartsPurple1200": {
          "light": "#431d84",
          "dark": "#f5edff"
        },
        "colorChartsPink300": {
          "light": "#da7596",
          "dark": "#c64a70"
        },
        "colorChartsPink400": {
          "light": "#ce567c",
          "dark": "#d56889"
        },
        "colorChartsPink500": {
          "light": "#c33d69",
          "dark": "#e07f9d"
        },
        "colorChartsPink600": {
          "light": "#b1325c",
          "dark": "#eb92ad"
        },
        "colorChartsPink700": {
          "light": "#a32952",
          "dark": "#f5a2bb"
        },
        "colorChartsPink800": {
          "light": "#962249",
          "dark": "#ffb0c8"
        },
        "colorChartsPink900": {
          "light": "#8b1b42",
          "dark": "#ffc1d4"
        },
        "colorChartsPink1000": {
          "light": "#81143b",
          "dark": "#ffd1de"
        },
        "colorChartsPink1100": {
          "light": "#780d35",
          "dark": "#ffdfe8"
        },
        "colorChartsPink1200": {
          "light": "#6f062f",
          "dark": "#ffecf1"
        },
        "colorChartsStatusCritical": {
          "light": "{colorChartsRed1000}",
          "dark": "{colorChartsRed300}"
        },
        "colorChartsStatusHigh": {
          "light": "{colorChartsRed600}",
          "dark": "{colorChartsRed500}"
        },
        "colorChartsStatusMedium": {
          "light": "{colorChartsOrange400}",
          "dark": "{colorChartsOrange600}"
        },
        "colorChartsStatusLow": {
          "light": "{colorChartsYellow300}",
          "dark": "{colorChartsYellow700}"
        },
        "colorChartsStatusPositive": {
          "light": "{colorChartsGreen300}",
          "dark": "{colorChartsGreen500}"
        },
        "colorChartsStatusInfo": {
          "light": "{colorChartsBlue1400}",
          "dark": "{colorChartsBlue1500}"
        },
        "colorChartsStatusNeutral": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorChartsThresholdNegative": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorChartsThresholdPositive": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess500}"
        },
        "colorChartsThresholdInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo300}"
        },
        "colorChartsThresholdNeutral": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorChartsLineGrid": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorChartsLineTick": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorChartsLineAxis": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorChartsPaletteCategorical1": {
          "light": "{colorChartsBlue2300}",
          "dark": "{colorChartsBlue2300}"
        },
        "colorChartsPaletteCategorical2": {
          "light": "{colorChartsPink500}",
          "dark": "{colorChartsPink500}"
        },
        "colorChartsPaletteCategorical3": {
          "light": "{colorChartsTeal300}",
          "dark": "{colorChartsTeal300}"
        },
        "colorChartsPaletteCategorical4": {
          "light": "{colorChartsPurple500}",
          "dark": "{colorChartsPurple500}"
        },
        "colorChartsPaletteCategorical5": {
          "light": "{colorChartsOrange300}",
          "dark": "{colorChartsOrange300}"
        },
        "colorChartsPaletteCategorical6": {
          "light": "{colorChartsBlue2600}",
          "dark": "{colorChartsBlue2600}"
        },
        "colorChartsPaletteCategorical7": {
          "light": "{colorChartsPink800}",
          "dark": "{colorChartsPink800}"
        },
        "colorChartsPaletteCategorical8": {
          "light": "{colorChartsTeal600}",
          "dark": "{colorChartsTeal600}"
        },
        "colorChartsPaletteCategorical9": {
          "light": "{colorChartsPurple800}",
          "dark": "{colorChartsPurple800}"
        },
        "colorChartsPaletteCategorical10": {
          "light": "{colorChartsOrange600}",
          "dark": "{colorChartsOrange600}"
        },
        "colorChartsPaletteCategorical11": {
          "light": "{colorChartsBlue2900}",
          "dark": "{colorChartsBlue2900}"
        },
        "colorChartsPaletteCategorical12": {
          "light": "{colorChartsPink1100}",
          "dark": "{colorChartsPink1100}"
        },
        "colorChartsPaletteCategorical13": {
          "light": "{colorChartsTeal900}",
          "dark": "{colorChartsTeal900}"
        },
        "colorChartsPaletteCategorical14": {
          "light": "{colorChartsPurple1100}",
          "dark": "{colorChartsPurple1100}"
        },
        "colorChartsPaletteCategorical15": {
          "light": "{colorChartsOrange900}",
          "dark": "{colorChartsOrange900}"
        },
        "colorChartsPaletteCategorical16": {
          "light": "{colorChartsBlue21200}",
          "dark": "{colorChartsBlue21200}"
        },
        "colorChartsPaletteCategorical17": {
          "light": "{colorChartsPink400}",
          "dark": "{colorChartsPink400}"
        },
        "colorChartsPaletteCategorical18": {
          "light": "{colorChartsTeal1200}",
          "dark": "{colorChartsTeal1200}"
        },
        "colorChartsPaletteCategorical19": {
          "light": "{colorChartsPurple400}",
          "dark": "{colorChartsPurple400}"
        },
        "colorChartsPaletteCategorical20": {
          "light": "{colorChartsOrange1200}",
          "dark": "{colorChartsOrange1200}"
        },
        "colorChartsPaletteCategorical21": {
          "light": "{colorChartsBlue2500}",
          "dark": "{colorChartsBlue2500}"
        },
        "colorChartsPaletteCategorical22": {
          "light": "{colorChartsPink700}",
          "dark": "{colorChartsPink700}"
        },
        "colorChartsPaletteCategorical23": {
          "light": "{colorChartsTeal500}",
          "dark": "{colorChartsTeal500}"
        },
        "colorChartsPaletteCategorical24": {
          "light": "{colorChartsPurple700}",
          "dark": "{colorChartsPurple700}"
        },
        "colorChartsPaletteCategorical25": {
          "light": "{colorChartsOrange500}",
          "dark": "{colorChartsOrange500}"
        },
        "colorChartsPaletteCategorical26": {
          "light": "{colorChartsBlue2800}",
          "dark": "{colorChartsBlue2800}"
        },
        "colorChartsPaletteCategorical27": {
          "light": "{colorChartsPink1000}",
          "dark": "{colorChartsPink1000}"
        },
        "colorChartsPaletteCategorical28": {
          "light": "{colorChartsTeal800}",
          "dark": "{colorChartsTeal800}"
        },
        "colorChartsPaletteCategorical29": {
          "light": "{colorChartsPurple1000}",
          "dark": "{colorChartsPurple1000}"
        },
        "colorChartsPaletteCategorical30": {
          "light": "{colorChartsOrange800}",
          "dark": "{colorChartsOrange800}"
        },
        "colorChartsPaletteCategorical31": {
          "light": "{colorChartsBlue21100}",
          "dark": "{colorChartsBlue21100}"
        },
        "colorChartsPaletteCategorical32": {
          "light": "{colorChartsPink300}",
          "dark": "{colorChartsPink300}"
        },
        "colorChartsPaletteCategorical33": {
          "light": "{colorChartsTeal1100}",
          "dark": "{colorChartsTeal1100}"
        },
        "colorChartsPaletteCategorical34": {
          "light": "{colorChartsPurple300}",
          "dark": "{colorChartsPurple300}"
        },
        "colorChartsPaletteCategorical35": {
          "light": "{colorChartsOrange1100}",
          "dark": "{colorChartsOrange1100}"
        },
        "colorChartsPaletteCategorical36": {
          "light": "{colorChartsBlue2400}",
          "dark": "{colorChartsBlue2400}"
        },
        "colorChartsPaletteCategorical37": {
          "light": "{colorChartsPink600}",
          "dark": "{colorChartsPink600}"
        },
        "colorChartsPaletteCategorical38": {
          "light": "{colorChartsTeal400}",
          "dark": "{colorChartsTeal400}"
        },
        "colorChartsPaletteCategorical39": {
          "light": "{colorChartsPurple600}",
          "dark": "{colorChartsPurple600}"
        },
        "colorChartsPaletteCategorical40": {
          "light": "{colorChartsOrange400}",
          "dark": "{colorChartsOrange400}"
        },
        "colorChartsPaletteCategorical41": {
          "light": "{colorChartsBlue2700}",
          "dark": "{colorChartsBlue2700}"
        },
        "colorChartsPaletteCategorical42": {
          "light": "{colorChartsPink900}",
          "dark": "{colorChartsPink900}"
        },
        "colorChartsPaletteCategorical43": {
          "light": "{colorChartsTeal700}",
          "dark": "{colorChartsTeal700}"
        },
        "colorChartsPaletteCategorical44": {
          "light": "{colorChartsPurple900}",
          "dark": "{colorChartsPurple900}"
        },
        "colorChartsPaletteCategorical45": {
          "light": "{colorChartsOrange700}",
          "dark": "{colorChartsOrange700}"
        },
        "colorChartsPaletteCategorical46": {
          "light": "{colorChartsBlue21000}",
          "dark": "{colorChartsBlue21000}"
        },
        "colorChartsPaletteCategorical47": {
          "light": "{colorChartsPink1200}",
          "dark": "{colorChartsPink1200}"
        },
        "colorChartsPaletteCategorical48": {
          "light": "{colorChartsTeal1000}",
          "dark": "{colorChartsTeal1000}"
        },
        "colorChartsPaletteCategorical49": {
          "light": "{colorChartsPurple1200}",
          "dark": "{colorChartsPurple1200}"
        },
        "colorChartsPaletteCategorical50": {
          "light": "{colorChartsOrange1000}",
          "dark": "{colorChartsOrange1000}"
        },
        "colorChartsErrorBarMarker": {
          "light": "{colorNeutral900}",
          "dark": "{colorWhite}"
        },
        "colorSeverityDarkRed": {
          "light": "#870303",
          "dark": "#d63f38"
        },
        "colorSeverityRed": {
          "light": "#ce3311",
          "dark": "#fe6e73"
        },
        "colorSeverityOrange": {
          "light": "#f89256",
          "dark": "#f89256"
        },
        "colorSeverityYellow": {
          "light": "#f2cd54",
          "dark": "#f2cd54"
        },
        "colorSeverityGrey": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundNotificationSeverityCritical": {
          "light": "{colorSeverityDarkRed}",
          "dark": "{colorSeverityDarkRed}"
        },
        "colorBackgroundNotificationSeverityHigh": {
          "light": "{colorSeverityRed}",
          "dark": "{colorSeverityRed}"
        },
        "colorBackgroundNotificationSeverityMedium": {
          "light": "{colorSeverityOrange}",
          "dark": "{colorSeverityOrange}"
        },
        "colorBackgroundNotificationSeverityLow": {
          "light": "{colorSeverityYellow}",
          "dark": "{colorSeverityYellow}"
        },
        "colorBackgroundNotificationSeverityNeutral": {
          "light": "{colorSeverityGrey}",
          "dark": "{colorSeverityGrey}"
        },
        "colorTextNotificationSeverityCritical": {
          "light": "{colorNeutral100}",
          "dark": "{colorBlack}"
        },
        "colorTextNotificationSeverityHigh": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral950}"
        },
        "colorTextNotificationSeverityMedium": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorTextNotificationSeverityLow": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorTextNotificationSeverityNeutral": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral100}"
        },
        "colorBorderBadgeSeverityCritical": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityHigh": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityMedium": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityLow": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityNeutral": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextBadgeSeverityCritical": {
          "light": "{colorTextNotificationSeverityCritical}",
          "dark": "{colorTextNotificationSeverityCritical}"
        },
        "colorTextBadgeSeverityHigh": {
          "light": "{colorTextNotificationSeverityHigh}",
          "dark": "{colorTextNotificationSeverityHigh}"
        },
        "colorTextBadgeSeverityMedium": {
          "light": "{colorTextNotificationSeverityMedium}",
          "dark": "{colorTextNotificationSeverityMedium}"
        },
        "colorTextBadgeSeverityLow": {
          "light": "{colorTextNotificationSeverityLow}",
          "dark": "{colorTextNotificationSeverityLow}"
        },
        "colorTextBadgeSeverityNeutral": {
          "light": "{colorTextNotificationSeverityNeutral}",
          "dark": "{colorTextNotificationSeverityNeutral}"
        },
        "colorGreyOpaque10": {
          "light": "rgba(0, 0, 0, 0.1)",
          "dark": "rgba(0, 0, 0, 0.1)"
        },
        "colorGreyOpaque25": {
          "light": "rgba(255, 255, 255, 0.25)",
          "dark": "rgba(255, 255, 255, 0.25)"
        },
        "colorGreyOpaque40": {
          "light": "rgba(0, 0, 0, 0.4)",
          "dark": "rgba(0, 0, 0, 0.4)"
        },
        "colorGreyOpaque50": {
          "light": "rgba(0, 0, 0, 0.5)",
          "dark": "rgba(0, 0, 0, 0.5)"
        },
        "colorGreyOpaque70": {
          "light": "rgba(35, 43, 55, 0.7)",
          "dark": "rgba(15, 20, 26, 0.7)"
        },
        "colorGreyOpaque80": {
          "light": "rgba(22, 25, 31, 0.8)",
          "dark": "rgba(22, 25, 31, 0.8)"
        },
        "colorGreyOpaque90": {
          "light": "rgba(242, 243, 243, 0.9)",
          "dark": "rgba(242, 243, 243, 0.9)"
        },
        "colorGreyTransparent": {
          "light": "rgba(15, 20, 26, 0.12)",
          "dark": "rgba(15, 20, 26, 1)"
        },
        "colorGreyTransparentHeavy": {
          "light": "rgba(15, 20, 26, 0.12)",
          "dark": "rgba(15, 20, 26, 1)"
        },
        "colorGreyTransparentLight": {
          "light": "rgba(15, 20, 26, 0.12)",
          "dark": "rgba(15, 20, 26, 1)"
        },
        "colorBackgroundBadgeIcon": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorBackgroundButtonLinkActive": {
          "light": "{colorPrimary100}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundButtonLinkDefault": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundButtonLinkDisabled": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundButtonLinkHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundButtonNormalActive": {
          "light": "{colorPrimary100}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundButtonNormalDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundButtonNormalDisabled": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundButtonNormalHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundToggleButtonNormalPressed": {
          "light": "{colorPrimary100}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundToggleButtonNormalDefault": {
          "light": "{colorBackgroundButtonNormalDefault}",
          "dark": "{colorBackgroundButtonNormalDefault}"
        },
        "colorBackgroundToggleButtonNormalHover": {
          "light": "{colorBackgroundButtonNormalHover}",
          "dark": "{colorBackgroundButtonNormalHover}"
        },
        "colorBackgroundButtonPrimaryActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundButtonPrimaryDefault": {
          "light": "{colorBorderButtonNormalDefault}",
          "dark": "{colorBorderButtonNormalDefault}"
        },
        "colorBackgroundButtonPrimaryDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundButtonPrimaryHover": {
          "light": "{colorBorderButtonNormalHover}",
          "dark": "{colorBorderButtonNormalHover}"
        },
        "colorBackgroundDirectionButtonActive": {
          "light": "{colorNeutral750}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundDirectionButtonDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundDirectionButtonDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundDirectionButtonHover": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral700}"
        },
        "colorTextDirectionButtonDefault": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextDirectionButtonDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorBackgroundCalendarCurrentDate": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundCellShaded": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCodeEditorGutterActiveLineDefault": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorBackgroundCodeEditorGutterActiveLineError": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundCodeEditorGutterDefault": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCodeEditorLoading": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCodeEditorPaneItemHover": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundCodeEditorStatusBar": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCard": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundItemCard": {
          "light": "{colorBackgroundCard}",
          "dark": "{colorBackgroundCard}"
        },
        "colorBackgroundContainerContent": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundContainerHeader": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundControlChecked": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundControlDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundControlDisabled": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundDropdownItemDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundDropdownItemDimmed": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundDropdownItemFilterMatch": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundDropdownItemHover": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral900}"
        },
        "colorBackgroundDropdownItemSelected": {
          "light": "{colorBackgroundItemSelected}",
          "dark": "{colorBackgroundItemSelected}"
        },
        "colorBackgroundHomeHeader": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundInlineCode": {
          "light": "rgba(0, 0, 0, 0.1)",
          "dark": "rgba(255, 255, 255, 0.1)"
        },
        "colorBackgroundInputDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundInputDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundItemSelected": {
          "light": "{colorPrimary50}",
          "dark": "{colorPrimary1000}"
        },
        "colorBackgroundSideNavigationItemActive": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundSideNavigationItemActiveCollapsed": {
          "light": "{colorBackgroundControlChecked}",
          "dark": "{colorBackgroundControlChecked}"
        },
        "colorBackgroundSideNavigationItemIconHover": {
          "light": "{colorBackgroundItemSelected}",
          "dark": "{colorBackgroundItemSelected}"
        },
        "colorBackgroundLayoutMain": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundLayoutAiDrawer": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundDrawer": {
          "light": "{colorBackgroundLayoutPanelContent}",
          "dark": "{colorBackgroundLayoutPanelContent}"
        },
        "colorBackgroundBackdrop": {
          "light": "{colorGreyOpaque70}",
          "dark": "{colorGreyOpaque70}"
        },
        "colorBackgroundDrawerBackdrop": {
          "light": "{colorBackgroundBackdrop}",
          "dark": "{colorBackgroundBackdrop}"
        },
        "colorBackgroundLayoutMobilePanel": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundLayoutPanel": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundLayoutPanelContent": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundLayoutPanelHover": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundLayoutToolbar": {
          "light": "{colorBackgroundLayoutPanelContent}",
          "dark": "{colorBackgroundLayoutPanelContent}"
        },
        "colorBackgroundLayoutToggleActive": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundLayoutToggleDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundLayoutToggleHover": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundLayoutToggleSelectedActive": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundLayoutToggleSelectedDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundLayoutToggleSelectedHover": {
          "light": "{colorPrimary700}",
          "dark": "{colorPrimary300}"
        },
        "colorBackgroundModalOverlay": {
          "light": "{colorBackgroundBackdrop}",
          "dark": "{colorBackgroundBackdrop}"
        },
        "colorBackgroundNotificationBlue": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo600}"
        },
        "colorBackgroundNotificationGreen": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess600}"
        },
        "colorBackgroundNotificationGrey": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundNotificationRed": {
          "light": "{colorError600}",
          "dark": "{colorError600}"
        },
        "colorBackgroundNotificationYellow": {
          "light": "{colorWarning400}",
          "dark": "{colorWarning400}"
        },
        "colorBackgroundFlashbarSuccess": {
          "light": "{colorBackgroundNotificationGreen}",
          "dark": "{colorBackgroundNotificationGreen}"
        },
        "colorBackgroundFlashbarError": {
          "light": "{colorBackgroundNotificationRed}",
          "dark": "{colorBackgroundNotificationRed}"
        },
        "colorBackgroundFlashbarInfo": {
          "light": "{colorBackgroundNotificationBlue}",
          "dark": "{colorBackgroundNotificationBlue}"
        },
        "colorBackgroundFlashbarWarning": {
          "light": "{colorBackgroundNotificationYellow}",
          "dark": "{colorBackgroundNotificationYellow}"
        },
        "colorBackgroundNotificationStackBar": {
          "light": "{colorNeutral750}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundNotificationStackBarActive": {
          "light": "{colorNeutral750}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundNotificationStackBarHover": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundPopover": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundProgressBarValueDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundProgressBarValueFlash": {
          "light": "{colorBackgroundProgressBarValueDefault}",
          "dark": "{colorBackgroundProgressBarValueDefault}"
        },
        "colorBackgroundProgressBarFlash": {
          "light": "{colorBackgroundProgressBarDefault}",
          "dark": "{colorBackgroundProgressBarDefault}"
        },
        "colorBackgroundProgressBarDefault": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundSegmentActive": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundSegmentDefault": {
          "light": "{colorBackgroundButtonNormalDefault}",
          "dark": "{colorBackgroundButtonNormalDefault}"
        },
        "colorBackgroundSegmentDisabled": {
          "light": "{colorBackgroundButtonNormalDisabled}",
          "dark": "{colorBackgroundButtonNormalDisabled}"
        },
        "colorBackgroundSegmentHover": {
          "light": "{colorBackgroundButtonNormalHover}",
          "dark": "{colorBackgroundButtonNormalHover}"
        },
        "colorBackgroundSegmentWrapper": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundSliderRangeDefault": {
          "light": "{colorBackgroundSliderHandleDefault}",
          "dark": "{colorBackgroundSliderHandleDefault}"
        },
        "colorBackgroundSliderRangeActive": {
          "light": "{colorBackgroundSliderHandleActive}",
          "dark": "{colorBackgroundSliderHandleActive}"
        },
        "colorBackgroundSliderHandleDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundSliderHandleActive": {
          "light": "{colorPrimary700}",
          "dark": "{colorPrimary300}"
        },
        "colorBackgroundSliderTrackDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundSliderHandleRing": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundSliderHandleErrorDefault": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderHandleErrorActive": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderHandleWarningDefault": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundSliderHandleWarningActive": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundSliderRangeErrorDefault": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderRangeErrorActive": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderRangeWarningDefault": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundSliderRangeWarningActive": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundStatusError": {
          "light": "{colorError50}",
          "dark": "{colorError1000}"
        },
        "colorBackgroundStatusInfo": {
          "light": "{colorInfo50}",
          "dark": "{colorInfo1000}"
        },
        "colorBackgroundAlertError": {
          "light": "{colorBackgroundStatusError}",
          "dark": "{colorBackgroundStatusError}"
        },
        "colorBackgroundAlertInfo": {
          "light": "{colorBackgroundStatusInfo}",
          "dark": "{colorBackgroundStatusInfo}"
        },
        "colorBackgroundAlertSuccess": {
          "light": "{colorBackgroundStatusSuccess}",
          "dark": "{colorBackgroundStatusSuccess}"
        },
        "colorBackgroundAlertWarning": {
          "light": "{colorBackgroundStatusWarning}",
          "dark": "{colorBackgroundStatusWarning}"
        },
        "colorBackgroundDialog": {
          "light": "{colorBackgroundStatusInfo}",
          "dark": "{colorBackgroundStatusInfo}"
        },
        "colorBackgroundDialogDefault": {
          "light": "{colorBackgroundCard}",
          "dark": "{colorBackgroundCard}"
        },
        "colorBackgroundStatusSuccess": {
          "light": "{colorSuccess50}",
          "dark": "{colorSuccess1000}"
        },
        "colorBackgroundStatusWarning": {
          "light": "{colorWarning50}",
          "dark": "{colorWarning1000}"
        },
        "colorBackgroundTableHeader": {
          "light": "{colorBackgroundContainerHeader}",
          "dark": "{colorBackgroundContainerHeader}"
        },
        "colorBackgroundTilesDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundToggleCheckedDisabled": {
          "light": "{colorPrimary200}",
          "dark": "{colorPrimary900}"
        },
        "colorBackgroundToggleDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral500}"
        },
        "colorBackgroundAvatarGenAi": {
          "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
          "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
        },
        "colorBackgroundAvatarDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorTextAvatar": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorBackgroundLoadingBarGenAi": {
          "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
          "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
        },
        "colorBackgroundStatusIndicatorError": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundStatusIndicatorWarning": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundStatusIndicatorSuccess": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundStatusIndicatorInfo": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundStatusIndicatorNeutral": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundChatBubbleOutgoing": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundChatBubbleIncoming": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral950}"
        },
        "colorTextChatBubbleOutgoing": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorTextChatBubbleIncoming": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorBorderButtonLinkDisabled": {
          "light": "{colorBackgroundButtonLinkDisabled}",
          "dark": "{colorBackgroundButtonLinkDisabled}"
        },
        "colorBorderButtonNormalActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorBorderButtonNormalDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderToggleButtonNormalPressed": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderToggleButtonNormalDefault": {
          "light": "{colorBorderButtonNormalDefault}",
          "dark": "{colorBorderButtonNormalDefault}"
        },
        "colorBorderToggleButtonNormalHover": {
          "light": "{colorBorderButtonNormalHover}",
          "dark": "{colorBorderButtonNormalHover}"
        },
        "colorBorderButtonNormalDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextButtonNormalDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderButtonNormalHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextButtonIconDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderButtonPrimaryActive": {
          "light": "{colorBackgroundButtonPrimaryActive}",
          "dark": "{colorBackgroundButtonPrimaryActive}"
        },
        "colorBorderButtonPrimaryDefault": {
          "light": "{colorBackgroundButtonPrimaryDefault}",
          "dark": "{colorBackgroundButtonPrimaryDefault}"
        },
        "colorBorderButtonPrimaryDisabled": {
          "light": "{colorBackgroundButtonPrimaryDisabled}",
          "dark": "{colorBackgroundButtonPrimaryDisabled}"
        },
        "colorBorderButtonPrimaryHover": {
          "light": "{colorBackgroundButtonPrimaryHover}",
          "dark": "{colorBackgroundButtonPrimaryHover}"
        },
        "colorTextButtonPrimaryDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorItemSelected": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextSideNavigationItemActive": {
          "light": "{colorTextAccent}",
          "dark": "{colorTextAccent}"
        },
        "colorTextSideNavigationItemActiveCollapsed": {
          "light": "{colorTextInverted}",
          "dark": "{colorTextInverted}"
        },
        "colorTextSideNavigationItemDefault": {
          "light": "{colorTextBodySecondary}",
          "dark": "{colorTextBodySecondary}"
        },
        "colorBorderCalendarGrid": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderCalendarGridSelectedFocusRing": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral850}"
        },
        "colorBorderCellShaded": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral700}"
        },
        "colorBorderCodeEditorAceActiveLineLightTheme": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderCodeEditorAceActiveLineDarkTheme": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderCodeEditorDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderCodeEditorPaneItemHover": {
          "light": "{colorBorderDropdownItemHover}",
          "dark": "{colorBorderDropdownItemHover}"
        },
        "colorBorderCard": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderCardHighlighted": {
          "light": "{colorBorderItemSelected}",
          "dark": "{colorBorderItemSelected}"
        },
        "colorBorderItemCard": {
          "light": "{colorBorderCard}",
          "dark": "{colorBorderCard}"
        },
        "colorBorderItemCardHighlighted": {
          "light": "{colorBorderCardHighlighted}",
          "dark": "{colorBorderCardHighlighted}"
        },
        "colorBorderContainerDivider": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderContainerTop": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderControlChecked": {
          "light": "{colorBackgroundControlChecked}",
          "dark": "{colorBackgroundControlChecked}"
        },
        "colorBorderControlDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderControlDisabled": {
          "light": "{colorBackgroundControlDisabled}",
          "dark": "{colorBackgroundControlDisabled}"
        },
        "colorBorderDividerActive": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorBorderDividerDefault": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral650}"
        },
        "colorBorderDividerNotification": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDividerPanelBottom": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDividerPanelSide": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDividerSecondary": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral750}"
        },
        "colorBorderDividerTableGroup": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDropdownContainer": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDropdownGroup": {
          "light": "{colorBorderDropdownItemDefault}",
          "dark": "{colorBorderDropdownItemDefault}"
        },
        "colorBorderDropdownItemDefault": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDropdownItemHover": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDropdownItemDimmedHover": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderDropdownItemSelected": {
          "light": "{colorBorderItemSelected}",
          "dark": "{colorBorderItemSelected}"
        },
        "colorBorderDropdownItemTop": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderEditableCellHover": {
          "light": "{colorBorderDropdownItemHover}",
          "dark": "{colorBorderDropdownItemHover}"
        },
        "colorBorderInputDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderInputDisabled": {
          "light": "{colorBackgroundInputDisabled}",
          "dark": "{colorBackgroundInputDisabled}"
        },
        "colorBorderInputFocused": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderItemFocused": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderDropdownItemFocused": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderItemPlaceholder": {
          "light": "{colorBorderItemSelected}",
          "dark": "{colorBorderItemSelected}"
        },
        "colorBorderItemSelected": {
          "light": "{colorItemSelected}",
          "dark": "{colorItemSelected}"
        },
        "colorBorderLayout": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral650}"
        },
        "colorBorderLayoutSideNavigation": {
          "light": "{colorBorderLayout}",
          "dark": "{colorBorderLayout}"
        },
        "colorBorderNotificationStackBar": {
          "light": "{colorNeutral750}",
          "dark": "{colorNeutral750}"
        },
        "colorBorderNotificationStackBarHover": {
          "light": "{colorBackgroundNotificationStackBarHover}",
          "dark": "{colorBackgroundNotificationStackBarHover}"
        },
        "colorBorderNotificationStackBarActive": {
          "light": "{colorBackgroundNotificationStackBar}",
          "dark": "{colorBackgroundNotificationStackBar}"
        },
        "colorBorderNotificationStackBarFocused": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral100}"
        },
        "colorBorderPanelHeader": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderPopover": {
          "light": "{colorBorderDropdownContainer}",
          "dark": "{colorBorderDropdownContainer}"
        },
        "colorBorderSegmentActive": {
          "light": "{colorBorderSegmentDefault}",
          "dark": "{colorBorderSegmentDefault}"
        },
        "colorBorderSegmentDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderSegmentDisabled": {
          "light": "{colorBorderSegmentDefault}",
          "dark": "{colorBorderSegmentDefault}"
        },
        "colorBorderSegmentDivider": {
          "light": "{colorBorderInputDefault}",
          "dark": "{colorBorderInputDefault}"
        },
        "colorBorderSegmentHover": {
          "light": "{colorBorderSegmentDefault}",
          "dark": "{colorBorderSegmentDefault}"
        },
        "colorBorderSegmentWrapper": {
          "light": "{colorBorderInputDefault}",
          "dark": "{colorBorderInputDefault}"
        },
        "colorBorderStatusError": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorBorderStatusInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo400}"
        },
        "colorBorderStatusSuccess": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess500}"
        },
        "colorBorderStatusWarning": {
          "light": "{colorWarning900}",
          "dark": "{colorWarning500}"
        },
        "colorBorderDialog": {
          "light": "{colorBorderStatusInfo}",
          "dark": "{colorBorderStatusInfo}"
        },
        "colorBorderDialogDefault": {
          "light": "{colorBorderCard}",
          "dark": "{colorBorderCard}"
        },
        "colorBorderDividerInteractiveDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderTabsDivider": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral650}"
        },
        "colorBorderTabsShadow": {
          "light": "{colorGreyTransparent}",
          "dark": "{colorGreyTransparent}"
        },
        "colorBorderTabsUnderline": {
          "light": "{colorTextAccent}",
          "dark": "{colorTextAccent}"
        },
        "colorBorderTilesDisabled": {
          "light": "{colorBackgroundTilesDisabled}",
          "dark": "{colorBackgroundTilesDisabled}"
        },
        "colorBorderTutorial": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorForegroundControlDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorForegroundControlDisabled": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorForegroundControlReadOnly": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorShadowDefault": {
          "light": "{colorGreyTransparentHeavy}",
          "dark": "{colorGreyTransparentHeavy}"
        },
        "colorShadowMedium": {
          "light": "{colorGreyTransparent}",
          "dark": "{colorGreyTransparent}"
        },
        "colorShadowSide": {
          "light": "{colorGreyTransparentLight}",
          "dark": "{colorGreyTransparentLight}"
        },
        "colorShadowToggleHandle": {
          "light": "rgba(0, 0, 0, 0.25)",
          "dark": "rgba(0, 0, 0, 0.25)"
        },
        "colorStrokeChartLine": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorStrokeCodeEditorGutterActiveLineDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral800}"
        },
        "colorStrokeCodeEditorGutterActiveLineHover": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral950}"
        },
        "colorTextAccent": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextBodyDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral350}"
        },
        "colorTextBodySecondary": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorTextBreadcrumbCurrent": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorTextBreadcrumbIcon": {
          "light": "{colorNeutral500}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextButtonInlineIconDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextButtonInlineIconDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextButtonInlineIconHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextButtonInlineLinkHover": {
          "light": "{colorTextButtonNormalHover}",
          "dark": "{colorTextButtonNormalHover}"
        },
        "colorTextButtonIconHover": {
          "light": "{colorTextInteractiveHover}",
          "dark": "{colorTextInteractiveHover}"
        },
        "colorTextButtonNormalActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextToggleButtonNormalPressed": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextButtonNormalDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextButtonNormalHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextLinkButtonNormalDefault": {
          "light": "{colorTextButtonNormalDefault}",
          "dark": "{colorTextButtonNormalDefault}"
        },
        "colorTextLinkButtonNormalHover": {
          "light": "{colorTextButtonNormalHover}",
          "dark": "{colorTextButtonNormalHover}"
        },
        "colorTextLinkButtonNormalActive": {
          "light": "{colorTextButtonNormalActive}",
          "dark": "{colorTextButtonNormalActive}"
        },
        "colorTextButtonLinkActive": {
          "light": "{colorTextButtonNormalActive}",
          "dark": "{colorTextButtonNormalActive}"
        },
        "colorTextButtonLinkDefault": {
          "light": "{colorTextButtonNormalDefault}",
          "dark": "{colorTextButtonNormalDefault}"
        },
        "colorTextButtonLinkDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextButtonLinkHover": {
          "light": "{colorTextButtonNormalHover}",
          "dark": "{colorTextButtonNormalHover}"
        },
        "colorTextButtonPrimaryActive": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextButtonPrimaryDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextButtonPrimaryHover": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextCalendarDateHover": {
          "light": "{colorTextDropdownItemDefault}",
          "dark": "{colorTextDropdownItemDefault}"
        },
        "colorTextCalendarDateSelected": {
          "light": "{colorBackgroundControlDefault}",
          "dark": "{colorBackgroundControlDefault}"
        },
        "colorTextCalendarMonth": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextCodeEditorGutterActiveLine": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextCodeEditorGutterDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextCodeEditorStatusBarDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorTextCodeEditorTabButtonError": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextColumnHeader": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral400}"
        },
        "colorTextColumnSortingIcon": {
          "light": "{colorTextColumnHeader}",
          "dark": "{colorTextColumnHeader}"
        },
        "colorTextControlDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextCounter": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextDisabledInlineEdit": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral400}"
        },
        "colorTextDropdownFooter": {
          "light": "{colorTextFormSecondary}",
          "dark": "{colorTextFormSecondary}"
        },
        "colorTextDropdownGroupLabel": {
          "light": "{colorTextGroupLabel}",
          "dark": "{colorTextGroupLabel}"
        },
        "colorTextDropdownItemDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextDropdownItemDimmed": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextDropdownItemDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextDropdownItemFilterMatch": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary300}"
        },
        "colorTextDropdownItemHighlighted": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral250}"
        },
        "colorTextDropdownItemSecondary": {
          "light": "{colorTextFormSecondary}",
          "dark": "{colorTextFormSecondary}"
        },
        "colorTextDropdownItemSecondaryHover": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral300}"
        },
        "colorTextEmpty": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral300}"
        },
        "colorTextExpandableSectionDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextExpandableSectionHover": {
          "light": "{colorTextAccent}",
          "dark": "{colorTextAccent}"
        },
        "colorTextExpandableSectionNavigationIconDefault": {
          "light": "{colorTextInteractiveDefault}",
          "dark": "{colorTextInteractiveDefault}"
        },
        "colorBorderExpandableSectionDefault": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorTextFormDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextFormLabel": {
          "light": "{colorTextFormDefault}",
          "dark": "{colorTextFormDefault}"
        },
        "colorTextFormSecondary": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextGroupLabel": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorTextLabelGenAi": {
          "light": "{colorPurple700}",
          "dark": "{colorPurple400}"
        },
        "colorTextHeadingDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral250}"
        },
        "colorTextHeadingSecondary": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral450}"
        },
        "colorTextHomeHeaderDefault": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral250}"
        },
        "colorTextHomeHeaderSecondary": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral350}"
        },
        "colorTextIconCaret": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral450}"
        },
        "colorTextIconSubtle": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral400}"
        },
        "colorTextInputDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextInputPlaceholder": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextInputPlaceholderDisabled": {
          "light": "{colorTextInputDisabled}",
          "dark": "{colorTextInputDisabled}"
        },
        "colorTextInteractiveActive": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextInteractiveDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorTextInteractiveDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextInteractiveHover": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextToggleButtonIconPressed": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextInteractiveInvertedDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral300}"
        },
        "colorTextInteractiveInvertedHover": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral100}"
        },
        "colorTextInverted": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextLabel": {
          "light": "{colorTextFormLabel}",
          "dark": "{colorTextFormLabel}"
        },
        "colorTextKeyValuePairsValue": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorTextLayoutToggle": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextLayoutToggleActive": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorTextLayoutToggleHover": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextLayoutToggleSelected": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextLinkDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextLinkHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextLinkDecorationDefault": {
          "light": "currentColor",
          "dark": "currentColor"
        },
        "colorTextLinkDecorationHover": {
          "light": "currentColor",
          "dark": "currentColor"
        },
        "colorTextLinkSecondaryDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextLinkSecondaryHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextLinkSecondaryDecorationDefault": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextLinkInfoDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextLinkInfoHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextLinkInvertedDefault": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorTextLinkInvertedHover": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextLinkButtonUnderline": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextLinkButtonUnderlineHover": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextNotificationDefault": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral100}"
        },
        "colorTextAlertDefault": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorTextNotificationLinkDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextNotificationLinkHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextNotificationStackBar": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextNotificationYellow": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorTextPaginationPageNumberActiveDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextPaginationPageNumberDefault": {
          "light": "{colorTextInteractiveDefault}",
          "dark": "{colorNeutral400}"
        },
        "colorTextSegmentActive": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextSegmentDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorTextSegmentHover": {
          "light": "{colorTextButtonNormalHover}",
          "dark": "{colorTextButtonNormalHover}"
        },
        "colorTextSmall": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextFlashbarIconError": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorTextFlashbarIconInfo": {
          "light": "{colorTextStatusInfo}",
          "dark": "{colorTextStatusInfo}"
        },
        "colorTextFlashbarIconSuccess": {
          "light": "{colorTextStatusSuccess}",
          "dark": "{colorTextStatusSuccess}"
        },
        "colorTextFlashbarIconWarning": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorTextAlertIconError": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorTextAlertIconInfo": {
          "light": "{colorTextStatusInfo}",
          "dark": "{colorTextStatusInfo}"
        },
        "colorTextAlertIconSuccess": {
          "light": "{colorTextStatusSuccess}",
          "dark": "{colorTextStatusSuccess}"
        },
        "colorTextAlertIconWarning": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorTextStatusError": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorTextStatusInactive": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextStatusInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo400}"
        },
        "colorTextStatusSuccess": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess500}"
        },
        "colorTextStatusWarning": {
          "light": "{colorWarning900}",
          "dark": "{colorWarning500}"
        },
        "colorTextTopNavigationTitle": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextTutorialHotspotDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextTutorialHotspotHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorBoardPlaceholderActive": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral600}"
        },
        "colorBoardPlaceholderHover": {
          "light": "{colorPrimary100}",
          "dark": "{colorPrimary600}"
        },
        "colorDragPlaceholderActive": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral600}"
        },
        "colorDragPlaceholderHover": {
          "light": "{colorPrimary100}",
          "dark": "{colorPrimary600}"
        },
        "colorDropzoneBackgroundDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorDropzoneBackgroundHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorPrimary1000}"
        },
        "colorDropzoneTextDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorDropzoneTextHover": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorDropzoneBorderDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorDropzoneBorderHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorGapGlobalDrawer": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral950}"
        },
        "colorTreeViewConnectorLine": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral300}"
        },
        "colorBackgroundActionCardDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundActionCardHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundActionCardActive": {
          "light": "{colorPrimary100}",
          "dark": "{colorNeutral700}"
        },
        "colorBorderActionCardDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderActionCardHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorBorderActionCardActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorBorderActionCardDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundActionCardDisabled": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorTextActionCardDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorTextActionCardIconDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextActionCardIconHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextActionCardIconActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextActionCardIconDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundSkeleton": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundSkeletonWave": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundBadgeGreen": {
          "light": "{colorBackgroundNotificationGreen}",
          "dark": "{colorBackgroundNotificationGreen}"
        },
        "colorBackgroundBadgeBlue": {
          "light": "{colorBackgroundNotificationBlue}",
          "dark": "{colorBackgroundNotificationBlue}"
        },
        "colorBackgroundBadgeRed": {
          "light": "{colorBackgroundNotificationRed}",
          "dark": "{colorBackgroundNotificationRed}"
        },
        "colorBackgroundBadgeYellow": {
          "light": "{colorBackgroundNotificationYellow}",
          "dark": "{colorBackgroundNotificationYellow}"
        },
        "colorBackgroundBadgeGrey": {
          "light": "{colorBackgroundNotificationGrey}",
          "dark": "{colorBackgroundNotificationGrey}"
        },
        "colorBorderBadge": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeGrey": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeGreen": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeBlue": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeRed": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextBadgeGrey": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorTextBadgeGreen": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorTextBadgeBlue": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorTextBadgeRed": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorBackgroundCodeView": {
          "light": "#f8f8f8",
          "dark": "#282c34"
        },
        "colorBackgroundVisualAccentRed": {
          "light": "#ffe0e0",
          "dark": "rgba(255, 61, 61, 0.2)"
        },
        "colorBackgroundVisualAccentYellow": {
          "light": "#fffbbd",
          "dark": "rgba(251, 211, 50, 0.2)"
        },
        "colorBackgroundVisualAccentIndigo": {
          "light": "#dbe4ff",
          "dark": "rgba(92, 127, 255, 0.2)"
        },
        "colorBackgroundVisualAccentGreen": {
          "light": "#d9ffd6",
          "dark": "rgba(43, 181, 52, 0.2)"
        },
        "colorBackgroundVisualAccentOrange": {
          "light": "rgba(255, 224, 214, 0.6)",
          "dark": "rgba(255, 75, 20, 0.2)"
        },
        "colorBackgroundVisualAccentPurple": {
          "light": "rgba(242, 229, 255, 0.6)",
          "dark": "rgba(173, 92, 255, 0.2)"
        },
        "colorBackgroundVisualAccentLime": {
          "light": "{colorLime100}",
          "dark": "rgba(49, 184, 0, 0.2)"
        },
        "colorBackgroundVisualAccentGrey": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundVisualAccentTeal": {
          "light": "rgba(204, 255, 252, 0.7)",
          "dark": "rgba(0, 173, 162, 0.2)"
        },
        "colorBackgroundVisualAccentBlue": {
          "light": "rgba(209, 241, 255, 0.6)",
          "dark": "rgba(0, 153, 255, 0.2)"
        },
        "colorBackgroundVisualAccentViolet": {
          "light": "rgba(232, 229, 255, 0.6)",
          "dark": "rgba(133, 117, 255, 0.2)"
        },
        "colorBackgroundVisualAccentMagenta": {
          "light": "rgba(255, 224, 251, 0.6)",
          "dark": "rgba(255, 26, 224, 0.2)"
        },
        "colorBackgroundVisualAccentPink": {
          "light": "rgba(255, 224, 240, 0.7)",
          "dark": "rgba(255, 51, 153, 0.2)"
        },
        "colorBackgroundVisualAccentAmber": {
          "light": "rgba(255, 232, 189, 0.7)",
          "dark": "rgba(250, 111, 0, 0.2)"
        },
        "colorTextVisualAccentRed": {
          "light": "{colorError700}",
          "dark": "{colorError400}"
        },
        "colorTextVisualAccentYellow": {
          "light": "{colorWarning900}",
          "dark": "{colorWarning200}"
        },
        "colorTextVisualAccentIndigo": {
          "light": "{colorInfo800}",
          "dark": "{colorInfo300}"
        },
        "colorTextVisualAccentGreen": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess200}"
        },
        "colorTextVisualAccentOrange": {
          "light": "#a82700",
          "dark": "#ff997a"
        },
        "colorTextVisualAccentPurple": {
          "light": "#962eff",
          "dark": "#d4a8ff"
        },
        "colorTextVisualAccentLime": {
          "light": "#007000",
          "dark": "#acff2e"
        },
        "colorTextVisualAccentGrey": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral300}"
        },
        "colorTextVisualAccentTeal": {
          "light": "#008077",
          "dark": "#00f5e4"
        },
        "colorTextVisualAccentBlue": {
          "light": "#006ce0",
          "dark": "#75cfff"
        },
        "colorTextVisualAccentViolet": {
          "light": "#6842ff",
          "dark": "#b2a8ff"
        },
        "colorTextVisualAccentMagenta": {
          "light": "#b2008f",
          "dark": "#ff57e9"
        },
        "colorTextVisualAccentPink": {
          "light": "#bb005d",
          "dark": "#ff99cc"
        },
        "colorTextVisualAccentAmber": {
          "light": "#9e3700",
          "dark": "#ffbb45"
        },
        "fontBoxValueLargeWeight": "700",
        "fontButtonLetterSpacing": "0.005em",
        "fontChartDetailSize": "{fontSizeBodyS}",
        "fontDecorationStyleLink": "solid",
        "fontDecorationLineLinkSecondary": "none",
        "fontDecorationThicknessLink": "1px",
        "fontDecorationThicknessLinkDisplayL": "2px",
        "fontDisplayLabelWeight": "700",
        "fontSizeExpandableHeading": "{fontSizeHeadingS}",
        "fontFamilyBase": "'Open Sans', 'Helvetica Neue', Roboto, Arial, sans-serif",
        "fontFamilyDisplay": "{fontFamilyBase}",
        "fontFamilyHeading": "{fontFamilyBase}",
        "fontFamilyMonospace": "Monaco, Menlo, Consolas, 'Courier Prime', Courier, 'Courier New', monospace",
        "fontHeaderH2DescriptionLineHeight": "{lineHeightBodyM}",
        "fontHeaderH2DescriptionSize": "{fontSizeBodyM}",
        "fontLinkButtonLetterSpacing": "{fontButtonLetterSpacing}",
        "fontLinkButtonWeight": "{fontWeightButton}",
        "fontPanelHeaderLineHeight": "{lineHeightHeadingM}",
        "fontPanelHeaderSize": "{fontSizeHeadingM}",
        "fontSideNavigationSectionHeaderSize": "inherit",
        "fontSideNavigationSectionHeaderWeight": "inherit",
        "fontSizeBodyM": "14px",
        "fontSizeBodyS": "12px",
        "fontSizeDisplayL": "42px",
        "fontSizeDisplayXl": "64px",
        "fontSizeFormLabel": "{fontSizeBodyM}",
        "fontSizeHeadingL": "20px",
        "fontSizeHeadingM": "18px",
        "fontSizeHeadingS": "16px",
        "fontSizeHeadingXl": "24px",
        "fontSizeHeadingXs": "14px",
        "fontSizeKeyValuePairsLabel": "{fontSizeBodyM}",
        "fontSizeTabs": "{fontSizeHeadingS}",
        "fontSmoothingMozOsx": "grayscale",
        "fontSmoothingWebkit": "antialiased",
        "fontWayfindingLinkActiveWeight": "700",
        "fontWeightAlertHeader": "700",
        "fontWeightBold": "700",
        "fontWeightBreadcrumbCurrent": "{fontWeightBold}",
        "fontWeightButton": "700",
        "fontWeightDisplayL": "700",
        "fontWeightDisplayXl": "400",
        "fontWeightFlashbarHeader": "700",
        "fontWeightFormLabel": "{fontDisplayLabelWeight}",
        "fontWeightHeadingL": "700",
        "fontWeightHeadingM": "700",
        "fontWeightHeadingS": "700",
        "fontWeightHeadingXl": "700",
        "fontWeightHeadingXs": "700",
        "fontWeightHeavy": "700",
        "fontWeightKeyValuePairsLabel": "{fontDisplayLabelWeight}",
        "fontWeightLighter": "300",
        "fontWeightLinkSecondary": "inherit",
        "fontWeightNormal": "400",
        "fontWeightTabs": "700",
        "fontWeightTabsDisabled": "{fontWayfindingLinkActiveWeight}",
        "letterSpacingBodyS": "0.005em",
        "letterSpacingDisplayL": "-0.03em",
        "letterSpacingDisplayXl": "-0.03em",
        "letterSpacingHeadingL": "-0.015em",
        "letterSpacingHeadingM": "-0.010em",
        "letterSpacingHeadingS": "-0.005em",
        "letterSpacingHeadingXl": "-0.02em",
        "letterSpacingHeadingXs": "normal",
        "lineHeightBodyM": "20px",
        "lineHeightBodyS": "16px",
        "lineHeightDisplayL": "48px",
        "lineHeightDisplayXl": "72px",
        "lineHeightFormLabel": "{lineHeightBodyM}",
        "lineHeightHeadingL": "24px",
        "lineHeightHeadingM": "22px",
        "lineHeightHeadingS": "20px",
        "lineHeightHeadingXl": "30px",
        "lineHeightHeadingXs": "18px",
        "lineHeightKeyValuePairsLabel": "{lineHeightBodyM}",
        "lineHeightTabs": "{lineHeightHeadingS}",
        "borderActiveWidth": "4px",
        "borderCodeEditorStatusDividerWidth": "{borderDividerSectionWidth}",
        "borderContainerStickyWidth": "0px",
        "borderContainerTopWidth": "0px",
        "borderControlFocusRingShadowSpread": "1px",
        "borderControlInvalidFocusRingShadowSpread": "2px",
        "borderDividerListWidth": "1px",
        "borderDividerSectionWidth": "1px",
        "borderDropdownVirtualOffsetWidth": "2px",
        "borderInvalidWidth": "8px",
        "borderItemWidth": "2px",
        "borderLineChartDashArray": "3 5",
        "borderLineChartLineJoin": "round",
        "borderLineChartWidth": "2px",
        "borderLinkFocusRingOutline": "0",
        "borderLinkFocusRingShadowSpread": "2px",
        "borderPanelHeaderWidth": "1px",
        "borderPanelTopWidth": "1px",
        "borderRadiusActionCardDefault": "{borderRadiusCardDefault}",
        "borderRadiusActionCardEmbedded": "{borderRadiusCardEmbedded}",
        "borderRadiusAlert": "{borderRadiusFlashbar}",
        "borderRadiusBadge": "4px",
        "borderRadiusButton": "20px",
        "borderRadiusCalendarDayFocusRing": "3px",
        "borderRadiusCardDefault": "{borderRadiusContainer}",
        "borderRadiusCardEmbedded": "{borderRadiusChatBubble}",
        "borderRadiusChatBubble": "8px",
        "borderRadiusSupportPrompt": "8px",
        "borderRadiusCodeEditor": "{borderRadiusInput}",
        "borderRadiusContainer": "16px",
        "borderRadiusControlCircularFocusRing": "4px",
        "borderRadiusControlDefaultFocusRing": "4px",
        "borderRadiusDropdown": "{borderRadiusItem}",
        "borderRadiusDropzone": "12px",
        "borderRadiusFlashbar": "12px",
        "borderRadiusInput": "8px",
        "borderRadiusItem": "8px",
        "borderRadiusSideNavigationItem": "{borderRadiusItem}",
        "borderRadiusSideNavigationItemCollapsed": "50%",
        "borderRadiusItemCardDefault": "{borderRadiusCardDefault}",
        "borderRadiusItemCardEmbedded": "{borderRadiusCardEmbedded}",
        "borderRadiusDialog": "{borderRadiusCardEmbedded}",
        "borderRadiusPopover": "{borderRadiusInput}",
        "borderRadiusSkeleton": "8px",
        "borderRadiusStatusIndicator": "{borderRadiusBadge}",
        "borderRadiusTabsFocusRing": "20px",
        "borderRadiusTiles": "{borderRadiusInput}",
        "borderRadiusToken": "{borderRadiusInput}",
        "borderRadiusTokenInline": "4px",
        "borderRadiusTutorialPanelItem": "{borderRadiusInput}",
        "borderTableStickyWidth": "1px",
        "borderWidthActionCardActive": "{borderWidthCard}",
        "borderWidthActionCardDefault": "{borderWidthCard}",
        "borderWidthActionCardDisabled": "{borderWidthCard}",
        "borderWidthActionCardHover": "{borderWidthCard}",
        "borderWidthAlert": "2px",
        "borderWidthAlertBlockEnd": "{borderWidthAlert}",
        "borderWidthAlertBlockStart": "{borderWidthAlert}",
        "borderWidthAlertInlineEnd": "{borderWidthAlert}",
        "borderWidthAlertInlineStart": "{borderWidthAlert}",
        "borderWidthFlashbarInlineStart": "0px",
        "borderWidthButton": "2px",
        "borderWidthCard": "{borderDividerSectionWidth}",
        "borderWidthCardSelected": "{borderItemWidth}",
        "borderWidthDropdown": "2px",
        "borderWidthField": "1px",
        "borderWidthIconBig": "3px",
        "borderWidthIconLarge": "4px",
        "borderWidthIconMedium": "2px",
        "borderWidthIconNormal": "2px",
        "borderWidthIconSmall": "2px",
        "borderWidthIconXSmall": "1.5px",
        "borderWidthItemCard": "{borderWidthCard}",
        "borderWidthItemCardHighlighted": "{borderWidthCardSelected}",
        "borderWidthDialog": "{borderWidthCard}",
        "borderWidthItemSelected": "2px",
        "borderWidthLayoutSideNavigation": "{borderDividerSectionWidth}",
        "borderWidthNotificationStackBar": "2px",
        "borderWidthBadge": "0px",
        "borderWidthPopover": "2px",
        "borderWidthToken": "2px",
        "motionDurationExtraFast": {
          "default": "45ms",
          "disabled": "0ms"
        },
        "motionDurationExtraSlow": {
          "default": "270ms",
          "disabled": "0ms"
        },
        "motionDurationFast": {
          "default": "90ms",
          "disabled": "0ms"
        },
        "motionDurationModerate": {
          "default": "135ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlyAmbient": {
          "default": "2000ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlyFast": {
          "default": "115ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlyMedium": {
          "default": "165ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlySlow": {
          "default": "250ms",
          "disabled": "0ms"
        },
        "motionDurationAvatarGenAiGradient": {
          "default": "3600ms",
          "disabled": "0ms"
        },
        "motionDurationAvatarLoadingDots": {
          "default": "1200ms",
          "disabled": "0ms"
        },
        "motionDurationRotate180": {
          "default": "{motionDurationModerate}",
          "disabled": "{motionDurationModerate}"
        },
        "motionDurationRotate90": {
          "default": "{motionDurationModerate}",
          "disabled": "{motionDurationModerate}"
        },
        "motionDurationShowPaced": {
          "default": "{motionDurationSlow}",
          "disabled": "{motionDurationSlow}"
        },
        "motionDurationShowQuick": {
          "default": "{motionDurationModerate}",
          "disabled": "{motionDurationModerate}"
        },
        "motionDurationSlow": {
          "default": "180ms",
          "disabled": "0ms"
        },
        "motionDurationTransitionQuick": {
          "default": "{motionDurationFast}",
          "disabled": "{motionDurationFast}"
        },
        "motionDurationTransitionShowPaced": {
          "default": "{motionDurationSlow}",
          "disabled": "{motionDurationSlow}"
        },
        "motionDurationTransitionShowQuick": {
          "default": "{motionDurationFast}",
          "disabled": "{motionDurationFast}"
        },
        "motionEasingEaseOutQuart": {
          "default": "cubic-bezier(0.165, 0.84, 0.44, 1)",
          "disabled": "cubic-bezier(0.165, 0.84, 0.44, 1)"
        },
        "motionEasingRefreshOnlyA": {
          "default": "cubic-bezier(0, 0, 0, 1)",
          "disabled": "cubic-bezier(0, 0, 0, 1)"
        },
        "motionEasingRefreshOnlyB": {
          "default": "cubic-bezier(1, 0, 0.83, 1)",
          "disabled": "cubic-bezier(1, 0, 0.83, 1)"
        },
        "motionEasingRefreshOnlyC": {
          "default": "cubic-bezier(0.84, 0, 0.16, 1)",
          "disabled": "cubic-bezier(0.84, 0, 0.16, 1)"
        },
        "motionEasingRefreshOnlyD": {
          "default": "cubic-bezier(0.33, 0, 0.67, 1)",
          "disabled": "cubic-bezier(0.33, 0, 0.67, 1)"
        },
        "motionEasingAvatarGenAiGradient": {
          "default": "cubic-bezier(0.7, 0, 0.3, 1)",
          "disabled": "cubic-bezier(0.7, 0, 0.3, 1)"
        },
        "motionEasingRotate180": {
          "default": "{motionEasingEaseOutQuart}",
          "disabled": "{motionEasingEaseOutQuart}"
        },
        "motionEasingRotate90": {
          "default": "{motionEasingEaseOutQuart}",
          "disabled": "{motionEasingEaseOutQuart}"
        },
        "motionEasingShowPaced": {
          "default": "ease-out",
          "disabled": "ease-out"
        },
        "motionEasingShowQuick": {
          "default": "ease-out",
          "disabled": "ease-out"
        },
        "motionEasingTransitionQuick": {
          "default": "linear",
          "disabled": "linear"
        },
        "motionEasingTransitionShowPaced": {
          "default": "ease-out",
          "disabled": "ease-out"
        },
        "motionEasingTransitionShowQuick": {
          "default": "linear",
          "disabled": "linear"
        },
        "motionEasingResponsive": {
          "default": "{motionEasingRefreshOnlyA}",
          "disabled": "{motionEasingRefreshOnlyA}"
        },
        "motionEasingSticky": {
          "default": "{motionEasingRefreshOnlyB}",
          "disabled": "{motionEasingRefreshOnlyB}"
        },
        "motionEasingExpressive": {
          "default": "{motionEasingRefreshOnlyC}",
          "disabled": "{motionEasingRefreshOnlyC}"
        },
        "motionDurationResponsive": {
          "default": "{motionDurationRefreshOnlyFast}",
          "disabled": "{motionDurationRefreshOnlyFast}"
        },
        "motionDurationExpressive": {
          "default": "{motionDurationRefreshOnlyMedium}",
          "disabled": "{motionDurationRefreshOnlyMedium}"
        },
        "motionDurationComplex": {
          "default": "{motionDurationRefreshOnlySlow}",
          "disabled": "{motionDurationRefreshOnlySlow}"
        },
        "motionDurationTooltipEnter": {
          "default": "{motionDurationRefreshOnlyFast}",
          "disabled": "{motionDurationRefreshOnlyFast}"
        },
        "motionEasingTooltipEnter": {
          "default": "{motionEasingRefreshOnlyA}",
          "disabled": "{motionEasingRefreshOnlyA}"
        },
        "motionDurationExpandableContentEnter": {
          "default": "{motionDurationShowPaced}",
          "disabled": "{motionDurationShowPaced}"
        },
        "motionEasingExpandableContentEnter": {
          "default": "{motionEasingShowPaced}",
          "disabled": "{motionEasingShowPaced}"
        },
        "motionDurationSideNavigationContentEnterFade": {
          "default": "0ms",
          "disabled": "0ms"
        },
        "motionDurationSideNavigationContentExit": {
          "default": "0ms",
          "disabled": "0ms"
        },
        "motionDurationSideNavigationContentExitFade": {
          "default": "0ms",
          "disabled": "0ms"
        },
        "motionEasingSideNavigationContentExit": {
          "default": "{motionEasingShowQuick}",
          "disabled": "{motionEasingShowQuick}"
        },
        "motionKeyframesFadeIn": {
          "default": "awsui-fade-in-jiml2r",
          "disabled": "awsui-fade-in-jiml2r"
        },
        "motionKeyframesFadeOut": {
          "default": "awsui-fade-out-au27m5",
          "disabled": "awsui-fade-out-au27m5"
        },
        "motionKeyframesStatusIconError": {
          "default": "awsui-status-icon-error-mjjk3s",
          "disabled": "awsui-status-icon-error-mjjk3s"
        },
        "motionKeyframesScalePopup": {
          "default": "awsui-scale-popup-2m9987",
          "disabled": "awsui-scale-popup-2m9987"
        },
        "sizeCalendarGridWidth": {
          "comfortable": "238px",
          "compact": "238px"
        },
        "sizeControl": {
          "comfortable": "16px",
          "compact": "16px"
        },
        "sizeIconBig": {
          "comfortable": "32px",
          "compact": "32px"
        },
        "sizeIconLarge": {
          "comfortable": "48px",
          "compact": "48px"
        },
        "sizeIconMedium": {
          "comfortable": "20px",
          "compact": "20px"
        },
        "sizeIconNormal": {
          "comfortable": "16px",
          "compact": "16px"
        },
        "sizeTableSelectionHorizontal": {
          "comfortable": "40px",
          "compact": "40px"
        },
        "sizeVerticalInput": {
          "comfortable": "32px",
          "compact": "28px"
        },
        "sizeVerticalPanelIconOffset": {
          "comfortable": "15px",
          "compact": "13px"
        },
        "sizeSideNavigationItemHeight": {
          "comfortable": "28px",
          "compact": "24px"
        },
        "sizeSideNavigationItemCollapsed": {
          "comfortable": "30px",
          "compact": "28px"
        },
        "sizeSideNavigationCollapsedWidth": {
          "comfortable": "52px",
          "compact": "52px"
        },
        "spaceAlertActionLeft": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceAlertHorizontal": {
          "comfortable": "{spaceFlashbarHorizontal}",
          "compact": "{spaceFlashbarHorizontal}"
        },
        "spaceAlertMessageRight": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceAlertVertical": {
          "comfortable": "{spaceFlashbarVertical}",
          "compact": "{spaceFlashbarVertical}"
        },
        "spaceButtonFocusOutlineGutter": {
          "comfortable": "4px",
          "compact": "4px"
        },
        "spaceButtonHorizontal": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spaceButtonVertical": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceTokenVertical": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceFieldVertical": {
          "comfortable": "5px",
          "compact": "3px"
        },
        "spaceButtonIconFocusOutlineGutterVertical": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceButtonIconOnlyHorizontal": {
          "comfortable": "6px",
          "compact": "{spaceXxs}"
        },
        "spaceButtonInlineIconFocusOutlineGutter": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceButtonModalDismissVertical": {
          "comfortable": "{spaceScaledXxxs}",
          "compact": "{spaceScaledXxxs}"
        },
        "spaceCalendarGridFocusOutlineGutter": {
          "comfortable": "-5px",
          "compact": "-5px"
        },
        "spaceCalendarGridSelectedFocusOutlineGutter": {
          "comfortable": "{spaceCalendarGridFocusOutlineGutter}",
          "compact": "{spaceCalendarGridFocusOutlineGutter}"
        },
        "spaceCalendarGridGutter": {
          "comfortable": "6px",
          "compact": "6px"
        },
        "spaceCardHorizontalDefault": {
          "comfortable": "{spaceContainerHorizontal}",
          "compact": "{spaceContainerHorizontal}"
        },
        "spaceCardHorizontalEmbedded": {
          "comfortable": "{spaceS}",
          "compact": "10px"
        },
        "spaceCardVerticalDefault": {
          "comfortable": "{spaceScaledM}",
          "compact": "{spaceScaledM}"
        },
        "spaceCardVerticalEmbedded": {
          "comfortable": "10px",
          "compact": "{spaceXs}"
        },
        "spaceItemCardHorizontalDefault": {
          "comfortable": "{spaceCardHorizontalDefault}",
          "compact": "{spaceCardHorizontalDefault}"
        },
        "spaceItemCardHorizontalEmbedded": {
          "comfortable": "{spaceCardHorizontalEmbedded}",
          "compact": "{spaceCardHorizontalEmbedded}"
        },
        "spaceItemCardVerticalDefault": {
          "comfortable": "{spaceCardVerticalDefault}",
          "compact": "{spaceCardVerticalDefault}"
        },
        "spaceItemCardVerticalEmbedded": {
          "comfortable": "{spaceCardVerticalEmbedded}",
          "compact": "{spaceCardVerticalEmbedded}"
        },
        "spaceDialogHorizontal": {
          "comfortable": "{spaceCardHorizontalEmbedded}",
          "compact": "{spaceCardHorizontalEmbedded}"
        },
        "spaceDialogVertical": {
          "comfortable": "{spaceCardVerticalEmbedded}",
          "compact": "{spaceCardVerticalEmbedded}"
        },
        "spaceDialogActionBlock": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceDialogActionInline": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceDialogHeaderGap": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXs}"
        },
        "spaceDialogSectionGap": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceCodeEditorStatusFocusOutlineGutter": {
          "comfortable": "-7px",
          "compact": "-7px"
        },
        "spaceContainerContentTop": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceContainerHeaderTop": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceContainerHeaderBottom": {
          "comfortable": "{spaceScaledXs}",
          "compact": "{spaceScaledXs}"
        },
        "spaceContainerHorizontal": {
          "comfortable": "{spaceL}",
          "compact": "{spaceL}"
        },
        "spaceContentHeaderPaddingBottom": {
          "comfortable": "{spaceScaledM}",
          "compact": "{spaceScaledM}"
        },
        "spaceDarkHeaderOverlapDistance": {
          "comfortable": "36px",
          "compact": "32px"
        },
        "spaceExpandableSectionIconOffsetTop": {
          "comfortable": "{spaceScaled2xXxs}",
          "compact": "{spaceScaled2xXxs}"
        },
        "spaceFieldHorizontal": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceFieldIconOffset": {
          "comfortable": "36px",
          "compact": "36px"
        },
        "spaceFilteringTokenDismissButtonFocusOutlineGutter": {
          "comfortable": "-5px",
          "compact": "-5px"
        },
        "spaceFilteringTokenOperationSelectFocusOutlineGutter": {
          "comfortable": "-5px",
          "compact": "-5px"
        },
        "spaceFlashbarActionLeft": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceFlashbarDismissRight": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceFlashbarHorizontal": {
          "comfortable": "{spaceM}",
          "compact": "{spaceM}"
        },
        "spaceFlashbarVertical": {
          "comfortable": "{spaceScaledXs}",
          "compact": "{spaceScaledXs}"
        },
        "spaceGridGutter": {
          "comfortable": "{spaceL}",
          "compact": "{spaceM}"
        },
        "spaceKeyValueGap": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceLayoutContentBottom": {
          "comfortable": "{spaceScaled2xXxxl}",
          "compact": "{spaceScaled2xXxxl}"
        },
        "spaceLayoutContentHorizontal": {
          "comfortable": "{spaceScaled2xXl}",
          "compact": "{spaceScaled2xXl}"
        },
        "spaceLayoutToggleDiameter": {
          "comfortable": "36px",
          "compact": "36px"
        },
        "spaceLayoutTogglePadding": {
          "comfortable": "{spaceStaticS}",
          "compact": "{spaceStaticS}"
        },
        "spaceModalContentBottom": {
          "comfortable": "{spaceScaled2xM}",
          "compact": "{spaceScaled2xM}"
        },
        "spaceModalHorizontal": {
          "comfortable": "{spaceContainerHorizontal}",
          "compact": "{spaceContainerHorizontal}"
        },
        "spacePanelContentBottom": {
          "comfortable": "{spaceScaledXxxl}",
          "compact": "{spaceScaledXxxl}"
        },
        "spacePanelContentTop": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spacePanelDividerMarginHorizontal": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXs}"
        },
        "spacePanelHeaderVertical": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spacePanelNavLeft": {
          "comfortable": "28px",
          "compact": "28px"
        },
        "spacePanelSideLeft": {
          "comfortable": "28px",
          "compact": "28px"
        },
        "spacePanelSideRight": {
          "comfortable": "{spaceScaledXl}",
          "compact": "{spaceScaledXl}"
        },
        "spacePanelSplitTop": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spacePanelSplitBottom": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spaceSegmentedControlFocusOutlineGutter": {
          "comfortable": "6px",
          "compact": "6px"
        },
        "spaceTabsContentTop": {
          "comfortable": "{spaceScaledS}",
          "compact": "{spaceScaledS}"
        },
        "spaceTabsFocusOutlineGutter": {
          "comfortable": "-8px",
          "compact": "-8px"
        },
        "spaceTabsVertical": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceTableContentBottom": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceTableEmbeddedHeaderTop": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceTableFooterHorizontal": {
          "comfortable": "{spaceTableHeaderHorizontal}",
          "compact": "{spaceTableHeaderHorizontal}"
        },
        "spaceTableHeaderFocusOutlineGutter": {
          "comfortable": "0px",
          "compact": "-1px"
        },
        "spaceTableHeaderHorizontal": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceTableHeaderToolsBottom": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceTableHeaderToolsFullPageBottom": {
          "comfortable": "4px",
          "compact": "4px"
        },
        "spaceTableHorizontal": {
          "comfortable": "{spaceContainerHorizontal}",
          "compact": "{spaceContainerHorizontal}"
        },
        "spaceTreeViewIndentation": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceXl}"
        },
        "spaceSideNavigationItemDefaultGap": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceSideNavigationItemIconGap": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceTileGutter": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceM}"
        },
        "spaceActionCardHorizontalDefault": {
          "comfortable": "{spaceCardHorizontalDefault}",
          "compact": "{spaceCardHorizontalDefault}"
        },
        "spaceActionCardHorizontalEmbedded": {
          "comfortable": "{spaceCardHorizontalEmbedded}",
          "compact": "{spaceCardHorizontalEmbedded}"
        },
        "spaceActionCardVerticalDefault": {
          "comfortable": "{spaceCardVerticalDefault}",
          "compact": "{spaceCardVerticalDefault}"
        },
        "spaceActionCardVerticalEmbedded": {
          "comfortable": "{spaceCardVerticalEmbedded}",
          "compact": "{spaceCardVerticalEmbedded}"
        },
        "spaceActionCardDescriptionPaddingTop": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceActionCardContentPaddingTop": {
          "comfortable": "{spaceScaledXs}",
          "compact": "{spaceScaledXs}"
        },
        "spaceOptionPaddingVertical": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceOptionPaddingHorizontal": {
          "comfortable": "{spaceL}",
          "compact": "{spaceL}"
        },
        "spaceStatusIndicatorPaddingHorizontal": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xNone": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xXxxs": {
          "comfortable": "{spaceXxxs}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xXxs": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xXs": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xS": {
          "comfortable": "{spaceS}",
          "compact": "{spaceXxs}"
        },
        "spaceScaled2xM": {
          "comfortable": "{spaceM}",
          "compact": "{spaceXs}"
        },
        "spaceScaled2xL": {
          "comfortable": "{spaceL}",
          "compact": "{spaceS}"
        },
        "spaceScaled2xXl": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceM}"
        },
        "spaceScaled2xXxl": {
          "comfortable": "{spaceXxl}",
          "compact": "{spaceL}"
        },
        "spaceScaled2xXxxl": {
          "comfortable": "{spaceXxxl}",
          "compact": "{spaceXl}"
        },
        "spaceScaledNone": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceScaledXxxs": {
          "comfortable": "{spaceXxxs}",
          "compact": "{spaceNone}"
        },
        "spaceScaledXxs": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxxs}"
        },
        "spaceScaledXs": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXxs}"
        },
        "spaceScaledS": {
          "comfortable": "{spaceS}",
          "compact": "{spaceXs}"
        },
        "spaceScaledM": {
          "comfortable": "{spaceM}",
          "compact": "{spaceS}"
        },
        "spaceScaledL": {
          "comfortable": "{spaceL}",
          "compact": "{spaceM}"
        },
        "spaceScaledXl": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceL}"
        },
        "spaceScaledXxl": {
          "comfortable": "{spaceXxl}",
          "compact": "{spaceXl}"
        },
        "spaceScaledXxxl": {
          "comfortable": "{spaceXxxl}",
          "compact": "{spaceXxl}"
        },
        "spaceStaticXxxs": {
          "comfortable": "{spaceXxxs}",
          "compact": "{spaceXxxs}"
        },
        "spaceStaticXxs": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceStaticXs": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXs}"
        },
        "spaceStaticS": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceStaticM": {
          "comfortable": "{spaceM}",
          "compact": "{spaceM}"
        },
        "spaceStaticL": {
          "comfortable": "{spaceL}",
          "compact": "{spaceL}"
        },
        "spaceStaticXl": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceXl}"
        },
        "spaceStaticXxl": {
          "comfortable": "{spaceXxl}",
          "compact": "{spaceXxl}"
        },
        "spaceStaticXxxl": {
          "comfortable": "{spaceXxxl}",
          "compact": "{spaceXxxl}"
        },
        "spaceNone": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceXxxs": {
          "comfortable": "2px",
          "compact": "2px"
        },
        "spaceXxs": {
          "comfortable": "4px",
          "compact": "4px"
        },
        "spaceXs": {
          "comfortable": "8px",
          "compact": "8px"
        },
        "spaceS": {
          "comfortable": "12px",
          "compact": "12px"
        },
        "spaceM": {
          "comfortable": "16px",
          "compact": "16px"
        },
        "spaceL": {
          "comfortable": "20px",
          "compact": "20px"
        },
        "spaceXl": {
          "comfortable": "24px",
          "compact": "24px"
        },
        "spaceXxl": {
          "comfortable": "32px",
          "compact": "32px"
        },
        "spaceXxxl": {
          "comfortable": "40px",
          "compact": "40px"
        },
        "shadowCard": {
          "light": "none",
          "dark": "none"
        },
        "shadowItemCard": {
          "light": "{shadowCard}",
          "dark": "{shadowCard}"
        },
        "shadowDialog": {
          "light": "{shadowCard}",
          "dark": "{shadowCard}"
        },
        "shadowContainer": {
          "light": "0px 0px 1px 1px #e9ebed, 0px 1px 8px 2px rgba(0, 7, 22, 0.12)",
          "dark": "0px 1px 8px 2px rgba(0, 7, 22, 0.6)"
        },
        "shadowContainerActive": {
          "light": "0px 1px 1px 1px #e9ebed, 0px 6px 36px #0007161a",
          "dark": "0px 1px 1px 1px #192534, 0px 6px 36px #00040c"
        },
        "shadowDropdown": {
          "light": "0px 4px 20px 1px rgba(0, 7, 22, 0.10)",
          "dark": "0px 4px 20px 1px rgba(0, 4, 12, 1)"
        },
        "shadowDropup": {
          "light": "{shadowDropdown}",
          "dark": "{shadowDropdown}"
        },
        "shadowFlashCollapsed": {
          "light": "0px 4px 4px rgba(0, 0, 0, 0.25)",
          "dark": "0px 4px 4px rgba(0, 0, 0, 0.25)"
        },
        "shadowFlashSticky": {
          "light": "0px 4px 8px rgba(0, 7, 22, 0.10)",
          "dark": "0px 4px 8px rgba(0, 7, 22, 0.5)"
        },
        "shadowModal": {
          "light": "{shadowDropdown}",
          "dark": "{shadowDropdown}"
        },
        "shadowPanel": {
          "light": "0px 0px 0px 1px #b6bec9",
          "dark": "0px 0px 0px 1px #414d5c"
        },
        "shadowPanelToggle": {
          "light": "0px 6px 12px 1px rgba(0, 7, 22, 0.12)",
          "dark": "0px 6px 12px 1px rgba(0, 7, 22, 1)"
        },
        "shadowPopover": {
          "light": "{shadowDropdown}",
          "dark": "{shadowDropdown}"
        },
        "shadowSplitBottom": {
          "light": "0px -36px 36px -36px rgba(0, 7, 22, 0.10)",
          "dark": "0px -36px 36px -36px rgba(0, 7, 22, 1)"
        },
        "shadowSplitSide": {
          "light": "-1px 0px 1px 0px #e9ebed, -36px 6px 36px -36px rgba(0, 7, 22, 0.10)",
          "dark": "-1px 0px 1px 0px #192534, -36px 6px 36px -36px rgba(0, 7, 22, 1)"
        },
        "shadowSticky": {
          "light": "0px 4px 8px 1px rgba(0, 7, 22, 0.10)",
          "dark": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)"
        },
        "shadowStickyEmbedded": {
          "light": "0px 2px 0px 0px #e9ebed, 0px 16px 16px -12px rgba(0, 7, 22, 0.10)",
          "dark": "0px 2px 0px 0px #414d5c, 0px 16px 16px -12px rgba(0, 7, 22, 1)"
        },
        "shadowStickyColumnFirst": {
          "light": "4px 0px 8px 1px rgba(0, 7, 22, 0.1)",
          "dark": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)"
        },
        "shadowStickyColumnLast": {
          "light": "-4px 0 8px 1px rgba(0, 28, 36, 0.1)",
          "dark": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)"
        }
      },
      "contexts": {
        "compact-table": {
          "id": "compact-table",
          "selector": ".awsui-context-compact-table",
          "tokens": {
            "spaceAlertActionLeft": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceAlertHorizontal": {
              "comfortable": "{spaceFlashbarHorizontal}",
              "compact": "{spaceFlashbarHorizontal}"
            },
            "spaceAlertMessageRight": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceAlertVertical": {
              "comfortable": "{spaceFlashbarVertical}",
              "compact": "{spaceFlashbarVertical}"
            },
            "spaceButtonFocusOutlineGutter": {
              "comfortable": "4px",
              "compact": "4px"
            },
            "spaceButtonHorizontal": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spaceButtonVertical": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceTokenVertical": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceFieldVertical": {
              "comfortable": "5px",
              "compact": "3px"
            },
            "spaceButtonIconFocusOutlineGutterVertical": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceButtonIconOnlyHorizontal": {
              "comfortable": "6px",
              "compact": "{spaceXxs}"
            },
            "spaceButtonInlineIconFocusOutlineGutter": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceButtonModalDismissVertical": {
              "comfortable": "{spaceScaledXxxs}",
              "compact": "{spaceScaledXxxs}"
            },
            "spaceCalendarGridFocusOutlineGutter": {
              "comfortable": "-5px",
              "compact": "-5px"
            },
            "spaceCalendarGridSelectedFocusOutlineGutter": {
              "comfortable": "{spaceCalendarGridFocusOutlineGutter}",
              "compact": "{spaceCalendarGridFocusOutlineGutter}"
            },
            "spaceCalendarGridGutter": {
              "comfortable": "6px",
              "compact": "6px"
            },
            "spaceCardHorizontalDefault": {
              "comfortable": "{spaceContainerHorizontal}",
              "compact": "{spaceContainerHorizontal}"
            },
            "spaceCardHorizontalEmbedded": {
              "comfortable": "{spaceS}",
              "compact": "10px"
            },
            "spaceCardVerticalDefault": {
              "comfortable": "{spaceScaledM}",
              "compact": "{spaceScaledM}"
            },
            "spaceCardVerticalEmbedded": {
              "comfortable": "10px",
              "compact": "{spaceXs}"
            },
            "spaceItemCardHorizontalDefault": {
              "comfortable": "{spaceCardHorizontalDefault}",
              "compact": "{spaceCardHorizontalDefault}"
            },
            "spaceItemCardHorizontalEmbedded": {
              "comfortable": "{spaceCardHorizontalEmbedded}",
              "compact": "{spaceCardHorizontalEmbedded}"
            },
            "spaceItemCardVerticalDefault": {
              "comfortable": "{spaceCardVerticalDefault}",
              "compact": "{spaceCardVerticalDefault}"
            },
            "spaceItemCardVerticalEmbedded": {
              "comfortable": "{spaceCardVerticalEmbedded}",
              "compact": "{spaceCardVerticalEmbedded}"
            },
            "spaceDialogHorizontal": {
              "comfortable": "{spaceCardHorizontalEmbedded}",
              "compact": "{spaceCardHorizontalEmbedded}"
            },
            "spaceDialogVertical": {
              "comfortable": "{spaceCardVerticalEmbedded}",
              "compact": "{spaceCardVerticalEmbedded}"
            },
            "spaceDialogActionBlock": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceDialogActionInline": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceDialogHeaderGap": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spaceDialogSectionGap": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceCodeEditorStatusFocusOutlineGutter": {
              "comfortable": "-7px",
              "compact": "-7px"
            },
            "spaceContainerContentTop": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceContainerHeaderTop": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceContainerHeaderBottom": {
              "comfortable": "{spaceScaledXs}",
              "compact": "{spaceScaledXs}"
            },
            "spaceContainerHorizontal": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceContentHeaderPaddingBottom": {
              "comfortable": "{spaceScaledM}",
              "compact": "{spaceScaledM}"
            },
            "spaceDarkHeaderOverlapDistance": {
              "comfortable": "36px",
              "compact": "32px"
            },
            "spaceExpandableSectionIconOffsetTop": {
              "comfortable": "{spaceScaled2xXxs}",
              "compact": "{spaceScaled2xXxs}"
            },
            "spaceFieldHorizontal": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceFieldIconOffset": {
              "comfortable": "36px",
              "compact": "36px"
            },
            "spaceFilteringTokenDismissButtonFocusOutlineGutter": {
              "comfortable": "-5px",
              "compact": "-5px"
            },
            "spaceFilteringTokenOperationSelectFocusOutlineGutter": {
              "comfortable": "-5px",
              "compact": "-5px"
            },
            "spaceFlashbarActionLeft": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceFlashbarDismissRight": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceFlashbarHorizontal": {
              "comfortable": "{spaceM}",
              "compact": "{spaceM}"
            },
            "spaceFlashbarVertical": {
              "comfortable": "{spaceScaledXs}",
              "compact": "{spaceScaledXs}"
            },
            "spaceGridGutter": {
              "comfortable": "{spaceL}",
              "compact": "{spaceM}"
            },
            "spaceKeyValueGap": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceLayoutContentBottom": {
              "comfortable": "{spaceScaled2xXxxl}",
              "compact": "{spaceScaled2xXxxl}"
            },
            "spaceLayoutContentHorizontal": {
              "comfortable": "{spaceScaled2xXl}",
              "compact": "{spaceScaled2xXl}"
            },
            "spaceLayoutToggleDiameter": {
              "comfortable": "36px",
              "compact": "36px"
            },
            "spaceLayoutTogglePadding": {
              "comfortable": "{spaceStaticS}",
              "compact": "{spaceStaticS}"
            },
            "spaceModalContentBottom": {
              "comfortable": "{spaceScaled2xM}",
              "compact": "{spaceScaled2xM}"
            },
            "spaceModalHorizontal": {
              "comfortable": "{spaceContainerHorizontal}",
              "compact": "{spaceContainerHorizontal}"
            },
            "spacePanelContentBottom": {
              "comfortable": "{spaceScaledXxxl}",
              "compact": "{spaceScaledXxxl}"
            },
            "spacePanelContentTop": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spacePanelDividerMarginHorizontal": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spacePanelHeaderVertical": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spacePanelNavLeft": {
              "comfortable": "28px",
              "compact": "28px"
            },
            "spacePanelSideLeft": {
              "comfortable": "28px",
              "compact": "28px"
            },
            "spacePanelSideRight": {
              "comfortable": "{spaceScaledXl}",
              "compact": "{spaceScaledXl}"
            },
            "spacePanelSplitTop": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spacePanelSplitBottom": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spaceSegmentedControlFocusOutlineGutter": {
              "comfortable": "6px",
              "compact": "6px"
            },
            "spaceTabsContentTop": {
              "comfortable": "{spaceScaledS}",
              "compact": "{spaceScaledS}"
            },
            "spaceTabsFocusOutlineGutter": {
              "comfortable": "-8px",
              "compact": "-8px"
            },
            "spaceTabsVertical": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceTableContentBottom": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceTableEmbeddedHeaderTop": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceTableFooterHorizontal": {
              "comfortable": "{spaceTableHeaderHorizontal}",
              "compact": "{spaceTableHeaderHorizontal}"
            },
            "spaceTableHeaderFocusOutlineGutter": {
              "comfortable": "0px",
              "compact": "-1px"
            },
            "spaceTableHeaderHorizontal": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceTableHeaderToolsBottom": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceTableHeaderToolsFullPageBottom": {
              "comfortable": "4px",
              "compact": "4px"
            },
            "spaceTableHorizontal": {
              "comfortable": "{spaceContainerHorizontal}",
              "compact": "{spaceContainerHorizontal}"
            },
            "spaceTreeViewIndentation": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceXl}"
            },
            "spaceSideNavigationItemDefaultGap": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceSideNavigationItemIconGap": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceTileGutter": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceM}"
            },
            "spaceActionCardHorizontalDefault": {
              "comfortable": "{spaceCardHorizontalDefault}",
              "compact": "{spaceCardHorizontalDefault}"
            },
            "spaceActionCardHorizontalEmbedded": {
              "comfortable": "{spaceCardHorizontalEmbedded}",
              "compact": "{spaceCardHorizontalEmbedded}"
            },
            "spaceActionCardVerticalDefault": {
              "comfortable": "{spaceCardVerticalDefault}",
              "compact": "{spaceCardVerticalDefault}"
            },
            "spaceActionCardVerticalEmbedded": {
              "comfortable": "{spaceCardVerticalEmbedded}",
              "compact": "{spaceCardVerticalEmbedded}"
            },
            "spaceActionCardDescriptionPaddingTop": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceActionCardContentPaddingTop": {
              "comfortable": "{spaceScaledXs}",
              "compact": "{spaceScaledXs}"
            },
            "spaceOptionPaddingVertical": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceOptionPaddingHorizontal": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceStatusIndicatorPaddingHorizontal": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xNone": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xXxxs": {
              "comfortable": "{spaceXxxs}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xXxs": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xXs": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xS": {
              "comfortable": "{spaceS}",
              "compact": "{spaceXxs}"
            },
            "spaceScaled2xM": {
              "comfortable": "{spaceM}",
              "compact": "{spaceXs}"
            },
            "spaceScaled2xL": {
              "comfortable": "{spaceL}",
              "compact": "{spaceS}"
            },
            "spaceScaled2xXl": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceM}"
            },
            "spaceScaled2xXxl": {
              "comfortable": "{spaceXxl}",
              "compact": "{spaceL}"
            },
            "spaceScaled2xXxxl": {
              "comfortable": "{spaceXxxl}",
              "compact": "{spaceXl}"
            },
            "spaceScaledNone": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaledXxxs": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaledXxs": {
              "comfortable": "{spaceXxxs}",
              "compact": "{spaceXxxs}"
            },
            "spaceScaledXs": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceScaledS": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spaceScaledM": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceScaledL": {
              "comfortable": "{spaceM}",
              "compact": "{spaceM}"
            },
            "spaceScaledXl": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceScaledXxl": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceXl}"
            },
            "spaceScaledXxxl": {
              "comfortable": "{spaceXxl}",
              "compact": "{spaceXxl}"
            },
            "spaceStaticXxxs": {
              "comfortable": "{spaceXxxs}",
              "compact": "{spaceXxxs}"
            },
            "spaceStaticXxs": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceStaticXs": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spaceStaticS": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceStaticM": {
              "comfortable": "{spaceM}",
              "compact": "{spaceM}"
            },
            "spaceStaticL": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceStaticXl": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceXl}"
            },
            "spaceStaticXxl": {
              "comfortable": "{spaceXxl}",
              "compact": "{spaceXxl}"
            },
            "spaceStaticXxxl": {
              "comfortable": "{spaceXxxl}",
              "compact": "{spaceXxxl}"
            },
            "spaceNone": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceXxxs": {
              "comfortable": "2px",
              "compact": "2px"
            },
            "spaceXxs": {
              "comfortable": "4px",
              "compact": "4px"
            },
            "spaceXs": {
              "comfortable": "8px",
              "compact": "8px"
            },
            "spaceS": {
              "comfortable": "12px",
              "compact": "12px"
            },
            "spaceM": {
              "comfortable": "16px",
              "compact": "16px"
            },
            "spaceL": {
              "comfortable": "20px",
              "compact": "20px"
            },
            "spaceXl": {
              "comfortable": "24px",
              "compact": "24px"
            },
            "spaceXxl": {
              "comfortable": "32px",
              "compact": "32px"
            },
            "spaceXxxl": {
              "comfortable": "40px",
              "compact": "40px"
            },
            "sizeVerticalInput": {
              "comfortable": "28px",
              "compact": "28px"
            }
          }
        },
        "top-navigation": {
          "id": "top-navigation",
          "selector": ".awsui-context-top-navigation",
          "tokens": {
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(15, 20, 26, 0.7)",
              "dark": "rgba(15, 20, 26, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(255, 255, 255, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundFlashbarError": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundPopover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorBackgroundProgressBarValueDefault}",
              "dark": "{colorBackgroundProgressBarValueDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorBackgroundProgressBarDefault}",
              "dark": "{colorBackgroundProgressBarDefault}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorBackgroundSliderHandleDefault}",
              "dark": "{colorBackgroundSliderHandleDefault}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError1000}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo1000}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "{colorBackgroundStatusError}",
              "dark": "{colorBackgroundStatusError}"
            },
            "colorBackgroundAlertInfo": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundAlertSuccess": {
              "light": "{colorBackgroundStatusSuccess}",
              "dark": "{colorBackgroundStatusSuccess}"
            },
            "colorBackgroundAlertWarning": {
              "light": "{colorBackgroundStatusWarning}",
              "dark": "{colorBackgroundStatusWarning}"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess1000}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning1000}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary900}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorTextInverted}",
              "dark": "{colorTextInverted}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodySecondary}",
              "dark": "{colorTextBodySecondary}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemSelected": {
              "light": "{colorItemSelected}",
              "dark": "{colorItemSelected}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorBackgroundNotificationStackBarHover}",
              "dark": "{colorBackgroundNotificationStackBarHover}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorBackgroundNotificationStackBar}",
              "dark": "{colorBackgroundNotificationStackBar}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorBorderDropdownContainer}",
              "dark": "{colorBorderDropdownContainer}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning500}",
              "dark": "{colorWarning500}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "rgba(0, 0, 0, 0.25)",
              "dark": "rgba(0, 0, 0, 0.25)"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextInteractiveHover}",
              "dark": "{colorTextInteractiveHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorTextFormDefault}",
              "dark": "{colorTextFormDefault}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple400}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInverted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorTextFormLabel}",
              "dark": "{colorTextFormLabel}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning500}",
              "dark": "{colorWarning500}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundBadgeBlue": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundBadgeRed": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundBadgeYellow": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorBackgroundNotificationGrey}",
              "dark": "{colorBackgroundNotificationGrey}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeRed": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundCodeView": {
              "light": "#282c34",
              "dark": "#282c34"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 75, 20, 0.2)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(173, 92, 255, 0.2)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "rgba(49, 184, 0, 0.2)",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(0, 173, 162, 0.2)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(0, 153, 255, 0.2)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(133, 117, 255, 0.2)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 26, 224, 0.2)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 51, 153, 0.2)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(250, 111, 0, 0.2)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning200}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#ff997a",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#d4a8ff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#acff2e",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#00f5e4",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#b2a8ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#ff57e9",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#ff99cc",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#ffbb45",
              "dark": "#ffbb45"
            },
            "colorPrimary50": "#f0fbff",
            "colorPrimary100": "#d1f1ff",
            "colorPrimary200": "#b8e7ff",
            "colorPrimary300": "#75cfff",
            "colorPrimary400": "#42b4ff",
            "colorPrimary500": "#0099ff",
            "colorPrimary600": "#006ce0",
            "colorPrimary700": "#004a9e",
            "colorPrimary800": "#003b8f",
            "colorPrimary900": "#002b66",
            "colorPrimary950": "#00204d",
            "colorPrimary1000": "#001129",
            "colorNeutral50": "#fcfcfd",
            "colorNeutral100": "#f9f9fa",
            "colorNeutral150": "#f6f6f9",
            "colorNeutral200": "#f3f3f7",
            "colorNeutral250": "#ebebf0",
            "colorNeutral300": "#dedee3",
            "colorNeutral350": "#c6c6cd",
            "colorNeutral400": "#b4b4bb",
            "colorNeutral450": "#a4a4ad",
            "colorNeutral500": "#8c8c94",
            "colorNeutral550": "#72747e",
            "colorNeutral600": "#656871",
            "colorNeutral650": "#424650",
            "colorNeutral700": "#333843",
            "colorNeutral750": "#232b37",
            "colorNeutral800": "#1b232d",
            "colorNeutral850": "#161d26",
            "colorNeutral900": "#131920",
            "colorNeutral950": "#0f141a",
            "colorNeutral1000": "#06080a",
            "colorError50": "#fff5f5",
            "colorError100": "#ffe0e0",
            "colorError400": "#ff7a7a",
            "colorError600": "#db0000",
            "colorError700": "#c20000",
            "colorError800": "#990000",
            "colorError900": "#700000",
            "colorError950": "#520000",
            "colorError1000": "#1f0000",
            "colorSuccess50": "#effff1",
            "colorSuccess100": "#d9ffd6",
            "colorSuccess200": "#aeffa8",
            "colorSuccess400": "#00e500",
            "colorSuccess500": "#2bb534",
            "colorSuccess600": "#00802f",
            "colorSuccess800": "#005c26",
            "colorSuccess950": "#003311",
            "colorSuccess1000": "#001401",
            "colorWarning50": "#fffef0",
            "colorWarning100": "#fffbbd",
            "colorWarning200": "#fef571",
            "colorWarning400": "#ffe347",
            "colorWarning500": "#fbd332",
            "colorWarning600": "#f2b100",
            "colorWarning800": "#9e6900",
            "colorWarning900": "#855900",
            "colorWarning950": "#573a00",
            "colorWarning1000": "#191100",
            "colorInfo50": "#f0fbff",
            "colorInfo100": "#d1f1ff",
            "colorInfo300": "#75cfff",
            "colorInfo400": "#42b4ff",
            "colorInfo600": "#006ce0",
            "colorInfo700": "#004a9e",
            "colorInfo800": "#003b8f",
            "colorInfo950": "#00204d",
            "colorInfo1000": "#001129",
            "colorChartsStatusNeutral": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorChartsThresholdNegative": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorChartsThresholdPositive": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorChartsThresholdInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo300}"
            },
            "colorChartsThresholdNeutral": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorChartsLineGrid": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineTick": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineAxis": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsErrorBarMarker": {
              "light": "{colorNeutral900}",
              "dark": "{colorWhite}"
            },
            "colorSeverityGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationSeverityNeutral": {
              "light": "{colorSeverityGrey}",
              "dark": "{colorSeverityGrey}"
            },
            "colorTextNotificationSeverityCritical": {
              "light": "{colorNeutral100}",
              "dark": "{colorBlack}"
            },
            "colorTextNotificationSeverityHigh": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityMedium": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityLow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityNeutral": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextBadgeSeverityCritical": {
              "light": "{colorTextNotificationSeverityCritical}",
              "dark": "{colorTextNotificationSeverityCritical}"
            },
            "colorTextBadgeSeverityHigh": {
              "light": "{colorTextNotificationSeverityHigh}",
              "dark": "{colorTextNotificationSeverityHigh}"
            },
            "colorTextBadgeSeverityMedium": {
              "light": "{colorTextNotificationSeverityMedium}",
              "dark": "{colorTextNotificationSeverityMedium}"
            },
            "colorTextBadgeSeverityLow": {
              "light": "{colorTextNotificationSeverityLow}",
              "dark": "{colorTextNotificationSeverityLow}"
            },
            "colorTextBadgeSeverityNeutral": {
              "light": "{colorTextNotificationSeverityNeutral}",
              "dark": "{colorTextNotificationSeverityNeutral}"
            }
          },
          "defaultMode": "dark"
        },
        "header": {
          "id": "header",
          "selector": ".awsui-context-content-header",
          "tokens": {
            "shadowCard": {
              "light": "none",
              "dark": "none"
            },
            "shadowItemCard": {
              "light": "{shadowCard}",
              "dark": "{shadowCard}"
            },
            "shadowDialog": {
              "light": "{shadowCard}",
              "dark": "{shadowCard}"
            },
            "shadowContainer": {
              "light": "0px 1px 8px 2px rgba(0, 7, 22, 0.6)",
              "dark": "0px 1px 8px 2px rgba(0, 7, 22, 0.6)"
            },
            "shadowContainerActive": {
              "light": "0px 1px 1px 1px #192534, 0px 6px 36px #00040c",
              "dark": "0px 1px 1px 1px #192534, 0px 6px 36px #00040c"
            },
            "shadowDropdown": {
              "light": "0px 4px 20px 1px rgba(0, 4, 12, 1)",
              "dark": "0px 4px 20px 1px rgba(0, 4, 12, 1)"
            },
            "shadowDropup": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowFlashCollapsed": {
              "light": "0px 4px 4px rgba(0, 0, 0, 0.25)",
              "dark": "0px 4px 4px rgba(0, 0, 0, 0.25)"
            },
            "shadowFlashSticky": {
              "light": "0px 4px 8px rgba(0, 7, 22, 0.10)",
              "dark": "0px 4px 8px rgba(0, 7, 22, 0.5)"
            },
            "shadowModal": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowPanel": {
              "light": "0px 0px 0px 1px #b6bec9",
              "dark": "0px 0px 0px 1px #414d5c"
            },
            "shadowPanelToggle": {
              "light": "0px 6px 12px 1px rgba(0, 7, 22, 0.12)",
              "dark": "0px 6px 12px 1px rgba(0, 7, 22, 1)"
            },
            "shadowPopover": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowSplitBottom": {
              "light": "0px -36px 36px -36px rgba(0, 7, 22, 1)",
              "dark": "0px -36px 36px -36px rgba(0, 7, 22, 1)"
            },
            "shadowSplitSide": {
              "light": "-1px 0px 1px 0px #192534, -36px 6px 36px -36px rgba(0, 7, 22, 1)",
              "dark": "-1px 0px 1px 0px #192534, -36px 6px 36px -36px rgba(0, 7, 22, 1)"
            },
            "shadowSticky": {
              "light": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)",
              "dark": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)"
            },
            "shadowStickyEmbedded": {
              "light": "0px 2px 0px 0px #414d5c, 0px 16px 16px -12px rgba(0, 7, 22, 1)",
              "dark": "0px 2px 0px 0px #414d5c, 0px 16px 16px -12px rgba(0, 7, 22, 1)"
            },
            "shadowStickyColumnFirst": {
              "light": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)",
              "dark": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)"
            },
            "shadowStickyColumnLast": {
              "light": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)",
              "dark": "0px 4px 8px 1px rgba(0, 7, 22, 0.5)"
            },
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(15, 20, 26, 0.7)",
              "dark": "rgba(15, 20, 26, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(255, 255, 255, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundFlashbarError": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundPopover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorBackgroundProgressBarValueDefault}",
              "dark": "{colorBackgroundProgressBarValueDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorBackgroundProgressBarDefault}",
              "dark": "{colorBackgroundProgressBarDefault}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorBackgroundSliderHandleDefault}",
              "dark": "{colorBackgroundSliderHandleDefault}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError1000}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo1000}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "{colorBackgroundStatusError}",
              "dark": "{colorBackgroundStatusError}"
            },
            "colorBackgroundAlertInfo": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundAlertSuccess": {
              "light": "{colorBackgroundStatusSuccess}",
              "dark": "{colorBackgroundStatusSuccess}"
            },
            "colorBackgroundAlertWarning": {
              "light": "{colorBackgroundStatusWarning}",
              "dark": "{colorBackgroundStatusWarning}"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess1000}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning1000}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary900}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorTextInverted}",
              "dark": "{colorTextInverted}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodySecondary}",
              "dark": "{colorTextBodySecondary}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemSelected": {
              "light": "{colorItemSelected}",
              "dark": "{colorItemSelected}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorBackgroundNotificationStackBarHover}",
              "dark": "{colorBackgroundNotificationStackBarHover}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorBackgroundNotificationStackBar}",
              "dark": "{colorBackgroundNotificationStackBar}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorBorderDropdownContainer}",
              "dark": "{colorBorderDropdownContainer}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning500}",
              "dark": "{colorWarning500}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "rgba(0, 0, 0, 0.25)",
              "dark": "rgba(0, 0, 0, 0.25)"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextInteractiveHover}",
              "dark": "{colorTextInteractiveHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorTextFormDefault}",
              "dark": "{colorTextFormDefault}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple400}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInverted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorTextFormLabel}",
              "dark": "{colorTextFormLabel}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning500}",
              "dark": "{colorWarning500}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundBadgeBlue": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundBadgeRed": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundBadgeYellow": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorBackgroundNotificationGrey}",
              "dark": "{colorBackgroundNotificationGrey}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeRed": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundCodeView": {
              "light": "#282c34",
              "dark": "#282c34"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 75, 20, 0.2)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(173, 92, 255, 0.2)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "rgba(49, 184, 0, 0.2)",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(0, 173, 162, 0.2)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(0, 153, 255, 0.2)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(133, 117, 255, 0.2)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 26, 224, 0.2)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 51, 153, 0.2)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(250, 111, 0, 0.2)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning200}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#ff997a",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#d4a8ff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#acff2e",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#00f5e4",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#b2a8ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#ff57e9",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#ff99cc",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#ffbb45",
              "dark": "#ffbb45"
            },
            "colorPrimary50": "#f0fbff",
            "colorPrimary100": "#d1f1ff",
            "colorPrimary200": "#b8e7ff",
            "colorPrimary300": "#75cfff",
            "colorPrimary400": "#42b4ff",
            "colorPrimary500": "#0099ff",
            "colorPrimary600": "#006ce0",
            "colorPrimary700": "#004a9e",
            "colorPrimary800": "#003b8f",
            "colorPrimary900": "#002b66",
            "colorPrimary950": "#00204d",
            "colorPrimary1000": "#001129",
            "colorNeutral50": "#fcfcfd",
            "colorNeutral100": "#f9f9fa",
            "colorNeutral150": "#f6f6f9",
            "colorNeutral200": "#f3f3f7",
            "colorNeutral250": "#ebebf0",
            "colorNeutral300": "#dedee3",
            "colorNeutral350": "#c6c6cd",
            "colorNeutral400": "#b4b4bb",
            "colorNeutral450": "#a4a4ad",
            "colorNeutral500": "#8c8c94",
            "colorNeutral550": "#72747e",
            "colorNeutral600": "#656871",
            "colorNeutral650": "#424650",
            "colorNeutral700": "#333843",
            "colorNeutral750": "#232b37",
            "colorNeutral800": "#1b232d",
            "colorNeutral850": "#161d26",
            "colorNeutral900": "#131920",
            "colorNeutral950": "#0f141a",
            "colorNeutral1000": "#06080a",
            "colorError50": "#fff5f5",
            "colorError100": "#ffe0e0",
            "colorError400": "#ff7a7a",
            "colorError600": "#db0000",
            "colorError700": "#c20000",
            "colorError800": "#990000",
            "colorError900": "#700000",
            "colorError950": "#520000",
            "colorError1000": "#1f0000",
            "colorSuccess50": "#effff1",
            "colorSuccess100": "#d9ffd6",
            "colorSuccess200": "#aeffa8",
            "colorSuccess400": "#00e500",
            "colorSuccess500": "#2bb534",
            "colorSuccess600": "#00802f",
            "colorSuccess800": "#005c26",
            "colorSuccess950": "#003311",
            "colorSuccess1000": "#001401",
            "colorWarning50": "#fffef0",
            "colorWarning100": "#fffbbd",
            "colorWarning200": "#fef571",
            "colorWarning400": "#ffe347",
            "colorWarning500": "#fbd332",
            "colorWarning600": "#f2b100",
            "colorWarning800": "#9e6900",
            "colorWarning900": "#855900",
            "colorWarning950": "#573a00",
            "colorWarning1000": "#191100",
            "colorInfo50": "#f0fbff",
            "colorInfo100": "#d1f1ff",
            "colorInfo300": "#75cfff",
            "colorInfo400": "#42b4ff",
            "colorInfo600": "#006ce0",
            "colorInfo700": "#004a9e",
            "colorInfo800": "#003b8f",
            "colorInfo950": "#00204d",
            "colorInfo1000": "#001129",
            "colorChartsStatusNeutral": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorChartsThresholdNegative": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorChartsThresholdPositive": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorChartsThresholdInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo300}"
            },
            "colorChartsThresholdNeutral": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorChartsLineGrid": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineTick": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineAxis": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsErrorBarMarker": {
              "light": "{colorNeutral900}",
              "dark": "{colorWhite}"
            },
            "colorSeverityGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationSeverityNeutral": {
              "light": "{colorSeverityGrey}",
              "dark": "{colorSeverityGrey}"
            },
            "colorTextNotificationSeverityCritical": {
              "light": "{colorNeutral100}",
              "dark": "{colorBlack}"
            },
            "colorTextNotificationSeverityHigh": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityMedium": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityLow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityNeutral": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextBadgeSeverityCritical": {
              "light": "{colorTextNotificationSeverityCritical}",
              "dark": "{colorTextNotificationSeverityCritical}"
            },
            "colorTextBadgeSeverityHigh": {
              "light": "{colorTextNotificationSeverityHigh}",
              "dark": "{colorTextNotificationSeverityHigh}"
            },
            "colorTextBadgeSeverityMedium": {
              "light": "{colorTextNotificationSeverityMedium}",
              "dark": "{colorTextNotificationSeverityMedium}"
            },
            "colorTextBadgeSeverityLow": {
              "light": "{colorTextNotificationSeverityLow}",
              "dark": "{colorTextNotificationSeverityLow}"
            },
            "colorTextBadgeSeverityNeutral": {
              "light": "{colorTextNotificationSeverityNeutral}",
              "dark": "{colorTextNotificationSeverityNeutral}"
            }
          },
          "defaultMode": "dark"
        },
        "app-layout-toolbar": {
          "id": "app-layout-toolbar",
          "selector": ".awsui-context-app-layout-toolbar",
          "tokens": {
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral50}",
              "dark": "{colorNeutral900}"
            }
          }
        },
        "flashbar": {
          "id": "flashbar",
          "selector": ".awsui-context-flashbar:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
          "tokens": {
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(35, 43, 55, 0.7)",
              "dark": "rgba(15, 20, 26, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(0, 7, 22, 0.2)",
              "dark": "rgba(0, 7, 22, 0.2)"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(0, 7, 22, 0.15)",
              "dark": "rgba(0, 7, 22, 0.15)"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(0, 0, 0, 0.2)",
              "dark": "rgba(0, 0, 0, 0.2)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorPrimary50}",
              "dark": "{colorPrimary1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary700}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundFlashbarError": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundPopover": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorBackgroundProgressBarValueDefault}",
              "dark": "{colorBackgroundProgressBarValueDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorBackgroundProgressBarDefault}",
              "dark": "{colorBackgroundProgressBarDefault}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorGreyOpaque25}",
              "dark": "{colorGreyOpaque25}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorBackgroundSliderHandleDefault}",
              "dark": "{colorBackgroundSliderHandleDefault}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary700}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError50}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo50}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "{colorBackgroundStatusError}",
              "dark": "{colorBackgroundStatusError}"
            },
            "colorBackgroundAlertInfo": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundAlertSuccess": {
              "light": "{colorBackgroundStatusSuccess}",
              "dark": "{colorBackgroundStatusSuccess}"
            },
            "colorBackgroundAlertWarning": {
              "light": "{colorBackgroundStatusWarning}",
              "dark": "{colorBackgroundStatusWarning}"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess50}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning50}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorPrimary200}",
              "dark": "{colorPrimary900}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral950}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorTextInverted}",
              "dark": "{colorTextInverted}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodySecondary}",
              "dark": "{colorTextBodySecondary}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemSelected": {
              "light": "{colorItemSelected}",
              "dark": "{colorItemSelected}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorBackgroundNotificationStackBarHover}",
              "dark": "{colorBackgroundNotificationStackBarHover}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorBackgroundNotificationStackBar}",
              "dark": "{colorBackgroundNotificationStackBar}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorBorderDropdownContainer}",
              "dark": "{colorBorderDropdownContainer}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning500}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "rgba(0, 0, 0, 0.25)",
              "dark": "rgba(0, 0, 0, 0.25)"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral500}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorNeutral500}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextInteractiveHover}",
              "dark": "{colorTextInteractiveHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary300}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorTextFormDefault}",
              "dark": "{colorTextFormDefault}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple700}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInverted": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextLinkHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning500}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary100}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary100}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral950}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundBadgeBlue": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundBadgeRed": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundBadgeYellow": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorBackgroundNotificationGrey}",
              "dark": "{colorBackgroundNotificationGrey}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeRed": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundCodeView": {
              "light": "#f8f8f8",
              "dark": "#282c34"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "#ffe0e0",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "#fffbbd",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "#dbe4ff",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "#d9ffd6",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 224, 214, 0.6)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(242, 229, 255, 0.6)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "{colorLime100}",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(204, 255, 252, 0.7)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(209, 241, 255, 0.6)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(232, 229, 255, 0.6)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 224, 251, 0.6)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 224, 240, 0.7)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(255, 232, 189, 0.7)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError700}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo800}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#a82700",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#962eff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#007000",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#008077",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#006ce0",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#6842ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#b2008f",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#bb005d",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#9e3700",
              "dark": "#ffbb45"
            }
          }
        },
        "flashbar-warning": {
          "id": "flashbar-warning",
          "selector": ".awsui-context-flashbar-warning:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
          "tokens": {
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(35, 43, 55, 0.7)",
              "dark": "rgba(15, 20, 26, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(0, 7, 22, 0.1)",
              "dark": "rgba(0, 7, 22, 0.1)"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(0, 7, 22, 0.05)",
              "dark": "rgba(0, 7, 22, 0.05)"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorPrimary50}",
              "dark": "{colorPrimary1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary700}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundFlashbarError": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundPopover": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorBackgroundProgressBarValueDefault}",
              "dark": "{colorBackgroundProgressBarValueDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorBackgroundProgressBarDefault}",
              "dark": "{colorBackgroundProgressBarDefault}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorGreyOpaque10}",
              "dark": "{colorGreyOpaque10}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorBackgroundSliderHandleDefault}",
              "dark": "{colorBackgroundSliderHandleDefault}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary700}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError50}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo50}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "{colorBackgroundStatusError}",
              "dark": "{colorBackgroundStatusError}"
            },
            "colorBackgroundAlertInfo": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundAlertSuccess": {
              "light": "{colorBackgroundStatusSuccess}",
              "dark": "{colorBackgroundStatusSuccess}"
            },
            "colorBackgroundAlertWarning": {
              "light": "{colorBackgroundStatusWarning}",
              "dark": "{colorBackgroundStatusWarning}"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess50}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning50}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorPrimary200}",
              "dark": "{colorPrimary900}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral950}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorTextInverted}",
              "dark": "{colorTextInverted}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodySecondary}",
              "dark": "{colorTextBodySecondary}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemSelected": {
              "light": "{colorItemSelected}",
              "dark": "{colorItemSelected}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorBackgroundNotificationStackBarHover}",
              "dark": "{colorBackgroundNotificationStackBarHover}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorBackgroundNotificationStackBar}",
              "dark": "{colorBackgroundNotificationStackBar}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorBorderDropdownContainer}",
              "dark": "{colorBorderDropdownContainer}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning500}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "rgba(0, 0, 0, 0.25)",
              "dark": "rgba(0, 0, 0, 0.25)"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextBodySecondary": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral500}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorNeutral500}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextInteractiveHover}",
              "dark": "{colorTextInteractiveHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary300}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorTextFormDefault}",
              "dark": "{colorTextFormDefault}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple700}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextInverted": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextLinkHover": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo400}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorTextStatusWarning": {
              "light": "{colorTextNotificationYellow}",
              "dark": "{colorTextNotificationYellow}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary100}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary100}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral950}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundBadgeBlue": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundBadgeRed": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundBadgeYellow": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorBackgroundNotificationGrey}",
              "dark": "{colorBackgroundNotificationGrey}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeRed": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundCodeView": {
              "light": "#f8f8f8",
              "dark": "#282c34"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "#ffe0e0",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "#fffbbd",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "#dbe4ff",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "#d9ffd6",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 224, 214, 0.6)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(242, 229, 255, 0.6)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "{colorLime100}",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(204, 255, 252, 0.7)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(209, 241, 255, 0.6)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(232, 229, 255, 0.6)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 224, 251, 0.6)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 224, 240, 0.7)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(255, 232, 189, 0.7)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError700}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo800}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#a82700",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#962eff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#007000",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#008077",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#006ce0",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#6842ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#b2008f",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#bb005d",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#9e3700",
              "dark": "#ffbb45"
            }
          }
        },
        "alert": {
          "id": "alert",
          "selector": ".awsui-context-alert:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
          "tokens": {
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(35, 43, 55, 0.7)",
              "dark": "rgba(15, 20, 26, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 0.12)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(0, 7, 22, 0.1)",
              "dark": "rgba(255, 255, 255, 0.15)"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(0, 7, 22, 0.05)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorPrimary50}",
              "dark": "{colorPrimary1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary700}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundFlashbarError": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundPopover": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorBackgroundProgressBarValueDefault}",
              "dark": "{colorBackgroundProgressBarValueDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorBackgroundProgressBarDefault}",
              "dark": "{colorBackgroundProgressBarDefault}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorBackgroundSliderHandleDefault}",
              "dark": "{colorBackgroundSliderHandleDefault}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary700}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError50}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo50}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "{colorBackgroundStatusError}",
              "dark": "{colorBackgroundStatusError}"
            },
            "colorBackgroundAlertInfo": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundAlertSuccess": {
              "light": "{colorBackgroundStatusSuccess}",
              "dark": "{colorBackgroundStatusSuccess}"
            },
            "colorBackgroundAlertWarning": {
              "light": "{colorBackgroundStatusWarning}",
              "dark": "{colorBackgroundStatusWarning}"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess50}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning50}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorPrimary200}",
              "dark": "{colorPrimary900}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral950}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorTextInverted}",
              "dark": "{colorTextInverted}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodySecondary}",
              "dark": "{colorTextBodySecondary}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorPrimary600}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemSelected": {
              "light": "{colorItemSelected}",
              "dark": "{colorItemSelected}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorBackgroundNotificationStackBarHover}",
              "dark": "{colorBackgroundNotificationStackBarHover}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorBackgroundNotificationStackBar}",
              "dark": "{colorBackgroundNotificationStackBar}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorBorderDropdownContainer}",
              "dark": "{colorBorderDropdownContainer}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning500}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "rgba(0, 0, 0, 0.25)",
              "dark": "rgba(0, 0, 0, 0.25)"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral500}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorNeutral500}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextInteractiveHover}",
              "dark": "{colorTextInteractiveHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary300}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorTextFormDefault}",
              "dark": "{colorTextFormDefault}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple700}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral450}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInverted": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorTextFormLabel}",
              "dark": "{colorTextFormLabel}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo400}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning500}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary100}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary100}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral950}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorPrimary50}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorPrimary100}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorWhite}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral150}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundBadgeBlue": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundBadgeRed": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundBadgeYellow": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorBackgroundNotificationGrey}",
              "dark": "{colorBackgroundNotificationGrey}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeRed": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundCodeView": {
              "light": "#f8f8f8",
              "dark": "#282c34"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "#ffe0e0",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "#fffbbd",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "#dbe4ff",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "#d9ffd6",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 224, 214, 0.6)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(242, 229, 255, 0.6)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "{colorLime100}",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(204, 255, 252, 0.7)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(209, 241, 255, 0.6)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(232, 229, 255, 0.6)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 224, 251, 0.6)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 224, 240, 0.7)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(255, 232, 189, 0.7)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError700}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning900}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo800}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#a82700",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#962eff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#007000",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#008077",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#006ce0",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#6842ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#b2008f",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#bb005d",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#9e3700",
              "dark": "#ffbb45"
            },
            "fontSizeExpandableHeading": "14px",
            "borderDividerSectionWidth": "1px"
          }
        },
        "alert-header": {
          "id": "alert-header",
          "selector": ".awsui-context-content-header .awsui-context-alert:where(:not(.awsui-one-theme):not(.awsui-one-theme *))",
          "tokens": {
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(15, 20, 26, 0.7)",
              "dark": "rgba(15, 20, 26, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(255, 255, 255, 0.15)",
              "dark": "rgba(255, 255, 255, 0.15)"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(255, 255, 255, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(255, 255, 255, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundFlashbarError": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundPopover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorBackgroundProgressBarValueDefault}",
              "dark": "{colorBackgroundProgressBarValueDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorBackgroundProgressBarDefault}",
              "dark": "{colorBackgroundProgressBarDefault}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorBackgroundSliderHandleDefault}",
              "dark": "{colorBackgroundSliderHandleDefault}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError1000}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo1000}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "{colorBackgroundStatusError}",
              "dark": "{colorBackgroundStatusError}"
            },
            "colorBackgroundAlertInfo": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundAlertSuccess": {
              "light": "{colorBackgroundStatusSuccess}",
              "dark": "{colorBackgroundStatusSuccess}"
            },
            "colorBackgroundAlertWarning": {
              "light": "{colorBackgroundStatusWarning}",
              "dark": "{colorBackgroundStatusWarning}"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess1000}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning1000}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorPrimary900}",
              "dark": "{colorPrimary900}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorTextInverted}",
              "dark": "{colorTextInverted}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodySecondary}",
              "dark": "{colorTextBodySecondary}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemSelected": {
              "light": "{colorItemSelected}",
              "dark": "{colorItemSelected}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorBackgroundNotificationStackBarHover}",
              "dark": "{colorBackgroundNotificationStackBarHover}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorBackgroundNotificationStackBar}",
              "dark": "{colorBackgroundNotificationStackBar}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorBorderDropdownContainer}",
              "dark": "{colorBorderDropdownContainer}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning500}",
              "dark": "{colorWarning500}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "rgba(0, 0, 0, 0.25)",
              "dark": "rgba(0, 0, 0, 0.25)"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextInteractiveHover}",
              "dark": "{colorTextInteractiveHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorTextFormDefault}",
              "dark": "{colorTextFormDefault}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple400}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInverted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorTextFormLabel}",
              "dark": "{colorTextFormLabel}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorTextStatusInfo}",
              "dark": "{colorTextStatusInfo}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorTextStatusSuccess}",
              "dark": "{colorTextStatusSuccess}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning500}",
              "dark": "{colorWarning500}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "{colorBackgroundNotificationGreen}",
              "dark": "{colorBackgroundNotificationGreen}"
            },
            "colorBackgroundBadgeBlue": {
              "light": "{colorBackgroundNotificationBlue}",
              "dark": "{colorBackgroundNotificationBlue}"
            },
            "colorBackgroundBadgeRed": {
              "light": "{colorBackgroundNotificationRed}",
              "dark": "{colorBackgroundNotificationRed}"
            },
            "colorBackgroundBadgeYellow": {
              "light": "{colorBackgroundNotificationYellow}",
              "dark": "{colorBackgroundNotificationYellow}"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorBackgroundNotificationGrey}",
              "dark": "{colorBackgroundNotificationGrey}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextBadgeRed": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundCodeView": {
              "light": "#282c34",
              "dark": "#282c34"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 75, 20, 0.2)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(173, 92, 255, 0.2)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "rgba(49, 184, 0, 0.2)",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(0, 173, 162, 0.2)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(0, 153, 255, 0.2)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(133, 117, 255, 0.2)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 26, 224, 0.2)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 51, 153, 0.2)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(250, 111, 0, 0.2)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning200}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#ff997a",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#d4a8ff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#acff2e",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#00f5e4",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#b2a8ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#ff57e9",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#ff99cc",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#ffbb45",
              "dark": "#ffbb45"
            }
          }
        }
      },
      "tokenModeMap": {
        "colorPrimary50": "color",
        "colorPrimary100": "color",
        "colorPrimary200": "color",
        "colorPrimary300": "color",
        "colorPrimary400": "color",
        "colorPrimary500": "color",
        "colorPrimary600": "color",
        "colorPrimary700": "color",
        "colorPrimary800": "color",
        "colorPrimary900": "color",
        "colorPrimary950": "color",
        "colorPrimary1000": "color",
        "colorNeutral50": "color",
        "colorNeutral100": "color",
        "colorNeutral150": "color",
        "colorNeutral200": "color",
        "colorNeutral250": "color",
        "colorNeutral300": "color",
        "colorNeutral350": "color",
        "colorNeutral400": "color",
        "colorNeutral450": "color",
        "colorNeutral500": "color",
        "colorNeutral550": "color",
        "colorNeutral600": "color",
        "colorNeutral650": "color",
        "colorNeutral700": "color",
        "colorNeutral750": "color",
        "colorNeutral800": "color",
        "colorNeutral850": "color",
        "colorNeutral900": "color",
        "colorNeutral950": "color",
        "colorNeutral1000": "color",
        "colorError50": "color",
        "colorError100": "color",
        "colorError400": "color",
        "colorError600": "color",
        "colorError700": "color",
        "colorError800": "color",
        "colorError900": "color",
        "colorError950": "color",
        "colorError1000": "color",
        "colorSuccess50": "color",
        "colorSuccess100": "color",
        "colorSuccess200": "color",
        "colorSuccess400": "color",
        "colorSuccess500": "color",
        "colorSuccess600": "color",
        "colorSuccess800": "color",
        "colorSuccess950": "color",
        "colorSuccess1000": "color",
        "colorWarning50": "color",
        "colorWarning100": "color",
        "colorWarning200": "color",
        "colorWarning400": "color",
        "colorWarning500": "color",
        "colorWarning600": "color",
        "colorWarning800": "color",
        "colorWarning900": "color",
        "colorWarning950": "color",
        "colorWarning1000": "color",
        "colorInfo50": "color",
        "colorInfo100": "color",
        "colorInfo300": "color",
        "colorInfo400": "color",
        "colorInfo600": "color",
        "colorInfo700": "color",
        "colorInfo800": "color",
        "colorInfo950": "color",
        "colorInfo1000": "color",
        "colorGrey50": "color",
        "colorGrey100": "color",
        "colorGrey150": "color",
        "colorGrey200": "color",
        "colorGrey250": "color",
        "colorGrey300": "color",
        "colorGrey350": "color",
        "colorGrey400": "color",
        "colorGrey450": "color",
        "colorGrey500": "color",
        "colorGrey600": "color",
        "colorGrey650": "color",
        "colorGrey700": "color",
        "colorGrey750": "color",
        "colorGrey800": "color",
        "colorGrey850": "color",
        "colorGrey900": "color",
        "colorGrey950": "color",
        "colorGrey1000": "color",
        "colorBlue50": "color",
        "colorBlue100": "color",
        "colorBlue200": "color",
        "colorBlue300": "color",
        "colorBlue400": "color",
        "colorBlue600": "color",
        "colorBlue700": "color",
        "colorBlue900": "color",
        "colorBlue1000": "color",
        "colorGreen50": "color",
        "colorGreen500": "color",
        "colorGreen600": "color",
        "colorGreen900": "color",
        "colorGreen1000": "color",
        "colorRed50": "color",
        "colorRed400": "color",
        "colorRed600": "color",
        "colorRed900": "color",
        "colorRed1000": "color",
        "colorYellow50": "color",
        "colorYellow400": "color",
        "colorYellow500": "color",
        "colorYellow900": "color",
        "colorYellow1000": "color",
        "colorPurple400": "color",
        "colorPurple700": "color",
        "colorAmber400": "color",
        "colorAmber500": "color",
        "colorRed950": "color",
        "colorOrange50": "color",
        "colorOrange100": "color",
        "colorOrange400": "color",
        "colorOrange700": "color",
        "colorOrange800": "color",
        "colorOrange950": "color",
        "colorYellow600": "color",
        "colorYellow950": "color",
        "colorLime50": "color",
        "colorLime100": "color",
        "colorLime400": "color",
        "colorLime700": "color",
        "colorLime800": "color",
        "colorLime950": "color",
        "colorGreen400": "color",
        "colorGreen950": "color",
        "colorMint50": "color",
        "colorMint100": "color",
        "colorMint400": "color",
        "colorMint700": "color",
        "colorMint800": "color",
        "colorMint950": "color",
        "colorIndigo50": "color",
        "colorIndigo400": "color",
        "colorIndigo600": "color",
        "colorIndigo950": "color",
        "colorPurple50": "color",
        "colorPurple100": "color",
        "colorPurple600": "color",
        "colorPurple800": "color",
        "colorPurple950": "color",
        "colorTeal50": "color",
        "colorTeal100": "color",
        "colorTeal400": "color",
        "colorTeal700": "color",
        "colorTeal800": "color",
        "colorTeal950": "color",
        "colorCyan50": "color",
        "colorCyan100": "color",
        "colorCyan400": "color",
        "colorCyan700": "color",
        "colorCyan800": "color",
        "colorCyan950": "color",
        "colorBlue950": "color",
        "colorViolet50": "color",
        "colorViolet100": "color",
        "colorViolet400": "color",
        "colorViolet700": "color",
        "colorViolet800": "color",
        "colorViolet950": "color",
        "colorFuchsia50": "color",
        "colorFuchsia100": "color",
        "colorFuchsia400": "color",
        "colorFuchsia700": "color",
        "colorFuchsia800": "color",
        "colorFuchsia950": "color",
        "colorMagenta50": "color",
        "colorMagenta100": "color",
        "colorMagenta400": "color",
        "colorMagenta700": "color",
        "colorMagenta800": "color",
        "colorMagenta950": "color",
        "colorPink50": "color",
        "colorPink100": "color",
        "colorPink400": "color",
        "colorPink700": "color",
        "colorPink800": "color",
        "colorPink950": "color",
        "colorRose50": "color",
        "colorRose100": "color",
        "colorRose400": "color",
        "colorRose700": "color",
        "colorRose800": "color",
        "colorRose950": "color",
        "colorAmber50": "color",
        "colorAmber100": "color",
        "colorAmber700": "color",
        "colorAmber800": "color",
        "colorAmber950": "color",
        "colorAwsSquidInk": "color",
        "colorTransparent": "color",
        "colorBlack": "color",
        "colorWhite": "color",
        "colorChartsRed300": "color",
        "colorChartsRed400": "color",
        "colorChartsRed500": "color",
        "colorChartsRed600": "color",
        "colorChartsRed700": "color",
        "colorChartsRed800": "color",
        "colorChartsRed900": "color",
        "colorChartsRed1000": "color",
        "colorChartsRed1100": "color",
        "colorChartsRed1200": "color",
        "colorChartsOrange300": "color",
        "colorChartsOrange400": "color",
        "colorChartsOrange500": "color",
        "colorChartsOrange600": "color",
        "colorChartsOrange700": "color",
        "colorChartsOrange800": "color",
        "colorChartsOrange900": "color",
        "colorChartsOrange1000": "color",
        "colorChartsOrange1100": "color",
        "colorChartsOrange1200": "color",
        "colorChartsYellow300": "color",
        "colorChartsYellow400": "color",
        "colorChartsYellow500": "color",
        "colorChartsYellow600": "color",
        "colorChartsYellow700": "color",
        "colorChartsYellow800": "color",
        "colorChartsYellow900": "color",
        "colorChartsYellow1000": "color",
        "colorChartsYellow1100": "color",
        "colorChartsYellow1200": "color",
        "colorChartsGreen300": "color",
        "colorChartsGreen400": "color",
        "colorChartsGreen500": "color",
        "colorChartsGreen600": "color",
        "colorChartsGreen700": "color",
        "colorChartsGreen800": "color",
        "colorChartsGreen900": "color",
        "colorChartsGreen1000": "color",
        "colorChartsGreen1100": "color",
        "colorChartsGreen1200": "color",
        "colorChartsTeal300": "color",
        "colorChartsTeal400": "color",
        "colorChartsTeal500": "color",
        "colorChartsTeal600": "color",
        "colorChartsTeal700": "color",
        "colorChartsTeal800": "color",
        "colorChartsTeal900": "color",
        "colorChartsTeal1000": "color",
        "colorChartsTeal1100": "color",
        "colorChartsTeal1200": "color",
        "colorChartsBlue1300": "color",
        "colorChartsBlue1400": "color",
        "colorChartsBlue1500": "color",
        "colorChartsBlue1600": "color",
        "colorChartsBlue1700": "color",
        "colorChartsBlue1800": "color",
        "colorChartsBlue1900": "color",
        "colorChartsBlue11000": "color",
        "colorChartsBlue11100": "color",
        "colorChartsBlue11200": "color",
        "colorChartsBlue2300": "color",
        "colorChartsBlue2400": "color",
        "colorChartsBlue2500": "color",
        "colorChartsBlue2600": "color",
        "colorChartsBlue2700": "color",
        "colorChartsBlue2800": "color",
        "colorChartsBlue2900": "color",
        "colorChartsBlue21000": "color",
        "colorChartsBlue21100": "color",
        "colorChartsBlue21200": "color",
        "colorChartsPurple300": "color",
        "colorChartsPurple400": "color",
        "colorChartsPurple500": "color",
        "colorChartsPurple600": "color",
        "colorChartsPurple700": "color",
        "colorChartsPurple800": "color",
        "colorChartsPurple900": "color",
        "colorChartsPurple1000": "color",
        "colorChartsPurple1100": "color",
        "colorChartsPurple1200": "color",
        "colorChartsPink300": "color",
        "colorChartsPink400": "color",
        "colorChartsPink500": "color",
        "colorChartsPink600": "color",
        "colorChartsPink700": "color",
        "colorChartsPink800": "color",
        "colorChartsPink900": "color",
        "colorChartsPink1000": "color",
        "colorChartsPink1100": "color",
        "colorChartsPink1200": "color",
        "colorChartsStatusCritical": "color",
        "colorChartsStatusHigh": "color",
        "colorChartsStatusMedium": "color",
        "colorChartsStatusLow": "color",
        "colorChartsStatusPositive": "color",
        "colorChartsStatusInfo": "color",
        "colorChartsStatusNeutral": "color",
        "colorChartsThresholdNegative": "color",
        "colorChartsThresholdPositive": "color",
        "colorChartsThresholdInfo": "color",
        "colorChartsThresholdNeutral": "color",
        "colorChartsLineGrid": "color",
        "colorChartsLineTick": "color",
        "colorChartsLineAxis": "color",
        "colorChartsPaletteCategorical1": "color",
        "colorChartsPaletteCategorical2": "color",
        "colorChartsPaletteCategorical3": "color",
        "colorChartsPaletteCategorical4": "color",
        "colorChartsPaletteCategorical5": "color",
        "colorChartsPaletteCategorical6": "color",
        "colorChartsPaletteCategorical7": "color",
        "colorChartsPaletteCategorical8": "color",
        "colorChartsPaletteCategorical9": "color",
        "colorChartsPaletteCategorical10": "color",
        "colorChartsPaletteCategorical11": "color",
        "colorChartsPaletteCategorical12": "color",
        "colorChartsPaletteCategorical13": "color",
        "colorChartsPaletteCategorical14": "color",
        "colorChartsPaletteCategorical15": "color",
        "colorChartsPaletteCategorical16": "color",
        "colorChartsPaletteCategorical17": "color",
        "colorChartsPaletteCategorical18": "color",
        "colorChartsPaletteCategorical19": "color",
        "colorChartsPaletteCategorical20": "color",
        "colorChartsPaletteCategorical21": "color",
        "colorChartsPaletteCategorical22": "color",
        "colorChartsPaletteCategorical23": "color",
        "colorChartsPaletteCategorical24": "color",
        "colorChartsPaletteCategorical25": "color",
        "colorChartsPaletteCategorical26": "color",
        "colorChartsPaletteCategorical27": "color",
        "colorChartsPaletteCategorical28": "color",
        "colorChartsPaletteCategorical29": "color",
        "colorChartsPaletteCategorical30": "color",
        "colorChartsPaletteCategorical31": "color",
        "colorChartsPaletteCategorical32": "color",
        "colorChartsPaletteCategorical33": "color",
        "colorChartsPaletteCategorical34": "color",
        "colorChartsPaletteCategorical35": "color",
        "colorChartsPaletteCategorical36": "color",
        "colorChartsPaletteCategorical37": "color",
        "colorChartsPaletteCategorical38": "color",
        "colorChartsPaletteCategorical39": "color",
        "colorChartsPaletteCategorical40": "color",
        "colorChartsPaletteCategorical41": "color",
        "colorChartsPaletteCategorical42": "color",
        "colorChartsPaletteCategorical43": "color",
        "colorChartsPaletteCategorical44": "color",
        "colorChartsPaletteCategorical45": "color",
        "colorChartsPaletteCategorical46": "color",
        "colorChartsPaletteCategorical47": "color",
        "colorChartsPaletteCategorical48": "color",
        "colorChartsPaletteCategorical49": "color",
        "colorChartsPaletteCategorical50": "color",
        "colorChartsErrorBarMarker": "color",
        "colorSeverityDarkRed": "color",
        "colorSeverityRed": "color",
        "colorSeverityOrange": "color",
        "colorSeverityYellow": "color",
        "colorSeverityGrey": "color",
        "colorBackgroundNotificationSeverityCritical": "color",
        "colorBackgroundNotificationSeverityHigh": "color",
        "colorBackgroundNotificationSeverityMedium": "color",
        "colorBackgroundNotificationSeverityLow": "color",
        "colorBackgroundNotificationSeverityNeutral": "color",
        "colorTextNotificationSeverityCritical": "color",
        "colorTextNotificationSeverityHigh": "color",
        "colorTextNotificationSeverityMedium": "color",
        "colorTextNotificationSeverityLow": "color",
        "colorTextNotificationSeverityNeutral": "color",
        "colorBorderBadgeSeverityCritical": "color",
        "colorBorderBadgeSeverityHigh": "color",
        "colorBorderBadgeSeverityMedium": "color",
        "colorBorderBadgeSeverityLow": "color",
        "colorBorderBadgeSeverityNeutral": "color",
        "colorTextBadgeSeverityCritical": "color",
        "colorTextBadgeSeverityHigh": "color",
        "colorTextBadgeSeverityMedium": "color",
        "colorTextBadgeSeverityLow": "color",
        "colorTextBadgeSeverityNeutral": "color",
        "colorGreyOpaque10": "color",
        "colorGreyOpaque25": "color",
        "colorGreyOpaque40": "color",
        "colorGreyOpaque50": "color",
        "colorGreyOpaque70": "color",
        "colorGreyOpaque80": "color",
        "colorGreyOpaque90": "color",
        "colorGreyTransparent": "color",
        "colorGreyTransparentHeavy": "color",
        "colorGreyTransparentLight": "color",
        "colorBackgroundBadgeIcon": "color",
        "colorBackgroundButtonLinkActive": "color",
        "colorBackgroundButtonLinkDefault": "color",
        "colorBackgroundButtonLinkDisabled": "color",
        "colorBackgroundButtonLinkHover": "color",
        "colorBackgroundButtonNormalActive": "color",
        "colorBackgroundButtonNormalDefault": "color",
        "colorBackgroundButtonNormalDisabled": "color",
        "colorBackgroundButtonNormalHover": "color",
        "colorBackgroundToggleButtonNormalPressed": "color",
        "colorBackgroundToggleButtonNormalDefault": "color",
        "colorBackgroundToggleButtonNormalHover": "color",
        "colorBackgroundButtonPrimaryActive": "color",
        "colorBackgroundButtonPrimaryDefault": "color",
        "colorBackgroundButtonPrimaryDisabled": "color",
        "colorBackgroundButtonPrimaryHover": "color",
        "colorBackgroundDirectionButtonActive": "color",
        "colorBackgroundDirectionButtonDefault": "color",
        "colorBackgroundDirectionButtonDisabled": "color",
        "colorBackgroundDirectionButtonHover": "color",
        "colorTextDirectionButtonDefault": "color",
        "colorTextDirectionButtonDisabled": "color",
        "colorBackgroundCalendarCurrentDate": "color",
        "colorBackgroundCellShaded": "color",
        "colorBackgroundCodeEditorGutterActiveLineDefault": "color",
        "colorBackgroundCodeEditorGutterActiveLineError": "color",
        "colorBackgroundCodeEditorGutterDefault": "color",
        "colorBackgroundCodeEditorLoading": "color",
        "colorBackgroundCodeEditorPaneItemHover": "color",
        "colorBackgroundCodeEditorStatusBar": "color",
        "colorBackgroundCard": "color",
        "colorBackgroundItemCard": "color",
        "colorBackgroundContainerContent": "color",
        "colorBackgroundContainerHeader": "color",
        "colorBackgroundControlChecked": "color",
        "colorBackgroundControlDefault": "color",
        "colorBackgroundControlDisabled": "color",
        "colorBackgroundDropdownItemDefault": "color",
        "colorBackgroundDropdownItemDimmed": "color",
        "colorBackgroundDropdownItemFilterMatch": "color",
        "colorBackgroundDropdownItemHover": "color",
        "colorBackgroundDropdownItemSelected": "color",
        "colorBackgroundHomeHeader": "color",
        "colorBackgroundInlineCode": "color",
        "colorBackgroundInputDefault": "color",
        "colorBackgroundInputDisabled": "color",
        "colorBackgroundItemSelected": "color",
        "colorBackgroundSideNavigationItemActive": "color",
        "colorBackgroundSideNavigationItemActiveCollapsed": "color",
        "colorBackgroundSideNavigationItemIconHover": "color",
        "colorBackgroundLayoutMain": "color",
        "colorBackgroundLayoutAiDrawer": "color",
        "colorBackgroundDrawer": "color",
        "colorBackgroundBackdrop": "color",
        "colorBackgroundDrawerBackdrop": "color",
        "colorBackgroundLayoutMobilePanel": "color",
        "colorBackgroundLayoutPanel": "color",
        "colorBackgroundLayoutPanelContent": "color",
        "colorBackgroundLayoutPanelHover": "color",
        "colorBackgroundLayoutToolbar": "color",
        "colorBackgroundLayoutToggleActive": "color",
        "colorBackgroundLayoutToggleDefault": "color",
        "colorBackgroundLayoutToggleHover": "color",
        "colorBackgroundLayoutToggleSelectedActive": "color",
        "colorBackgroundLayoutToggleSelectedDefault": "color",
        "colorBackgroundLayoutToggleSelectedHover": "color",
        "colorBackgroundModalOverlay": "color",
        "colorBackgroundNotificationBlue": "color",
        "colorBackgroundNotificationGreen": "color",
        "colorBackgroundNotificationGrey": "color",
        "colorBackgroundNotificationRed": "color",
        "colorBackgroundNotificationYellow": "color",
        "colorBackgroundFlashbarSuccess": "color",
        "colorBackgroundFlashbarError": "color",
        "colorBackgroundFlashbarInfo": "color",
        "colorBackgroundFlashbarWarning": "color",
        "colorBackgroundNotificationStackBar": "color",
        "colorBackgroundNotificationStackBarActive": "color",
        "colorBackgroundNotificationStackBarHover": "color",
        "colorBackgroundPopover": "color",
        "colorBackgroundProgressBarValueDefault": "color",
        "colorBackgroundProgressBarValueFlash": "color",
        "colorBackgroundProgressBarFlash": "color",
        "colorBackgroundProgressBarDefault": "color",
        "colorBackgroundSegmentActive": "color",
        "colorBackgroundSegmentDefault": "color",
        "colorBackgroundSegmentDisabled": "color",
        "colorBackgroundSegmentHover": "color",
        "colorBackgroundSegmentWrapper": "color",
        "colorBackgroundSliderRangeDefault": "color",
        "colorBackgroundSliderRangeActive": "color",
        "colorBackgroundSliderHandleDefault": "color",
        "colorBackgroundSliderHandleActive": "color",
        "colorBackgroundSliderTrackDefault": "color",
        "colorBackgroundSliderHandleRing": "color",
        "colorBackgroundSliderHandleErrorDefault": "color",
        "colorBackgroundSliderHandleErrorActive": "color",
        "colorBackgroundSliderHandleWarningDefault": "color",
        "colorBackgroundSliderHandleWarningActive": "color",
        "colorBackgroundSliderRangeErrorDefault": "color",
        "colorBackgroundSliderRangeErrorActive": "color",
        "colorBackgroundSliderRangeWarningDefault": "color",
        "colorBackgroundSliderRangeWarningActive": "color",
        "colorBackgroundStatusError": "color",
        "colorBackgroundStatusInfo": "color",
        "colorBackgroundAlertError": "color",
        "colorBackgroundAlertInfo": "color",
        "colorBackgroundAlertSuccess": "color",
        "colorBackgroundAlertWarning": "color",
        "colorBackgroundDialog": "color",
        "colorBackgroundDialogDefault": "color",
        "colorBackgroundStatusSuccess": "color",
        "colorBackgroundStatusWarning": "color",
        "colorBackgroundTableHeader": "color",
        "colorBackgroundTilesDisabled": "color",
        "colorBackgroundToggleCheckedDisabled": "color",
        "colorBackgroundToggleDefault": "color",
        "colorBackgroundAvatarGenAi": "color",
        "colorBackgroundAvatarDefault": "color",
        "colorTextAvatar": "color",
        "colorBackgroundLoadingBarGenAi": "color",
        "colorBackgroundStatusIndicatorError": "color",
        "colorBackgroundStatusIndicatorWarning": "color",
        "colorBackgroundStatusIndicatorSuccess": "color",
        "colorBackgroundStatusIndicatorInfo": "color",
        "colorBackgroundStatusIndicatorNeutral": "color",
        "colorBackgroundChatBubbleOutgoing": "color",
        "colorBackgroundChatBubbleIncoming": "color",
        "colorTextChatBubbleOutgoing": "color",
        "colorTextChatBubbleIncoming": "color",
        "colorBorderButtonLinkDisabled": "color",
        "colorBorderButtonNormalActive": "color",
        "colorBorderButtonNormalDefault": "color",
        "colorBorderToggleButtonNormalPressed": "color",
        "colorBorderToggleButtonNormalDefault": "color",
        "colorBorderToggleButtonNormalHover": "color",
        "colorBorderButtonNormalDisabled": "color",
        "colorTextButtonNormalDisabled": "color",
        "colorBorderButtonNormalHover": "color",
        "colorTextButtonIconDisabled": "color",
        "colorBorderButtonPrimaryActive": "color",
        "colorBorderButtonPrimaryDefault": "color",
        "colorBorderButtonPrimaryDisabled": "color",
        "colorBorderButtonPrimaryHover": "color",
        "colorTextButtonPrimaryDisabled": "color",
        "colorItemSelected": "color",
        "colorTextSideNavigationItemActive": "color",
        "colorTextSideNavigationItemActiveCollapsed": "color",
        "colorTextSideNavigationItemDefault": "color",
        "colorBorderCalendarGrid": "color",
        "colorBorderCalendarGridSelectedFocusRing": "color",
        "colorBorderCellShaded": "color",
        "colorBorderCodeEditorAceActiveLineLightTheme": "color",
        "colorBorderCodeEditorAceActiveLineDarkTheme": "color",
        "colorBorderCodeEditorDefault": "color",
        "colorBorderCodeEditorPaneItemHover": "color",
        "colorBorderCard": "color",
        "colorBorderCardHighlighted": "color",
        "colorBorderItemCard": "color",
        "colorBorderItemCardHighlighted": "color",
        "colorBorderContainerDivider": "color",
        "colorBorderContainerTop": "color",
        "colorBorderControlChecked": "color",
        "colorBorderControlDefault": "color",
        "colorBorderControlDisabled": "color",
        "colorBorderDividerActive": "color",
        "colorBorderDividerDefault": "color",
        "colorBorderDividerNotification": "color",
        "colorBorderDividerPanelBottom": "color",
        "colorBorderDividerPanelSide": "color",
        "colorBorderDividerSecondary": "color",
        "colorBorderDividerTableGroup": "color",
        "colorBorderDropdownContainer": "color",
        "colorBorderDropdownGroup": "color",
        "colorBorderDropdownItemDefault": "color",
        "colorBorderDropdownItemHover": "color",
        "colorBorderDropdownItemDimmedHover": "color",
        "colorBorderDropdownItemSelected": "color",
        "colorBorderDropdownItemTop": "color",
        "colorBorderEditableCellHover": "color",
        "colorBorderInputDefault": "color",
        "colorBorderInputDisabled": "color",
        "colorBorderInputFocused": "color",
        "colorBorderItemFocused": "color",
        "colorBorderDropdownItemFocused": "color",
        "colorBorderItemPlaceholder": "color",
        "colorBorderItemSelected": "color",
        "colorBorderLayout": "color",
        "colorBorderLayoutSideNavigation": "color",
        "colorBorderNotificationStackBar": "color",
        "colorBorderNotificationStackBarHover": "color",
        "colorBorderNotificationStackBarActive": "color",
        "colorBorderNotificationStackBarFocused": "color",
        "colorBorderPanelHeader": "color",
        "colorBorderPopover": "color",
        "colorBorderSegmentActive": "color",
        "colorBorderSegmentDefault": "color",
        "colorBorderSegmentDisabled": "color",
        "colorBorderSegmentDivider": "color",
        "colorBorderSegmentHover": "color",
        "colorBorderSegmentWrapper": "color",
        "colorBorderStatusError": "color",
        "colorBorderStatusInfo": "color",
        "colorBorderStatusSuccess": "color",
        "colorBorderStatusWarning": "color",
        "colorBorderDialog": "color",
        "colorBorderDialogDefault": "color",
        "colorBorderDividerInteractiveDefault": "color",
        "colorBorderTabsDivider": "color",
        "colorBorderTabsShadow": "color",
        "colorBorderTabsUnderline": "color",
        "colorBorderTilesDisabled": "color",
        "colorBorderTutorial": "color",
        "colorForegroundControlDefault": "color",
        "colorForegroundControlDisabled": "color",
        "colorForegroundControlReadOnly": "color",
        "colorShadowDefault": "color",
        "colorShadowMedium": "color",
        "colorShadowSide": "color",
        "colorShadowToggleHandle": "color",
        "colorStrokeChartLine": "color",
        "colorStrokeCodeEditorGutterActiveLineDefault": "color",
        "colorStrokeCodeEditorGutterActiveLineHover": "color",
        "colorTextAccent": "color",
        "colorTextBodyDefault": "color",
        "colorTextBodySecondary": "color",
        "colorTextBreadcrumbCurrent": "color",
        "colorTextBreadcrumbIcon": "color",
        "colorTextButtonInlineIconDefault": "color",
        "colorTextButtonInlineIconDisabled": "color",
        "colorTextButtonInlineIconHover": "color",
        "colorTextButtonInlineLinkHover": "color",
        "colorTextButtonIconHover": "color",
        "colorTextButtonNormalActive": "color",
        "colorTextToggleButtonNormalPressed": "color",
        "colorTextButtonNormalDefault": "color",
        "colorTextButtonNormalHover": "color",
        "colorTextLinkButtonNormalDefault": "color",
        "colorTextLinkButtonNormalHover": "color",
        "colorTextLinkButtonNormalActive": "color",
        "colorTextButtonLinkActive": "color",
        "colorTextButtonLinkDefault": "color",
        "colorTextButtonLinkDisabled": "color",
        "colorTextButtonLinkHover": "color",
        "colorTextButtonPrimaryActive": "color",
        "colorTextButtonPrimaryDefault": "color",
        "colorTextButtonPrimaryHover": "color",
        "colorTextCalendarDateHover": "color",
        "colorTextCalendarDateSelected": "color",
        "colorTextCalendarMonth": "color",
        "colorTextCodeEditorGutterActiveLine": "color",
        "colorTextCodeEditorGutterDefault": "color",
        "colorTextCodeEditorStatusBarDisabled": "color",
        "colorTextCodeEditorTabButtonError": "color",
        "colorTextColumnHeader": "color",
        "colorTextColumnSortingIcon": "color",
        "colorTextControlDisabled": "color",
        "colorTextCounter": "color",
        "colorTextDisabled": "color",
        "colorTextDisabledInlineEdit": "color",
        "colorTextDropdownFooter": "color",
        "colorTextDropdownGroupLabel": "color",
        "colorTextDropdownItemDefault": "color",
        "colorTextDropdownItemDimmed": "color",
        "colorTextDropdownItemDisabled": "color",
        "colorTextDropdownItemFilterMatch": "color",
        "colorTextDropdownItemHighlighted": "color",
        "colorTextDropdownItemSecondary": "color",
        "colorTextDropdownItemSecondaryHover": "color",
        "colorTextEmpty": "color",
        "colorTextExpandableSectionDefault": "color",
        "colorTextExpandableSectionHover": "color",
        "colorTextExpandableSectionNavigationIconDefault": "color",
        "colorBorderExpandableSectionDefault": "color",
        "colorTextFormDefault": "color",
        "colorTextFormLabel": "color",
        "colorTextFormSecondary": "color",
        "colorTextGroupLabel": "color",
        "colorTextLabelGenAi": "color",
        "colorTextHeadingDefault": "color",
        "colorTextHeadingSecondary": "color",
        "colorTextHomeHeaderDefault": "color",
        "colorTextHomeHeaderSecondary": "color",
        "colorTextIconCaret": "color",
        "colorTextIconSubtle": "color",
        "colorTextInputDisabled": "color",
        "colorTextInputPlaceholder": "color",
        "colorTextInputPlaceholderDisabled": "color",
        "colorTextInteractiveActive": "color",
        "colorTextInteractiveDefault": "color",
        "colorTextInteractiveDisabled": "color",
        "colorTextInteractiveHover": "color",
        "colorTextToggleButtonIconPressed": "color",
        "colorTextInteractiveInvertedDefault": "color",
        "colorTextInteractiveInvertedHover": "color",
        "colorTextInverted": "color",
        "colorTextLabel": "color",
        "colorTextKeyValuePairsValue": "color",
        "colorTextLayoutToggle": "color",
        "colorTextLayoutToggleActive": "color",
        "colorTextLayoutToggleHover": "color",
        "colorTextLayoutToggleSelected": "color",
        "colorTextLinkDefault": "color",
        "colorTextLinkHover": "color",
        "colorTextLinkDecorationDefault": "color",
        "colorTextLinkDecorationHover": "color",
        "colorTextLinkSecondaryDefault": "color",
        "colorTextLinkSecondaryHover": "color",
        "colorTextLinkSecondaryDecorationDefault": "color",
        "colorTextLinkInfoDefault": "color",
        "colorTextLinkInfoHover": "color",
        "colorTextLinkInvertedDefault": "color",
        "colorTextLinkInvertedHover": "color",
        "colorTextLinkButtonUnderline": "color",
        "colorTextLinkButtonUnderlineHover": "color",
        "colorTextNotificationDefault": "color",
        "colorTextAlertDefault": "color",
        "colorTextNotificationLinkDefault": "color",
        "colorTextNotificationLinkHover": "color",
        "colorTextNotificationStackBar": "color",
        "colorTextNotificationYellow": "color",
        "colorTextPaginationPageNumberActiveDisabled": "color",
        "colorTextPaginationPageNumberDefault": "color",
        "colorTextSegmentActive": "color",
        "colorTextSegmentDefault": "color",
        "colorTextSegmentHover": "color",
        "colorTextSmall": "color",
        "colorTextFlashbarIconError": "color",
        "colorTextFlashbarIconInfo": "color",
        "colorTextFlashbarIconSuccess": "color",
        "colorTextFlashbarIconWarning": "color",
        "colorTextAlertIconError": "color",
        "colorTextAlertIconInfo": "color",
        "colorTextAlertIconSuccess": "color",
        "colorTextAlertIconWarning": "color",
        "colorTextStatusError": "color",
        "colorTextStatusInactive": "color",
        "colorTextStatusInfo": "color",
        "colorTextStatusSuccess": "color",
        "colorTextStatusWarning": "color",
        "colorTextTopNavigationTitle": "color",
        "colorTextTutorialHotspotDefault": "color",
        "colorTextTutorialHotspotHover": "color",
        "colorBoardPlaceholderActive": "color",
        "colorBoardPlaceholderHover": "color",
        "colorDragPlaceholderActive": "color",
        "colorDragPlaceholderHover": "color",
        "colorDropzoneBackgroundDefault": "color",
        "colorDropzoneBackgroundHover": "color",
        "colorDropzoneTextDefault": "color",
        "colorDropzoneTextHover": "color",
        "colorDropzoneBorderDefault": "color",
        "colorDropzoneBorderHover": "color",
        "colorGapGlobalDrawer": "color",
        "colorTreeViewConnectorLine": "color",
        "colorBackgroundActionCardDefault": "color",
        "colorBackgroundActionCardHover": "color",
        "colorBackgroundActionCardActive": "color",
        "colorBorderActionCardDefault": "color",
        "colorBorderActionCardHover": "color",
        "colorBorderActionCardActive": "color",
        "colorBorderActionCardDisabled": "color",
        "colorBackgroundActionCardDisabled": "color",
        "colorTextActionCardDisabled": "color",
        "colorTextActionCardIconDefault": "color",
        "colorTextActionCardIconHover": "color",
        "colorTextActionCardIconActive": "color",
        "colorTextActionCardIconDisabled": "color",
        "colorBackgroundSkeleton": "color",
        "colorBackgroundSkeletonWave": "color",
        "colorBackgroundBadgeGreen": "color",
        "colorBackgroundBadgeBlue": "color",
        "colorBackgroundBadgeRed": "color",
        "colorBackgroundBadgeYellow": "color",
        "colorBackgroundBadgeGrey": "color",
        "colorBorderBadge": "color",
        "colorBorderBadgeGrey": "color",
        "colorBorderBadgeGreen": "color",
        "colorBorderBadgeBlue": "color",
        "colorBorderBadgeRed": "color",
        "colorTextBadgeGrey": "color",
        "colorTextBadgeGreen": "color",
        "colorTextBadgeBlue": "color",
        "colorTextBadgeRed": "color",
        "colorBackgroundCodeView": "color",
        "colorBackgroundVisualAccentRed": "color",
        "colorBackgroundVisualAccentYellow": "color",
        "colorBackgroundVisualAccentIndigo": "color",
        "colorBackgroundVisualAccentGreen": "color",
        "colorBackgroundVisualAccentOrange": "color",
        "colorBackgroundVisualAccentPurple": "color",
        "colorBackgroundVisualAccentLime": "color",
        "colorBackgroundVisualAccentGrey": "color",
        "colorBackgroundVisualAccentTeal": "color",
        "colorBackgroundVisualAccentBlue": "color",
        "colorBackgroundVisualAccentViolet": "color",
        "colorBackgroundVisualAccentMagenta": "color",
        "colorBackgroundVisualAccentPink": "color",
        "colorBackgroundVisualAccentAmber": "color",
        "colorTextVisualAccentRed": "color",
        "colorTextVisualAccentYellow": "color",
        "colorTextVisualAccentIndigo": "color",
        "colorTextVisualAccentGreen": "color",
        "colorTextVisualAccentOrange": "color",
        "colorTextVisualAccentPurple": "color",
        "colorTextVisualAccentLime": "color",
        "colorTextVisualAccentGrey": "color",
        "colorTextVisualAccentTeal": "color",
        "colorTextVisualAccentBlue": "color",
        "colorTextVisualAccentViolet": "color",
        "colorTextVisualAccentMagenta": "color",
        "colorTextVisualAccentPink": "color",
        "colorTextVisualAccentAmber": "color",
        "motionDurationExtraFast": "motion",
        "motionDurationExtraSlow": "motion",
        "motionDurationFast": "motion",
        "motionDurationModerate": "motion",
        "motionDurationRefreshOnlyAmbient": "motion",
        "motionDurationRefreshOnlyFast": "motion",
        "motionDurationRefreshOnlyMedium": "motion",
        "motionDurationRefreshOnlySlow": "motion",
        "motionDurationAvatarGenAiGradient": "motion",
        "motionDurationAvatarLoadingDots": "motion",
        "motionDurationRotate180": "motion",
        "motionDurationRotate90": "motion",
        "motionDurationShowPaced": "motion",
        "motionDurationShowQuick": "motion",
        "motionDurationSlow": "motion",
        "motionDurationTransitionQuick": "motion",
        "motionDurationTransitionShowPaced": "motion",
        "motionDurationTransitionShowQuick": "motion",
        "motionEasingEaseOutQuart": "motion",
        "motionEasingRefreshOnlyA": "motion",
        "motionEasingRefreshOnlyB": "motion",
        "motionEasingRefreshOnlyC": "motion",
        "motionEasingRefreshOnlyD": "motion",
        "motionEasingAvatarGenAiGradient": "motion",
        "motionEasingRotate180": "motion",
        "motionEasingRotate90": "motion",
        "motionEasingShowPaced": "motion",
        "motionEasingShowQuick": "motion",
        "motionEasingTransitionQuick": "motion",
        "motionEasingTransitionShowPaced": "motion",
        "motionEasingTransitionShowQuick": "motion",
        "motionEasingResponsive": "motion",
        "motionEasingSticky": "motion",
        "motionEasingExpressive": "motion",
        "motionDurationResponsive": "motion",
        "motionDurationExpressive": "motion",
        "motionDurationComplex": "motion",
        "motionDurationTooltipEnter": "motion",
        "motionEasingTooltipEnter": "motion",
        "motionDurationExpandableContentEnter": "motion",
        "motionEasingExpandableContentEnter": "motion",
        "motionDurationSideNavigationContentEnterFade": "motion",
        "motionDurationSideNavigationContentExit": "motion",
        "motionDurationSideNavigationContentExitFade": "motion",
        "motionEasingSideNavigationContentExit": "motion",
        "motionKeyframesFadeIn": "motion",
        "motionKeyframesFadeOut": "motion",
        "motionKeyframesStatusIconError": "motion",
        "motionKeyframesScalePopup": "motion",
        "sizeCalendarGridWidth": "density",
        "sizeControl": "density",
        "sizeIconBig": "density",
        "sizeIconLarge": "density",
        "sizeIconMedium": "density",
        "sizeIconNormal": "density",
        "sizeTableSelectionHorizontal": "density",
        "sizeVerticalInput": "density",
        "sizeVerticalPanelIconOffset": "density",
        "sizeSideNavigationItemHeight": "density",
        "sizeSideNavigationItemCollapsed": "density",
        "sizeSideNavigationCollapsedWidth": "density",
        "spaceAlertActionLeft": "density",
        "spaceAlertHorizontal": "density",
        "spaceAlertMessageRight": "density",
        "spaceAlertVertical": "density",
        "spaceButtonFocusOutlineGutter": "density",
        "spaceButtonHorizontal": "density",
        "spaceButtonVertical": "density",
        "spaceTokenVertical": "density",
        "spaceFieldVertical": "density",
        "spaceButtonIconFocusOutlineGutterVertical": "density",
        "spaceButtonIconOnlyHorizontal": "density",
        "spaceButtonInlineIconFocusOutlineGutter": "density",
        "spaceButtonModalDismissVertical": "density",
        "spaceCalendarGridFocusOutlineGutter": "density",
        "spaceCalendarGridSelectedFocusOutlineGutter": "density",
        "spaceCalendarGridGutter": "density",
        "spaceCardHorizontalDefault": "density",
        "spaceCardHorizontalEmbedded": "density",
        "spaceCardVerticalDefault": "density",
        "spaceCardVerticalEmbedded": "density",
        "spaceItemCardHorizontalDefault": "density",
        "spaceItemCardHorizontalEmbedded": "density",
        "spaceItemCardVerticalDefault": "density",
        "spaceItemCardVerticalEmbedded": "density",
        "spaceDialogHorizontal": "density",
        "spaceDialogVertical": "density",
        "spaceDialogActionBlock": "density",
        "spaceDialogActionInline": "density",
        "spaceDialogHeaderGap": "density",
        "spaceDialogSectionGap": "density",
        "spaceCodeEditorStatusFocusOutlineGutter": "density",
        "spaceContainerContentTop": "density",
        "spaceContainerHeaderTop": "density",
        "spaceContainerHeaderBottom": "density",
        "spaceContainerHorizontal": "density",
        "spaceContentHeaderPaddingBottom": "density",
        "spaceDarkHeaderOverlapDistance": "density",
        "spaceExpandableSectionIconOffsetTop": "density",
        "spaceFieldHorizontal": "density",
        "spaceFieldIconOffset": "density",
        "spaceFilteringTokenDismissButtonFocusOutlineGutter": "density",
        "spaceFilteringTokenOperationSelectFocusOutlineGutter": "density",
        "spaceFlashbarActionLeft": "density",
        "spaceFlashbarDismissRight": "density",
        "spaceFlashbarHorizontal": "density",
        "spaceFlashbarVertical": "density",
        "spaceGridGutter": "density",
        "spaceKeyValueGap": "density",
        "spaceLayoutContentBottom": "density",
        "spaceLayoutContentHorizontal": "density",
        "spaceLayoutToggleDiameter": "density",
        "spaceLayoutTogglePadding": "density",
        "spaceModalContentBottom": "density",
        "spaceModalHorizontal": "density",
        "spacePanelContentBottom": "density",
        "spacePanelContentTop": "density",
        "spacePanelDividerMarginHorizontal": "density",
        "spacePanelHeaderVertical": "density",
        "spacePanelNavLeft": "density",
        "spacePanelSideLeft": "density",
        "spacePanelSideRight": "density",
        "spacePanelSplitTop": "density",
        "spacePanelSplitBottom": "density",
        "spaceSegmentedControlFocusOutlineGutter": "density",
        "spaceTabsContentTop": "density",
        "spaceTabsFocusOutlineGutter": "density",
        "spaceTabsVertical": "density",
        "spaceTableContentBottom": "density",
        "spaceTableEmbeddedHeaderTop": "density",
        "spaceTableFooterHorizontal": "density",
        "spaceTableHeaderFocusOutlineGutter": "density",
        "spaceTableHeaderHorizontal": "density",
        "spaceTableHeaderToolsBottom": "density",
        "spaceTableHeaderToolsFullPageBottom": "density",
        "spaceTableHorizontal": "density",
        "spaceTreeViewIndentation": "density",
        "spaceSideNavigationItemDefaultGap": "density",
        "spaceSideNavigationItemIconGap": "density",
        "spaceTileGutter": "density",
        "spaceActionCardHorizontalDefault": "density",
        "spaceActionCardHorizontalEmbedded": "density",
        "spaceActionCardVerticalDefault": "density",
        "spaceActionCardVerticalEmbedded": "density",
        "spaceActionCardDescriptionPaddingTop": "density",
        "spaceActionCardContentPaddingTop": "density",
        "spaceOptionPaddingVertical": "density",
        "spaceOptionPaddingHorizontal": "density",
        "spaceStatusIndicatorPaddingHorizontal": "density",
        "spaceScaled2xNone": "density",
        "spaceScaled2xXxxs": "density",
        "spaceScaled2xXxs": "density",
        "spaceScaled2xXs": "density",
        "spaceScaled2xS": "density",
        "spaceScaled2xM": "density",
        "spaceScaled2xL": "density",
        "spaceScaled2xXl": "density",
        "spaceScaled2xXxl": "density",
        "spaceScaled2xXxxl": "density",
        "spaceScaledNone": "density",
        "spaceScaledXxxs": "density",
        "spaceScaledXxs": "density",
        "spaceScaledXs": "density",
        "spaceScaledS": "density",
        "spaceScaledM": "density",
        "spaceScaledL": "density",
        "spaceScaledXl": "density",
        "spaceScaledXxl": "density",
        "spaceScaledXxxl": "density",
        "spaceStaticXxxs": "density",
        "spaceStaticXxs": "density",
        "spaceStaticXs": "density",
        "spaceStaticS": "density",
        "spaceStaticM": "density",
        "spaceStaticL": "density",
        "spaceStaticXl": "density",
        "spaceStaticXxl": "density",
        "spaceStaticXxxl": "density",
        "spaceNone": "density",
        "spaceXxxs": "density",
        "spaceXxs": "density",
        "spaceXs": "density",
        "spaceS": "density",
        "spaceM": "density",
        "spaceL": "density",
        "spaceXl": "density",
        "spaceXxl": "density",
        "spaceXxxl": "density",
        "shadowCard": "color",
        "shadowItemCard": "color",
        "shadowDialog": "color",
        "shadowContainer": "color",
        "shadowContainerActive": "color",
        "shadowDropdown": "color",
        "shadowDropup": "color",
        "shadowFlashCollapsed": "color",
        "shadowFlashSticky": "color",
        "shadowModal": "color",
        "shadowPanel": "color",
        "shadowPanelToggle": "color",
        "shadowPopover": "color",
        "shadowSplitBottom": "color",
        "shadowSplitSide": "color",
        "shadowSticky": "color",
        "shadowStickyEmbedded": "color",
        "shadowStickyColumnFirst": "color",
        "shadowStickyColumnLast": "color"
      },
      "referenceTokens": {
        "color": {
          "primary": {
            "50": {
              "light": "#f0fbff",
              "dark": "#f0fbff"
            },
            "100": {
              "light": "#d1f1ff",
              "dark": "#d1f1ff"
            },
            "200": {
              "light": "#b8e7ff",
              "dark": "#b8e7ff"
            },
            "300": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "400": {
              "light": "#42b4ff",
              "dark": "#42b4ff"
            },
            "500": {
              "light": "#0099ff",
              "dark": "#0099ff"
            },
            "600": {
              "light": "#006ce0",
              "dark": "#006ce0"
            },
            "700": {
              "light": "#004a9e",
              "dark": "#004a9e"
            },
            "800": {
              "light": "#003b8f",
              "dark": "#003b8f"
            },
            "900": {
              "light": "#002b66",
              "dark": "#002b66"
            },
            "950": {
              "light": "#00204d",
              "dark": "#00204d"
            },
            "1000": {
              "light": "#001129",
              "dark": "#001129"
            }
          },
          "neutral": {
            "50": {
              "light": "#fcfcfd",
              "dark": "#fcfcfd"
            },
            "100": {
              "light": "#f9f9fa",
              "dark": "#f9f9fa"
            },
            "150": {
              "light": "#f6f6f9",
              "dark": "#f6f6f9"
            },
            "200": {
              "light": "#f3f3f7",
              "dark": "#f3f3f7"
            },
            "250": {
              "light": "#ebebf0",
              "dark": "#ebebf0"
            },
            "300": {
              "light": "#dedee3",
              "dark": "#dedee3"
            },
            "350": {
              "light": "#c6c6cd",
              "dark": "#c6c6cd"
            },
            "400": {
              "light": "#b4b4bb",
              "dark": "#b4b4bb"
            },
            "450": {
              "light": "#a4a4ad",
              "dark": "#a4a4ad"
            },
            "500": {
              "light": "#8c8c94",
              "dark": "#8c8c94"
            },
            "550": {
              "light": "#72747e",
              "dark": "#72747e"
            },
            "600": {
              "light": "#656871",
              "dark": "#656871"
            },
            "650": {
              "light": "#424650",
              "dark": "#424650"
            },
            "700": {
              "light": "#333843",
              "dark": "#333843"
            },
            "750": {
              "light": "#232b37",
              "dark": "#232b37"
            },
            "800": {
              "light": "#1b232d",
              "dark": "#1b232d"
            },
            "850": {
              "light": "#161d26",
              "dark": "#161d26"
            },
            "900": {
              "light": "#131920",
              "dark": "#131920"
            },
            "950": {
              "light": "#0f141a",
              "dark": "#0f141a"
            },
            "1000": {
              "light": "#06080a",
              "dark": "#06080a"
            }
          },
          "error": {
            "50": {
              "light": "#fff5f5",
              "dark": "#fff5f5"
            },
            "100": {
              "light": "#ffe0e0",
              "dark": "#ffe0e0"
            },
            "400": {
              "light": "#ff7a7a",
              "dark": "#ff7a7a"
            },
            "600": {
              "light": "#db0000",
              "dark": "#db0000"
            },
            "700": {
              "light": "#c20000",
              "dark": "#c20000"
            },
            "800": {
              "light": "#990000",
              "dark": "#990000"
            },
            "900": {
              "light": "#700000",
              "dark": "#700000"
            },
            "950": {
              "light": "#520000",
              "dark": "#520000"
            },
            "1000": {
              "light": "#1f0000",
              "dark": "#1f0000"
            }
          },
          "success": {
            "50": {
              "light": "#effff1",
              "dark": "#effff1"
            },
            "100": {
              "light": "#d9ffd6",
              "dark": "#d9ffd6"
            },
            "200": {
              "light": "#aeffa8",
              "dark": "#aeffa8"
            },
            "400": {
              "light": "#00e500",
              "dark": "#00e500"
            },
            "500": {
              "light": "#2bb534",
              "dark": "#2bb534"
            },
            "600": {
              "light": "#00802f",
              "dark": "#00802f"
            },
            "800": {
              "light": "#005c26",
              "dark": "#005c26"
            },
            "950": {
              "light": "#003311",
              "dark": "#003311"
            },
            "1000": {
              "light": "#001401",
              "dark": "#001401"
            }
          },
          "warning": {
            "50": {
              "light": "#fffef0",
              "dark": "#fffef0"
            },
            "100": {
              "light": "#fffbbd",
              "dark": "#fffbbd"
            },
            "200": {
              "light": "#fef571",
              "dark": "#fef571"
            },
            "400": {
              "light": "#ffe347",
              "dark": "#ffe347"
            },
            "500": {
              "light": "#fbd332",
              "dark": "#fbd332"
            },
            "600": {
              "light": "#f2b100",
              "dark": "#f2b100"
            },
            "800": {
              "light": "#9e6900",
              "dark": "#9e6900"
            },
            "900": {
              "light": "#855900",
              "dark": "#855900"
            },
            "950": {
              "light": "#573a00",
              "dark": "#573a00"
            },
            "1000": {
              "light": "#191100",
              "dark": "#191100"
            }
          },
          "info": {
            "50": {
              "light": "#f0fbff",
              "dark": "#f0fbff"
            },
            "100": {
              "light": "#d1f1ff",
              "dark": "#d1f1ff"
            },
            "300": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "400": {
              "light": "#42b4ff",
              "dark": "#42b4ff"
            },
            "600": {
              "light": "#006ce0",
              "dark": "#006ce0"
            },
            "700": {
              "light": "#004a9e",
              "dark": "#004a9e"
            },
            "800": {
              "light": "#003b8f",
              "dark": "#003b8f"
            },
            "950": {
              "light": "#00204d",
              "dark": "#00204d"
            },
            "1000": {
              "light": "#001129",
              "dark": "#001129"
            }
          }
        }
      }
    },
    {
      "id": "one-theme",
      "selector": ".awsui-one-theme",
      "modes": {
        "color": {
          "id": "color",
          "states": {
            "light": {
              "default": true
            },
            "dark": {
              "selector": ".awsui-dark-mode",
              "media": "not print"
            }
          }
        },
        "density": {
          "id": "density",
          "states": {
            "comfortable": {
              "default": true
            },
            "compact": {
              "selector": ".awsui-compact-mode"
            }
          }
        },
        "motion": {
          "id": "motion",
          "states": {
            "default": {
              "default": true
            },
            "disabled": {
              "selector": ".awsui-motion-disabled"
            }
          }
        }
      },
      "tokens": {
        "colorPrimary50": {
          "light": "#f5f7ff",
          "dark": "#f5f7ff"
        },
        "colorPrimary100": {
          "light": "#dbe4ff",
          "dark": "#dbe4ff"
        },
        "colorPrimary200": {
          "light": "#c2d1ff",
          "dark": "#c2d1ff"
        },
        "colorPrimary300": {
          "light": "#94afff",
          "dark": "#94afff"
        },
        "colorPrimary400": {
          "light": "#7598ff",
          "dark": "#7598ff"
        },
        "colorPrimary500": {
          "light": "#5c7fff",
          "dark": "#5c7fff"
        },
        "colorPrimary600": {
          "light": "#295eff",
          "dark": "#295eff"
        },
        "colorPrimary700": {
          "light": "#003efa",
          "dark": "#003efa"
        },
        "colorPrimary800": {
          "light": "#0033cc",
          "dark": "#0033cc"
        },
        "colorPrimary900": {
          "light": "#001a99",
          "dark": "#001a99"
        },
        "colorPrimary950": {
          "light": "#00204d",
          "dark": "#00204d"
        },
        "colorPrimary1000": {
          "light": "#000833",
          "dark": "#000833"
        },
        "colorNeutral50": {
          "light": "#fcfcfc",
          "dark": "#fcfcfc"
        },
        "colorNeutral100": {
          "light": "#f9f9f9",
          "dark": "#f9f9f9"
        },
        "colorNeutral150": {
          "light": "#f8f8f7",
          "dark": "#f8f8f7"
        },
        "colorNeutral200": {
          "light": "#f3f3f1",
          "dark": "#f3f3f1"
        },
        "colorNeutral250": {
          "light": "#eeedeb",
          "dark": "#eeedeb"
        },
        "colorNeutral300": {
          "light": "#e3e1de",
          "dark": "#e3e1de"
        },
        "colorNeutral350": {
          "light": "#cbc9c3",
          "dark": "#cbc9c3"
        },
        "colorNeutral400": {
          "light": "#bab7b0",
          "dark": "#bab7b0"
        },
        "colorNeutral450": {
          "light": "#aca9a2",
          "dark": "#aca9a2"
        },
        "colorNeutral500": {
          "light": "#949088",
          "dark": "#949088"
        },
        "colorNeutral550": {
          "light": "#868279",
          "dark": "#868279"
        },
        "colorNeutral600": {
          "light": "#6f6b63",
          "dark": "#6f6b63"
        },
        "colorNeutral650": {
          "light": "#4c4942",
          "dark": "#4c4942"
        },
        "colorNeutral700": {
          "light": "#3e3b35",
          "dark": "#3e3b35"
        },
        "colorNeutral750": {
          "light": "#2f2d28",
          "dark": "#2f2d28"
        },
        "colorNeutral800": {
          "light": "#262420",
          "dark": "#262420"
        },
        "colorNeutral850": {
          "light": "#201e1b",
          "dark": "#201e1b"
        },
        "colorNeutral900": {
          "light": "#1b1a17",
          "dark": "#1b1a17"
        },
        "colorNeutral950": {
          "light": "#161512",
          "dark": "#161512"
        },
        "colorNeutral1000": {
          "light": "#100f0d",
          "dark": "#100f0d"
        },
        "colorError50": {
          "light": "#fff5f5",
          "dark": "#fff5f5"
        },
        "colorError100": {
          "light": "#ffe0e0",
          "dark": "#ffe0e0"
        },
        "colorError300": {
          "light": "#ff9e9e",
          "dark": "#ff9e9e"
        },
        "colorError400": {
          "light": "#ff7a7a",
          "dark": "#ff7a7a"
        },
        "colorError500": {
          "light": "#ff3d3d",
          "dark": "#ff3d3d"
        },
        "colorError600": {
          "light": "#db0000",
          "dark": "#db0000"
        },
        "colorError700": {
          "light": "#c20000",
          "dark": "#c20000"
        },
        "colorError800": {
          "light": "#990000",
          "dark": "#990000"
        },
        "colorError900": {
          "light": "#700000",
          "dark": "#700000"
        },
        "colorError950": {
          "light": "#520000",
          "dark": "#520000"
        },
        "colorError1000": {
          "light": "#1f0000",
          "dark": "#1f0000"
        },
        "colorSuccess50": {
          "light": "#effff1",
          "dark": "#effff1"
        },
        "colorSuccess100": {
          "light": "#d9ffd6",
          "dark": "#d9ffd6"
        },
        "colorSuccess200": {
          "light": "#aeffa8",
          "dark": "#aeffa8"
        },
        "colorSuccess300": {
          "light": "#62ff57",
          "dark": "#62ff57"
        },
        "colorSuccess400": {
          "light": "#00e500",
          "dark": "#00e500"
        },
        "colorSuccess500": {
          "light": "#2bb534",
          "dark": "#2bb534"
        },
        "colorSuccess600": {
          "light": "#00802f",
          "dark": "#00802f"
        },
        "colorSuccess700": {
          "light": "#007029",
          "dark": "#007029"
        },
        "colorSuccess800": {
          "light": "#005c26",
          "dark": "#005c26"
        },
        "colorSuccess950": {
          "light": "#003311",
          "dark": "#003311"
        },
        "colorSuccess1000": {
          "light": "#001401",
          "dark": "#001401"
        },
        "colorWarning50": {
          "light": "#fffde5",
          "dark": "#fffde5"
        },
        "colorWarning100": {
          "light": "#fffbbd",
          "dark": "#fffbbd"
        },
        "colorWarning200": {
          "light": "#fff78a",
          "dark": "#fff78a"
        },
        "colorWarning300": {
          "light": "#fced69",
          "dark": "#fced69"
        },
        "colorWarning400": {
          "light": "#fce255",
          "dark": "#fce255"
        },
        "colorWarning500": {
          "light": "#fbd332",
          "dark": "#fbd332"
        },
        "colorWarning600": {
          "light": "#f2b100",
          "dark": "#f2b100"
        },
        "colorWarning800": {
          "light": "#9e6900",
          "dark": "#9e6900"
        },
        "colorWarning900": {
          "light": "#855900",
          "dark": "#855900"
        },
        "colorWarning950": {
          "light": "#573a00",
          "dark": "#573a00"
        },
        "colorWarning1000": {
          "light": "#191100",
          "dark": "#191100"
        },
        "colorInfo50": {
          "light": "#f5f7ff",
          "dark": "#f5f7ff"
        },
        "colorInfo100": {
          "light": "#dbe4ff",
          "dark": "#dbe4ff"
        },
        "colorInfo300": {
          "light": "#94afff",
          "dark": "#94afff"
        },
        "colorInfo400": {
          "light": "#7598ff",
          "dark": "#7598ff"
        },
        "colorInfo500": {
          "light": "#5c7fff",
          "dark": "#5c7fff"
        },
        "colorInfo600": {
          "light": "#295eff",
          "dark": "#295eff"
        },
        "colorInfo700": {
          "light": "#003efa",
          "dark": "#003efa"
        },
        "colorInfo800": {
          "light": "#0033cc",
          "dark": "#0033cc"
        },
        "colorInfo900": {
          "light": "#001a99",
          "dark": "#001a99"
        },
        "colorInfo950": {
          "light": "#001475",
          "dark": "#001475"
        },
        "colorInfo1000": {
          "light": "#000833",
          "dark": "#000833"
        },
        "colorGrey50": {
          "light": "#fcfcfd",
          "dark": "#fcfcfd"
        },
        "colorGrey100": {
          "light": "#f9f9fa",
          "dark": "#f9f9fa"
        },
        "colorGrey150": {
          "light": "#f6f6f9",
          "dark": "#f6f6f9"
        },
        "colorGrey200": {
          "light": "#f3f3f7",
          "dark": "#f3f3f7"
        },
        "colorGrey250": {
          "light": "#ebebf0",
          "dark": "#ebebf0"
        },
        "colorGrey300": {
          "light": "#dedee3",
          "dark": "#dedee3"
        },
        "colorGrey350": {
          "light": "#c6c6cd",
          "dark": "#c6c6cd"
        },
        "colorGrey400": {
          "light": "#b4b4bb",
          "dark": "#b4b4bb"
        },
        "colorGrey450": {
          "light": "#a4a4ad",
          "dark": "#a4a4ad"
        },
        "colorGrey500": {
          "light": "#8c8c94",
          "dark": "#8c8c94"
        },
        "colorGrey600": {
          "light": "#656871",
          "dark": "#656871"
        },
        "colorGrey650": {
          "light": "#424650",
          "dark": "#424650"
        },
        "colorGrey700": {
          "light": "#333843",
          "dark": "#333843"
        },
        "colorGrey750": {
          "light": "#232b37",
          "dark": "#232b37"
        },
        "colorGrey800": {
          "light": "#1b232d",
          "dark": "#1b232d"
        },
        "colorGrey850": {
          "light": "#161d26",
          "dark": "#161d26"
        },
        "colorGrey900": {
          "light": "#131920",
          "dark": "#131920"
        },
        "colorGrey950": {
          "light": "#0f141a",
          "dark": "#0f141a"
        },
        "colorGrey1000": {
          "light": "#06080a",
          "dark": "#06080a"
        },
        "colorBlue50": {
          "light": "#f0fbff",
          "dark": "#f0fbff"
        },
        "colorBlue100": {
          "light": "#d1f1ff",
          "dark": "#d1f1ff"
        },
        "colorBlue200": {
          "light": "#b8e7ff",
          "dark": "#b8e7ff"
        },
        "colorBlue300": {
          "light": "#75cfff",
          "dark": "#75cfff"
        },
        "colorBlue400": {
          "light": "#42b4ff",
          "dark": "#42b4ff"
        },
        "colorBlue600": {
          "light": "#006ce0",
          "dark": "#006ce0"
        },
        "colorBlue700": {
          "light": "#004a9e",
          "dark": "#004a9e"
        },
        "colorBlue900": {
          "light": "#002b66",
          "dark": "#002b66"
        },
        "colorBlue1000": {
          "light": "#001129",
          "dark": "#001129"
        },
        "colorGreen50": {
          "light": "#effff1",
          "dark": "#effff1"
        },
        "colorGreen500": {
          "light": "#2bb534",
          "dark": "#2bb534"
        },
        "colorGreen600": {
          "light": "#00802f",
          "dark": "#00802f"
        },
        "colorGreen900": {
          "light": "#00471e",
          "dark": "#00471e"
        },
        "colorGreen1000": {
          "light": "#001401",
          "dark": "#001401"
        },
        "colorRed50": {
          "light": "#fff5f5",
          "dark": "#fff5f5"
        },
        "colorRed400": {
          "light": "#ff7a7a",
          "dark": "#ff7a7a"
        },
        "colorRed600": {
          "light": "#db0000",
          "dark": "#db0000"
        },
        "colorRed900": {
          "light": "#700000",
          "dark": "#700000"
        },
        "colorRed1000": {
          "light": "#1f0000",
          "dark": "#1f0000"
        },
        "colorYellow50": {
          "light": "#fffef0",
          "dark": "#fffef0"
        },
        "colorYellow400": {
          "light": "#ffe347",
          "dark": "#ffe347"
        },
        "colorYellow500": {
          "light": "#fbd332",
          "dark": "#fbd332"
        },
        "colorYellow900": {
          "light": "#855900",
          "dark": "#855900"
        },
        "colorYellow1000": {
          "light": "#191100",
          "dark": "#191100"
        },
        "colorPurple400": {
          "light": "#bf80ff",
          "dark": "#bf80ff"
        },
        "colorPurple700": {
          "light": "#7300e5",
          "dark": "#7300e5"
        },
        "colorAmber400": {
          "light": "#ff9900",
          "dark": "#ff9900"
        },
        "colorAmber500": {
          "light": "#fa6f00",
          "dark": "#fa6f00"
        },
        "colorRed950": {
          "light": "#520000",
          "dark": "#520000"
        },
        "colorOrange50": {
          "light": "#fff7f5",
          "dark": "#fff7f5"
        },
        "colorOrange100": {
          "light": "#ffe0d6",
          "dark": "#ffe0d6"
        },
        "colorOrange400": {
          "light": "#ff6a3d",
          "dark": "#ff6a3d"
        },
        "colorOrange700": {
          "light": "#a82700",
          "dark": "#a82700"
        },
        "colorOrange800": {
          "light": "#8a2000",
          "dark": "#8a2000"
        },
        "colorOrange950": {
          "light": "#471100",
          "dark": "#471100"
        },
        "colorYellow600": {
          "light": "#f2b100",
          "dark": "#f2b100"
        },
        "colorYellow950": {
          "light": "#573a00",
          "dark": "#573a00"
        },
        "colorLime50": {
          "light": "#f7ffeb",
          "dark": "#f7ffeb"
        },
        "colorLime100": {
          "light": "#ebffcc",
          "dark": "#ebffcc"
        },
        "colorLime400": {
          "light": "#7ae500",
          "dark": "#7ae500"
        },
        "colorLime700": {
          "light": "#007000",
          "dark": "#007000"
        },
        "colorLime800": {
          "light": "#005700",
          "dark": "#005700"
        },
        "colorLime950": {
          "light": "#002e00",
          "dark": "#002e00"
        },
        "colorGreen400": {
          "light": "#00e500",
          "dark": "#00e500"
        },
        "colorGreen950": {
          "light": "#003311",
          "dark": "#003311"
        },
        "colorMint50": {
          "light": "#ebfff6",
          "dark": "#ebfff6"
        },
        "colorMint100": {
          "light": "#ccffe9",
          "dark": "#ccffe9"
        },
        "colorMint400": {
          "light": "#00e582",
          "dark": "#00e582"
        },
        "colorMint700": {
          "light": "#006b48",
          "dark": "#006b48"
        },
        "colorMint800": {
          "light": "#005237",
          "dark": "#005237"
        },
        "colorMint950": {
          "light": "#003322",
          "dark": "#003322"
        },
        "colorIndigo50": {
          "light": "#f5f7ff",
          "dark": "#f5f7ff"
        },
        "colorIndigo400": {
          "light": "#7598ff",
          "dark": "#7598ff"
        },
        "colorIndigo600": {
          "light": "#295eff",
          "dark": "#295eff"
        },
        "colorIndigo950": {
          "light": "#001475",
          "dark": "#001475"
        },
        "colorPurple50": {
          "light": "#faf5ff",
          "dark": "#faf5ff"
        },
        "colorPurple100": {
          "light": "#f2e5ff",
          "dark": "#f2e5ff"
        },
        "colorPurple600": {
          "light": "#962eff",
          "dark": "#962eff"
        },
        "colorPurple800": {
          "light": "#5900b2",
          "dark": "#5900b2"
        },
        "colorPurple950": {
          "light": "#300061",
          "dark": "#300061"
        },
        "colorTeal50": {
          "light": "#ebfffe",
          "dark": "#ebfffe"
        },
        "colorTeal100": {
          "light": "#ccfffc",
          "dark": "#ccfffc"
        },
        "colorTeal400": {
          "light": "#00d6c8",
          "dark": "#00d6c8"
        },
        "colorTeal700": {
          "light": "#00665f",
          "dark": "#00665f"
        },
        "colorTeal800": {
          "light": "#00524c",
          "dark": "#00524c"
        },
        "colorTeal950": {
          "light": "#003330",
          "dark": "#003330"
        },
        "colorCyan50": {
          "light": "#f0feff",
          "dark": "#f0feff"
        },
        "colorCyan100": {
          "light": "#d1fbff",
          "dark": "#d1fbff"
        },
        "colorCyan400": {
          "light": "#00d2e5",
          "dark": "#00d2e5"
        },
        "colorCyan700": {
          "light": "#00627a",
          "dark": "#00627a"
        },
        "colorCyan800": {
          "light": "#004761",
          "dark": "#004761"
        },
        "colorCyan950": {
          "light": "#00293d",
          "dark": "#00293d"
        },
        "colorBlue950": {
          "light": "#00204d",
          "dark": "#00204d"
        },
        "colorViolet50": {
          "light": "#f6f5ff",
          "dark": "#f6f5ff"
        },
        "colorViolet100": {
          "light": "#e8e5ff",
          "dark": "#e8e5ff"
        },
        "colorViolet400": {
          "light": "#978aff",
          "dark": "#978aff"
        },
        "colorViolet700": {
          "light": "#5724ff",
          "dark": "#5724ff"
        },
        "colorViolet800": {
          "light": "#4200db",
          "dark": "#4200db"
        },
        "colorViolet950": {
          "light": "#250070",
          "dark": "#250070"
        },
        "colorFuchsia50": {
          "light": "#fff5fe",
          "dark": "#fff5fe"
        },
        "colorFuchsia100": {
          "light": "#fce5ff",
          "dark": "#fce5ff"
        },
        "colorFuchsia400": {
          "light": "#ec70ff",
          "dark": "#ec70ff"
        },
        "colorFuchsia700": {
          "light": "#a000b8",
          "dark": "#a000b8"
        },
        "colorFuchsia800": {
          "light": "#78008a",
          "dark": "#78008a"
        },
        "colorFuchsia950": {
          "light": "#43004d",
          "dark": "#43004d"
        },
        "colorMagenta50": {
          "light": "#fff5fe",
          "dark": "#fff5fe"
        },
        "colorMagenta100": {
          "light": "#ffe0fb",
          "dark": "#ffe0fb"
        },
        "colorMagenta400": {
          "light": "#ff57e9",
          "dark": "#ff57e9"
        },
        "colorMagenta700": {
          "light": "#b2008f",
          "dark": "#b2008f"
        },
        "colorMagenta800": {
          "light": "#8f0072",
          "dark": "#8f0072"
        },
        "colorMagenta950": {
          "light": "#470039",
          "dark": "#470039"
        },
        "colorPink50": {
          "light": "#fff5fa",
          "dark": "#fff5fa"
        },
        "colorPink100": {
          "light": "#ffe0f0",
          "dark": "#ffe0f0"
        },
        "colorPink400": {
          "light": "#ff66b2",
          "dark": "#ff66b2"
        },
        "colorPink700": {
          "light": "#bb005d",
          "dark": "#bb005d"
        },
        "colorPink800": {
          "light": "#8f0047",
          "dark": "#8f0047"
        },
        "colorPink950": {
          "light": "#4d0020",
          "dark": "#4d0020"
        },
        "colorRose50": {
          "light": "#fff5f8",
          "dark": "#fff5f8"
        },
        "colorRose100": {
          "light": "#ffe0e8",
          "dark": "#ffe0e8"
        },
        "colorRose400": {
          "light": "#ff5c85",
          "dark": "#ff5c85"
        },
        "colorRose700": {
          "light": "#c20030",
          "dark": "#c20030"
        },
        "colorRose800": {
          "light": "#940025",
          "dark": "#940025"
        },
        "colorRose950": {
          "light": "#4d0013",
          "dark": "#4d0013"
        },
        "colorAmber50": {
          "light": "#fff7e6",
          "dark": "#fff7e6"
        },
        "colorAmber100": {
          "light": "#ffe8bd",
          "dark": "#ffe8bd"
        },
        "colorAmber700": {
          "light": "#9e3700",
          "dark": "#9e3700"
        },
        "colorAmber800": {
          "light": "#7a2b00",
          "dark": "#7a2b00"
        },
        "colorAmber950": {
          "light": "#471500",
          "dark": "#471500"
        },
        "colorAwsSquidInk": {
          "light": "#232f3e",
          "dark": "#232f3e"
        },
        "colorTransparent": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBlack": {
          "light": "#000000",
          "dark": "#000000"
        },
        "colorWhite": {
          "light": "#ffffff",
          "dark": "#ffffff"
        },
        "colorNeutralGrey50": {
          "light": "#fcfcfc",
          "dark": "#fcfcfc"
        },
        "colorNeutralGrey100": {
          "light": "#f9f9f9",
          "dark": "#f9f9f9"
        },
        "colorNeutralGrey150": {
          "light": "#f8f8f7",
          "dark": "#f8f8f7"
        },
        "colorNeutralGrey200": {
          "light": "#f3f3f1",
          "dark": "#f3f3f1"
        },
        "colorNeutralGrey250": {
          "light": "#eeedeb",
          "dark": "#eeedeb"
        },
        "colorNeutralGrey300": {
          "light": "#e3e1de",
          "dark": "#e3e1de"
        },
        "colorNeutralGrey350": {
          "light": "#cbc9c3",
          "dark": "#cbc9c3"
        },
        "colorNeutralGrey400": {
          "light": "#bab7b0",
          "dark": "#bab7b0"
        },
        "colorNeutralGrey450": {
          "light": "#aca9a2",
          "dark": "#aca9a2"
        },
        "colorNeutralGrey500": {
          "light": "#949088",
          "dark": "#949088"
        },
        "colorNeutralGrey550": {
          "light": "#868279",
          "dark": "#868279"
        },
        "colorNeutralGrey600": {
          "light": "#6f6b63",
          "dark": "#6f6b63"
        },
        "colorNeutralGrey650": {
          "light": "#4c4942",
          "dark": "#4c4942"
        },
        "colorNeutralGrey700": {
          "light": "#3e3b35",
          "dark": "#3e3b35"
        },
        "colorNeutralGrey750": {
          "light": "#2f2d28",
          "dark": "#2f2d28"
        },
        "colorNeutralGrey800": {
          "light": "#262420",
          "dark": "#262420"
        },
        "colorNeutralGrey850": {
          "light": "#201e1b",
          "dark": "#201e1b"
        },
        "colorNeutralGrey900": {
          "light": "#1b1a17",
          "dark": "#1b1a17"
        },
        "colorNeutralGrey950": {
          "light": "#161512",
          "dark": "#161512"
        },
        "colorNeutralGrey1000": {
          "light": "#100f0d",
          "dark": "#100f0d"
        },
        "colorIndigo100": {
          "light": "#dbe4ff",
          "dark": "#dbe4ff"
        },
        "colorIndigo200": {
          "light": "#c2d1ff",
          "dark": "#c2d1ff"
        },
        "colorIndigo300": {
          "light": "#94afff",
          "dark": "#94afff"
        },
        "colorIndigo500": {
          "light": "#5c7fff",
          "dark": "#5c7fff"
        },
        "colorIndigo700": {
          "light": "#003efa",
          "dark": "#003efa"
        },
        "colorIndigo800": {
          "light": "#0033cc",
          "dark": "#0033cc"
        },
        "colorIndigo900": {
          "light": "#001a99",
          "dark": "#001a99"
        },
        "colorIndigo1000": {
          "light": "#000833",
          "dark": "#000833"
        },
        "colorGreen200": {
          "light": "#aeffa8",
          "dark": "#aeffa8"
        },
        "colorGreen700": {
          "light": "#007029",
          "dark": "#007029"
        },
        "colorOneThemeYellow50": {
          "light": "#fffde5",
          "dark": "#fffde5"
        },
        "colorOneThemeYellow300": {
          "light": "#fced69",
          "dark": "#fced69"
        },
        "colorOneThemeYellow400": {
          "light": "#fce255",
          "dark": "#fce255"
        },
        "colorOneThemeYellow500": {
          "light": "#fbd332",
          "dark": "#fbd332"
        },
        "colorOneThemeYellow800": {
          "light": "#9e6900",
          "dark": "#9e6900"
        },
        "colorOneThemeYellow900": {
          "light": "#855900",
          "dark": "#855900"
        },
        "colorOneThemeYellow1000": {
          "light": "#191100",
          "dark": "#191100"
        },
        "colorChartsRed300": {
          "light": "#ea7158",
          "dark": "#d63f38"
        },
        "colorChartsRed400": {
          "light": "#dc5032",
          "dark": "#ed5958"
        },
        "colorChartsRed500": {
          "light": "#d13313",
          "dark": "#fe6e73"
        },
        "colorChartsRed600": {
          "light": "#ba2e0f",
          "dark": "#ff8a8a"
        },
        "colorChartsRed700": {
          "light": "#a82a0c",
          "dark": "#ffa09e"
        },
        "colorChartsRed800": {
          "light": "#972709",
          "dark": "#ffb3b0"
        },
        "colorChartsRed900": {
          "light": "#892407",
          "dark": "#ffc4c0"
        },
        "colorChartsRed1000": {
          "light": "#7d2105",
          "dark": "#ffd2cf"
        },
        "colorChartsRed1100": {
          "light": "#721e03",
          "dark": "#ffe0dd"
        },
        "colorChartsRed1200": {
          "light": "#671c00",
          "dark": "#ffecea"
        },
        "colorChartsOrange300": {
          "light": "#e07941",
          "dark": "#c55305"
        },
        "colorChartsOrange400": {
          "light": "#cc5f21",
          "dark": "#de6923"
        },
        "colorChartsOrange500": {
          "light": "#bc4d01",
          "dark": "#f27c36"
        },
        "colorChartsOrange600": {
          "light": "#a84401",
          "dark": "#f89256"
        },
        "colorChartsOrange700": {
          "light": "#983c02",
          "dark": "#fca572"
        },
        "colorChartsOrange800": {
          "light": "#8a3603",
          "dark": "#ffb68b"
        },
        "colorChartsOrange900": {
          "light": "#7e3103",
          "dark": "#ffc6a4"
        },
        "colorChartsOrange1000": {
          "light": "#732c02",
          "dark": "#ffd4bb"
        },
        "colorChartsOrange1100": {
          "light": "#692801",
          "dark": "#ffe1cf"
        },
        "colorChartsOrange1200": {
          "light": "#602400",
          "dark": "#ffede2"
        },
        "colorChartsYellow300": {
          "light": "#b2911c",
          "dark": "#977001"
        },
        "colorChartsYellow400": {
          "light": "#9c7b0b",
          "dark": "#b08400"
        },
        "colorChartsYellow500": {
          "light": "#8a6b05",
          "dark": "#c59600"
        },
        "colorChartsYellow600": {
          "light": "#7b5f04",
          "dark": "#d3a61c"
        },
        "colorChartsYellow700": {
          "light": "#6f5504",
          "dark": "#dfb52c"
        },
        "colorChartsYellow800": {
          "light": "#654d03",
          "dark": "#eac33a"
        },
        "colorChartsYellow900": {
          "light": "#5d4503",
          "dark": "#f1cf65"
        },
        "colorChartsYellow1000": {
          "light": "#553f03",
          "dark": "#f7db8a"
        },
        "colorChartsYellow1100": {
          "light": "#4d3901",
          "dark": "#fce5a8"
        },
        "colorChartsYellow1200": {
          "light": "#483300",
          "dark": "#ffefc9"
        },
        "colorChartsGreen300": {
          "light": "#67a353",
          "dark": "#48851a"
        },
        "colorChartsGreen400": {
          "light": "#41902c",
          "dark": "#5a9b29"
        },
        "colorChartsGreen500": {
          "light": "#1f8104",
          "dark": "#69ae34"
        },
        "colorChartsGreen600": {
          "light": "#1a7302",
          "dark": "#7dbd4c"
        },
        "colorChartsGreen700": {
          "light": "#176702",
          "dark": "#8fca61"
        },
        "colorChartsGreen800": {
          "light": "#145d02",
          "dark": "#9fd673"
        },
        "colorChartsGreen900": {
          "light": "#125502",
          "dark": "#b2df8d"
        },
        "colorChartsGreen1000": {
          "light": "#104d01",
          "dark": "#c5e7a8"
        },
        "colorChartsGreen1100": {
          "light": "#0f4601",
          "dark": "#d5efbe"
        },
        "colorChartsGreen1200": {
          "light": "#0d4000",
          "dark": "#e4f7d5"
        },
        "colorChartsTeal300": {
          "light": "#2ea597",
          "dark": "#018977"
        },
        "colorChartsTeal400": {
          "light": "#1c8e81",
          "dark": "#009d89"
        },
        "colorChartsTeal500": {
          "light": "#0d7d70",
          "dark": "#00b09b"
        },
        "colorChartsTeal600": {
          "light": "#096f64",
          "dark": "#40bfa9"
        },
        "colorChartsTeal700": {
          "light": "#06645a",
          "dark": "#5fccb7"
        },
        "colorChartsTeal800": {
          "light": "#045b52",
          "dark": "#77d7c3"
        },
        "colorChartsTeal900": {
          "light": "#03524a",
          "dark": "#94e0d0"
        },
        "colorChartsTeal1000": {
          "light": "#014b44",
          "dark": "#ace9db"
        },
        "colorChartsTeal1100": {
          "light": "#01443e",
          "dark": "#c2f0e6"
        },
        "colorChartsTeal1200": {
          "light": "#003e38",
          "dark": "#d7f7f0"
        },
        "colorChartsBlue1300": {
          "light": "#529ccb",
          "dark": "#00819c"
        },
        "colorChartsBlue1400": {
          "light": "#3184c2",
          "dark": "#0497ba"
        },
        "colorChartsBlue1500": {
          "light": "#0273bb",
          "dark": "#08aad2"
        },
        "colorChartsBlue1600": {
          "light": "#0166ab",
          "dark": "#44b9dd"
        },
        "colorChartsBlue1700": {
          "light": "#015b9d",
          "dark": "#63c6e7"
        },
        "colorChartsBlue1800": {
          "light": "#015292",
          "dark": "#79d2f0"
        },
        "colorChartsBlue1900": {
          "light": "#014a87",
          "dark": "#98dcf5"
        },
        "colorChartsBlue11000": {
          "light": "#01437d",
          "dark": "#b3e4f8"
        },
        "colorChartsBlue11100": {
          "light": "#003c75",
          "dark": "#caedfc"
        },
        "colorChartsBlue11200": {
          "light": "#00366d",
          "dark": "#ddf4ff"
        },
        "colorChartsBlue2300": {
          "light": "#688ae8",
          "dark": "#486de8"
        },
        "colorChartsBlue2400": {
          "light": "#5978e3",
          "dark": "#6384f5"
        },
        "colorChartsBlue2500": {
          "light": "#4066df",
          "dark": "#7698fe"
        },
        "colorChartsBlue2600": {
          "light": "#3759ce",
          "dark": "#8ea9ff"
        },
        "colorChartsBlue2700": {
          "light": "#314fbf",
          "dark": "#a2b8ff"
        },
        "colorChartsBlue2800": {
          "light": "#2c46b1",
          "dark": "#b1c5ff"
        },
        "colorChartsBlue2900": {
          "light": "#273ea5",
          "dark": "#c3d1ff"
        },
        "colorChartsBlue21000": {
          "light": "#23379b",
          "dark": "#d2dcff"
        },
        "colorChartsBlue21100": {
          "light": "#1f3191",
          "dark": "#dfe6ff"
        },
        "colorChartsBlue21200": {
          "light": "#1b2b88",
          "dark": "#ecf0ff"
        },
        "colorChartsPurple300": {
          "light": "#a783e1",
          "dark": "#8d59de"
        },
        "colorChartsPurple400": {
          "light": "#9469d6",
          "dark": "#a173ea"
        },
        "colorChartsPurple500": {
          "light": "#8456ce",
          "dark": "#b088f5"
        },
        "colorChartsPurple600": {
          "light": "#7749bf",
          "dark": "#bf9bf9"
        },
        "colorChartsPurple700": {
          "light": "#6b40b2",
          "dark": "#cbabfc"
        },
        "colorChartsPurple800": {
          "light": "#6237a7",
          "dark": "#d6baff"
        },
        "colorChartsPurple900": {
          "light": "#59309d",
          "dark": "#dfc8ff"
        },
        "colorChartsPurple1000": {
          "light": "#512994",
          "dark": "#e8d5ff"
        },
        "colorChartsPurple1100": {
          "light": "#4a238b",
          "dark": "#efe2ff"
        },
        "colorChartsPurple1200": {
          "light": "#431d84",
          "dark": "#f5edff"
        },
        "colorChartsPink300": {
          "light": "#da7596",
          "dark": "#c64a70"
        },
        "colorChartsPink400": {
          "light": "#ce567c",
          "dark": "#d56889"
        },
        "colorChartsPink500": {
          "light": "#c33d69",
          "dark": "#e07f9d"
        },
        "colorChartsPink600": {
          "light": "#b1325c",
          "dark": "#eb92ad"
        },
        "colorChartsPink700": {
          "light": "#a32952",
          "dark": "#f5a2bb"
        },
        "colorChartsPink800": {
          "light": "#962249",
          "dark": "#ffb0c8"
        },
        "colorChartsPink900": {
          "light": "#8b1b42",
          "dark": "#ffc1d4"
        },
        "colorChartsPink1000": {
          "light": "#81143b",
          "dark": "#ffd1de"
        },
        "colorChartsPink1100": {
          "light": "#780d35",
          "dark": "#ffdfe8"
        },
        "colorChartsPink1200": {
          "light": "#6f062f",
          "dark": "#ffecf1"
        },
        "colorChartsStatusCritical": {
          "light": "{colorChartsRed1000}",
          "dark": "{colorChartsRed300}"
        },
        "colorChartsStatusHigh": {
          "light": "{colorChartsRed600}",
          "dark": "{colorChartsRed500}"
        },
        "colorChartsStatusMedium": {
          "light": "{colorChartsOrange400}",
          "dark": "{colorChartsOrange600}"
        },
        "colorChartsStatusLow": {
          "light": "{colorChartsYellow300}",
          "dark": "{colorChartsYellow700}"
        },
        "colorChartsStatusPositive": {
          "light": "{colorChartsGreen300}",
          "dark": "{colorChartsGreen500}"
        },
        "colorChartsStatusInfo": {
          "light": "{colorChartsBlue1400}",
          "dark": "{colorChartsBlue1500}"
        },
        "colorChartsStatusNeutral": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorChartsThresholdNegative": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorChartsThresholdPositive": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess500}"
        },
        "colorChartsThresholdInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo300}"
        },
        "colorChartsThresholdNeutral": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorChartsLineGrid": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorChartsLineTick": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorChartsLineAxis": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorChartsPaletteCategorical1": {
          "light": "{colorChartsBlue2300}",
          "dark": "{colorChartsBlue2300}"
        },
        "colorChartsPaletteCategorical2": {
          "light": "{colorChartsPink500}",
          "dark": "{colorChartsPink500}"
        },
        "colorChartsPaletteCategorical3": {
          "light": "{colorChartsTeal300}",
          "dark": "{colorChartsTeal300}"
        },
        "colorChartsPaletteCategorical4": {
          "light": "{colorChartsPurple500}",
          "dark": "{colorChartsPurple500}"
        },
        "colorChartsPaletteCategorical5": {
          "light": "{colorChartsOrange300}",
          "dark": "{colorChartsOrange300}"
        },
        "colorChartsPaletteCategorical6": {
          "light": "{colorChartsBlue2600}",
          "dark": "{colorChartsBlue2600}"
        },
        "colorChartsPaletteCategorical7": {
          "light": "{colorChartsPink800}",
          "dark": "{colorChartsPink800}"
        },
        "colorChartsPaletteCategorical8": {
          "light": "{colorChartsTeal600}",
          "dark": "{colorChartsTeal600}"
        },
        "colorChartsPaletteCategorical9": {
          "light": "{colorChartsPurple800}",
          "dark": "{colorChartsPurple800}"
        },
        "colorChartsPaletteCategorical10": {
          "light": "{colorChartsOrange600}",
          "dark": "{colorChartsOrange600}"
        },
        "colorChartsPaletteCategorical11": {
          "light": "{colorChartsBlue2900}",
          "dark": "{colorChartsBlue2900}"
        },
        "colorChartsPaletteCategorical12": {
          "light": "{colorChartsPink1100}",
          "dark": "{colorChartsPink1100}"
        },
        "colorChartsPaletteCategorical13": {
          "light": "{colorChartsTeal900}",
          "dark": "{colorChartsTeal900}"
        },
        "colorChartsPaletteCategorical14": {
          "light": "{colorChartsPurple1100}",
          "dark": "{colorChartsPurple1100}"
        },
        "colorChartsPaletteCategorical15": {
          "light": "{colorChartsOrange900}",
          "dark": "{colorChartsOrange900}"
        },
        "colorChartsPaletteCategorical16": {
          "light": "{colorChartsBlue21200}",
          "dark": "{colorChartsBlue21200}"
        },
        "colorChartsPaletteCategorical17": {
          "light": "{colorChartsPink400}",
          "dark": "{colorChartsPink400}"
        },
        "colorChartsPaletteCategorical18": {
          "light": "{colorChartsTeal1200}",
          "dark": "{colorChartsTeal1200}"
        },
        "colorChartsPaletteCategorical19": {
          "light": "{colorChartsPurple400}",
          "dark": "{colorChartsPurple400}"
        },
        "colorChartsPaletteCategorical20": {
          "light": "{colorChartsOrange1200}",
          "dark": "{colorChartsOrange1200}"
        },
        "colorChartsPaletteCategorical21": {
          "light": "{colorChartsBlue2500}",
          "dark": "{colorChartsBlue2500}"
        },
        "colorChartsPaletteCategorical22": {
          "light": "{colorChartsPink700}",
          "dark": "{colorChartsPink700}"
        },
        "colorChartsPaletteCategorical23": {
          "light": "{colorChartsTeal500}",
          "dark": "{colorChartsTeal500}"
        },
        "colorChartsPaletteCategorical24": {
          "light": "{colorChartsPurple700}",
          "dark": "{colorChartsPurple700}"
        },
        "colorChartsPaletteCategorical25": {
          "light": "{colorChartsOrange500}",
          "dark": "{colorChartsOrange500}"
        },
        "colorChartsPaletteCategorical26": {
          "light": "{colorChartsBlue2800}",
          "dark": "{colorChartsBlue2800}"
        },
        "colorChartsPaletteCategorical27": {
          "light": "{colorChartsPink1000}",
          "dark": "{colorChartsPink1000}"
        },
        "colorChartsPaletteCategorical28": {
          "light": "{colorChartsTeal800}",
          "dark": "{colorChartsTeal800}"
        },
        "colorChartsPaletteCategorical29": {
          "light": "{colorChartsPurple1000}",
          "dark": "{colorChartsPurple1000}"
        },
        "colorChartsPaletteCategorical30": {
          "light": "{colorChartsOrange800}",
          "dark": "{colorChartsOrange800}"
        },
        "colorChartsPaletteCategorical31": {
          "light": "{colorChartsBlue21100}",
          "dark": "{colorChartsBlue21100}"
        },
        "colorChartsPaletteCategorical32": {
          "light": "{colorChartsPink300}",
          "dark": "{colorChartsPink300}"
        },
        "colorChartsPaletteCategorical33": {
          "light": "{colorChartsTeal1100}",
          "dark": "{colorChartsTeal1100}"
        },
        "colorChartsPaletteCategorical34": {
          "light": "{colorChartsPurple300}",
          "dark": "{colorChartsPurple300}"
        },
        "colorChartsPaletteCategorical35": {
          "light": "{colorChartsOrange1100}",
          "dark": "{colorChartsOrange1100}"
        },
        "colorChartsPaletteCategorical36": {
          "light": "{colorChartsBlue2400}",
          "dark": "{colorChartsBlue2400}"
        },
        "colorChartsPaletteCategorical37": {
          "light": "{colorChartsPink600}",
          "dark": "{colorChartsPink600}"
        },
        "colorChartsPaletteCategorical38": {
          "light": "{colorChartsTeal400}",
          "dark": "{colorChartsTeal400}"
        },
        "colorChartsPaletteCategorical39": {
          "light": "{colorChartsPurple600}",
          "dark": "{colorChartsPurple600}"
        },
        "colorChartsPaletteCategorical40": {
          "light": "{colorChartsOrange400}",
          "dark": "{colorChartsOrange400}"
        },
        "colorChartsPaletteCategorical41": {
          "light": "{colorChartsBlue2700}",
          "dark": "{colorChartsBlue2700}"
        },
        "colorChartsPaletteCategorical42": {
          "light": "{colorChartsPink900}",
          "dark": "{colorChartsPink900}"
        },
        "colorChartsPaletteCategorical43": {
          "light": "{colorChartsTeal700}",
          "dark": "{colorChartsTeal700}"
        },
        "colorChartsPaletteCategorical44": {
          "light": "{colorChartsPurple900}",
          "dark": "{colorChartsPurple900}"
        },
        "colorChartsPaletteCategorical45": {
          "light": "{colorChartsOrange700}",
          "dark": "{colorChartsOrange700}"
        },
        "colorChartsPaletteCategorical46": {
          "light": "{colorChartsBlue21000}",
          "dark": "{colorChartsBlue21000}"
        },
        "colorChartsPaletteCategorical47": {
          "light": "{colorChartsPink1200}",
          "dark": "{colorChartsPink1200}"
        },
        "colorChartsPaletteCategorical48": {
          "light": "{colorChartsTeal1000}",
          "dark": "{colorChartsTeal1000}"
        },
        "colorChartsPaletteCategorical49": {
          "light": "{colorChartsPurple1200}",
          "dark": "{colorChartsPurple1200}"
        },
        "colorChartsPaletteCategorical50": {
          "light": "{colorChartsOrange1000}",
          "dark": "{colorChartsOrange1000}"
        },
        "colorChartsErrorBarMarker": {
          "light": "{colorNeutral900}",
          "dark": "{colorWhite}"
        },
        "colorSeverityDarkRed": {
          "light": "#870303",
          "dark": "#d63f38"
        },
        "colorSeverityRed": {
          "light": "#ce3311",
          "dark": "#fe6e73"
        },
        "colorSeverityOrange": {
          "light": "#f89256",
          "dark": "#f89256"
        },
        "colorSeverityYellow": {
          "light": "#f2cd54",
          "dark": "#f2cd54"
        },
        "colorSeverityGrey": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundNotificationSeverityCritical": {
          "light": "{colorSeverityDarkRed}",
          "dark": "{colorSeverityDarkRed}"
        },
        "colorBackgroundNotificationSeverityHigh": {
          "light": "{colorSeverityRed}",
          "dark": "{colorSeverityRed}"
        },
        "colorBackgroundNotificationSeverityMedium": {
          "light": "{colorSeverityOrange}",
          "dark": "{colorSeverityOrange}"
        },
        "colorBackgroundNotificationSeverityLow": {
          "light": "{colorSeverityYellow}",
          "dark": "{colorSeverityYellow}"
        },
        "colorBackgroundNotificationSeverityNeutral": {
          "light": "{colorSeverityGrey}",
          "dark": "{colorSeverityGrey}"
        },
        "colorTextNotificationSeverityCritical": {
          "light": "{colorNeutral100}",
          "dark": "{colorBlack}"
        },
        "colorTextNotificationSeverityHigh": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral950}"
        },
        "colorTextNotificationSeverityMedium": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorTextNotificationSeverityLow": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorTextNotificationSeverityNeutral": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral100}"
        },
        "colorBorderBadgeSeverityCritical": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityHigh": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityMedium": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityLow": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeSeverityNeutral": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextBadgeSeverityCritical": {
          "light": "{colorTextNotificationSeverityCritical}",
          "dark": "{colorTextNotificationSeverityCritical}"
        },
        "colorTextBadgeSeverityHigh": {
          "light": "{colorTextNotificationSeverityHigh}",
          "dark": "{colorTextNotificationSeverityHigh}"
        },
        "colorTextBadgeSeverityMedium": {
          "light": "{colorTextNotificationSeverityMedium}",
          "dark": "{colorTextNotificationSeverityMedium}"
        },
        "colorTextBadgeSeverityLow": {
          "light": "{colorTextNotificationSeverityLow}",
          "dark": "{colorTextNotificationSeverityLow}"
        },
        "colorTextBadgeSeverityNeutral": {
          "light": "{colorTextNotificationSeverityNeutral}",
          "dark": "{colorTextNotificationSeverityNeutral}"
        },
        "colorGreyOpaque10": {
          "light": "rgba(0, 0, 0, 0.1)",
          "dark": "rgba(0, 0, 0, 0.1)"
        },
        "colorGreyOpaque25": {
          "light": "rgba(255, 255, 255, 0.25)",
          "dark": "rgba(255, 255, 255, 0.25)"
        },
        "colorGreyOpaque40": {
          "light": "rgba(0, 0, 0, 0.4)",
          "dark": "rgba(0, 0, 0, 0.4)"
        },
        "colorGreyOpaque50": {
          "light": "rgba(0, 0, 0, 0.5)",
          "dark": "rgba(0, 0, 0, 0.5)"
        },
        "colorGreyOpaque70": {
          "light": "rgba(0, 0, 0, 0.7)",
          "dark": "rgba(0, 0, 0, 0.7)"
        },
        "colorGreyOpaque80": {
          "light": "rgba(22, 25, 31, 0.8)",
          "dark": "rgba(22, 25, 31, 0.8)"
        },
        "colorGreyOpaque90": {
          "light": "rgba(242, 243, 243, 0.9)",
          "dark": "rgba(242, 243, 243, 0.9)"
        },
        "colorGreyTransparent": {
          "light": "rgba(15, 20, 26, 0.12)",
          "dark": "rgba(15, 20, 26, 1)"
        },
        "colorGreyTransparentHeavy": {
          "light": "rgba(15, 20, 26, 0.12)",
          "dark": "rgba(15, 20, 26, 1)"
        },
        "colorGreyTransparentLight": {
          "light": "rgba(15, 20, 26, 0.12)",
          "dark": "rgba(15, 20, 26, 1)"
        },
        "colorBackgroundBadgeIcon": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorBackgroundButtonLinkActive": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundButtonLinkDefault": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundButtonLinkDisabled": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundButtonLinkHover": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundButtonNormalActive": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundButtonNormalDefault": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundButtonNormalDisabled": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundButtonNormalHover": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundToggleButtonNormalPressed": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundToggleButtonNormalDefault": {
          "light": "{colorBackgroundButtonNormalDefault}",
          "dark": "{colorBackgroundButtonNormalDefault}"
        },
        "colorBackgroundToggleButtonNormalHover": {
          "light": "{colorBackgroundButtonNormalHover}",
          "dark": "{colorBackgroundButtonNormalHover}"
        },
        "colorBackgroundButtonPrimaryActive": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral300}"
        },
        "colorBackgroundButtonPrimaryDefault": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral300}"
        },
        "colorBackgroundButtonPrimaryDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundButtonPrimaryHover": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral200}"
        },
        "colorBackgroundDirectionButtonActive": {
          "light": "{colorNeutral750}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundDirectionButtonDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundDirectionButtonDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral750}"
        },
        "colorBackgroundDirectionButtonHover": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral700}"
        },
        "colorTextDirectionButtonDefault": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextDirectionButtonDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorBackgroundCalendarCurrentDate": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundCellShaded": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral900}"
        },
        "colorBackgroundCodeEditorGutterActiveLineDefault": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorBackgroundCodeEditorGutterActiveLineError": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundCodeEditorGutterDefault": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCodeEditorLoading": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCodeEditorPaneItemHover": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundCodeEditorStatusBar": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundCard": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundItemCard": {
          "light": "{colorBackgroundCard}",
          "dark": "{colorBackgroundCard}"
        },
        "colorBackgroundContainerContent": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundContainerHeader": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundControlChecked": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundControlDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundControlDisabled": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundDropdownItemDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundDropdownItemDimmed": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundDropdownItemFilterMatch": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundDropdownItemHover": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral900}"
        },
        "colorBackgroundDropdownItemSelected": {
          "light": "{colorBackgroundItemSelected}",
          "dark": "{colorBackgroundItemSelected}"
        },
        "colorBackgroundHomeHeader": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundInlineCode": {
          "light": "rgba(0, 0, 0, 0.1)",
          "dark": "rgba(255, 255, 255, 0.1)"
        },
        "colorBackgroundInputDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundInputDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundItemSelected": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundSideNavigationItemActive": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundSideNavigationItemActiveCollapsed": {
          "light": "{colorPrimary500}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundSideNavigationItemIconHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorBackgroundStatusIndicatorInfo}"
        },
        "colorBackgroundLayoutMain": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundLayoutAiDrawer": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundDrawer": {
          "light": "{colorBackgroundLayoutPanelContent}",
          "dark": "{colorBackgroundLayoutPanelContent}"
        },
        "colorBackgroundBackdrop": {
          "light": "{colorGreyOpaque70}",
          "dark": "{colorGreyOpaque70}"
        },
        "colorBackgroundDrawerBackdrop": {
          "light": "{colorBackgroundBackdrop}",
          "dark": "{colorBackgroundBackdrop}"
        },
        "colorBackgroundLayoutMobilePanel": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral950}"
        },
        "colorBackgroundLayoutPanel": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundLayoutPanelContent": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral1000}"
        },
        "colorBackgroundLayoutPanelHover": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundLayoutToolbar": {
          "light": "{colorBackgroundLayoutPanelContent}",
          "dark": "{colorBackgroundLayoutPanelContent}"
        },
        "colorBackgroundLayoutToggleActive": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundLayoutToggleDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorBackgroundLayoutToggleHover": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundLayoutToggleSelectedActive": {
          "light": "{colorPrimary500}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundLayoutToggleSelectedDefault": {
          "light": "{colorPrimary500}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundLayoutToggleSelectedHover": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBackgroundModalOverlay": {
          "light": "{colorGreyOpaque70}",
          "dark": "{colorGreyOpaque70}"
        },
        "colorBackgroundNotificationBlue": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo600}"
        },
        "colorBackgroundNotificationGreen": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess600}"
        },
        "colorBackgroundNotificationGrey": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundNotificationRed": {
          "light": "{colorError600}",
          "dark": "{colorError600}"
        },
        "colorBackgroundNotificationYellow": {
          "light": "{colorWarning400}",
          "dark": "{colorWarning400}"
        },
        "colorBackgroundFlashbarSuccess": {
          "light": "#e9fce7",
          "dark": "#03220d"
        },
        "colorBackgroundFlashbarError": {
          "light": "#fceded",
          "dark": "#460303"
        },
        "colorBackgroundFlashbarInfo": {
          "light": "#eaeffc",
          "dark": "#08144f"
        },
        "colorBackgroundFlashbarWarning": {
          "light": "#fcfadb",
          "dark": "#372603"
        },
        "colorBackgroundNotificationStackBar": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundNotificationStackBarActive": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundNotificationStackBarHover": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundPopover": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundProgressBarValueDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundProgressBarValueFlash": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorBackgroundProgressBarFlash": {
          "light": "{colorGreyOpaque10}",
          "dark": "{colorGreyOpaque25}"
        },
        "colorBackgroundProgressBarDefault": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundSegmentActive": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral300}"
        },
        "colorBackgroundSegmentDefault": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundSegmentDisabled": {
          "light": "{colorBackgroundButtonNormalDisabled}",
          "dark": "{colorBackgroundButtonNormalDisabled}"
        },
        "colorBackgroundSegmentHover": {
          "light": "{colorBackgroundButtonNormalHover}",
          "dark": "{colorBackgroundButtonNormalHover}"
        },
        "colorBackgroundSegmentWrapper": {
          "light": "{colorBackgroundContainerContent}",
          "dark": "{colorBackgroundContainerContent}"
        },
        "colorBackgroundSliderRangeDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundSliderRangeActive": {
          "light": "{colorBackgroundSliderHandleActive}",
          "dark": "{colorBackgroundSliderHandleActive}"
        },
        "colorBackgroundSliderHandleDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBackgroundSliderHandleActive": {
          "light": "{colorPrimary700}",
          "dark": "{colorPrimary300}"
        },
        "colorBackgroundSliderTrackDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundSliderHandleRing": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundSliderHandleErrorDefault": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderHandleErrorActive": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderHandleWarningDefault": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundSliderHandleWarningActive": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundSliderRangeErrorDefault": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderRangeErrorActive": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorBackgroundSliderRangeWarningDefault": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundSliderRangeWarningActive": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorBackgroundStatusError": {
          "light": "{colorError50}",
          "dark": "{colorError1000}"
        },
        "colorBackgroundStatusInfo": {
          "light": "{colorInfo50}",
          "dark": "{colorInfo1000}"
        },
        "colorBackgroundAlertError": {
          "light": "#fceded",
          "dark": "#460303"
        },
        "colorBackgroundAlertInfo": {
          "light": "#eaeffc",
          "dark": "#08144f"
        },
        "colorBackgroundAlertSuccess": {
          "light": "#e9fce7",
          "dark": "#03220d"
        },
        "colorBackgroundAlertWarning": {
          "light": "#fcfadb",
          "dark": "#372603"
        },
        "colorBackgroundDialog": {
          "light": "{colorBackgroundStatusInfo}",
          "dark": "{colorBackgroundStatusInfo}"
        },
        "colorBackgroundDialogDefault": {
          "light": "{colorBackgroundCard}",
          "dark": "{colorBackgroundCard}"
        },
        "colorBackgroundStatusSuccess": {
          "light": "{colorSuccess50}",
          "dark": "{colorSuccess1000}"
        },
        "colorBackgroundStatusWarning": {
          "light": "{colorWarning50}",
          "dark": "{colorWarning1000}"
        },
        "colorBackgroundTableHeader": {
          "light": "{colorBackgroundContainerHeader}",
          "dark": "{colorBackgroundContainerHeader}"
        },
        "colorBackgroundTilesDisabled": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundToggleCheckedDisabled": {
          "light": "{colorBackgroundControlDisabled}",
          "dark": "{colorBackgroundControlDisabled}"
        },
        "colorBackgroundToggleDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral500}"
        },
        "colorBackgroundAvatarGenAi": {
          "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
          "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
        },
        "colorBackgroundAvatarDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral650}"
        },
        "colorTextAvatar": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorBackgroundLoadingBarGenAi": {
          "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
          "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
        },
        "colorBackgroundStatusIndicatorError": {
          "light": "{colorError50}",
          "dark": "#ff7a7a20"
        },
        "colorBackgroundStatusIndicatorWarning": {
          "light": "{colorWarning50}",
          "dark": "#fbd33220"
        },
        "colorBackgroundStatusIndicatorSuccess": {
          "light": "{colorSuccess50}",
          "dark": "#2bb53420"
        },
        "colorBackgroundStatusIndicatorInfo": {
          "light": "{colorInfo50}",
          "dark": "#5c7fff20"
        },
        "colorBackgroundStatusIndicatorNeutral": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundChatBubbleOutgoing": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBackgroundChatBubbleIncoming": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral900}"
        },
        "colorTextChatBubbleOutgoing": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorTextChatBubbleIncoming": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorBorderButtonLinkDisabled": {
          "light": "{colorBackgroundButtonLinkDisabled}",
          "dark": "{colorBackgroundButtonLinkDisabled}"
        },
        "colorBorderButtonNormalActive": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderButtonNormalDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderToggleButtonNormalPressed": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBorderToggleButtonNormalDefault": {
          "light": "{colorBorderButtonNormalDefault}",
          "dark": "{colorBorderButtonNormalDefault}"
        },
        "colorBorderToggleButtonNormalHover": {
          "light": "{colorBorderButtonNormalHover}",
          "dark": "{colorBorderButtonNormalHover}"
        },
        "colorBorderButtonNormalDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral700}"
        },
        "colorTextButtonNormalDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderButtonNormalHover": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorTextButtonIconDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderButtonPrimaryActive": {
          "light": "{colorBackgroundButtonPrimaryActive}",
          "dark": "{colorBackgroundButtonPrimaryActive}"
        },
        "colorBorderButtonPrimaryDefault": {
          "light": "{colorBackgroundButtonPrimaryDefault}",
          "dark": "{colorBackgroundButtonPrimaryDefault}"
        },
        "colorBorderButtonPrimaryDisabled": {
          "light": "{colorBackgroundButtonPrimaryDisabled}",
          "dark": "{colorBackgroundButtonPrimaryDisabled}"
        },
        "colorBorderButtonPrimaryHover": {
          "light": "{colorBackgroundButtonPrimaryHover}",
          "dark": "{colorBackgroundButtonPrimaryHover}"
        },
        "colorTextButtonPrimaryDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorItemSelected": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextSideNavigationItemActive": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary300}"
        },
        "colorTextSideNavigationItemActiveCollapsed": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral1000}"
        },
        "colorTextSideNavigationItemDefault": {
          "light": "{colorTextBodyDefault}",
          "dark": "{colorTextBodyDefault}"
        },
        "colorBorderCalendarGrid": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderCalendarGridSelectedFocusRing": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral850}"
        },
        "colorBorderCellShaded": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral700}"
        },
        "colorBorderCodeEditorAceActiveLineLightTheme": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderCodeEditorAceActiveLineDarkTheme": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderCodeEditorDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderCodeEditorPaneItemHover": {
          "light": "{colorBorderDropdownItemHover}",
          "dark": "{colorBorderDropdownItemHover}"
        },
        "colorBorderCard": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderCardHighlighted": {
          "light": "{colorBorderItemSelected}",
          "dark": "{colorBorderItemSelected}"
        },
        "colorBorderItemCard": {
          "light": "{colorBorderCard}",
          "dark": "{colorBorderCard}"
        },
        "colorBorderItemCardHighlighted": {
          "light": "{colorBorderCardHighlighted}",
          "dark": "{colorBorderCardHighlighted}"
        },
        "colorBorderContainerDivider": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderContainerTop": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderControlChecked": {
          "light": "{colorBackgroundControlChecked}",
          "dark": "{colorBackgroundControlChecked}"
        },
        "colorBorderControlDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderControlDisabled": {
          "light": "{colorBackgroundControlDisabled}",
          "dark": "{colorBackgroundControlDisabled}"
        },
        "colorBorderDividerActive": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorBorderDividerDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral750}"
        },
        "colorBorderDividerNotification": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDividerPanelBottom": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDividerPanelSide": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDividerSecondary": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral800}"
        },
        "colorBorderDividerTableGroup": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDropdownContainer": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDropdownGroup": {
          "light": "{colorBorderDropdownItemDefault}",
          "dark": "{colorBorderDropdownItemDefault}"
        },
        "colorBorderDropdownItemDefault": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderDropdownItemHover": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderDropdownItemDimmedHover": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderDropdownItemSelected": {
          "light": "{colorBorderItemSelected}",
          "dark": "{colorBorderItemSelected}"
        },
        "colorBorderDropdownItemTop": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderEditableCellHover": {
          "light": "{colorBorderDropdownItemHover}",
          "dark": "{colorBorderDropdownItemHover}"
        },
        "colorBorderInputDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderInputDisabled": {
          "light": "{colorBackgroundInputDisabled}",
          "dark": "{colorBackgroundInputDisabled}"
        },
        "colorBorderInputFocused": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderItemFocused": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBorderDropdownItemFocused": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderItemPlaceholder": {
          "light": "{colorTransparent}",
          "dark": "{colorTransparent}"
        },
        "colorBorderItemSelected": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorBorderLayout": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral750}"
        },
        "colorBorderLayoutSideNavigation": {
          "light": "{colorBorderLayout}",
          "dark": "{colorBorderLayout}"
        },
        "colorBorderNotificationStackBar": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderNotificationStackBarHover": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderNotificationStackBarActive": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral500}"
        },
        "colorBorderNotificationStackBarFocused": {
          "light": "{colorBorderItemFocused}",
          "dark": "{colorBorderItemFocused}"
        },
        "colorBorderPanelHeader": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorBorderPopover": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBorderSegmentActive": {
          "light": "{colorBorderSegmentDefault}",
          "dark": "{colorBorderSegmentDefault}"
        },
        "colorBorderSegmentDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorBorderSegmentDisabled": {
          "light": "{colorBorderSegmentDefault}",
          "dark": "{colorBorderSegmentDefault}"
        },
        "colorBorderSegmentDivider": {
          "light": "{colorBorderInputDefault}",
          "dark": "{colorBorderInputDefault}"
        },
        "colorBorderSegmentHover": {
          "light": "{colorBorderSegmentDefault}",
          "dark": "{colorBorderSegmentDefault}"
        },
        "colorBorderSegmentWrapper": {
          "light": "{colorBorderInputDefault}",
          "dark": "{colorBorderInputDefault}"
        },
        "colorBorderStatusError": {
          "light": "{colorError600}",
          "dark": "{colorError500}"
        },
        "colorBorderStatusInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo400}"
        },
        "colorBorderStatusSuccess": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess300}"
        },
        "colorBorderStatusWarning": {
          "light": "{colorWarning900}",
          "dark": "{colorWarning300}"
        },
        "colorBorderDialog": {
          "light": "{colorBorderStatusInfo}",
          "dark": "{colorBorderStatusInfo}"
        },
        "colorBorderDialogDefault": {
          "light": "{colorBorderCard}",
          "dark": "{colorBorderCard}"
        },
        "colorBorderDividerInteractiveDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral750}"
        },
        "colorBorderTabsDivider": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral650}"
        },
        "colorBorderTabsShadow": {
          "light": "{colorGreyTransparent}",
          "dark": "{colorGreyTransparent}"
        },
        "colorBorderTabsUnderline": {
          "light": "{colorTextAccent}",
          "dark": "{colorTextAccent}"
        },
        "colorBorderTilesDisabled": {
          "light": "{colorBackgroundTilesDisabled}",
          "dark": "{colorBackgroundTilesDisabled}"
        },
        "colorBorderTutorial": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral650}"
        },
        "colorForegroundControlDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorForegroundControlDisabled": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorForegroundControlReadOnly": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorShadowDefault": {
          "light": "{colorGreyTransparentHeavy}",
          "dark": "{colorGreyTransparentHeavy}"
        },
        "colorShadowMedium": {
          "light": "{colorGreyTransparent}",
          "dark": "{colorGreyTransparent}"
        },
        "colorShadowSide": {
          "light": "{colorGreyTransparentLight}",
          "dark": "{colorGreyTransparentLight}"
        },
        "colorShadowToggleHandle": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorStrokeChartLine": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorStrokeCodeEditorGutterActiveLineDefault": {
          "light": "{colorNeutral300}",
          "dark": "{colorNeutral800}"
        },
        "colorStrokeCodeEditorGutterActiveLineHover": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral950}"
        },
        "colorTextAccent": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextBodyDefault": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral400}"
        },
        "colorTextBodySecondary": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextBreadcrumbCurrent": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral250}"
        },
        "colorTextBreadcrumbIcon": {
          "light": "{colorNeutral500}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextButtonInlineIconDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextButtonInlineIconDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextButtonInlineIconHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextButtonInlineLinkHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextButtonIconHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorTextButtonNormalActive": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral350}"
        },
        "colorTextToggleButtonNormalPressed": {
          "light": "{colorNeutral900}",
          "dark": "{colorWhite}"
        },
        "colorTextButtonNormalDefault": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral350}"
        },
        "colorTextButtonNormalHover": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral250}"
        },
        "colorTextLinkButtonNormalDefault": {
          "light": "{colorTextButtonNormalDefault}",
          "dark": "{colorTextButtonNormalDefault}"
        },
        "colorTextLinkButtonNormalHover": {
          "light": "{colorTextButtonNormalHover}",
          "dark": "{colorTextButtonNormalHover}"
        },
        "colorTextLinkButtonNormalActive": {
          "light": "{colorTextButtonNormalActive}",
          "dark": "{colorTextButtonNormalActive}"
        },
        "colorTextButtonLinkActive": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral300}"
        },
        "colorTextButtonLinkDefault": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral350}"
        },
        "colorTextButtonLinkDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral650}"
        },
        "colorTextButtonLinkHover": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral250}"
        },
        "colorTextButtonPrimaryActive": {
          "light": "{colorNeutral50}",
          "dark": "{colorNeutral950}"
        },
        "colorTextButtonPrimaryDefault": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral950}"
        },
        "colorTextButtonPrimaryHover": {
          "light": "{colorNeutral50}",
          "dark": "{colorNeutral950}"
        },
        "colorTextCalendarDateHover": {
          "light": "{colorTextDropdownItemDefault}",
          "dark": "{colorTextDropdownItemDefault}"
        },
        "colorTextCalendarDateSelected": {
          "light": "{colorBackgroundControlDefault}",
          "dark": "{colorBackgroundControlDefault}"
        },
        "colorTextCalendarMonth": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextCodeEditorGutterActiveLine": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextCodeEditorGutterDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextCodeEditorStatusBarDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorTextCodeEditorTabButtonError": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextColumnHeader": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral400}"
        },
        "colorTextColumnSortingIcon": {
          "light": "{colorTextColumnHeader}",
          "dark": "{colorTextColumnHeader}"
        },
        "colorTextControlDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextCounter": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextDisabledInlineEdit": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral400}"
        },
        "colorTextDropdownFooter": {
          "light": "{colorTextFormSecondary}",
          "dark": "{colorTextFormSecondary}"
        },
        "colorTextDropdownGroupLabel": {
          "light": "{colorTextGroupLabel}",
          "dark": "{colorTextGroupLabel}"
        },
        "colorTextDropdownItemDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextDropdownItemDimmed": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextDropdownItemDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextDropdownItemFilterMatch": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary500}"
        },
        "colorTextDropdownItemHighlighted": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral250}"
        },
        "colorTextDropdownItemSecondary": {
          "light": "{colorTextFormSecondary}",
          "dark": "{colorTextFormSecondary}"
        },
        "colorTextDropdownItemSecondaryHover": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral300}"
        },
        "colorTextEmpty": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral300}"
        },
        "colorTextExpandableSectionDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextExpandableSectionHover": {
          "light": "{colorTextAccent}",
          "dark": "{colorTextAccent}"
        },
        "colorTextExpandableSectionNavigationIconDefault": {
          "light": "{colorTextInteractiveDefault}",
          "dark": "{colorTextInteractiveDefault}"
        },
        "colorBorderExpandableSectionDefault": {
          "light": "{colorBorderDividerDefault}",
          "dark": "{colorBorderDividerDefault}"
        },
        "colorTextFormDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral300}"
        },
        "colorTextFormLabel": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral350}"
        },
        "colorTextFormSecondary": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorTextGroupLabel": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorTextLabelGenAi": {
          "light": "{colorPurple700}",
          "dark": "{colorPurple400}"
        },
        "colorTextHeadingDefault": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral250}"
        },
        "colorTextHeadingSecondary": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral450}"
        },
        "colorTextHomeHeaderDefault": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral250}"
        },
        "colorTextHomeHeaderSecondary": {
          "light": "{colorNeutral350}",
          "dark": "{colorNeutral350}"
        },
        "colorTextIconCaret": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral450}"
        },
        "colorTextIconSubtle": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral400}"
        },
        "colorTextInputDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextInputPlaceholder": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextInputPlaceholderDisabled": {
          "light": "{colorTextInputDisabled}",
          "dark": "{colorTextInputDisabled}"
        },
        "colorTextInteractiveActive": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextInteractiveDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral300}"
        },
        "colorTextInteractiveDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorTextInteractiveHover": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextToggleButtonIconPressed": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextInteractiveInvertedDefault": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral100}"
        },
        "colorTextInteractiveInvertedHover": {
          "light": "{colorNeutral950}",
          "dark": "{colorWhite}"
        },
        "colorTextInverted": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextLabel": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral500}"
        },
        "colorTextKeyValuePairsValue": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral350}"
        },
        "colorTextLayoutToggle": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextLayoutToggleActive": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorTextLayoutToggleHover": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextLayoutToggleSelected": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral950}"
        },
        "colorTextLinkDefault": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral350}"
        },
        "colorTextLinkHover": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextLinkDecorationDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorTextLinkDecorationHover": {
          "light": "currentColor",
          "dark": "currentColor"
        },
        "colorTextLinkSecondaryDefault": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral350}"
        },
        "colorTextLinkSecondaryHover": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextLinkSecondaryDecorationDefault": {
          "light": "{colorTextLinkDecorationDefault}",
          "dark": "{colorTextLinkDecorationDefault}"
        },
        "colorTextLinkInfoDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextLinkInfoHover": {
          "light": "{colorPrimary800}",
          "dark": "{colorPrimary300}"
        },
        "colorTextLinkInvertedDefault": {
          "light": "{colorNeutral100}",
          "dark": "{colorNeutral100}"
        },
        "colorTextLinkInvertedHover": {
          "light": "{colorWhite}",
          "dark": "{colorWhite}"
        },
        "colorTextLinkButtonUnderline": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextLinkButtonUnderlineHover": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextNotificationDefault": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral250}"
        },
        "colorTextAlertDefault": {
          "light": "{colorTextNotificationDefault}",
          "dark": "{colorTextNotificationDefault}"
        },
        "colorTextNotificationLinkDefault": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral250}"
        },
        "colorTextNotificationLinkHover": {
          "light": "{colorNeutral950}",
          "dark": "{colorWhite}"
        },
        "colorTextNotificationStackBar": {
          "light": "{colorNeutral700}",
          "dark": "{colorNeutral350}"
        },
        "colorTextNotificationYellow": {
          "light": "{colorNeutral800}",
          "dark": "{colorNeutral100}"
        },
        "colorTextPaginationPageNumberActiveDisabled": {
          "light": "{colorTextInteractiveDisabled}",
          "dark": "{colorTextInteractiveDisabled}"
        },
        "colorTextPaginationPageNumberDefault": {
          "light": "{colorTextInteractiveDefault}",
          "dark": "{colorNeutral400}"
        },
        "colorTextSegmentActive": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral950}"
        },
        "colorTextSegmentDefault": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral300}"
        },
        "colorTextSegmentHover": {
          "light": "{colorTextButtonNormalHover}",
          "dark": "{colorTextButtonNormalHover}"
        },
        "colorTextSmall": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextFlashbarIconError": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorTextFlashbarIconInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo400}"
        },
        "colorTextFlashbarIconSuccess": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess500}"
        },
        "colorTextFlashbarIconWarning": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorTextAlertIconError": {
          "light": "{colorTextStatusError}",
          "dark": "{colorTextStatusError}"
        },
        "colorTextAlertIconInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo400}"
        },
        "colorTextAlertIconSuccess": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess500}"
        },
        "colorTextAlertIconWarning": {
          "light": "{colorTextStatusWarning}",
          "dark": "{colorTextStatusWarning}"
        },
        "colorTextStatusError": {
          "light": "{colorError600}",
          "dark": "{colorError400}"
        },
        "colorTextStatusInactive": {
          "light": "{colorNeutral600}",
          "dark": "{colorNeutral450}"
        },
        "colorTextStatusInfo": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo300}"
        },
        "colorTextStatusSuccess": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess200}"
        },
        "colorTextStatusWarning": {
          "light": "{colorWarning900}",
          "dark": "{colorWarning300}"
        },
        "colorTextTopNavigationTitle": {
          "light": "{colorNeutral950}",
          "dark": "{colorNeutral100}"
        },
        "colorTextTutorialHotspotDefault": {
          "light": "{colorTextLinkDefault}",
          "dark": "{colorTextLinkDefault}"
        },
        "colorTextTutorialHotspotHover": {
          "light": "{colorTextLinkHover}",
          "dark": "{colorTextLinkHover}"
        },
        "colorBoardPlaceholderActive": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral600}"
        },
        "colorBoardPlaceholderHover": {
          "light": "{colorPrimary100}",
          "dark": "{colorPrimary600}"
        },
        "colorDragPlaceholderActive": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral600}"
        },
        "colorDragPlaceholderHover": {
          "light": "{colorPrimary100}",
          "dark": "{colorPrimary600}"
        },
        "colorDropzoneBackgroundDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorDropzoneBackgroundHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorPrimary1000}"
        },
        "colorDropzoneTextDefault": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorDropzoneTextHover": {
          "light": "{colorNeutral650}",
          "dark": "{colorNeutral350}"
        },
        "colorDropzoneBorderDefault": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorDropzoneBorderHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorGapGlobalDrawer": {
          "light": "{colorNeutral250}",
          "dark": "{colorBlack}"
        },
        "colorTreeViewConnectorLine": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral300}"
        },
        "colorBackgroundActionCardDefault": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorBackgroundActionCardHover": {
          "light": "{colorPrimary50}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundActionCardActive": {
          "light": "{colorPrimary100}",
          "dark": "{colorNeutral700}"
        },
        "colorBorderActionCardDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorBorderActionCardHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorBorderActionCardActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorBorderActionCardDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundActionCardDisabled": {
          "light": "{colorWhite}",
          "dark": "{colorNeutral850}"
        },
        "colorTextActionCardDisabled": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral500}"
        },
        "colorTextActionCardIconDefault": {
          "light": "{colorPrimary600}",
          "dark": "{colorPrimary400}"
        },
        "colorTextActionCardIconHover": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextActionCardIconActive": {
          "light": "{colorPrimary900}",
          "dark": "{colorPrimary300}"
        },
        "colorTextActionCardIconDisabled": {
          "light": "{colorNeutral400}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundSkeleton": {
          "light": "{colorNeutral500}",
          "dark": "{colorNeutral600}"
        },
        "colorBackgroundSkeletonWave": {
          "light": "{colorNeutral150}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundBadgeGreen": {
          "light": "{colorSuccess100}",
          "dark": "rgba(43, 181, 52, 0.2)"
        },
        "colorBackgroundBadgeBlue": {
          "light": "{colorInfo100}",
          "dark": "rgba(92, 127, 255, 0.2)"
        },
        "colorBackgroundBadgeRed": {
          "light": "{colorError100}",
          "dark": "rgba(255, 61, 61, 0.2)"
        },
        "colorBackgroundBadgeYellow": {
          "light": "{colorWarning100}",
          "dark": "rgba(251, 211, 50, 0.2)"
        },
        "colorBackgroundBadgeGrey": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBorderBadge": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeGrey": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeGreen": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeBlue": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorBorderBadgeRed": {
          "light": "transparent",
          "dark": "transparent"
        },
        "colorTextBadgeGrey": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral300}"
        },
        "colorTextBadgeGreen": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess200}"
        },
        "colorTextBadgeBlue": {
          "light": "{colorInfo600}",
          "dark": "{colorInfo300}"
        },
        "colorTextBadgeRed": {
          "light": "{colorError700}",
          "dark": "{colorError400}"
        },
        "colorBackgroundCodeView": {
          "light": "{colorNeutral200}",
          "dark": "{colorNeutral800}"
        },
        "colorBackgroundVisualAccentRed": {
          "light": "#ffe0e0",
          "dark": "rgba(255, 61, 61, 0.2)"
        },
        "colorBackgroundVisualAccentYellow": {
          "light": "#fffbbd",
          "dark": "rgba(251, 211, 50, 0.2)"
        },
        "colorBackgroundVisualAccentIndigo": {
          "light": "#dbe4ff",
          "dark": "rgba(92, 127, 255, 0.2)"
        },
        "colorBackgroundVisualAccentGreen": {
          "light": "#d9ffd6",
          "dark": "rgba(43, 181, 52, 0.2)"
        },
        "colorBackgroundVisualAccentOrange": {
          "light": "rgba(255, 224, 214, 0.6)",
          "dark": "rgba(255, 75, 20, 0.2)"
        },
        "colorBackgroundVisualAccentPurple": {
          "light": "rgba(242, 229, 255, 0.6)",
          "dark": "rgba(173, 92, 255, 0.2)"
        },
        "colorBackgroundVisualAccentLime": {
          "light": "{colorLime100}",
          "dark": "rgba(49, 184, 0, 0.2)"
        },
        "colorBackgroundVisualAccentGrey": {
          "light": "{colorNeutral250}",
          "dark": "{colorNeutral700}"
        },
        "colorBackgroundVisualAccentTeal": {
          "light": "rgba(204, 255, 252, 0.7)",
          "dark": "rgba(0, 173, 162, 0.2)"
        },
        "colorBackgroundVisualAccentBlue": {
          "light": "rgba(209, 241, 255, 0.6)",
          "dark": "rgba(0, 153, 255, 0.2)"
        },
        "colorBackgroundVisualAccentViolet": {
          "light": "rgba(232, 229, 255, 0.6)",
          "dark": "rgba(133, 117, 255, 0.2)"
        },
        "colorBackgroundVisualAccentMagenta": {
          "light": "rgba(255, 224, 251, 0.6)",
          "dark": "rgba(255, 26, 224, 0.2)"
        },
        "colorBackgroundVisualAccentPink": {
          "light": "rgba(255, 224, 240, 0.7)",
          "dark": "rgba(255, 51, 153, 0.2)"
        },
        "colorBackgroundVisualAccentAmber": {
          "light": "rgba(255, 232, 189, 0.7)",
          "dark": "rgba(250, 111, 0, 0.2)"
        },
        "colorTextVisualAccentRed": {
          "light": "{colorError700}",
          "dark": "{colorError400}"
        },
        "colorTextVisualAccentYellow": {
          "light": "{colorWarning900}",
          "dark": "{colorWarning200}"
        },
        "colorTextVisualAccentIndigo": {
          "light": "{colorInfo800}",
          "dark": "{colorInfo300}"
        },
        "colorTextVisualAccentGreen": {
          "light": "{colorSuccess600}",
          "dark": "{colorSuccess200}"
        },
        "colorTextVisualAccentOrange": {
          "light": "#a82700",
          "dark": "#ff997a"
        },
        "colorTextVisualAccentPurple": {
          "light": "#962eff",
          "dark": "#d4a8ff"
        },
        "colorTextVisualAccentLime": {
          "light": "#007000",
          "dark": "#acff2e"
        },
        "colorTextVisualAccentGrey": {
          "light": "{colorNeutral850}",
          "dark": "{colorNeutral300}"
        },
        "colorTextVisualAccentTeal": {
          "light": "#008077",
          "dark": "#00f5e4"
        },
        "colorTextVisualAccentBlue": {
          "light": "#006ce0",
          "dark": "#75cfff"
        },
        "colorTextVisualAccentViolet": {
          "light": "#6842ff",
          "dark": "#b2a8ff"
        },
        "colorTextVisualAccentMagenta": {
          "light": "#b2008f",
          "dark": "#ff57e9"
        },
        "colorTextVisualAccentPink": {
          "light": "#bb005d",
          "dark": "#ff99cc"
        },
        "colorTextVisualAccentAmber": {
          "light": "#9e3700",
          "dark": "#ffbb45"
        },
        "fontBoxValueLargeWeight": "700",
        "fontButtonLetterSpacing": "0.005em",
        "fontChartDetailSize": "{fontSizeBodyS}",
        "fontDecorationStyleLink": "solid",
        "fontDecorationLineLinkSecondary": "underline",
        "fontDecorationThicknessLink": "1px",
        "fontDecorationThicknessLinkDisplayL": "2px",
        "fontDisplayLabelWeight": "500",
        "fontSizeExpandableHeading": "{fontSizeHeadingS}",
        "fontFamilyBase": "'Ember Modern Text UI', 'Amazon Ember', Roboto, Arial, sans-serif",
        "fontFamilyDisplay": "{fontFamilyBase}",
        "fontFamilyHeading": "{fontFamilyBase}",
        "fontFamilyMonospace": "'Ember Modern Mono', Monaco, Menlo, Consolas, 'Courier Prime', Courier, 'Courier New', monospace",
        "fontHeaderH2DescriptionLineHeight": "{lineHeightBodyM}",
        "fontHeaderH2DescriptionSize": "{fontSizeBodyM}",
        "fontLinkButtonLetterSpacing": "{fontButtonLetterSpacing}",
        "fontLinkButtonWeight": "{fontWeightButton}",
        "fontPanelHeaderLineHeight": "{lineHeightHeadingM}",
        "fontPanelHeaderSize": "{fontSizeHeadingM}",
        "fontSideNavigationSectionHeaderSize": "inherit",
        "fontSideNavigationSectionHeaderWeight": "inherit",
        "fontSizeBodyM": "14px",
        "fontSizeBodyS": "12px",
        "fontSizeDisplayL": "42px",
        "fontSizeDisplayXl": "64px",
        "fontSizeFormLabel": "14px",
        "fontSizeHeadingL": "20px",
        "fontSizeHeadingM": "18px",
        "fontSizeHeadingS": "16px",
        "fontSizeHeadingXl": "24px",
        "fontSizeHeadingXs": "14px",
        "fontSizeKeyValuePairsLabel": "14px",
        "fontSizeTabs": "14px",
        "fontSmoothingMozOsx": "grayscale",
        "fontSmoothingWebkit": "antialiased",
        "fontWayfindingLinkActiveWeight": "600",
        "fontWeightAlertHeader": "500",
        "fontWeightBold": "600",
        "fontWeightBreadcrumbCurrent": "400",
        "fontWeightButton": "500",
        "fontWeightDisplayL": "500",
        "fontWeightDisplayXl": "400",
        "fontWeightFlashbarHeader": "500",
        "fontWeightFormLabel": "600",
        "fontWeightHeadingL": "500",
        "fontWeightHeadingM": "500",
        "fontWeightHeadingS": "500",
        "fontWeightHeadingXl": "500",
        "fontWeightHeadingXs": "500",
        "fontWeightHeavy": "700",
        "fontWeightKeyValuePairsLabel": "400",
        "fontWeightLighter": "300",
        "fontWeightLinkSecondary": "inherit",
        "fontWeightNormal": "400",
        "fontWeightTabs": "600",
        "fontWeightTabsDisabled": "{fontWayfindingLinkActiveWeight}",
        "letterSpacingBodyS": "0.005em",
        "letterSpacingDisplayL": "-0.03em",
        "letterSpacingDisplayXl": "-0.03em",
        "letterSpacingHeadingL": "-0.015em",
        "letterSpacingHeadingM": "-0.010em",
        "letterSpacingHeadingS": "-0.005em",
        "letterSpacingHeadingXl": "-0.02em",
        "letterSpacingHeadingXs": "normal",
        "lineHeightBodyM": "20px",
        "lineHeightBodyS": "16px",
        "lineHeightDisplayL": "48px",
        "lineHeightDisplayXl": "72px",
        "lineHeightFormLabel": "20px",
        "lineHeightHeadingL": "24px",
        "lineHeightHeadingM": "22px",
        "lineHeightHeadingS": "20px",
        "lineHeightHeadingXl": "30px",
        "lineHeightHeadingXs": "20px",
        "lineHeightKeyValuePairsLabel": "20px",
        "lineHeightTabs": "{lineHeightHeadingS}",
        "borderActiveWidth": "4px",
        "borderCodeEditorStatusDividerWidth": "{borderDividerSectionWidth}",
        "borderContainerStickyWidth": "0px",
        "borderContainerTopWidth": "0px",
        "borderControlFocusRingShadowSpread": "1px",
        "borderControlInvalidFocusRingShadowSpread": "2px",
        "borderDividerListWidth": "1px",
        "borderDividerSectionWidth": "1px",
        "borderDropdownVirtualOffsetWidth": "2px",
        "borderInvalidWidth": "8px",
        "borderItemWidth": "1px",
        "borderLineChartDashArray": "3 5",
        "borderLineChartLineJoin": "round",
        "borderLineChartWidth": "2px",
        "borderLinkFocusRingOutline": "0",
        "borderLinkFocusRingShadowSpread": "2px",
        "borderPanelHeaderWidth": "1px",
        "borderPanelTopWidth": "1px",
        "borderRadiusActionCardDefault": "{borderRadiusCardDefault}",
        "borderRadiusActionCardEmbedded": "{borderRadiusCardEmbedded}",
        "borderRadiusAlert": "2px",
        "borderRadiusBadge": "16px",
        "borderRadiusButton": "4px",
        "borderRadiusCalendarDayFocusRing": "3px",
        "borderRadiusCardDefault": "{borderRadiusContainer}",
        "borderRadiusCardEmbedded": "{borderRadiusChatBubble}",
        "borderRadiusChatBubble": "4px",
        "borderRadiusSupportPrompt": "4px",
        "borderRadiusCodeEditor": "{borderRadiusInput}",
        "borderRadiusContainer": "2px",
        "borderRadiusControlCircularFocusRing": "4px",
        "borderRadiusControlDefaultFocusRing": "4px",
        "borderRadiusDropdown": "4px",
        "borderRadiusDropzone": "2px",
        "borderRadiusFlashbar": "2px",
        "borderRadiusInput": "4px",
        "borderRadiusItem": "4px",
        "borderRadiusSideNavigationItem": "{borderRadiusItem}",
        "borderRadiusSideNavigationItemCollapsed": "{borderRadiusItem}",
        "borderRadiusItemCardDefault": "{borderRadiusCardDefault}",
        "borderRadiusItemCardEmbedded": "{borderRadiusCardEmbedded}",
        "borderRadiusDialog": "{borderRadiusCardEmbedded}",
        "borderRadiusPopover": "4px",
        "borderRadiusSkeleton": "8px",
        "borderRadiusStatusIndicator": "2px",
        "borderRadiusTabsFocusRing": "4px",
        "borderRadiusTiles": "{borderRadiusInput}",
        "borderRadiusToken": "4px",
        "borderRadiusTokenInline": "{borderRadiusToken}",
        "borderRadiusTutorialPanelItem": "2px",
        "borderTableStickyWidth": "1px",
        "borderWidthActionCardActive": "{borderWidthCard}",
        "borderWidthActionCardDefault": "{borderWidthCard}",
        "borderWidthActionCardDisabled": "{borderWidthCard}",
        "borderWidthActionCardHover": "{borderWidthCard}",
        "borderWidthAlert": "0px",
        "borderWidthAlertBlockEnd": "{borderWidthAlert}",
        "borderWidthAlertBlockStart": "{borderWidthAlert}",
        "borderWidthAlertInlineEnd": "{borderWidthAlert}",
        "borderWidthAlertInlineStart": "2px",
        "borderWidthFlashbarInlineStart": "2px",
        "borderWidthButton": "1px",
        "borderWidthCard": "{borderDividerSectionWidth}",
        "borderWidthCardSelected": "1px",
        "borderWidthDropdown": "1px",
        "borderWidthField": "1px",
        "borderWidthIconBig": "2px",
        "borderWidthIconLarge": "2.5px",
        "borderWidthIconMedium": "1.75px",
        "borderWidthIconNormal": "1.5px",
        "borderWidthIconSmall": "1.5px",
        "borderWidthIconXSmall": "1.5px",
        "borderWidthItemCard": "{borderWidthCard}",
        "borderWidthItemCardHighlighted": "{borderWidthCardSelected}",
        "borderWidthDialog": "{borderWidthCard}",
        "borderWidthItemSelected": "1px",
        "borderWidthLayoutSideNavigation": "{borderDividerSectionWidth}",
        "borderWidthNotificationStackBar": "1px",
        "borderWidthBadge": "0px",
        "borderWidthPopover": "1px",
        "borderWidthToken": "1px",
        "motionDurationExtraFast": {
          "default": "45ms",
          "disabled": "0ms"
        },
        "motionDurationExtraSlow": {
          "default": "270ms",
          "disabled": "0ms"
        },
        "motionDurationFast": {
          "default": "90ms",
          "disabled": "0ms"
        },
        "motionDurationModerate": {
          "default": "135ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlyAmbient": {
          "default": "2000ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlyFast": {
          "default": "115ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlyMedium": {
          "default": "165ms",
          "disabled": "0ms"
        },
        "motionDurationRefreshOnlySlow": {
          "default": "250ms",
          "disabled": "0ms"
        },
        "motionDurationAvatarGenAiGradient": {
          "default": "3600ms",
          "disabled": "0ms"
        },
        "motionDurationAvatarLoadingDots": {
          "default": "1200ms",
          "disabled": "0ms"
        },
        "motionDurationRotate180": {
          "default": "{motionDurationModerate}",
          "disabled": "{motionDurationModerate}"
        },
        "motionDurationRotate90": {
          "default": "{motionDurationModerate}",
          "disabled": "{motionDurationModerate}"
        },
        "motionDurationShowPaced": {
          "default": "{motionDurationSlow}",
          "disabled": "{motionDurationSlow}"
        },
        "motionDurationShowQuick": {
          "default": "{motionDurationModerate}",
          "disabled": "{motionDurationModerate}"
        },
        "motionDurationSlow": {
          "default": "180ms",
          "disabled": "0ms"
        },
        "motionDurationTransitionQuick": {
          "default": "{motionDurationFast}",
          "disabled": "{motionDurationFast}"
        },
        "motionDurationTransitionShowPaced": {
          "default": "{motionDurationSlow}",
          "disabled": "{motionDurationSlow}"
        },
        "motionDurationTransitionShowQuick": {
          "default": "{motionDurationFast}",
          "disabled": "{motionDurationFast}"
        },
        "motionEasingEaseOutQuart": {
          "default": "cubic-bezier(0.165, 0.84, 0.44, 1)",
          "disabled": "cubic-bezier(0.165, 0.84, 0.44, 1)"
        },
        "motionEasingRefreshOnlyA": {
          "default": "cubic-bezier(0, 0, 0, 1)",
          "disabled": "cubic-bezier(0, 0, 0, 1)"
        },
        "motionEasingRefreshOnlyB": {
          "default": "cubic-bezier(1, 0, 0.83, 1)",
          "disabled": "cubic-bezier(1, 0, 0.83, 1)"
        },
        "motionEasingRefreshOnlyC": {
          "default": "cubic-bezier(0.84, 0, 0.16, 1)",
          "disabled": "cubic-bezier(0.84, 0, 0.16, 1)"
        },
        "motionEasingRefreshOnlyD": {
          "default": "cubic-bezier(0.33, 0, 0.67, 1)",
          "disabled": "cubic-bezier(0.33, 0, 0.67, 1)"
        },
        "motionEasingAvatarGenAiGradient": {
          "default": "cubic-bezier(0.7, 0, 0.3, 1)",
          "disabled": "cubic-bezier(0.7, 0, 0.3, 1)"
        },
        "motionEasingRotate180": {
          "default": "{motionEasingEaseOutQuart}",
          "disabled": "{motionEasingEaseOutQuart}"
        },
        "motionEasingRotate90": {
          "default": "{motionEasingEaseOutQuart}",
          "disabled": "{motionEasingEaseOutQuart}"
        },
        "motionEasingShowPaced": {
          "default": "ease-out",
          "disabled": "ease-out"
        },
        "motionEasingShowQuick": {
          "default": "ease-out",
          "disabled": "ease-out"
        },
        "motionEasingTransitionQuick": {
          "default": "linear",
          "disabled": "linear"
        },
        "motionEasingTransitionShowPaced": {
          "default": "ease-out",
          "disabled": "ease-out"
        },
        "motionEasingTransitionShowQuick": {
          "default": "linear",
          "disabled": "linear"
        },
        "motionEasingResponsive": {
          "default": "{motionEasingRefreshOnlyA}",
          "disabled": "{motionEasingRefreshOnlyA}"
        },
        "motionEasingSticky": {
          "default": "{motionEasingRefreshOnlyB}",
          "disabled": "{motionEasingRefreshOnlyB}"
        },
        "motionEasingExpressive": {
          "default": "{motionEasingRefreshOnlyC}",
          "disabled": "{motionEasingRefreshOnlyC}"
        },
        "motionDurationResponsive": {
          "default": "{motionDurationRefreshOnlyFast}",
          "disabled": "{motionDurationRefreshOnlyFast}"
        },
        "motionDurationExpressive": {
          "default": "{motionDurationRefreshOnlyMedium}",
          "disabled": "{motionDurationRefreshOnlyMedium}"
        },
        "motionDurationComplex": {
          "default": "{motionDurationRefreshOnlySlow}",
          "disabled": "{motionDurationRefreshOnlySlow}"
        },
        "motionDurationTooltipEnter": {
          "default": "{motionDurationRefreshOnlyFast}",
          "disabled": "{motionDurationRefreshOnlyFast}"
        },
        "motionEasingTooltipEnter": {
          "default": "{motionEasingRefreshOnlyA}",
          "disabled": "{motionEasingRefreshOnlyA}"
        },
        "motionDurationExpandableContentEnter": {
          "default": "300ms",
          "disabled": "0ms"
        },
        "motionEasingExpandableContentEnter": {
          "default": "cubic-bezier(0, 0, 0.2, 1)",
          "disabled": "cubic-bezier(0, 0, 0.2, 1)"
        },
        "motionDurationSideNavigationContentEnterFade": {
          "default": "150ms",
          "disabled": "0ms"
        },
        "motionDurationSideNavigationContentExit": {
          "default": "200ms",
          "disabled": "0ms"
        },
        "motionDurationSideNavigationContentExitFade": {
          "default": "{motionDurationFast}",
          "disabled": "{motionDurationFast}"
        },
        "motionEasingSideNavigationContentExit": {
          "default": "cubic-bezier(0.4, 0, 1, 1)",
          "disabled": "cubic-bezier(0.4, 0, 1, 1)"
        },
        "motionKeyframesFadeIn": {
          "default": "awsui-fade-in-jiml2r",
          "disabled": "awsui-fade-in-jiml2r"
        },
        "motionKeyframesFadeOut": {
          "default": "awsui-fade-out-au27m5",
          "disabled": "awsui-fade-out-au27m5"
        },
        "motionKeyframesStatusIconError": {
          "default": "awsui-status-icon-error-mjjk3s",
          "disabled": "awsui-status-icon-error-mjjk3s"
        },
        "motionKeyframesScalePopup": {
          "default": "awsui-scale-popup-2m9987",
          "disabled": "awsui-scale-popup-2m9987"
        },
        "shadowCard": {
          "light": "none",
          "dark": "none"
        },
        "shadowItemCard": {
          "light": "{shadowCard}",
          "dark": "{shadowCard}"
        },
        "shadowContainer": {
          "light": "0px 0px 1px 1px #ebebeb, 0px 1px 8px 2px rgba(0, 0, 0, 0.12)",
          "dark": "0px 1px 8px 2px rgba(0, 0, 0, 0.6)"
        },
        "shadowContainerActive": {
          "light": "0px 1px 1px 1px #ebebeb, 0px 6px 36px #0606061a",
          "dark": "0px 1px 1px 1px #222222, 0px 6px 36px #030303"
        },
        "shadowDropdown": {
          "light": "0px 4px 20px 1px rgba(0, 0, 0, 0.10)",
          "dark": "0px 4px 20px 1px rgba(0, 0, 0, 1)"
        },
        "shadowDropup": {
          "light": "{shadowDropdown}",
          "dark": "{shadowDropdown}"
        },
        "shadowFlashCollapsed": {
          "light": "0px 2px 4px rgba(0, 0, 0, 0.15)",
          "dark": "0px 2px 4px rgba(0, 0, 0, 0.15)"
        },
        "shadowFlashSticky": {
          "light": "0px 2px 4px rgba(0, 0, 0, 0.15)",
          "dark": "0px 2px 4px rgba(0, 0, 0, 0.15)"
        },
        "shadowModal": {
          "light": "{shadowDropdown}",
          "dark": "{shadowDropdown}"
        },
        "shadowPanel": {
          "light": "0px 0px 0px 1px #bebebe",
          "dark": "0px 0px 0px 1px #4b4b4b"
        },
        "shadowPanelToggle": {
          "light": "0px 6px 12px 1px rgba(0, 0, 0, 0.1)",
          "dark": "0px 6px 12px 1px rgba(0, 0, 0, 1)"
        },
        "shadowPopover": {
          "light": "{shadowDropdown}",
          "dark": "{shadowDropdown}"
        },
        "shadowSplitBottom": {
          "light": "0px -36px 36px -36px rgba(0, 0, 0, 0.10)",
          "dark": "0px -36px 36px -36px rgba(0, 0, 0, 1)"
        },
        "shadowSplitSide": {
          "light": "-1px 0px 1px 0px #ebebeb, -36px 6px 36px -36px rgba(0, 0, 0, 0.10)",
          "dark": "-1px 0px 1px 0px #222222, -36px 6px 36px -36px rgba(0, 0, 0, 1)"
        },
        "shadowSticky": {
          "light": "0px 4px 8px 1px rgba(0, 0, 0, 0.10)",
          "dark": "0px 4px 8px 1px rgba(0, 0, 0, 0.5)"
        },
        "shadowStickyEmbedded": {
          "light": "0px 2px 0px 0px #ebebeb, 0px 16px 16px -12px rgba(0, 0, 0, 0.10)",
          "dark": "0px 2px 0px 0px #4b4b4b, 0px 16px 16px -12px rgba(0, 0, 0, 1)"
        },
        "shadowStickyColumnFirst": {
          "light": "4px 0px 8px 1px rgba(0, 0, 0, 0.1)",
          "dark": "2px 4px 8px 1px rgba(0, 0, 0, 0.5)"
        },
        "shadowStickyColumnLast": {
          "light": "-4px 0 8px 1px rgba(0, 0, 0, 0.1)",
          "dark": "-2px 4px 8px 1px rgba(0, 0, 0, 0.5)"
        },
        "sizeCalendarGridWidth": {
          "comfortable": "238px",
          "compact": "238px"
        },
        "sizeControl": {
          "comfortable": "16px",
          "compact": "16px"
        },
        "sizeIconBig": {
          "comfortable": "32px",
          "compact": "32px"
        },
        "sizeIconLarge": {
          "comfortable": "48px",
          "compact": "48px"
        },
        "sizeIconMedium": {
          "comfortable": "20px",
          "compact": "20px"
        },
        "sizeIconNormal": {
          "comfortable": "16px",
          "compact": "16px"
        },
        "sizeTableSelectionHorizontal": {
          "comfortable": "40px",
          "compact": "40px"
        },
        "sizeVerticalInput": {
          "comfortable": "30px",
          "compact": "26px"
        },
        "sizeVerticalPanelIconOffset": {
          "comfortable": "15px",
          "compact": "13px"
        },
        "sizeSideNavigationItemHeight": {
          "comfortable": "30px",
          "compact": "26px"
        },
        "sizeSideNavigationItemCollapsed": {
          "comfortable": "28px",
          "compact": "26px"
        },
        "sizeSideNavigationCollapsedWidth": {
          "comfortable": "52px",
          "compact": "52px"
        },
        "spaceAlertActionLeft": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceAlertHorizontal": {
          "comfortable": "{spaceFlashbarHorizontal}",
          "compact": "{spaceFlashbarHorizontal}"
        },
        "spaceAlertMessageRight": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceAlertVertical": {
          "comfortable": "6px",
          "compact": "6px"
        },
        "spaceButtonFocusOutlineGutter": {
          "comfortable": "4px",
          "compact": "4px"
        },
        "spaceButtonHorizontal": {
          "comfortable": "12px",
          "compact": "12px"
        },
        "spaceButtonVertical": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceTokenVertical": {
          "comfortable": "1px",
          "compact": "1px"
        },
        "spaceFieldVertical": {
          "comfortable": "4px",
          "compact": "2px"
        },
        "spaceButtonIconFocusOutlineGutterVertical": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceButtonIconOnlyHorizontal": {
          "comfortable": "6px",
          "compact": "{spaceXxs}"
        },
        "spaceButtonInlineIconFocusOutlineGutter": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceButtonModalDismissVertical": {
          "comfortable": "{spaceScaledXxxs}",
          "compact": "{spaceScaledXxxs}"
        },
        "spaceCalendarGridFocusOutlineGutter": {
          "comfortable": "-5px",
          "compact": "-5px"
        },
        "spaceCalendarGridSelectedFocusOutlineGutter": {
          "comfortable": "{spaceCalendarGridFocusOutlineGutter}",
          "compact": "{spaceCalendarGridFocusOutlineGutter}"
        },
        "spaceCalendarGridGutter": {
          "comfortable": "6px",
          "compact": "6px"
        },
        "spaceCardHorizontalDefault": {
          "comfortable": "{spaceContainerHorizontal}",
          "compact": "{spaceContainerHorizontal}"
        },
        "spaceCardHorizontalEmbedded": {
          "comfortable": "{spaceS}",
          "compact": "10px"
        },
        "spaceCardVerticalDefault": {
          "comfortable": "{spaceScaledM}",
          "compact": "{spaceScaledM}"
        },
        "spaceCardVerticalEmbedded": {
          "comfortable": "10px",
          "compact": "{spaceXs}"
        },
        "spaceItemCardHorizontalDefault": {
          "comfortable": "{spaceCardHorizontalDefault}",
          "compact": "{spaceCardHorizontalDefault}"
        },
        "spaceItemCardHorizontalEmbedded": {
          "comfortable": "{spaceCardHorizontalEmbedded}",
          "compact": "{spaceCardHorizontalEmbedded}"
        },
        "spaceItemCardVerticalDefault": {
          "comfortable": "{spaceCardVerticalDefault}",
          "compact": "{spaceCardVerticalDefault}"
        },
        "spaceItemCardVerticalEmbedded": {
          "comfortable": "{spaceCardVerticalEmbedded}",
          "compact": "{spaceCardVerticalEmbedded}"
        },
        "spaceDialogHorizontal": {
          "comfortable": "{spaceCardHorizontalEmbedded}",
          "compact": "{spaceCardHorizontalEmbedded}"
        },
        "spaceDialogVertical": {
          "comfortable": "{spaceCardVerticalEmbedded}",
          "compact": "{spaceCardVerticalEmbedded}"
        },
        "spaceDialogActionBlock": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceDialogActionInline": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceDialogHeaderGap": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXs}"
        },
        "spaceDialogSectionGap": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceCodeEditorStatusFocusOutlineGutter": {
          "comfortable": "-7px",
          "compact": "-7px"
        },
        "spaceContainerContentTop": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceContainerHeaderTop": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceContainerHeaderBottom": {
          "comfortable": "{spaceScaledXs}",
          "compact": "{spaceScaledXs}"
        },
        "spaceContainerHorizontal": {
          "comfortable": "{spaceL}",
          "compact": "{spaceL}"
        },
        "spaceContentHeaderPaddingBottom": {
          "comfortable": "{spaceScaledM}",
          "compact": "{spaceScaledM}"
        },
        "spaceDarkHeaderOverlapDistance": {
          "comfortable": "36px",
          "compact": "32px"
        },
        "spaceExpandableSectionIconOffsetTop": {
          "comfortable": "{spaceScaled2xXxs}",
          "compact": "{spaceScaled2xXxs}"
        },
        "spaceFieldHorizontal": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceFieldIconOffset": {
          "comfortable": "36px",
          "compact": "36px"
        },
        "spaceFilteringTokenDismissButtonFocusOutlineGutter": {
          "comfortable": "-5px",
          "compact": "-5px"
        },
        "spaceFilteringTokenOperationSelectFocusOutlineGutter": {
          "comfortable": "-5px",
          "compact": "-5px"
        },
        "spaceFlashbarActionLeft": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceFlashbarDismissRight": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceFlashbarHorizontal": {
          "comfortable": "{spaceM}",
          "compact": "{spaceM}"
        },
        "spaceFlashbarVertical": {
          "comfortable": "6px",
          "compact": "6px"
        },
        "spaceGridGutter": {
          "comfortable": "{spaceL}",
          "compact": "{spaceM}"
        },
        "spaceKeyValueGap": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceLayoutContentBottom": {
          "comfortable": "{spaceScaled2xXxxl}",
          "compact": "{spaceScaled2xXxxl}"
        },
        "spaceLayoutContentHorizontal": {
          "comfortable": "{spaceScaled2xXl}",
          "compact": "{spaceScaled2xXl}"
        },
        "spaceLayoutToggleDiameter": {
          "comfortable": "36px",
          "compact": "36px"
        },
        "spaceLayoutTogglePadding": {
          "comfortable": "{spaceStaticS}",
          "compact": "{spaceStaticS}"
        },
        "spaceModalContentBottom": {
          "comfortable": "{spaceScaled2xM}",
          "compact": "{spaceScaled2xM}"
        },
        "spaceModalHorizontal": {
          "comfortable": "{spaceContainerHorizontal}",
          "compact": "{spaceContainerHorizontal}"
        },
        "spacePanelContentBottom": {
          "comfortable": "{spaceScaledXxxl}",
          "compact": "{spaceScaledXxxl}"
        },
        "spacePanelContentTop": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spacePanelDividerMarginHorizontal": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXs}"
        },
        "spacePanelHeaderVertical": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spacePanelNavLeft": {
          "comfortable": "28px",
          "compact": "28px"
        },
        "spacePanelSideLeft": {
          "comfortable": "28px",
          "compact": "28px"
        },
        "spacePanelSideRight": {
          "comfortable": "{spaceScaledXl}",
          "compact": "{spaceScaledXl}"
        },
        "spacePanelSplitTop": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spacePanelSplitBottom": {
          "comfortable": "{spaceScaledL}",
          "compact": "{spaceScaledL}"
        },
        "spaceSegmentedControlFocusOutlineGutter": {
          "comfortable": "6px",
          "compact": "6px"
        },
        "spaceTabsContentTop": {
          "comfortable": "{spaceScaledS}",
          "compact": "{spaceScaledS}"
        },
        "spaceTabsFocusOutlineGutter": {
          "comfortable": "-8px",
          "compact": "-8px"
        },
        "spaceTabsVertical": {
          "comfortable": "2px",
          "compact": "2px"
        },
        "spaceTableContentBottom": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceTableEmbeddedHeaderTop": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceTableFooterHorizontal": {
          "comfortable": "{spaceTableHeaderHorizontal}",
          "compact": "{spaceTableHeaderHorizontal}"
        },
        "spaceTableHeaderFocusOutlineGutter": {
          "comfortable": "0px",
          "compact": "-1px"
        },
        "spaceTableHeaderHorizontal": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceTableHeaderToolsBottom": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceTableHeaderToolsFullPageBottom": {
          "comfortable": "4px",
          "compact": "4px"
        },
        "spaceTableHorizontal": {
          "comfortable": "{spaceContainerHorizontal}",
          "compact": "{spaceContainerHorizontal}"
        },
        "spaceTreeViewIndentation": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceXl}"
        },
        "spaceSideNavigationItemDefaultGap": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceSideNavigationItemIconGap": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceTileGutter": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceM}"
        },
        "spaceActionCardHorizontalDefault": {
          "comfortable": "{spaceCardHorizontalDefault}",
          "compact": "{spaceCardHorizontalDefault}"
        },
        "spaceActionCardHorizontalEmbedded": {
          "comfortable": "{spaceCardHorizontalEmbedded}",
          "compact": "{spaceCardHorizontalEmbedded}"
        },
        "spaceActionCardVerticalDefault": {
          "comfortable": "{spaceCardVerticalDefault}",
          "compact": "{spaceCardVerticalDefault}"
        },
        "spaceActionCardVerticalEmbedded": {
          "comfortable": "{spaceCardVerticalEmbedded}",
          "compact": "{spaceCardVerticalEmbedded}"
        },
        "spaceActionCardDescriptionPaddingTop": {
          "comfortable": "{spaceScaledXxs}",
          "compact": "{spaceScaledXxs}"
        },
        "spaceActionCardContentPaddingTop": {
          "comfortable": "{spaceScaledXs}",
          "compact": "{spaceScaledXs}"
        },
        "spaceOptionPaddingVertical": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceOptionPaddingHorizontal": {
          "comfortable": "{spaceL}",
          "compact": "{spaceL}"
        },
        "spaceStatusIndicatorPaddingHorizontal": {
          "comfortable": "2px",
          "compact": "2px"
        },
        "spaceScaled2xNone": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xXxxs": {
          "comfortable": "{spaceXxxs}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xXxs": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xXs": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceNone}"
        },
        "spaceScaled2xS": {
          "comfortable": "{spaceS}",
          "compact": "{spaceXxs}"
        },
        "spaceScaled2xM": {
          "comfortable": "{spaceM}",
          "compact": "{spaceXs}"
        },
        "spaceScaled2xL": {
          "comfortable": "{spaceL}",
          "compact": "{spaceS}"
        },
        "spaceScaled2xXl": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceM}"
        },
        "spaceScaled2xXxl": {
          "comfortable": "{spaceXxl}",
          "compact": "{spaceL}"
        },
        "spaceScaled2xXxxl": {
          "comfortable": "{spaceXxxl}",
          "compact": "{spaceXl}"
        },
        "spaceScaledNone": {
          "comfortable": "{spaceNone}",
          "compact": "{spaceNone}"
        },
        "spaceScaledXxxs": {
          "comfortable": "{spaceXxxs}",
          "compact": "{spaceNone}"
        },
        "spaceScaledXxs": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxxs}"
        },
        "spaceScaledXs": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXxs}"
        },
        "spaceScaledS": {
          "comfortable": "{spaceS}",
          "compact": "{spaceXs}"
        },
        "spaceScaledM": {
          "comfortable": "{spaceM}",
          "compact": "{spaceS}"
        },
        "spaceScaledL": {
          "comfortable": "{spaceL}",
          "compact": "{spaceM}"
        },
        "spaceScaledXl": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceL}"
        },
        "spaceScaledXxl": {
          "comfortable": "{spaceXxl}",
          "compact": "{spaceXl}"
        },
        "spaceScaledXxxl": {
          "comfortable": "{spaceXxxl}",
          "compact": "{spaceXxl}"
        },
        "spaceStaticXxxs": {
          "comfortable": "{spaceXxxs}",
          "compact": "{spaceXxxs}"
        },
        "spaceStaticXxs": {
          "comfortable": "{spaceXxs}",
          "compact": "{spaceXxs}"
        },
        "spaceStaticXs": {
          "comfortable": "{spaceXs}",
          "compact": "{spaceXs}"
        },
        "spaceStaticS": {
          "comfortable": "{spaceS}",
          "compact": "{spaceS}"
        },
        "spaceStaticM": {
          "comfortable": "{spaceM}",
          "compact": "{spaceM}"
        },
        "spaceStaticL": {
          "comfortable": "{spaceL}",
          "compact": "{spaceL}"
        },
        "spaceStaticXl": {
          "comfortable": "{spaceXl}",
          "compact": "{spaceXl}"
        },
        "spaceStaticXxl": {
          "comfortable": "{spaceXxl}",
          "compact": "{spaceXxl}"
        },
        "spaceStaticXxxl": {
          "comfortable": "{spaceXxxl}",
          "compact": "{spaceXxxl}"
        },
        "spaceNone": {
          "comfortable": "0px",
          "compact": "0px"
        },
        "spaceXxxs": {
          "comfortable": "2px",
          "compact": "2px"
        },
        "spaceXxs": {
          "comfortable": "4px",
          "compact": "4px"
        },
        "spaceXs": {
          "comfortable": "8px",
          "compact": "8px"
        },
        "spaceS": {
          "comfortable": "12px",
          "compact": "12px"
        },
        "spaceM": {
          "comfortable": "16px",
          "compact": "16px"
        },
        "spaceL": {
          "comfortable": "20px",
          "compact": "20px"
        },
        "spaceXl": {
          "comfortable": "24px",
          "compact": "24px"
        },
        "spaceXxl": {
          "comfortable": "32px",
          "compact": "32px"
        },
        "spaceXxxl": {
          "comfortable": "40px",
          "compact": "40px"
        }
      },
      "contexts": {
        "compact-table": {
          "id": "compact-table",
          "selector": ".awsui-context-compact-table",
          "tokens": {
            "spaceAlertActionLeft": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceAlertHorizontal": {
              "comfortable": "{spaceFlashbarHorizontal}",
              "compact": "{spaceFlashbarHorizontal}"
            },
            "spaceAlertMessageRight": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceAlertVertical": {
              "comfortable": "{spaceFlashbarVertical}",
              "compact": "{spaceFlashbarVertical}"
            },
            "spaceButtonFocusOutlineGutter": {
              "comfortable": "4px",
              "compact": "4px"
            },
            "spaceButtonHorizontal": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spaceButtonVertical": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceTokenVertical": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceFieldVertical": {
              "comfortable": "5px",
              "compact": "3px"
            },
            "spaceButtonIconFocusOutlineGutterVertical": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceButtonIconOnlyHorizontal": {
              "comfortable": "6px",
              "compact": "{spaceXxs}"
            },
            "spaceButtonInlineIconFocusOutlineGutter": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceButtonModalDismissVertical": {
              "comfortable": "{spaceScaledXxxs}",
              "compact": "{spaceScaledXxxs}"
            },
            "spaceCalendarGridFocusOutlineGutter": {
              "comfortable": "-5px",
              "compact": "-5px"
            },
            "spaceCalendarGridSelectedFocusOutlineGutter": {
              "comfortable": "{spaceCalendarGridFocusOutlineGutter}",
              "compact": "{spaceCalendarGridFocusOutlineGutter}"
            },
            "spaceCalendarGridGutter": {
              "comfortable": "6px",
              "compact": "6px"
            },
            "spaceCardHorizontalDefault": {
              "comfortable": "{spaceContainerHorizontal}",
              "compact": "{spaceContainerHorizontal}"
            },
            "spaceCardHorizontalEmbedded": {
              "comfortable": "{spaceS}",
              "compact": "10px"
            },
            "spaceCardVerticalDefault": {
              "comfortable": "{spaceScaledM}",
              "compact": "{spaceScaledM}"
            },
            "spaceCardVerticalEmbedded": {
              "comfortable": "10px",
              "compact": "{spaceXs}"
            },
            "spaceItemCardHorizontalDefault": {
              "comfortable": "{spaceCardHorizontalDefault}",
              "compact": "{spaceCardHorizontalDefault}"
            },
            "spaceItemCardHorizontalEmbedded": {
              "comfortable": "{spaceCardHorizontalEmbedded}",
              "compact": "{spaceCardHorizontalEmbedded}"
            },
            "spaceItemCardVerticalDefault": {
              "comfortable": "{spaceCardVerticalDefault}",
              "compact": "{spaceCardVerticalDefault}"
            },
            "spaceItemCardVerticalEmbedded": {
              "comfortable": "{spaceCardVerticalEmbedded}",
              "compact": "{spaceCardVerticalEmbedded}"
            },
            "spaceDialogHorizontal": {
              "comfortable": "{spaceCardHorizontalEmbedded}",
              "compact": "{spaceCardHorizontalEmbedded}"
            },
            "spaceDialogVertical": {
              "comfortable": "{spaceCardVerticalEmbedded}",
              "compact": "{spaceCardVerticalEmbedded}"
            },
            "spaceDialogActionBlock": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceDialogActionInline": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceDialogHeaderGap": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spaceDialogSectionGap": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceCodeEditorStatusFocusOutlineGutter": {
              "comfortable": "-7px",
              "compact": "-7px"
            },
            "spaceContainerContentTop": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceContainerHeaderTop": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceContainerHeaderBottom": {
              "comfortable": "{spaceScaledXs}",
              "compact": "{spaceScaledXs}"
            },
            "spaceContainerHorizontal": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceContentHeaderPaddingBottom": {
              "comfortable": "{spaceScaledM}",
              "compact": "{spaceScaledM}"
            },
            "spaceDarkHeaderOverlapDistance": {
              "comfortable": "36px",
              "compact": "32px"
            },
            "spaceExpandableSectionIconOffsetTop": {
              "comfortable": "{spaceScaled2xXxs}",
              "compact": "{spaceScaled2xXxs}"
            },
            "spaceFieldHorizontal": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceFieldIconOffset": {
              "comfortable": "36px",
              "compact": "36px"
            },
            "spaceFilteringTokenDismissButtonFocusOutlineGutter": {
              "comfortable": "-5px",
              "compact": "-5px"
            },
            "spaceFilteringTokenOperationSelectFocusOutlineGutter": {
              "comfortable": "-5px",
              "compact": "-5px"
            },
            "spaceFlashbarActionLeft": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceFlashbarDismissRight": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceFlashbarHorizontal": {
              "comfortable": "{spaceM}",
              "compact": "{spaceM}"
            },
            "spaceFlashbarVertical": {
              "comfortable": "{spaceScaledXs}",
              "compact": "{spaceScaledXs}"
            },
            "spaceGridGutter": {
              "comfortable": "{spaceL}",
              "compact": "{spaceM}"
            },
            "spaceKeyValueGap": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceLayoutContentBottom": {
              "comfortable": "{spaceScaled2xXxxl}",
              "compact": "{spaceScaled2xXxxl}"
            },
            "spaceLayoutContentHorizontal": {
              "comfortable": "{spaceScaled2xXl}",
              "compact": "{spaceScaled2xXl}"
            },
            "spaceLayoutToggleDiameter": {
              "comfortable": "36px",
              "compact": "36px"
            },
            "spaceLayoutTogglePadding": {
              "comfortable": "{spaceStaticS}",
              "compact": "{spaceStaticS}"
            },
            "spaceModalContentBottom": {
              "comfortable": "{spaceScaled2xM}",
              "compact": "{spaceScaled2xM}"
            },
            "spaceModalHorizontal": {
              "comfortable": "{spaceContainerHorizontal}",
              "compact": "{spaceContainerHorizontal}"
            },
            "spacePanelContentBottom": {
              "comfortable": "{spaceScaledXxxl}",
              "compact": "{spaceScaledXxxl}"
            },
            "spacePanelContentTop": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spacePanelDividerMarginHorizontal": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spacePanelHeaderVertical": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spacePanelNavLeft": {
              "comfortable": "28px",
              "compact": "28px"
            },
            "spacePanelSideLeft": {
              "comfortable": "28px",
              "compact": "28px"
            },
            "spacePanelSideRight": {
              "comfortable": "{spaceScaledXl}",
              "compact": "{spaceScaledXl}"
            },
            "spacePanelSplitTop": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spacePanelSplitBottom": {
              "comfortable": "{spaceScaledL}",
              "compact": "{spaceScaledL}"
            },
            "spaceSegmentedControlFocusOutlineGutter": {
              "comfortable": "6px",
              "compact": "6px"
            },
            "spaceTabsContentTop": {
              "comfortable": "{spaceScaledS}",
              "compact": "{spaceScaledS}"
            },
            "spaceTabsFocusOutlineGutter": {
              "comfortable": "-8px",
              "compact": "-8px"
            },
            "spaceTabsVertical": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceTableContentBottom": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceTableEmbeddedHeaderTop": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceTableFooterHorizontal": {
              "comfortable": "{spaceTableHeaderHorizontal}",
              "compact": "{spaceTableHeaderHorizontal}"
            },
            "spaceTableHeaderFocusOutlineGutter": {
              "comfortable": "0px",
              "compact": "-1px"
            },
            "spaceTableHeaderHorizontal": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceTableHeaderToolsBottom": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceTableHeaderToolsFullPageBottom": {
              "comfortable": "4px",
              "compact": "4px"
            },
            "spaceTableHorizontal": {
              "comfortable": "{spaceContainerHorizontal}",
              "compact": "{spaceContainerHorizontal}"
            },
            "spaceTreeViewIndentation": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceXl}"
            },
            "spaceSideNavigationItemDefaultGap": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceSideNavigationItemIconGap": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceTileGutter": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceM}"
            },
            "spaceActionCardHorizontalDefault": {
              "comfortable": "{spaceCardHorizontalDefault}",
              "compact": "{spaceCardHorizontalDefault}"
            },
            "spaceActionCardHorizontalEmbedded": {
              "comfortable": "{spaceCardHorizontalEmbedded}",
              "compact": "{spaceCardHorizontalEmbedded}"
            },
            "spaceActionCardVerticalDefault": {
              "comfortable": "{spaceCardVerticalDefault}",
              "compact": "{spaceCardVerticalDefault}"
            },
            "spaceActionCardVerticalEmbedded": {
              "comfortable": "{spaceCardVerticalEmbedded}",
              "compact": "{spaceCardVerticalEmbedded}"
            },
            "spaceActionCardDescriptionPaddingTop": {
              "comfortable": "{spaceScaledXxs}",
              "compact": "{spaceScaledXxs}"
            },
            "spaceActionCardContentPaddingTop": {
              "comfortable": "{spaceScaledXs}",
              "compact": "{spaceScaledXs}"
            },
            "spaceOptionPaddingVertical": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceOptionPaddingHorizontal": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceStatusIndicatorPaddingHorizontal": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xNone": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xXxxs": {
              "comfortable": "{spaceXxxs}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xXxs": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xXs": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceNone}"
            },
            "spaceScaled2xS": {
              "comfortable": "{spaceS}",
              "compact": "{spaceXxs}"
            },
            "spaceScaled2xM": {
              "comfortable": "{spaceM}",
              "compact": "{spaceXs}"
            },
            "spaceScaled2xL": {
              "comfortable": "{spaceL}",
              "compact": "{spaceS}"
            },
            "spaceScaled2xXl": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceM}"
            },
            "spaceScaled2xXxl": {
              "comfortable": "{spaceXxl}",
              "compact": "{spaceL}"
            },
            "spaceScaled2xXxxl": {
              "comfortable": "{spaceXxxl}",
              "compact": "{spaceXl}"
            },
            "spaceScaledNone": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaledXxxs": {
              "comfortable": "{spaceNone}",
              "compact": "{spaceNone}"
            },
            "spaceScaledXxs": {
              "comfortable": "{spaceXxxs}",
              "compact": "{spaceXxxs}"
            },
            "spaceScaledXs": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceScaledS": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spaceScaledM": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceScaledL": {
              "comfortable": "{spaceM}",
              "compact": "{spaceM}"
            },
            "spaceScaledXl": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceScaledXxl": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceXl}"
            },
            "spaceScaledXxxl": {
              "comfortable": "{spaceXxl}",
              "compact": "{spaceXxl}"
            },
            "spaceStaticXxxs": {
              "comfortable": "{spaceXxxs}",
              "compact": "{spaceXxxs}"
            },
            "spaceStaticXxs": {
              "comfortable": "{spaceXxs}",
              "compact": "{spaceXxs}"
            },
            "spaceStaticXs": {
              "comfortable": "{spaceXs}",
              "compact": "{spaceXs}"
            },
            "spaceStaticS": {
              "comfortable": "{spaceS}",
              "compact": "{spaceS}"
            },
            "spaceStaticM": {
              "comfortable": "{spaceM}",
              "compact": "{spaceM}"
            },
            "spaceStaticL": {
              "comfortable": "{spaceL}",
              "compact": "{spaceL}"
            },
            "spaceStaticXl": {
              "comfortable": "{spaceXl}",
              "compact": "{spaceXl}"
            },
            "spaceStaticXxl": {
              "comfortable": "{spaceXxl}",
              "compact": "{spaceXxl}"
            },
            "spaceStaticXxxl": {
              "comfortable": "{spaceXxxl}",
              "compact": "{spaceXxxl}"
            },
            "spaceNone": {
              "comfortable": "0px",
              "compact": "0px"
            },
            "spaceXxxs": {
              "comfortable": "2px",
              "compact": "2px"
            },
            "spaceXxs": {
              "comfortable": "4px",
              "compact": "4px"
            },
            "spaceXs": {
              "comfortable": "8px",
              "compact": "8px"
            },
            "spaceS": {
              "comfortable": "12px",
              "compact": "12px"
            },
            "spaceM": {
              "comfortable": "16px",
              "compact": "16px"
            },
            "spaceL": {
              "comfortable": "20px",
              "compact": "20px"
            },
            "spaceXl": {
              "comfortable": "24px",
              "compact": "24px"
            },
            "spaceXxl": {
              "comfortable": "32px",
              "compact": "32px"
            },
            "spaceXxxl": {
              "comfortable": "40px",
              "compact": "40px"
            },
            "sizeVerticalInput": {
              "comfortable": "28px",
              "compact": "28px"
            }
          }
        },
        "app-layout-toolbar": {
          "id": "app-layout-toolbar",
          "selector": ".awsui-context-app-layout-toolbar",
          "tokens": {
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral1000}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral1000}"
            }
          }
        },
        "top-navigation": {
          "id": "top-navigation",
          "selector": ".awsui-context-top-navigation",
          "tokens": {
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(0, 0, 0, 0.7)",
              "dark": "rgba(0, 0, 0, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral200}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(255, 255, 255, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundStatusIndicatorInfo}",
              "dark": "{colorBackgroundStatusIndicatorInfo}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "#03220d",
              "dark": "#03220d"
            },
            "colorBackgroundFlashbarError": {
              "light": "#460303",
              "dark": "#460303"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "#08144f",
              "dark": "#08144f"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "#372603",
              "dark": "#372603"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundPopover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorGreyOpaque25}",
              "dark": "{colorGreyOpaque25}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError1000}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo1000}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "#460303",
              "dark": "#460303"
            },
            "colorBackgroundAlertInfo": {
              "light": "#08144f",
              "dark": "#08144f"
            },
            "colorBackgroundAlertSuccess": {
              "light": "#03220d",
              "dark": "#03220d"
            },
            "colorBackgroundAlertWarning": {
              "light": "#372603",
              "dark": "#372603"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess1000}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning1000}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "#ff7a7a20",
              "dark": "#ff7a7a20"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "#fbd33220",
              "dark": "#fbd33220"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "#2bb53420",
              "dark": "#2bb53420"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "#5c7fff20",
              "dark": "#5c7fff20"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorIndigo400}",
              "dark": "{colorIndigo400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorIndigo500}",
              "dark": "{colorIndigo500}"
            },
            "colorBorderItemFocused": {
              "light": "{colorIndigo500}",
              "dark": "{colorIndigo500}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorTransparent}",
              "dark": "{colorTransparent}"
            },
            "colorBorderItemSelected": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorBorderItemFocused}",
              "dark": "{colorBorderItemFocused}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError500}",
              "dark": "{colorError500}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess300}",
              "dark": "{colorSuccess300}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning300}",
              "dark": "{colorWarning300}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorIndigo400}",
              "dark": "{colorIndigo400}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorIndigo300}",
              "dark": "{colorIndigo300}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple400}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextInverted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLinkHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "{colorTextLinkDecorationDefault}",
              "dark": "{colorTextLinkDecorationDefault}"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning300}",
              "dark": "{colorWarning300}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorBlack}",
              "dark": "{colorBlack}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundBadgeBlue": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundBadgeRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundBadgeYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextBadgeRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundCodeView": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 75, 20, 0.2)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(173, 92, 255, 0.2)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "rgba(49, 184, 0, 0.2)",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(0, 173, 162, 0.2)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(0, 153, 255, 0.2)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(133, 117, 255, 0.2)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 26, 224, 0.2)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 51, 153, 0.2)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(250, 111, 0, 0.2)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning200}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#ff997a",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#d4a8ff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#acff2e",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#00f5e4",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#b2a8ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#ff57e9",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#ff99cc",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#ffbb45",
              "dark": "#ffbb45"
            },
            "shadowCard": {
              "light": "none",
              "dark": "none"
            },
            "shadowItemCard": {
              "light": "{shadowCard}",
              "dark": "{shadowCard}"
            },
            "shadowContainer": {
              "light": "0px 1px 8px 2px rgba(0, 0, 0, 0.6)",
              "dark": "0px 1px 8px 2px rgba(0, 0, 0, 0.6)"
            },
            "shadowContainerActive": {
              "light": "0px 1px 1px 1px #222222, 0px 6px 36px #030303",
              "dark": "0px 1px 1px 1px #222222, 0px 6px 36px #030303"
            },
            "shadowDropdown": {
              "light": "0px 4px 20px 1px rgba(0, 0, 0, 1)",
              "dark": "0px 4px 20px 1px rgba(0, 0, 0, 1)"
            },
            "shadowDropup": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowFlashCollapsed": {
              "light": "0px 2px 4px rgba(0, 0, 0, 0.15)",
              "dark": "0px 2px 4px rgba(0, 0, 0, 0.15)"
            },
            "shadowFlashSticky": {
              "light": "0px 2px 4px rgba(0, 0, 0, 0.15)",
              "dark": "0px 2px 4px rgba(0, 0, 0, 0.15)"
            },
            "shadowModal": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowPanel": {
              "light": "0px 0px 0px 1px #4b4b4b",
              "dark": "0px 0px 0px 1px #4b4b4b"
            },
            "shadowPanelToggle": {
              "light": "0px 6px 12px 1px rgba(0, 0, 0, 1)",
              "dark": "0px 6px 12px 1px rgba(0, 0, 0, 1)"
            },
            "shadowPopover": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowSplitBottom": {
              "light": "0px -36px 36px -36px rgba(0, 0, 0, 1)",
              "dark": "0px -36px 36px -36px rgba(0, 0, 0, 1)"
            },
            "shadowSplitSide": {
              "light": "-1px 0px 1px 0px #222222, -36px 6px 36px -36px rgba(0, 0, 0, 1)",
              "dark": "-1px 0px 1px 0px #222222, -36px 6px 36px -36px rgba(0, 0, 0, 1)"
            },
            "shadowSticky": {
              "light": "0px 4px 8px 1px rgba(0, 0, 0, 0.5)",
              "dark": "0px 4px 8px 1px rgba(0, 0, 0, 0.5)"
            },
            "shadowStickyEmbedded": {
              "light": "0px 2px 0px 0px #4b4b4b, 0px 16px 16px -12px rgba(0, 0, 0, 1)",
              "dark": "0px 2px 0px 0px #4b4b4b, 0px 16px 16px -12px rgba(0, 0, 0, 1)"
            },
            "shadowStickyColumnFirst": {
              "light": "2px 4px 8px 1px rgba(0, 0, 0, 0.5)",
              "dark": "2px 4px 8px 1px rgba(0, 0, 0, 0.5)"
            },
            "shadowStickyColumnLast": {
              "light": "-2px 4px 8px 1px rgba(0, 0, 0, 0.5)",
              "dark": "-2px 4px 8px 1px rgba(0, 0, 0, 0.5)"
            },
            "colorPrimary50": "#f5f7ff",
            "colorPrimary100": "#dbe4ff",
            "colorPrimary200": "#c2d1ff",
            "colorPrimary300": "#94afff",
            "colorPrimary400": "#7598ff",
            "colorPrimary500": "#5c7fff",
            "colorPrimary600": "#295eff",
            "colorPrimary700": "#003efa",
            "colorPrimary800": "#0033cc",
            "colorPrimary900": "#001a99",
            "colorPrimary950": "#00204d",
            "colorPrimary1000": "#000833",
            "colorNeutral50": "#fcfcfc",
            "colorNeutral100": "#f9f9f9",
            "colorNeutral150": "#f8f8f7",
            "colorNeutral200": "#f3f3f1",
            "colorNeutral250": "#eeedeb",
            "colorNeutral300": "#e3e1de",
            "colorNeutral350": "#cbc9c3",
            "colorNeutral400": "#bab7b0",
            "colorNeutral450": "#aca9a2",
            "colorNeutral500": "#949088",
            "colorNeutral550": "#868279",
            "colorNeutral600": "#6f6b63",
            "colorNeutral650": "#4c4942",
            "colorNeutral700": "#3e3b35",
            "colorNeutral750": "#2f2d28",
            "colorNeutral800": "#262420",
            "colorNeutral850": "#201e1b",
            "colorNeutral900": "#1b1a17",
            "colorNeutral950": "#161512",
            "colorNeutral1000": "#100f0d",
            "colorError50": "#fff5f5",
            "colorError100": "#ffe0e0",
            "colorError300": "#ff9e9e",
            "colorError400": "#ff7a7a",
            "colorError500": "#ff3d3d",
            "colorError600": "#db0000",
            "colorError700": "#c20000",
            "colorError800": "#990000",
            "colorError900": "#700000",
            "colorError950": "#520000",
            "colorError1000": "#1f0000",
            "colorSuccess50": "#effff1",
            "colorSuccess100": "#d9ffd6",
            "colorSuccess200": "#aeffa8",
            "colorSuccess300": "#62ff57",
            "colorSuccess400": "#00e500",
            "colorSuccess500": "#2bb534",
            "colorSuccess600": "#00802f",
            "colorSuccess700": "#007029",
            "colorSuccess800": "#005c26",
            "colorSuccess950": "#003311",
            "colorSuccess1000": "#001401",
            "colorWarning50": "#fffde5",
            "colorWarning100": "#fffbbd",
            "colorWarning200": "#fff78a",
            "colorWarning300": "#fced69",
            "colorWarning400": "#fce255",
            "colorWarning500": "#fbd332",
            "colorWarning600": "#f2b100",
            "colorWarning800": "#9e6900",
            "colorWarning900": "#855900",
            "colorWarning950": "#573a00",
            "colorWarning1000": "#191100",
            "colorInfo50": "#f5f7ff",
            "colorInfo100": "#dbe4ff",
            "colorInfo300": "#94afff",
            "colorInfo400": "#7598ff",
            "colorInfo500": "#5c7fff",
            "colorInfo600": "#295eff",
            "colorInfo700": "#003efa",
            "colorInfo800": "#0033cc",
            "colorInfo900": "#001a99",
            "colorInfo950": "#001475",
            "colorInfo1000": "#000833",
            "colorChartsStatusNeutral": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorChartsThresholdNegative": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorChartsThresholdPositive": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorChartsThresholdInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo300}"
            },
            "colorChartsThresholdNeutral": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorChartsLineGrid": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineTick": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineAxis": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsErrorBarMarker": {
              "light": "{colorNeutral900}",
              "dark": "{colorWhite}"
            },
            "colorSeverityGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationSeverityNeutral": {
              "light": "{colorSeverityGrey}",
              "dark": "{colorSeverityGrey}"
            },
            "colorTextNotificationSeverityCritical": {
              "light": "{colorNeutral100}",
              "dark": "{colorBlack}"
            },
            "colorTextNotificationSeverityHigh": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityMedium": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityLow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityNeutral": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextBadgeSeverityCritical": {
              "light": "{colorTextNotificationSeverityCritical}",
              "dark": "{colorTextNotificationSeverityCritical}"
            },
            "colorTextBadgeSeverityHigh": {
              "light": "{colorTextNotificationSeverityHigh}",
              "dark": "{colorTextNotificationSeverityHigh}"
            },
            "colorTextBadgeSeverityMedium": {
              "light": "{colorTextNotificationSeverityMedium}",
              "dark": "{colorTextNotificationSeverityMedium}"
            },
            "colorTextBadgeSeverityLow": {
              "light": "{colorTextNotificationSeverityLow}",
              "dark": "{colorTextNotificationSeverityLow}"
            },
            "colorTextBadgeSeverityNeutral": {
              "light": "{colorTextNotificationSeverityNeutral}",
              "dark": "{colorTextNotificationSeverityNeutral}"
            }
          },
          "defaultMode": "dark"
        },
        "header": {
          "id": "header",
          "selector": ".awsui-context-content-header",
          "tokens": {
            "shadowCard": {
              "light": "none",
              "dark": "none"
            },
            "shadowItemCard": {
              "light": "{shadowCard}",
              "dark": "{shadowCard}"
            },
            "shadowContainer": {
              "light": "0px 1px 8px 2px rgba(0, 0, 0, 0.6)",
              "dark": "0px 1px 8px 2px rgba(0, 0, 0, 0.6)"
            },
            "shadowContainerActive": {
              "light": "0px 1px 1px 1px #222222, 0px 6px 36px #030303",
              "dark": "0px 1px 1px 1px #222222, 0px 6px 36px #030303"
            },
            "shadowDropdown": {
              "light": "0px 4px 20px 1px rgba(0, 0, 0, 1)",
              "dark": "0px 4px 20px 1px rgba(0, 0, 0, 1)"
            },
            "shadowDropup": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowFlashCollapsed": {
              "light": "0px 2px 4px rgba(0, 0, 0, 0.15)",
              "dark": "0px 2px 4px rgba(0, 0, 0, 0.15)"
            },
            "shadowFlashSticky": {
              "light": "0px 2px 4px rgba(0, 0, 0, 0.15)",
              "dark": "0px 2px 4px rgba(0, 0, 0, 0.15)"
            },
            "shadowModal": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowPanel": {
              "light": "0px 0px 0px 1px #4b4b4b",
              "dark": "0px 0px 0px 1px #4b4b4b"
            },
            "shadowPanelToggle": {
              "light": "0px 6px 12px 1px rgba(0, 0, 0, 1)",
              "dark": "0px 6px 12px 1px rgba(0, 0, 0, 1)"
            },
            "shadowPopover": {
              "light": "{shadowDropdown}",
              "dark": "{shadowDropdown}"
            },
            "shadowSplitBottom": {
              "light": "0px -36px 36px -36px rgba(0, 0, 0, 1)",
              "dark": "0px -36px 36px -36px rgba(0, 0, 0, 1)"
            },
            "shadowSplitSide": {
              "light": "-1px 0px 1px 0px #222222, -36px 6px 36px -36px rgba(0, 0, 0, 1)",
              "dark": "-1px 0px 1px 0px #222222, -36px 6px 36px -36px rgba(0, 0, 0, 1)"
            },
            "shadowSticky": {
              "light": "0px 4px 8px 1px rgba(0, 0, 0, 0.5)",
              "dark": "0px 4px 8px 1px rgba(0, 0, 0, 0.5)"
            },
            "shadowStickyEmbedded": {
              "light": "0px 2px 0px 0px #4b4b4b, 0px 16px 16px -12px rgba(0, 0, 0, 1)",
              "dark": "0px 2px 0px 0px #4b4b4b, 0px 16px 16px -12px rgba(0, 0, 0, 1)"
            },
            "shadowStickyColumnFirst": {
              "light": "2px 4px 8px 1px rgba(0, 0, 0, 0.5)",
              "dark": "2px 4px 8px 1px rgba(0, 0, 0, 0.5)"
            },
            "shadowStickyColumnLast": {
              "light": "-2px 4px 8px 1px rgba(0, 0, 0, 0.5)",
              "dark": "-2px 4px 8px 1px rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque10": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorGreyOpaque25": {
              "light": "rgba(255, 255, 255, 0.25)",
              "dark": "rgba(255, 255, 255, 0.25)"
            },
            "colorGreyOpaque40": {
              "light": "rgba(0, 0, 0, 0.4)",
              "dark": "rgba(0, 0, 0, 0.4)"
            },
            "colorGreyOpaque50": {
              "light": "rgba(0, 0, 0, 0.5)",
              "dark": "rgba(0, 0, 0, 0.5)"
            },
            "colorGreyOpaque70": {
              "light": "rgba(0, 0, 0, 0.7)",
              "dark": "rgba(0, 0, 0, 0.7)"
            },
            "colorGreyOpaque80": {
              "light": "rgba(22, 25, 31, 0.8)",
              "dark": "rgba(22, 25, 31, 0.8)"
            },
            "colorGreyOpaque90": {
              "light": "rgba(242, 243, 243, 0.9)",
              "dark": "rgba(242, 243, 243, 0.9)"
            },
            "colorGreyTransparent": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentHeavy": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorGreyTransparentLight": {
              "light": "rgba(15, 20, 26, 1)",
              "dark": "rgba(15, 20, 26, 1)"
            },
            "colorBackgroundBadgeIcon": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundButtonLinkActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonLinkDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkDisabled": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonLinkHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundButtonNormalDisabled": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleButtonNormalPressed": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundToggleButtonNormalDefault": {
              "light": "{colorBackgroundButtonNormalDefault}",
              "dark": "{colorBackgroundButtonNormalDefault}"
            },
            "colorBackgroundToggleButtonNormalHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundButtonPrimaryActive": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundButtonPrimaryDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundButtonPrimaryDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundButtonPrimaryHover": {
              "light": "{colorNeutral200}",
              "dark": "{colorNeutral200}"
            },
            "colorBackgroundDirectionButtonActive": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDirectionButtonDisabled": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBackgroundDirectionButtonHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextDirectionButtonDefault": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextDirectionButtonDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorBackgroundCalendarCurrentDate": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCellShaded": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundCodeEditorGutterActiveLineError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundCodeEditorGutterDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorLoading": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCodeEditorPaneItemHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundCodeEditorStatusBar": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundCard": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundItemCard": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundContainerContent": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundContainerHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundControlChecked": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundControlDisabled": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundDropdownItemDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundDropdownItemDimmed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundDropdownItemFilterMatch": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundDropdownItemHover": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorBackgroundDropdownItemSelected": {
              "light": "{colorBackgroundItemSelected}",
              "dark": "{colorBackgroundItemSelected}"
            },
            "colorBackgroundHomeHeader": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundInlineCode": {
              "light": "rgba(255, 255, 255, 0.1)",
              "dark": "rgba(255, 255, 255, 0.1)"
            },
            "colorBackgroundInputDefault": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundInputDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundItemSelected": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundSideNavigationItemActive": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSideNavigationItemActiveCollapsed": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundSideNavigationItemIconHover": {
              "light": "{colorBackgroundStatusIndicatorInfo}",
              "dark": "{colorBackgroundStatusIndicatorInfo}"
            },
            "colorBackgroundLayoutMain": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutAiDrawer": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundDrawer": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundBackdrop": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundDrawerBackdrop": {
              "light": "{colorBackgroundBackdrop}",
              "dark": "{colorBackgroundBackdrop}"
            },
            "colorBackgroundLayoutMobilePanel": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorBackgroundLayoutPanel": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundLayoutPanelContent": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorBackgroundLayoutPanelHover": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundLayoutToolbar": {
              "light": "{colorBackgroundLayoutPanelContent}",
              "dark": "{colorBackgroundLayoutPanelContent}"
            },
            "colorBackgroundLayoutToggleActive": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBackgroundLayoutToggleHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundLayoutToggleSelectedActive": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundLayoutToggleSelectedDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundLayoutToggleSelectedHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBackgroundModalOverlay": {
              "light": "{colorGreyOpaque70}",
              "dark": "{colorGreyOpaque70}"
            },
            "colorBackgroundNotificationBlue": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo600}"
            },
            "colorBackgroundNotificationGreen": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess600}"
            },
            "colorBackgroundNotificationGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationRed": {
              "light": "{colorError600}",
              "dark": "{colorError600}"
            },
            "colorBackgroundNotificationYellow": {
              "light": "{colorWarning400}",
              "dark": "{colorWarning400}"
            },
            "colorBackgroundFlashbarSuccess": {
              "light": "#03220d",
              "dark": "#03220d"
            },
            "colorBackgroundFlashbarError": {
              "light": "#460303",
              "dark": "#460303"
            },
            "colorBackgroundFlashbarInfo": {
              "light": "#08144f",
              "dark": "#08144f"
            },
            "colorBackgroundFlashbarWarning": {
              "light": "#372603",
              "dark": "#372603"
            },
            "colorBackgroundNotificationStackBar": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundNotificationStackBarActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundNotificationStackBarHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundPopover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundProgressBarValueDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundProgressBarValueFlash": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorBackgroundProgressBarFlash": {
              "light": "{colorGreyOpaque25}",
              "dark": "{colorGreyOpaque25}"
            },
            "colorBackgroundProgressBarDefault": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundSegmentActive": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundSegmentDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundSegmentDisabled": {
              "light": "{colorBackgroundButtonNormalDisabled}",
              "dark": "{colorBackgroundButtonNormalDisabled}"
            },
            "colorBackgroundSegmentHover": {
              "light": "{colorBackgroundButtonNormalHover}",
              "dark": "{colorBackgroundButtonNormalHover}"
            },
            "colorBackgroundSegmentWrapper": {
              "light": "{colorBackgroundContainerContent}",
              "dark": "{colorBackgroundContainerContent}"
            },
            "colorBackgroundSliderRangeDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundSliderRangeActive": {
              "light": "{colorBackgroundSliderHandleActive}",
              "dark": "{colorBackgroundSliderHandleActive}"
            },
            "colorBackgroundSliderHandleDefault": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBackgroundSliderHandleActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBackgroundSliderTrackDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSliderHandleRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundSliderHandleErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderHandleWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderHandleWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeErrorDefault": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeErrorActive": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorBackgroundSliderRangeWarningDefault": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundSliderRangeWarningActive": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorBackgroundStatusError": {
              "light": "{colorError1000}",
              "dark": "{colorError1000}"
            },
            "colorBackgroundStatusInfo": {
              "light": "{colorInfo1000}",
              "dark": "{colorInfo1000}"
            },
            "colorBackgroundAlertError": {
              "light": "#460303",
              "dark": "#460303"
            },
            "colorBackgroundAlertInfo": {
              "light": "#08144f",
              "dark": "#08144f"
            },
            "colorBackgroundAlertSuccess": {
              "light": "#03220d",
              "dark": "#03220d"
            },
            "colorBackgroundAlertWarning": {
              "light": "#372603",
              "dark": "#372603"
            },
            "colorBackgroundDialog": {
              "light": "{colorBackgroundStatusInfo}",
              "dark": "{colorBackgroundStatusInfo}"
            },
            "colorBackgroundDialogDefault": {
              "light": "{colorBackgroundCard}",
              "dark": "{colorBackgroundCard}"
            },
            "colorBackgroundStatusSuccess": {
              "light": "{colorSuccess1000}",
              "dark": "{colorSuccess1000}"
            },
            "colorBackgroundStatusWarning": {
              "light": "{colorWarning1000}",
              "dark": "{colorWarning1000}"
            },
            "colorBackgroundTableHeader": {
              "light": "{colorBackgroundContainerHeader}",
              "dark": "{colorBackgroundContainerHeader}"
            },
            "colorBackgroundTilesDisabled": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundToggleCheckedDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBackgroundToggleDefault": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBackgroundAvatarGenAi": {
              "light": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)",
              "dark": "radial-gradient(circle farthest-corner at top right, #b8e7ff 0%, #0099ff 25%, #5c7fff 40% , #8575ff 60%, #962eff 80%)"
            },
            "colorBackgroundAvatarDefault": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextAvatar": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorBackgroundLoadingBarGenAi": {
              "light": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)",
              "dark": "linear-gradient(90deg, #b8e7ff 0%, #0099ff 10%, #5c7fff 24%, #8575ff 50%, #962eff 76%, #0099ff 90%, #b8e7ff 100%)"
            },
            "colorBackgroundStatusIndicatorError": {
              "light": "#ff7a7a20",
              "dark": "#ff7a7a20"
            },
            "colorBackgroundStatusIndicatorWarning": {
              "light": "#fbd33220",
              "dark": "#fbd33220"
            },
            "colorBackgroundStatusIndicatorSuccess": {
              "light": "#2bb53420",
              "dark": "#2bb53420"
            },
            "colorBackgroundStatusIndicatorInfo": {
              "light": "#5c7fff20",
              "dark": "#5c7fff20"
            },
            "colorBackgroundStatusIndicatorNeutral": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundChatBubbleOutgoing": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundChatBubbleIncoming": {
              "light": "{colorNeutral900}",
              "dark": "{colorNeutral900}"
            },
            "colorTextChatBubbleOutgoing": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorTextChatBubbleIncoming": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderButtonLinkDisabled": {
              "light": "{colorBackgroundButtonLinkDisabled}",
              "dark": "{colorBackgroundButtonLinkDisabled}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderToggleButtonNormalPressed": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBorderToggleButtonNormalDefault": {
              "light": "{colorBorderButtonNormalDefault}",
              "dark": "{colorBorderButtonNormalDefault}"
            },
            "colorBorderToggleButtonNormalHover": {
              "light": "{colorBorderButtonNormalHover}",
              "dark": "{colorBorderButtonNormalHover}"
            },
            "colorBorderButtonNormalDisabled": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorTextButtonNormalDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextButtonIconDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderButtonPrimaryActive": {
              "light": "{colorBackgroundButtonPrimaryActive}",
              "dark": "{colorBackgroundButtonPrimaryActive}"
            },
            "colorBorderButtonPrimaryDefault": {
              "light": "{colorBackgroundButtonPrimaryDefault}",
              "dark": "{colorBackgroundButtonPrimaryDefault}"
            },
            "colorBorderButtonPrimaryDisabled": {
              "light": "{colorBackgroundButtonPrimaryDisabled}",
              "dark": "{colorBackgroundButtonPrimaryDisabled}"
            },
            "colorBorderButtonPrimaryHover": {
              "light": "{colorBackgroundButtonPrimaryHover}",
              "dark": "{colorBackgroundButtonPrimaryHover}"
            },
            "colorTextButtonPrimaryDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorItemSelected": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextSideNavigationItemActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextSideNavigationItemActiveCollapsed": {
              "light": "{colorNeutral1000}",
              "dark": "{colorNeutral1000}"
            },
            "colorTextSideNavigationItemDefault": {
              "light": "{colorTextBodyDefault}",
              "dark": "{colorTextBodyDefault}"
            },
            "colorBorderCalendarGrid": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderCalendarGridSelectedFocusRing": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBorderCellShaded": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderCodeEditorAceActiveLineLightTheme": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderCodeEditorAceActiveLineDarkTheme": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderCodeEditorPaneItemHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderCard": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderCardHighlighted": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderItemCard": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderItemCardHighlighted": {
              "light": "{colorBorderCardHighlighted}",
              "dark": "{colorBorderCardHighlighted}"
            },
            "colorBorderContainerDivider": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderContainerTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderControlChecked": {
              "light": "{colorBackgroundControlChecked}",
              "dark": "{colorBackgroundControlChecked}"
            },
            "colorBorderControlDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderControlDisabled": {
              "light": "{colorBackgroundControlDisabled}",
              "dark": "{colorBackgroundControlDisabled}"
            },
            "colorBorderDividerActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderDividerNotification": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDividerPanelBottom": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerPanelSide": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDividerSecondary": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBorderDividerTableGroup": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownContainer": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownGroup": {
              "light": "{colorBorderDropdownItemDefault}",
              "dark": "{colorBorderDropdownItemDefault}"
            },
            "colorBorderDropdownItemDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderDropdownItemHover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderDropdownItemDimmedHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderDropdownItemSelected": {
              "light": "{colorBorderItemSelected}",
              "dark": "{colorBorderItemSelected}"
            },
            "colorBorderDropdownItemTop": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderEditableCellHover": {
              "light": "{colorBorderDropdownItemHover}",
              "dark": "{colorBorderDropdownItemHover}"
            },
            "colorBorderInputDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderInputDisabled": {
              "light": "{colorBackgroundInputDisabled}",
              "dark": "{colorBackgroundInputDisabled}"
            },
            "colorBorderInputFocused": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderItemFocused": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBorderDropdownItemFocused": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderItemPlaceholder": {
              "light": "{colorTransparent}",
              "dark": "{colorTransparent}"
            },
            "colorBorderItemSelected": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorBorderLayout": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderLayoutSideNavigation": {
              "light": "{colorBorderLayout}",
              "dark": "{colorBorderLayout}"
            },
            "colorBorderNotificationStackBar": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderNotificationStackBarHover": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderNotificationStackBarActive": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorBorderNotificationStackBarFocused": {
              "light": "{colorBorderItemFocused}",
              "dark": "{colorBorderItemFocused}"
            },
            "colorBorderPanelHeader": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorBorderPopover": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBorderSegmentActive": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBorderSegmentDisabled": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentDivider": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderSegmentHover": {
              "light": "{colorBorderSegmentDefault}",
              "dark": "{colorBorderSegmentDefault}"
            },
            "colorBorderSegmentWrapper": {
              "light": "{colorBorderInputDefault}",
              "dark": "{colorBorderInputDefault}"
            },
            "colorBorderStatusError": {
              "light": "{colorError500}",
              "dark": "{colorError500}"
            },
            "colorBorderStatusInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorBorderStatusSuccess": {
              "light": "{colorSuccess300}",
              "dark": "{colorSuccess300}"
            },
            "colorBorderStatusWarning": {
              "light": "{colorWarning300}",
              "dark": "{colorWarning300}"
            },
            "colorBorderDialog": {
              "light": "{colorBorderStatusInfo}",
              "dark": "{colorBorderStatusInfo}"
            },
            "colorBorderDialogDefault": {
              "light": "{colorBorderCard}",
              "dark": "{colorBorderCard}"
            },
            "colorBorderDividerInteractiveDefault": {
              "light": "{colorNeutral750}",
              "dark": "{colorNeutral750}"
            },
            "colorBorderTabsDivider": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorBorderTabsShadow": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorBorderTabsUnderline": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorBorderTilesDisabled": {
              "light": "{colorBackgroundTilesDisabled}",
              "dark": "{colorBackgroundTilesDisabled}"
            },
            "colorBorderTutorial": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorForegroundControlDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorForegroundControlDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorForegroundControlReadOnly": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorShadowDefault": {
              "light": "{colorGreyTransparentHeavy}",
              "dark": "{colorGreyTransparentHeavy}"
            },
            "colorShadowMedium": {
              "light": "{colorGreyTransparent}",
              "dark": "{colorGreyTransparent}"
            },
            "colorShadowSide": {
              "light": "{colorGreyTransparentLight}",
              "dark": "{colorGreyTransparentLight}"
            },
            "colorShadowToggleHandle": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorStrokeChartLine": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorStrokeCodeEditorGutterActiveLineDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorStrokeCodeEditorGutterActiveLineHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextAccent": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextBodyDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextBodySecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextBreadcrumbCurrent": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextBreadcrumbIcon": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextButtonInlineIconDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextButtonInlineIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonInlineLinkHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonIconHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextToggleButtonNormalPressed": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextLinkButtonNormalDefault": {
              "light": "{colorTextButtonNormalDefault}",
              "dark": "{colorTextButtonNormalDefault}"
            },
            "colorTextLinkButtonNormalHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextLinkButtonNormalActive": {
              "light": "{colorTextButtonNormalActive}",
              "dark": "{colorTextButtonNormalActive}"
            },
            "colorTextButtonLinkActive": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextButtonLinkDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextButtonLinkDisabled": {
              "light": "{colorNeutral650}",
              "dark": "{colorNeutral650}"
            },
            "colorTextButtonLinkHover": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextButtonPrimaryActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryDefault": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextButtonPrimaryHover": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCalendarDateHover": {
              "light": "{colorTextDropdownItemDefault}",
              "dark": "{colorTextDropdownItemDefault}"
            },
            "colorTextCalendarDateSelected": {
              "light": "{colorBackgroundControlDefault}",
              "dark": "{colorBackgroundControlDefault}"
            },
            "colorTextCalendarMonth": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextCodeEditorGutterActiveLine": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextCodeEditorGutterDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextCodeEditorStatusBarDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextCodeEditorTabButtonError": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextColumnHeader": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextColumnSortingIcon": {
              "light": "{colorTextColumnHeader}",
              "dark": "{colorTextColumnHeader}"
            },
            "colorTextControlDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextCounter": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextDisabledInlineEdit": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextDropdownFooter": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownGroupLabel": {
              "light": "{colorTextGroupLabel}",
              "dark": "{colorTextGroupLabel}"
            },
            "colorTextDropdownItemDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextDropdownItemDimmed": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextDropdownItemFilterMatch": {
              "light": "{colorPrimary500}",
              "dark": "{colorPrimary500}"
            },
            "colorTextDropdownItemHighlighted": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextDropdownItemSecondary": {
              "light": "{colorTextFormSecondary}",
              "dark": "{colorTextFormSecondary}"
            },
            "colorTextDropdownItemSecondaryHover": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextEmpty": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextExpandableSectionHover": {
              "light": "{colorTextAccent}",
              "dark": "{colorTextAccent}"
            },
            "colorTextExpandableSectionNavigationIconDefault": {
              "light": "{colorTextInteractiveDefault}",
              "dark": "{colorTextInteractiveDefault}"
            },
            "colorBorderExpandableSectionDefault": {
              "light": "{colorBorderDividerDefault}",
              "dark": "{colorBorderDividerDefault}"
            },
            "colorTextFormDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextFormLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextFormSecondary": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextGroupLabel": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLabelGenAi": {
              "light": "{colorPurple400}",
              "dark": "{colorPurple400}"
            },
            "colorTextHeadingDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHeadingSecondary": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextHomeHeaderDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextHomeHeaderSecondary": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextIconCaret": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextIconSubtle": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextInputDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInputPlaceholder": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextInputPlaceholderDisabled": {
              "light": "{colorTextInputDisabled}",
              "dark": "{colorTextInputDisabled}"
            },
            "colorTextInteractiveActive": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextInteractiveDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextInteractiveHover": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextToggleButtonIconPressed": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextInteractiveInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextInverted": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLabel": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextKeyValuePairsValue": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLayoutToggle": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLayoutToggleActive": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextLayoutToggleHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLayoutToggleSelected": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextLinkDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLinkHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkDecorationDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorTextLinkDecorationHover": {
              "light": "currentColor",
              "dark": "currentColor"
            },
            "colorTextLinkSecondaryDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextLinkSecondaryHover": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkSecondaryDecorationDefault": {
              "light": "{colorTextLinkDecorationDefault}",
              "dark": "{colorTextLinkDecorationDefault}"
            },
            "colorTextLinkInfoDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextLinkInfoHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextLinkButtonUnderline": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextLinkButtonUnderlineHover": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextNotificationDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextAlertDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextNotificationLinkDefault": {
              "light": "{colorNeutral250}",
              "dark": "{colorNeutral250}"
            },
            "colorTextNotificationLinkHover": {
              "light": "{colorWhite}",
              "dark": "{colorWhite}"
            },
            "colorTextNotificationStackBar": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorTextNotificationYellow": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextPaginationPageNumberActiveDisabled": {
              "light": "{colorTextInteractiveDisabled}",
              "dark": "{colorTextInteractiveDisabled}"
            },
            "colorTextPaginationPageNumberDefault": {
              "light": "{colorNeutral400}",
              "dark": "{colorNeutral400}"
            },
            "colorTextSegmentActive": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextSegmentDefault": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextSegmentHover": {
              "light": "{colorTextButtonNormalHover}",
              "dark": "{colorTextButtonNormalHover}"
            },
            "colorTextSmall": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextFlashbarIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextFlashbarIconInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextFlashbarIconSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextFlashbarIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextAlertIconError": {
              "light": "{colorTextStatusError}",
              "dark": "{colorTextStatusError}"
            },
            "colorTextAlertIconInfo": {
              "light": "{colorInfo400}",
              "dark": "{colorInfo400}"
            },
            "colorTextAlertIconSuccess": {
              "light": "{colorSuccess500}",
              "dark": "{colorSuccess500}"
            },
            "colorTextAlertIconWarning": {
              "light": "{colorTextStatusWarning}",
              "dark": "{colorTextStatusWarning}"
            },
            "colorTextStatusError": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextStatusInactive": {
              "light": "{colorNeutral450}",
              "dark": "{colorNeutral450}"
            },
            "colorTextStatusInfo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextStatusSuccess": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextStatusWarning": {
              "light": "{colorWarning300}",
              "dark": "{colorWarning300}"
            },
            "colorTextTopNavigationTitle": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextTutorialHotspotDefault": {
              "light": "{colorTextLinkDefault}",
              "dark": "{colorTextLinkDefault}"
            },
            "colorTextTutorialHotspotHover": {
              "light": "{colorTextLinkHover}",
              "dark": "{colorTextLinkHover}"
            },
            "colorBoardPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBoardPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDragPlaceholderActive": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDragPlaceholderHover": {
              "light": "{colorPrimary600}",
              "dark": "{colorPrimary600}"
            },
            "colorDropzoneBackgroundDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorDropzoneBackgroundHover": {
              "light": "{colorPrimary1000}",
              "dark": "{colorPrimary1000}"
            },
            "colorDropzoneTextDefault": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneTextHover": {
              "light": "{colorNeutral350}",
              "dark": "{colorNeutral350}"
            },
            "colorDropzoneBorderDefault": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorDropzoneBorderHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorGapGlobalDrawer": {
              "light": "{colorBlack}",
              "dark": "{colorBlack}"
            },
            "colorTreeViewConnectorLine": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorBackgroundActionCardDefault": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorBackgroundActionCardHover": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundActionCardActive": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderActionCardDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorBorderActionCardHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorBorderActionCardDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundActionCardDisabled": {
              "light": "{colorNeutral850}",
              "dark": "{colorNeutral850}"
            },
            "colorTextActionCardDisabled": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorTextActionCardIconDefault": {
              "light": "{colorPrimary400}",
              "dark": "{colorPrimary400}"
            },
            "colorTextActionCardIconHover": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconActive": {
              "light": "{colorPrimary300}",
              "dark": "{colorPrimary300}"
            },
            "colorTextActionCardIconDisabled": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeleton": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundSkeletonWave": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundBadgeGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundBadgeBlue": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundBadgeRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundBadgeYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundBadgeGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBorderBadge": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGrey": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeGreen": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeBlue": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBorderBadgeRed": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorTextBadgeGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextBadgeGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextBadgeBlue": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextBadgeRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorBackgroundCodeView": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral800}"
            },
            "colorBackgroundVisualAccentRed": {
              "light": "rgba(255, 61, 61, 0.2)",
              "dark": "rgba(255, 61, 61, 0.2)"
            },
            "colorBackgroundVisualAccentYellow": {
              "light": "rgba(251, 211, 50, 0.2)",
              "dark": "rgba(251, 211, 50, 0.2)"
            },
            "colorBackgroundVisualAccentIndigo": {
              "light": "rgba(92, 127, 255, 0.2)",
              "dark": "rgba(92, 127, 255, 0.2)"
            },
            "colorBackgroundVisualAccentGreen": {
              "light": "rgba(43, 181, 52, 0.2)",
              "dark": "rgba(43, 181, 52, 0.2)"
            },
            "colorBackgroundVisualAccentOrange": {
              "light": "rgba(255, 75, 20, 0.2)",
              "dark": "rgba(255, 75, 20, 0.2)"
            },
            "colorBackgroundVisualAccentPurple": {
              "light": "rgba(173, 92, 255, 0.2)",
              "dark": "rgba(173, 92, 255, 0.2)"
            },
            "colorBackgroundVisualAccentLime": {
              "light": "rgba(49, 184, 0, 0.2)",
              "dark": "rgba(49, 184, 0, 0.2)"
            },
            "colorBackgroundVisualAccentGrey": {
              "light": "{colorNeutral700}",
              "dark": "{colorNeutral700}"
            },
            "colorBackgroundVisualAccentTeal": {
              "light": "rgba(0, 173, 162, 0.2)",
              "dark": "rgba(0, 173, 162, 0.2)"
            },
            "colorBackgroundVisualAccentBlue": {
              "light": "rgba(0, 153, 255, 0.2)",
              "dark": "rgba(0, 153, 255, 0.2)"
            },
            "colorBackgroundVisualAccentViolet": {
              "light": "rgba(133, 117, 255, 0.2)",
              "dark": "rgba(133, 117, 255, 0.2)"
            },
            "colorBackgroundVisualAccentMagenta": {
              "light": "rgba(255, 26, 224, 0.2)",
              "dark": "rgba(255, 26, 224, 0.2)"
            },
            "colorBackgroundVisualAccentPink": {
              "light": "rgba(255, 51, 153, 0.2)",
              "dark": "rgba(255, 51, 153, 0.2)"
            },
            "colorBackgroundVisualAccentAmber": {
              "light": "rgba(250, 111, 0, 0.2)",
              "dark": "rgba(250, 111, 0, 0.2)"
            },
            "colorTextVisualAccentRed": {
              "light": "{colorError400}",
              "dark": "{colorError400}"
            },
            "colorTextVisualAccentYellow": {
              "light": "{colorWarning200}",
              "dark": "{colorWarning200}"
            },
            "colorTextVisualAccentIndigo": {
              "light": "{colorInfo300}",
              "dark": "{colorInfo300}"
            },
            "colorTextVisualAccentGreen": {
              "light": "{colorSuccess200}",
              "dark": "{colorSuccess200}"
            },
            "colorTextVisualAccentOrange": {
              "light": "#ff997a",
              "dark": "#ff997a"
            },
            "colorTextVisualAccentPurple": {
              "light": "#d4a8ff",
              "dark": "#d4a8ff"
            },
            "colorTextVisualAccentLime": {
              "light": "#acff2e",
              "dark": "#acff2e"
            },
            "colorTextVisualAccentGrey": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral300}"
            },
            "colorTextVisualAccentTeal": {
              "light": "#00f5e4",
              "dark": "#00f5e4"
            },
            "colorTextVisualAccentBlue": {
              "light": "#75cfff",
              "dark": "#75cfff"
            },
            "colorTextVisualAccentViolet": {
              "light": "#b2a8ff",
              "dark": "#b2a8ff"
            },
            "colorTextVisualAccentMagenta": {
              "light": "#ff57e9",
              "dark": "#ff57e9"
            },
            "colorTextVisualAccentPink": {
              "light": "#ff99cc",
              "dark": "#ff99cc"
            },
            "colorTextVisualAccentAmber": {
              "light": "#ffbb45",
              "dark": "#ffbb45"
            },
            "colorPrimary50": "#f5f7ff",
            "colorPrimary100": "#dbe4ff",
            "colorPrimary200": "#c2d1ff",
            "colorPrimary300": "#94afff",
            "colorPrimary400": "#7598ff",
            "colorPrimary500": "#5c7fff",
            "colorPrimary600": "#295eff",
            "colorPrimary700": "#003efa",
            "colorPrimary800": "#0033cc",
            "colorPrimary900": "#001a99",
            "colorPrimary950": "#00204d",
            "colorPrimary1000": "#000833",
            "colorNeutral50": "#fcfcfc",
            "colorNeutral100": "#f9f9f9",
            "colorNeutral150": "#f8f8f7",
            "colorNeutral200": "#f3f3f1",
            "colorNeutral250": "#eeedeb",
            "colorNeutral300": "#e3e1de",
            "colorNeutral350": "#cbc9c3",
            "colorNeutral400": "#bab7b0",
            "colorNeutral450": "#aca9a2",
            "colorNeutral500": "#949088",
            "colorNeutral550": "#868279",
            "colorNeutral600": "#6f6b63",
            "colorNeutral650": "#4c4942",
            "colorNeutral700": "#3e3b35",
            "colorNeutral750": "#2f2d28",
            "colorNeutral800": "#262420",
            "colorNeutral850": "#201e1b",
            "colorNeutral900": "#1b1a17",
            "colorNeutral950": "#161512",
            "colorNeutral1000": "#100f0d",
            "colorError50": "#fff5f5",
            "colorError100": "#ffe0e0",
            "colorError300": "#ff9e9e",
            "colorError400": "#ff7a7a",
            "colorError500": "#ff3d3d",
            "colorError600": "#db0000",
            "colorError700": "#c20000",
            "colorError800": "#990000",
            "colorError900": "#700000",
            "colorError950": "#520000",
            "colorError1000": "#1f0000",
            "colorSuccess50": "#effff1",
            "colorSuccess100": "#d9ffd6",
            "colorSuccess200": "#aeffa8",
            "colorSuccess300": "#62ff57",
            "colorSuccess400": "#00e500",
            "colorSuccess500": "#2bb534",
            "colorSuccess600": "#00802f",
            "colorSuccess700": "#007029",
            "colorSuccess800": "#005c26",
            "colorSuccess950": "#003311",
            "colorSuccess1000": "#001401",
            "colorWarning50": "#fffde5",
            "colorWarning100": "#fffbbd",
            "colorWarning200": "#fff78a",
            "colorWarning300": "#fced69",
            "colorWarning400": "#fce255",
            "colorWarning500": "#fbd332",
            "colorWarning600": "#f2b100",
            "colorWarning800": "#9e6900",
            "colorWarning900": "#855900",
            "colorWarning950": "#573a00",
            "colorWarning1000": "#191100",
            "colorInfo50": "#f5f7ff",
            "colorInfo100": "#dbe4ff",
            "colorInfo300": "#94afff",
            "colorInfo400": "#7598ff",
            "colorInfo500": "#5c7fff",
            "colorInfo600": "#295eff",
            "colorInfo700": "#003efa",
            "colorInfo800": "#0033cc",
            "colorInfo900": "#001a99",
            "colorInfo950": "#001475",
            "colorInfo1000": "#000833",
            "colorChartsStatusNeutral": {
              "light": "{colorNeutral500}",
              "dark": "{colorNeutral500}"
            },
            "colorChartsThresholdNegative": {
              "light": "{colorError600}",
              "dark": "{colorError400}"
            },
            "colorChartsThresholdPositive": {
              "light": "{colorSuccess600}",
              "dark": "{colorSuccess500}"
            },
            "colorChartsThresholdInfo": {
              "light": "{colorInfo600}",
              "dark": "{colorInfo300}"
            },
            "colorChartsThresholdNeutral": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral450}"
            },
            "colorChartsLineGrid": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineTick": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsLineAxis": {
              "light": "{colorNeutral300}",
              "dark": "{colorNeutral650}"
            },
            "colorChartsErrorBarMarker": {
              "light": "{colorNeutral900}",
              "dark": "{colorWhite}"
            },
            "colorSeverityGrey": {
              "light": "{colorNeutral600}",
              "dark": "{colorNeutral600}"
            },
            "colorBackgroundNotificationSeverityNeutral": {
              "light": "{colorSeverityGrey}",
              "dark": "{colorSeverityGrey}"
            },
            "colorTextNotificationSeverityCritical": {
              "light": "{colorNeutral100}",
              "dark": "{colorBlack}"
            },
            "colorTextNotificationSeverityHigh": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityMedium": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityLow": {
              "light": "{colorNeutral950}",
              "dark": "{colorNeutral950}"
            },
            "colorTextNotificationSeverityNeutral": {
              "light": "{colorNeutral100}",
              "dark": "{colorNeutral100}"
            },
            "colorTextBadgeSeverityCritical": {
              "light": "{colorTextNotificationSeverityCritical}",
              "dark": "{colorTextNotificationSeverityCritical}"
            },
            "colorTextBadgeSeverityHigh": {
              "light": "{colorTextNotificationSeverityHigh}",
              "dark": "{colorTextNotificationSeverityHigh}"
            },
            "colorTextBadgeSeverityMedium": {
              "light": "{colorTextNotificationSeverityMedium}",
              "dark": "{colorTextNotificationSeverityMedium}"
            },
            "colorTextBadgeSeverityLow": {
              "light": "{colorTextNotificationSeverityLow}",
              "dark": "{colorTextNotificationSeverityLow}"
            },
            "colorTextBadgeSeverityNeutral": {
              "light": "{colorTextNotificationSeverityNeutral}",
              "dark": "{colorTextNotificationSeverityNeutral}"
            }
          },
          "defaultMode": "dark"
        },
        "flashbar": {
          "id": "flashbar",
          "selector": ".awsui-context-flashbar",
          "tokens": {
            "colorTextBodyDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral250}"
            },
            "colorTextLinkDefault": {
              "light": "{colorTextNotificationLinkDefault}",
              "dark": "{colorTextNotificationLinkDefault}"
            },
            "colorTextLinkHover": {
              "light": "{colorTextNotificationLinkHover}",
              "dark": "{colorTextNotificationLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorTextNotificationLinkHover}",
              "dark": "{colorTextNotificationLinkHover}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorBorderDividerNotification}",
              "dark": "{colorBorderDividerNotification}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorTextInteractiveInvertedHover}",
              "dark": "{colorTextInteractiveInvertedHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorTextInteractiveInvertedHover}",
              "dark": "{colorTextInteractiveInvertedHover}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(0, 0, 0, 0.05)",
              "dark": "rgba(0, 0, 0, 0.05)"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorBorderItemFocused": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedHover}"
            }
          }
        },
        "flashbar-warning": {
          "id": "flashbar-warning",
          "selector": ".awsui-context-flashbar-warning",
          "tokens": {
            "colorTextBodyDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral250}"
            },
            "colorTextLinkDefault": {
              "light": "{colorTextNotificationLinkDefault}",
              "dark": "{colorTextNotificationLinkDefault}"
            },
            "colorTextLinkHover": {
              "light": "{colorTextNotificationLinkHover}",
              "dark": "{colorTextNotificationLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorTextNotificationLinkHover}",
              "dark": "{colorTextNotificationLinkHover}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorBorderDividerNotification}",
              "dark": "{colorBorderDividerNotification}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorTextInteractiveInvertedHover}",
              "dark": "{colorTextInteractiveInvertedHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorTextInteractiveInvertedHover}",
              "dark": "{colorTextInteractiveInvertedHover}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(0, 0, 0, 0.05)",
              "dark": "rgba(0, 0, 0, 0.05)"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorBorderItemFocused": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedHover}"
            }
          }
        },
        "alert": {
          "id": "alert",
          "selector": ".awsui-context-alert",
          "tokens": {
            "colorTextBodyDefault": {
              "light": "{colorNeutral800}",
              "dark": "{colorNeutral250}"
            },
            "colorTextLinkDefault": {
              "light": "{colorTextNotificationLinkDefault}",
              "dark": "{colorTextNotificationLinkDefault}"
            },
            "colorTextLinkHover": {
              "light": "{colorTextNotificationLinkHover}",
              "dark": "{colorTextNotificationLinkHover}"
            },
            "colorTextLinkInvertedDefault": {
              "light": "{colorTextNotificationDefault}",
              "dark": "{colorTextNotificationDefault}"
            },
            "colorTextLinkInvertedHover": {
              "light": "{colorTextNotificationLinkHover}",
              "dark": "{colorTextNotificationLinkHover}"
            },
            "colorBorderDividerDefault": {
              "light": "{colorBorderDividerNotification}",
              "dark": "{colorBorderDividerNotification}"
            },
            "colorTextButtonNormalDefault": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorTextButtonNormalHover": {
              "light": "{colorTextInteractiveInvertedHover}",
              "dark": "{colorTextInteractiveInvertedHover}"
            },
            "colorTextButtonNormalActive": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBorderButtonNormalDefault": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBorderButtonNormalHover": {
              "light": "{colorTextInteractiveInvertedHover}",
              "dark": "{colorTextInteractiveInvertedHover}"
            },
            "colorBorderButtonNormalActive": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedDefault}"
            },
            "colorBackgroundButtonNormalDefault": {
              "light": "transparent",
              "dark": "transparent"
            },
            "colorBackgroundButtonNormalHover": {
              "light": "rgba(0, 0, 0, 0.05)",
              "dark": "rgba(0, 0, 0, 0.05)"
            },
            "colorBackgroundButtonNormalActive": {
              "light": "rgba(0, 0, 0, 0.1)",
              "dark": "rgba(0, 0, 0, 0.1)"
            },
            "colorBorderItemFocused": {
              "light": "{colorTextInteractiveInvertedDefault}",
              "dark": "{colorTextInteractiveInvertedHover}"
            }
          }
        }
      },
      "tokenModeMap": {
        "colorPrimary50": "color",
        "colorPrimary100": "color",
        "colorPrimary200": "color",
        "colorPrimary300": "color",
        "colorPrimary400": "color",
        "colorPrimary500": "color",
        "colorPrimary600": "color",
        "colorPrimary700": "color",
        "colorPrimary800": "color",
        "colorPrimary900": "color",
        "colorPrimary950": "color",
        "colorPrimary1000": "color",
        "colorNeutral50": "color",
        "colorNeutral100": "color",
        "colorNeutral150": "color",
        "colorNeutral200": "color",
        "colorNeutral250": "color",
        "colorNeutral300": "color",
        "colorNeutral350": "color",
        "colorNeutral400": "color",
        "colorNeutral450": "color",
        "colorNeutral500": "color",
        "colorNeutral550": "color",
        "colorNeutral600": "color",
        "colorNeutral650": "color",
        "colorNeutral700": "color",
        "colorNeutral750": "color",
        "colorNeutral800": "color",
        "colorNeutral850": "color",
        "colorNeutral900": "color",
        "colorNeutral950": "color",
        "colorNeutral1000": "color",
        "colorError50": "color",
        "colorError100": "color",
        "colorError300": "color",
        "colorError400": "color",
        "colorError500": "color",
        "colorError600": "color",
        "colorError700": "color",
        "colorError800": "color",
        "colorError900": "color",
        "colorError950": "color",
        "colorError1000": "color",
        "colorSuccess50": "color",
        "colorSuccess100": "color",
        "colorSuccess200": "color",
        "colorSuccess300": "color",
        "colorSuccess400": "color",
        "colorSuccess500": "color",
        "colorSuccess600": "color",
        "colorSuccess700": "color",
        "colorSuccess800": "color",
        "colorSuccess950": "color",
        "colorSuccess1000": "color",
        "colorWarning50": "color",
        "colorWarning100": "color",
        "colorWarning200": "color",
        "colorWarning300": "color",
        "colorWarning400": "color",
        "colorWarning500": "color",
        "colorWarning600": "color",
        "colorWarning800": "color",
        "colorWarning900": "color",
        "colorWarning950": "color",
        "colorWarning1000": "color",
        "colorInfo50": "color",
        "colorInfo100": "color",
        "colorInfo300": "color",
        "colorInfo400": "color",
        "colorInfo500": "color",
        "colorInfo600": "color",
        "colorInfo700": "color",
        "colorInfo800": "color",
        "colorInfo900": "color",
        "colorInfo950": "color",
        "colorInfo1000": "color",
        "colorGrey50": "color",
        "colorGrey100": "color",
        "colorGrey150": "color",
        "colorGrey200": "color",
        "colorGrey250": "color",
        "colorGrey300": "color",
        "colorGrey350": "color",
        "colorGrey400": "color",
        "colorGrey450": "color",
        "colorGrey500": "color",
        "colorGrey600": "color",
        "colorGrey650": "color",
        "colorGrey700": "color",
        "colorGrey750": "color",
        "colorGrey800": "color",
        "colorGrey850": "color",
        "colorGrey900": "color",
        "colorGrey950": "color",
        "colorGrey1000": "color",
        "colorBlue50": "color",
        "colorBlue100": "color",
        "colorBlue200": "color",
        "colorBlue300": "color",
        "colorBlue400": "color",
        "colorBlue600": "color",
        "colorBlue700": "color",
        "colorBlue900": "color",
        "colorBlue1000": "color",
        "colorGreen50": "color",
        "colorGreen500": "color",
        "colorGreen600": "color",
        "colorGreen900": "color",
        "colorGreen1000": "color",
        "colorRed50": "color",
        "colorRed400": "color",
        "colorRed600": "color",
        "colorRed900": "color",
        "colorRed1000": "color",
        "colorYellow50": "color",
        "colorYellow400": "color",
        "colorYellow500": "color",
        "colorYellow900": "color",
        "colorYellow1000": "color",
        "colorPurple400": "color",
        "colorPurple700": "color",
        "colorAmber400": "color",
        "colorAmber500": "color",
        "colorRed950": "color",
        "colorOrange50": "color",
        "colorOrange100": "color",
        "colorOrange400": "color",
        "colorOrange700": "color",
        "colorOrange800": "color",
        "colorOrange950": "color",
        "colorYellow600": "color",
        "colorYellow950": "color",
        "colorLime50": "color",
        "colorLime100": "color",
        "colorLime400": "color",
        "colorLime700": "color",
        "colorLime800": "color",
        "colorLime950": "color",
        "colorGreen400": "color",
        "colorGreen950": "color",
        "colorMint50": "color",
        "colorMint100": "color",
        "colorMint400": "color",
        "colorMint700": "color",
        "colorMint800": "color",
        "colorMint950": "color",
        "colorIndigo50": "color",
        "colorIndigo400": "color",
        "colorIndigo600": "color",
        "colorIndigo950": "color",
        "colorPurple50": "color",
        "colorPurple100": "color",
        "colorPurple600": "color",
        "colorPurple800": "color",
        "colorPurple950": "color",
        "colorTeal50": "color",
        "colorTeal100": "color",
        "colorTeal400": "color",
        "colorTeal700": "color",
        "colorTeal800": "color",
        "colorTeal950": "color",
        "colorCyan50": "color",
        "colorCyan100": "color",
        "colorCyan400": "color",
        "colorCyan700": "color",
        "colorCyan800": "color",
        "colorCyan950": "color",
        "colorBlue950": "color",
        "colorViolet50": "color",
        "colorViolet100": "color",
        "colorViolet400": "color",
        "colorViolet700": "color",
        "colorViolet800": "color",
        "colorViolet950": "color",
        "colorFuchsia50": "color",
        "colorFuchsia100": "color",
        "colorFuchsia400": "color",
        "colorFuchsia700": "color",
        "colorFuchsia800": "color",
        "colorFuchsia950": "color",
        "colorMagenta50": "color",
        "colorMagenta100": "color",
        "colorMagenta400": "color",
        "colorMagenta700": "color",
        "colorMagenta800": "color",
        "colorMagenta950": "color",
        "colorPink50": "color",
        "colorPink100": "color",
        "colorPink400": "color",
        "colorPink700": "color",
        "colorPink800": "color",
        "colorPink950": "color",
        "colorRose50": "color",
        "colorRose100": "color",
        "colorRose400": "color",
        "colorRose700": "color",
        "colorRose800": "color",
        "colorRose950": "color",
        "colorAmber50": "color",
        "colorAmber100": "color",
        "colorAmber700": "color",
        "colorAmber800": "color",
        "colorAmber950": "color",
        "colorAwsSquidInk": "color",
        "colorTransparent": "color",
        "colorBlack": "color",
        "colorWhite": "color",
        "colorNeutralGrey50": "color",
        "colorNeutralGrey100": "color",
        "colorNeutralGrey150": "color",
        "colorNeutralGrey200": "color",
        "colorNeutralGrey250": "color",
        "colorNeutralGrey300": "color",
        "colorNeutralGrey350": "color",
        "colorNeutralGrey400": "color",
        "colorNeutralGrey450": "color",
        "colorNeutralGrey500": "color",
        "colorNeutralGrey550": "color",
        "colorNeutralGrey600": "color",
        "colorNeutralGrey650": "color",
        "colorNeutralGrey700": "color",
        "colorNeutralGrey750": "color",
        "colorNeutralGrey800": "color",
        "colorNeutralGrey850": "color",
        "colorNeutralGrey900": "color",
        "colorNeutralGrey950": "color",
        "colorNeutralGrey1000": "color",
        "colorIndigo100": "color",
        "colorIndigo200": "color",
        "colorIndigo300": "color",
        "colorIndigo500": "color",
        "colorIndigo700": "color",
        "colorIndigo800": "color",
        "colorIndigo900": "color",
        "colorIndigo1000": "color",
        "colorGreen200": "color",
        "colorGreen700": "color",
        "colorOneThemeYellow50": "color",
        "colorOneThemeYellow300": "color",
        "colorOneThemeYellow400": "color",
        "colorOneThemeYellow500": "color",
        "colorOneThemeYellow800": "color",
        "colorOneThemeYellow900": "color",
        "colorOneThemeYellow1000": "color",
        "colorChartsRed300": "color",
        "colorChartsRed400": "color",
        "colorChartsRed500": "color",
        "colorChartsRed600": "color",
        "colorChartsRed700": "color",
        "colorChartsRed800": "color",
        "colorChartsRed900": "color",
        "colorChartsRed1000": "color",
        "colorChartsRed1100": "color",
        "colorChartsRed1200": "color",
        "colorChartsOrange300": "color",
        "colorChartsOrange400": "color",
        "colorChartsOrange500": "color",
        "colorChartsOrange600": "color",
        "colorChartsOrange700": "color",
        "colorChartsOrange800": "color",
        "colorChartsOrange900": "color",
        "colorChartsOrange1000": "color",
        "colorChartsOrange1100": "color",
        "colorChartsOrange1200": "color",
        "colorChartsYellow300": "color",
        "colorChartsYellow400": "color",
        "colorChartsYellow500": "color",
        "colorChartsYellow600": "color",
        "colorChartsYellow700": "color",
        "colorChartsYellow800": "color",
        "colorChartsYellow900": "color",
        "colorChartsYellow1000": "color",
        "colorChartsYellow1100": "color",
        "colorChartsYellow1200": "color",
        "colorChartsGreen300": "color",
        "colorChartsGreen400": "color",
        "colorChartsGreen500": "color",
        "colorChartsGreen600": "color",
        "colorChartsGreen700": "color",
        "colorChartsGreen800": "color",
        "colorChartsGreen900": "color",
        "colorChartsGreen1000": "color",
        "colorChartsGreen1100": "color",
        "colorChartsGreen1200": "color",
        "colorChartsTeal300": "color",
        "colorChartsTeal400": "color",
        "colorChartsTeal500": "color",
        "colorChartsTeal600": "color",
        "colorChartsTeal700": "color",
        "colorChartsTeal800": "color",
        "colorChartsTeal900": "color",
        "colorChartsTeal1000": "color",
        "colorChartsTeal1100": "color",
        "colorChartsTeal1200": "color",
        "colorChartsBlue1300": "color",
        "colorChartsBlue1400": "color",
        "colorChartsBlue1500": "color",
        "colorChartsBlue1600": "color",
        "colorChartsBlue1700": "color",
        "colorChartsBlue1800": "color",
        "colorChartsBlue1900": "color",
        "colorChartsBlue11000": "color",
        "colorChartsBlue11100": "color",
        "colorChartsBlue11200": "color",
        "colorChartsBlue2300": "color",
        "colorChartsBlue2400": "color",
        "colorChartsBlue2500": "color",
        "colorChartsBlue2600": "color",
        "colorChartsBlue2700": "color",
        "colorChartsBlue2800": "color",
        "colorChartsBlue2900": "color",
        "colorChartsBlue21000": "color",
        "colorChartsBlue21100": "color",
        "colorChartsBlue21200": "color",
        "colorChartsPurple300": "color",
        "colorChartsPurple400": "color",
        "colorChartsPurple500": "color",
        "colorChartsPurple600": "color",
        "colorChartsPurple700": "color",
        "colorChartsPurple800": "color",
        "colorChartsPurple900": "color",
        "colorChartsPurple1000": "color",
        "colorChartsPurple1100": "color",
        "colorChartsPurple1200": "color",
        "colorChartsPink300": "color",
        "colorChartsPink400": "color",
        "colorChartsPink500": "color",
        "colorChartsPink600": "color",
        "colorChartsPink700": "color",
        "colorChartsPink800": "color",
        "colorChartsPink900": "color",
        "colorChartsPink1000": "color",
        "colorChartsPink1100": "color",
        "colorChartsPink1200": "color",
        "colorChartsStatusCritical": "color",
        "colorChartsStatusHigh": "color",
        "colorChartsStatusMedium": "color",
        "colorChartsStatusLow": "color",
        "colorChartsStatusPositive": "color",
        "colorChartsStatusInfo": "color",
        "colorChartsStatusNeutral": "color",
        "colorChartsThresholdNegative": "color",
        "colorChartsThresholdPositive": "color",
        "colorChartsThresholdInfo": "color",
        "colorChartsThresholdNeutral": "color",
        "colorChartsLineGrid": "color",
        "colorChartsLineTick": "color",
        "colorChartsLineAxis": "color",
        "colorChartsPaletteCategorical1": "color",
        "colorChartsPaletteCategorical2": "color",
        "colorChartsPaletteCategorical3": "color",
        "colorChartsPaletteCategorical4": "color",
        "colorChartsPaletteCategorical5": "color",
        "colorChartsPaletteCategorical6": "color",
        "colorChartsPaletteCategorical7": "color",
        "colorChartsPaletteCategorical8": "color",
        "colorChartsPaletteCategorical9": "color",
        "colorChartsPaletteCategorical10": "color",
        "colorChartsPaletteCategorical11": "color",
        "colorChartsPaletteCategorical12": "color",
        "colorChartsPaletteCategorical13": "color",
        "colorChartsPaletteCategorical14": "color",
        "colorChartsPaletteCategorical15": "color",
        "colorChartsPaletteCategorical16": "color",
        "colorChartsPaletteCategorical17": "color",
        "colorChartsPaletteCategorical18": "color",
        "colorChartsPaletteCategorical19": "color",
        "colorChartsPaletteCategorical20": "color",
        "colorChartsPaletteCategorical21": "color",
        "colorChartsPaletteCategorical22": "color",
        "colorChartsPaletteCategorical23": "color",
        "colorChartsPaletteCategorical24": "color",
        "colorChartsPaletteCategorical25": "color",
        "colorChartsPaletteCategorical26": "color",
        "colorChartsPaletteCategorical27": "color",
        "colorChartsPaletteCategorical28": "color",
        "colorChartsPaletteCategorical29": "color",
        "colorChartsPaletteCategorical30": "color",
        "colorChartsPaletteCategorical31": "color",
        "colorChartsPaletteCategorical32": "color",
        "colorChartsPaletteCategorical33": "color",
        "colorChartsPaletteCategorical34": "color",
        "colorChartsPaletteCategorical35": "color",
        "colorChartsPaletteCategorical36": "color",
        "colorChartsPaletteCategorical37": "color",
        "colorChartsPaletteCategorical38": "color",
        "colorChartsPaletteCategorical39": "color",
        "colorChartsPaletteCategorical40": "color",
        "colorChartsPaletteCategorical41": "color",
        "colorChartsPaletteCategorical42": "color",
        "colorChartsPaletteCategorical43": "color",
        "colorChartsPaletteCategorical44": "color",
        "colorChartsPaletteCategorical45": "color",
        "colorChartsPaletteCategorical46": "color",
        "colorChartsPaletteCategorical47": "color",
        "colorChartsPaletteCategorical48": "color",
        "colorChartsPaletteCategorical49": "color",
        "colorChartsPaletteCategorical50": "color",
        "colorChartsErrorBarMarker": "color",
        "colorSeverityDarkRed": "color",
        "colorSeverityRed": "color",
        "colorSeverityOrange": "color",
        "colorSeverityYellow": "color",
        "colorSeverityGrey": "color",
        "colorBackgroundNotificationSeverityCritical": "color",
        "colorBackgroundNotificationSeverityHigh": "color",
        "colorBackgroundNotificationSeverityMedium": "color",
        "colorBackgroundNotificationSeverityLow": "color",
        "colorBackgroundNotificationSeverityNeutral": "color",
        "colorTextNotificationSeverityCritical": "color",
        "colorTextNotificationSeverityHigh": "color",
        "colorTextNotificationSeverityMedium": "color",
        "colorTextNotificationSeverityLow": "color",
        "colorTextNotificationSeverityNeutral": "color",
        "colorBorderBadgeSeverityCritical": "color",
        "colorBorderBadgeSeverityHigh": "color",
        "colorBorderBadgeSeverityMedium": "color",
        "colorBorderBadgeSeverityLow": "color",
        "colorBorderBadgeSeverityNeutral": "color",
        "colorTextBadgeSeverityCritical": "color",
        "colorTextBadgeSeverityHigh": "color",
        "colorTextBadgeSeverityMedium": "color",
        "colorTextBadgeSeverityLow": "color",
        "colorTextBadgeSeverityNeutral": "color",
        "colorGreyOpaque10": "color",
        "colorGreyOpaque25": "color",
        "colorGreyOpaque40": "color",
        "colorGreyOpaque50": "color",
        "colorGreyOpaque70": "color",
        "colorGreyOpaque80": "color",
        "colorGreyOpaque90": "color",
        "colorGreyTransparent": "color",
        "colorGreyTransparentHeavy": "color",
        "colorGreyTransparentLight": "color",
        "colorBackgroundBadgeIcon": "color",
        "colorBackgroundButtonLinkActive": "color",
        "colorBackgroundButtonLinkDefault": "color",
        "colorBackgroundButtonLinkDisabled": "color",
        "colorBackgroundButtonLinkHover": "color",
        "colorBackgroundButtonNormalActive": "color",
        "colorBackgroundButtonNormalDefault": "color",
        "colorBackgroundButtonNormalDisabled": "color",
        "colorBackgroundButtonNormalHover": "color",
        "colorBackgroundToggleButtonNormalPressed": "color",
        "colorBackgroundToggleButtonNormalDefault": "color",
        "colorBackgroundToggleButtonNormalHover": "color",
        "colorBackgroundButtonPrimaryActive": "color",
        "colorBackgroundButtonPrimaryDefault": "color",
        "colorBackgroundButtonPrimaryDisabled": "color",
        "colorBackgroundButtonPrimaryHover": "color",
        "colorBackgroundDirectionButtonActive": "color",
        "colorBackgroundDirectionButtonDefault": "color",
        "colorBackgroundDirectionButtonDisabled": "color",
        "colorBackgroundDirectionButtonHover": "color",
        "colorTextDirectionButtonDefault": "color",
        "colorTextDirectionButtonDisabled": "color",
        "colorBackgroundCalendarCurrentDate": "color",
        "colorBackgroundCellShaded": "color",
        "colorBackgroundCodeEditorGutterActiveLineDefault": "color",
        "colorBackgroundCodeEditorGutterActiveLineError": "color",
        "colorBackgroundCodeEditorGutterDefault": "color",
        "colorBackgroundCodeEditorLoading": "color",
        "colorBackgroundCodeEditorPaneItemHover": "color",
        "colorBackgroundCodeEditorStatusBar": "color",
        "colorBackgroundCard": "color",
        "colorBackgroundItemCard": "color",
        "colorBackgroundContainerContent": "color",
        "colorBackgroundContainerHeader": "color",
        "colorBackgroundControlChecked": "color",
        "colorBackgroundControlDefault": "color",
        "colorBackgroundControlDisabled": "color",
        "colorBackgroundDropdownItemDefault": "color",
        "colorBackgroundDropdownItemDimmed": "color",
        "colorBackgroundDropdownItemFilterMatch": "color",
        "colorBackgroundDropdownItemHover": "color",
        "colorBackgroundDropdownItemSelected": "color",
        "colorBackgroundHomeHeader": "color",
        "colorBackgroundInlineCode": "color",
        "colorBackgroundInputDefault": "color",
        "colorBackgroundInputDisabled": "color",
        "colorBackgroundItemSelected": "color",
        "colorBackgroundSideNavigationItemActive": "color",
        "colorBackgroundSideNavigationItemActiveCollapsed": "color",
        "colorBackgroundSideNavigationItemIconHover": "color",
        "colorBackgroundLayoutMain": "color",
        "colorBackgroundLayoutAiDrawer": "color",
        "colorBackgroundDrawer": "color",
        "colorBackgroundBackdrop": "color",
        "colorBackgroundDrawerBackdrop": "color",
        "colorBackgroundLayoutMobilePanel": "color",
        "colorBackgroundLayoutPanel": "color",
        "colorBackgroundLayoutPanelContent": "color",
        "colorBackgroundLayoutPanelHover": "color",
        "colorBackgroundLayoutToolbar": "color",
        "colorBackgroundLayoutToggleActive": "color",
        "colorBackgroundLayoutToggleDefault": "color",
        "colorBackgroundLayoutToggleHover": "color",
        "colorBackgroundLayoutToggleSelectedActive": "color",
        "colorBackgroundLayoutToggleSelectedDefault": "color",
        "colorBackgroundLayoutToggleSelectedHover": "color",
        "colorBackgroundModalOverlay": "color",
        "colorBackgroundNotificationBlue": "color",
        "colorBackgroundNotificationGreen": "color",
        "colorBackgroundNotificationGrey": "color",
        "colorBackgroundNotificationRed": "color",
        "colorBackgroundNotificationYellow": "color",
        "colorBackgroundFlashbarSuccess": "color",
        "colorBackgroundFlashbarError": "color",
        "colorBackgroundFlashbarInfo": "color",
        "colorBackgroundFlashbarWarning": "color",
        "colorBackgroundNotificationStackBar": "color",
        "colorBackgroundNotificationStackBarActive": "color",
        "colorBackgroundNotificationStackBarHover": "color",
        "colorBackgroundPopover": "color",
        "colorBackgroundProgressBarValueDefault": "color",
        "colorBackgroundProgressBarValueFlash": "color",
        "colorBackgroundProgressBarFlash": "color",
        "colorBackgroundProgressBarDefault": "color",
        "colorBackgroundSegmentActive": "color",
        "colorBackgroundSegmentDefault": "color",
        "colorBackgroundSegmentDisabled": "color",
        "colorBackgroundSegmentHover": "color",
        "colorBackgroundSegmentWrapper": "color",
        "colorBackgroundSliderRangeDefault": "color",
        "colorBackgroundSliderRangeActive": "color",
        "colorBackgroundSliderHandleDefault": "color",
        "colorBackgroundSliderHandleActive": "color",
        "colorBackgroundSliderTrackDefault": "color",
        "colorBackgroundSliderHandleRing": "color",
        "colorBackgroundSliderHandleErrorDefault": "color",
        "colorBackgroundSliderHandleErrorActive": "color",
        "colorBackgroundSliderHandleWarningDefault": "color",
        "colorBackgroundSliderHandleWarningActive": "color",
        "colorBackgroundSliderRangeErrorDefault": "color",
        "colorBackgroundSliderRangeErrorActive": "color",
        "colorBackgroundSliderRangeWarningDefault": "color",
        "colorBackgroundSliderRangeWarningActive": "color",
        "colorBackgroundStatusError": "color",
        "colorBackgroundStatusInfo": "color",
        "colorBackgroundAlertError": "color",
        "colorBackgroundAlertInfo": "color",
        "colorBackgroundAlertSuccess": "color",
        "colorBackgroundAlertWarning": "color",
        "colorBackgroundDialog": "color",
        "colorBackgroundDialogDefault": "color",
        "colorBackgroundStatusSuccess": "color",
        "colorBackgroundStatusWarning": "color",
        "colorBackgroundTableHeader": "color",
        "colorBackgroundTilesDisabled": "color",
        "colorBackgroundToggleCheckedDisabled": "color",
        "colorBackgroundToggleDefault": "color",
        "colorBackgroundAvatarGenAi": "color",
        "colorBackgroundAvatarDefault": "color",
        "colorTextAvatar": "color",
        "colorBackgroundLoadingBarGenAi": "color",
        "colorBackgroundStatusIndicatorError": "color",
        "colorBackgroundStatusIndicatorWarning": "color",
        "colorBackgroundStatusIndicatorSuccess": "color",
        "colorBackgroundStatusIndicatorInfo": "color",
        "colorBackgroundStatusIndicatorNeutral": "color",
        "colorBackgroundChatBubbleOutgoing": "color",
        "colorBackgroundChatBubbleIncoming": "color",
        "colorTextChatBubbleOutgoing": "color",
        "colorTextChatBubbleIncoming": "color",
        "colorBorderButtonLinkDisabled": "color",
        "colorBorderButtonNormalActive": "color",
        "colorBorderButtonNormalDefault": "color",
        "colorBorderToggleButtonNormalPressed": "color",
        "colorBorderToggleButtonNormalDefault": "color",
        "colorBorderToggleButtonNormalHover": "color",
        "colorBorderButtonNormalDisabled": "color",
        "colorTextButtonNormalDisabled": "color",
        "colorBorderButtonNormalHover": "color",
        "colorTextButtonIconDisabled": "color",
        "colorBorderButtonPrimaryActive": "color",
        "colorBorderButtonPrimaryDefault": "color",
        "colorBorderButtonPrimaryDisabled": "color",
        "colorBorderButtonPrimaryHover": "color",
        "colorTextButtonPrimaryDisabled": "color",
        "colorItemSelected": "color",
        "colorTextSideNavigationItemActive": "color",
        "colorTextSideNavigationItemActiveCollapsed": "color",
        "colorTextSideNavigationItemDefault": "color",
        "colorBorderCalendarGrid": "color",
        "colorBorderCalendarGridSelectedFocusRing": "color",
        "colorBorderCellShaded": "color",
        "colorBorderCodeEditorAceActiveLineLightTheme": "color",
        "colorBorderCodeEditorAceActiveLineDarkTheme": "color",
        "colorBorderCodeEditorDefault": "color",
        "colorBorderCodeEditorPaneItemHover": "color",
        "colorBorderCard": "color",
        "colorBorderCardHighlighted": "color",
        "colorBorderItemCard": "color",
        "colorBorderItemCardHighlighted": "color",
        "colorBorderContainerDivider": "color",
        "colorBorderContainerTop": "color",
        "colorBorderControlChecked": "color",
        "colorBorderControlDefault": "color",
        "colorBorderControlDisabled": "color",
        "colorBorderDividerActive": "color",
        "colorBorderDividerDefault": "color",
        "colorBorderDividerNotification": "color",
        "colorBorderDividerPanelBottom": "color",
        "colorBorderDividerPanelSide": "color",
        "colorBorderDividerSecondary": "color",
        "colorBorderDividerTableGroup": "color",
        "colorBorderDropdownContainer": "color",
        "colorBorderDropdownGroup": "color",
        "colorBorderDropdownItemDefault": "color",
        "colorBorderDropdownItemHover": "color",
        "colorBorderDropdownItemDimmedHover": "color",
        "colorBorderDropdownItemSelected": "color",
        "colorBorderDropdownItemTop": "color",
        "colorBorderEditableCellHover": "color",
        "colorBorderInputDefault": "color",
        "colorBorderInputDisabled": "color",
        "colorBorderInputFocused": "color",
        "colorBorderItemFocused": "color",
        "colorBorderDropdownItemFocused": "color",
        "colorBorderItemPlaceholder": "color",
        "colorBorderItemSelected": "color",
        "colorBorderLayout": "color",
        "colorBorderLayoutSideNavigation": "color",
        "colorBorderNotificationStackBar": "color",
        "colorBorderNotificationStackBarHover": "color",
        "colorBorderNotificationStackBarActive": "color",
        "colorBorderNotificationStackBarFocused": "color",
        "colorBorderPanelHeader": "color",
        "colorBorderPopover": "color",
        "colorBorderSegmentActive": "color",
        "colorBorderSegmentDefault": "color",
        "colorBorderSegmentDisabled": "color",
        "colorBorderSegmentDivider": "color",
        "colorBorderSegmentHover": "color",
        "colorBorderSegmentWrapper": "color",
        "colorBorderStatusError": "color",
        "colorBorderStatusInfo": "color",
        "colorBorderStatusSuccess": "color",
        "colorBorderStatusWarning": "color",
        "colorBorderDialog": "color",
        "colorBorderDialogDefault": "color",
        "colorBorderDividerInteractiveDefault": "color",
        "colorBorderTabsDivider": "color",
        "colorBorderTabsShadow": "color",
        "colorBorderTabsUnderline": "color",
        "colorBorderTilesDisabled": "color",
        "colorBorderTutorial": "color",
        "colorForegroundControlDefault": "color",
        "colorForegroundControlDisabled": "color",
        "colorForegroundControlReadOnly": "color",
        "colorShadowDefault": "color",
        "colorShadowMedium": "color",
        "colorShadowSide": "color",
        "colorShadowToggleHandle": "color",
        "colorStrokeChartLine": "color",
        "colorStrokeCodeEditorGutterActiveLineDefault": "color",
        "colorStrokeCodeEditorGutterActiveLineHover": "color",
        "colorTextAccent": "color",
        "colorTextBodyDefault": "color",
        "colorTextBodySecondary": "color",
        "colorTextBreadcrumbCurrent": "color",
        "colorTextBreadcrumbIcon": "color",
        "colorTextButtonInlineIconDefault": "color",
        "colorTextButtonInlineIconDisabled": "color",
        "colorTextButtonInlineIconHover": "color",
        "colorTextButtonInlineLinkHover": "color",
        "colorTextButtonIconHover": "color",
        "colorTextButtonNormalActive": "color",
        "colorTextToggleButtonNormalPressed": "color",
        "colorTextButtonNormalDefault": "color",
        "colorTextButtonNormalHover": "color",
        "colorTextLinkButtonNormalDefault": "color",
        "colorTextLinkButtonNormalHover": "color",
        "colorTextLinkButtonNormalActive": "color",
        "colorTextButtonLinkActive": "color",
        "colorTextButtonLinkDefault": "color",
        "colorTextButtonLinkDisabled": "color",
        "colorTextButtonLinkHover": "color",
        "colorTextButtonPrimaryActive": "color",
        "colorTextButtonPrimaryDefault": "color",
        "colorTextButtonPrimaryHover": "color",
        "colorTextCalendarDateHover": "color",
        "colorTextCalendarDateSelected": "color",
        "colorTextCalendarMonth": "color",
        "colorTextCodeEditorGutterActiveLine": "color",
        "colorTextCodeEditorGutterDefault": "color",
        "colorTextCodeEditorStatusBarDisabled": "color",
        "colorTextCodeEditorTabButtonError": "color",
        "colorTextColumnHeader": "color",
        "colorTextColumnSortingIcon": "color",
        "colorTextControlDisabled": "color",
        "colorTextCounter": "color",
        "colorTextDisabled": "color",
        "colorTextDisabledInlineEdit": "color",
        "colorTextDropdownFooter": "color",
        "colorTextDropdownGroupLabel": "color",
        "colorTextDropdownItemDefault": "color",
        "colorTextDropdownItemDimmed": "color",
        "colorTextDropdownItemDisabled": "color",
        "colorTextDropdownItemFilterMatch": "color",
        "colorTextDropdownItemHighlighted": "color",
        "colorTextDropdownItemSecondary": "color",
        "colorTextDropdownItemSecondaryHover": "color",
        "colorTextEmpty": "color",
        "colorTextExpandableSectionDefault": "color",
        "colorTextExpandableSectionHover": "color",
        "colorTextExpandableSectionNavigationIconDefault": "color",
        "colorBorderExpandableSectionDefault": "color",
        "colorTextFormDefault": "color",
        "colorTextFormLabel": "color",
        "colorTextFormSecondary": "color",
        "colorTextGroupLabel": "color",
        "colorTextLabelGenAi": "color",
        "colorTextHeadingDefault": "color",
        "colorTextHeadingSecondary": "color",
        "colorTextHomeHeaderDefault": "color",
        "colorTextHomeHeaderSecondary": "color",
        "colorTextIconCaret": "color",
        "colorTextIconSubtle": "color",
        "colorTextInputDisabled": "color",
        "colorTextInputPlaceholder": "color",
        "colorTextInputPlaceholderDisabled": "color",
        "colorTextInteractiveActive": "color",
        "colorTextInteractiveDefault": "color",
        "colorTextInteractiveDisabled": "color",
        "colorTextInteractiveHover": "color",
        "colorTextToggleButtonIconPressed": "color",
        "colorTextInteractiveInvertedDefault": "color",
        "colorTextInteractiveInvertedHover": "color",
        "colorTextInverted": "color",
        "colorTextLabel": "color",
        "colorTextKeyValuePairsValue": "color",
        "colorTextLayoutToggle": "color",
        "colorTextLayoutToggleActive": "color",
        "colorTextLayoutToggleHover": "color",
        "colorTextLayoutToggleSelected": "color",
        "colorTextLinkDefault": "color",
        "colorTextLinkHover": "color",
        "colorTextLinkDecorationDefault": "color",
        "colorTextLinkDecorationHover": "color",
        "colorTextLinkSecondaryDefault": "color",
        "colorTextLinkSecondaryHover": "color",
        "colorTextLinkSecondaryDecorationDefault": "color",
        "colorTextLinkInfoDefault": "color",
        "colorTextLinkInfoHover": "color",
        "colorTextLinkInvertedDefault": "color",
        "colorTextLinkInvertedHover": "color",
        "colorTextLinkButtonUnderline": "color",
        "colorTextLinkButtonUnderlineHover": "color",
        "colorTextNotificationDefault": "color",
        "colorTextAlertDefault": "color",
        "colorTextNotificationLinkDefault": "color",
        "colorTextNotificationLinkHover": "color",
        "colorTextNotificationStackBar": "color",
        "colorTextNotificationYellow": "color",
        "colorTextPaginationPageNumberActiveDisabled": "color",
        "colorTextPaginationPageNumberDefault": "color",
        "colorTextSegmentActive": "color",
        "colorTextSegmentDefault": "color",
        "colorTextSegmentHover": "color",
        "colorTextSmall": "color",
        "colorTextFlashbarIconError": "color",
        "colorTextFlashbarIconInfo": "color",
        "colorTextFlashbarIconSuccess": "color",
        "colorTextFlashbarIconWarning": "color",
        "colorTextAlertIconError": "color",
        "colorTextAlertIconInfo": "color",
        "colorTextAlertIconSuccess": "color",
        "colorTextAlertIconWarning": "color",
        "colorTextStatusError": "color",
        "colorTextStatusInactive": "color",
        "colorTextStatusInfo": "color",
        "colorTextStatusSuccess": "color",
        "colorTextStatusWarning": "color",
        "colorTextTopNavigationTitle": "color",
        "colorTextTutorialHotspotDefault": "color",
        "colorTextTutorialHotspotHover": "color",
        "colorBoardPlaceholderActive": "color",
        "colorBoardPlaceholderHover": "color",
        "colorDragPlaceholderActive": "color",
        "colorDragPlaceholderHover": "color",
        "colorDropzoneBackgroundDefault": "color",
        "colorDropzoneBackgroundHover": "color",
        "colorDropzoneTextDefault": "color",
        "colorDropzoneTextHover": "color",
        "colorDropzoneBorderDefault": "color",
        "colorDropzoneBorderHover": "color",
        "colorGapGlobalDrawer": "color",
        "colorTreeViewConnectorLine": "color",
        "colorBackgroundActionCardDefault": "color",
        "colorBackgroundActionCardHover": "color",
        "colorBackgroundActionCardActive": "color",
        "colorBorderActionCardDefault": "color",
        "colorBorderActionCardHover": "color",
        "colorBorderActionCardActive": "color",
        "colorBorderActionCardDisabled": "color",
        "colorBackgroundActionCardDisabled": "color",
        "colorTextActionCardDisabled": "color",
        "colorTextActionCardIconDefault": "color",
        "colorTextActionCardIconHover": "color",
        "colorTextActionCardIconActive": "color",
        "colorTextActionCardIconDisabled": "color",
        "colorBackgroundSkeleton": "color",
        "colorBackgroundSkeletonWave": "color",
        "colorBackgroundBadgeGreen": "color",
        "colorBackgroundBadgeBlue": "color",
        "colorBackgroundBadgeRed": "color",
        "colorBackgroundBadgeYellow": "color",
        "colorBackgroundBadgeGrey": "color",
        "colorBorderBadge": "color",
        "colorBorderBadgeGrey": "color",
        "colorBorderBadgeGreen": "color",
        "colorBorderBadgeBlue": "color",
        "colorBorderBadgeRed": "color",
        "colorTextBadgeGrey": "color",
        "colorTextBadgeGreen": "color",
        "colorTextBadgeBlue": "color",
        "colorTextBadgeRed": "color",
        "colorBackgroundCodeView": "color",
        "colorBackgroundVisualAccentRed": "color",
        "colorBackgroundVisualAccentYellow": "color",
        "colorBackgroundVisualAccentIndigo": "color",
        "colorBackgroundVisualAccentGreen": "color",
        "colorBackgroundVisualAccentOrange": "color",
        "colorBackgroundVisualAccentPurple": "color",
        "colorBackgroundVisualAccentLime": "color",
        "colorBackgroundVisualAccentGrey": "color",
        "colorBackgroundVisualAccentTeal": "color",
        "colorBackgroundVisualAccentBlue": "color",
        "colorBackgroundVisualAccentViolet": "color",
        "colorBackgroundVisualAccentMagenta": "color",
        "colorBackgroundVisualAccentPink": "color",
        "colorBackgroundVisualAccentAmber": "color",
        "colorTextVisualAccentRed": "color",
        "colorTextVisualAccentYellow": "color",
        "colorTextVisualAccentIndigo": "color",
        "colorTextVisualAccentGreen": "color",
        "colorTextVisualAccentOrange": "color",
        "colorTextVisualAccentPurple": "color",
        "colorTextVisualAccentLime": "color",
        "colorTextVisualAccentGrey": "color",
        "colorTextVisualAccentTeal": "color",
        "colorTextVisualAccentBlue": "color",
        "colorTextVisualAccentViolet": "color",
        "colorTextVisualAccentMagenta": "color",
        "colorTextVisualAccentPink": "color",
        "colorTextVisualAccentAmber": "color",
        "motionDurationExtraFast": "motion",
        "motionDurationExtraSlow": "motion",
        "motionDurationFast": "motion",
        "motionDurationModerate": "motion",
        "motionDurationRefreshOnlyAmbient": "motion",
        "motionDurationRefreshOnlyFast": "motion",
        "motionDurationRefreshOnlyMedium": "motion",
        "motionDurationRefreshOnlySlow": "motion",
        "motionDurationAvatarGenAiGradient": "motion",
        "motionDurationAvatarLoadingDots": "motion",
        "motionDurationRotate180": "motion",
        "motionDurationRotate90": "motion",
        "motionDurationShowPaced": "motion",
        "motionDurationShowQuick": "motion",
        "motionDurationSlow": "motion",
        "motionDurationTransitionQuick": "motion",
        "motionDurationTransitionShowPaced": "motion",
        "motionDurationTransitionShowQuick": "motion",
        "motionEasingEaseOutQuart": "motion",
        "motionEasingRefreshOnlyA": "motion",
        "motionEasingRefreshOnlyB": "motion",
        "motionEasingRefreshOnlyC": "motion",
        "motionEasingRefreshOnlyD": "motion",
        "motionEasingAvatarGenAiGradient": "motion",
        "motionEasingRotate180": "motion",
        "motionEasingRotate90": "motion",
        "motionEasingShowPaced": "motion",
        "motionEasingShowQuick": "motion",
        "motionEasingTransitionQuick": "motion",
        "motionEasingTransitionShowPaced": "motion",
        "motionEasingTransitionShowQuick": "motion",
        "motionEasingResponsive": "motion",
        "motionEasingSticky": "motion",
        "motionEasingExpressive": "motion",
        "motionDurationResponsive": "motion",
        "motionDurationExpressive": "motion",
        "motionDurationComplex": "motion",
        "motionDurationTooltipEnter": "motion",
        "motionEasingTooltipEnter": "motion",
        "motionDurationExpandableContentEnter": "motion",
        "motionEasingExpandableContentEnter": "motion",
        "motionDurationSideNavigationContentEnterFade": "motion",
        "motionDurationSideNavigationContentExit": "motion",
        "motionDurationSideNavigationContentExitFade": "motion",
        "motionEasingSideNavigationContentExit": "motion",
        "motionKeyframesFadeIn": "motion",
        "motionKeyframesFadeOut": "motion",
        "motionKeyframesStatusIconError": "motion",
        "motionKeyframesScalePopup": "motion",
        "shadowCard": "color",
        "shadowItemCard": "color",
        "shadowContainer": "color",
        "shadowContainerActive": "color",
        "shadowDropdown": "color",
        "shadowDropup": "color",
        "shadowFlashCollapsed": "color",
        "shadowFlashSticky": "color",
        "shadowModal": "color",
        "shadowPanel": "color",
        "shadowPanelToggle": "color",
        "shadowPopover": "color",
        "shadowSplitBottom": "color",
        "shadowSplitSide": "color",
        "shadowSticky": "color",
        "shadowStickyEmbedded": "color",
        "shadowStickyColumnFirst": "color",
        "shadowStickyColumnLast": "color",
        "sizeCalendarGridWidth": "density",
        "sizeControl": "density",
        "sizeIconBig": "density",
        "sizeIconLarge": "density",
        "sizeIconMedium": "density",
        "sizeIconNormal": "density",
        "sizeTableSelectionHorizontal": "density",
        "sizeVerticalInput": "density",
        "sizeVerticalPanelIconOffset": "density",
        "sizeSideNavigationItemHeight": "density",
        "sizeSideNavigationItemCollapsed": "density",
        "sizeSideNavigationCollapsedWidth": "density",
        "spaceAlertActionLeft": "density",
        "spaceAlertHorizontal": "density",
        "spaceAlertMessageRight": "density",
        "spaceAlertVertical": "density",
        "spaceButtonFocusOutlineGutter": "density",
        "spaceButtonHorizontal": "density",
        "spaceButtonVertical": "density",
        "spaceTokenVertical": "density",
        "spaceFieldVertical": "density",
        "spaceButtonIconFocusOutlineGutterVertical": "density",
        "spaceButtonIconOnlyHorizontal": "density",
        "spaceButtonInlineIconFocusOutlineGutter": "density",
        "spaceButtonModalDismissVertical": "density",
        "spaceCalendarGridFocusOutlineGutter": "density",
        "spaceCalendarGridSelectedFocusOutlineGutter": "density",
        "spaceCalendarGridGutter": "density",
        "spaceCardHorizontalDefault": "density",
        "spaceCardHorizontalEmbedded": "density",
        "spaceCardVerticalDefault": "density",
        "spaceCardVerticalEmbedded": "density",
        "spaceItemCardHorizontalDefault": "density",
        "spaceItemCardHorizontalEmbedded": "density",
        "spaceItemCardVerticalDefault": "density",
        "spaceItemCardVerticalEmbedded": "density",
        "spaceDialogHorizontal": "density",
        "spaceDialogVertical": "density",
        "spaceDialogActionBlock": "density",
        "spaceDialogActionInline": "density",
        "spaceDialogHeaderGap": "density",
        "spaceDialogSectionGap": "density",
        "spaceCodeEditorStatusFocusOutlineGutter": "density",
        "spaceContainerContentTop": "density",
        "spaceContainerHeaderTop": "density",
        "spaceContainerHeaderBottom": "density",
        "spaceContainerHorizontal": "density",
        "spaceContentHeaderPaddingBottom": "density",
        "spaceDarkHeaderOverlapDistance": "density",
        "spaceExpandableSectionIconOffsetTop": "density",
        "spaceFieldHorizontal": "density",
        "spaceFieldIconOffset": "density",
        "spaceFilteringTokenDismissButtonFocusOutlineGutter": "density",
        "spaceFilteringTokenOperationSelectFocusOutlineGutter": "density",
        "spaceFlashbarActionLeft": "density",
        "spaceFlashbarDismissRight": "density",
        "spaceFlashbarHorizontal": "density",
        "spaceFlashbarVertical": "density",
        "spaceGridGutter": "density",
        "spaceKeyValueGap": "density",
        "spaceLayoutContentBottom": "density",
        "spaceLayoutContentHorizontal": "density",
        "spaceLayoutToggleDiameter": "density",
        "spaceLayoutTogglePadding": "density",
        "spaceModalContentBottom": "density",
        "spaceModalHorizontal": "density",
        "spacePanelContentBottom": "density",
        "spacePanelContentTop": "density",
        "spacePanelDividerMarginHorizontal": "density",
        "spacePanelHeaderVertical": "density",
        "spacePanelNavLeft": "density",
        "spacePanelSideLeft": "density",
        "spacePanelSideRight": "density",
        "spacePanelSplitTop": "density",
        "spacePanelSplitBottom": "density",
        "spaceSegmentedControlFocusOutlineGutter": "density",
        "spaceTabsContentTop": "density",
        "spaceTabsFocusOutlineGutter": "density",
        "spaceTabsVertical": "density",
        "spaceTableContentBottom": "density",
        "spaceTableEmbeddedHeaderTop": "density",
        "spaceTableFooterHorizontal": "density",
        "spaceTableHeaderFocusOutlineGutter": "density",
        "spaceTableHeaderHorizontal": "density",
        "spaceTableHeaderToolsBottom": "density",
        "spaceTableHeaderToolsFullPageBottom": "density",
        "spaceTableHorizontal": "density",
        "spaceTreeViewIndentation": "density",
        "spaceSideNavigationItemDefaultGap": "density",
        "spaceSideNavigationItemIconGap": "density",
        "spaceTileGutter": "density",
        "spaceActionCardHorizontalDefault": "density",
        "spaceActionCardHorizontalEmbedded": "density",
        "spaceActionCardVerticalDefault": "density",
        "spaceActionCardVerticalEmbedded": "density",
        "spaceActionCardDescriptionPaddingTop": "density",
        "spaceActionCardContentPaddingTop": "density",
        "spaceOptionPaddingVertical": "density",
        "spaceOptionPaddingHorizontal": "density",
        "spaceStatusIndicatorPaddingHorizontal": "density",
        "spaceScaled2xNone": "density",
        "spaceScaled2xXxxs": "density",
        "spaceScaled2xXxs": "density",
        "spaceScaled2xXs": "density",
        "spaceScaled2xS": "density",
        "spaceScaled2xM": "density",
        "spaceScaled2xL": "density",
        "spaceScaled2xXl": "density",
        "spaceScaled2xXxl": "density",
        "spaceScaled2xXxxl": "density",
        "spaceScaledNone": "density",
        "spaceScaledXxxs": "density",
        "spaceScaledXxs": "density",
        "spaceScaledXs": "density",
        "spaceScaledS": "density",
        "spaceScaledM": "density",
        "spaceScaledL": "density",
        "spaceScaledXl": "density",
        "spaceScaledXxl": "density",
        "spaceScaledXxxl": "density",
        "spaceStaticXxxs": "density",
        "spaceStaticXxs": "density",
        "spaceStaticXs": "density",
        "spaceStaticS": "density",
        "spaceStaticM": "density",
        "spaceStaticL": "density",
        "spaceStaticXl": "density",
        "spaceStaticXxl": "density",
        "spaceStaticXxxl": "density",
        "spaceNone": "density",
        "spaceXxxs": "density",
        "spaceXxs": "density",
        "spaceXs": "density",
        "spaceS": "density",
        "spaceM": "density",
        "spaceL": "density",
        "spaceXl": "density",
        "spaceXxl": "density",
        "spaceXxxl": "density"
      },
      "referenceTokens": {
        "color": {
          "primary": {
            "50": {
              "light": "#f5f7ff",
              "dark": "#f5f7ff"
            },
            "100": {
              "light": "#dbe4ff",
              "dark": "#dbe4ff"
            },
            "200": {
              "light": "#c2d1ff",
              "dark": "#c2d1ff"
            },
            "300": {
              "light": "#94afff",
              "dark": "#94afff"
            },
            "400": {
              "light": "#7598ff",
              "dark": "#7598ff"
            },
            "500": {
              "light": "#5c7fff",
              "dark": "#5c7fff"
            },
            "600": {
              "light": "#295eff",
              "dark": "#295eff"
            },
            "700": {
              "light": "#003efa",
              "dark": "#003efa"
            },
            "800": {
              "light": "#0033cc",
              "dark": "#0033cc"
            },
            "900": {
              "light": "#001a99",
              "dark": "#001a99"
            },
            "950": {
              "light": "#00204d",
              "dark": "#00204d"
            },
            "1000": {
              "light": "#000833",
              "dark": "#000833"
            }
          },
          "neutral": {
            "50": {
              "light": "#fcfcfc",
              "dark": "#fcfcfc"
            },
            "100": {
              "light": "#f9f9f9",
              "dark": "#f9f9f9"
            },
            "150": {
              "light": "#f8f8f7",
              "dark": "#f8f8f7"
            },
            "200": {
              "light": "#f3f3f1",
              "dark": "#f3f3f1"
            },
            "250": {
              "light": "#eeedeb",
              "dark": "#eeedeb"
            },
            "300": {
              "light": "#e3e1de",
              "dark": "#e3e1de"
            },
            "350": {
              "light": "#cbc9c3",
              "dark": "#cbc9c3"
            },
            "400": {
              "light": "#bab7b0",
              "dark": "#bab7b0"
            },
            "450": {
              "light": "#aca9a2",
              "dark": "#aca9a2"
            },
            "500": {
              "light": "#949088",
              "dark": "#949088"
            },
            "550": {
              "light": "#868279",
              "dark": "#868279"
            },
            "600": {
              "light": "#6f6b63",
              "dark": "#6f6b63"
            },
            "650": {
              "light": "#4c4942",
              "dark": "#4c4942"
            },
            "700": {
              "light": "#3e3b35",
              "dark": "#3e3b35"
            },
            "750": {
              "light": "#2f2d28",
              "dark": "#2f2d28"
            },
            "800": {
              "light": "#262420",
              "dark": "#262420"
            },
            "850": {
              "light": "#201e1b",
              "dark": "#201e1b"
            },
            "900": {
              "light": "#1b1a17",
              "dark": "#1b1a17"
            },
            "950": {
              "light": "#161512",
              "dark": "#161512"
            },
            "1000": {
              "light": "#100f0d",
              "dark": "#100f0d"
            }
          },
          "error": {
            "50": {
              "light": "#fff5f5",
              "dark": "#fff5f5"
            },
            "100": {
              "light": "#ffe0e0",
              "dark": "#ffe0e0"
            },
            "300": {
              "light": "#ff9e9e",
              "dark": "#ff9e9e"
            },
            "400": {
              "light": "#ff7a7a",
              "dark": "#ff7a7a"
            },
            "500": {
              "light": "#ff3d3d",
              "dark": "#ff3d3d"
            },
            "600": {
              "light": "#db0000",
              "dark": "#db0000"
            },
            "700": {
              "light": "#c20000",
              "dark": "#c20000"
            },
            "800": {
              "light": "#990000",
              "dark": "#990000"
            },
            "900": {
              "light": "#700000",
              "dark": "#700000"
            },
            "950": {
              "light": "#520000",
              "dark": "#520000"
            },
            "1000": {
              "light": "#1f0000",
              "dark": "#1f0000"
            }
          },
          "success": {
            "50": {
              "light": "#effff1",
              "dark": "#effff1"
            },
            "100": {
              "light": "#d9ffd6",
              "dark": "#d9ffd6"
            },
            "200": {
              "light": "#aeffa8",
              "dark": "#aeffa8"
            },
            "300": {
              "light": "#62ff57",
              "dark": "#62ff57"
            },
            "400": {
              "light": "#00e500",
              "dark": "#00e500"
            },
            "500": {
              "light": "#2bb534",
              "dark": "#2bb534"
            },
            "600": {
              "light": "#00802f",
              "dark": "#00802f"
            },
            "700": {
              "light": "#007029",
              "dark": "#007029"
            },
            "800": {
              "light": "#005c26",
              "dark": "#005c26"
            },
            "950": {
              "light": "#003311",
              "dark": "#003311"
            },
            "1000": {
              "light": "#001401",
              "dark": "#001401"
            }
          },
          "warning": {
            "50": {
              "light": "#fffde5",
              "dark": "#fffde5"
            },
            "100": {
              "light": "#fffbbd",
              "dark": "#fffbbd"
            },
            "200": {
              "light": "#fff78a",
              "dark": "#fff78a"
            },
            "300": {
              "light": "#fced69",
              "dark": "#fced69"
            },
            "400": {
              "light": "#fce255",
              "dark": "#fce255"
            },
            "500": {
              "light": "#fbd332",
              "dark": "#fbd332"
            },
            "600": {
              "light": "#f2b100",
              "dark": "#f2b100"
            },
            "800": {
              "light": "#9e6900",
              "dark": "#9e6900"
            },
            "900": {
              "light": "#855900",
              "dark": "#855900"
            },
            "950": {
              "light": "#573a00",
              "dark": "#573a00"
            },
            "1000": {
              "light": "#191100",
              "dark": "#191100"
            }
          },
          "info": {
            "50": {
              "light": "#f5f7ff",
              "dark": "#f5f7ff"
            },
            "100": {
              "light": "#dbe4ff",
              "dark": "#dbe4ff"
            },
            "300": {
              "light": "#94afff",
              "dark": "#94afff"
            },
            "400": {
              "light": "#7598ff",
              "dark": "#7598ff"
            },
            "500": {
              "light": "#5c7fff",
              "dark": "#5c7fff"
            },
            "600": {
              "light": "#295eff",
              "dark": "#295eff"
            },
            "700": {
              "light": "#003efa",
              "dark": "#003efa"
            },
            "800": {
              "light": "#0033cc",
              "dark": "#0033cc"
            },
            "900": {
              "light": "#001a99",
              "dark": "#001a99"
            },
            "950": {
              "light": "#001475",
              "dark": "#001475"
            },
            "1000": {
              "light": "#000833",
              "dark": "#000833"
            }
          }
        }
      }
    }
  ],
  "themeable": [
    "colorChartsStatusCritical",
    "colorChartsStatusHigh",
    "colorChartsStatusMedium",
    "colorChartsStatusLow",
    "colorChartsStatusPositive",
    "colorChartsStatusInfo",
    "colorChartsStatusNeutral",
    "colorChartsThresholdNegative",
    "colorChartsThresholdPositive",
    "colorChartsThresholdInfo",
    "colorChartsThresholdNeutral",
    "colorChartsPaletteCategorical1",
    "colorChartsPaletteCategorical2",
    "colorChartsPaletteCategorical3",
    "colorChartsPaletteCategorical4",
    "colorChartsPaletteCategorical5",
    "colorChartsPaletteCategorical6",
    "colorChartsPaletteCategorical7",
    "colorChartsPaletteCategorical8",
    "colorChartsPaletteCategorical9",
    "colorChartsPaletteCategorical10",
    "colorChartsPaletteCategorical11",
    "colorChartsPaletteCategorical12",
    "colorChartsPaletteCategorical13",
    "colorChartsPaletteCategorical14",
    "colorChartsPaletteCategorical15",
    "colorChartsPaletteCategorical16",
    "colorChartsPaletteCategorical17",
    "colorChartsPaletteCategorical18",
    "colorChartsPaletteCategorical19",
    "colorChartsPaletteCategorical20",
    "colorChartsPaletteCategorical21",
    "colorChartsPaletteCategorical22",
    "colorChartsPaletteCategorical23",
    "colorChartsPaletteCategorical24",
    "colorChartsPaletteCategorical25",
    "colorChartsPaletteCategorical26",
    "colorChartsPaletteCategorical27",
    "colorChartsPaletteCategorical28",
    "colorChartsPaletteCategorical29",
    "colorChartsPaletteCategorical30",
    "colorChartsPaletteCategorical31",
    "colorChartsPaletteCategorical32",
    "colorChartsPaletteCategorical33",
    "colorChartsPaletteCategorical34",
    "colorChartsPaletteCategorical35",
    "colorChartsPaletteCategorical36",
    "colorChartsPaletteCategorical37",
    "colorChartsPaletteCategorical38",
    "colorChartsPaletteCategorical39",
    "colorChartsPaletteCategorical40",
    "colorChartsPaletteCategorical41",
    "colorChartsPaletteCategorical42",
    "colorChartsPaletteCategorical43",
    "colorChartsPaletteCategorical44",
    "colorChartsPaletteCategorical45",
    "colorChartsPaletteCategorical46",
    "colorChartsPaletteCategorical47",
    "colorChartsPaletteCategorical48",
    "colorChartsPaletteCategorical49",
    "colorChartsPaletteCategorical50",
    "colorChartsErrorBarMarker",
    "colorBackgroundNotificationSeverityCritical",
    "colorBackgroundNotificationSeverityHigh",
    "colorBackgroundNotificationSeverityMedium",
    "colorBackgroundNotificationSeverityLow",
    "colorBackgroundNotificationSeverityNeutral",
    "colorTextNotificationSeverityCritical",
    "colorTextNotificationSeverityHigh",
    "colorTextNotificationSeverityMedium",
    "colorTextNotificationSeverityLow",
    "colorTextNotificationSeverityNeutral",
    "colorBorderBadgeSeverityCritical",
    "colorBorderBadgeSeverityHigh",
    "colorBorderBadgeSeverityMedium",
    "colorBorderBadgeSeverityLow",
    "colorBorderBadgeSeverityNeutral",
    "colorTextBadgeSeverityCritical",
    "colorTextBadgeSeverityHigh",
    "colorTextBadgeSeverityMedium",
    "colorTextBadgeSeverityLow",
    "colorTextBadgeSeverityNeutral",
    "colorBackgroundBadgeIcon",
    "colorBackgroundButtonLinkActive",
    "colorBackgroundButtonLinkDefault",
    "colorBackgroundButtonLinkDisabled",
    "colorBackgroundButtonLinkHover",
    "colorBackgroundButtonNormalActive",
    "colorBackgroundButtonNormalDefault",
    "colorBackgroundButtonNormalDisabled",
    "colorBackgroundButtonNormalHover",
    "colorBackgroundToggleButtonNormalPressed",
    "colorBackgroundToggleButtonNormalDefault",
    "colorBackgroundToggleButtonNormalHover",
    "colorBackgroundButtonPrimaryActive",
    "colorBackgroundButtonPrimaryDefault",
    "colorBackgroundButtonPrimaryDisabled",
    "colorBackgroundButtonPrimaryHover",
    "colorBackgroundCellShaded",
    "colorBackgroundCard",
    "colorBackgroundContainerContent",
    "colorBackgroundContainerHeader",
    "colorBackgroundControlChecked",
    "colorBackgroundControlDefault",
    "colorBackgroundControlDisabled",
    "colorBackgroundDropdownItemDefault",
    "colorBackgroundDropdownItemFilterMatch",
    "colorBackgroundDropdownItemHover",
    "colorBackgroundDropdownItemSelected",
    "colorBackgroundHomeHeader",
    "colorBackgroundInputDefault",
    "colorBackgroundInputDisabled",
    "colorBackgroundItemSelected",
    "colorBackgroundSideNavigationItemActive",
    "colorBackgroundSideNavigationItemActiveCollapsed",
    "colorBackgroundLayoutMain",
    "colorBackgroundLayoutAiDrawer",
    "colorBackgroundBackdrop",
    "colorBackgroundLayoutPanel",
    "colorBackgroundLayoutPanelContent",
    "colorBackgroundLayoutToolbar",
    "colorBackgroundLayoutToggleActive",
    "colorBackgroundLayoutToggleDefault",
    "colorBackgroundLayoutToggleHover",
    "colorBackgroundLayoutToggleSelectedActive",
    "colorBackgroundLayoutToggleSelectedDefault",
    "colorBackgroundLayoutToggleSelectedHover",
    "colorBackgroundNotificationBlue",
    "colorBackgroundNotificationGreen",
    "colorBackgroundNotificationGrey",
    "colorBackgroundNotificationRed",
    "colorBackgroundNotificationYellow",
    "colorBackgroundFlashbarSuccess",
    "colorBackgroundFlashbarError",
    "colorBackgroundFlashbarInfo",
    "colorBackgroundFlashbarWarning",
    "colorBackgroundPopover",
    "colorBackgroundProgressBarValueDefault",
    "colorBackgroundProgressBarDefault",
    "colorBackgroundSegmentActive",
    "colorBackgroundSegmentDefault",
    "colorBackgroundSegmentDisabled",
    "colorBackgroundSegmentHover",
    "colorBackgroundSegmentWrapper",
    "colorBackgroundSliderRangeDefault",
    "colorBackgroundSliderRangeActive",
    "colorBackgroundSliderHandleDefault",
    "colorBackgroundSliderHandleActive",
    "colorBackgroundSliderTrackDefault",
    "colorBackgroundStatusError",
    "colorBackgroundStatusInfo",
    "colorBackgroundDialog",
    "colorBackgroundDialogDefault",
    "colorBackgroundStatusSuccess",
    "colorBackgroundStatusWarning",
    "colorBackgroundTilesDisabled",
    "colorBackgroundToggleCheckedDisabled",
    "colorBackgroundToggleDefault",
    "colorBackgroundStatusIndicatorError",
    "colorBackgroundStatusIndicatorWarning",
    "colorBackgroundStatusIndicatorSuccess",
    "colorBackgroundStatusIndicatorInfo",
    "colorBackgroundStatusIndicatorNeutral",
    "colorBackgroundChatBubbleOutgoing",
    "colorBackgroundChatBubbleIncoming",
    "colorTextChatBubbleOutgoing",
    "colorTextChatBubbleIncoming",
    "colorBorderButtonLinkDisabled",
    "colorBorderButtonNormalActive",
    "colorBorderButtonNormalDefault",
    "colorBorderToggleButtonNormalPressed",
    "colorBorderToggleButtonNormalDefault",
    "colorBorderToggleButtonNormalHover",
    "colorBorderButtonNormalDisabled",
    "colorTextButtonNormalDisabled",
    "colorBorderButtonNormalHover",
    "colorTextButtonIconDisabled",
    "colorBorderButtonPrimaryActive",
    "colorBorderButtonPrimaryDefault",
    "colorBorderButtonPrimaryDisabled",
    "colorBorderButtonPrimaryHover",
    "colorTextButtonPrimaryDisabled",
    "colorItemSelected",
    "colorTextSideNavigationItemActive",
    "colorTextSideNavigationItemActiveCollapsed",
    "colorTextSideNavigationItemDefault",
    "colorBorderCard",
    "colorBorderContainerTop",
    "colorBorderControlDefault",
    "colorBorderDividerDefault",
    "colorBorderDividerSecondary",
    "colorBorderDropdownContainer",
    "colorBorderDropdownItemHover",
    "colorBorderInputDefault",
    "colorBorderInputFocused",
    "colorBorderItemFocused",
    "colorBorderDropdownItemFocused",
    "colorBorderItemSelected",
    "colorBorderLayout",
    "colorBorderLayoutSideNavigation",
    "colorBorderPopover",
    "colorBorderSegmentActive",
    "colorBorderSegmentDefault",
    "colorBorderSegmentDisabled",
    "colorBorderSegmentDivider",
    "colorBorderSegmentHover",
    "colorBorderSegmentWrapper",
    "colorBorderStatusError",
    "colorBorderStatusInfo",
    "colorBorderStatusSuccess",
    "colorBorderStatusWarning",
    "colorBorderDialog",
    "colorBorderDialogDefault",
    "colorForegroundControlDefault",
    "colorForegroundControlDisabled",
    "colorForegroundControlReadOnly",
    "colorShadowToggleHandle",
    "colorTextAccent",
    "colorTextBodyDefault",
    "colorTextBodySecondary",
    "colorTextBreadcrumbCurrent",
    "colorTextBreadcrumbIcon",
    "colorTextButtonInlineIconDefault",
    "colorTextButtonInlineIconDisabled",
    "colorTextButtonInlineIconHover",
    "colorTextButtonInlineLinkHover",
    "colorTextButtonIconHover",
    "colorTextButtonNormalActive",
    "colorTextToggleButtonNormalPressed",
    "colorTextButtonNormalDefault",
    "colorTextButtonNormalHover",
    "colorTextLinkButtonNormalDefault",
    "colorTextLinkButtonNormalHover",
    "colorTextLinkButtonNormalActive",
    "colorTextButtonLinkActive",
    "colorTextButtonLinkDefault",
    "colorTextButtonLinkDisabled",
    "colorTextButtonLinkHover",
    "colorTextButtonPrimaryActive",
    "colorTextButtonPrimaryDefault",
    "colorTextButtonPrimaryHover",
    "colorTextCalendarDateSelected",
    "colorTextCounter",
    "colorTextDropdownItemDefault",
    "colorTextDropdownItemDisabled",
    "colorTextDropdownItemFilterMatch",
    "colorTextDropdownItemHighlighted",
    "colorTextDropdownItemSecondary",
    "colorTextEmpty",
    "colorTextExpandableSectionDefault",
    "colorTextExpandableSectionHover",
    "colorTextExpandableSectionNavigationIconDefault",
    "colorBorderExpandableSectionDefault",
    "colorTextFormDefault",
    "colorTextFormLabel",
    "colorTextFormSecondary",
    "colorTextGroupLabel",
    "colorTextHeadingDefault",
    "colorTextHeadingSecondary",
    "colorTextHomeHeaderDefault",
    "colorTextHomeHeaderSecondary",
    "colorTextIconSubtle",
    "colorTextInputDisabled",
    "colorTextInputPlaceholder",
    "colorTextInteractiveActive",
    "colorTextInteractiveDefault",
    "colorTextInteractiveDisabled",
    "colorTextInteractiveHover",
    "colorTextToggleButtonIconPressed",
    "colorTextInteractiveInvertedDefault",
    "colorTextInteractiveInvertedHover",
    "colorTextLabel",
    "colorTextKeyValuePairsValue",
    "colorTextLayoutToggle",
    "colorTextLayoutToggleActive",
    "colorTextLayoutToggleHover",
    "colorTextLayoutToggleSelected",
    "colorTextLinkDefault",
    "colorTextLinkHover",
    "colorTextLinkDecorationDefault",
    "colorTextLinkDecorationHover",
    "colorTextLinkSecondaryDefault",
    "colorTextLinkSecondaryHover",
    "colorTextLinkInfoDefault",
    "colorTextLinkInfoHover",
    "colorTextNotificationDefault",
    "colorTextNotificationYellow",
    "colorTextSegmentActive",
    "colorTextSegmentDefault",
    "colorTextSegmentHover",
    "colorTextStatusError",
    "colorTextStatusInactive",
    "colorTextStatusInfo",
    "colorTextStatusSuccess",
    "colorTextStatusWarning",
    "colorTextTopNavigationTitle",
    "colorDropzoneBackgroundDefault",
    "colorDropzoneBackgroundHover",
    "colorDropzoneTextDefault",
    "colorDropzoneTextHover",
    "colorDropzoneBorderDefault",
    "colorDropzoneBorderHover",
    "colorTreeViewConnectorLine",
    "colorBackgroundActionCardDefault",
    "colorBackgroundActionCardHover",
    "colorBackgroundActionCardActive",
    "colorBorderActionCardDefault",
    "colorBorderActionCardHover",
    "colorBorderActionCardActive",
    "colorBorderActionCardDisabled",
    "colorBackgroundActionCardDisabled",
    "colorTextActionCardDisabled",
    "colorTextActionCardIconDefault",
    "colorTextActionCardIconHover",
    "colorTextActionCardIconActive",
    "colorTextActionCardIconDisabled",
    "colorBackgroundBadgeGreen",
    "colorBackgroundBadgeBlue",
    "colorBackgroundBadgeRed",
    "colorBackgroundBadgeYellow",
    "colorBackgroundBadgeGrey",
    "colorBorderBadge",
    "colorBorderBadgeGrey",
    "colorBorderBadgeGreen",
    "colorBorderBadgeBlue",
    "colorBorderBadgeRed",
    "colorTextBadgeGrey",
    "colorTextBadgeGreen",
    "colorTextBadgeBlue",
    "colorTextBadgeRed",
    "colorBackgroundCodeView",
    "fontDecorationStyleLink",
    "fontDecorationThicknessLink",
    "fontDecorationThicknessLinkDisplayL",
    "fontSizeExpandableHeading",
    "fontFamilyBase",
    "fontFamilyDisplay",
    "fontFamilyHeading",
    "fontFamilyMonospace",
    "fontSizeBodyM",
    "fontSizeBodyS",
    "fontSizeDisplayL",
    "fontSizeDisplayXl",
    "fontSizeFormLabel",
    "fontSizeHeadingL",
    "fontSizeHeadingM",
    "fontSizeHeadingS",
    "fontSizeHeadingXl",
    "fontSizeHeadingXs",
    "fontSizeKeyValuePairsLabel",
    "fontSizeTabs",
    "fontWeightAlertHeader",
    "fontWeightBold",
    "fontWeightBreadcrumbCurrent",
    "fontWeightButton",
    "fontWeightDisplayL",
    "fontWeightDisplayXl",
    "fontWeightFlashbarHeader",
    "fontWeightFormLabel",
    "fontWeightHeadingL",
    "fontWeightHeadingM",
    "fontWeightHeadingS",
    "fontWeightHeadingXl",
    "fontWeightHeadingXs",
    "fontWeightHeavy",
    "fontWeightKeyValuePairsLabel",
    "fontWeightLighter",
    "fontWeightNormal",
    "fontWeightTabs",
    "fontWeightTabsDisabled",
    "letterSpacingDisplayL",
    "letterSpacingDisplayXl",
    "letterSpacingHeadingL",
    "letterSpacingHeadingM",
    "letterSpacingHeadingS",
    "letterSpacingHeadingXl",
    "letterSpacingHeadingXs",
    "lineHeightBodyM",
    "lineHeightBodyS",
    "lineHeightDisplayL",
    "lineHeightDisplayXl",
    "lineHeightFormLabel",
    "lineHeightHeadingL",
    "lineHeightHeadingM",
    "lineHeightHeadingS",
    "lineHeightHeadingXl",
    "lineHeightHeadingXs",
    "lineHeightKeyValuePairsLabel",
    "lineHeightTabs",
    "borderRadiusActionCardDefault",
    "borderRadiusActionCardEmbedded",
    "borderRadiusAlert",
    "borderRadiusBadge",
    "borderRadiusButton",
    "borderRadiusCalendarDayFocusRing",
    "borderRadiusCardDefault",
    "borderRadiusCardEmbedded",
    "borderRadiusChatBubble",
    "borderRadiusSupportPrompt",
    "borderRadiusContainer",
    "borderRadiusControlCircularFocusRing",
    "borderRadiusControlDefaultFocusRing",
    "borderRadiusDropdown",
    "borderRadiusDropzone",
    "borderRadiusFlashbar",
    "borderRadiusInput",
    "borderRadiusItem",
    "borderRadiusSideNavigationItem",
    "borderRadiusSideNavigationItemCollapsed",
    "borderRadiusDialog",
    "borderRadiusPopover",
    "borderRadiusStatusIndicator",
    "borderRadiusTabsFocusRing",
    "borderRadiusTiles",
    "borderRadiusToken",
    "borderRadiusTokenInline",
    "borderRadiusTutorialPanelItem",
    "borderWidthActionCardActive",
    "borderWidthActionCardDefault",
    "borderWidthActionCardDisabled",
    "borderWidthActionCardHover",
    "borderWidthAlert",
    "borderWidthAlertBlockEnd",
    "borderWidthAlertBlockStart",
    "borderWidthAlertInlineEnd",
    "borderWidthAlertInlineStart",
    "borderWidthFlashbarInlineStart",
    "borderWidthButton",
    "borderWidthCard",
    "borderWidthCardSelected",
    "borderWidthDropdown",
    "borderWidthField",
    "borderWidthIconBig",
    "borderWidthIconLarge",
    "borderWidthIconMedium",
    "borderWidthIconNormal",
    "borderWidthIconSmall",
    "borderWidthIconXSmall",
    "borderWidthDialog",
    "borderWidthItemSelected",
    "borderWidthLayoutSideNavigation",
    "borderWidthBadge",
    "borderWidthPopover",
    "borderWidthToken",
    "motionDurationTooltipEnter",
    "motionEasingTooltipEnter",
    "sizeVerticalInput",
    "sizeSideNavigationItemHeight",
    "sizeSideNavigationItemCollapsed",
    "sizeSideNavigationCollapsedWidth",
    "spaceAlertVertical",
    "spaceButtonHorizontal",
    "spaceButtonVertical",
    "spaceTokenVertical",
    "spaceFieldVertical",
    "spaceCardHorizontalDefault",
    "spaceCardHorizontalEmbedded",
    "spaceCardVerticalDefault",
    "spaceCardVerticalEmbedded",
    "spaceDialogHorizontal",
    "spaceDialogVertical",
    "spaceDialogActionBlock",
    "spaceDialogActionInline",
    "spaceDialogHeaderGap",
    "spaceDialogSectionGap",
    "spaceTabsVertical",
    "spaceSideNavigationItemDefaultGap",
    "spaceSideNavigationItemIconGap",
    "spaceActionCardHorizontalDefault",
    "spaceActionCardHorizontalEmbedded",
    "spaceActionCardVerticalDefault",
    "spaceActionCardVerticalEmbedded",
    "spaceStatusIndicatorPaddingHorizontal",
    "shadowCard",
    "shadowDialog"
  ],
  "exposed": [
    "colorChartsRed300",
    "colorChartsRed400",
    "colorChartsRed500",
    "colorChartsRed600",
    "colorChartsRed700",
    "colorChartsRed800",
    "colorChartsRed900",
    "colorChartsRed1000",
    "colorChartsRed1100",
    "colorChartsRed1200",
    "colorChartsOrange300",
    "colorChartsOrange400",
    "colorChartsOrange500",
    "colorChartsOrange600",
    "colorChartsOrange700",
    "colorChartsOrange800",
    "colorChartsOrange900",
    "colorChartsOrange1000",
    "colorChartsOrange1100",
    "colorChartsOrange1200",
    "colorChartsYellow300",
    "colorChartsYellow400",
    "colorChartsYellow500",
    "colorChartsYellow600",
    "colorChartsYellow700",
    "colorChartsYellow800",
    "colorChartsYellow900",
    "colorChartsYellow1000",
    "colorChartsYellow1100",
    "colorChartsYellow1200",
    "colorChartsGreen300",
    "colorChartsGreen400",
    "colorChartsGreen500",
    "colorChartsGreen600",
    "colorChartsGreen700",
    "colorChartsGreen800",
    "colorChartsGreen900",
    "colorChartsGreen1000",
    "colorChartsGreen1100",
    "colorChartsGreen1200",
    "colorChartsTeal300",
    "colorChartsTeal400",
    "colorChartsTeal500",
    "colorChartsTeal600",
    "colorChartsTeal700",
    "colorChartsTeal800",
    "colorChartsTeal900",
    "colorChartsTeal1000",
    "colorChartsTeal1100",
    "colorChartsTeal1200",
    "colorChartsBlue1300",
    "colorChartsBlue1400",
    "colorChartsBlue1500",
    "colorChartsBlue1600",
    "colorChartsBlue1700",
    "colorChartsBlue1800",
    "colorChartsBlue1900",
    "colorChartsBlue11000",
    "colorChartsBlue11100",
    "colorChartsBlue11200",
    "colorChartsBlue2300",
    "colorChartsBlue2400",
    "colorChartsBlue2500",
    "colorChartsBlue2600",
    "colorChartsBlue2700",
    "colorChartsBlue2800",
    "colorChartsBlue2900",
    "colorChartsBlue21000",
    "colorChartsBlue21100",
    "colorChartsBlue21200",
    "colorChartsPurple300",
    "colorChartsPurple400",
    "colorChartsPurple500",
    "colorChartsPurple600",
    "colorChartsPurple700",
    "colorChartsPurple800",
    "colorChartsPurple900",
    "colorChartsPurple1000",
    "colorChartsPurple1100",
    "colorChartsPurple1200",
    "colorChartsPink300",
    "colorChartsPink400",
    "colorChartsPink500",
    "colorChartsPink600",
    "colorChartsPink700",
    "colorChartsPink800",
    "colorChartsPink900",
    "colorChartsPink1000",
    "colorChartsPink1100",
    "colorChartsPink1200",
    "colorChartsStatusCritical",
    "colorChartsStatusHigh",
    "colorChartsStatusMedium",
    "colorChartsStatusLow",
    "colorChartsStatusPositive",
    "colorChartsStatusInfo",
    "colorChartsStatusNeutral",
    "colorChartsThresholdNegative",
    "colorChartsThresholdPositive",
    "colorChartsThresholdInfo",
    "colorChartsThresholdNeutral",
    "colorChartsLineGrid",
    "colorChartsLineTick",
    "colorChartsLineAxis",
    "colorChartsPaletteCategorical1",
    "colorChartsPaletteCategorical2",
    "colorChartsPaletteCategorical3",
    "colorChartsPaletteCategorical4",
    "colorChartsPaletteCategorical5",
    "colorChartsPaletteCategorical6",
    "colorChartsPaletteCategorical7",
    "colorChartsPaletteCategorical8",
    "colorChartsPaletteCategorical9",
    "colorChartsPaletteCategorical10",
    "colorChartsPaletteCategorical11",
    "colorChartsPaletteCategorical12",
    "colorChartsPaletteCategorical13",
    "colorChartsPaletteCategorical14",
    "colorChartsPaletteCategorical15",
    "colorChartsPaletteCategorical16",
    "colorChartsPaletteCategorical17",
    "colorChartsPaletteCategorical18",
    "colorChartsPaletteCategorical19",
    "colorChartsPaletteCategorical20",
    "colorChartsPaletteCategorical21",
    "colorChartsPaletteCategorical22",
    "colorChartsPaletteCategorical23",
    "colorChartsPaletteCategorical24",
    "colorChartsPaletteCategorical25",
    "colorChartsPaletteCategorical26",
    "colorChartsPaletteCategorical27",
    "colorChartsPaletteCategorical28",
    "colorChartsPaletteCategorical29",
    "colorChartsPaletteCategorical30",
    "colorChartsPaletteCategorical31",
    "colorChartsPaletteCategorical32",
    "colorChartsPaletteCategorical33",
    "colorChartsPaletteCategorical34",
    "colorChartsPaletteCategorical35",
    "colorChartsPaletteCategorical36",
    "colorChartsPaletteCategorical37",
    "colorChartsPaletteCategorical38",
    "colorChartsPaletteCategorical39",
    "colorChartsPaletteCategorical40",
    "colorChartsPaletteCategorical41",
    "colorChartsPaletteCategorical42",
    "colorChartsPaletteCategorical43",
    "colorChartsPaletteCategorical44",
    "colorChartsPaletteCategorical45",
    "colorChartsPaletteCategorical46",
    "colorChartsPaletteCategorical47",
    "colorChartsPaletteCategorical48",
    "colorChartsPaletteCategorical49",
    "colorChartsPaletteCategorical50",
    "colorChartsErrorBarMarker",
    "colorBackgroundNotificationSeverityCritical",
    "colorBackgroundNotificationSeverityHigh",
    "colorBackgroundNotificationSeverityMedium",
    "colorBackgroundNotificationSeverityLow",
    "colorBackgroundNotificationSeverityNeutral",
    "colorTextNotificationSeverityCritical",
    "colorTextNotificationSeverityHigh",
    "colorTextNotificationSeverityMedium",
    "colorTextNotificationSeverityLow",
    "colorTextNotificationSeverityNeutral",
    "colorBorderBadgeSeverityCritical",
    "colorBorderBadgeSeverityHigh",
    "colorBorderBadgeSeverityMedium",
    "colorBorderBadgeSeverityLow",
    "colorBorderBadgeSeverityNeutral",
    "colorTextBadgeSeverityCritical",
    "colorTextBadgeSeverityHigh",
    "colorTextBadgeSeverityMedium",
    "colorTextBadgeSeverityLow",
    "colorTextBadgeSeverityNeutral",
    "colorBackgroundBadgeIcon",
    "colorBackgroundButtonLinkActive",
    "colorBackgroundButtonLinkDefault",
    "colorBackgroundButtonLinkDisabled",
    "colorBackgroundButtonLinkHover",
    "colorBackgroundButtonNormalActive",
    "colorBackgroundButtonNormalDefault",
    "colorBackgroundButtonNormalDisabled",
    "colorBackgroundButtonNormalHover",
    "colorBackgroundToggleButtonNormalPressed",
    "colorBackgroundToggleButtonNormalDefault",
    "colorBackgroundToggleButtonNormalHover",
    "colorBackgroundButtonPrimaryActive",
    "colorBackgroundButtonPrimaryDefault",
    "colorBackgroundButtonPrimaryDisabled",
    "colorBackgroundButtonPrimaryHover",
    "colorBackgroundCellShaded",
    "colorBackgroundCard",
    "colorBackgroundContainerContent",
    "colorBackgroundContainerHeader",
    "colorBackgroundControlChecked",
    "colorBackgroundControlDefault",
    "colorBackgroundControlDisabled",
    "colorBackgroundDropdownItemDefault",
    "colorBackgroundDropdownItemFilterMatch",
    "colorBackgroundDropdownItemHover",
    "colorBackgroundDropdownItemSelected",
    "colorBackgroundHomeHeader",
    "colorBackgroundInputDefault",
    "colorBackgroundInputDisabled",
    "colorBackgroundItemSelected",
    "colorBackgroundSideNavigationItemActive",
    "colorBackgroundLayoutMain",
    "colorBackgroundBackdrop",
    "colorBackgroundLayoutPanel",
    "colorBackgroundLayoutPanelContent",
    "colorBackgroundLayoutToolbar",
    "colorBackgroundLayoutToggleActive",
    "colorBackgroundLayoutToggleDefault",
    "colorBackgroundLayoutToggleHover",
    "colorBackgroundLayoutToggleSelectedActive",
    "colorBackgroundLayoutToggleSelectedDefault",
    "colorBackgroundLayoutToggleSelectedHover",
    "colorBackgroundNotificationBlue",
    "colorBackgroundNotificationGreen",
    "colorBackgroundNotificationGrey",
    "colorBackgroundNotificationRed",
    "colorBackgroundNotificationYellow",
    "colorBackgroundFlashbarSuccess",
    "colorBackgroundFlashbarError",
    "colorBackgroundFlashbarInfo",
    "colorBackgroundFlashbarWarning",
    "colorBackgroundPopover",
    "colorBackgroundProgressBarValueDefault",
    "colorBackgroundProgressBarDefault",
    "colorBackgroundSegmentActive",
    "colorBackgroundSegmentDefault",
    "colorBackgroundSegmentDisabled",
    "colorBackgroundSegmentHover",
    "colorBackgroundSegmentWrapper",
    "colorBackgroundSliderRangeDefault",
    "colorBackgroundSliderRangeActive",
    "colorBackgroundSliderHandleDefault",
    "colorBackgroundSliderHandleActive",
    "colorBackgroundSliderTrackDefault",
    "colorBackgroundStatusError",
    "colorBackgroundStatusInfo",
    "colorBackgroundDialog",
    "colorBackgroundStatusSuccess",
    "colorBackgroundStatusWarning",
    "colorBackgroundTilesDisabled",
    "colorBackgroundToggleCheckedDisabled",
    "colorBackgroundToggleDefault",
    "colorBackgroundAvatarGenAi",
    "colorBackgroundAvatarDefault",
    "colorTextAvatar",
    "colorBackgroundLoadingBarGenAi",
    "colorBackgroundChatBubbleOutgoing",
    "colorBackgroundChatBubbleIncoming",
    "colorTextChatBubbleOutgoing",
    "colorTextChatBubbleIncoming",
    "colorBorderButtonLinkDisabled",
    "colorBorderButtonNormalActive",
    "colorBorderButtonNormalDefault",
    "colorBorderToggleButtonNormalPressed",
    "colorBorderToggleButtonNormalDefault",
    "colorBorderToggleButtonNormalHover",
    "colorBorderButtonNormalDisabled",
    "colorTextButtonNormalDisabled",
    "colorBorderButtonNormalHover",
    "colorTextButtonIconDisabled",
    "colorBorderButtonPrimaryActive",
    "colorBorderButtonPrimaryDefault",
    "colorBorderButtonPrimaryDisabled",
    "colorBorderButtonPrimaryHover",
    "colorTextButtonPrimaryDisabled",
    "colorItemSelected",
    "colorTextSideNavigationItemActive",
    "colorBorderCard",
    "colorBorderContainerTop",
    "colorBorderControlDefault",
    "colorBorderDividerDefault",
    "colorBorderDividerSecondary",
    "colorBorderDropdownContainer",
    "colorBorderDropdownItemHover",
    "colorBorderInputDefault",
    "colorBorderInputFocused",
    "colorBorderItemFocused",
    "colorBorderDropdownItemFocused",
    "colorBorderItemSelected",
    "colorBorderLayoutSideNavigation",
    "colorBorderPopover",
    "colorBorderSegmentActive",
    "colorBorderSegmentDefault",
    "colorBorderSegmentDisabled",
    "colorBorderSegmentDivider",
    "colorBorderSegmentHover",
    "colorBorderSegmentWrapper",
    "colorBorderStatusError",
    "colorBorderStatusInfo",
    "colorBorderStatusSuccess",
    "colorBorderStatusWarning",
    "colorBorderDialog",
    "colorForegroundControlDefault",
    "colorForegroundControlDisabled",
    "colorForegroundControlReadOnly",
    "colorShadowToggleHandle",
    "colorTextAccent",
    "colorTextBodyDefault",
    "colorTextBodySecondary",
    "colorTextBreadcrumbCurrent",
    "colorTextBreadcrumbIcon",
    "colorTextButtonInlineIconDefault",
    "colorTextButtonInlineIconDisabled",
    "colorTextButtonInlineIconHover",
    "colorTextButtonNormalActive",
    "colorTextToggleButtonNormalPressed",
    "colorTextButtonNormalDefault",
    "colorTextButtonNormalHover",
    "colorTextButtonLinkActive",
    "colorTextButtonLinkDefault",
    "colorTextButtonLinkDisabled",
    "colorTextButtonLinkHover",
    "colorTextButtonPrimaryActive",
    "colorTextButtonPrimaryDefault",
    "colorTextButtonPrimaryHover",
    "colorTextCalendarDateSelected",
    "colorTextCounter",
    "colorTextDropdownItemDefault",
    "colorTextDropdownItemDisabled",
    "colorTextDropdownItemFilterMatch",
    "colorTextDropdownItemHighlighted",
    "colorTextDropdownItemSecondary",
    "colorTextEmpty",
    "colorTextExpandableSectionDefault",
    "colorTextExpandableSectionHover",
    "colorTextExpandableSectionNavigationIconDefault",
    "colorTextFormDefault",
    "colorTextFormSecondary",
    "colorTextGroupLabel",
    "colorTextLabelGenAi",
    "colorTextHeadingDefault",
    "colorTextHeadingSecondary",
    "colorTextHomeHeaderDefault",
    "colorTextHomeHeaderSecondary",
    "colorTextIconSubtle",
    "colorTextInputDisabled",
    "colorTextInputPlaceholder",
    "colorTextInteractiveActive",
    "colorTextInteractiveDefault",
    "colorTextInteractiveDisabled",
    "colorTextInteractiveHover",
    "colorTextToggleButtonIconPressed",
    "colorTextInteractiveInvertedDefault",
    "colorTextInteractiveInvertedHover",
    "colorTextLabel",
    "colorTextLayoutToggle",
    "colorTextLayoutToggleActive",
    "colorTextLayoutToggleHover",
    "colorTextLayoutToggleSelected",
    "colorTextLinkDefault",
    "colorTextLinkHover",
    "colorTextLinkDecorationDefault",
    "colorTextLinkDecorationHover",
    "colorTextLinkSecondaryDefault",
    "colorTextLinkSecondaryHover",
    "colorTextLinkInfoDefault",
    "colorTextLinkInfoHover",
    "colorTextNotificationDefault",
    "colorTextNotificationYellow",
    "colorTextSegmentActive",
    "colorTextSegmentDefault",
    "colorTextSegmentHover",
    "colorTextStatusError",
    "colorTextStatusInactive",
    "colorTextStatusInfo",
    "colorTextStatusSuccess",
    "colorTextStatusWarning",
    "colorTextTopNavigationTitle",
    "colorBoardPlaceholderActive",
    "colorBoardPlaceholderHover",
    "colorDragPlaceholderActive",
    "colorDragPlaceholderHover",
    "colorDropzoneBackgroundDefault",
    "colorDropzoneBackgroundHover",
    "colorDropzoneTextDefault",
    "colorDropzoneTextHover",
    "colorDropzoneBorderDefault",
    "colorDropzoneBorderHover",
    "colorTreeViewConnectorLine",
    "colorBackgroundActionCardDefault",
    "colorBackgroundActionCardHover",
    "colorBackgroundActionCardActive",
    "colorBorderActionCardDefault",
    "colorBorderActionCardHover",
    "colorBorderActionCardActive",
    "colorBorderActionCardDisabled",
    "colorBackgroundActionCardDisabled",
    "colorTextActionCardDisabled",
    "colorTextActionCardIconDefault",
    "colorTextActionCardIconHover",
    "colorTextActionCardIconActive",
    "colorTextActionCardIconDisabled",
    "colorBackgroundBadgeGreen",
    "colorBackgroundBadgeBlue",
    "colorBackgroundBadgeRed",
    "colorBackgroundBadgeYellow",
    "colorBackgroundBadgeGrey",
    "colorBorderBadge",
    "colorBorderBadgeGrey",
    "colorBorderBadgeGreen",
    "colorBorderBadgeBlue",
    "colorBorderBadgeRed",
    "colorTextBadgeGrey",
    "colorTextBadgeGreen",
    "colorTextBadgeBlue",
    "colorTextBadgeRed",
    "colorBackgroundCodeView",
    "fontFamilyBase",
    "fontFamilyDisplay",
    "fontFamilyHeading",
    "fontFamilyMonospace",
    "fontSizeBodyM",
    "fontSizeBodyS",
    "fontSizeDisplayL",
    "fontSizeDisplayXl",
    "fontSizeHeadingL",
    "fontSizeHeadingM",
    "fontSizeHeadingS",
    "fontSizeHeadingXl",
    "fontSizeHeadingXs",
    "fontSizeTabs",
    "fontWeightAlertHeader",
    "fontWeightBold",
    "fontWeightButton",
    "fontWeightDisplayL",
    "fontWeightDisplayXl",
    "fontWeightFlashbarHeader",
    "fontWeightHeadingL",
    "fontWeightHeadingM",
    "fontWeightHeadingS",
    "fontWeightHeadingXl",
    "fontWeightHeadingXs",
    "fontWeightHeavy",
    "fontWeightLighter",
    "fontWeightNormal",
    "fontWeightTabs",
    "fontWeightTabsDisabled",
    "letterSpacingDisplayL",
    "letterSpacingDisplayXl",
    "letterSpacingHeadingL",
    "letterSpacingHeadingM",
    "letterSpacingHeadingS",
    "letterSpacingHeadingXl",
    "letterSpacingHeadingXs",
    "lineHeightBodyM",
    "lineHeightBodyS",
    "lineHeightDisplayL",
    "lineHeightDisplayXl",
    "lineHeightHeadingL",
    "lineHeightHeadingM",
    "lineHeightHeadingS",
    "lineHeightHeadingXl",
    "lineHeightHeadingXs",
    "lineHeightTabs",
    "borderRadiusActionCardDefault",
    "borderRadiusActionCardEmbedded",
    "borderRadiusAlert",
    "borderRadiusBadge",
    "borderRadiusButton",
    "borderRadiusCalendarDayFocusRing",
    "borderRadiusCardDefault",
    "borderRadiusCardEmbedded",
    "borderRadiusChatBubble",
    "borderRadiusSupportPrompt",
    "borderRadiusContainer",
    "borderRadiusControlCircularFocusRing",
    "borderRadiusControlDefaultFocusRing",
    "borderRadiusDropdown",
    "borderRadiusDropzone",
    "borderRadiusFlashbar",
    "borderRadiusInput",
    "borderRadiusItem",
    "borderRadiusPopover",
    "borderRadiusTabsFocusRing",
    "borderRadiusTiles",
    "borderRadiusToken",
    "borderRadiusTokenInline",
    "borderRadiusTutorialPanelItem",
    "borderWidthActionCardActive",
    "borderWidthActionCardDefault",
    "borderWidthActionCardDisabled",
    "borderWidthActionCardHover",
    "borderWidthAlert",
    "borderWidthAlertBlockEnd",
    "borderWidthAlertBlockStart",
    "borderWidthAlertInlineEnd",
    "borderWidthAlertInlineStart",
    "borderWidthFlashbarInlineStart",
    "borderWidthButton",
    "borderWidthCard",
    "borderWidthCardSelected",
    "borderWidthDropdown",
    "borderWidthField",
    "borderWidthIconBig",
    "borderWidthIconLarge",
    "borderWidthIconMedium",
    "borderWidthIconNormal",
    "borderWidthIconSmall",
    "borderWidthIconXSmall",
    "borderWidthItemSelected",
    "borderWidthLayoutSideNavigation",
    "borderWidthBadge",
    "borderWidthPopover",
    "borderWidthToken",
    "motionDurationAvatarGenAiGradient",
    "motionDurationAvatarLoadingDots",
    "motionEasingAvatarGenAiGradient",
    "motionEasingResponsive",
    "motionEasingSticky",
    "motionEasingExpressive",
    "motionDurationResponsive",
    "motionDurationExpressive",
    "motionDurationComplex",
    "motionDurationTooltipEnter",
    "motionEasingTooltipEnter",
    "motionKeyframesFadeIn",
    "motionKeyframesFadeOut",
    "motionKeyframesStatusIconError",
    "motionKeyframesScalePopup",
    "sizeVerticalInput",
    "sizeSideNavigationItemHeight",
    "sizeSideNavigationItemCollapsed",
    "sizeSideNavigationCollapsedWidth",
    "spaceAlertVertical",
    "spaceButtonHorizontal",
    "spaceButtonVertical",
    "spaceTokenVertical",
    "spaceFieldVertical",
    "spaceCardHorizontalDefault",
    "spaceCardHorizontalEmbedded",
    "spaceCardVerticalDefault",
    "spaceCardVerticalEmbedded",
    "spaceContainerHorizontal",
    "spaceFieldHorizontal",
    "spaceTabsVertical",
    "spaceTreeViewIndentation",
    "spaceSideNavigationItemDefaultGap",
    "spaceSideNavigationItemIconGap",
    "spaceActionCardHorizontalDefault",
    "spaceActionCardHorizontalEmbedded",
    "spaceActionCardVerticalDefault",
    "spaceActionCardVerticalEmbedded",
    "spaceOptionPaddingVertical",
    "spaceOptionPaddingHorizontal",
    "spaceScaledXxxs",
    "spaceScaledXxs",
    "spaceScaledXs",
    "spaceScaledS",
    "spaceScaledM",
    "spaceScaledL",
    "spaceScaledXl",
    "spaceScaledXxl",
    "spaceScaledXxxl",
    "spaceStaticXxxs",
    "spaceStaticXxs",
    "spaceStaticXs",
    "spaceStaticS",
    "spaceStaticM",
    "spaceStaticL",
    "spaceStaticXl",
    "spaceStaticXxl",
    "spaceStaticXxxl",
    "shadowCard",
    "shadowContainerActive"
  ],
  "variablesMap": {
    "colorPrimary50": "color-primary-50",
    "colorPrimary100": "color-primary-100",
    "colorPrimary200": "color-primary-200",
    "colorPrimary300": "color-primary-300",
    "colorPrimary400": "color-primary-400",
    "colorPrimary500": "color-primary-500",
    "colorPrimary600": "color-primary-600",
    "colorPrimary700": "color-primary-700",
    "colorPrimary800": "color-primary-800",
    "colorPrimary900": "color-primary-900",
    "colorPrimary950": "color-primary-950",
    "colorPrimary1000": "color-primary-1000",
    "colorNeutral50": "color-neutral-50",
    "colorNeutral100": "color-neutral-100",
    "colorNeutral150": "color-neutral-150",
    "colorNeutral200": "color-neutral-200",
    "colorNeutral250": "color-neutral-250",
    "colorNeutral300": "color-neutral-300",
    "colorNeutral350": "color-neutral-350",
    "colorNeutral400": "color-neutral-400",
    "colorNeutral450": "color-neutral-450",
    "colorNeutral500": "color-neutral-500",
    "colorNeutral550": "color-neutral-550",
    "colorNeutral600": "color-neutral-600",
    "colorNeutral650": "color-neutral-650",
    "colorNeutral700": "color-neutral-700",
    "colorNeutral750": "color-neutral-750",
    "colorNeutral800": "color-neutral-800",
    "colorNeutral850": "color-neutral-850",
    "colorNeutral900": "color-neutral-900",
    "colorNeutral950": "color-neutral-950",
    "colorNeutral1000": "color-neutral-1000",
    "colorError50": "color-error-50",
    "colorError100": "color-error-100",
    "colorError400": "color-error-400",
    "colorError600": "color-error-600",
    "colorError700": "color-error-700",
    "colorError800": "color-error-800",
    "colorError900": "color-error-900",
    "colorError950": "color-error-950",
    "colorError1000": "color-error-1000",
    "colorSuccess50": "color-success-50",
    "colorSuccess100": "color-success-100",
    "colorSuccess200": "color-success-200",
    "colorSuccess400": "color-success-400",
    "colorSuccess500": "color-success-500",
    "colorSuccess600": "color-success-600",
    "colorSuccess800": "color-success-800",
    "colorSuccess950": "color-success-950",
    "colorSuccess1000": "color-success-1000",
    "colorWarning50": "color-warning-50",
    "colorWarning100": "color-warning-100",
    "colorWarning200": "color-warning-200",
    "colorWarning400": "color-warning-400",
    "colorWarning500": "color-warning-500",
    "colorWarning600": "color-warning-600",
    "colorWarning800": "color-warning-800",
    "colorWarning900": "color-warning-900",
    "colorWarning950": "color-warning-950",
    "colorWarning1000": "color-warning-1000",
    "colorInfo50": "color-info-50",
    "colorInfo100": "color-info-100",
    "colorInfo300": "color-info-300",
    "colorInfo400": "color-info-400",
    "colorInfo600": "color-info-600",
    "colorInfo700": "color-info-700",
    "colorInfo800": "color-info-800",
    "colorInfo950": "color-info-950",
    "colorInfo1000": "color-info-1000",
    "colorGrey50": "color-grey-50",
    "colorGrey100": "color-grey-100",
    "colorGrey150": "color-grey-150",
    "colorGrey200": "color-grey-200",
    "colorGrey250": "color-grey-250",
    "colorGrey300": "color-grey-300",
    "colorGrey350": "color-grey-350",
    "colorGrey400": "color-grey-400",
    "colorGrey450": "color-grey-450",
    "colorGrey500": "color-grey-500",
    "colorGrey600": "color-grey-600",
    "colorGrey650": "color-grey-650",
    "colorGrey700": "color-grey-700",
    "colorGrey750": "color-grey-750",
    "colorGrey800": "color-grey-800",
    "colorGrey850": "color-grey-850",
    "colorGrey900": "color-grey-900",
    "colorGrey950": "color-grey-950",
    "colorGrey1000": "color-grey-1000",
    "colorBlue50": "color-blue-50",
    "colorBlue100": "color-blue-100",
    "colorBlue200": "color-blue-200",
    "colorBlue300": "color-blue-300",
    "colorBlue400": "color-blue-400",
    "colorBlue600": "color-blue-600",
    "colorBlue700": "color-blue-700",
    "colorBlue900": "color-blue-900",
    "colorBlue1000": "color-blue-1000",
    "colorGreen50": "color-green-50",
    "colorGreen500": "color-green-500",
    "colorGreen600": "color-green-600",
    "colorGreen900": "color-green-900",
    "colorGreen1000": "color-green-1000",
    "colorRed50": "color-red-50",
    "colorRed400": "color-red-400",
    "colorRed600": "color-red-600",
    "colorRed900": "color-red-900",
    "colorRed1000": "color-red-1000",
    "colorYellow50": "color-yellow-50",
    "colorYellow400": "color-yellow-400",
    "colorYellow500": "color-yellow-500",
    "colorYellow900": "color-yellow-900",
    "colorYellow1000": "color-yellow-1000",
    "colorPurple400": "color-purple-400",
    "colorPurple700": "color-purple-700",
    "colorAmber400": "color-amber-400",
    "colorAmber500": "color-amber-500",
    "colorRed950": "color-red-950",
    "colorOrange50": "color-orange-50",
    "colorOrange100": "color-orange-100",
    "colorOrange400": "color-orange-400",
    "colorOrange700": "color-orange-700",
    "colorOrange800": "color-orange-800",
    "colorOrange950": "color-orange-950",
    "colorYellow600": "color-yellow-600",
    "colorYellow950": "color-yellow-950",
    "colorLime50": "color-lime-50",
    "colorLime100": "color-lime-100",
    "colorLime400": "color-lime-400",
    "colorLime700": "color-lime-700",
    "colorLime800": "color-lime-800",
    "colorLime950": "color-lime-950",
    "colorGreen400": "color-green-400",
    "colorGreen950": "color-green-950",
    "colorMint50": "color-mint-50",
    "colorMint100": "color-mint-100",
    "colorMint400": "color-mint-400",
    "colorMint700": "color-mint-700",
    "colorMint800": "color-mint-800",
    "colorMint950": "color-mint-950",
    "colorIndigo50": "color-indigo-50",
    "colorIndigo400": "color-indigo-400",
    "colorIndigo600": "color-indigo-600",
    "colorIndigo950": "color-indigo-950",
    "colorPurple50": "color-purple-50",
    "colorPurple100": "color-purple-100",
    "colorPurple600": "color-purple-600",
    "colorPurple800": "color-purple-800",
    "colorPurple950": "color-purple-950",
    "colorTeal50": "color-teal-50",
    "colorTeal100": "color-teal-100",
    "colorTeal400": "color-teal-400",
    "colorTeal700": "color-teal-700",
    "colorTeal800": "color-teal-800",
    "colorTeal950": "color-teal-950",
    "colorCyan50": "color-cyan-50",
    "colorCyan100": "color-cyan-100",
    "colorCyan400": "color-cyan-400",
    "colorCyan700": "color-cyan-700",
    "colorCyan800": "color-cyan-800",
    "colorCyan950": "color-cyan-950",
    "colorBlue950": "color-blue-950",
    "colorViolet50": "color-violet-50",
    "colorViolet100": "color-violet-100",
    "colorViolet400": "color-violet-400",
    "colorViolet700": "color-violet-700",
    "colorViolet800": "color-violet-800",
    "colorViolet950": "color-violet-950",
    "colorFuchsia50": "color-fuchsia-50",
    "colorFuchsia100": "color-fuchsia-100",
    "colorFuchsia400": "color-fuchsia-400",
    "colorFuchsia700": "color-fuchsia-700",
    "colorFuchsia800": "color-fuchsia-800",
    "colorFuchsia950": "color-fuchsia-950",
    "colorMagenta50": "color-magenta-50",
    "colorMagenta100": "color-magenta-100",
    "colorMagenta400": "color-magenta-400",
    "colorMagenta700": "color-magenta-700",
    "colorMagenta800": "color-magenta-800",
    "colorMagenta950": "color-magenta-950",
    "colorPink50": "color-pink-50",
    "colorPink100": "color-pink-100",
    "colorPink400": "color-pink-400",
    "colorPink700": "color-pink-700",
    "colorPink800": "color-pink-800",
    "colorPink950": "color-pink-950",
    "colorRose50": "color-rose-50",
    "colorRose100": "color-rose-100",
    "colorRose400": "color-rose-400",
    "colorRose700": "color-rose-700",
    "colorRose800": "color-rose-800",
    "colorRose950": "color-rose-950",
    "colorAmber50": "color-amber-50",
    "colorAmber100": "color-amber-100",
    "colorAmber700": "color-amber-700",
    "colorAmber800": "color-amber-800",
    "colorAmber950": "color-amber-950",
    "colorAwsSquidInk": "color-aws-squid-ink",
    "colorTransparent": "color-transparent",
    "colorBlack": "color-black",
    "colorWhite": "color-white",
    "colorChartsRed300": "color-charts-red-300",
    "colorChartsRed400": "color-charts-red-400",
    "colorChartsRed500": "color-charts-red-500",
    "colorChartsRed600": "color-charts-red-600",
    "colorChartsRed700": "color-charts-red-700",
    "colorChartsRed800": "color-charts-red-800",
    "colorChartsRed900": "color-charts-red-900",
    "colorChartsRed1000": "color-charts-red-1000",
    "colorChartsRed1100": "color-charts-red-1100",
    "colorChartsRed1200": "color-charts-red-1200",
    "colorChartsOrange300": "color-charts-orange-300",
    "colorChartsOrange400": "color-charts-orange-400",
    "colorChartsOrange500": "color-charts-orange-500",
    "colorChartsOrange600": "color-charts-orange-600",
    "colorChartsOrange700": "color-charts-orange-700",
    "colorChartsOrange800": "color-charts-orange-800",
    "colorChartsOrange900": "color-charts-orange-900",
    "colorChartsOrange1000": "color-charts-orange-1000",
    "colorChartsOrange1100": "color-charts-orange-1100",
    "colorChartsOrange1200": "color-charts-orange-1200",
    "colorChartsYellow300": "color-charts-yellow-300",
    "colorChartsYellow400": "color-charts-yellow-400",
    "colorChartsYellow500": "color-charts-yellow-500",
    "colorChartsYellow600": "color-charts-yellow-600",
    "colorChartsYellow700": "color-charts-yellow-700",
    "colorChartsYellow800": "color-charts-yellow-800",
    "colorChartsYellow900": "color-charts-yellow-900",
    "colorChartsYellow1000": "color-charts-yellow-1000",
    "colorChartsYellow1100": "color-charts-yellow-1100",
    "colorChartsYellow1200": "color-charts-yellow-1200",
    "colorChartsGreen300": "color-charts-green-300",
    "colorChartsGreen400": "color-charts-green-400",
    "colorChartsGreen500": "color-charts-green-500",
    "colorChartsGreen600": "color-charts-green-600",
    "colorChartsGreen700": "color-charts-green-700",
    "colorChartsGreen800": "color-charts-green-800",
    "colorChartsGreen900": "color-charts-green-900",
    "colorChartsGreen1000": "color-charts-green-1000",
    "colorChartsGreen1100": "color-charts-green-1100",
    "colorChartsGreen1200": "color-charts-green-1200",
    "colorChartsTeal300": "color-charts-teal-300",
    "colorChartsTeal400": "color-charts-teal-400",
    "colorChartsTeal500": "color-charts-teal-500",
    "colorChartsTeal600": "color-charts-teal-600",
    "colorChartsTeal700": "color-charts-teal-700",
    "colorChartsTeal800": "color-charts-teal-800",
    "colorChartsTeal900": "color-charts-teal-900",
    "colorChartsTeal1000": "color-charts-teal-1000",
    "colorChartsTeal1100": "color-charts-teal-1100",
    "colorChartsTeal1200": "color-charts-teal-1200",
    "colorChartsBlue1300": "color-charts-blue-1-300",
    "colorChartsBlue1400": "color-charts-blue-1-400",
    "colorChartsBlue1500": "color-charts-blue-1-500",
    "colorChartsBlue1600": "color-charts-blue-1-600",
    "colorChartsBlue1700": "color-charts-blue-1-700",
    "colorChartsBlue1800": "color-charts-blue-1-800",
    "colorChartsBlue1900": "color-charts-blue-1-900",
    "colorChartsBlue11000": "color-charts-blue-1-1000",
    "colorChartsBlue11100": "color-charts-blue-1-1100",
    "colorChartsBlue11200": "color-charts-blue-1-1200",
    "colorChartsBlue2300": "color-charts-blue-2-300",
    "colorChartsBlue2400": "color-charts-blue-2-400",
    "colorChartsBlue2500": "color-charts-blue-2-500",
    "colorChartsBlue2600": "color-charts-blue-2-600",
    "colorChartsBlue2700": "color-charts-blue-2-700",
    "colorChartsBlue2800": "color-charts-blue-2-800",
    "colorChartsBlue2900": "color-charts-blue-2-900",
    "colorChartsBlue21000": "color-charts-blue-2-1000",
    "colorChartsBlue21100": "color-charts-blue-2-1100",
    "colorChartsBlue21200": "color-charts-blue-2-1200",
    "colorChartsPurple300": "color-charts-purple-300",
    "colorChartsPurple400": "color-charts-purple-400",
    "colorChartsPurple500": "color-charts-purple-500",
    "colorChartsPurple600": "color-charts-purple-600",
    "colorChartsPurple700": "color-charts-purple-700",
    "colorChartsPurple800": "color-charts-purple-800",
    "colorChartsPurple900": "color-charts-purple-900",
    "colorChartsPurple1000": "color-charts-purple-1000",
    "colorChartsPurple1100": "color-charts-purple-1100",
    "colorChartsPurple1200": "color-charts-purple-1200",
    "colorChartsPink300": "color-charts-pink-300",
    "colorChartsPink400": "color-charts-pink-400",
    "colorChartsPink500": "color-charts-pink-500",
    "colorChartsPink600": "color-charts-pink-600",
    "colorChartsPink700": "color-charts-pink-700",
    "colorChartsPink800": "color-charts-pink-800",
    "colorChartsPink900": "color-charts-pink-900",
    "colorChartsPink1000": "color-charts-pink-1000",
    "colorChartsPink1100": "color-charts-pink-1100",
    "colorChartsPink1200": "color-charts-pink-1200",
    "colorChartsStatusCritical": "color-charts-status-critical",
    "colorChartsStatusHigh": "color-charts-status-high",
    "colorChartsStatusMedium": "color-charts-status-medium",
    "colorChartsStatusLow": "color-charts-status-low",
    "colorChartsStatusPositive": "color-charts-status-positive",
    "colorChartsStatusInfo": "color-charts-status-info",
    "colorChartsStatusNeutral": "color-charts-status-neutral",
    "colorChartsThresholdNegative": "color-charts-threshold-negative",
    "colorChartsThresholdPositive": "color-charts-threshold-positive",
    "colorChartsThresholdInfo": "color-charts-threshold-info",
    "colorChartsThresholdNeutral": "color-charts-threshold-neutral",
    "colorChartsLineGrid": "color-charts-line-grid",
    "colorChartsLineTick": "color-charts-line-tick",
    "colorChartsLineAxis": "color-charts-line-axis",
    "colorChartsPaletteCategorical1": "color-charts-palette-categorical-1",
    "colorChartsPaletteCategorical2": "color-charts-palette-categorical-2",
    "colorChartsPaletteCategorical3": "color-charts-palette-categorical-3",
    "colorChartsPaletteCategorical4": "color-charts-palette-categorical-4",
    "colorChartsPaletteCategorical5": "color-charts-palette-categorical-5",
    "colorChartsPaletteCategorical6": "color-charts-palette-categorical-6",
    "colorChartsPaletteCategorical7": "color-charts-palette-categorical-7",
    "colorChartsPaletteCategorical8": "color-charts-palette-categorical-8",
    "colorChartsPaletteCategorical9": "color-charts-palette-categorical-9",
    "colorChartsPaletteCategorical10": "color-charts-palette-categorical-10",
    "colorChartsPaletteCategorical11": "color-charts-palette-categorical-11",
    "colorChartsPaletteCategorical12": "color-charts-palette-categorical-12",
    "colorChartsPaletteCategorical13": "color-charts-palette-categorical-13",
    "colorChartsPaletteCategorical14": "color-charts-palette-categorical-14",
    "colorChartsPaletteCategorical15": "color-charts-palette-categorical-15",
    "colorChartsPaletteCategorical16": "color-charts-palette-categorical-16",
    "colorChartsPaletteCategorical17": "color-charts-palette-categorical-17",
    "colorChartsPaletteCategorical18": "color-charts-palette-categorical-18",
    "colorChartsPaletteCategorical19": "color-charts-palette-categorical-19",
    "colorChartsPaletteCategorical20": "color-charts-palette-categorical-20",
    "colorChartsPaletteCategorical21": "color-charts-palette-categorical-21",
    "colorChartsPaletteCategorical22": "color-charts-palette-categorical-22",
    "colorChartsPaletteCategorical23": "color-charts-palette-categorical-23",
    "colorChartsPaletteCategorical24": "color-charts-palette-categorical-24",
    "colorChartsPaletteCategorical25": "color-charts-palette-categorical-25",
    "colorChartsPaletteCategorical26": "color-charts-palette-categorical-26",
    "colorChartsPaletteCategorical27": "color-charts-palette-categorical-27",
    "colorChartsPaletteCategorical28": "color-charts-palette-categorical-28",
    "colorChartsPaletteCategorical29": "color-charts-palette-categorical-29",
    "colorChartsPaletteCategorical30": "color-charts-palette-categorical-30",
    "colorChartsPaletteCategorical31": "color-charts-palette-categorical-31",
    "colorChartsPaletteCategorical32": "color-charts-palette-categorical-32",
    "colorChartsPaletteCategorical33": "color-charts-palette-categorical-33",
    "colorChartsPaletteCategorical34": "color-charts-palette-categorical-34",
    "colorChartsPaletteCategorical35": "color-charts-palette-categorical-35",
    "colorChartsPaletteCategorical36": "color-charts-palette-categorical-36",
    "colorChartsPaletteCategorical37": "color-charts-palette-categorical-37",
    "colorChartsPaletteCategorical38": "color-charts-palette-categorical-38",
    "colorChartsPaletteCategorical39": "color-charts-palette-categorical-39",
    "colorChartsPaletteCategorical40": "color-charts-palette-categorical-40",
    "colorChartsPaletteCategorical41": "color-charts-palette-categorical-41",
    "colorChartsPaletteCategorical42": "color-charts-palette-categorical-42",
    "colorChartsPaletteCategorical43": "color-charts-palette-categorical-43",
    "colorChartsPaletteCategorical44": "color-charts-palette-categorical-44",
    "colorChartsPaletteCategorical45": "color-charts-palette-categorical-45",
    "colorChartsPaletteCategorical46": "color-charts-palette-categorical-46",
    "colorChartsPaletteCategorical47": "color-charts-palette-categorical-47",
    "colorChartsPaletteCategorical48": "color-charts-palette-categorical-48",
    "colorChartsPaletteCategorical49": "color-charts-palette-categorical-49",
    "colorChartsPaletteCategorical50": "color-charts-palette-categorical-50",
    "colorChartsErrorBarMarker": "color-charts-error-bar-marker",
    "colorSeverityDarkRed": "color-severity-dark-red",
    "colorSeverityRed": "color-severity-red",
    "colorSeverityOrange": "color-severity-orange",
    "colorSeverityYellow": "color-severity-yellow",
    "colorSeverityGrey": "color-severity-grey",
    "colorBackgroundNotificationSeverityCritical": "color-background-notification-severity-critical",
    "colorBackgroundNotificationSeverityHigh": "color-background-notification-severity-high",
    "colorBackgroundNotificationSeverityMedium": "color-background-notification-severity-medium",
    "colorBackgroundNotificationSeverityLow": "color-background-notification-severity-low",
    "colorBackgroundNotificationSeverityNeutral": "color-background-notification-severity-neutral",
    "colorTextNotificationSeverityCritical": "color-text-notification-severity-critical",
    "colorTextNotificationSeverityHigh": "color-text-notification-severity-high",
    "colorTextNotificationSeverityMedium": "color-text-notification-severity-medium",
    "colorTextNotificationSeverityLow": "color-text-notification-severity-low",
    "colorTextNotificationSeverityNeutral": "color-text-notification-severity-neutral",
    "colorBorderBadgeSeverityCritical": "color-border-badge-severity-critical",
    "colorBorderBadgeSeverityHigh": "color-border-badge-severity-high",
    "colorBorderBadgeSeverityMedium": "color-border-badge-severity-medium",
    "colorBorderBadgeSeverityLow": "color-border-badge-severity-low",
    "colorBorderBadgeSeverityNeutral": "color-border-badge-severity-neutral",
    "colorTextBadgeSeverityCritical": "color-text-badge-severity-critical",
    "colorTextBadgeSeverityHigh": "color-text-badge-severity-high",
    "colorTextBadgeSeverityMedium": "color-text-badge-severity-medium",
    "colorTextBadgeSeverityLow": "color-text-badge-severity-low",
    "colorTextBadgeSeverityNeutral": "color-text-badge-severity-neutral",
    "colorGreyOpaque10": "color-grey-opaque-10",
    "colorGreyOpaque25": "color-grey-opaque-25",
    "colorGreyOpaque40": "color-grey-opaque-40",
    "colorGreyOpaque50": "color-grey-opaque-50",
    "colorGreyOpaque70": "color-grey-opaque-70",
    "colorGreyOpaque80": "color-grey-opaque-80",
    "colorGreyOpaque90": "color-grey-opaque-90",
    "colorGreyTransparent": "color-grey-transparent",
    "colorGreyTransparentHeavy": "color-grey-transparent-heavy",
    "colorGreyTransparentLight": "color-grey-transparent-light",
    "colorBackgroundBadgeIcon": "color-background-badge-icon",
    "colorBackgroundButtonLinkActive": "color-background-button-link-active",
    "colorBackgroundButtonLinkDefault": "color-background-button-link-default",
    "colorBackgroundButtonLinkDisabled": "color-background-button-link-disabled",
    "colorBackgroundButtonLinkHover": "color-background-button-link-hover",
    "colorBackgroundButtonNormalActive": "color-background-button-normal-active",
    "colorBackgroundButtonNormalDefault": "color-background-button-normal-default",
    "colorBackgroundButtonNormalDisabled": "color-background-button-normal-disabled",
    "colorBackgroundButtonNormalHover": "color-background-button-normal-hover",
    "colorBackgroundToggleButtonNormalPressed": "color-background-toggle-button-normal-pressed",
    "colorBackgroundToggleButtonNormalDefault": "color-background-toggle-button-normal-default",
    "colorBackgroundToggleButtonNormalHover": "color-background-toggle-button-normal-hover",
    "colorBackgroundButtonPrimaryActive": "color-background-button-primary-active",
    "colorBackgroundButtonPrimaryDefault": "color-background-button-primary-default",
    "colorBackgroundButtonPrimaryDisabled": "color-background-button-primary-disabled",
    "colorBackgroundButtonPrimaryHover": "color-background-button-primary-hover",
    "colorBackgroundDirectionButtonActive": "color-background-direction-button-active",
    "colorBackgroundDirectionButtonDefault": "color-background-direction-button-default",
    "colorBackgroundDirectionButtonDisabled": "color-background-direction-button-disabled",
    "colorBackgroundDirectionButtonHover": "color-background-direction-button-hover",
    "colorTextDirectionButtonDefault": "color-text-direction-button-default",
    "colorTextDirectionButtonDisabled": "color-text-direction-button-disabled",
    "colorBackgroundCalendarCurrentDate": "color-background-calendar-current-date",
    "colorBackgroundCellShaded": "color-background-cell-shaded",
    "colorBackgroundCodeEditorGutterActiveLineDefault": "color-background-code-editor-gutter-active-line-default",
    "colorBackgroundCodeEditorGutterActiveLineError": "color-background-code-editor-gutter-active-line-error",
    "colorBackgroundCodeEditorGutterDefault": "color-background-code-editor-gutter-default",
    "colorBackgroundCodeEditorLoading": "color-background-code-editor-loading",
    "colorBackgroundCodeEditorPaneItemHover": "color-background-code-editor-pane-item-hover",
    "colorBackgroundCodeEditorStatusBar": "color-background-code-editor-status-bar",
    "colorBackgroundCard": "color-background-card",
    "colorBackgroundItemCard": "color-background-item-card",
    "colorBackgroundContainerContent": "color-background-container-content",
    "colorBackgroundContainerHeader": "color-background-container-header",
    "colorBackgroundControlChecked": "color-background-control-checked",
    "colorBackgroundControlDefault": "color-background-control-default",
    "colorBackgroundControlDisabled": "color-background-control-disabled",
    "colorBackgroundDropdownItemDefault": "color-background-dropdown-item-default",
    "colorBackgroundDropdownItemDimmed": "color-background-dropdown-item-dimmed",
    "colorBackgroundDropdownItemFilterMatch": "color-background-dropdown-item-filter-match",
    "colorBackgroundDropdownItemHover": "color-background-dropdown-item-hover",
    "colorBackgroundDropdownItemSelected": "color-background-dropdown-item-selected",
    "colorBackgroundHomeHeader": "color-background-home-header",
    "colorBackgroundInlineCode": "color-background-inline-code",
    "colorBackgroundInputDefault": "color-background-input-default",
    "colorBackgroundInputDisabled": "color-background-input-disabled",
    "colorBackgroundItemSelected": "color-background-item-selected",
    "colorBackgroundSideNavigationItemActive": "color-background-side-navigation-item-active",
    "colorBackgroundSideNavigationItemActiveCollapsed": "color-background-side-navigation-item-active-collapsed",
    "colorBackgroundSideNavigationItemIconHover": "color-background-side-navigation-item-icon-hover",
    "colorBackgroundLayoutMain": "color-background-layout-main",
    "colorBackgroundLayoutAiDrawer": "color-background-layout-ai-drawer",
    "colorBackgroundDrawer": "color-background-drawer",
    "colorBackgroundBackdrop": "color-background-backdrop",
    "colorBackgroundDrawerBackdrop": "color-background-drawer-backdrop",
    "colorBackgroundLayoutMobilePanel": "color-background-layout-mobile-panel",
    "colorBackgroundLayoutPanel": "color-background-layout-panel",
    "colorBackgroundLayoutPanelContent": "color-background-layout-panel-content",
    "colorBackgroundLayoutPanelHover": "color-background-layout-panel-hover",
    "colorBackgroundLayoutToolbar": "color-background-layout-toolbar",
    "colorBackgroundLayoutToggleActive": "color-background-layout-toggle-active",
    "colorBackgroundLayoutToggleDefault": "color-background-layout-toggle-default",
    "colorBackgroundLayoutToggleHover": "color-background-layout-toggle-hover",
    "colorBackgroundLayoutToggleSelectedActive": "color-background-layout-toggle-selected-active",
    "colorBackgroundLayoutToggleSelectedDefault": "color-background-layout-toggle-selected-default",
    "colorBackgroundLayoutToggleSelectedHover": "color-background-layout-toggle-selected-hover",
    "colorBackgroundModalOverlay": "color-background-modal-overlay",
    "colorBackgroundNotificationBlue": "color-background-notification-blue",
    "colorBackgroundNotificationGreen": "color-background-notification-green",
    "colorBackgroundNotificationGrey": "color-background-notification-grey",
    "colorBackgroundNotificationRed": "color-background-notification-red",
    "colorBackgroundNotificationYellow": "color-background-notification-yellow",
    "colorBackgroundFlashbarSuccess": "color-background-flashbar-success",
    "colorBackgroundFlashbarError": "color-background-flashbar-error",
    "colorBackgroundFlashbarInfo": "color-background-flashbar-info",
    "colorBackgroundFlashbarWarning": "color-background-flashbar-warning",
    "colorBackgroundNotificationStackBar": "color-background-notification-stack-bar",
    "colorBackgroundNotificationStackBarActive": "color-background-notification-stack-bar-active",
    "colorBackgroundNotificationStackBarHover": "color-background-notification-stack-bar-hover",
    "colorBackgroundPopover": "color-background-popover",
    "colorBackgroundProgressBarValueDefault": "color-background-progress-bar-value-default",
    "colorBackgroundProgressBarValueFlash": "color-background-progress-bar-value-flash",
    "colorBackgroundProgressBarFlash": "color-background-progress-bar-flash",
    "colorBackgroundProgressBarDefault": "color-background-progress-bar-default",
    "colorBackgroundSegmentActive": "color-background-segment-active",
    "colorBackgroundSegmentDefault": "color-background-segment-default",
    "colorBackgroundSegmentDisabled": "color-background-segment-disabled",
    "colorBackgroundSegmentHover": "color-background-segment-hover",
    "colorBackgroundSegmentWrapper": "color-background-segment-wrapper",
    "colorBackgroundSliderRangeDefault": "color-background-slider-range-default",
    "colorBackgroundSliderRangeActive": "color-background-slider-range-active",
    "colorBackgroundSliderHandleDefault": "color-background-slider-handle-default",
    "colorBackgroundSliderHandleActive": "color-background-slider-handle-active",
    "colorBackgroundSliderTrackDefault": "color-background-slider-track-default",
    "colorBackgroundSliderHandleRing": "color-background-slider-handle-ring",
    "colorBackgroundSliderHandleErrorDefault": "color-background-slider-handle-error-default",
    "colorBackgroundSliderHandleErrorActive": "color-background-slider-handle-error-active",
    "colorBackgroundSliderHandleWarningDefault": "color-background-slider-handle-warning-default",
    "colorBackgroundSliderHandleWarningActive": "color-background-slider-handle-warning-active",
    "colorBackgroundSliderRangeErrorDefault": "color-background-slider-range-error-default",
    "colorBackgroundSliderRangeErrorActive": "color-background-slider-range-error-active",
    "colorBackgroundSliderRangeWarningDefault": "color-background-slider-range-warning-default",
    "colorBackgroundSliderRangeWarningActive": "color-background-slider-range-warning-active",
    "colorBackgroundStatusError": "color-background-status-error",
    "colorBackgroundStatusInfo": "color-background-status-info",
    "colorBackgroundAlertError": "color-background-alert-error",
    "colorBackgroundAlertInfo": "color-background-alert-info",
    "colorBackgroundAlertSuccess": "color-background-alert-success",
    "colorBackgroundAlertWarning": "color-background-alert-warning",
    "colorBackgroundDialog": "color-background-dialog",
    "colorBackgroundDialogDefault": "color-background-dialog-default",
    "colorBackgroundStatusSuccess": "color-background-status-success",
    "colorBackgroundStatusWarning": "color-background-status-warning",
    "colorBackgroundTableHeader": "color-background-table-header",
    "colorBackgroundTilesDisabled": "color-background-tiles-disabled",
    "colorBackgroundToggleCheckedDisabled": "color-background-toggle-checked-disabled",
    "colorBackgroundToggleDefault": "color-background-toggle-default",
    "colorBackgroundAvatarGenAi": "color-background-avatar-gen-ai",
    "colorBackgroundAvatarDefault": "color-background-avatar-default",
    "colorTextAvatar": "color-text-avatar",
    "colorBackgroundLoadingBarGenAi": "color-background-loading-bar-gen-ai",
    "colorBackgroundStatusIndicatorError": "color-background-status-indicator-error",
    "colorBackgroundStatusIndicatorWarning": "color-background-status-indicator-warning",
    "colorBackgroundStatusIndicatorSuccess": "color-background-status-indicator-success",
    "colorBackgroundStatusIndicatorInfo": "color-background-status-indicator-info",
    "colorBackgroundStatusIndicatorNeutral": "color-background-status-indicator-neutral",
    "colorBackgroundChatBubbleOutgoing": "color-background-chat-bubble-outgoing",
    "colorBackgroundChatBubbleIncoming": "color-background-chat-bubble-incoming",
    "colorTextChatBubbleOutgoing": "color-text-chat-bubble-outgoing",
    "colorTextChatBubbleIncoming": "color-text-chat-bubble-incoming",
    "colorBorderButtonLinkDisabled": "color-border-button-link-disabled",
    "colorBorderButtonNormalActive": "color-border-button-normal-active",
    "colorBorderButtonNormalDefault": "color-border-button-normal-default",
    "colorBorderToggleButtonNormalPressed": "color-border-toggle-button-normal-pressed",
    "colorBorderToggleButtonNormalDefault": "color-border-toggle-button-normal-default",
    "colorBorderToggleButtonNormalHover": "color-border-toggle-button-normal-hover",
    "colorBorderButtonNormalDisabled": "color-border-button-normal-disabled",
    "colorTextButtonNormalDisabled": "color-text-button-normal-disabled",
    "colorBorderButtonNormalHover": "color-border-button-normal-hover",
    "colorTextButtonIconDisabled": "color-text-button-icon-disabled",
    "colorBorderButtonPrimaryActive": "color-border-button-primary-active",
    "colorBorderButtonPrimaryDefault": "color-border-button-primary-default",
    "colorBorderButtonPrimaryDisabled": "color-border-button-primary-disabled",
    "colorBorderButtonPrimaryHover": "color-border-button-primary-hover",
    "colorTextButtonPrimaryDisabled": "color-text-button-primary-disabled",
    "colorItemSelected": "color-item-selected",
    "colorTextSideNavigationItemActive": "color-text-side-navigation-item-active",
    "colorTextSideNavigationItemActiveCollapsed": "color-text-side-navigation-item-active-collapsed",
    "colorTextSideNavigationItemDefault": "color-text-side-navigation-item-default",
    "colorBorderCalendarGrid": "color-border-calendar-grid",
    "colorBorderCalendarGridSelectedFocusRing": "color-border-calendar-grid-selected-focus-ring",
    "colorBorderCellShaded": "color-border-cell-shaded",
    "colorBorderCodeEditorAceActiveLineLightTheme": "color-border-code-editor-ace-active-line-light-theme",
    "colorBorderCodeEditorAceActiveLineDarkTheme": "color-border-code-editor-ace-active-line-dark-theme",
    "colorBorderCodeEditorDefault": "color-border-code-editor-default",
    "colorBorderCodeEditorPaneItemHover": "color-border-code-editor-pane-item-hover",
    "colorBorderCard": "color-border-card",
    "colorBorderCardHighlighted": "color-border-card-highlighted",
    "colorBorderItemCard": "color-border-item-card",
    "colorBorderItemCardHighlighted": "color-border-item-card-highlighted",
    "colorBorderContainerDivider": "color-border-container-divider",
    "colorBorderContainerTop": "color-border-container-top",
    "colorBorderControlChecked": "color-border-control-checked",
    "colorBorderControlDefault": "color-border-control-default",
    "colorBorderControlDisabled": "color-border-control-disabled",
    "colorBorderDividerActive": "color-border-divider-active",
    "colorBorderDividerDefault": "color-border-divider-default",
    "colorBorderDividerNotification": "color-border-divider-notification",
    "colorBorderDividerPanelBottom": "color-border-divider-panel-bottom",
    "colorBorderDividerPanelSide": "color-border-divider-panel-side",
    "colorBorderDividerSecondary": "color-border-divider-secondary",
    "colorBorderDividerTableGroup": "color-border-divider-table-group",
    "colorBorderDropdownContainer": "color-border-dropdown-container",
    "colorBorderDropdownGroup": "color-border-dropdown-group",
    "colorBorderDropdownItemDefault": "color-border-dropdown-item-default",
    "colorBorderDropdownItemHover": "color-border-dropdown-item-hover",
    "colorBorderDropdownItemDimmedHover": "color-border-dropdown-item-dimmed-hover",
    "colorBorderDropdownItemSelected": "color-border-dropdown-item-selected",
    "colorBorderDropdownItemTop": "color-border-dropdown-item-top",
    "colorBorderEditableCellHover": "color-border-editable-cell-hover",
    "colorBorderInputDefault": "color-border-input-default",
    "colorBorderInputDisabled": "color-border-input-disabled",
    "colorBorderInputFocused": "color-border-input-focused",
    "colorBorderItemFocused": "color-border-item-focused",
    "colorBorderDropdownItemFocused": "color-border-dropdown-item-focused",
    "colorBorderItemPlaceholder": "color-border-item-placeholder",
    "colorBorderItemSelected": "color-border-item-selected",
    "colorBorderLayout": "color-border-layout",
    "colorBorderLayoutSideNavigation": "color-border-layout-side-navigation",
    "colorBorderNotificationStackBar": "color-border-notification-stack-bar",
    "colorBorderNotificationStackBarHover": "color-border-notification-stack-bar-hover",
    "colorBorderNotificationStackBarActive": "color-border-notification-stack-bar-active",
    "colorBorderNotificationStackBarFocused": "color-border-notification-stack-bar-focused",
    "colorBorderPanelHeader": "color-border-panel-header",
    "colorBorderPopover": "color-border-popover",
    "colorBorderSegmentActive": "color-border-segment-active",
    "colorBorderSegmentDefault": "color-border-segment-default",
    "colorBorderSegmentDisabled": "color-border-segment-disabled",
    "colorBorderSegmentDivider": "color-border-segment-divider",
    "colorBorderSegmentHover": "color-border-segment-hover",
    "colorBorderSegmentWrapper": "color-border-segment-wrapper",
    "colorBorderStatusError": "color-border-status-error",
    "colorBorderStatusInfo": "color-border-status-info",
    "colorBorderStatusSuccess": "color-border-status-success",
    "colorBorderStatusWarning": "color-border-status-warning",
    "colorBorderDialog": "color-border-dialog",
    "colorBorderDialogDefault": "color-border-dialog-default",
    "colorBorderDividerInteractiveDefault": "color-border-divider-interactive-default",
    "colorBorderTabsDivider": "color-border-tabs-divider",
    "colorBorderTabsShadow": "color-border-tabs-shadow",
    "colorBorderTabsUnderline": "color-border-tabs-underline",
    "colorBorderTilesDisabled": "color-border-tiles-disabled",
    "colorBorderTutorial": "color-border-tutorial",
    "colorForegroundControlDefault": "color-foreground-control-default",
    "colorForegroundControlDisabled": "color-foreground-control-disabled",
    "colorForegroundControlReadOnly": "color-foreground-control-read-only",
    "colorShadowDefault": "color-shadow-default",
    "colorShadowMedium": "color-shadow-medium",
    "colorShadowSide": "color-shadow-side",
    "colorShadowToggleHandle": "color-shadow-toggle-handle",
    "colorStrokeChartLine": "color-stroke-chart-line",
    "colorStrokeCodeEditorGutterActiveLineDefault": "color-stroke-code-editor-gutter-active-line-default",
    "colorStrokeCodeEditorGutterActiveLineHover": "color-stroke-code-editor-gutter-active-line-hover",
    "colorTextAccent": "color-text-accent",
    "colorTextBodyDefault": "color-text-body-default",
    "colorTextBodySecondary": "color-text-body-secondary",
    "colorTextBreadcrumbCurrent": "color-text-breadcrumb-current",
    "colorTextBreadcrumbIcon": "color-text-breadcrumb-icon",
    "colorTextButtonInlineIconDefault": "color-text-button-inline-icon-default",
    "colorTextButtonInlineIconDisabled": "color-text-button-inline-icon-disabled",
    "colorTextButtonInlineIconHover": "color-text-button-inline-icon-hover",
    "colorTextButtonInlineLinkHover": "color-text-button-inline-link-hover",
    "colorTextButtonIconHover": "color-text-button-icon-hover",
    "colorTextButtonNormalActive": "color-text-button-normal-active",
    "colorTextToggleButtonNormalPressed": "color-text-toggle-button-normal-pressed",
    "colorTextButtonNormalDefault": "color-text-button-normal-default",
    "colorTextButtonNormalHover": "color-text-button-normal-hover",
    "colorTextLinkButtonNormalDefault": "color-text-link-button-normal-default",
    "colorTextLinkButtonNormalHover": "color-text-link-button-normal-hover",
    "colorTextLinkButtonNormalActive": "color-text-link-button-normal-active",
    "colorTextButtonLinkActive": "color-text-button-link-active",
    "colorTextButtonLinkDefault": "color-text-button-link-default",
    "colorTextButtonLinkDisabled": "color-text-button-link-disabled",
    "colorTextButtonLinkHover": "color-text-button-link-hover",
    "colorTextButtonPrimaryActive": "color-text-button-primary-active",
    "colorTextButtonPrimaryDefault": "color-text-button-primary-default",
    "colorTextButtonPrimaryHover": "color-text-button-primary-hover",
    "colorTextCalendarDateHover": "color-text-calendar-date-hover",
    "colorTextCalendarDateSelected": "color-text-calendar-date-selected",
    "colorTextCalendarMonth": "color-text-calendar-month",
    "colorTextCodeEditorGutterActiveLine": "color-text-code-editor-gutter-active-line",
    "colorTextCodeEditorGutterDefault": "color-text-code-editor-gutter-default",
    "colorTextCodeEditorStatusBarDisabled": "color-text-code-editor-status-bar-disabled",
    "colorTextCodeEditorTabButtonError": "color-text-code-editor-tab-button-error",
    "colorTextColumnHeader": "color-text-column-header",
    "colorTextColumnSortingIcon": "color-text-column-sorting-icon",
    "colorTextControlDisabled": "color-text-control-disabled",
    "colorTextCounter": "color-text-counter",
    "colorTextDisabled": "color-text-disabled",
    "colorTextDisabledInlineEdit": "color-text-disabled-inline-edit",
    "colorTextDropdownFooter": "color-text-dropdown-footer",
    "colorTextDropdownGroupLabel": "color-text-dropdown-group-label",
    "colorTextDropdownItemDefault": "color-text-dropdown-item-default",
    "colorTextDropdownItemDimmed": "color-text-dropdown-item-dimmed",
    "colorTextDropdownItemDisabled": "color-text-dropdown-item-disabled",
    "colorTextDropdownItemFilterMatch": "color-text-dropdown-item-filter-match",
    "colorTextDropdownItemHighlighted": "color-text-dropdown-item-highlighted",
    "colorTextDropdownItemSecondary": "color-text-dropdown-item-secondary",
    "colorTextDropdownItemSecondaryHover": "color-text-dropdown-item-secondary-hover",
    "colorTextEmpty": "color-text-empty",
    "colorTextExpandableSectionDefault": "color-text-expandable-section-default",
    "colorTextExpandableSectionHover": "color-text-expandable-section-hover",
    "colorTextExpandableSectionNavigationIconDefault": "color-text-expandable-section-navigation-icon-default",
    "colorBorderExpandableSectionDefault": "color-border-expandable-section-default",
    "colorTextFormDefault": "color-text-form-default",
    "colorTextFormLabel": "color-text-form-label",
    "colorTextFormSecondary": "color-text-form-secondary",
    "colorTextGroupLabel": "color-text-group-label",
    "colorTextLabelGenAi": "color-text-label-gen-ai",
    "colorTextHeadingDefault": "color-text-heading-default",
    "colorTextHeadingSecondary": "color-text-heading-secondary",
    "colorTextHomeHeaderDefault": "color-text-home-header-default",
    "colorTextHomeHeaderSecondary": "color-text-home-header-secondary",
    "colorTextIconCaret": "color-text-icon-caret",
    "colorTextIconSubtle": "color-text-icon-subtle",
    "colorTextInputDisabled": "color-text-input-disabled",
    "colorTextInputPlaceholder": "color-text-input-placeholder",
    "colorTextInputPlaceholderDisabled": "color-text-input-placeholder-disabled",
    "colorTextInteractiveActive": "color-text-interactive-active",
    "colorTextInteractiveDefault": "color-text-interactive-default",
    "colorTextInteractiveDisabled": "color-text-interactive-disabled",
    "colorTextInteractiveHover": "color-text-interactive-hover",
    "colorTextToggleButtonIconPressed": "color-text-toggle-button-icon-pressed",
    "colorTextInteractiveInvertedDefault": "color-text-interactive-inverted-default",
    "colorTextInteractiveInvertedHover": "color-text-interactive-inverted-hover",
    "colorTextInverted": "color-text-inverted",
    "colorTextLabel": "color-text-label",
    "colorTextKeyValuePairsValue": "color-text-key-value-pairs-value",
    "colorTextLayoutToggle": "color-text-layout-toggle",
    "colorTextLayoutToggleActive": "color-text-layout-toggle-active",
    "colorTextLayoutToggleHover": "color-text-layout-toggle-hover",
    "colorTextLayoutToggleSelected": "color-text-layout-toggle-selected",
    "colorTextLinkDefault": "color-text-link-default",
    "colorTextLinkHover": "color-text-link-hover",
    "colorTextLinkDecorationDefault": "color-text-link-decoration-default",
    "colorTextLinkDecorationHover": "color-text-link-decoration-hover",
    "colorTextLinkSecondaryDefault": "color-text-link-secondary-default",
    "colorTextLinkSecondaryHover": "color-text-link-secondary-hover",
    "colorTextLinkSecondaryDecorationDefault": "color-text-link-secondary-decoration-default",
    "colorTextLinkInfoDefault": "color-text-link-info-default",
    "colorTextLinkInfoHover": "color-text-link-info-hover",
    "colorTextLinkInvertedDefault": "color-text-link-inverted-default",
    "colorTextLinkInvertedHover": "color-text-link-inverted-hover",
    "colorTextLinkButtonUnderline": "color-text-link-button-underline",
    "colorTextLinkButtonUnderlineHover": "color-text-link-button-underline-hover",
    "colorTextNotificationDefault": "color-text-notification-default",
    "colorTextAlertDefault": "color-text-alert-default",
    "colorTextNotificationLinkDefault": "color-text-notification-link-default",
    "colorTextNotificationLinkHover": "color-text-notification-link-hover",
    "colorTextNotificationStackBar": "color-text-notification-stack-bar",
    "colorTextNotificationYellow": "color-text-notification-yellow",
    "colorTextPaginationPageNumberActiveDisabled": "color-text-pagination-page-number-active-disabled",
    "colorTextPaginationPageNumberDefault": "color-text-pagination-page-number-default",
    "colorTextSegmentActive": "color-text-segment-active",
    "colorTextSegmentDefault": "color-text-segment-default",
    "colorTextSegmentHover": "color-text-segment-hover",
    "colorTextSmall": "color-text-small",
    "colorTextFlashbarIconError": "color-text-flashbar-icon-error",
    "colorTextFlashbarIconInfo": "color-text-flashbar-icon-info",
    "colorTextFlashbarIconSuccess": "color-text-flashbar-icon-success",
    "colorTextFlashbarIconWarning": "color-text-flashbar-icon-warning",
    "colorTextAlertIconError": "color-text-alert-icon-error",
    "colorTextAlertIconInfo": "color-text-alert-icon-info",
    "colorTextAlertIconSuccess": "color-text-alert-icon-success",
    "colorTextAlertIconWarning": "color-text-alert-icon-warning",
    "colorTextStatusError": "color-text-status-error",
    "colorTextStatusInactive": "color-text-status-inactive",
    "colorTextStatusInfo": "color-text-status-info",
    "colorTextStatusSuccess": "color-text-status-success",
    "colorTextStatusWarning": "color-text-status-warning",
    "colorTextTopNavigationTitle": "color-text-top-navigation-title",
    "colorTextTutorialHotspotDefault": "color-text-tutorial-hotspot-default",
    "colorTextTutorialHotspotHover": "color-text-tutorial-hotspot-hover",
    "colorBoardPlaceholderActive": "color-board-placeholder-active",
    "colorBoardPlaceholderHover": "color-board-placeholder-hover",
    "colorDragPlaceholderActive": "color-drag-placeholder-active",
    "colorDragPlaceholderHover": "color-drag-placeholder-hover",
    "colorDropzoneBackgroundDefault": "color-dropzone-background-default",
    "colorDropzoneBackgroundHover": "color-dropzone-background-hover",
    "colorDropzoneTextDefault": "color-dropzone-text-default",
    "colorDropzoneTextHover": "color-dropzone-text-hover",
    "colorDropzoneBorderDefault": "color-dropzone-border-default",
    "colorDropzoneBorderHover": "color-dropzone-border-hover",
    "colorGapGlobalDrawer": "color-gap-global-drawer",
    "colorTreeViewConnectorLine": "color-tree-view-connector-line",
    "colorBackgroundActionCardDefault": "color-background-action-card-default",
    "colorBackgroundActionCardHover": "color-background-action-card-hover",
    "colorBackgroundActionCardActive": "color-background-action-card-active",
    "colorBorderActionCardDefault": "color-border-action-card-default",
    "colorBorderActionCardHover": "color-border-action-card-hover",
    "colorBorderActionCardActive": "color-border-action-card-active",
    "colorBorderActionCardDisabled": "color-border-action-card-disabled",
    "colorBackgroundActionCardDisabled": "color-background-action-card-disabled",
    "colorTextActionCardDisabled": "color-text-action-card-disabled",
    "colorTextActionCardIconDefault": "color-text-action-card-icon-default",
    "colorTextActionCardIconHover": "color-text-action-card-icon-hover",
    "colorTextActionCardIconActive": "color-text-action-card-icon-active",
    "colorTextActionCardIconDisabled": "color-text-action-card-icon-disabled",
    "colorBackgroundSkeleton": "color-background-skeleton",
    "colorBackgroundSkeletonWave": "color-background-skeleton-wave",
    "colorBackgroundBadgeGreen": "color-background-badge-green",
    "colorBackgroundBadgeBlue": "color-background-badge-blue",
    "colorBackgroundBadgeRed": "color-background-badge-red",
    "colorBackgroundBadgeYellow": "color-background-badge-yellow",
    "colorBackgroundBadgeGrey": "color-background-badge-grey",
    "colorBorderBadge": "color-border-badge",
    "colorBorderBadgeGrey": "color-border-badge-grey",
    "colorBorderBadgeGreen": "color-border-badge-green",
    "colorBorderBadgeBlue": "color-border-badge-blue",
    "colorBorderBadgeRed": "color-border-badge-red",
    "colorTextBadgeGrey": "color-text-badge-grey",
    "colorTextBadgeGreen": "color-text-badge-green",
    "colorTextBadgeBlue": "color-text-badge-blue",
    "colorTextBadgeRed": "color-text-badge-red",
    "colorBackgroundCodeView": "color-background-code-view",
    "colorBackgroundVisualAccentRed": "color-background-visual-accent-red",
    "colorBackgroundVisualAccentYellow": "color-background-visual-accent-yellow",
    "colorBackgroundVisualAccentIndigo": "color-background-visual-accent-indigo",
    "colorBackgroundVisualAccentGreen": "color-background-visual-accent-green",
    "colorBackgroundVisualAccentOrange": "color-background-visual-accent-orange",
    "colorBackgroundVisualAccentPurple": "color-background-visual-accent-purple",
    "colorBackgroundVisualAccentLime": "color-background-visual-accent-lime",
    "colorBackgroundVisualAccentGrey": "color-background-visual-accent-grey",
    "colorBackgroundVisualAccentTeal": "color-background-visual-accent-teal",
    "colorBackgroundVisualAccentBlue": "color-background-visual-accent-blue",
    "colorBackgroundVisualAccentViolet": "color-background-visual-accent-violet",
    "colorBackgroundVisualAccentMagenta": "color-background-visual-accent-magenta",
    "colorBackgroundVisualAccentPink": "color-background-visual-accent-pink",
    "colorBackgroundVisualAccentAmber": "color-background-visual-accent-amber",
    "colorTextVisualAccentRed": "color-text-visual-accent-red",
    "colorTextVisualAccentYellow": "color-text-visual-accent-yellow",
    "colorTextVisualAccentIndigo": "color-text-visual-accent-indigo",
    "colorTextVisualAccentGreen": "color-text-visual-accent-green",
    "colorTextVisualAccentOrange": "color-text-visual-accent-orange",
    "colorTextVisualAccentPurple": "color-text-visual-accent-purple",
    "colorTextVisualAccentLime": "color-text-visual-accent-lime",
    "colorTextVisualAccentGrey": "color-text-visual-accent-grey",
    "colorTextVisualAccentTeal": "color-text-visual-accent-teal",
    "colorTextVisualAccentBlue": "color-text-visual-accent-blue",
    "colorTextVisualAccentViolet": "color-text-visual-accent-violet",
    "colorTextVisualAccentMagenta": "color-text-visual-accent-magenta",
    "colorTextVisualAccentPink": "color-text-visual-accent-pink",
    "colorTextVisualAccentAmber": "color-text-visual-accent-amber",
    "fontBoxValueLargeWeight": "font-box-value-large-weight",
    "fontButtonLetterSpacing": "font-button-letter-spacing",
    "fontChartDetailSize": "font-chart-detail-size",
    "fontDecorationStyleLink": "font-decoration-style-link",
    "fontDecorationLineLinkSecondary": "font-decoration-line-link-secondary",
    "fontDecorationThicknessLink": "font-decoration-thickness-link",
    "fontDecorationThicknessLinkDisplayL": "font-decoration-thickness-link-display-l",
    "fontDisplayLabelWeight": "font-display-label-weight",
    "fontSizeExpandableHeading": "font-size-expandable-heading",
    "fontFamilyBase": "font-family-base",
    "fontFamilyDisplay": "font-family-display",
    "fontFamilyHeading": "font-family-heading",
    "fontFamilyMonospace": "font-family-monospace",
    "fontHeaderH2DescriptionLineHeight": "font-header-h2-description-line-height",
    "fontHeaderH2DescriptionSize": "font-header-h2-description-size",
    "fontLinkButtonLetterSpacing": "font-link-button-letter-spacing",
    "fontLinkButtonWeight": "font-link-button-weight",
    "fontPanelHeaderLineHeight": "font-panel-header-line-height",
    "fontPanelHeaderSize": "font-panel-header-size",
    "fontSideNavigationSectionHeaderSize": "font-side-navigation-section-header-size",
    "fontSideNavigationSectionHeaderWeight": "font-side-navigation-section-header-weight",
    "fontSizeBodyM": "font-size-body-m",
    "fontSizeBodyS": "font-size-body-s",
    "fontSizeDisplayL": "font-size-display-l",
    "fontSizeDisplayXl": "font-size-display-xl",
    "fontSizeFormLabel": "font-size-form-label",
    "fontSizeHeadingL": "font-size-heading-l",
    "fontSizeHeadingM": "font-size-heading-m",
    "fontSizeHeadingS": "font-size-heading-s",
    "fontSizeHeadingXl": "font-size-heading-xl",
    "fontSizeHeadingXs": "font-size-heading-xs",
    "fontSizeKeyValuePairsLabel": "font-size-key-value-pairs-label",
    "fontSizeTabs": "font-size-tabs",
    "fontSmoothingMozOsx": "font-smoothing-moz-osx",
    "fontSmoothingWebkit": "font-smoothing-webkit",
    "fontWayfindingLinkActiveWeight": "font-wayfinding-link-active-weight",
    "fontWeightAlertHeader": "font-weight-alert-header",
    "fontWeightBold": "font-weight-bold",
    "fontWeightBreadcrumbCurrent": "font-weight-breadcrumb-current",
    "fontWeightButton": "font-weight-button",
    "fontWeightDisplayL": "font-weight-display-l",
    "fontWeightDisplayXl": "font-weight-display-xl",
    "fontWeightFlashbarHeader": "font-weight-flashbar-header",
    "fontWeightFormLabel": "font-weight-form-label",
    "fontWeightHeadingL": "font-weight-heading-l",
    "fontWeightHeadingM": "font-weight-heading-m",
    "fontWeightHeadingS": "font-weight-heading-s",
    "fontWeightHeadingXl": "font-weight-heading-xl",
    "fontWeightHeadingXs": "font-weight-heading-xs",
    "fontWeightHeavy": "font-weight-heavy",
    "fontWeightKeyValuePairsLabel": "font-weight-key-value-pairs-label",
    "fontWeightLighter": "font-weight-lighter",
    "fontWeightLinkSecondary": "font-weight-link-secondary",
    "fontWeightNormal": "font-weight-normal",
    "fontWeightTabs": "font-weight-tabs",
    "fontWeightTabsDisabled": "font-weight-tabs-disabled",
    "letterSpacingBodyS": "letter-spacing-body-s",
    "letterSpacingDisplayL": "letter-spacing-display-l",
    "letterSpacingDisplayXl": "letter-spacing-display-xl",
    "letterSpacingHeadingL": "letter-spacing-heading-l",
    "letterSpacingHeadingM": "letter-spacing-heading-m",
    "letterSpacingHeadingS": "letter-spacing-heading-s",
    "letterSpacingHeadingXl": "letter-spacing-heading-xl",
    "letterSpacingHeadingXs": "letter-spacing-heading-xs",
    "lineHeightBodyM": "line-height-body-m",
    "lineHeightBodyS": "line-height-body-s",
    "lineHeightDisplayL": "line-height-display-l",
    "lineHeightDisplayXl": "line-height-display-xl",
    "lineHeightFormLabel": "line-height-form-label",
    "lineHeightHeadingL": "line-height-heading-l",
    "lineHeightHeadingM": "line-height-heading-m",
    "lineHeightHeadingS": "line-height-heading-s",
    "lineHeightHeadingXl": "line-height-heading-xl",
    "lineHeightHeadingXs": "line-height-heading-xs",
    "lineHeightKeyValuePairsLabel": "line-height-key-value-pairs-label",
    "lineHeightTabs": "line-height-tabs",
    "borderActiveWidth": "border-active-width",
    "borderCodeEditorStatusDividerWidth": "border-code-editor-status-divider-width",
    "borderContainerStickyWidth": "border-container-sticky-width",
    "borderContainerTopWidth": "border-container-top-width",
    "borderControlFocusRingShadowSpread": "border-control-focus-ring-shadow-spread",
    "borderControlInvalidFocusRingShadowSpread": "border-control-invalid-focus-ring-shadow-spread",
    "borderDividerListWidth": "border-divider-list-width",
    "borderDividerSectionWidth": "border-divider-section-width",
    "borderDropdownVirtualOffsetWidth": "border-dropdown-virtual-offset-width",
    "borderInvalidWidth": "border-invalid-width",
    "borderItemWidth": "border-item-width",
    "borderLineChartDashArray": "border-line-chart-dash-array",
    "borderLineChartLineJoin": "border-line-chart-line-join",
    "borderLineChartWidth": "border-line-chart-width",
    "borderLinkFocusRingOutline": "border-link-focus-ring-outline",
    "borderLinkFocusRingShadowSpread": "border-link-focus-ring-shadow-spread",
    "borderPanelHeaderWidth": "border-panel-header-width",
    "borderPanelTopWidth": "border-panel-top-width",
    "borderRadiusActionCardDefault": "border-radius-action-card-default",
    "borderRadiusActionCardEmbedded": "border-radius-action-card-embedded",
    "borderRadiusAlert": "border-radius-alert",
    "borderRadiusBadge": "border-radius-badge",
    "borderRadiusButton": "border-radius-button",
    "borderRadiusCalendarDayFocusRing": "border-radius-calendar-day-focus-ring",
    "borderRadiusCardDefault": "border-radius-card-default",
    "borderRadiusCardEmbedded": "border-radius-card-embedded",
    "borderRadiusChatBubble": "border-radius-chat-bubble",
    "borderRadiusSupportPrompt": "border-radius-support-prompt",
    "borderRadiusCodeEditor": "border-radius-code-editor",
    "borderRadiusContainer": "border-radius-container",
    "borderRadiusControlCircularFocusRing": "border-radius-control-circular-focus-ring",
    "borderRadiusControlDefaultFocusRing": "border-radius-control-default-focus-ring",
    "borderRadiusDropdown": "border-radius-dropdown",
    "borderRadiusDropzone": "border-radius-dropzone",
    "borderRadiusFlashbar": "border-radius-flashbar",
    "borderRadiusInput": "border-radius-input",
    "borderRadiusItem": "border-radius-item",
    "borderRadiusSideNavigationItem": "border-radius-side-navigation-item",
    "borderRadiusSideNavigationItemCollapsed": "border-radius-side-navigation-item-collapsed",
    "borderRadiusItemCardDefault": "border-radius-item-card-default",
    "borderRadiusItemCardEmbedded": "border-radius-item-card-embedded",
    "borderRadiusDialog": "border-radius-dialog",
    "borderRadiusPopover": "border-radius-popover",
    "borderRadiusSkeleton": "border-radius-skeleton",
    "borderRadiusStatusIndicator": "border-radius-status-indicator",
    "borderRadiusTabsFocusRing": "border-radius-tabs-focus-ring",
    "borderRadiusTiles": "border-radius-tiles",
    "borderRadiusToken": "border-radius-token",
    "borderRadiusTokenInline": "border-radius-token-inline",
    "borderRadiusTutorialPanelItem": "border-radius-tutorial-panel-item",
    "borderTableStickyWidth": "border-table-sticky-width",
    "borderWidthActionCardActive": "border-width-action-card-active",
    "borderWidthActionCardDefault": "border-width-action-card-default",
    "borderWidthActionCardDisabled": "border-width-action-card-disabled",
    "borderWidthActionCardHover": "border-width-action-card-hover",
    "borderWidthAlert": "border-width-alert",
    "borderWidthAlertBlockEnd": "border-width-alert-block-end",
    "borderWidthAlertBlockStart": "border-width-alert-block-start",
    "borderWidthAlertInlineEnd": "border-width-alert-inline-end",
    "borderWidthAlertInlineStart": "border-width-alert-inline-start",
    "borderWidthFlashbarInlineStart": "border-width-flashbar-inline-start",
    "borderWidthButton": "border-width-button",
    "borderWidthCard": "border-width-card",
    "borderWidthCardSelected": "border-width-card-selected",
    "borderWidthDropdown": "border-width-dropdown",
    "borderWidthField": "border-width-field",
    "borderWidthIconBig": "border-width-icon-big",
    "borderWidthIconLarge": "border-width-icon-large",
    "borderWidthIconMedium": "border-width-icon-medium",
    "borderWidthIconNormal": "border-width-icon-normal",
    "borderWidthIconSmall": "border-width-icon-small",
    "borderWidthIconXSmall": "border-width-icon-x-small",
    "borderWidthItemCard": "border-width-item-card",
    "borderWidthItemCardHighlighted": "border-width-item-card-highlighted",
    "borderWidthDialog": "border-width-dialog",
    "borderWidthItemSelected": "border-width-item-selected",
    "borderWidthLayoutSideNavigation": "border-width-layout-side-navigation",
    "borderWidthNotificationStackBar": "border-width-notification-stack-bar",
    "borderWidthBadge": "border-width-badge",
    "borderWidthPopover": "border-width-popover",
    "borderWidthToken": "border-width-token",
    "motionDurationExtraFast": "motion-duration-extra-fast",
    "motionDurationExtraSlow": "motion-duration-extra-slow",
    "motionDurationFast": "motion-duration-fast",
    "motionDurationModerate": "motion-duration-moderate",
    "motionDurationRefreshOnlyAmbient": "motion-duration-refresh-only-ambient",
    "motionDurationRefreshOnlyFast": "motion-duration-refresh-only-fast",
    "motionDurationRefreshOnlyMedium": "motion-duration-refresh-only-medium",
    "motionDurationRefreshOnlySlow": "motion-duration-refresh-only-slow",
    "motionDurationAvatarGenAiGradient": "motion-duration-avatar-gen-ai-gradient",
    "motionDurationAvatarLoadingDots": "motion-duration-avatar-loading-dots",
    "motionDurationRotate180": "motion-duration-rotate-180",
    "motionDurationRotate90": "motion-duration-rotate-90",
    "motionDurationShowPaced": "motion-duration-show-paced",
    "motionDurationShowQuick": "motion-duration-show-quick",
    "motionDurationSlow": "motion-duration-slow",
    "motionDurationTransitionQuick": "motion-duration-transition-quick",
    "motionDurationTransitionShowPaced": "motion-duration-transition-show-paced",
    "motionDurationTransitionShowQuick": "motion-duration-transition-show-quick",
    "motionEasingEaseOutQuart": "motion-easing-ease-out-quart",
    "motionEasingRefreshOnlyA": "motion-easing-refresh-only-a",
    "motionEasingRefreshOnlyB": "motion-easing-refresh-only-b",
    "motionEasingRefreshOnlyC": "motion-easing-refresh-only-c",
    "motionEasingRefreshOnlyD": "motion-easing-refresh-only-d",
    "motionEasingAvatarGenAiGradient": "motion-easing-avatar-gen-ai-gradient",
    "motionEasingRotate180": "motion-easing-rotate-180",
    "motionEasingRotate90": "motion-easing-rotate-90",
    "motionEasingShowPaced": "motion-easing-show-paced",
    "motionEasingShowQuick": "motion-easing-show-quick",
    "motionEasingTransitionQuick": "motion-easing-transition-quick",
    "motionEasingTransitionShowPaced": "motion-easing-transition-show-paced",
    "motionEasingTransitionShowQuick": "motion-easing-transition-show-quick",
    "motionEasingResponsive": "motion-easing-responsive",
    "motionEasingSticky": "motion-easing-sticky",
    "motionEasingExpressive": "motion-easing-expressive",
    "motionDurationResponsive": "motion-duration-responsive",
    "motionDurationExpressive": "motion-duration-expressive",
    "motionDurationComplex": "motion-duration-complex",
    "motionDurationTooltipEnter": "motion-duration-tooltip-enter",
    "motionEasingTooltipEnter": "motion-easing-tooltip-enter",
    "motionDurationExpandableContentEnter": "motion-duration-expandable-content-enter",
    "motionEasingExpandableContentEnter": "motion-easing-expandable-content-enter",
    "motionDurationSideNavigationContentEnterFade": "motion-duration-side-navigation-content-enter-fade",
    "motionDurationSideNavigationContentExit": "motion-duration-side-navigation-content-exit",
    "motionDurationSideNavigationContentExitFade": "motion-duration-side-navigation-content-exit-fade",
    "motionEasingSideNavigationContentExit": "motion-easing-side-navigation-content-exit",
    "motionKeyframesFadeIn": "motion-keyframes-fade-in",
    "motionKeyframesFadeOut": "motion-keyframes-fade-out",
    "motionKeyframesStatusIconError": "motion-keyframes-status-icon-error",
    "motionKeyframesScalePopup": "motion-keyframes-scale-popup",
    "sizeCalendarGridWidth": "size-calendar-grid-width",
    "sizeControl": "size-control",
    "sizeIconBig": "size-icon-big",
    "sizeIconLarge": "size-icon-large",
    "sizeIconMedium": "size-icon-medium",
    "sizeIconNormal": "size-icon-normal",
    "sizeTableSelectionHorizontal": "size-table-selection-horizontal",
    "sizeVerticalInput": "size-vertical-input",
    "sizeVerticalPanelIconOffset": "size-vertical-panel-icon-offset",
    "sizeSideNavigationItemHeight": "size-side-navigation-item-height",
    "sizeSideNavigationItemCollapsed": "size-side-navigation-item-collapsed",
    "sizeSideNavigationCollapsedWidth": "size-side-navigation-collapsed-width",
    "spaceAlertActionLeft": "space-alert-action-left",
    "spaceAlertHorizontal": "space-alert-horizontal",
    "spaceAlertMessageRight": "space-alert-message-right",
    "spaceAlertVertical": "space-alert-vertical",
    "spaceButtonFocusOutlineGutter": "space-button-focus-outline-gutter",
    "spaceButtonHorizontal": "space-button-horizontal",
    "spaceButtonVertical": "space-button-vertical",
    "spaceTokenVertical": "space-token-vertical",
    "spaceFieldVertical": "space-field-vertical",
    "spaceButtonIconFocusOutlineGutterVertical": "space-button-icon-focus-outline-gutter-vertical",
    "spaceButtonIconOnlyHorizontal": "space-button-icon-only-horizontal",
    "spaceButtonInlineIconFocusOutlineGutter": "space-button-inline-icon-focus-outline-gutter",
    "spaceButtonModalDismissVertical": "space-button-modal-dismiss-vertical",
    "spaceCalendarGridFocusOutlineGutter": "space-calendar-grid-focus-outline-gutter",
    "spaceCalendarGridSelectedFocusOutlineGutter": "space-calendar-grid-selected-focus-outline-gutter",
    "spaceCalendarGridGutter": "space-calendar-grid-gutter",
    "spaceCardHorizontalDefault": "space-card-horizontal-default",
    "spaceCardHorizontalEmbedded": "space-card-horizontal-embedded",
    "spaceCardVerticalDefault": "space-card-vertical-default",
    "spaceCardVerticalEmbedded": "space-card-vertical-embedded",
    "spaceItemCardHorizontalDefault": "space-item-card-horizontal-default",
    "spaceItemCardHorizontalEmbedded": "space-item-card-horizontal-embedded",
    "spaceItemCardVerticalDefault": "space-item-card-vertical-default",
    "spaceItemCardVerticalEmbedded": "space-item-card-vertical-embedded",
    "spaceDialogHorizontal": "space-dialog-horizontal",
    "spaceDialogVertical": "space-dialog-vertical",
    "spaceDialogActionBlock": "space-dialog-action-block",
    "spaceDialogActionInline": "space-dialog-action-inline",
    "spaceDialogHeaderGap": "space-dialog-header-gap",
    "spaceDialogSectionGap": "space-dialog-section-gap",
    "spaceCodeEditorStatusFocusOutlineGutter": "space-code-editor-status-focus-outline-gutter",
    "spaceContainerContentTop": "space-container-content-top",
    "spaceContainerHeaderTop": "space-container-header-top",
    "spaceContainerHeaderBottom": "space-container-header-bottom",
    "spaceContainerHorizontal": "space-container-horizontal",
    "spaceContentHeaderPaddingBottom": "space-content-header-padding-bottom",
    "spaceDarkHeaderOverlapDistance": "space-dark-header-overlap-distance",
    "spaceExpandableSectionIconOffsetTop": "space-expandable-section-icon-offset-top",
    "spaceFieldHorizontal": "space-field-horizontal",
    "spaceFieldIconOffset": "space-field-icon-offset",
    "spaceFilteringTokenDismissButtonFocusOutlineGutter": "space-filtering-token-dismiss-button-focus-outline-gutter",
    "spaceFilteringTokenOperationSelectFocusOutlineGutter": "space-filtering-token-operation-select-focus-outline-gutter",
    "spaceFlashbarActionLeft": "space-flashbar-action-left",
    "spaceFlashbarDismissRight": "space-flashbar-dismiss-right",
    "spaceFlashbarHorizontal": "space-flashbar-horizontal",
    "spaceFlashbarVertical": "space-flashbar-vertical",
    "spaceGridGutter": "space-grid-gutter",
    "spaceKeyValueGap": "space-key-value-gap",
    "spaceLayoutContentBottom": "space-layout-content-bottom",
    "spaceLayoutContentHorizontal": "space-layout-content-horizontal",
    "spaceLayoutToggleDiameter": "space-layout-toggle-diameter",
    "spaceLayoutTogglePadding": "space-layout-toggle-padding",
    "spaceModalContentBottom": "space-modal-content-bottom",
    "spaceModalHorizontal": "space-modal-horizontal",
    "spacePanelContentBottom": "space-panel-content-bottom",
    "spacePanelContentTop": "space-panel-content-top",
    "spacePanelDividerMarginHorizontal": "space-panel-divider-margin-horizontal",
    "spacePanelHeaderVertical": "space-panel-header-vertical",
    "spacePanelNavLeft": "space-panel-nav-left",
    "spacePanelSideLeft": "space-panel-side-left",
    "spacePanelSideRight": "space-panel-side-right",
    "spacePanelSplitTop": "space-panel-split-top",
    "spacePanelSplitBottom": "space-panel-split-bottom",
    "spaceSegmentedControlFocusOutlineGutter": "space-segmented-control-focus-outline-gutter",
    "spaceTabsContentTop": "space-tabs-content-top",
    "spaceTabsFocusOutlineGutter": "space-tabs-focus-outline-gutter",
    "spaceTabsVertical": "space-tabs-vertical",
    "spaceTableContentBottom": "space-table-content-bottom",
    "spaceTableEmbeddedHeaderTop": "space-table-embedded-header-top",
    "spaceTableFooterHorizontal": "space-table-footer-horizontal",
    "spaceTableHeaderFocusOutlineGutter": "space-table-header-focus-outline-gutter",
    "spaceTableHeaderHorizontal": "space-table-header-horizontal",
    "spaceTableHeaderToolsBottom": "space-table-header-tools-bottom",
    "spaceTableHeaderToolsFullPageBottom": "space-table-header-tools-full-page-bottom",
    "spaceTableHorizontal": "space-table-horizontal",
    "spaceTreeViewIndentation": "space-tree-view-indentation",
    "spaceSideNavigationItemDefaultGap": "space-side-navigation-item-default-gap",
    "spaceSideNavigationItemIconGap": "space-side-navigation-item-icon-gap",
    "spaceTileGutter": "space-tile-gutter",
    "spaceActionCardHorizontalDefault": "space-action-card-horizontal-default",
    "spaceActionCardHorizontalEmbedded": "space-action-card-horizontal-embedded",
    "spaceActionCardVerticalDefault": "space-action-card-vertical-default",
    "spaceActionCardVerticalEmbedded": "space-action-card-vertical-embedded",
    "spaceActionCardDescriptionPaddingTop": "space-action-card-description-padding-top",
    "spaceActionCardContentPaddingTop": "space-action-card-content-padding-top",
    "spaceOptionPaddingVertical": "space-option-padding-vertical",
    "spaceOptionPaddingHorizontal": "space-option-padding-horizontal",
    "spaceStatusIndicatorPaddingHorizontal": "space-status-indicator-padding-horizontal",
    "spaceScaled2xNone": "space-scaled-2x-none",
    "spaceScaled2xXxxs": "space-scaled-2x-xxxs",
    "spaceScaled2xXxs": "space-scaled-2x-xxs",
    "spaceScaled2xXs": "space-scaled-2x-xs",
    "spaceScaled2xS": "space-scaled-2x-s",
    "spaceScaled2xM": "space-scaled-2x-m",
    "spaceScaled2xL": "space-scaled-2x-l",
    "spaceScaled2xXl": "space-scaled-2x-xl",
    "spaceScaled2xXxl": "space-scaled-2x-xxl",
    "spaceScaled2xXxxl": "space-scaled-2x-xxxl",
    "spaceScaledNone": "space-scaled-none",
    "spaceScaledXxxs": "space-scaled-xxxs",
    "spaceScaledXxs": "space-scaled-xxs",
    "spaceScaledXs": "space-scaled-xs",
    "spaceScaledS": "space-scaled-s",
    "spaceScaledM": "space-scaled-m",
    "spaceScaledL": "space-scaled-l",
    "spaceScaledXl": "space-scaled-xl",
    "spaceScaledXxl": "space-scaled-xxl",
    "spaceScaledXxxl": "space-scaled-xxxl",
    "spaceStaticXxxs": "space-static-xxxs",
    "spaceStaticXxs": "space-static-xxs",
    "spaceStaticXs": "space-static-xs",
    "spaceStaticS": "space-static-s",
    "spaceStaticM": "space-static-m",
    "spaceStaticL": "space-static-l",
    "spaceStaticXl": "space-static-xl",
    "spaceStaticXxl": "space-static-xxl",
    "spaceStaticXxxl": "space-static-xxxl",
    "spaceNone": "space-none",
    "spaceXxxs": "space-xxxs",
    "spaceXxs": "space-xxs",
    "spaceXs": "space-xs",
    "spaceS": "space-s",
    "spaceM": "space-m",
    "spaceL": "space-l",
    "spaceXl": "space-xl",
    "spaceXxl": "space-xxl",
    "spaceXxxl": "space-xxxl",
    "shadowCard": "shadow-card",
    "shadowItemCard": "shadow-item-card",
    "shadowDialog": "shadow-dialog",
    "shadowContainer": "shadow-container",
    "shadowContainerActive": "shadow-container-active",
    "shadowDropdown": "shadow-dropdown",
    "shadowDropup": "shadow-dropup",
    "shadowFlashCollapsed": "shadow-flash-collapsed",
    "shadowFlashSticky": "shadow-flash-sticky",
    "shadowModal": "shadow-modal",
    "shadowPanel": "shadow-panel",
    "shadowPanelToggle": "shadow-panel-toggle",
    "shadowPopover": "shadow-popover",
    "shadowSplitBottom": "shadow-split-bottom",
    "shadowSplitSide": "shadow-split-side",
    "shadowSticky": "shadow-sticky",
    "shadowStickyEmbedded": "shadow-sticky-embedded",
    "shadowStickyColumnFirst": "shadow-sticky-column-first",
    "shadowStickyColumnLast": "shadow-sticky-column-last"
  },
  "propertiesMap": {
    "colorPrimary50": "--color-primary-50-hzpado",
    "colorPrimary100": "--color-primary-100-n2qcgb",
    "colorPrimary200": "--color-primary-200-aj9trr",
    "colorPrimary300": "--color-primary-300-2rt5tg",
    "colorPrimary400": "--color-primary-400-x68qyw",
    "colorPrimary500": "--color-primary-500-4m805g",
    "colorPrimary600": "--color-primary-600-su56h9",
    "colorPrimary700": "--color-primary-700-1y7vyc",
    "colorPrimary800": "--color-primary-800-b4xmy4",
    "colorPrimary900": "--color-primary-900-ed50ni",
    "colorPrimary950": "--color-primary-950-ulhojy",
    "colorPrimary1000": "--color-primary-1000-cr22ew",
    "colorNeutral50": "--color-neutral-50-rcv7d5",
    "colorNeutral100": "--color-neutral-100-1tq0gf",
    "colorNeutral150": "--color-neutral-150-44n9cw",
    "colorNeutral200": "--color-neutral-200-ycjq01",
    "colorNeutral250": "--color-neutral-250-gbfdhl",
    "colorNeutral300": "--color-neutral-300-uoc9f7",
    "colorNeutral350": "--color-neutral-350-n78myc",
    "colorNeutral400": "--color-neutral-400-prk64u",
    "colorNeutral450": "--color-neutral-450-0zamgn",
    "colorNeutral500": "--color-neutral-500-w303c2",
    "colorNeutral550": "--color-neutral-550-13h867",
    "colorNeutral600": "--color-neutral-600-3y2c6w",
    "colorNeutral650": "--color-neutral-650-kuge0t",
    "colorNeutral700": "--color-neutral-700-c12c5v",
    "colorNeutral750": "--color-neutral-750-a0y7ng",
    "colorNeutral800": "--color-neutral-800-vmae6a",
    "colorNeutral850": "--color-neutral-850-d1tdt7",
    "colorNeutral900": "--color-neutral-900-6ecnwi",
    "colorNeutral950": "--color-neutral-950-qa1l7j",
    "colorNeutral1000": "--color-neutral-1000-iwhgj7",
    "colorError50": "--color-error-50-8h8p9x",
    "colorError100": "--color-error-100-0rtdic",
    "colorError400": "--color-error-400-n41ymk",
    "colorError600": "--color-error-600-tub94v",
    "colorError700": "--color-error-700-jl0s0z",
    "colorError800": "--color-error-800-n1566o",
    "colorError900": "--color-error-900-k48ikq",
    "colorError950": "--color-error-950-31kcvl",
    "colorError1000": "--color-error-1000-z38mvz",
    "colorSuccess50": "--color-success-50-yv7e12",
    "colorSuccess100": "--color-success-100-9dmhuk",
    "colorSuccess200": "--color-success-200-qmz6ku",
    "colorSuccess400": "--color-success-400-lrqqda",
    "colorSuccess500": "--color-success-500-n9ovsj",
    "colorSuccess600": "--color-success-600-9gprcu",
    "colorSuccess800": "--color-success-800-s9pinh",
    "colorSuccess950": "--color-success-950-f57emm",
    "colorSuccess1000": "--color-success-1000-vk1vyg",
    "colorWarning50": "--color-warning-50-pb3ziz",
    "colorWarning100": "--color-warning-100-oix7hg",
    "colorWarning200": "--color-warning-200-zmguuh",
    "colorWarning400": "--color-warning-400-b8uinu",
    "colorWarning500": "--color-warning-500-w4rb37",
    "colorWarning600": "--color-warning-600-1dwriu",
    "colorWarning800": "--color-warning-800-jh9k55",
    "colorWarning900": "--color-warning-900-rpufqr",
    "colorWarning950": "--color-warning-950-feshn0",
    "colorWarning1000": "--color-warning-1000-0orl6k",
    "colorInfo50": "--color-info-50-td1fx9",
    "colorInfo100": "--color-info-100-xl2nfo",
    "colorInfo300": "--color-info-300-vyzy9x",
    "colorInfo400": "--color-info-400-b9n5ih",
    "colorInfo600": "--color-info-600-14lpnx",
    "colorInfo700": "--color-info-700-scw336",
    "colorInfo800": "--color-info-800-xho7xf",
    "colorInfo950": "--color-info-950-tea6k1",
    "colorInfo1000": "--color-info-1000-9fl059",
    "colorGrey50": "--color-grey-50-1oe3og",
    "colorGrey100": "--color-grey-100-0v134n",
    "colorGrey150": "--color-grey-150-kw46x8",
    "colorGrey200": "--color-grey-200-qre0gc",
    "colorGrey250": "--color-grey-250-ay87mw",
    "colorGrey300": "--color-grey-300-mkpjae",
    "colorGrey350": "--color-grey-350-uwxla9",
    "colorGrey400": "--color-grey-400-6qezhs",
    "colorGrey450": "--color-grey-450-phsaou",
    "colorGrey500": "--color-grey-500-ssn4ky",
    "colorGrey600": "--color-grey-600-rniziy",
    "colorGrey650": "--color-grey-650-d40ulc",
    "colorGrey700": "--color-grey-700-61c45y",
    "colorGrey750": "--color-grey-750-f4v8hu",
    "colorGrey800": "--color-grey-800-30cbfe",
    "colorGrey850": "--color-grey-850-p8uyqu",
    "colorGrey900": "--color-grey-900-fahp9p",
    "colorGrey950": "--color-grey-950-y66yag",
    "colorGrey1000": "--color-grey-1000-w647yk",
    "colorBlue50": "--color-blue-50-awhln8",
    "colorBlue100": "--color-blue-100-zvvfj6",
    "colorBlue200": "--color-blue-200-lfqx8o",
    "colorBlue300": "--color-blue-300-75k3tn",
    "colorBlue400": "--color-blue-400-6mea5r",
    "colorBlue600": "--color-blue-600-yrlhzc",
    "colorBlue700": "--color-blue-700-6hqzkl",
    "colorBlue900": "--color-blue-900-ttal2j",
    "colorBlue1000": "--color-blue-1000-lopk2e",
    "colorGreen50": "--color-green-50-afssjg",
    "colorGreen500": "--color-green-500-kanmdr",
    "colorGreen600": "--color-green-600-hcuaaz",
    "colorGreen900": "--color-green-900-bhsx60",
    "colorGreen1000": "--color-green-1000-nayset",
    "colorRed50": "--color-red-50-4lq0nb",
    "colorRed400": "--color-red-400-32aav0",
    "colorRed600": "--color-red-600-4s2b3d",
    "colorRed900": "--color-red-900-954t2k",
    "colorRed1000": "--color-red-1000-0zsq40",
    "colorYellow50": "--color-yellow-50-08pnpu",
    "colorYellow400": "--color-yellow-400-nerrmu",
    "colorYellow500": "--color-yellow-500-77xnfo",
    "colorYellow900": "--color-yellow-900-bwfuhu",
    "colorYellow1000": "--color-yellow-1000-b3b9l1",
    "colorPurple400": "--color-purple-400-hspfb5",
    "colorPurple700": "--color-purple-700-jc4ci6",
    "colorAmber400": "--color-amber-400-nqrj66",
    "colorAmber500": "--color-amber-500-g48lnm",
    "colorRed950": "--color-red-950-8ex7py",
    "colorOrange50": "--color-orange-50-lqn7d4",
    "colorOrange100": "--color-orange-100-e0j6cc",
    "colorOrange400": "--color-orange-400-47qqgs",
    "colorOrange700": "--color-orange-700-1j4jzb",
    "colorOrange800": "--color-orange-800-79687b",
    "colorOrange950": "--color-orange-950-xgprc6",
    "colorYellow600": "--color-yellow-600-vl3zln",
    "colorYellow950": "--color-yellow-950-qf3mbj",
    "colorLime50": "--color-lime-50-nn1bpi",
    "colorLime100": "--color-lime-100-ztx8ku",
    "colorLime400": "--color-lime-400-4gz6gm",
    "colorLime700": "--color-lime-700-9n5mq3",
    "colorLime800": "--color-lime-800-94ssuy",
    "colorLime950": "--color-lime-950-44f2s6",
    "colorGreen400": "--color-green-400-jd5rtl",
    "colorGreen950": "--color-green-950-7fbppl",
    "colorMint50": "--color-mint-50-0mddco",
    "colorMint100": "--color-mint-100-quqyo8",
    "colorMint400": "--color-mint-400-r7jvop",
    "colorMint700": "--color-mint-700-y0bg9w",
    "colorMint800": "--color-mint-800-aes6he",
    "colorMint950": "--color-mint-950-swmd3m",
    "colorIndigo50": "--color-indigo-50-0o4i7o",
    "colorIndigo400": "--color-indigo-400-9zqtk1",
    "colorIndigo600": "--color-indigo-600-nr9258",
    "colorIndigo950": "--color-indigo-950-k26409",
    "colorPurple50": "--color-purple-50-p4yc9r",
    "colorPurple100": "--color-purple-100-ui5dtk",
    "colorPurple600": "--color-purple-600-rxcat6",
    "colorPurple800": "--color-purple-800-0a28gb",
    "colorPurple950": "--color-purple-950-4dlt1x",
    "colorTeal50": "--color-teal-50-4tkt1l",
    "colorTeal100": "--color-teal-100-knhnmv",
    "colorTeal400": "--color-teal-400-uiblfo",
    "colorTeal700": "--color-teal-700-e0qziw",
    "colorTeal800": "--color-teal-800-r2lx0r",
    "colorTeal950": "--color-teal-950-114lad",
    "colorCyan50": "--color-cyan-50-prjv9o",
    "colorCyan100": "--color-cyan-100-2fjfn7",
    "colorCyan400": "--color-cyan-400-k93yzz",
    "colorCyan700": "--color-cyan-700-fuy3xz",
    "colorCyan800": "--color-cyan-800-lyo336",
    "colorCyan950": "--color-cyan-950-v5xks3",
    "colorBlue950": "--color-blue-950-a323ym",
    "colorViolet50": "--color-violet-50-bpjrmb",
    "colorViolet100": "--color-violet-100-83bluc",
    "colorViolet400": "--color-violet-400-7rg58f",
    "colorViolet700": "--color-violet-700-fl25gc",
    "colorViolet800": "--color-violet-800-e0wbij",
    "colorViolet950": "--color-violet-950-xfo2br",
    "colorFuchsia50": "--color-fuchsia-50-zmvouq",
    "colorFuchsia100": "--color-fuchsia-100-6qr05m",
    "colorFuchsia400": "--color-fuchsia-400-duefp9",
    "colorFuchsia700": "--color-fuchsia-700-wrqpy0",
    "colorFuchsia800": "--color-fuchsia-800-d7j3n4",
    "colorFuchsia950": "--color-fuchsia-950-rng8hq",
    "colorMagenta50": "--color-magenta-50-1cwix3",
    "colorMagenta100": "--color-magenta-100-17l80m",
    "colorMagenta400": "--color-magenta-400-afdirf",
    "colorMagenta700": "--color-magenta-700-34ox3x",
    "colorMagenta800": "--color-magenta-800-9puq2i",
    "colorMagenta950": "--color-magenta-950-5dqe8m",
    "colorPink50": "--color-pink-50-e9n1g0",
    "colorPink100": "--color-pink-100-r7pbe6",
    "colorPink400": "--color-pink-400-ul3h6y",
    "colorPink700": "--color-pink-700-r5669a",
    "colorPink800": "--color-pink-800-4pruje",
    "colorPink950": "--color-pink-950-tqlm9d",
    "colorRose50": "--color-rose-50-71dgc5",
    "colorRose100": "--color-rose-100-3z81qc",
    "colorRose400": "--color-rose-400-xfoh71",
    "colorRose700": "--color-rose-700-jw7bvp",
    "colorRose800": "--color-rose-800-9qjfs8",
    "colorRose950": "--color-rose-950-b2vfkk",
    "colorAmber50": "--color-amber-50-9fa8nn",
    "colorAmber100": "--color-amber-100-zibeui",
    "colorAmber700": "--color-amber-700-wotad9",
    "colorAmber800": "--color-amber-800-c2d3ec",
    "colorAmber950": "--color-amber-950-cgd9m7",
    "colorAwsSquidInk": "--color-aws-squid-ink-5xkegp",
    "colorTransparent": "--color-transparent-p90zgt",
    "colorBlack": "--color-black-52yvf9",
    "colorWhite": "--color-white-v6y4fc",
    "colorChartsRed300": "--color-charts-red-300-z9ds7g",
    "colorChartsRed400": "--color-charts-red-400-gxj8lc",
    "colorChartsRed500": "--color-charts-red-500-4cybug",
    "colorChartsRed600": "--color-charts-red-600-pv26cj",
    "colorChartsRed700": "--color-charts-red-700-l3zq8p",
    "colorChartsRed800": "--color-charts-red-800-on9u9n",
    "colorChartsRed900": "--color-charts-red-900-ka5eu9",
    "colorChartsRed1000": "--color-charts-red-1000-wpi6g3",
    "colorChartsRed1100": "--color-charts-red-1100-b6anfe",
    "colorChartsRed1200": "--color-charts-red-1200-a8i454",
    "colorChartsOrange300": "--color-charts-orange-300-3ukzml",
    "colorChartsOrange400": "--color-charts-orange-400-8asgze",
    "colorChartsOrange500": "--color-charts-orange-500-gacslz",
    "colorChartsOrange600": "--color-charts-orange-600-1qwmnf",
    "colorChartsOrange700": "--color-charts-orange-700-uhtlkw",
    "colorChartsOrange800": "--color-charts-orange-800-f0dept",
    "colorChartsOrange900": "--color-charts-orange-900-arzyha",
    "colorChartsOrange1000": "--color-charts-orange-1000-h3ngtu",
    "colorChartsOrange1100": "--color-charts-orange-1100-r6exa5",
    "colorChartsOrange1200": "--color-charts-orange-1200-ne4s3s",
    "colorChartsYellow300": "--color-charts-yellow-300-xpm8ii",
    "colorChartsYellow400": "--color-charts-yellow-400-6hkt5e",
    "colorChartsYellow500": "--color-charts-yellow-500-d4wngk",
    "colorChartsYellow600": "--color-charts-yellow-600-4x72va",
    "colorChartsYellow700": "--color-charts-yellow-700-npql4h",
    "colorChartsYellow800": "--color-charts-yellow-800-oic1h3",
    "colorChartsYellow900": "--color-charts-yellow-900-ris9s3",
    "colorChartsYellow1000": "--color-charts-yellow-1000-s1aw4s",
    "colorChartsYellow1100": "--color-charts-yellow-1100-o8gbwq",
    "colorChartsYellow1200": "--color-charts-yellow-1200-phdgvs",
    "colorChartsGreen300": "--color-charts-green-300-8dkwv8",
    "colorChartsGreen400": "--color-charts-green-400-mozr97",
    "colorChartsGreen500": "--color-charts-green-500-r796pm",
    "colorChartsGreen600": "--color-charts-green-600-q4ko7b",
    "colorChartsGreen700": "--color-charts-green-700-phpk00",
    "colorChartsGreen800": "--color-charts-green-800-0xxrjp",
    "colorChartsGreen900": "--color-charts-green-900-vaj95a",
    "colorChartsGreen1000": "--color-charts-green-1000-8ljryt",
    "colorChartsGreen1100": "--color-charts-green-1100-ma9kb7",
    "colorChartsGreen1200": "--color-charts-green-1200-t9o6h1",
    "colorChartsTeal300": "--color-charts-teal-300-6cfi34",
    "colorChartsTeal400": "--color-charts-teal-400-mto87i",
    "colorChartsTeal500": "--color-charts-teal-500-o59os4",
    "colorChartsTeal600": "--color-charts-teal-600-iw7nm7",
    "colorChartsTeal700": "--color-charts-teal-700-64t1qm",
    "colorChartsTeal800": "--color-charts-teal-800-6kntc2",
    "colorChartsTeal900": "--color-charts-teal-900-mtlxsc",
    "colorChartsTeal1000": "--color-charts-teal-1000-15jx71",
    "colorChartsTeal1100": "--color-charts-teal-1100-mptbhb",
    "colorChartsTeal1200": "--color-charts-teal-1200-99v3e8",
    "colorChartsBlue1300": "--color-charts-blue-1-300-x5ftk3",
    "colorChartsBlue1400": "--color-charts-blue-1-400-xgmbmo",
    "colorChartsBlue1500": "--color-charts-blue-1-500-0m9a22",
    "colorChartsBlue1600": "--color-charts-blue-1-600-r05ox1",
    "colorChartsBlue1700": "--color-charts-blue-1-700-86ltax",
    "colorChartsBlue1800": "--color-charts-blue-1-800-a34dra",
    "colorChartsBlue1900": "--color-charts-blue-1-900-pyfvpi",
    "colorChartsBlue11000": "--color-charts-blue-1-1000-2d7qgd",
    "colorChartsBlue11100": "--color-charts-blue-1-1100-e03va6",
    "colorChartsBlue11200": "--color-charts-blue-1-1200-z12iwc",
    "colorChartsBlue2300": "--color-charts-blue-2-300-k1hsad",
    "colorChartsBlue2400": "--color-charts-blue-2-400-4eyral",
    "colorChartsBlue2500": "--color-charts-blue-2-500-ofdxoz",
    "colorChartsBlue2600": "--color-charts-blue-2-600-h1dp1p",
    "colorChartsBlue2700": "--color-charts-blue-2-700-btl7e1",
    "colorChartsBlue2800": "--color-charts-blue-2-800-e7a372",
    "colorChartsBlue2900": "--color-charts-blue-2-900-t7lc07",
    "colorChartsBlue21000": "--color-charts-blue-2-1000-f8pt8x",
    "colorChartsBlue21100": "--color-charts-blue-2-1100-6i63ws",
    "colorChartsBlue21200": "--color-charts-blue-2-1200-e6mv6d",
    "colorChartsPurple300": "--color-charts-purple-300-wprvfw",
    "colorChartsPurple400": "--color-charts-purple-400-udss0e",
    "colorChartsPurple500": "--color-charts-purple-500-yru4vx",
    "colorChartsPurple600": "--color-charts-purple-600-h0hn5k",
    "colorChartsPurple700": "--color-charts-purple-700-e4e0yc",
    "colorChartsPurple800": "--color-charts-purple-800-860s7l",
    "colorChartsPurple900": "--color-charts-purple-900-7ac8fa",
    "colorChartsPurple1000": "--color-charts-purple-1000-s3td66",
    "colorChartsPurple1100": "--color-charts-purple-1100-z3vrac",
    "colorChartsPurple1200": "--color-charts-purple-1200-jm9c9t",
    "colorChartsPink300": "--color-charts-pink-300-nrcvo9",
    "colorChartsPink400": "--color-charts-pink-400-0w94fq",
    "colorChartsPink500": "--color-charts-pink-500-gpj0v3",
    "colorChartsPink600": "--color-charts-pink-600-8olep9",
    "colorChartsPink700": "--color-charts-pink-700-9sge6t",
    "colorChartsPink800": "--color-charts-pink-800-abe1l6",
    "colorChartsPink900": "--color-charts-pink-900-72iuq9",
    "colorChartsPink1000": "--color-charts-pink-1000-h21gz8",
    "colorChartsPink1100": "--color-charts-pink-1100-9c8uua",
    "colorChartsPink1200": "--color-charts-pink-1200-2j3i8s",
    "colorChartsStatusCritical": "--color-charts-status-critical-dflvgi",
    "colorChartsStatusHigh": "--color-charts-status-high-36e4y0",
    "colorChartsStatusMedium": "--color-charts-status-medium-7uzmxu",
    "colorChartsStatusLow": "--color-charts-status-low-794jpj",
    "colorChartsStatusPositive": "--color-charts-status-positive-bijtpy",
    "colorChartsStatusInfo": "--color-charts-status-info-u1d8gu",
    "colorChartsStatusNeutral": "--color-charts-status-neutral-l402tz",
    "colorChartsThresholdNegative": "--color-charts-threshold-negative-wfvub2",
    "colorChartsThresholdPositive": "--color-charts-threshold-positive-4g3q6s",
    "colorChartsThresholdInfo": "--color-charts-threshold-info-yqggec",
    "colorChartsThresholdNeutral": "--color-charts-threshold-neutral-iz3odf",
    "colorChartsLineGrid": "--color-charts-line-grid-hezpxm",
    "colorChartsLineTick": "--color-charts-line-tick-kkhxmn",
    "colorChartsLineAxis": "--color-charts-line-axis-y1rkac",
    "colorChartsPaletteCategorical1": "--color-charts-palette-categorical-1-r41m2k",
    "colorChartsPaletteCategorical2": "--color-charts-palette-categorical-2-37jc27",
    "colorChartsPaletteCategorical3": "--color-charts-palette-categorical-3-2qk36g",
    "colorChartsPaletteCategorical4": "--color-charts-palette-categorical-4-greu4f",
    "colorChartsPaletteCategorical5": "--color-charts-palette-categorical-5-5cbtgt",
    "colorChartsPaletteCategorical6": "--color-charts-palette-categorical-6-wr9hab",
    "colorChartsPaletteCategorical7": "--color-charts-palette-categorical-7-m8ft2u",
    "colorChartsPaletteCategorical8": "--color-charts-palette-categorical-8-f7ufk6",
    "colorChartsPaletteCategorical9": "--color-charts-palette-categorical-9-sdg2ga",
    "colorChartsPaletteCategorical10": "--color-charts-palette-categorical-10-yfb2h7",
    "colorChartsPaletteCategorical11": "--color-charts-palette-categorical-11-b38mwa",
    "colorChartsPaletteCategorical12": "--color-charts-palette-categorical-12-6ey9tm",
    "colorChartsPaletteCategorical13": "--color-charts-palette-categorical-13-m3rl66",
    "colorChartsPaletteCategorical14": "--color-charts-palette-categorical-14-7ospze",
    "colorChartsPaletteCategorical15": "--color-charts-palette-categorical-15-fpd5zx",
    "colorChartsPaletteCategorical16": "--color-charts-palette-categorical-16-3vux0m",
    "colorChartsPaletteCategorical17": "--color-charts-palette-categorical-17-zb9wnt",
    "colorChartsPaletteCategorical18": "--color-charts-palette-categorical-18-qyjp0b",
    "colorChartsPaletteCategorical19": "--color-charts-palette-categorical-19-v16eb8",
    "colorChartsPaletteCategorical20": "--color-charts-palette-categorical-20-ws3klu",
    "colorChartsPaletteCategorical21": "--color-charts-palette-categorical-21-4m5ha5",
    "colorChartsPaletteCategorical22": "--color-charts-palette-categorical-22-njdznc",
    "colorChartsPaletteCategorical23": "--color-charts-palette-categorical-23-g4kffj",
    "colorChartsPaletteCategorical24": "--color-charts-palette-categorical-24-fh9v3z",
    "colorChartsPaletteCategorical25": "--color-charts-palette-categorical-25-6ba6en",
    "colorChartsPaletteCategorical26": "--color-charts-palette-categorical-26-w7fzwx",
    "colorChartsPaletteCategorical27": "--color-charts-palette-categorical-27-qrw50i",
    "colorChartsPaletteCategorical28": "--color-charts-palette-categorical-28-x3v5x7",
    "colorChartsPaletteCategorical29": "--color-charts-palette-categorical-29-drg4rc",
    "colorChartsPaletteCategorical30": "--color-charts-palette-categorical-30-8j9ihk",
    "colorChartsPaletteCategorical31": "--color-charts-palette-categorical-31-ip3fqi",
    "colorChartsPaletteCategorical32": "--color-charts-palette-categorical-32-ylu7uq",
    "colorChartsPaletteCategorical33": "--color-charts-palette-categorical-33-9aw5eu",
    "colorChartsPaletteCategorical34": "--color-charts-palette-categorical-34-jrug6a",
    "colorChartsPaletteCategorical35": "--color-charts-palette-categorical-35-rpt1pv",
    "colorChartsPaletteCategorical36": "--color-charts-palette-categorical-36-fcc7x2",
    "colorChartsPaletteCategorical37": "--color-charts-palette-categorical-37-62e2i9",
    "colorChartsPaletteCategorical38": "--color-charts-palette-categorical-38-moulpi",
    "colorChartsPaletteCategorical39": "--color-charts-palette-categorical-39-n928a4",
    "colorChartsPaletteCategorical40": "--color-charts-palette-categorical-40-srz79a",
    "colorChartsPaletteCategorical41": "--color-charts-palette-categorical-41-u3ui4k",
    "colorChartsPaletteCategorical42": "--color-charts-palette-categorical-42-nitvzf",
    "colorChartsPaletteCategorical43": "--color-charts-palette-categorical-43-j9aedz",
    "colorChartsPaletteCategorical44": "--color-charts-palette-categorical-44-uwezqg",
    "colorChartsPaletteCategorical45": "--color-charts-palette-categorical-45-q67isn",
    "colorChartsPaletteCategorical46": "--color-charts-palette-categorical-46-mekuui",
    "colorChartsPaletteCategorical47": "--color-charts-palette-categorical-47-n8g5ec",
    "colorChartsPaletteCategorical48": "--color-charts-palette-categorical-48-n3sewk",
    "colorChartsPaletteCategorical49": "--color-charts-palette-categorical-49-qfhn13",
    "colorChartsPaletteCategorical50": "--color-charts-palette-categorical-50-7pwbq1",
    "colorChartsErrorBarMarker": "--color-charts-error-bar-marker-hvifqd",
    "colorSeverityDarkRed": "--color-severity-dark-red-cco8im",
    "colorSeverityRed": "--color-severity-red-lsc9q4",
    "colorSeverityOrange": "--color-severity-orange-wq2k70",
    "colorSeverityYellow": "--color-severity-yellow-d5xnru",
    "colorSeverityGrey": "--color-severity-grey-cscgnt",
    "colorBackgroundNotificationSeverityCritical": "--color-background-notification-severity-critical-bklmxp",
    "colorBackgroundNotificationSeverityHigh": "--color-background-notification-severity-high-44r6oe",
    "colorBackgroundNotificationSeverityMedium": "--color-background-notification-severity-medium-87oafh",
    "colorBackgroundNotificationSeverityLow": "--color-background-notification-severity-low-g8anka",
    "colorBackgroundNotificationSeverityNeutral": "--color-background-notification-severity-neutral-2smv4l",
    "colorTextNotificationSeverityCritical": "--color-text-notification-severity-critical-k2eiaf",
    "colorTextNotificationSeverityHigh": "--color-text-notification-severity-high-n8ep8i",
    "colorTextNotificationSeverityMedium": "--color-text-notification-severity-medium-fr8mmc",
    "colorTextNotificationSeverityLow": "--color-text-notification-severity-low-4c6dno",
    "colorTextNotificationSeverityNeutral": "--color-text-notification-severity-neutral-k864rz",
    "colorBorderBadgeSeverityCritical": "--color-border-badge-severity-critical-iy9xj7",
    "colorBorderBadgeSeverityHigh": "--color-border-badge-severity-high-byl1dx",
    "colorBorderBadgeSeverityMedium": "--color-border-badge-severity-medium-7z1far",
    "colorBorderBadgeSeverityLow": "--color-border-badge-severity-low-jxgtiz",
    "colorBorderBadgeSeverityNeutral": "--color-border-badge-severity-neutral-p51wlk",
    "colorTextBadgeSeverityCritical": "--color-text-badge-severity-critical-y13z63",
    "colorTextBadgeSeverityHigh": "--color-text-badge-severity-high-kckiuo",
    "colorTextBadgeSeverityMedium": "--color-text-badge-severity-medium-ns9l4d",
    "colorTextBadgeSeverityLow": "--color-text-badge-severity-low-pnvr07",
    "colorTextBadgeSeverityNeutral": "--color-text-badge-severity-neutral-vz3r3d",
    "colorGreyOpaque10": "--color-grey-opaque-10-lm5hsm",
    "colorGreyOpaque25": "--color-grey-opaque-25-x5mga4",
    "colorGreyOpaque40": "--color-grey-opaque-40-t4j7ml",
    "colorGreyOpaque50": "--color-grey-opaque-50-ljcamy",
    "colorGreyOpaque70": "--color-grey-opaque-70-96zz4s",
    "colorGreyOpaque80": "--color-grey-opaque-80-ev7ovx",
    "colorGreyOpaque90": "--color-grey-opaque-90-3vw53a",
    "colorGreyTransparent": "--color-grey-transparent-3dqrf2",
    "colorGreyTransparentHeavy": "--color-grey-transparent-heavy-80huim",
    "colorGreyTransparentLight": "--color-grey-transparent-light-x8t86g",
    "colorBackgroundBadgeIcon": "--color-background-badge-icon-7pcuv1",
    "colorBackgroundButtonLinkActive": "--color-background-button-link-active-kmjpil",
    "colorBackgroundButtonLinkDefault": "--color-background-button-link-default-zpa58t",
    "colorBackgroundButtonLinkDisabled": "--color-background-button-link-disabled-hc0i8h",
    "colorBackgroundButtonLinkHover": "--color-background-button-link-hover-ufqy7g",
    "colorBackgroundButtonNormalActive": "--color-background-button-normal-active-yolxhj",
    "colorBackgroundButtonNormalDefault": "--color-background-button-normal-default-3s2qeb",
    "colorBackgroundButtonNormalDisabled": "--color-background-button-normal-disabled-poiij5",
    "colorBackgroundButtonNormalHover": "--color-background-button-normal-hover-1ajrtx",
    "colorBackgroundToggleButtonNormalPressed": "--color-background-toggle-button-normal-pressed-aidxyc",
    "colorBackgroundToggleButtonNormalDefault": "--color-background-toggle-button-normal-default-9tccuh",
    "colorBackgroundToggleButtonNormalHover": "--color-background-toggle-button-normal-hover-tg91r6",
    "colorBackgroundButtonPrimaryActive": "--color-background-button-primary-active-bqqfj8",
    "colorBackgroundButtonPrimaryDefault": "--color-background-button-primary-default-x6ecit",
    "colorBackgroundButtonPrimaryDisabled": "--color-background-button-primary-disabled-9w6u2t",
    "colorBackgroundButtonPrimaryHover": "--color-background-button-primary-hover-t7jlh2",
    "colorBackgroundDirectionButtonActive": "--color-background-direction-button-active-ilpypx",
    "colorBackgroundDirectionButtonDefault": "--color-background-direction-button-default-vtjmq9",
    "colorBackgroundDirectionButtonDisabled": "--color-background-direction-button-disabled-p1avil",
    "colorBackgroundDirectionButtonHover": "--color-background-direction-button-hover-ixmpit",
    "colorTextDirectionButtonDefault": "--color-text-direction-button-default-rvsx02",
    "colorTextDirectionButtonDisabled": "--color-text-direction-button-disabled-qzn64l",
    "colorBackgroundCalendarCurrentDate": "--color-background-calendar-current-date-4z244f",
    "colorBackgroundCellShaded": "--color-background-cell-shaded-twxsbz",
    "colorBackgroundCodeEditorGutterActiveLineDefault": "--color-background-code-editor-gutter-active-line-default-vdlqwm",
    "colorBackgroundCodeEditorGutterActiveLineError": "--color-background-code-editor-gutter-active-line-error-8a9lhc",
    "colorBackgroundCodeEditorGutterDefault": "--color-background-code-editor-gutter-default-8n8dxf",
    "colorBackgroundCodeEditorLoading": "--color-background-code-editor-loading-1te8g4",
    "colorBackgroundCodeEditorPaneItemHover": "--color-background-code-editor-pane-item-hover-umtijd",
    "colorBackgroundCodeEditorStatusBar": "--color-background-code-editor-status-bar-jisb5k",
    "colorBackgroundCard": "--color-background-card-wgxkh9",
    "colorBackgroundItemCard": "--color-background-item-card-xvm5ec",
    "colorBackgroundContainerContent": "--color-background-container-content-mjfil9",
    "colorBackgroundContainerHeader": "--color-background-container-header-irktp5",
    "colorBackgroundControlChecked": "--color-background-control-checked-ksqwhc",
    "colorBackgroundControlDefault": "--color-background-control-default-9p1s17",
    "colorBackgroundControlDisabled": "--color-background-control-disabled-m61b8s",
    "colorBackgroundDropdownItemDefault": "--color-background-dropdown-item-default-x5ga9w",
    "colorBackgroundDropdownItemDimmed": "--color-background-dropdown-item-dimmed-vz24i5",
    "colorBackgroundDropdownItemFilterMatch": "--color-background-dropdown-item-filter-match-i7cm84",
    "colorBackgroundDropdownItemHover": "--color-background-dropdown-item-hover-pvfsrg",
    "colorBackgroundDropdownItemSelected": "--color-background-dropdown-item-selected-jwgsiw",
    "colorBackgroundHomeHeader": "--color-background-home-header-x3x77n",
    "colorBackgroundInlineCode": "--color-background-inline-code-q7f520",
    "colorBackgroundInputDefault": "--color-background-input-default-1u0v1p",
    "colorBackgroundInputDisabled": "--color-background-input-disabled-pyvhb1",
    "colorBackgroundItemSelected": "--color-background-item-selected-dotkup",
    "colorBackgroundSideNavigationItemActive": "--color-background-side-navigation-item-active-vz7d6m",
    "colorBackgroundSideNavigationItemActiveCollapsed": "--color-background-side-navigation-item-active-collapsed-cws5yi",
    "colorBackgroundSideNavigationItemIconHover": "--color-background-side-navigation-item-icon-hover-ru7p8a",
    "colorBackgroundLayoutMain": "--color-background-layout-main-y4565g",
    "colorBackgroundLayoutAiDrawer": "--color-background-layout-ai-drawer-u8ll44",
    "colorBackgroundDrawer": "--color-background-drawer-m5wg8g",
    "colorBackgroundBackdrop": "--color-background-backdrop-8r45j1",
    "colorBackgroundDrawerBackdrop": "--color-background-drawer-backdrop-qc4p2a",
    "colorBackgroundLayoutMobilePanel": "--color-background-layout-mobile-panel-u5g4jx",
    "colorBackgroundLayoutPanel": "--color-background-layout-panel-d6e0ec",
    "colorBackgroundLayoutPanelContent": "--color-background-layout-panel-content-lmvj28",
    "colorBackgroundLayoutPanelHover": "--color-background-layout-panel-hover-b9uvel",
    "colorBackgroundLayoutToolbar": "--color-background-layout-toolbar-1jwzza",
    "colorBackgroundLayoutToggleActive": "--color-background-layout-toggle-active-tqol98",
    "colorBackgroundLayoutToggleDefault": "--color-background-layout-toggle-default-tyzrhi",
    "colorBackgroundLayoutToggleHover": "--color-background-layout-toggle-hover-8byg9u",
    "colorBackgroundLayoutToggleSelectedActive": "--color-background-layout-toggle-selected-active-lon4qo",
    "colorBackgroundLayoutToggleSelectedDefault": "--color-background-layout-toggle-selected-default-oz0e3e",
    "colorBackgroundLayoutToggleSelectedHover": "--color-background-layout-toggle-selected-hover-w25090",
    "colorBackgroundModalOverlay": "--color-background-modal-overlay-wa3opa",
    "colorBackgroundNotificationBlue": "--color-background-notification-blue-4hgetl",
    "colorBackgroundNotificationGreen": "--color-background-notification-green-e1wmo4",
    "colorBackgroundNotificationGrey": "--color-background-notification-grey-k6g19b",
    "colorBackgroundNotificationRed": "--color-background-notification-red-yrj9t3",
    "colorBackgroundNotificationYellow": "--color-background-notification-yellow-6wqoyk",
    "colorBackgroundFlashbarSuccess": "--color-background-flashbar-success-zie99h",
    "colorBackgroundFlashbarError": "--color-background-flashbar-error-i9pesb",
    "colorBackgroundFlashbarInfo": "--color-background-flashbar-info-i0nahj",
    "colorBackgroundFlashbarWarning": "--color-background-flashbar-warning-3uzdk3",
    "colorBackgroundNotificationStackBar": "--color-background-notification-stack-bar-g6w7e0",
    "colorBackgroundNotificationStackBarActive": "--color-background-notification-stack-bar-active-p84qcp",
    "colorBackgroundNotificationStackBarHover": "--color-background-notification-stack-bar-hover-gwd3ks",
    "colorBackgroundPopover": "--color-background-popover-qtxx5q",
    "colorBackgroundProgressBarValueDefault": "--color-background-progress-bar-value-default-ddtpb6",
    "colorBackgroundProgressBarValueFlash": "--color-background-progress-bar-value-flash-urwrbg",
    "colorBackgroundProgressBarFlash": "--color-background-progress-bar-flash-npejc5",
    "colorBackgroundProgressBarDefault": "--color-background-progress-bar-default-34ibji",
    "colorBackgroundSegmentActive": "--color-background-segment-active-ns5rt6",
    "colorBackgroundSegmentDefault": "--color-background-segment-default-6rgn11",
    "colorBackgroundSegmentDisabled": "--color-background-segment-disabled-mjubn7",
    "colorBackgroundSegmentHover": "--color-background-segment-hover-el4hte",
    "colorBackgroundSegmentWrapper": "--color-background-segment-wrapper-yqb22i",
    "colorBackgroundSliderRangeDefault": "--color-background-slider-range-default-8gps3m",
    "colorBackgroundSliderRangeActive": "--color-background-slider-range-active-eqkikb",
    "colorBackgroundSliderHandleDefault": "--color-background-slider-handle-default-mn0e65",
    "colorBackgroundSliderHandleActive": "--color-background-slider-handle-active-52bw7p",
    "colorBackgroundSliderTrackDefault": "--color-background-slider-track-default-c56fhx",
    "colorBackgroundSliderHandleRing": "--color-background-slider-handle-ring-1npztv",
    "colorBackgroundSliderHandleErrorDefault": "--color-background-slider-handle-error-default-rfcukk",
    "colorBackgroundSliderHandleErrorActive": "--color-background-slider-handle-error-active-gdx4th",
    "colorBackgroundSliderHandleWarningDefault": "--color-background-slider-handle-warning-default-vfz937",
    "colorBackgroundSliderHandleWarningActive": "--color-background-slider-handle-warning-active-49f34h",
    "colorBackgroundSliderRangeErrorDefault": "--color-background-slider-range-error-default-q0zwz6",
    "colorBackgroundSliderRangeErrorActive": "--color-background-slider-range-error-active-cinvr9",
    "colorBackgroundSliderRangeWarningDefault": "--color-background-slider-range-warning-default-zoam2f",
    "colorBackgroundSliderRangeWarningActive": "--color-background-slider-range-warning-active-quujtv",
    "colorBackgroundStatusError": "--color-background-status-error-edh6bo",
    "colorBackgroundStatusInfo": "--color-background-status-info-lki61z",
    "colorBackgroundAlertError": "--color-background-alert-error-dpj69i",
    "colorBackgroundAlertInfo": "--color-background-alert-info-lqhdg0",
    "colorBackgroundAlertSuccess": "--color-background-alert-success-9dyn87",
    "colorBackgroundAlertWarning": "--color-background-alert-warning-021z3n",
    "colorBackgroundDialog": "--color-background-dialog-l7uuft",
    "colorBackgroundDialogDefault": "--color-background-dialog-default-xpvorm",
    "colorBackgroundStatusSuccess": "--color-background-status-success-1woffs",
    "colorBackgroundStatusWarning": "--color-background-status-warning-52cylj",
    "colorBackgroundTableHeader": "--color-background-table-header-pgyagt",
    "colorBackgroundTilesDisabled": "--color-background-tiles-disabled-9yvcfs",
    "colorBackgroundToggleCheckedDisabled": "--color-background-toggle-checked-disabled-81loy3",
    "colorBackgroundToggleDefault": "--color-background-toggle-default-quxg9w",
    "colorBackgroundAvatarGenAi": "--color-background-avatar-gen-ai-p90q43",
    "colorBackgroundAvatarDefault": "--color-background-avatar-default-2c3w8u",
    "colorTextAvatar": "--color-text-avatar-ph9udp",
    "colorBackgroundLoadingBarGenAi": "--color-background-loading-bar-gen-ai-zx6dxz",
    "colorBackgroundStatusIndicatorError": "--color-background-status-indicator-error-mdm30w",
    "colorBackgroundStatusIndicatorWarning": "--color-background-status-indicator-warning-4hkqn2",
    "colorBackgroundStatusIndicatorSuccess": "--color-background-status-indicator-success-5z9dt9",
    "colorBackgroundStatusIndicatorInfo": "--color-background-status-indicator-info-vrpf2i",
    "colorBackgroundStatusIndicatorNeutral": "--color-background-status-indicator-neutral-izf254",
    "colorBackgroundChatBubbleOutgoing": "--color-background-chat-bubble-outgoing-lto0xq",
    "colorBackgroundChatBubbleIncoming": "--color-background-chat-bubble-incoming-gkldma",
    "colorTextChatBubbleOutgoing": "--color-text-chat-bubble-outgoing-225h2z",
    "colorTextChatBubbleIncoming": "--color-text-chat-bubble-incoming-383aqi",
    "colorBorderButtonLinkDisabled": "--color-border-button-link-disabled-8cf1qo",
    "colorBorderButtonNormalActive": "--color-border-button-normal-active-intpfi",
    "colorBorderButtonNormalDefault": "--color-border-button-normal-default-5u0s6m",
    "colorBorderToggleButtonNormalPressed": "--color-border-toggle-button-normal-pressed-j5gmhc",
    "colorBorderToggleButtonNormalDefault": "--color-border-toggle-button-normal-default-7wco5p",
    "colorBorderToggleButtonNormalHover": "--color-border-toggle-button-normal-hover-snh2tp",
    "colorBorderButtonNormalDisabled": "--color-border-button-normal-disabled-cr5kw0",
    "colorTextButtonNormalDisabled": "--color-text-button-normal-disabled-aia007",
    "colorBorderButtonNormalHover": "--color-border-button-normal-hover-0pwlzm",
    "colorTextButtonIconDisabled": "--color-text-button-icon-disabled-q2hkka",
    "colorBorderButtonPrimaryActive": "--color-border-button-primary-active-w09byb",
    "colorBorderButtonPrimaryDefault": "--color-border-button-primary-default-nhh7ei",
    "colorBorderButtonPrimaryDisabled": "--color-border-button-primary-disabled-xll6rj",
    "colorBorderButtonPrimaryHover": "--color-border-button-primary-hover-b5vfpk",
    "colorTextButtonPrimaryDisabled": "--color-text-button-primary-disabled-m8bh15",
    "colorItemSelected": "--color-item-selected-2irl78",
    "colorTextSideNavigationItemActive": "--color-text-side-navigation-item-active-lwnv03",
    "colorTextSideNavigationItemActiveCollapsed": "--color-text-side-navigation-item-active-collapsed-5rhubl",
    "colorTextSideNavigationItemDefault": "--color-text-side-navigation-item-default-uy2wte",
    "colorBorderCalendarGrid": "--color-border-calendar-grid-ke4u1f",
    "colorBorderCalendarGridSelectedFocusRing": "--color-border-calendar-grid-selected-focus-ring-qi02r4",
    "colorBorderCellShaded": "--color-border-cell-shaded-f2b4hq",
    "colorBorderCodeEditorAceActiveLineLightTheme": "--color-border-code-editor-ace-active-line-light-theme-uymo6h",
    "colorBorderCodeEditorAceActiveLineDarkTheme": "--color-border-code-editor-ace-active-line-dark-theme-4zt45r",
    "colorBorderCodeEditorDefault": "--color-border-code-editor-default-g2lxyw",
    "colorBorderCodeEditorPaneItemHover": "--color-border-code-editor-pane-item-hover-gu61eq",
    "colorBorderCard": "--color-border-card-btvpmf",
    "colorBorderCardHighlighted": "--color-border-card-highlighted-l5jn6r",
    "colorBorderItemCard": "--color-border-item-card-hcapa2",
    "colorBorderItemCardHighlighted": "--color-border-item-card-highlighted-rt3aue",
    "colorBorderContainerDivider": "--color-border-container-divider-rkhoab",
    "colorBorderContainerTop": "--color-border-container-top-9e7tpv",
    "colorBorderControlChecked": "--color-border-control-checked-g8qf7s",
    "colorBorderControlDefault": "--color-border-control-default-9qbus4",
    "colorBorderControlDisabled": "--color-border-control-disabled-dh8zaw",
    "colorBorderDividerActive": "--color-border-divider-active-zbcsa9",
    "colorBorderDividerDefault": "--color-border-divider-default-diwd4w",
    "colorBorderDividerNotification": "--color-border-divider-notification-3nnpxj",
    "colorBorderDividerPanelBottom": "--color-border-divider-panel-bottom-z3kijx",
    "colorBorderDividerPanelSide": "--color-border-divider-panel-side-nuzjt3",
    "colorBorderDividerSecondary": "--color-border-divider-secondary-xq0hy8",
    "colorBorderDividerTableGroup": "--color-border-divider-table-group-42wwt3",
    "colorBorderDropdownContainer": "--color-border-dropdown-container-zmsfa8",
    "colorBorderDropdownGroup": "--color-border-dropdown-group-y5droz",
    "colorBorderDropdownItemDefault": "--color-border-dropdown-item-default-j9osbc",
    "colorBorderDropdownItemHover": "--color-border-dropdown-item-hover-y2b7z1",
    "colorBorderDropdownItemDimmedHover": "--color-border-dropdown-item-dimmed-hover-54pdcr",
    "colorBorderDropdownItemSelected": "--color-border-dropdown-item-selected-y1kt81",
    "colorBorderDropdownItemTop": "--color-border-dropdown-item-top-vxgkn8",
    "colorBorderEditableCellHover": "--color-border-editable-cell-hover-hamak6",
    "colorBorderInputDefault": "--color-border-input-default-jtkw9d",
    "colorBorderInputDisabled": "--color-border-input-disabled-5m31k6",
    "colorBorderInputFocused": "--color-border-input-focused-ppoq5z",
    "colorBorderItemFocused": "--color-border-item-focused-sewkzn",
    "colorBorderDropdownItemFocused": "--color-border-dropdown-item-focused-y1x3ts",
    "colorBorderItemPlaceholder": "--color-border-item-placeholder-ipp92l",
    "colorBorderItemSelected": "--color-border-item-selected-7104rh",
    "colorBorderLayout": "--color-border-layout-h5yp20",
    "colorBorderLayoutSideNavigation": "--color-border-layout-side-navigation-a02vgs",
    "colorBorderNotificationStackBar": "--color-border-notification-stack-bar-iua5tr",
    "colorBorderNotificationStackBarHover": "--color-border-notification-stack-bar-hover-pzy1rr",
    "colorBorderNotificationStackBarActive": "--color-border-notification-stack-bar-active-itxyux",
    "colorBorderNotificationStackBarFocused": "--color-border-notification-stack-bar-focused-6lgllw",
    "colorBorderPanelHeader": "--color-border-panel-header-sqy0v4",
    "colorBorderPopover": "--color-border-popover-e8qomr",
    "colorBorderSegmentActive": "--color-border-segment-active-y8x5lr",
    "colorBorderSegmentDefault": "--color-border-segment-default-7wdd7x",
    "colorBorderSegmentDisabled": "--color-border-segment-disabled-ht9qft",
    "colorBorderSegmentDivider": "--color-border-segment-divider-mq01bu",
    "colorBorderSegmentHover": "--color-border-segment-hover-3wvhit",
    "colorBorderSegmentWrapper": "--color-border-segment-wrapper-ofstpm",
    "colorBorderStatusError": "--color-border-status-error-nczvil",
    "colorBorderStatusInfo": "--color-border-status-info-e5c14y",
    "colorBorderStatusSuccess": "--color-border-status-success-zsy8d6",
    "colorBorderStatusWarning": "--color-border-status-warning-zj1tu9",
    "colorBorderDialog": "--color-border-dialog-c9wxm6",
    "colorBorderDialogDefault": "--color-border-dialog-default-8c0afg",
    "colorBorderDividerInteractiveDefault": "--color-border-divider-interactive-default-cs7tmi",
    "colorBorderTabsDivider": "--color-border-tabs-divider-sog0al",
    "colorBorderTabsShadow": "--color-border-tabs-shadow-egq8wq",
    "colorBorderTabsUnderline": "--color-border-tabs-underline-yipmio",
    "colorBorderTilesDisabled": "--color-border-tiles-disabled-0fmv29",
    "colorBorderTutorial": "--color-border-tutorial-y71mlg",
    "colorForegroundControlDefault": "--color-foreground-control-default-poakg0",
    "colorForegroundControlDisabled": "--color-foreground-control-disabled-bikivj",
    "colorForegroundControlReadOnly": "--color-foreground-control-read-only-8sqxyy",
    "colorShadowDefault": "--color-shadow-default-ihj2rf",
    "colorShadowMedium": "--color-shadow-medium-utn53g",
    "colorShadowSide": "--color-shadow-side-6j14og",
    "colorShadowToggleHandle": "--color-shadow-toggle-handle-h7hwyu",
    "colorStrokeChartLine": "--color-stroke-chart-line-jphybt",
    "colorStrokeCodeEditorGutterActiveLineDefault": "--color-stroke-code-editor-gutter-active-line-default-6torfg",
    "colorStrokeCodeEditorGutterActiveLineHover": "--color-stroke-code-editor-gutter-active-line-hover-q0kg00",
    "colorTextAccent": "--color-text-accent-1mglsg",
    "colorTextBodyDefault": "--color-text-body-default-b2us04",
    "colorTextBodySecondary": "--color-text-body-secondary-66ygbb",
    "colorTextBreadcrumbCurrent": "--color-text-breadcrumb-current-iukxuf",
    "colorTextBreadcrumbIcon": "--color-text-breadcrumb-icon-bkucca",
    "colorTextButtonInlineIconDefault": "--color-text-button-inline-icon-default-yujzfi",
    "colorTextButtonInlineIconDisabled": "--color-text-button-inline-icon-disabled-yeab6p",
    "colorTextButtonInlineIconHover": "--color-text-button-inline-icon-hover-kxgkw7",
    "colorTextButtonInlineLinkHover": "--color-text-button-inline-link-hover-b55y5l",
    "colorTextButtonIconHover": "--color-text-button-icon-hover-9a7ije",
    "colorTextButtonNormalActive": "--color-text-button-normal-active-n48ns6",
    "colorTextToggleButtonNormalPressed": "--color-text-toggle-button-normal-pressed-9l3s2t",
    "colorTextButtonNormalDefault": "--color-text-button-normal-default-0rhdlx",
    "colorTextButtonNormalHover": "--color-text-button-normal-hover-a8yjvb",
    "colorTextLinkButtonNormalDefault": "--color-text-link-button-normal-default-2b5u43",
    "colorTextLinkButtonNormalHover": "--color-text-link-button-normal-hover-2w733x",
    "colorTextLinkButtonNormalActive": "--color-text-link-button-normal-active-9d4yxg",
    "colorTextButtonLinkActive": "--color-text-button-link-active-48pxp0",
    "colorTextButtonLinkDefault": "--color-text-button-link-default-w6ikk4",
    "colorTextButtonLinkDisabled": "--color-text-button-link-disabled-9cww9x",
    "colorTextButtonLinkHover": "--color-text-button-link-hover-2srq0t",
    "colorTextButtonPrimaryActive": "--color-text-button-primary-active-mostrh",
    "colorTextButtonPrimaryDefault": "--color-text-button-primary-default-twcxgo",
    "colorTextButtonPrimaryHover": "--color-text-button-primary-hover-2baqo4",
    "colorTextCalendarDateHover": "--color-text-calendar-date-hover-bc1v6m",
    "colorTextCalendarDateSelected": "--color-text-calendar-date-selected-adki4w",
    "colorTextCalendarMonth": "--color-text-calendar-month-2jnxdt",
    "colorTextCodeEditorGutterActiveLine": "--color-text-code-editor-gutter-active-line-lujzbm",
    "colorTextCodeEditorGutterDefault": "--color-text-code-editor-gutter-default-u68cfj",
    "colorTextCodeEditorStatusBarDisabled": "--color-text-code-editor-status-bar-disabled-368u13",
    "colorTextCodeEditorTabButtonError": "--color-text-code-editor-tab-button-error-5pyt8l",
    "colorTextColumnHeader": "--color-text-column-header-f8stnp",
    "colorTextColumnSortingIcon": "--color-text-column-sorting-icon-8ewv37",
    "colorTextControlDisabled": "--color-text-control-disabled-54tz75",
    "colorTextCounter": "--color-text-counter-r03ks4",
    "colorTextDisabled": "--color-text-disabled-ybqlwm",
    "colorTextDisabledInlineEdit": "--color-text-disabled-inline-edit-8wp4er",
    "colorTextDropdownFooter": "--color-text-dropdown-footer-opqn5k",
    "colorTextDropdownGroupLabel": "--color-text-dropdown-group-label-gquzok",
    "colorTextDropdownItemDefault": "--color-text-dropdown-item-default-u2mfqy",
    "colorTextDropdownItemDimmed": "--color-text-dropdown-item-dimmed-asp9ue",
    "colorTextDropdownItemDisabled": "--color-text-dropdown-item-disabled-2udtn0",
    "colorTextDropdownItemFilterMatch": "--color-text-dropdown-item-filter-match-lfblqh",
    "colorTextDropdownItemHighlighted": "--color-text-dropdown-item-highlighted-dikwgu",
    "colorTextDropdownItemSecondary": "--color-text-dropdown-item-secondary-1qkuo5",
    "colorTextDropdownItemSecondaryHover": "--color-text-dropdown-item-secondary-hover-zeming",
    "colorTextEmpty": "--color-text-empty-y81uqw",
    "colorTextExpandableSectionDefault": "--color-text-expandable-section-default-ae8rte",
    "colorTextExpandableSectionHover": "--color-text-expandable-section-hover-spaa5r",
    "colorTextExpandableSectionNavigationIconDefault": "--color-text-expandable-section-navigation-icon-default-hmowzn",
    "colorBorderExpandableSectionDefault": "--color-border-expandable-section-default-0tyw84",
    "colorTextFormDefault": "--color-text-form-default-8bb22s",
    "colorTextFormLabel": "--color-text-form-label-lm6ttg",
    "colorTextFormSecondary": "--color-text-form-secondary-wt0md2",
    "colorTextGroupLabel": "--color-text-group-label-8ordkz",
    "colorTextLabelGenAi": "--color-text-label-gen-ai-lkdcrw",
    "colorTextHeadingDefault": "--color-text-heading-default-e3tuze",
    "colorTextHeadingSecondary": "--color-text-heading-secondary-dsk9lp",
    "colorTextHomeHeaderDefault": "--color-text-home-header-default-3aasx5",
    "colorTextHomeHeaderSecondary": "--color-text-home-header-secondary-4ie19u",
    "colorTextIconCaret": "--color-text-icon-caret-apa5jz",
    "colorTextIconSubtle": "--color-text-icon-subtle-83jiby",
    "colorTextInputDisabled": "--color-text-input-disabled-s4k7tb",
    "colorTextInputPlaceholder": "--color-text-input-placeholder-l6klmg",
    "colorTextInputPlaceholderDisabled": "--color-text-input-placeholder-disabled-8cf69l",
    "colorTextInteractiveActive": "--color-text-interactive-active-nbyczy",
    "colorTextInteractiveDefault": "--color-text-interactive-default-pauydh",
    "colorTextInteractiveDisabled": "--color-text-interactive-disabled-tuxgxq",
    "colorTextInteractiveHover": "--color-text-interactive-hover-zj1911",
    "colorTextToggleButtonIconPressed": "--color-text-toggle-button-icon-pressed-9zicna",
    "colorTextInteractiveInvertedDefault": "--color-text-interactive-inverted-default-fkdaz3",
    "colorTextInteractiveInvertedHover": "--color-text-interactive-inverted-hover-ihqwp5",
    "colorTextInverted": "--color-text-inverted-fflnsl",
    "colorTextLabel": "--color-text-label-g80qnu",
    "colorTextKeyValuePairsValue": "--color-text-key-value-pairs-value-i86dvj",
    "colorTextLayoutToggle": "--color-text-layout-toggle-p1fjoq",
    "colorTextLayoutToggleActive": "--color-text-layout-toggle-active-3fc53x",
    "colorTextLayoutToggleHover": "--color-text-layout-toggle-hover-8ikeh3",
    "colorTextLayoutToggleSelected": "--color-text-layout-toggle-selected-rty4rx",
    "colorTextLinkDefault": "--color-text-link-default-qabnuk",
    "colorTextLinkHover": "--color-text-link-hover-n1r6g0",
    "colorTextLinkDecorationDefault": "--color-text-link-decoration-default-ku4wkw",
    "colorTextLinkDecorationHover": "--color-text-link-decoration-hover-opkmr8",
    "colorTextLinkSecondaryDefault": "--color-text-link-secondary-default-urew28",
    "colorTextLinkSecondaryHover": "--color-text-link-secondary-hover-kql7rc",
    "colorTextLinkSecondaryDecorationDefault": "--color-text-link-secondary-decoration-default-i3q9ql",
    "colorTextLinkInfoDefault": "--color-text-link-info-default-r8vwpt",
    "colorTextLinkInfoHover": "--color-text-link-info-hover-wlgtui",
    "colorTextLinkInvertedDefault": "--color-text-link-inverted-default-ahzm62",
    "colorTextLinkInvertedHover": "--color-text-link-inverted-hover-id53pz",
    "colorTextLinkButtonUnderline": "--color-text-link-button-underline-dfac05",
    "colorTextLinkButtonUnderlineHover": "--color-text-link-button-underline-hover-mrvitd",
    "colorTextNotificationDefault": "--color-text-notification-default-j0vb8v",
    "colorTextAlertDefault": "--color-text-alert-default-u9yymz",
    "colorTextNotificationLinkDefault": "--color-text-notification-link-default-ejciux",
    "colorTextNotificationLinkHover": "--color-text-notification-link-hover-m0gz4b",
    "colorTextNotificationStackBar": "--color-text-notification-stack-bar-cnlqja",
    "colorTextNotificationYellow": "--color-text-notification-yellow-tk462k",
    "colorTextPaginationPageNumberActiveDisabled": "--color-text-pagination-page-number-active-disabled-xo5o10",
    "colorTextPaginationPageNumberDefault": "--color-text-pagination-page-number-default-lt9i33",
    "colorTextSegmentActive": "--color-text-segment-active-hbbf1h",
    "colorTextSegmentDefault": "--color-text-segment-default-nk7mbi",
    "colorTextSegmentHover": "--color-text-segment-hover-qq2b2e",
    "colorTextSmall": "--color-text-small-uo2fu4",
    "colorTextFlashbarIconError": "--color-text-flashbar-icon-error-iniskk",
    "colorTextFlashbarIconInfo": "--color-text-flashbar-icon-info-6gjbnj",
    "colorTextFlashbarIconSuccess": "--color-text-flashbar-icon-success-m3u8zi",
    "colorTextFlashbarIconWarning": "--color-text-flashbar-icon-warning-0y4zrp",
    "colorTextAlertIconError": "--color-text-alert-icon-error-6ivbnd",
    "colorTextAlertIconInfo": "--color-text-alert-icon-info-ud5q0o",
    "colorTextAlertIconSuccess": "--color-text-alert-icon-success-1ldpm2",
    "colorTextAlertIconWarning": "--color-text-alert-icon-warning-lan9qr",
    "colorTextStatusError": "--color-text-status-error-ri38gt",
    "colorTextStatusInactive": "--color-text-status-inactive-fqjc97",
    "colorTextStatusInfo": "--color-text-status-info-su6k9n",
    "colorTextStatusSuccess": "--color-text-status-success-1i2jf8",
    "colorTextStatusWarning": "--color-text-status-warning-fabq6h",
    "colorTextTopNavigationTitle": "--color-text-top-navigation-title-7vpkqe",
    "colorTextTutorialHotspotDefault": "--color-text-tutorial-hotspot-default-wh1ngd",
    "colorTextTutorialHotspotHover": "--color-text-tutorial-hotspot-hover-azi6ck",
    "colorBoardPlaceholderActive": "--color-board-placeholder-active-y53hbb",
    "colorBoardPlaceholderHover": "--color-board-placeholder-hover-19qqxj",
    "colorDragPlaceholderActive": "--color-drag-placeholder-active-dxqser",
    "colorDragPlaceholderHover": "--color-drag-placeholder-hover-h0smpz",
    "colorDropzoneBackgroundDefault": "--color-dropzone-background-default-ttj3d8",
    "colorDropzoneBackgroundHover": "--color-dropzone-background-hover-u152n8",
    "colorDropzoneTextDefault": "--color-dropzone-text-default-o0nccm",
    "colorDropzoneTextHover": "--color-dropzone-text-hover-rik86m",
    "colorDropzoneBorderDefault": "--color-dropzone-border-default-5gqm3g",
    "colorDropzoneBorderHover": "--color-dropzone-border-hover-62a06y",
    "colorGapGlobalDrawer": "--color-gap-global-drawer-df7fm3",
    "colorTreeViewConnectorLine": "--color-tree-view-connector-line-lo05p8",
    "colorBackgroundActionCardDefault": "--color-background-action-card-default-65abr5",
    "colorBackgroundActionCardHover": "--color-background-action-card-hover-c66rb7",
    "colorBackgroundActionCardActive": "--color-background-action-card-active-pxdbk4",
    "colorBorderActionCardDefault": "--color-border-action-card-default-glrcr2",
    "colorBorderActionCardHover": "--color-border-action-card-hover-vrxfv7",
    "colorBorderActionCardActive": "--color-border-action-card-active-rfuevk",
    "colorBorderActionCardDisabled": "--color-border-action-card-disabled-5s03y2",
    "colorBackgroundActionCardDisabled": "--color-background-action-card-disabled-leg2wh",
    "colorTextActionCardDisabled": "--color-text-action-card-disabled-s894wy",
    "colorTextActionCardIconDefault": "--color-text-action-card-icon-default-6vmg5i",
    "colorTextActionCardIconHover": "--color-text-action-card-icon-hover-f5zddy",
    "colorTextActionCardIconActive": "--color-text-action-card-icon-active-zjslx8",
    "colorTextActionCardIconDisabled": "--color-text-action-card-icon-disabled-por5j0",
    "colorBackgroundSkeleton": "--color-background-skeleton-kon6do",
    "colorBackgroundSkeletonWave": "--color-background-skeleton-wave-07ksaz",
    "colorBackgroundBadgeGreen": "--color-background-badge-green-vna6pb",
    "colorBackgroundBadgeBlue": "--color-background-badge-blue-knlb4f",
    "colorBackgroundBadgeRed": "--color-background-badge-red-4ap748",
    "colorBackgroundBadgeYellow": "--color-background-badge-yellow-qiswl9",
    "colorBackgroundBadgeGrey": "--color-background-badge-grey-6h1dmu",
    "colorBorderBadge": "--color-border-badge-4zq3x2",
    "colorBorderBadgeGrey": "--color-border-badge-grey-7uvo1l",
    "colorBorderBadgeGreen": "--color-border-badge-green-lv2jw1",
    "colorBorderBadgeBlue": "--color-border-badge-blue-ze81zs",
    "colorBorderBadgeRed": "--color-border-badge-red-5xqfzk",
    "colorTextBadgeGrey": "--color-text-badge-grey-9tpmmu",
    "colorTextBadgeGreen": "--color-text-badge-green-5g7a8n",
    "colorTextBadgeBlue": "--color-text-badge-blue-r39mon",
    "colorTextBadgeRed": "--color-text-badge-red-wvf8rj",
    "colorBackgroundCodeView": "--color-background-code-view-emuorz",
    "colorBackgroundVisualAccentRed": "--color-background-visual-accent-red-3zu7ka",
    "colorBackgroundVisualAccentYellow": "--color-background-visual-accent-yellow-c3vp4k",
    "colorBackgroundVisualAccentIndigo": "--color-background-visual-accent-indigo-lpfndk",
    "colorBackgroundVisualAccentGreen": "--color-background-visual-accent-green-sn9m0x",
    "colorBackgroundVisualAccentOrange": "--color-background-visual-accent-orange-nzgr32",
    "colorBackgroundVisualAccentPurple": "--color-background-visual-accent-purple-1uz19y",
    "colorBackgroundVisualAccentLime": "--color-background-visual-accent-lime-lnjjms",
    "colorBackgroundVisualAccentGrey": "--color-background-visual-accent-grey-iw1dx7",
    "colorBackgroundVisualAccentTeal": "--color-background-visual-accent-teal-nbslme",
    "colorBackgroundVisualAccentBlue": "--color-background-visual-accent-blue-a11czi",
    "colorBackgroundVisualAccentViolet": "--color-background-visual-accent-violet-o2rd6l",
    "colorBackgroundVisualAccentMagenta": "--color-background-visual-accent-magenta-hufi82",
    "colorBackgroundVisualAccentPink": "--color-background-visual-accent-pink-of2yss",
    "colorBackgroundVisualAccentAmber": "--color-background-visual-accent-amber-9o1190",
    "colorTextVisualAccentRed": "--color-text-visual-accent-red-niwubx",
    "colorTextVisualAccentYellow": "--color-text-visual-accent-yellow-068yuu",
    "colorTextVisualAccentIndigo": "--color-text-visual-accent-indigo-7jjzus",
    "colorTextVisualAccentGreen": "--color-text-visual-accent-green-ux1arx",
    "colorTextVisualAccentOrange": "--color-text-visual-accent-orange-hcq1ht",
    "colorTextVisualAccentPurple": "--color-text-visual-accent-purple-m8lx5j",
    "colorTextVisualAccentLime": "--color-text-visual-accent-lime-gtu8of",
    "colorTextVisualAccentGrey": "--color-text-visual-accent-grey-vq1cnd",
    "colorTextVisualAccentTeal": "--color-text-visual-accent-teal-o3qtnb",
    "colorTextVisualAccentBlue": "--color-text-visual-accent-blue-4ivc5v",
    "colorTextVisualAccentViolet": "--color-text-visual-accent-violet-37lrr2",
    "colorTextVisualAccentMagenta": "--color-text-visual-accent-magenta-e0jpji",
    "colorTextVisualAccentPink": "--color-text-visual-accent-pink-sdrkws",
    "colorTextVisualAccentAmber": "--color-text-visual-accent-amber-32ua1k",
    "fontBoxValueLargeWeight": "--font-box-value-large-weight-a27txb",
    "fontButtonLetterSpacing": "--font-button-letter-spacing-7mz5n3",
    "fontChartDetailSize": "--font-chart-detail-size-gadmd0",
    "fontDecorationStyleLink": "--font-decoration-style-link-lw1s9g",
    "fontDecorationLineLinkSecondary": "--font-decoration-line-link-secondary-tcr1f6",
    "fontDecorationThicknessLink": "--font-decoration-thickness-link-n3u7wl",
    "fontDecorationThicknessLinkDisplayL": "--font-decoration-thickness-link-display-l-9n3xpw",
    "fontDisplayLabelWeight": "--font-display-label-weight-tz6zkz",
    "fontSizeExpandableHeading": "--font-size-expandable-heading-04ofyn",
    "fontFamilyBase": "--font-family-base-c9u5cr",
    "fontFamilyDisplay": "--font-family-display-vybf2o",
    "fontFamilyHeading": "--font-family-heading-f20kh9",
    "fontFamilyMonospace": "--font-family-monospace-842lr2",
    "fontHeaderH2DescriptionLineHeight": "--font-header-h2-description-line-height-4twwjm",
    "fontHeaderH2DescriptionSize": "--font-header-h2-description-size-5e2ebv",
    "fontLinkButtonLetterSpacing": "--font-link-button-letter-spacing-3qtgsm",
    "fontLinkButtonWeight": "--font-link-button-weight-fgl7rr",
    "fontPanelHeaderLineHeight": "--font-panel-header-line-height-4n3q8r",
    "fontPanelHeaderSize": "--font-panel-header-size-vy6xld",
    "fontSideNavigationSectionHeaderSize": "--font-side-navigation-section-header-size-i9jmyw",
    "fontSideNavigationSectionHeaderWeight": "--font-side-navigation-section-header-weight-kgk4tm",
    "fontSizeBodyM": "--font-size-body-m-tq5a14",
    "fontSizeBodyS": "--font-size-body-s-89y7qg",
    "fontSizeDisplayL": "--font-size-display-l-pdduqq",
    "fontSizeDisplayXl": "--font-size-display-xl-sgpjr4",
    "fontSizeFormLabel": "--font-size-form-label-c9sdxr",
    "fontSizeHeadingL": "--font-size-heading-l-cax9xk",
    "fontSizeHeadingM": "--font-size-heading-m-cqvsuv",
    "fontSizeHeadingS": "--font-size-heading-s-hm1hv8",
    "fontSizeHeadingXl": "--font-size-heading-xl-0tgqx0",
    "fontSizeHeadingXs": "--font-size-heading-xs-yrvp79",
    "fontSizeKeyValuePairsLabel": "--font-size-key-value-pairs-label-3n21ly",
    "fontSizeTabs": "--font-size-tabs-dii5id",
    "fontSmoothingMozOsx": "--font-smoothing-moz-osx-kjlydy",
    "fontSmoothingWebkit": "--font-smoothing-webkit-dpz0hr",
    "fontWayfindingLinkActiveWeight": "--font-wayfinding-link-active-weight-mlvia6",
    "fontWeightAlertHeader": "--font-weight-alert-header-ym3e4s",
    "fontWeightBold": "--font-weight-bold-xpar9m",
    "fontWeightBreadcrumbCurrent": "--font-weight-breadcrumb-current-7sfze6",
    "fontWeightButton": "--font-weight-button-2p3grf",
    "fontWeightDisplayL": "--font-weight-display-l-mgsrr3",
    "fontWeightDisplayXl": "--font-weight-display-xl-x45woz",
    "fontWeightFlashbarHeader": "--font-weight-flashbar-header-a0ezj3",
    "fontWeightFormLabel": "--font-weight-form-label-51gead",
    "fontWeightHeadingL": "--font-weight-heading-l-0v2v9e",
    "fontWeightHeadingM": "--font-weight-heading-m-f9aiaz",
    "fontWeightHeadingS": "--font-weight-heading-s-mu75ca",
    "fontWeightHeadingXl": "--font-weight-heading-xl-pyfvsm",
    "fontWeightHeadingXs": "--font-weight-heading-xs-s1j3wn",
    "fontWeightHeavy": "--font-weight-heavy-4d9hxp",
    "fontWeightKeyValuePairsLabel": "--font-weight-key-value-pairs-label-zp4d0l",
    "fontWeightLighter": "--font-weight-lighter-bdf8bf",
    "fontWeightLinkSecondary": "--font-weight-link-secondary-gzuq69",
    "fontWeightNormal": "--font-weight-normal-fr92v6",
    "fontWeightTabs": "--font-weight-tabs-a6xetk",
    "fontWeightTabsDisabled": "--font-weight-tabs-disabled-utbnpu",
    "letterSpacingBodyS": "--letter-spacing-body-s-dzcybc",
    "letterSpacingDisplayL": "--letter-spacing-display-l-4pc9hm",
    "letterSpacingDisplayXl": "--letter-spacing-display-xl-goanzc",
    "letterSpacingHeadingL": "--letter-spacing-heading-l-no7j10",
    "letterSpacingHeadingM": "--letter-spacing-heading-m-iab0ug",
    "letterSpacingHeadingS": "--letter-spacing-heading-s-kfu48f",
    "letterSpacingHeadingXl": "--letter-spacing-heading-xl-hgjceo",
    "letterSpacingHeadingXs": "--letter-spacing-heading-xs-pjb0xm",
    "lineHeightBodyM": "--line-height-body-m-5xw6xo",
    "lineHeightBodyS": "--line-height-body-s-gako33",
    "lineHeightDisplayL": "--line-height-display-l-tjudur",
    "lineHeightDisplayXl": "--line-height-display-xl-bjbwbh",
    "lineHeightFormLabel": "--line-height-form-label-wqlhhe",
    "lineHeightHeadingL": "--line-height-heading-l-zmt48b",
    "lineHeightHeadingM": "--line-height-heading-m-d6lkzb",
    "lineHeightHeadingS": "--line-height-heading-s-3z7qjv",
    "lineHeightHeadingXl": "--line-height-heading-xl-pi61pg",
    "lineHeightHeadingXs": "--line-height-heading-xs-wcrr4i",
    "lineHeightKeyValuePairsLabel": "--line-height-key-value-pairs-label-hztspf",
    "lineHeightTabs": "--line-height-tabs-5bo37m",
    "borderActiveWidth": "--border-active-width-8f63o4",
    "borderCodeEditorStatusDividerWidth": "--border-code-editor-status-divider-width-62xtcs",
    "borderContainerStickyWidth": "--border-container-sticky-width-ns9pe4",
    "borderContainerTopWidth": "--border-container-top-width-6p1io9",
    "borderControlFocusRingShadowSpread": "--border-control-focus-ring-shadow-spread-iijyo6",
    "borderControlInvalidFocusRingShadowSpread": "--border-control-invalid-focus-ring-shadow-spread-bl5nmx",
    "borderDividerListWidth": "--border-divider-list-width-2qbfmz",
    "borderDividerSectionWidth": "--border-divider-section-width-dlkb8v",
    "borderDropdownVirtualOffsetWidth": "--border-dropdown-virtual-offset-width-a5kgm3",
    "borderInvalidWidth": "--border-invalid-width-b183os",
    "borderItemWidth": "--border-item-width-pyfg4s",
    "borderLineChartDashArray": "--border-line-chart-dash-array-ctwkrt",
    "borderLineChartLineJoin": "--border-line-chart-line-join-lskdht",
    "borderLineChartWidth": "--border-line-chart-width-vyj7eu",
    "borderLinkFocusRingOutline": "--border-link-focus-ring-outline-wn9h6t",
    "borderLinkFocusRingShadowSpread": "--border-link-focus-ring-shadow-spread-ggjunl",
    "borderPanelHeaderWidth": "--border-panel-header-width-91o5vi",
    "borderPanelTopWidth": "--border-panel-top-width-lsu1cp",
    "borderRadiusActionCardDefault": "--border-radius-action-card-default-scbf4g",
    "borderRadiusActionCardEmbedded": "--border-radius-action-card-embedded-8wwy9h",
    "borderRadiusAlert": "--border-radius-alert-m5flwx",
    "borderRadiusBadge": "--border-radius-badge-86n91d",
    "borderRadiusButton": "--border-radius-button-9k0hrl",
    "borderRadiusCalendarDayFocusRing": "--border-radius-calendar-day-focus-ring-5b8ckf",
    "borderRadiusCardDefault": "--border-radius-card-default-dfh0ly",
    "borderRadiusCardEmbedded": "--border-radius-card-embedded-yu0pej",
    "borderRadiusChatBubble": "--border-radius-chat-bubble-qqrkau",
    "borderRadiusSupportPrompt": "--border-radius-support-prompt-1jyqwv",
    "borderRadiusCodeEditor": "--border-radius-code-editor-blfdm5",
    "borderRadiusContainer": "--border-radius-container-33hhdh",
    "borderRadiusControlCircularFocusRing": "--border-radius-control-circular-focus-ring-go6crh",
    "borderRadiusControlDefaultFocusRing": "--border-radius-control-default-focus-ring-akwhsf",
    "borderRadiusDropdown": "--border-radius-dropdown-azs8zp",
    "borderRadiusDropzone": "--border-radius-dropzone-1g7e01",
    "borderRadiusFlashbar": "--border-radius-flashbar-wdar84",
    "borderRadiusInput": "--border-radius-input-k1q34z",
    "borderRadiusItem": "--border-radius-item-mitz8h",
    "borderRadiusSideNavigationItem": "--border-radius-side-navigation-item-umkj1e",
    "borderRadiusSideNavigationItemCollapsed": "--border-radius-side-navigation-item-collapsed-mi3uty",
    "borderRadiusItemCardDefault": "--border-radius-item-card-default-nurfq3",
    "borderRadiusItemCardEmbedded": "--border-radius-item-card-embedded-patnwm",
    "borderRadiusDialog": "--border-radius-dialog-adcisc",
    "borderRadiusPopover": "--border-radius-popover-pmwd0c",
    "borderRadiusSkeleton": "--border-radius-skeleton-0r7m8y",
    "borderRadiusStatusIndicator": "--border-radius-status-indicator-1d9bsf",
    "borderRadiusTabsFocusRing": "--border-radius-tabs-focus-ring-ss6drb",
    "borderRadiusTiles": "--border-radius-tiles-vjpivy",
    "borderRadiusToken": "--border-radius-token-dnq13z",
    "borderRadiusTokenInline": "--border-radius-token-inline-09715z",
    "borderRadiusTutorialPanelItem": "--border-radius-tutorial-panel-item-ueam46",
    "borderTableStickyWidth": "--border-table-sticky-width-0njdoj",
    "borderWidthActionCardActive": "--border-width-action-card-active-vzrcwp",
    "borderWidthActionCardDefault": "--border-width-action-card-default-hmz48y",
    "borderWidthActionCardDisabled": "--border-width-action-card-disabled-30ta09",
    "borderWidthActionCardHover": "--border-width-action-card-hover-sufiqn",
    "borderWidthAlert": "--border-width-alert-cj1l4d",
    "borderWidthAlertBlockEnd": "--border-width-alert-block-end-bz9tdg",
    "borderWidthAlertBlockStart": "--border-width-alert-block-start-qp1o4s",
    "borderWidthAlertInlineEnd": "--border-width-alert-inline-end-8vmvde",
    "borderWidthAlertInlineStart": "--border-width-alert-inline-start-irqq4q",
    "borderWidthFlashbarInlineStart": "--border-width-flashbar-inline-start-pmb8d1",
    "borderWidthButton": "--border-width-button-lffd4t",
    "borderWidthCard": "--border-width-card-niewam",
    "borderWidthCardSelected": "--border-width-card-selected-pzt73h",
    "borderWidthDropdown": "--border-width-dropdown-4gpjx5",
    "borderWidthField": "--border-width-field-2365x3",
    "borderWidthIconBig": "--border-width-icon-big-telu48",
    "borderWidthIconLarge": "--border-width-icon-large-cvs2dx",
    "borderWidthIconMedium": "--border-width-icon-medium-4yajvt",
    "borderWidthIconNormal": "--border-width-icon-normal-swx9va",
    "borderWidthIconSmall": "--border-width-icon-small-m3z2f5",
    "borderWidthIconXSmall": "--border-width-icon-x-small-3m5wt5",
    "borderWidthItemCard": "--border-width-item-card-6sthd9",
    "borderWidthItemCardHighlighted": "--border-width-item-card-highlighted-1jvaro",
    "borderWidthDialog": "--border-width-dialog-6bh1ii",
    "borderWidthItemSelected": "--border-width-item-selected-l41fek",
    "borderWidthLayoutSideNavigation": "--border-width-layout-side-navigation-q0k26x",
    "borderWidthNotificationStackBar": "--border-width-notification-stack-bar-b90c4m",
    "borderWidthBadge": "--border-width-badge-p88itr",
    "borderWidthPopover": "--border-width-popover-snsxri",
    "borderWidthToken": "--border-width-token-p4a0gu",
    "motionDurationExtraFast": "--motion-duration-extra-fast-x9762s",
    "motionDurationExtraSlow": "--motion-duration-extra-slow-bzo8np",
    "motionDurationFast": "--motion-duration-fast-yb0m8k",
    "motionDurationModerate": "--motion-duration-moderate-evtfj0",
    "motionDurationRefreshOnlyAmbient": "--motion-duration-refresh-only-ambient-1fnb3e",
    "motionDurationRefreshOnlyFast": "--motion-duration-refresh-only-fast-y8f250",
    "motionDurationRefreshOnlyMedium": "--motion-duration-refresh-only-medium-s8g1xv",
    "motionDurationRefreshOnlySlow": "--motion-duration-refresh-only-slow-8cyf6l",
    "motionDurationAvatarGenAiGradient": "--motion-duration-avatar-gen-ai-gradient-jvrdu4",
    "motionDurationAvatarLoadingDots": "--motion-duration-avatar-loading-dots-nmvz6j",
    "motionDurationRotate180": "--motion-duration-rotate-180-69rh8b",
    "motionDurationRotate90": "--motion-duration-rotate-90-de2qw0",
    "motionDurationShowPaced": "--motion-duration-show-paced-i87eux",
    "motionDurationShowQuick": "--motion-duration-show-quick-24aj9c",
    "motionDurationSlow": "--motion-duration-slow-8cu00l",
    "motionDurationTransitionQuick": "--motion-duration-transition-quick-1p8yzt",
    "motionDurationTransitionShowPaced": "--motion-duration-transition-show-paced-ljwltl",
    "motionDurationTransitionShowQuick": "--motion-duration-transition-show-quick-5e3cub",
    "motionEasingEaseOutQuart": "--motion-easing-ease-out-quart-k5q7pi",
    "motionEasingRefreshOnlyA": "--motion-easing-refresh-only-a-b2p95e",
    "motionEasingRefreshOnlyB": "--motion-easing-refresh-only-b-qfsc10",
    "motionEasingRefreshOnlyC": "--motion-easing-refresh-only-c-7hkv9v",
    "motionEasingRefreshOnlyD": "--motion-easing-refresh-only-d-pnvbjw",
    "motionEasingAvatarGenAiGradient": "--motion-easing-avatar-gen-ai-gradient-i1xk2w",
    "motionEasingRotate180": "--motion-easing-rotate-180-nmpsiw",
    "motionEasingRotate90": "--motion-easing-rotate-90-mfea51",
    "motionEasingShowPaced": "--motion-easing-show-paced-r4ee22",
    "motionEasingShowQuick": "--motion-easing-show-quick-gb8584",
    "motionEasingTransitionQuick": "--motion-easing-transition-quick-afgcka",
    "motionEasingTransitionShowPaced": "--motion-easing-transition-show-paced-9j2ih7",
    "motionEasingTransitionShowQuick": "--motion-easing-transition-show-quick-08tkxg",
    "motionEasingResponsive": "--motion-easing-responsive-k7246o",
    "motionEasingSticky": "--motion-easing-sticky-erj3ph",
    "motionEasingExpressive": "--motion-easing-expressive-7na2oq",
    "motionDurationResponsive": "--motion-duration-responsive-6nbqre",
    "motionDurationExpressive": "--motion-duration-expressive-6bpizs",
    "motionDurationComplex": "--motion-duration-complex-n5wfwh",
    "motionDurationTooltipEnter": "--motion-duration-tooltip-enter-crskvc",
    "motionEasingTooltipEnter": "--motion-easing-tooltip-enter-9zegwn",
    "motionDurationExpandableContentEnter": "--motion-duration-expandable-content-enter-ztgfuo",
    "motionEasingExpandableContentEnter": "--motion-easing-expandable-content-enter-ufdnuw",
    "motionDurationSideNavigationContentEnterFade": "--motion-duration-side-navigation-content-enter-fade-tsfau0",
    "motionDurationSideNavigationContentExit": "--motion-duration-side-navigation-content-exit-pn2ye8",
    "motionDurationSideNavigationContentExitFade": "--motion-duration-side-navigation-content-exit-fade-nmc7k9",
    "motionEasingSideNavigationContentExit": "--motion-easing-side-navigation-content-exit-wsadq7",
    "motionKeyframesFadeIn": "--motion-keyframes-fade-in-zvelik",
    "motionKeyframesFadeOut": "--motion-keyframes-fade-out-kspz0u",
    "motionKeyframesStatusIconError": "--motion-keyframes-status-icon-error-lz4rdp",
    "motionKeyframesScalePopup": "--motion-keyframes-scale-popup-i6fwwn",
    "sizeCalendarGridWidth": "--size-calendar-grid-width-9z2nlc",
    "sizeControl": "--size-control-jpgj8e",
    "sizeIconBig": "--size-icon-big-z6z1yl",
    "sizeIconLarge": "--size-icon-large-uba15s",
    "sizeIconMedium": "--size-icon-medium-0cbske",
    "sizeIconNormal": "--size-icon-normal-311gry",
    "sizeTableSelectionHorizontal": "--size-table-selection-horizontal-uadoa1",
    "sizeVerticalInput": "--size-vertical-input-5g8cy5",
    "sizeVerticalPanelIconOffset": "--size-vertical-panel-icon-offset-4593ko",
    "sizeSideNavigationItemHeight": "--size-side-navigation-item-height-4tugsp",
    "sizeSideNavigationItemCollapsed": "--size-side-navigation-item-collapsed-khs945",
    "sizeSideNavigationCollapsedWidth": "--size-side-navigation-collapsed-width-irf8ik",
    "spaceAlertActionLeft": "--space-alert-action-left-6trzof",
    "spaceAlertHorizontal": "--space-alert-horizontal-ncpiov",
    "spaceAlertMessageRight": "--space-alert-message-right-3i2sx2",
    "spaceAlertVertical": "--space-alert-vertical-uiixbm",
    "spaceButtonFocusOutlineGutter": "--space-button-focus-outline-gutter-dzjnny",
    "spaceButtonHorizontal": "--space-button-horizontal-ojp1rq",
    "spaceButtonVertical": "--space-button-vertical-r9jnds",
    "spaceTokenVertical": "--space-token-vertical-zoq8xd",
    "spaceFieldVertical": "--space-field-vertical-77df8s",
    "spaceButtonIconFocusOutlineGutterVertical": "--space-button-icon-focus-outline-gutter-vertical-euaiep",
    "spaceButtonIconOnlyHorizontal": "--space-button-icon-only-horizontal-p5zb7m",
    "spaceButtonInlineIconFocusOutlineGutter": "--space-button-inline-icon-focus-outline-gutter-rit6yp",
    "spaceButtonModalDismissVertical": "--space-button-modal-dismiss-vertical-3vgc5x",
    "spaceCalendarGridFocusOutlineGutter": "--space-calendar-grid-focus-outline-gutter-ksrb33",
    "spaceCalendarGridSelectedFocusOutlineGutter": "--space-calendar-grid-selected-focus-outline-gutter-hpu0ac",
    "spaceCalendarGridGutter": "--space-calendar-grid-gutter-s8n4gf",
    "spaceCardHorizontalDefault": "--space-card-horizontal-default-2sdf3l",
    "spaceCardHorizontalEmbedded": "--space-card-horizontal-embedded-5u2228",
    "spaceCardVerticalDefault": "--space-card-vertical-default-iz8x7a",
    "spaceCardVerticalEmbedded": "--space-card-vertical-embedded-xt7hoh",
    "spaceItemCardHorizontalDefault": "--space-item-card-horizontal-default-d4gw8c",
    "spaceItemCardHorizontalEmbedded": "--space-item-card-horizontal-embedded-0dtpkm",
    "spaceItemCardVerticalDefault": "--space-item-card-vertical-default-vibtiz",
    "spaceItemCardVerticalEmbedded": "--space-item-card-vertical-embedded-i4sbwc",
    "spaceDialogHorizontal": "--space-dialog-horizontal-f19fik",
    "spaceDialogVertical": "--space-dialog-vertical-24ji2g",
    "spaceDialogActionBlock": "--space-dialog-action-block-jznvno",
    "spaceDialogActionInline": "--space-dialog-action-inline-tb23m8",
    "spaceDialogHeaderGap": "--space-dialog-header-gap-h3tlnk",
    "spaceDialogSectionGap": "--space-dialog-section-gap-xh4b86",
    "spaceCodeEditorStatusFocusOutlineGutter": "--space-code-editor-status-focus-outline-gutter-udne29",
    "spaceContainerContentTop": "--space-container-content-top-ryubqz",
    "spaceContainerHeaderTop": "--space-container-header-top-3txhx4",
    "spaceContainerHeaderBottom": "--space-container-header-bottom-9elagw",
    "spaceContainerHorizontal": "--space-container-horizontal-quy5ai",
    "spaceContentHeaderPaddingBottom": "--space-content-header-padding-bottom-yv2yex",
    "spaceDarkHeaderOverlapDistance": "--space-dark-header-overlap-distance-16rv3i",
    "spaceExpandableSectionIconOffsetTop": "--space-expandable-section-icon-offset-top-ggjci7",
    "spaceFieldHorizontal": "--space-field-horizontal-anki5k",
    "spaceFieldIconOffset": "--space-field-icon-offset-2wydv9",
    "spaceFilteringTokenDismissButtonFocusOutlineGutter": "--space-filtering-token-dismiss-button-focus-outline-gutter-4a0cqn",
    "spaceFilteringTokenOperationSelectFocusOutlineGutter": "--space-filtering-token-operation-select-focus-outline-gutter-677p72",
    "spaceFlashbarActionLeft": "--space-flashbar-action-left-btmo3q",
    "spaceFlashbarDismissRight": "--space-flashbar-dismiss-right-m8whke",
    "spaceFlashbarHorizontal": "--space-flashbar-horizontal-re1dse",
    "spaceFlashbarVertical": "--space-flashbar-vertical-ssj5fl",
    "spaceGridGutter": "--space-grid-gutter-2qs4vj",
    "spaceKeyValueGap": "--space-key-value-gap-ju2jyr",
    "spaceLayoutContentBottom": "--space-layout-content-bottom-adv8e9",
    "spaceLayoutContentHorizontal": "--space-layout-content-horizontal-axaoos",
    "spaceLayoutToggleDiameter": "--space-layout-toggle-diameter-qufod6",
    "spaceLayoutTogglePadding": "--space-layout-toggle-padding-va8352",
    "spaceModalContentBottom": "--space-modal-content-bottom-i4wk4i",
    "spaceModalHorizontal": "--space-modal-horizontal-f789j4",
    "spacePanelContentBottom": "--space-panel-content-bottom-3vrcbj",
    "spacePanelContentTop": "--space-panel-content-top-ehvp15",
    "spacePanelDividerMarginHorizontal": "--space-panel-divider-margin-horizontal-8w6hvr",
    "spacePanelHeaderVertical": "--space-panel-header-vertical-62uc26",
    "spacePanelNavLeft": "--space-panel-nav-left-9gc77i",
    "spacePanelSideLeft": "--space-panel-side-left-sa5n0l",
    "spacePanelSideRight": "--space-panel-side-right-14ygs5",
    "spacePanelSplitTop": "--space-panel-split-top-wffoqq",
    "spacePanelSplitBottom": "--space-panel-split-bottom-72ldzt",
    "spaceSegmentedControlFocusOutlineGutter": "--space-segmented-control-focus-outline-gutter-sz9jgo",
    "spaceTabsContentTop": "--space-tabs-content-top-vepiyd",
    "spaceTabsFocusOutlineGutter": "--space-tabs-focus-outline-gutter-j12jn3",
    "spaceTabsVertical": "--space-tabs-vertical-7sydz7",
    "spaceTableContentBottom": "--space-table-content-bottom-88oqzz",
    "spaceTableEmbeddedHeaderTop": "--space-table-embedded-header-top-bnncuk",
    "spaceTableFooterHorizontal": "--space-table-footer-horizontal-81b00d",
    "spaceTableHeaderFocusOutlineGutter": "--space-table-header-focus-outline-gutter-yl4rtb",
    "spaceTableHeaderHorizontal": "--space-table-header-horizontal-y8sy8d",
    "spaceTableHeaderToolsBottom": "--space-table-header-tools-bottom-37d7z7",
    "spaceTableHeaderToolsFullPageBottom": "--space-table-header-tools-full-page-bottom-g1a6as",
    "spaceTableHorizontal": "--space-table-horizontal-o0ypm8",
    "spaceTreeViewIndentation": "--space-tree-view-indentation-org1hm",
    "spaceSideNavigationItemDefaultGap": "--space-side-navigation-item-default-gap-j48i0t",
    "spaceSideNavigationItemIconGap": "--space-side-navigation-item-icon-gap-0fty3a",
    "spaceTileGutter": "--space-tile-gutter-5d7z8f",
    "spaceActionCardHorizontalDefault": "--space-action-card-horizontal-default-kz91ls",
    "spaceActionCardHorizontalEmbedded": "--space-action-card-horizontal-embedded-i0jik5",
    "spaceActionCardVerticalDefault": "--space-action-card-vertical-default-575mjk",
    "spaceActionCardVerticalEmbedded": "--space-action-card-vertical-embedded-tge73d",
    "spaceActionCardDescriptionPaddingTop": "--space-action-card-description-padding-top-wfjbx3",
    "spaceActionCardContentPaddingTop": "--space-action-card-content-padding-top-hg0mjq",
    "spaceOptionPaddingVertical": "--space-option-padding-vertical-hggcse",
    "spaceOptionPaddingHorizontal": "--space-option-padding-horizontal-5om7we",
    "spaceStatusIndicatorPaddingHorizontal": "--space-status-indicator-padding-horizontal-pqbmh8",
    "spaceScaled2xNone": "--space-scaled-2x-none-mu1md7",
    "spaceScaled2xXxxs": "--space-scaled-2x-xxxs-j5s6l7",
    "spaceScaled2xXxs": "--space-scaled-2x-xxs-vru90o",
    "spaceScaled2xXs": "--space-scaled-2x-xs-flbfeu",
    "spaceScaled2xS": "--space-scaled-2x-s-4azy1l",
    "spaceScaled2xM": "--space-scaled-2x-m-jfoxe1",
    "spaceScaled2xL": "--space-scaled-2x-l-ilaibr",
    "spaceScaled2xXl": "--space-scaled-2x-xl-4as794",
    "spaceScaled2xXxl": "--space-scaled-2x-xxl-yzd35o",
    "spaceScaled2xXxxl": "--space-scaled-2x-xxxl-rjox3z",
    "spaceScaledNone": "--space-scaled-none-i77qml",
    "spaceScaledXxxs": "--space-scaled-xxxs-n0ri6o",
    "spaceScaledXxs": "--space-scaled-xxs-j00t0m",
    "spaceScaledXs": "--space-scaled-xs-pajbd1",
    "spaceScaledS": "--space-scaled-s-2crg2b",
    "spaceScaledM": "--space-scaled-m-lfeh3i",
    "spaceScaledL": "--space-scaled-l-33ruz6",
    "spaceScaledXl": "--space-scaled-xl-avp3kz",
    "spaceScaledXxl": "--space-scaled-xxl-qprsam",
    "spaceScaledXxxl": "--space-scaled-xxxl-7imyij",
    "spaceStaticXxxs": "--space-static-xxxs-opeihl",
    "spaceStaticXxs": "--space-static-xxs-vzto3j",
    "spaceStaticXs": "--space-static-xs-789l1l",
    "spaceStaticS": "--space-static-s-bwcdfm",
    "spaceStaticM": "--space-static-m-0gdnhk",
    "spaceStaticL": "--space-static-l-mj9pf2",
    "spaceStaticXl": "--space-static-xl-frcfkv",
    "spaceStaticXxl": "--space-static-xxl-qzfy7v",
    "spaceStaticXxxl": "--space-static-xxxl-0qd99j",
    "spaceNone": "--space-none-8budoy",
    "spaceXxxs": "--space-xxxs-3ulqs3",
    "spaceXxs": "--space-xxs-3o1yoq",
    "spaceXs": "--space-xs-m9b7jf",
    "spaceS": "--space-s-kll7oj",
    "spaceM": "--space-m-n8iq8o",
    "spaceL": "--space-l-dpyxli",
    "spaceXl": "--space-xl-6jh0ay",
    "spaceXxl": "--space-xxl-xj5vu7",
    "spaceXxxl": "--space-xxxl-pjngik",
    "shadowCard": "--shadow-card-9fwoie",
    "shadowItemCard": "--shadow-item-card-ltzk0y",
    "shadowDialog": "--shadow-dialog-q0m0rn",
    "shadowContainer": "--shadow-container-quglkl",
    "shadowContainerActive": "--shadow-container-active-iomjxu",
    "shadowDropdown": "--shadow-dropdown-ogwesf",
    "shadowDropup": "--shadow-dropup-40ssty",
    "shadowFlashCollapsed": "--shadow-flash-collapsed-eh2z6q",
    "shadowFlashSticky": "--shadow-flash-sticky-ytd6f0",
    "shadowModal": "--shadow-modal-gdc1ov",
    "shadowPanel": "--shadow-panel-8l4v80",
    "shadowPanelToggle": "--shadow-panel-toggle-a81wj1",
    "shadowPopover": "--shadow-popover-96f0nr",
    "shadowSplitBottom": "--shadow-split-bottom-p8ki2v",
    "shadowSplitSide": "--shadow-split-side-wha3re",
    "shadowSticky": "--shadow-sticky-ukzbip",
    "shadowStickyEmbedded": "--shadow-sticky-embedded-5m1s1m",
    "shadowStickyColumnFirst": "--shadow-sticky-column-first-7d9wxu",
    "shadowStickyColumnLast": "--shadow-sticky-column-last-f2p6g7",
    "colorError300": "--undefined-dv56tw",
    "colorError500": "--undefined-hf8a6s",
    "colorSuccess300": "--undefined-xwqdc8",
    "colorSuccess700": "--undefined-jhclu1",
    "colorWarning300": "--undefined-qvy423",
    "colorInfo500": "--undefined-gwxu9l",
    "colorInfo900": "--undefined-gu2zmd",
    "colorNeutralGrey50": "--undefined-6h2ggb",
    "colorNeutralGrey100": "--undefined-qhi59i",
    "colorNeutralGrey150": "--undefined-vf6wj9",
    "colorNeutralGrey200": "--undefined-u4evfe",
    "colorNeutralGrey250": "--undefined-71hb8y",
    "colorNeutralGrey300": "--undefined-rwwn5i",
    "colorNeutralGrey350": "--undefined-85jx5r",
    "colorNeutralGrey400": "--undefined-l0wm9b",
    "colorNeutralGrey450": "--undefined-tbxfvi",
    "colorNeutralGrey500": "--undefined-nak4vs",
    "colorNeutralGrey550": "--undefined-rrfll4",
    "colorNeutralGrey600": "--undefined-ppsggf",
    "colorNeutralGrey650": "--undefined-llp2um",
    "colorNeutralGrey700": "--undefined-1gb057",
    "colorNeutralGrey750": "--undefined-d4ckiq",
    "colorNeutralGrey800": "--undefined-eh36mb",
    "colorNeutralGrey850": "--undefined-4gjmgm",
    "colorNeutralGrey900": "--undefined-dishdk",
    "colorNeutralGrey950": "--undefined-wt96gu",
    "colorNeutralGrey1000": "--undefined-zuz5cy",
    "colorIndigo100": "--undefined-d9s3af",
    "colorIndigo200": "--undefined-2e0748",
    "colorIndigo300": "--undefined-r0acr0",
    "colorIndigo500": "--undefined-gwxu9l",
    "colorIndigo700": "--undefined-l1s6ks",
    "colorIndigo800": "--undefined-kl9k3k",
    "colorIndigo900": "--undefined-gu2zmd",
    "colorIndigo1000": "--undefined-0ndvo9",
    "colorGreen200": "--undefined-5o8wy9",
    "colorGreen700": "--undefined-jhclu1",
    "colorOneThemeYellow50": "--undefined-2vv42l",
    "colorOneThemeYellow300": "--undefined-qvy423",
    "colorOneThemeYellow400": "--undefined-ogj12j",
    "colorOneThemeYellow500": "--undefined-7cyeoz",
    "colorOneThemeYellow800": "--undefined-e4kn3x",
    "colorOneThemeYellow900": "--undefined-dlp5vv",
    "colorOneThemeYellow1000": "--undefined-msdkv6"
  }
};
